import { gql } from '@apollo/client';
import * as ApolloReactCommon from '@apollo/client/react';
import * as ApolloReactHooks from '@apollo/client/react';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  BigInt: { input: any; output: any; }
  CamelizedJson: { input: any; output: any; }
  ISO8601Date: { input: any; output: any; }
  ISO8601DateTime: { input: any; output: any; }
  JSON: { input: any; output: any; }
};

/** Access entity */
export type Access = {
  __typename?: 'Access';
  /** Component name (Access control component) */
  component: AccessComponentEnum;
  /** Related items IDs */
  itemIds: Array<Scalars['ID']['output']>;
  /** Level of access */
  level: Maybe<AccessLevelEnum>;
  /** Policy type */
  policy: Maybe<AccessPolicyEnum>;
  /** Scope level */
  scopeLevel: Maybe<AccessScopeLevelEnum>;
};

/** Available components */
export enum AccessComponentEnum {
  /** AI assistance */
  AiAssistance = 'AI_ASSISTANCE',
  /** Assets counter reading (index adding) */
  AssetsCounterReading = 'ASSETS_COUNTER_READING',
  /** Assets management */
  AssetsManagement = 'ASSETS_MANAGEMENT',
  /** Assets management in asset categories only */
  AssetsManagementCategoriesScope = 'ASSETS_MANAGEMENT_CATEGORIES_SCOPE',
  /** Asset categories management */
  AssetCategoriesManagement = 'ASSET_CATEGORIES_MANAGEMENT',
  /** Departments management */
  DepartmentsManagement = 'DEPARTMENTS_MANAGEMENT',
  /** Documentation analytics */
  DocumentationAnalytics = 'DOCUMENTATION_ANALYTICS',
  /** Documentation categories management */
  DocumentationCategoriesManagement = 'DOCUMENTATION_CATEGORIES_MANAGEMENT',
  /** Documentation management */
  DocumentationManagement = 'DOCUMENTATION_MANAGEMENT',
  /** Documentation categories scope */
  DocumentationManagementCategoriesScope = 'DOCUMENTATION_MANAGEMENT_CATEGORIES_SCOPE',
  /** Form categories management */
  FormCategoriesManagement = 'FORM_CATEGORIES_MANAGEMENT',
  /** Home page management */
  HomePageManagement = 'HOME_PAGE_MANAGEMENT',
  /** Interventions management */
  InterventionsManagement = 'INTERVENTIONS_MANAGEMENT',
  /** Interventions management in intervention categories only */
  InterventionsManagementCategoriesScope = 'INTERVENTIONS_MANAGEMENT_CATEGORIES_SCOPE',
  /** Intervention categories management */
  InterventionCategoriesManagement = 'INTERVENTION_CATEGORIES_MANAGEMENT',
  /** Sites management */
  SitesManagement = 'SITES_MANAGEMENT',
  /** Tasks management */
  TasksManagement = 'TASKS_MANAGEMENT',
  /** Tasks performing */
  TasksPerforming = 'TASKS_PERFORMING',
  /** Users and teams management */
  UsersManagement = 'USERS_MANAGEMENT'
}

/** Access attributes */
export type AccessCuInputObject = {
  /** Destroy access */
  _destroy?: InputMaybe<Scalars['Boolean']['input']>;
  /** Component name (Access control component) */
  component: AccessComponentEnum;
  /** Scope items attributes array */
  items?: InputMaybe<Array<LinkingInputObject>>;
  /** Level of access (for non-scope access) */
  level?: InputMaybe<AccessLevelEnum>;
  /** Scope level of access (for scope access) */
  scopeLevel?: InputMaybe<AccessScopeLevelEnum>;
};

/** Available levels of access */
export enum AccessLevelEnum {
  LimitedRead = 'LIMITED_READ',
  Read = 'READ',
  Write = 'WRITE'
}

/** Available policies of accesses based on every possible setup */
export enum AccessPolicyEnum {
  CompanyPlan = 'COMPANY_PLAN',
  Default = 'DEFAULT',
  Team = 'TEAM',
  User = 'USER'
}

/** Available scope levels of access */
export enum AccessScopeLevelEnum {
  All = 'ALL',
  Selected = 'SELECTED'
}

/** Whether a document's file can be attached to an AI chat, or the reason it cannot */
export enum AiAttachabilityStatusEnum {
  /** The file can be attached and read by the assistant */
  Attachable = 'ATTACHABLE',
  /** The file exceeds the attachment size limit */
  TooLarge = 'TOO_LARGE',
  /** The video exceeds the attachment duration limit */
  TooLong = 'TOO_LONG',
  /** The file type cannot be read by the assistant */
  UnsupportedType = 'UNSUPPORTED_TYPE'
}

/** Why AI spend is currently refused */
export enum AiBudgetBlockedReasonEnum {
  /** The current period's budget has been used up; spend resumes next cycle */
  BudgetExhausted = 'BUDGET_EXHAUSTED',
  /** No budget cap is configured for the company, so no spend is admitted until an administrator sets one */
  BudgetNotConfigured = 'BUDGET_NOT_CONFIGURED'
}

/** A point-in-time view of a company's AI budget for the current billing period, in both authoritative micros and the credits the UI renders. */
export type AiBudgetStatus = {
  __typename?: 'AiBudgetStatus';
  /** Why AI spend is refused right now; null when it is admitted. The signal to disable AI controls — a request made anyway fails with the matching error code. Not derivable from the credit fields, which round up; an unconfigured cap also blocks spend while reading enforced false. */
  blockedReason: Maybe<AiBudgetBlockedReasonEnum>;
  /**
   * The last day of the current billing period; null when no cap is configured.
   * ATTENTION: Access allowed for system admins.
   */
  cycleEndsAt: Maybe<Scalars['ISO8601Date']['output']>;
  /**
   * The day the current billing period started; null when no cap is configured.
   * ATTENTION: Access allowed for system admins.
   */
  cycleStartedAt: Maybe<Scalars['ISO8601Date']['output']>;
  /** Whether a budget cap is configured. When false, the cap fields below are null — render the meter as unlimited, but read blocked_reason before allowing AI usage. */
  enforced: Scalars['Boolean']['output'];
  /** Spend so far this period as a percentage of the cap (0–100, can read above 100 if a charge overran the remainder); null when no cap is configured. */
  percentage: Maybe<Scalars['Float']['output']>;
  /** Remaining display credits, clamped at zero; null when no cap is configured. */
  remainingCredits: Maybe<Scalars['Int']['output']>;
  /**
   * Cap minus usage, in micros; null when no cap is configured. May go negative if a single allowed charge exceeded the remainder.
   * ATTENTION: Access allowed for system admins.
   */
  remainingMicros: Maybe<Scalars['BigInt']['output']>;
  /** The share of the cap consumed by automated background work with no acting user (document indexing, etc.), as a percentage; null when no cap is configured. */
  systemPercentage: Maybe<Scalars['Float']['output']>;
  /** The cap in display credits (1000 credits = 1 euro, EUR); null when no cap is configured. */
  totalCredits: Maybe<Scalars['Int']['output']>;
  /**
   * The current-period spending cap in micros (millionths of a euro, EUR); null when no cap is configured.
   * ATTENTION: Access allowed for system admins.
   */
  totalMicros: Maybe<Scalars['BigInt']['output']>;
  /** When this snapshot was computed. */
  updatedAt: Scalars['ISO8601DateTime']['output'];
  /** Spend so far this period in display credits, rounded up. */
  usedCredits: Scalars['Int']['output'];
  /**
   * Spend so far this period, in micros.
   * ATTENTION: Access allowed for system admins.
   */
  usedMicros: Scalars['BigInt']['output'];
  /** The share of the cap consumed by real users (credits users spent), as a percentage; null when no cap is configured. */
  userPercentage: Maybe<Scalars['Float']['output']>;
};

/** A single content block in an AI message; provide exactly one variant. */
export type AiContentBlockInputObject = {
  /** A reference to an existing entity. */
  entityRef?: InputMaybe<AiEntityRefBlockInputObject>;
  /** A run of message text. */
  text?: InputMaybe<Scalars['String']['input']>;
};

/** An AI assistant conversation owned by a user. */
export type AiConversation = TimestampInterface & {
  __typename?: 'AiConversation';
  /** Whether an assistant reply is currently being generated; clients use this on load to decide whether to wait before sending. */
  busy: Maybe<Scalars['Boolean']['output']>;
  /** Time when was created */
  createdAt: Scalars['ISO8601DateTime']['output'];
  /** The AI feature (assistant) this conversation belongs to. */
  feature: AiConversationFeatureEnum;
  /** The conversation ID. */
  id: Scalars['ID']['output'];
  /** Who initiated the conversation (user or system). */
  initiator: AiConversationInitiatorEnum;
  /** Number of visible (non-system) messages in the conversation. */
  messagesCount: Scalars['Int']['output'];
  /** The conversation status (active or closed). */
  status: AiConversationStatusEnum;
  /** The conversation's current reasoning level — sticky across sends; restore the client's level picker from it on load. */
  thinkingLevel: AiThinkingLevelEnum;
  /** The conversation title; null until generated or set. */
  title: Maybe<Scalars['String']['output']>;
  /** Whether the title was generated automatically. */
  titleAutoGenerated: Scalars['Boolean']['output'];
  /** Last update time */
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

/** AiConversationCollection type */
export type AiConversationCollection = {
  __typename?: 'AiConversationCollection';
  /** A collection of paginated AiConversationCollection */
  collection: Array<AiConversation>;
  /** Pagination Metadata for navigating the Pagination */
  metadata: CollectionMetadata;
};

/** Description from base input object. Please set your description for child object. */
export type AiConversationDestroyInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The conversation ID. */
  id: Scalars['ID']['input'];
};

/** AI feature (assistant) a conversation belongs to */
export enum AiConversationFeatureEnum {
  /** Documentation assistant */
  Documentation = 'DOCUMENTATION'
}

/** Filters for the AI conversations collection. */
export type AiConversationFilterInputObject = {
  /** Filter by conversation status (ACTIVE / CLOSED). */
  status?: InputMaybe<FilterIntInputObject>;
  /** Filter by conversation title. */
  title?: InputMaybe<FilterInputObject>;
};

/** Who initiated an AI conversation */
export enum AiConversationInitiatorEnum {
  /** Started by an automated workflow */
  System = 'SYSTEM',
  /** Started by a human user */
  User = 'USER'
}

/** Sort options for the AI conversations collection. */
export type AiConversationSortInputObject = {
  /** Sort by creation time. */
  createdAt?: InputMaybe<SortDirectionEnum>;
  /** Sort by last update time. */
  updatedAt?: InputMaybe<SortDirectionEnum>;
};

/** Lifecycle status of an AI conversation */
export enum AiConversationStatusEnum {
  /** Open and accepting messages */
  Active = 'ACTIVE',
  /** Closed; no further messages accepted */
  Closed = 'CLOSED'
}

/** A single frame on the AI conversation stream, discriminated by eventType; fields not applicable to the frame kind are null. */
export type AiConversationStreamEvent = {
  __typename?: 'AiConversationStreamEvent';
  /** The auto-generated conversation title; only on title frames. */
  conversationTitle: Maybe<Scalars['String']['output']>;
  /** The newly generated text fragment for this frame; null outside streaming message frames. */
  delta: Maybe<Scalars['String']['output']>;
  /** Machine-readable failure reason on terminal failure frames; null otherwise. */
  errorCode: Maybe<Scalars['String']['output']>;
  /** Discriminator for the frame kind. */
  eventType: AiStreamEventTypeEnum;
  /** The assistant message the frame belongs to — on tool frames, the message that carries the tool invocation (the same message toolCalls are grouped under in the transcript). Null on title frames. */
  messageId: Maybe<Scalars['ID']['output']>;
  /** A monotonic per-turn frame number on message frames; clients order deltas by this, since delivery order is not guaranteed. Null on suggestions and title frames. */
  sequence: Maybe<Scalars['Int']['output']>;
  /** The assistant message status (streaming while generating, then complete, failed, or truncated_budget). Null outside message frames. */
  status: Maybe<AiMessageStatusEnum>;
  /** Follow-up question suggestions for the completed assistant message; only on suggestions frames. */
  suggestedFollowups: Maybe<Array<Scalars['String']['output']>>;
  /** Identifier of the individual tool invocation; pairs the running and completed frames of one call. Only on tool frames. */
  toolCallId: Maybe<Scalars['ID']['output']>;
  /** Machine name of the tool being invoked; only on tool frames. */
  toolName: Maybe<Scalars['String']['output']>;
  /** Whether the tool is running or has completed; only on tool frames. */
  toolStatus: Maybe<AiToolStatusEnum>;
};

/** Description from base input object. Please set your description for child object. */
export type AiConversationUpdateInput = {
  /** The fields to update. */
  attributes: AiConversationUpdateInputObject;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The conversation ID. */
  id: Scalars['ID']['input'];
};

/** Input for renaming an AI conversation. */
export type AiConversationUpdateInputObject = {
  /** The new conversation title. */
  title?: InputMaybe<Scalars['String']['input']>;
};

/** Description from base input object. Please set your description for child object. */
export type AiDismissDocumentationDetectionInput = {
  /** Which detection annotation to dismiss. */
  attributes: AiDismissDocumentationDetectionInputObject;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The document ID. */
  id: Scalars['ID']['input'];
};

/** Input for dismissing a document's AI-detection annotations. */
export type AiDismissDocumentationDetectionInputObject = {
  /** Which field's annotation to dismiss; omit to dismiss every annotation on the document. */
  field?: InputMaybe<AiDocumentationFieldEnum>;
};

/** A documentation field that AI can generate. */
export enum AiDocumentationFieldEnum {
  /** The best-matching category for the document, chosen from the categories the requester can assign. */
  Category = 'CATEGORY',
  /** The document's reference code. */
  Code = 'CODE',
  /** The document's description. */
  Description = 'DESCRIPTION',
  /** The document's name (title). */
  Name = 'NAME',
  /** The version's notes. */
  Notes = 'NOTES',
  /** Suggested tags (short labels) for the document. */
  Tags = 'TAGS'
}

/** A reference to an existing entity by id. */
export type AiEntityRefBlockInputObject = {
  /** The referenced entity type. */
  entityType: AiEntityRefTypeEnum;
  /** The referenced entity ID. */
  id: Scalars['ID']['input'];
};

/** Type of entity a content block can reference */
export enum AiEntityRefTypeEnum {
  /** A specific version of a document */
  DocumentationVersion = 'DOCUMENTATION_VERSION'
}

/** One indexable media kind and the model that extracts its text in a region. */
export type AiExtractionMedia = {
  __typename?: 'AiExtractionMedia';
  /** The media kind — DOCUMENT, IMAGE, or VIDEO. */
  mediaKind: AiMediaKindEnum;
  /** The model that extracts this kind's text — an OCR model with its page pricing, or null when the region's assistant model does it via vision (token-priced; render the region's selected chat model there). */
  model: Maybe<AiModelInfo>;
};

/** The status of AI detection for one field of a document. */
export enum AiFieldDetectionStatusEnum {
  /** Detection was stopped before it reached this field. */
  Cancelled = 'CANCELLED',
  /** A value was written (or tags linked). */
  Detected = 'DETECTED',
  /** AI is generating this field now. */
  Detecting = 'DETECTING',
  /** The user reviewed and settled this annotation (acknowledged a failure or ignored the suggestions). */
  Dismissed = 'DISMISSED',
  /** Detection failed for this field. */
  Failed = 'FAILED',
  /** AI found nothing to fill for this field. */
  NotFound = 'NOT_FOUND',
  /** Detection is scheduled but has not started for this field. */
  Queued = 'QUEUED',
  /** Left untouched because the field was already filled by hand. */
  SkippedExisting = 'SKIPPED_EXISTING',
  /** The document's file cannot be read by AI (e.g. a spreadsheet). */
  UnsupportedFile = 'UNSUPPORTED_FILE'
}

/** The result of an asynchronous documentation field generation, delivered on the subscription. */
export type AiFieldGeneration = {
  __typename?: 'AiFieldGeneration';
  /** The detected category id for the category field; null on failure, for other fields, or when the model found nothing (see not_found). Resolve it via documentationCategory to prefill the selector. */
  categoryId: Maybe<Scalars['ID']['output']>;
  /** The failure code when generation failed; null on success. */
  errorCode: Maybe<Scalars['String']['output']>;
  /** Which field was generated. */
  field: AiDocumentationFieldEnum;
  /** True when the model ran but produced nothing to fill for this field; the value fields are null and there is no error code. */
  notFound: Scalars['Boolean']['output'];
  /** The generated scalar value; null on failure, for list fields, or when the model found nothing (see not_found). */
  text: Maybe<Scalars['String']['output']>;
  /** The generated list values (e.g. suggested tags); null on failure, for scalar fields, or when the model found nothing (see not_found). */
  values: Maybe<Array<Scalars['String']['output']>>;
};

/** Acknowledges that a field generation was validated and enqueued. */
export type AiFieldGenerationRequest = {
  __typename?: 'AiFieldGenerationRequest';
  /** The client's correlation id, echoed; the value arrives on the subscription. */
  generationId: Scalars['ID']['output'];
};

/** The result of a one-click "detect all" — every requested documentation field generated in one combined model call, delivered on the subscription. */
export type AiFieldsGeneration = {
  __typename?: 'AiFieldsGeneration';
  /** The failure code when the whole combined generation failed; null on success. */
  errorCode: Maybe<Scalars['String']['output']>;
  /** The client's correlation id for this generation. */
  generationId: Scalars['ID']['output'];
  /** One entry per requested field with its detected value or not_found; empty when the whole call failed (see error_code). */
  results: Array<AiFieldGeneration>;
};

/** Description from base input object. Please set your description for child object. */
export type AiGenerateDocumentationFieldsInput = {
  /** The fields to generate and their source. */
  attributes: AiGenerateDocumentationFieldsInputObject;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Input for generating a document's own fields — one, a subset, or all — in one job. */
export type AiGenerateDocumentationFieldsInputObject = {
  /** Optional free-text hint applied only when generating CODE (ignored for other fields); a hint, never an override. */
  codePrompt?: InputMaybe<Scalars['String']['input']>;
  /** A saved documentation version to generate from. Provide exactly one of file or documentationVersionId. */
  documentationVersionId?: InputMaybe<Scalars['ID']['input']>;
  /** Which fields to generate (NAME, DESCRIPTION, CODE, TAGS, CATEGORY); deduped. */
  fields: Array<AiDocumentationFieldEnum>;
  /** A freshly uploaded file (cache descriptor) to generate from, for create or a new version. Provide exactly one of file or documentationVersionId. */
  file?: InputMaybe<AttachmentFileInputObject>;
  /** Client-generated id, unique per request, correlating this generation with the aiDocumentationFieldsGenerated subscription. */
  generationId: Scalars['ID']['input'];
};

/** Description from base input object. Please set your description for child object. */
export type AiGenerateDocumentationVersionFieldsInput = {
  /** The fields to generate and their source. */
  attributes: AiGenerateDocumentationVersionFieldsInputObject;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Input for generating a documentation version's own fields (currently notes) — one, a subset, or all — in one job. */
export type AiGenerateDocumentationVersionFieldsInputObject = {
  /** A saved documentation version to generate from. Provide exactly one of file or documentationVersionId. */
  documentationVersionId?: InputMaybe<Scalars['ID']['input']>;
  /** Which version fields to generate (currently NOTES); deduped. */
  fields: Array<AiDocumentationFieldEnum>;
  /** A freshly uploaded file (cache descriptor) to generate from, for a new version. Provide exactly one of file or documentationVersionId. */
  file?: InputMaybe<AttachmentFileInputObject>;
  /** Client-generated id, unique per request, correlating this generation with the aiDocumentationVersionFieldsGenerated subscription. */
  generationId: Scalars['ID']['input'];
};

/** Documentation indexing coverage for one company, on two axes: the five buckets say whether each document is searchable, the retry counts and `indexingState` say whether anything is still working on the ones that are not. */
export type AiIndexingCoverage = {
  __typename?: 'AiIndexingCoverage';
  /** The company. */
  companyId: Scalars['ID']['output'];
  /** The company's name. */
  companyName: Maybe<Scalars['String']['output']>;
  /** Rough processing time for the documents the next automatic pass will actually take (`retryingSoon`), from a crude per-document average — a display hint ("~N min"), not a promise. `0` when nothing is due imminently, including when the whole backlog is waiting for the daily pass or is parked; `indexingState` says which. */
  estimatedReindexSeconds: Scalars['Int']['output'];
  /** Documentations whose indexing exhausted its retries. Still retried once a day for a while — `parked` counts the ones nothing will retry again. */
  failed: Scalars['Int']['output'];
  /** Documentations whose current version is indexed with the active embedding model and has searchable content. */
  indexed: Scalars['Int']['output'];
  /** Documentations whose content extraction is riding a provider batch that has not come back yet. Their processing is genuinely under way even though no count moves for minutes; `0` does not mean idle (ordinary indexing shows up as a moving `lastIndexingAttemptAt`). */
  indexingInFlight: Scalars['Int']['output'];
  /** What is happening to the backlog right now — the verdict to render as the card's status line, instead of guessing from how long updates have been quiet. */
  indexingState: AiIndexingStateEnum;
  /** When indexing last completed on any of the company's current document versions. A historical fact — unaffected by the region argument and by staleness after a model change. Null when nothing was ever indexed. */
  lastIndexedAt: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** When indexing was last attempted on any of the company's current document versions, whether it succeeded or failed — the sign of life `lastIndexedAt` cannot give, since a backlog that keeps failing never completes. Null when nothing was ever attempted. */
  lastIndexingAttemptAt: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** Documentations no automatic retry will touch again — they stay unsearchable until someone re-indexes them. The one count that means "a human has to act". */
  parked: Scalars['Int']['output'];
  /** Why the parked documentations gave up, commonest first, always summing to `parked` — so the card can say "2 unreadable files, 1 file missing" instead of a bare number. Empty when nothing is parked. */
  parkedReasons: Array<AiIndexingFailureReason>;
  /** Documentations whose current version is awaiting indexing. */
  pending: Scalars['Int']['output'];
  /** Processed share of documentations (indexed + skipped), as a percentage (0–100) — reaches 100 even when some files are unindexable; `skipped` names the gap between processed and searchable. */
  progress: Scalars['Float']['output'];
  /** Documentations only the once-a-day pass will retry — the next attempt can be up to a day away. Nothing is wrong; the frequent pass has given up on them for now. */
  retryingDaily: Scalars['Int']['output'];
  /** Documentations awaiting the frequent (roughly quarter-hourly) indexing pass. With `retryingDaily` and `parked` this splits the not-yet-searchable documents (stale + pending + failed) by what happens to them NEXT, and the three always sum to that total. Under the `region` argument every document that the switch would re-index counts here, because a region switch re-drives all of them at once. */
  retryingSoon: Scalars['Int']['output'];
  /** Documentations terminally processed with the active model but yielding NO searchable content — the file type is unsupported for the region (e.g. video under Mistral) or the file has no extractable text. Not searchable, and never will be until the file or region changes. */
  skipped: Scalars['Int']['output'];
  /** Documentations still indexed with a PREVIOUS embedding model — being re-embedded to the current one after a region/model change (the "Re-indexing" state). Distinct from `pending` (never indexed); not searchable until re-indexed. A region switch turns the whole corpus stale at once, then drains it toward `indexed`. */
  stale: Scalars['Int']['output'];
  /** Total documentations. */
  total: Scalars['Int']['output'];
};

/** One reason documentations stopped being indexed, with how many carry it. */
export type AiIndexingFailureReason = {
  __typename?: 'AiIndexingFailureReason';
  /** How many documentations carry this reason. */
  count: Scalars['Int']['output'];
  /** Why indexing gave up, as a stable code — `file_missing` (the document's file is gone from storage; re-upload it), `unreadable_file` (the file could not be parsed; replace it), `unknown` (recorded before reasons were kept), or one of the shared AI error codes listed in the error-code table. Render a label per code; never show it raw. */
  reason: Scalars['String']['output'];
};

/** Which automatic pass will next revisit a document that still needs indexing — the per-document counterpart of the coverage card's retry-lane counts. Orthogonal to the status: it answers "will this fix itself?", not "is it searchable?". */
export enum AiIndexingRetryLaneEnum {
  /** Every automatic retry is exhausted — nothing will revisit it until someone acts. */
  Parked = 'PARKED',
  /** Frequent retries exhausted; retried once a day for a while yet. */
  RetryingDaily = 'RETRYING_DAILY',
  /** Picked up by the frequent pass; expected to resolve on its own shortly. */
  RetryingSoon = 'RETRYING_SOON'
}

/** Description from base input object. Please set your description for child object. */
export type AiIndexingRetryParkedForCompanyInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The company whose indexing to re-drive. */
  companyId: Scalars['ID']['input'];
};

/** Description from base input object. Please set your description for child object. */
export type AiIndexingRetryParkedInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** What is happening to a company's document-indexing backlog right now — the single verdict behind the indexing card's status line, so no client has to infer progress from the absence of updates. */
export enum AiIndexingStateEnum {
  /** Only documents no automatic retry will touch again remain — they need a manual re-index. */
  Blocked = 'BLOCKED',
  /** What remains is only retried by the once-a-day pass. */
  Deferred = 'DEFERRED',
  /** Background indexing is held back by the company's AI spending limit. */
  PausedBudget = 'PAUSED_BUDGET',
  /** The company's AI plan is off, so nothing is indexed. */
  PausedPlan = 'PAUSED_PLAN',
  /** The AI provider is unavailable and indexing has backed off until it recovers. */
  PausedProvider = 'PAUSED_PROVIDER',
  /** The documents have only just arrived and the next processing pass is still due — nothing has been attempted yet, and nothing is wrong. */
  Scheduled = 'SCHEDULED',
  /** There is work the frequent pass should have picked up, nothing is known to be holding it back, and nothing has been attempted for far longer than expected — worth investigating. */
  Stalled = 'STALLED',
  /** Every document is processed; there is no backlog. */
  UpToDate = 'UP_TO_DATE',
  /** Indexing is progressing — a provider batch is open, or a document was attempted moments ago. */
  Working = 'WORKING'
}

/** Where one document stands in AI processing — the per-document counterpart of the company-wide indexing coverage counts, judged against the company's current system model. */
export enum AiIndexingStatusEnum {
  /** Processing could not complete (see aiIndexingError). */
  Failed = 'FAILED',
  /** Processed and searchable by the assistant. */
  Indexed = 'INDEXED',
  /** Not processed yet; being picked up automatically. */
  Pending = 'PENDING',
  /** Processed, but yielded no searchable text — an unsupported file type, or nothing extractable. */
  Skipped = 'SKIPPED',
  /** Indexed under a previous system model; re-processed automatically. */
  Stale = 'STALE'
}

/** The AI validation rules for one processable file type — its size cap and, where applicable, its duration cap. */
export type AiMediaConstraint = {
  __typename?: 'AiMediaConstraint';
  /** The maximum file size in bytes for this type. */
  maxBytes: Scalars['Int']['output'];
  /** The maximum duration in seconds; null when the type has no duration limit. */
  maxDurationSeconds: Maybe<Scalars['Int']['output']>;
  /** The MIME type these rules apply to. */
  mimeType: Scalars['String']['output'];
};

/** A category of file the AI can process — grouped the way the indexing pipeline groups uploads. */
export enum AiMediaKindEnum {
  /** PDF and other document files. */
  Document = 'DOCUMENT',
  /** Image files (JPEG, PNG, WebP). */
  Image = 'IMAGE',
  /** Video files. */
  Video = 'VIDEO'
}

/** A single message within an AI conversation. */
export type AiMessage = TimestampInterface & {
  __typename?: 'AiMessage';
  /** The message text; null until generated. */
  content: Maybe<Scalars['String']['output']>;
  /** Structured content blocks (text and entity references) for the message. */
  contentBlocks: Maybe<Scalars['CamelizedJson']['output']>;
  /** Time when was created */
  createdAt: Scalars['ISO8601DateTime']['output'];
  /** Machine-readable failure reason when the message failed. */
  errorCode: Maybe<Scalars['String']['output']>;
  /** The requester's rating of this assistant message (POSITIVE or NEGATIVE); null when not rated. */
  feedback: Maybe<AiMessageFeedbackEnum>;
  /** When the current feedback was recorded; null when not rated. */
  feedbackAt: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** Optional free-text detail the requester left with a NEGATIVE rating. */
  feedbackComment: Maybe<Scalars['String']['output']>;
  /** Why the message was rated NEGATIVE; null otherwise. */
  feedbackReason: Maybe<AiMessageFeedbackReasonEnum>;
  /** The message ID. */
  id: Scalars['ID']['output'];
  /** The message role (user, assistant, or tool). */
  role: AiMessageRoleEnum;
  /** The message lifecycle status. */
  status: AiMessageStatusEnum;
  /** Follow-up questions suggested after this assistant message; empty when none were generated. */
  suggestedFollowups: Array<Scalars['String']['output']>;
  /** The assistant's extended-thinking (reasoning) text for this message; null in regular mode or when the model returned none. */
  thinking: Maybe<Scalars['String']['output']>;
  /** Tool invocations this assistant message requested, in invocation order; empty for messages without tool use. */
  toolCalls: Array<AiToolCall>;
  /** Whether the assistant reply stopped at the model's output-token limit instead of finishing naturally (distinct from the TRUNCATED_BUDGET status, which is the company budget guard); always false for user messages and for history predating this field. */
  truncated: Scalars['Boolean']['output'];
  /** Last update time */
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

/** AiMessageCollection type */
export type AiMessageCollection = {
  __typename?: 'AiMessageCollection';
  /** A collection of paginated AiMessageCollection */
  collection: Array<AiMessage>;
  /** Pagination Metadata for navigating the Pagination */
  metadata: CollectionMetadata;
};

/** Description from base input object. Please set your description for child object. */
export type AiMessageFeedbackCreateInput = {
  /** The feedback to record. */
  attributes: AiMessageFeedbackInputObject;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The message ID. */
  id: Scalars['ID']['input'];
};

/** Description from base input object. Please set your description for child object. */
export type AiMessageFeedbackDestroyInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The message ID. */
  id: Scalars['ID']['input'];
};

/** A requester's rating of an AI assistant message */
export enum AiMessageFeedbackEnum {
  /** The message was not helpful */
  Negative = 'NEGATIVE',
  /** The message was helpful */
  Positive = 'POSITIVE'
}

/** Input for rating an AI assistant message. */
export type AiMessageFeedbackInputObject = {
  /** Optional free-text detail about the rating. */
  comment?: InputMaybe<Scalars['String']['input']>;
  /** Whether the message was helpful (POSITIVE) or not (NEGATIVE). */
  feedback: AiMessageFeedbackEnum;
  /** Why the message was unhelpful; required when feedback is NEGATIVE. */
  reason?: InputMaybe<AiMessageFeedbackReasonEnum>;
};

/** Why an AI assistant message was rated not helpful */
export enum AiMessageFeedbackReasonEnum {
  /** The answer was wrong */
  Incorrect = 'INCORRECT',
  /** The answer did not address the request */
  NotRelevant = 'NOT_RELEVANT',
  /** Another reason, given in the comment */
  Other = 'OTHER',
  /** The answer was based on outdated information */
  Outdated = 'OUTDATED'
}

/** Author role of an AI message */
export enum AiMessageRoleEnum {
  /** Generated by the assistant */
  Assistant = 'ASSISTANT',
  /** Produced by a tool invocation */
  Tool = 'TOOL',
  /** Sent by the user */
  User = 'USER'
}

/** Sort options for the AI messages collection. */
export type AiMessageSortInputObject = {
  /** Sort by creation time. */
  createdAt?: InputMaybe<SortDirectionEnum>;
};

/** Lifecycle status of an AI assistant message */
export enum AiMessageStatusEnum {
  /** Generation was cancelled */
  Cancelled = 'CANCELLED',
  /** Generation finished successfully */
  Complete = 'COMPLETE',
  /** Generation failed; see errorCode */
  Failed = 'FAILED',
  /** Queued; generation has not started yet */
  Pending = 'PENDING',
  /** Generation in progress; text deltas are being streamed */
  Streaming = 'STREAMING',
  /** Stopped because the conversation exceeded the model context window; the conversation is closed */
  TruncatedBudget = 'TRUNCATED_BUDGET'
}

/** One hosting region's AI model offer. */
export type AiModelCatalogRegion = {
  __typename?: 'AiModelCatalogRegion';
  /** Whether the region can serve traffic (its provider credential is configured). An unavailable region cannot be assigned to a company. */
  available: Scalars['Boolean']['output'];
  /** The selectable assistant models. */
  chatModels: Array<AiModelOption>;
  /** Stable persona key for the region's one-line description; clients map it to their own localized copy. Null — or a key the client does not recognize — means no description. */
  copyKey: Maybe<Scalars['String']['output']>;
  /** Human-readable region name. */
  displayName: Scalars['String']['output'];
  /** The region-derived embedding model powering document search. Not selectable. */
  embeddingModel: AiModelInfo;
  /** What extracts each indexable media kind in this region — one entry per kind, each with the extracting model, or a null model when the region's assistant model does it via vision. Documents, images, and video may use different engines per region; render this instead of hardcoding a per-region label. */
  extractionMedia: Array<AiExtractionMedia>;
  /** The region-derived document-extraction (OCR) model. Null when extraction rides the chat model's vision. */
  extractionModel: Maybe<AiModelInfo>;
  /** The media kinds this region's indexing pipeline can turn into searchable text. A kind absent here (e.g. VIDEO under a region whose model cannot read video) is stored but never searchable — derive any "not indexed" note from what is missing, never hardcode it per region. */
  indexableMediaKinds: Array<AiMediaKindEnum>;
  /** Whether this region is the recommended choice. */
  recommended: Scalars['Boolean']['output'];
  /** The hosting and data region. */
  region: CompanyPlanAiRegionEnum;
};

/** A region-derived AI model with its pricing. Display data only — no input accepts its id. */
export type AiModelInfo = {
  __typename?: 'AiModelInfo';
  /** Human-readable model name. */
  displayName: Scalars['String']['output'];
  /** The model's id. */
  modelId: Scalars['String']['output'];
  /** The model's price. */
  pricing: AiModelPricing;
};

/** A selectable AI chat model with its pricing. */
export type AiModelOption = {
  __typename?: 'AiModelOption';
  /** Stable persona key for the option's one-line description; clients map it to their own localized copy. Null — or a key the client does not recognize — means no description. */
  copyKey: Maybe<Scalars['String']['output']>;
  /** Whether this model applies when no selection is stored. */
  default: Scalars['Boolean']['output'];
  /** Human-readable model name. */
  displayName: Scalars['String']['output'];
  /** Whether this model is the newest/premium tier. */
  latest: Scalars['Boolean']['output'];
  /** The id to store via companyCreate/companyUpdate plan.aiModelConfig.chatModelId. */
  modelId: Scalars['String']['output'];
  /** The model's price. */
  pricing: AiModelPricing;
  /** Whether this model is the recommended choice. */
  recommended: Scalars['Boolean']['output'];
};

/** A provider discount currently applied to a model's price, and the price it reverts to when the discount lapses. */
export type AiModelPriceDiscount = {
  __typename?: 'AiModelPriceDiscount';
  /** The last day the discounted price applies. Null for a discount published without an end date. */
  endsOn: Maybe<Scalars['ISO8601Date']['output']>;
  /** listInputPrice converted to EUR at the current exchange rate. Null when no rate is available. */
  listEurInputPrice: Maybe<Scalars['Float']['output']>;
  /** listOutputPrice converted to EUR at the current exchange rate. Null when listOutputPrice is null or no rate is available. */
  listEurOutputPrice: Maybe<Scalars['Float']['output']>;
  /** Price per `per` input units once the discount lapses, in `currency`. */
  listInputPrice: Maybe<Scalars['Float']['output']>;
  /** Price per `per` output tokens once the discount lapses, in `currency`. Null for embedding and extraction models. */
  listOutputPrice: Maybe<Scalars['Float']['output']>;
  /** How far below the list price the model is charged today, rounded to whole percent. */
  percentage: Maybe<Scalars['Int']['output']>;
};

/** An AI model's price in its provider's billing currency, with EUR equivalents. */
export type AiModelPricing = {
  __typename?: 'AiModelPricing';
  /** Approximate words corresponding to `per` units (~0.75 words per token, ~500 words per page) — an English-centric display hint (real ratios vary by language, tokenizer and layout), never a billing basis. */
  approxWordsPer: Maybe<Scalars['Int']['output']>;
  /** ISO code of the currency the provider bills in. */
  currency: Scalars['String']['output'];
  /** The provider discount currently applied to this model, and the list price it reverts to. Null when the model is charged at list price, and once a discount has lapsed. */
  discount: Maybe<AiModelPriceDiscount>;
  /** inputPrice converted to EUR at the current exchange rate (equals inputPrice when the currency is EUR). Null when no rate is available. */
  eurInputPrice: Maybe<Scalars['Float']['output']>;
  /** outputPrice converted to EUR at the current exchange rate (equals outputPrice when the currency is EUR). Null when outputPrice is null or no rate is available. */
  eurOutputPrice: Maybe<Scalars['Float']['output']>;
  /** Price per `per` input units, in `currency`. */
  inputPrice: Scalars['Float']['output'];
  /** Price per `per` output tokens, in `currency`. Null for embedding and extraction models. */
  outputPrice: Maybe<Scalars['Float']['output']>;
  /** The denominator the prices refer to (1,000,000 tokens or 1,000 pages). */
  per: Scalars['Int']['output'];
  /** Whether prices are per tokens or per document pages. */
  unit: AiPricingUnitEnum;
};

/** Everything the AI price calculator screen needs — the form to render, the rate cards, the costed workload and the caveats that apply to it. */
export type AiPriceCalculator = {
  __typename?: 'AiPriceCalculator';
  /** The panel's own wording, so the client holds no copy of its own. */
  copy: AiPriceCopy;
  /** The same workload costed at the price a discounted model reverts to, and the date it does. Null when nothing this quote prices is discounted. */
  discount: Maybe<AiPriceDiscount>;
  /** The submitted workload costed out. */
  estimate: AiPriceEstimate;
  /** The form controls to render, with their labels, bounds, defaults and options. */
  fields: Array<AiPriceFormField>;
  /** Caveats that apply to this particular quote. */
  notices: Array<AiPriceNotice>;
  /** Per-unit prices for every region and assistant model on offer, priced for the same workload. */
  rateCards: Array<AiPriceRateCard>;
};

/** The workload to cost and how to calibrate it. Every argument is optional — omit them all to get the form, its defaults, and the estimate they produce. */
export type AiPriceCalculatorInput = {
  /** Which assistant model to cost. Defaults to the region's own default. */
  chatModelId?: InputMaybe<Scalars['String']['input']>;
  /** Offers this company's own size as a starting point. Does not narrow the calibration, which stays platform-wide. */
  companyId?: InputMaybe<Scalars['ID']['input']>;
  /** Average document size, used for storage and transfer, and to infer pages when pages are not given. */
  documentSizeMb?: InputMaybe<Scalars['Float']['input']>;
  /** How many documents will be indexed. */
  documents?: InputMaybe<Scalars['Int']['input']>;
  /** How many documents arrive each month after go-live. Indexing recurs, so this is what makes the monthly figure real. */
  documentsPerMonth?: InputMaybe<Scalars['Int']['input']>;
  /** Average image size. Affects storage and transfer only. */
  imageSizeMb?: InputMaybe<Scalars['Float']['input']>;
  /** How many images will be indexed. Billed per image rather than per megabyte. */
  images?: InputMaybe<Scalars['Int']['input']>;
  /** Images uploaded every month after go-live, indexed as they land. */
  imagesPerMonth?: InputMaybe<Scalars['Int']['input']>;
  /** Messages each user sends per month. Model round-trips per message are already accounted for. */
  messagesPerUser?: InputMaybe<Scalars['Int']['input']>;
  /** Average pages per document. The main cost driver — extraction is billed per page. */
  pagesPerDocument?: InputMaybe<Scalars['Int']['input']>;
  /** Which hosting region to cost. Defaults to the recommended one. */
  region?: InputMaybe<CompanyPlanAiRegionEnum>;
  /** How many people will use the assistant. */
  users?: InputMaybe<Scalars['Int']['input']>;
  /** Average video size. Video cost scales with size — the whole file is sent to the model. */
  videoSizeMb?: InputMaybe<Scalars['Float']['input']>;
  /** How many videos will be indexed. Not supported in every region. */
  videos?: InputMaybe<Scalars['Int']['input']>;
  /** Videos uploaded every month after go-live, indexed as they land. */
  videosPerMonth?: InputMaybe<Scalars['Int']['input']>;
  /** How far back to measure real usage when calibrating the platform-wide averages. */
  windowDays?: InputMaybe<Scalars['String']['input']>;
};

/** Where one figure behind the estimate came from — real traffic or a committed default. */
export type AiPriceCalibrationEntry = {
  __typename?: 'AiPriceCalibrationEntry';
  /** Which figure this describes. */
  key: Scalars['String']['output'];
  /** How many observations it rests on; null for a default. */
  sampleSize: Maybe<Scalars['Int']['output']>;
  /** Whether it was measured or defaulted. */
  source: AiPriceCalibrationSourceEnum;
  /** The figure itself. */
  value: Maybe<Scalars['JSON']['output']>;
};

/** Whether a figure behind a price estimate was measured from real traffic or fell back to a committed default. */
export enum AiPriceCalibrationSourceEnum {
  /** A committed fallback, used when there was not enough real usage to trust. */
  Default = 'DEFAULT',
  /** Learned from the platform's own usage over the calibration window. */
  Measured = 'MEASURED'
}

/** One priced ingredient of a unit of work. A single unit can span two providers on different commercial terms, only one of which may charge a commission. */
export type AiPriceComponent = {
  __typename?: 'AiPriceComponent';
  /** What the provider's platform adds on top. */
  commission: Scalars['Float']['output'];
  /** Net plus commission — what we actually pay. */
  gross: Scalars['Float']['output'];
  /** What this ingredient is — extraction, embedding, chat, storage, egress or database. */
  key: Scalars['String']['output'];
  /** Provider list price, in the estimate's currency. */
  net: Scalars['Float']['output'];
  /** The provider billing it, or null for infrastructure. */
  provider: Maybe<Scalars['String']['output']>;
};

/** The calculator panel's own wording — captions, column headings and section names, so the client holds none of its own. */
export type AiPriceCopy = {
  __typename?: 'AiPriceCopy';
  /** Name of the section holding fields a quote rarely touches. */
  advancedSection: Scalars['String']['output'];
  /** Caption for the same total costed at list price, shown beside each figure while a model in the quote is discounted. */
  afterDiscount: Scalars['String']['output'];
  /** How a cost relates to the monthly AI budget it can be applied to. */
  budgetHint: Scalars['String']['output'];
  /** Name of the assistant-usage block. */
  conversationsSection: Scalars['String']['output'];
  /** Names the figure as our spend rather than a price to charge. */
  costLabel: Scalars['String']['output'];
  /** What the estimate is and how far it can be trusted. */
  description: Scalars['String']['output'];
  /** Name of the section holding the rate card and the remaining caveats. */
  detailsSection: Scalars['String']['output'];
  /** Name of the corpus block. */
  documentsSection: Scalars['String']['output'];
  /** Name of the images-and-video section. */
  mediaSection: Scalars['String']['output'];
  /** Shown as the media section's summary when it asks for none. */
  mediaSectionEmpty: Scalars['String']['output'];
  /** Caption for the first month, which carries the migration. */
  monthOne: Scalars['String']['output'];
  /** Caption for every month after the migration. */
  monthly: Scalars['String']['output'];
  /** Shown in place of a price for a medium the region cannot index. */
  notSupported: Scalars['String']['output'];
  /** Heading for the rate card's unit column. */
  unitColumn: Scalars['String']['output'];
};

/** The same workload costed at the price a discounted model reverts to, beside the date it does. */
export type AiPriceDiscount = {
  __typename?: 'AiPriceDiscount';
  /** The last day the discounted prices apply — the earliest end date among the models this quote is priced with. Null when every discount on them was published without one. */
  endsOn: Maybe<Scalars['ISO8601Date']['output']>;
  /** The workload costed at the providers' list prices, for comparison with the estimate charged today. */
  estimate: AiPriceEstimate;
};

/** A workload costed out, with one-off and recurring costs kept apart. */
export type AiPriceEstimate = {
  __typename?: 'AiPriceEstimate';
  /** The named parts each total was built from, for a cost-breakdown chart. */
  breakdown: Scalars['JSON']['output'];
  /** Quantities inferred from the workload, such as page counts implied by file sizes. */
  derived: Scalars['JSON']['output'];
  /** The one-off and the first month together. */
  monthOne: AiPriceTotals;
  /** Charged every month — conversations, storage and database. */
  monthly: AiPriceTotals;
  /** Charged once, when the corpus is first indexed. */
  oneOff: AiPriceTotals;
};

/** How prominent a price-calculator field is — the handful that decide the price, versus details a quote rarely touches. */
export enum AiPriceFieldGroupEnum {
  /** Tuning a quote rarely needs. */
  Advanced = 'ADVANCED',
  /** Rendered by the page this panel sits under, not by the panel itself. */
  Configuration = 'CONFIGURATION',
  /** How much the assistant is used; always shown. */
  Conversations = 'CONVERSATIONS',
  /** The corpus and its shape; always shown. */
  Documents = 'DOCUMENTS',
  /** Images and video, which most corpora have none of. */
  Media = 'MEDIA'
}

/** Which control renders a price-calculator field. */
export enum AiPriceFieldKindEnum {
  /** A numeric input. */
  Number = 'NUMBER',
  /** A small set of mutually exclusive choices shown side by side. */
  Segmented = 'SEGMENTED',
  /** A single-choice dropdown. */
  Select = 'SELECT'
}

/** One control on the calculator form, described by the backend so the client renders the same form the estimate was computed from. */
export type AiPriceFormField = {
  __typename?: 'AiPriceFormField';
  /** The value to start from. */
  defaultValue: Maybe<Scalars['JSON']['output']>;
  /** Why this control cannot be used with the current selection; null when it can. */
  disabledReason: Maybe<Scalars['String']['output']>;
  /** How prominent the field is, so a client can fold the details away. */
  group: AiPriceFieldGroupEnum;
  /** One line explaining what the value affects. */
  help: Maybe<Scalars['String']['output']>;
  /** The workload attribute this control sets. */
  key: Scalars['String']['output'];
  /** Which control to render. */
  kind: AiPriceFieldKindEnum;
  /** The control's label. */
  label: Scalars['String']['output'];
  /** Whether the value is a fact read from the record rather than an input; the reason is in disabled_reason. */
  locked: Scalars['Boolean']['output'];
  /** Highest accepted value. */
  max: Maybe<Scalars['Float']['output']>;
  /** Lowest accepted value. */
  min: Maybe<Scalars['Float']['output']>;
  /** The available choices, for controls that have a fixed set. */
  options: Array<AiPriceFormOption>;
  /** Increment between accepted values. */
  step: Maybe<Scalars['Float']['output']>;
  /** The unit the value is expressed in, when it has one. */
  unit: Maybe<Scalars['String']['output']>;
};

/** One choice available on a calculator control. */
export type AiPriceFormOption = {
  __typename?: 'AiPriceFormOption';
  /** A figure worth showing beside the label, such as what this model costs per message. */
  detail: Maybe<Scalars['Float']['output']>;
  /** The choice's label. */
  label: Scalars['String']['output'];
  /** The value submitted when this choice is picked. */
  value: Scalars['String']['output'];
};

/** The exchange rate every non-EUR price in this quote was converted at. */
export type AiPriceFx = {
  __typename?: 'AiPriceFx';
  /** Whether a rate was on record. When false, money fields are null rather than zero. */
  available: Scalars['Boolean']['output'];
  /** When that rate was published. */
  observedAt: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** The rate used. */
  rate: Maybe<Scalars['Float']['output']>;
};

/** The price of one unit — a page, a megabyte, a message, a gigabyte-month. Money fields are null, never zero, when the figure could not be produced. */
export type AiPriceLine = {
  __typename?: 'AiPriceLine';
  /** What the provider's platform adds on top. */
  commission: Maybe<Scalars['Float']['output']>;
  /** The priced ingredients this line is the sum of. */
  components: Array<AiPriceComponent>;
  /** Net plus commission — what we actually pay. */
  gross: Maybe<Scalars['Float']['output']>;
  /** Which unit this prices. */
  key: Scalars['String']['output'];
  /** The unit's name, for display. */
  label: Scalars['String']['output'];
  /** The kind of file this applies to, when it applies to one. */
  mediaKind: Maybe<AiMediaKindEnum>;
  /** Provider list price. */
  net: Maybe<Scalars['Float']['output']>;
  /** Why it could not be priced — the medium is not indexable, the model has no price, or no exchange rate was available. */
  reason: Maybe<Scalars['String']['output']>;
  /** Whether this unit could be priced at all. */
  supported: Scalars['Boolean']['output'];
  /** What one unit is. */
  unit: Scalars['String']['output'];
};

/** A caveat that applies to this quote, emitted only when it applies. */
export type AiPriceNotice = {
  __typename?: 'AiPriceNotice';
  /** Which caveat this is, for clients that want to style or suppress specific ones. */
  key: Scalars['String']['output'];
  /** The caveat, already translated. */
  message: Scalars['String']['output'];
  /** How much attention it deserves. */
  severity: AiPriceNoticeSeverityEnum;
};

/** How much attention a price-calculator caveat deserves. */
export enum AiPriceNoticeSeverityEnum {
  /** The estimate could not be produced in full. */
  Error = 'ERROR',
  /** Context worth knowing; nothing is wrong. */
  Info = 'INFO',
  /** Confirmation that the figures rest on real measurements. */
  Success = 'SUCCESS',
  /** Something that materially affects the price or its reliability. */
  Warning = 'WARNING'
}

/** Per-unit prices for one region and one assistant model, independent of any workload. */
export type AiPriceRateCard = {
  __typename?: 'AiPriceRateCard';
  /** Whether bulk-import pricing was applied. */
  batch: Scalars['Boolean']['output'];
  /** Where each figure behind these prices came from. */
  calibration: Array<AiPriceCalibrationEntry>;
  /** The assistant model priced. */
  chatModelId: Scalars['String']['output'];
  /** The currency every figure is expressed in. */
  currency: Scalars['String']['output'];
  /** The exchange rate the non-EUR prices were converted at. */
  fx: AiPriceFx;
  /** Whether files reach the model as inlined bytes rather than links, which changes what transfer costs. */
  inlineAttachments: Scalars['Boolean']['output'];
  /** The per-unit prices. */
  lines: Array<AiPriceLine>;
  /** The hosting region priced. */
  region: CompanyPlanAiRegionEnum;
  /** Whether this region is configured on this environment and can serve traffic today. */
  regionAvailable: Scalars['Boolean']['output'];
};

/** A costed total. Null rather than zero when part of the workload could not be priced. */
export type AiPriceTotals = {
  __typename?: 'AiPriceTotals';
  /** What provider platforms add on top. */
  commission: Maybe<Scalars['Float']['output']>;
  /** Net plus commission — what we actually pay. */
  gross: Maybe<Scalars['Float']['output']>;
  /** Provider list prices. */
  net: Maybe<Scalars['Float']['output']>;
};

/** Unit an AI model's price is denominated in */
export enum AiPricingUnitEnum {
  /** Priced per processed document pages */
  Pages = 'PAGES',
  /** Priced per processed tokens */
  Tokens = 'TOKENS'
}

/** Description from base input object. Please set your description for child object. */
export type AiSendMessageInput = {
  /** The message to send. */
  attributes: AiSendMessageInputObject;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Input for sending a message to an AI conversation. */
export type AiSendMessageInputObject = {
  /** The message as ordered content blocks (text and entity references). */
  contentBlocks: Array<AiContentBlockInputObject>;
  /** Existing conversation to continue; omit to start a new one. */
  conversationId?: InputMaybe<Scalars['ID']['input']>;
  /** The AI feature (assistant) to use. */
  feature: AiConversationFeatureEnum;
  /** Sets the conversation's reasoning level from this message on (sticky until changed); omit to keep the current level. Levels come from aiThinkingCapability; a level the model does not support is safely ignored at send time. */
  thinkingLevel?: InputMaybe<AiThinkingLevelEnum>;
};

/** Description from base input object. Please set your description for child object. */
export type AiSendMessageStopInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The conversation ID. */
  id: Scalars['ID']['input'];
};

/** Kind of event delivered on the AI conversation stream */
export enum AiStreamEventTypeEnum {
  /** An assistant message frame (text delta or status change) */
  Message = 'MESSAGE',
  /** Follow-up question suggestions generated for a completed assistant message */
  Suggestions = 'SUGGESTIONS',
  /** A reasoning frame — an extended-thinking text delta streamed before the answer when thinking mode is on */
  Thinking = 'THINKING',
  /** The conversation's auto-generated title */
  Title = 'TITLE',
  /** A tool-activity frame emitted when a tool starts or finishes running during the turn */
  Tool = 'TOOL'
}

/** The thinking levels the current AI model offers — the choices a client may present and send as thinkingLevel. Per model; cache it, it changes only when the model does. */
export type AiThinkingCapability = {
  __typename?: 'AiThinkingCapability';
  /** The thinking levels available on the current model; a single-element list means there is nothing to pick. */
  levels: Array<AiThinkingLevelEnum>;
  /** Whether reasoning is UNSUPPORTED, OPTIONAL (reasons on demand), or ALWAYS_ON. */
  mode: AiThinkingModeEnum;
  /** Whether the thinking level is user-selectable — false when a single level is offered. */
  selectable: Scalars['Boolean']['output'];
};

/** The reasoning level of an AI conversation — one vocabulary for every model, mapped to the model's own reasoning control at send time */
export enum AiThinkingLevelEnum {
  /** The model reasons before answering — deeper analysis at higher cost and latency */
  Extended = 'EXTENDED',
  /** Regular answers without extended reasoning */
  Standard = 'STANDARD'
}

/** Whether the current AI model supports extended thinking (reasoning) */
export enum AiThinkingModeEnum {
  /** The model always reasons; EXTENDED is the only level */
  AlwaysOn = 'ALWAYS_ON',
  /** The model reasons on demand */
  Optional = 'OPTIONAL',
  /** The model cannot reason; STANDARD is the only level */
  Unsupported = 'UNSUPPORTED'
}

/** A tool invocation requested by an assistant message. */
export type AiToolCall = TimestampInterface & {
  __typename?: 'AiToolCall';
  /** Time when was created */
  createdAt: Scalars['ISO8601DateTime']['output'];
  /** The tool call ID. */
  id: Scalars['ID']['output'];
  /** Provider-issued identifier of the invocation; matches toolCallId on AI conversation stream tool frames. */
  toolCallId: Scalars['ID']['output'];
  /** Machine name of the invoked tool. */
  toolName: Scalars['String']['output'];
  /** Last update time */
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

/** Phase of a tool invocation reported on the AI conversation stream */
export enum AiToolStatusEnum {
  /** The tool has finished and returned its result */
  Completed = 'COMPLETED',
  /** The tool has started executing */
  Running = 'RUNNING'
}

/** One row of the AI-usage-by-user table — an AI-enabled user's AI credit spend this period and its share of the total user spend (zero for a user who hasn't used AI). */
export type AiUsageByUser = {
  __typename?: 'AiUsageByUser';
  /** Credits this user spent this period, rounded up (0 if none). */
  creditsUsed: Scalars['Int']['output'];
  /** This row's share of the total user spend this period, as a percentage (0–100). */
  sharePercentage: Scalars['Float']['output'];
  /** The AI-enabled user this row is for. */
  user: User;
};

/** AiUsageByUserCollection type */
export type AiUsageByUserCollection = {
  __typename?: 'AiUsageByUserCollection';
  /** A collection of paginated AiUsageByUserCollection */
  collection: Array<AiUsageByUser>;
  /** Pagination Metadata for navigating the Pagination */
  metadata: CollectionMetadata;
};

/** Filters for the AI usage-by-user table. */
export type AiUsageByUserFilterInputObject = {
  /** Filter by user name. */
  fullName?: InputMaybe<FilterInputObject>;
};

/** Sort options for the AI usage-by-user table. */
export type AiUsageByUserSortInputObject = {
  /** Sort by credits used. */
  creditsUsed?: InputMaybe<SortDirectionEnum>;
  /** Sort by user name. */
  name?: InputMaybe<SortDirectionEnum>;
  /** Sort by share of usage. */
  sharePercentage?: InputMaybe<SortDirectionEnum>;
};

/** API Token */
export type ApiToken = TimestampInterface & {
  __typename?: 'ApiToken';
  /** Time when was created */
  createdAt: Scalars['ISO8601DateTime']['output'];
  /** ApiToken ID */
  id: Scalars['ID']['output'];
  /** Label */
  label: Maybe<Scalars['String']['output']>;
  /** Last activity time */
  lastActivityAt: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** Status */
  status: Maybe<ApiTokenStatusEnum>;
  /** Token (can be accessed once only after creation) */
  token: Maybe<Scalars['String']['output']>;
  /** Last update time */
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

/** ApiTokenCollection type */
export type ApiTokenCollection = {
  __typename?: 'ApiTokenCollection';
  /** A collection of paginated ApiTokenCollection */
  collection: Array<ApiToken>;
  /** Pagination Metadata for navigating the Pagination */
  metadata: CollectionMetadata;
};

/** Description from base input object. Please set your description for child object. */
export type ApiTokenCreateInput = {
  /** Create attributes */
  attributes: ApiTokenCreateInputObject;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** ApiToken attributes */
export type ApiTokenCreateInputObject = {
  /** Label */
  label?: InputMaybe<Scalars['String']['input']>;
};

/** Description from base input object. Please set your description for child object. */
export type ApiTokenDestroyInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** ApiToken ID */
  id: Scalars['ID']['input'];
};

/** Available statuses */
export enum ApiTokenStatusEnum {
  Active = 'ACTIVE',
  Inactive = 'INACTIVE'
}

/** Description from base input object. Please set your description for child object. */
export type ApiTokenUpdateInput = {
  /** Update attributes */
  attributes: ApiTokenUpdateInputObject;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** ApiToken ID */
  id: Scalars['ID']['input'];
};

/** ApiToken attributes */
export type ApiTokenUpdateInputObject = {
  /** Label */
  label?: InputMaybe<Scalars['String']['input']>;
  /** Status */
  status?: InputMaybe<ApiTokenStatusEnum>;
};

/** Asset entity */
export type Asset = TimestampInterface & {
  __typename?: 'Asset';
  canDestroy: AuthorizationResult;
  /**
   * Asset Category entity
   * NOTE: if you only need an Object ID, please use the categoryId field to reduce the load on the database.
   */
  category: Maybe<AssetCategory>;
  /** Asset Category ID */
  categoryId: Maybe<Scalars['ID']['output']>;
  /** Code */
  code: Scalars['String']['output'];
  /** Counter count */
  countersCount: Maybe<Scalars['Int']['output']>;
  /** Time when was created */
  createdAt: Scalars['ISO8601DateTime']['output'];
  /** Description */
  description: Maybe<Scalars['String']['output']>;
  /** Full code (As on the QR code) */
  fullCode: Scalars['String']['output'];
  /** Asset icon */
  iconAttached: Maybe<Attachment>;
  /** Asset ID */
  id: Scalars['ID']['output'];
  /** Manufacturer */
  manufacturer: Maybe<Scalars['String']['output']>;
  /** Model */
  model: Maybe<Scalars['String']['output']>;
  /** Name */
  name: Scalars['String']['output'];
  /** Indicates if asset location has poor wifi or does not have wifi */
  poorWifi: Scalars['Boolean']['output'];
  /** QR code prefix */
  qrPrefix: Maybe<Scalars['String']['output']>;
  /** Serial number */
  serialNumber: Maybe<Scalars['String']['output']>;
  /** Service date */
  serviceDate: Maybe<Scalars['ISO8601Date']['output']>;
  /**
   * Site entity
   * NOTE: if you only need an Object ID, please use the siteId field to reduce the load on the database.
   */
  site: Maybe<Site>;
  /**
   * Site Area entity
   * NOTE: if you only need an Object ID, please use the siteAreaId field to reduce the load on the database.
   */
  siteArea: Maybe<SiteArea>;
  /** Site Area ID */
  siteAreaId: Maybe<Scalars['ID']['output']>;
  /** Site ID */
  siteId: Maybe<Scalars['ID']['output']>;
  /** Last update time */
  updatedAt: Scalars['ISO8601DateTime']['output'];
  /** Indicates number of nomenclatures where is used */
  usesAsNomenclatureCount: Scalars['Int']['output'];
};

/** Description from base input object. Please set your description for child object. */
export type AssetBulkDestroyInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** IDs */
  ids: Array<Scalars['ID']['input']>;
};

/** Description from base input object. Please set your description for child object. */
export type AssetBulkQrCodeCreateInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Create params */
  params: QrCodesCreateInputObject;
};

/** Asset Category entity */
export type AssetCategory = TimestampInterface & {
  __typename?: 'AssetCategory';
  /** Assets collection */
  assets: AssetCollection;
  canDestroy: AuthorizationResult;
  /** Color */
  color: ColorEnum;
  /** Time when was created */
  createdAt: Scalars['ISO8601DateTime']['output'];
  /** Asset Category ID */
  id: Scalars['ID']['output'];
  /** Name */
  name: Scalars['String']['output'];
  /** Prefix */
  prefix: Maybe<Scalars['String']['output']>;
  /** Last update time */
  updatedAt: Scalars['ISO8601DateTime']['output'];
  /** Number of visible Assets */
  visibleAssetsCount: Scalars['Int']['output'];
};


/** Asset Category entity */
export type AssetCategoryAssetsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
};

/** AssetCategoryCollection type */
export type AssetCategoryCollection = {
  __typename?: 'AssetCategoryCollection';
  /** A collection of paginated AssetCategoryCollection */
  collection: Array<AssetCategory>;
  /** Pagination Metadata for navigating the Pagination */
  metadata: CollectionMetadata;
};

/** Description from base input object. Please set your description for child object. */
export type AssetCategoryCreateInput = {
  /** Create attributes */
  attributes: AssetCategoryCreateInputObject;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Asset Category attributes */
export type AssetCategoryCreateInputObject = {
  /** Color */
  color: ColorEnum;
  /** Name */
  name: Scalars['String']['input'];
  /** Prefix */
  prefix?: InputMaybe<Scalars['String']['input']>;
};

/** Description from base input object. Please set your description for child object. */
export type AssetCategoryDestroyInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Asset Category ID */
  id: Scalars['ID']['input'];
};

/** Asset Category filters */
export type AssetCategoryFilterInputObject = {
  /** Asset Category ID */
  id?: InputMaybe<FilterIdInputObject>;
  /** Asset Category name */
  name?: InputMaybe<FilterInputObject>;
};

/** Asset Category sorts */
export type AssetCategorySortInputObject = {
  /** Created at */
  createdAt?: InputMaybe<SortDirectionEnum>;
  /** Name */
  name?: InputMaybe<SortDirectionEnum>;
  /** Number of visible Assets in this category */
  visibleAssetsCount?: InputMaybe<SortDirectionEnum>;
};

/** Description from base input object. Please set your description for child object. */
export type AssetCategoryUpdateInput = {
  /** Update attributes */
  attributes: AssetCategoryUpdateInputObject;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Asset Category ID */
  id: Scalars['ID']['input'];
  /** Refresh QR prefix for related assets */
  refreshQrPrefixForAssets?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Asset Category attributes */
export type AssetCategoryUpdateInputObject = {
  /** Color */
  color?: InputMaybe<ColorEnum>;
  /** Name */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Prefix */
  prefix?: InputMaybe<Scalars['String']['input']>;
};

/** AssetCollection type */
export type AssetCollection = {
  __typename?: 'AssetCollection';
  /** A collection of paginated AssetCollection */
  collection: Array<Asset>;
  /** Pagination Metadata for navigating the Pagination */
  metadata: CollectionMetadata;
};

/** Description from base input object. Please set your description for child object. */
export type AssetCreateInput = {
  /** Create attributes */
  attributes: AssetCreateInputObject;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Asset attributes */
export type AssetCreateInputObject = {
  /** Asset Category ID */
  categoryId: Scalars['ID']['input'];
  /** Code */
  code?: InputMaybe<Scalars['String']['input']>;
  /** Description */
  description?: InputMaybe<Scalars['String']['input']>;
  /**
   * Documentations to link to / unlink from the asset. On the free plan, exactly one entry
   * is accepted and unlinking is not supported; on paid plans any combination of link and
   * unlink entries is allowed. On free-plan update, the provided link replaces any existing
   * documentation link(s) on the asset.
   *
   */
  documentationLinks?: InputMaybe<Array<DocumentationLinkInputObject>>;
  /** Icon */
  iconAttached?: InputMaybe<AttachmentCuInputObject>;
  /** Manufacturer */
  manufacturer?: InputMaybe<Scalars['String']['input']>;
  /** Model */
  model?: InputMaybe<Scalars['String']['input']>;
  /** Name */
  name: Scalars['String']['input'];
  /** Indicates if asset location has poor wifi or does not have wifi */
  poorWifi?: InputMaybe<Scalars['Boolean']['input']>;
  /** Serial number */
  serialNumber?: InputMaybe<Scalars['String']['input']>;
  /** Service date */
  serviceDate?: InputMaybe<Scalars['ISO8601Date']['input']>;
  /** Site Area ID */
  siteAreaId?: InputMaybe<Scalars['ID']['input']>;
  /** Site ID */
  siteId: Scalars['ID']['input'];
};

/** Asset filters */
export type AssetFilterInputObject = {
  /** Asset Category ID */
  categoryId?: InputMaybe<FilterIdInputObject>;
  /** Asset Category name */
  categoryName?: InputMaybe<FilterInputObject>;
  /** Asset code */
  code?: InputMaybe<FilterInputObject>;
  /** Counter count */
  countersCount?: InputMaybe<FilterIntInputObject>;
  /** Documentation ID */
  documentationsId?: InputMaybe<FilterIdInputObject>;
  /** Asset ID */
  id?: InputMaybe<FilterIdInputObject>;
  /** Asset manufacturer */
  manufacturer?: InputMaybe<FilterInputObject>;
  /** Asset name */
  name?: InputMaybe<FilterInputObject>;
  /** QR prefix */
  qrPrefix?: InputMaybe<FilterInputObject>;
  /** Asset serial number */
  serialNumber?: InputMaybe<FilterInputObject>;
  /** Site Area code */
  siteAreaCode?: InputMaybe<FilterInputObject>;
  /** Site Area ID */
  siteAreaId?: InputMaybe<FilterIdInputObject>;
  /** Site Area name */
  siteAreaName?: InputMaybe<FilterInputObject>;
  /** Site code */
  siteCode?: InputMaybe<FilterInputObject>;
  /** Site ID */
  siteId?: InputMaybe<FilterIdInputObject>;
  /** Site name */
  siteName?: InputMaybe<FilterInputObject>;
  /** Site Sector ID */
  siteSectorId?: InputMaybe<FilterIdInputObject>;
};

/** Asset attributes */
export type AssetFindByInputObject = {
  /** Code */
  code?: InputMaybe<Scalars['String']['input']>;
  /** ID */
  id?: InputMaybe<Scalars['ID']['input']>;
};

/** Asset sorts */
export type AssetSortInputObject = {
  /** Asset Category name */
  categoryName?: InputMaybe<SortDirectionEnum>;
  /** Code */
  code?: InputMaybe<SortDirectionEnum>;
  /** Created at */
  createdAt?: InputMaybe<SortDirectionEnum>;
  /** Asset manufacturer */
  manufacturer?: InputMaybe<SortDirectionEnum>;
  /** Name */
  name?: InputMaybe<SortDirectionEnum>;
  /** Asset serial number */
  serialNumber?: InputMaybe<SortDirectionEnum>;
  /** Site Area code */
  siteAreaCode?: InputMaybe<SortDirectionEnum>;
  /** Site Area name */
  siteAreaName?: InputMaybe<SortDirectionEnum>;
  /** Site code */
  siteCode?: InputMaybe<SortDirectionEnum>;
  /** Site name */
  siteName?: InputMaybe<SortDirectionEnum>;
};

/** Description from base input object. Please set your description for child object. */
export type AssetUpdateInput = {
  /** Update attributes */
  attributes: AssetUpdateInputObject;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Asset ID */
  id: Scalars['ID']['input'];
};

/** Asset attributes */
export type AssetUpdateInputObject = {
  /** Asset Category ID */
  categoryId?: InputMaybe<Scalars['ID']['input']>;
  /** Description */
  description?: InputMaybe<Scalars['String']['input']>;
  /**
   * Documentations to link to / unlink from the asset. On the free plan, exactly one entry
   * is accepted and unlinking is not supported; on paid plans any combination of link and
   * unlink entries is allowed. On free-plan update, the provided link replaces any existing
   * documentation link(s) on the asset.
   *
   */
  documentationLinks?: InputMaybe<Array<DocumentationLinkInputObject>>;
  /** Icon */
  iconAttached?: InputMaybe<AttachmentCuInputObject>;
  /** Manufacturer */
  manufacturer?: InputMaybe<Scalars['String']['input']>;
  /** Model */
  model?: InputMaybe<Scalars['String']['input']>;
  /** Name */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Indicates if asset location has poor wifi or does not have wifi */
  poorWifi?: InputMaybe<Scalars['Boolean']['input']>;
  /** Serial number */
  serialNumber?: InputMaybe<Scalars['String']['input']>;
  /** Service date */
  serviceDate?: InputMaybe<Scalars['ISO8601Date']['input']>;
  /** Site Area ID */
  siteAreaId?: InputMaybe<Scalars['ID']['input']>;
  /** Update QR prefix (if true, QR prefix will be used from asset category prefix) */
  updateQrPrefix?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Attachment */
export type Attachment = {
  __typename?: 'Attachment';
  /** Raw file data JSON (to copy attached files from one object to another without reprocessing) */
  fileData: Maybe<Scalars['JSON']['output']>;
  /** Any string to identify file in CDN (content delivery network) (e.g. some default icon or image or whatever) */
  fileTag: Maybe<Scalars['String']['output']>;
  /** Filename */
  filename: Maybe<Scalars['String']['output']>;
  /** Attachment ID */
  id: Scalars['ID']['output'];
  /** {description: "Metadata", fields: {intended_use: "Intended use"}} */
  metadata: Maybe<AttachmentMetadata>;
  /** MIME type */
  mimeType: Maybe<Scalars['String']['output']>;
  /** Position */
  position: Maybe<Scalars['Int']['output']>;
  /** Indicates if attachment is processed */
  processed: Scalars['Boolean']['output'];
  /** URLs */
  urls: Maybe<AttachmentUrl>;
};

/** Attachment attributes */
export type AttachmentCuInputObject = {
  /** Destroy attachment */
  _destroy?: InputMaybe<Scalars['Boolean']['input']>;
  /** File */
  file?: InputMaybe<AttachmentFileInputObject>;
  /** Any string to identify file in CDN (content delivery network) (e.g. some default icon or image or whatever) */
  fileTag?: InputMaybe<Scalars['String']['input']>;
  /** Filename */
  filename?: InputMaybe<Scalars['String']['input']>;
  /** Attachment ID (to update existing attachment pass ID. To create new attachment do not pass ID) */
  id?: InputMaybe<Scalars['ID']['input']>;
  /** Metadata */
  metadata?: InputMaybe<AttachmentMetadataInputObject>;
  /** Position */
  position?: InputMaybe<Scalars['Int']['input']>;
};

/** File attributes */
export type AttachmentFileDerivativesInputObject = {
  /** Large */
  large: AttachmentFileInfoInputObject;
  /** Medium */
  medium: AttachmentFileInfoInputObject;
  /** Small */
  small: AttachmentFileInfoInputObject;
};

/** File attributes */
export type AttachmentFileInfoInputObject = {
  /** File ID */
  id: Scalars['String']['input'];
  /** Metadata */
  metadata: AttachmentFileMetadataInputObject;
  /** Storage */
  storage: AttachmentStorageEnum;
};

/** File attributes */
export type AttachmentFileInputObject = {
  /** Derivatives */
  derivatives?: InputMaybe<AttachmentFileDerivativesInputObject>;
  /** File ID */
  id: Scalars['String']['input'];
  /** Metadata */
  metadata: AttachmentFileMetadataInputObject;
  /** Storage */
  storage: AttachmentStorageEnum;
};

/** File attributes */
export type AttachmentFileMetadataInputObject = {
  /** Filename */
  filename: Scalars['String']['input'];
  /** Height */
  height?: InputMaybe<Scalars['Int']['input']>;
  /** Mime type */
  mimeType: Scalars['String']['input'];
  /** Size of file */
  size: Scalars['Int']['input'];
  /** Width */
  width?: InputMaybe<Scalars['Int']['input']>;
};

/** Metadata */
export type AttachmentMetadata = {
  __typename?: 'AttachmentMetadata';
  /** Intended use */
  intendedUse: Maybe<Scalars['String']['output']>;
};

/** Metadata attributes */
export type AttachmentMetadataInputObject = {
  /** Intended use */
  intendedUse?: InputMaybe<Scalars['String']['input']>;
};

/** Available storages */
export enum AttachmentStorageEnum {
  Cache = 'cache',
  Store = 'store'
}

/** Attachment URLs */
export type AttachmentUrl = {
  __typename?: 'AttachmentUrl';
  /** Image preview URL */
  imagePreview: Maybe<Scalars['String']['output']>;
  /** Large URL */
  large: Maybe<Scalars['String']['output']>;
  /** Medium URL */
  medium: Maybe<Scalars['String']['output']>;
  /** Original URL */
  original: Maybe<Scalars['String']['output']>;
  /** Original direct download URL (without preview in browser even for known formats) */
  originalDirectDownload: Maybe<Scalars['String']['output']>;
  /** Small URL */
  small: Maybe<Scalars['String']['output']>;
  /** Video 480p URL */
  video480p: Maybe<Scalars['String']['output']>;
  /** Video 720p URL */
  video720p: Maybe<Scalars['String']['output']>;
  /** Video 1080p URL */
  video1080p: Maybe<Scalars['String']['output']>;
};

/** Description from base input object. Please set your description for child object. */
export type AuthenticationConfirmationsEmailConfirmationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Scope */
  scope: AuthenticationScopeEnum;
  /** Token */
  token: Scalars['String']['input'];
};

/** Description from base input object. Please set your description for child object. */
export type AuthenticationConfirmationsRegistrationConfirmationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Scope */
  scope: AuthenticationScopeEnum;
  /** Token */
  token: Scalars['String']['input'];
};

/** Description from base input object. Please set your description for child object. */
export type AuthenticationConfirmationsResendEmailConfirmationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Resource ID */
  id: Scalars['String']['input'];
  /** Url to confirm new email */
  redirectUrl: Scalars['String']['input'];
  /** Scope */
  scope: AuthenticationScopeEnum;
};

/** Description from base input object. Please set your description for child object. */
export type AuthenticationConfirmationsResendRegistrationConfirmationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Resource ID */
  id: Scalars['String']['input'];
  /** Url to confirm registration */
  redirectUrl: Scalars['String']['input'];
  /** Scope */
  scope: AuthenticationScopeEnum;
};

/** Show entrypoint */
export type AuthenticationEntrypointUnion = ApiToken | Session;

/** Description from base input object. Please set your description for child object. */
export type AuthenticationPasswordSetupInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** New password */
  password: Scalars['String']['input'];
  /** New password confirmation */
  passwordConfirmation: Scalars['String']['input'];
};

/** Description from base input object. Please set your description for child object. */
export type AuthenticationPasswordsForgotInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Email */
  email: Scalars['String']['input'];
  /** Url to change password */
  redirectUrl: Scalars['String']['input'];
  /** Scope */
  scope: AuthenticationScopeEnum;
};

/** Description from base input object. Please set your description for child object. */
export type AuthenticationPasswordsResetInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** New password */
  password: Scalars['String']['input'];
  /** New password confirmation */
  passwordConfirmation: Scalars['String']['input'];
  /** Scope */
  scope: AuthenticationScopeEnum;
  /** Token */
  token: Scalars['String']['input'];
};

/** Description from base input object. Please set your description for child object. */
export type AuthenticationPasswordsUpdateInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** New password */
  password: Scalars['String']['input'];
  /** Current password. Required only if user already has a password set (check hasPassword field). */
  passwordChallenge?: InputMaybe<Scalars['String']['input']>;
  /** New password confirmation */
  passwordConfirmation: Scalars['String']['input'];
};

/** Description from base input object. Please set your description for child object. */
export type AuthenticationResendAccountLockedEmailForAdminInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** URL to include in the email for account restoration */
  restoreRedirectUrl: Scalars['String']['input'];
  /** ID of the locked admin to send the email to */
  targetAdminId: Scalars['ID']['input'];
};

/** Description from base input object. Please set your description for child object. */
export type AuthenticationResendAccountLockedEmailInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Email address of the locked account */
  email: Scalars['String']['input'];
  /** URL for account restore link in email */
  restoreRedirectUrl: Scalars['String']['input'];
  /** Account type (USER or SYSTEM_ADMIN) */
  scope: AuthenticationScopeEnum;
};

/** Description from base input object. Please set your description for child object. */
export type AuthenticationRestoreAccountInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** New password */
  password: Scalars['String']['input'];
  /** New password confirmation */
  passwordConfirmation: Scalars['String']['input'];
  /** Scope */
  scope: AuthenticationScopeEnum;
  /** Account restore token from email */
  token: Scalars['String']['input'];
};

/** Available resource scopes */
export enum AuthenticationScopeEnum {
  SystemAdmin = 'SYSTEM_ADMIN',
  User = 'USER'
}

/** Description from base input object. Please set your description for child object. */
export type AuthenticationSessionCreateInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Password */
  password: Scalars['String']['input'];
  /** Scope */
  scope: AuthenticationScopeEnum;
  /** Email or username */
  uid: Scalars['String']['input'];
};

/** Description from base input object. Please set your description for child object. */
export type AuthenticationSessionEndAllInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Whether to exclude current session (default true) */
  excludeCurrent?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Description from base input object. Please set your description for child object. */
export type AuthenticationSessionEndInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Description from base input object. Please set your description for child object. */
export type AuthenticationSessionEndSpecificInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Session ID */
  sessionId: Scalars['ID']['input'];
};

/** Description from base input object. Please set your description for child object. */
export type AuthenticationSessionReportSuspiciousByTokenInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** URL to redirect to for account restoration */
  restoreRedirectUrl: Scalars['String']['input'];
  /** Token from email */
  token: Scalars['String']['input'];
};

/** Description from base input object. Please set your description for child object. */
export type AuthenticationSessionReportSuspiciousInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** URL to redirect to for account restoration */
  restoreRedirectUrl: Scalars['String']['input'];
  /** Session ID to report */
  sessionId: Scalars['ID']['input'];
};

/** Two-factor authentication code types */
export enum AuthenticationTwoFactorCodeTypeEnum {
  /** Backup code */
  Backup = 'BACKUP',
  /** Email One-Time Password */
  Email = 'EMAIL',
  /** Time-based One-Time Password */
  Totp = 'TOTP'
}

/** Description from base input object. Please set your description for child object. */
export type AuthenticationTwoFactorDisableEmailOtpInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Description from base input object. Please set your description for child object. */
export type AuthenticationTwoFactorDisableTotpInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Description from base input object. Please set your description for child object. */
export type AuthenticationTwoFactorEnableEmailOtpInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** 6-digit code from email */
  code: Scalars['String']['input'];
  /** Generate backup codes after enabling email OTP */
  generateBackupCodes?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Description from base input object. Please set your description for child object. */
export type AuthenticationTwoFactorEnableTotpInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** 6-digit code from authenticator app */
  code: Scalars['String']['input'];
  /** Generate backup codes after enabling TOTP */
  generateBackupCodes?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Description from base input object. Please set your description for child object. */
export type AuthenticationTwoFactorGenerateBackupCodesInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** 2FA code for verification */
  code: Scalars['String']['input'];
  /** Type of code (totp, email, backup) */
  codeType: AuthenticationTwoFactorCodeTypeEnum;
};

/** Two-factor authentication methods */
export enum AuthenticationTwoFactorOtpMethodEnum {
  /** Email One-Time Password */
  Email = 'EMAIL',
  /** Time-based One-Time Password (authenticator app) */
  Totp = 'TOTP'
}

/** Description from base input object. Please set your description for child object. */
export type AuthenticationTwoFactorResendEmailOtpInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Description from base input object. Please set your description for child object. */
export type AuthenticationTwoFactorResetInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Current admin's 2FA code for verification */
  code: Scalars['String']['input'];
  /** Type of code (totp, email, backup) */
  codeType: AuthenticationTwoFactorCodeTypeEnum;
  /** Target SystemAdmin ID */
  targetAdminId: Scalars['ID']['input'];
};

/** Description from base input object. Please set your description for child object. */
export type AuthenticationTwoFactorSetupEmailOtpInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** 2FA verification code (required when adding second method) */
  code?: InputMaybe<Scalars['String']['input']>;
  /** Type of verification code (required when adding second method) */
  codeType?: InputMaybe<AuthenticationTwoFactorCodeTypeEnum>;
};

/** Description from base input object. Please set your description for child object. */
export type AuthenticationTwoFactorSetupTotpInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** 2FA verification code (required when adding second method) */
  code?: InputMaybe<Scalars['String']['input']>;
  /** Type of verification code (required when adding second method) */
  codeType?: InputMaybe<AuthenticationTwoFactorCodeTypeEnum>;
};

/** Description from base input object. Please set your description for child object. */
export type AuthenticationTwoFactorVerifyInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** 6-digit code from authenticator app or email */
  code: Scalars['String']['input'];
  /** Type of code (totp, email, backup) */
  codeType: AuthenticationTwoFactorCodeTypeEnum;
};

/** Show current user */
export type AuthenticationWhoamiUnion = SystemAdmin | User;

export type AuthorizationResult = {
  __typename?: 'AuthorizationResult';
  /** Human-readable error message */
  message: Maybe<Scalars['String']['output']>;
  /** Reasons of check failure */
  reasons: Maybe<FailureReasons>;
  /** Result of applying a policy rule */
  value: Scalars['Boolean']['output'];
};

/** A tracked background job — a node in a (possibly hierarchical) job tree */
export type BackgroundJob = TimestampInterface & {
  __typename?: 'BackgroundJob';
  canCancel: AuthorizationResult;
  canDismiss: AuthorizationResult;
  canRequestDelivery: AuthorizationResult;
  canRequeue: AuthorizationResult;
  /** When cancellation was requested (drives the "Cancelling…" state); null otherwise */
  cancelRequestedAt: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** Child nodes (e.g. phases) of this job */
  children: Array<BackgroundJob>;
  /** Time when was created */
  createdAt: Scalars['ISO8601DateTime']['output'];
  /** When the owner asked to be emailed the result; null otherwise */
  deliveryRequestedAt: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** Whether the owner has closed this job from their list */
  dismissed: Scalars['Boolean']['output'];
  /** User-facing status — like status but never shows retrying (a retrying job is presented as working/in progress) */
  displayStatus: BackgroundJobStatusEnum;
  /** Units completed */
  done: Scalars['Int']['output'];
  /** Stable reason this job failed, for the client to key off; null unless it failed with a classified cause. Shares its vocabulary with the AI stream's errorCode (e.g. budget_exhausted), so one copy map serves both. */
  errorCode: Maybe<Scalars['String']['output']>;
  /** Absolute estimated finish time (null when not estimable); count down to it */
  estimatedFinishAt: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** Units that failed */
  failed: Scalars['Int']['output'];
  /** When the job reached a terminal status */
  finishedAt: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** Background job ID */
  id: Scalars['ID']['output'];
  /** The Sidekiq job ID (null for an aggregate phase) */
  jid: Maybe<Scalars['String']['output']>;
  /** What kind of work this job performs */
  kind: BackgroundJobKindEnum;
  /** Current progress message; cleared when the job finishes, so it is only ever set on a live node */
  message: Maybe<Scalars['String']['output']>;
  /** Parent node ID (null for a root) */
  parentId: Maybe<Scalars['ID']['output']>;
  /** Percentage complete (0–100) */
  pctComplete: Scalars['Int']['output'];
  /** The job's durable result payload, when it produces one */
  result: Maybe<Scalars['JSON']['output']>;
  /** Root node ID of this job's tree (the subscription topic) */
  rootId: Scalars['ID']['output'];
  /** When the job started running */
  startedAt: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** Current status (raw lifecycle state, incl. retrying) */
  status: BackgroundJobStatusEnum;
  /** Total units of work */
  total: Scalars['Int']['output'];
  /** Rolled-up status for this job's whole tree — working while any node is live, otherwise the worst terminal outcome (so a failed child is not hidden behind a complete parent) */
  treeStatus: BackgroundJobStatusEnum;
  /** Last update time */
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

/** Description from base input object. Please set your description for child object. */
export type BackgroundJobCancelInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Background job ID */
  id: Scalars['ID']['input'];
};

/** BackgroundJobCollection type */
export type BackgroundJobCollection = {
  __typename?: 'BackgroundJobCollection';
  /** A collection of paginated BackgroundJobCollection */
  collection: Array<BackgroundJob>;
  /** Pagination Metadata for navigating the Pagination */
  metadata: CollectionMetadata;
};

/** Description from base input object. Please set your description for child object. */
export type BackgroundJobDismissInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Background job ID */
  id: Scalars['ID']['input'];
};

/** Background job filters */
export type BackgroundJobFilterInputObject = {
  /** Filter by creation time */
  createdAt?: InputMaybe<FilterDateInputObject>;
  /** Filter by the dismissed (closed-from-list) flag */
  dismissed?: InputMaybe<FilterBooleanInputObject>;
  /** Filter by finish time */
  finishedAt?: InputMaybe<FilterDateInputObject>;
  /** Filter by ID */
  id?: InputMaybe<FilterIdInputObject>;
  /** Filter by kind */
  kind?: InputMaybe<FilterIntInputObject>;
  /** Filter by status */
  status?: InputMaybe<FilterIntInputObject>;
};

/** Background-job kinds */
export enum BackgroundJobKindEnum {
  /** Data import */
  DataImport = 'DATA_IMPORT',
  /** AI field detection for an imported document */
  DocumentationFieldDetection = 'DOCUMENTATION_FIELD_DETECTION',
  /** Documentation import */
  DocumentationImport = 'DOCUMENTATION_IMPORT',
  /** QR code generation */
  QrCodeGeneration = 'QR_CODE_GENERATION',
  /** Timeline report generation */
  TimelineReport = 'TIMELINE_REPORT'
}

/** A pushed change to a background job tree — apply the node delta by id */
export type BackgroundJobProgressEvent = {
  __typename?: 'BackgroundJobProgressEvent';
  /** The changed node */
  node: Maybe<BackgroundJob>;
  /** Root node ID of the affected tree */
  rootId: Scalars['ID']['output'];
};

/** Description from base input object. Please set your description for child object. */
export type BackgroundJobRequestDeliveryInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Background job ID */
  id: Scalars['ID']['input'];
};

/** Description from base input object. Please set your description for child object. */
export type BackgroundJobRequeueInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Background job ID */
  id: Scalars['ID']['input'];
};

/** Coarse status-group presets for listing background jobs */
export enum BackgroundJobScopeEnum {
  /** All jobs */
  All = 'ALL',
  /** Completed */
  Completed = 'COMPLETED',
  /** Failed or interrupted */
  Failed = 'FAILED',
  /** Queued */
  Queued = 'QUEUED',
  /** Finished within the last 30 minutes (any outcome) */
  Recent = 'RECENT',
  /** Retrying */
  Retrying = 'RETRYING',
  /** Stopped */
  Stopped = 'STOPPED',
  /** Working */
  Working = 'WORKING'
}

/** Background job sorts */
export type BackgroundJobSortInputObject = {
  /** Sort by creation time */
  createdAt?: InputMaybe<SortDirectionEnum>;
  /** Sort by finish time */
  finishedAt?: InputMaybe<SortDirectionEnum>;
};

/** Background-job statuses */
export enum BackgroundJobStatusEnum {
  /** Completed successfully */
  Complete = 'COMPLETE',
  /** Failed (after all retries) */
  Failed = 'FAILED',
  /** Interrupted (process ended before finishing) */
  Interrupted = 'INTERRUPTED',
  /** Queued (waiting to be processed) */
  Queued = 'QUEUED',
  /** Still in progress: an attempt failed and another is scheduled. Not an outcome — use display_status, which presents it as working */
  Retrying = 'RETRYING',
  /** Stopped (cancelled) */
  Stopped = 'STOPPED',
  /** Work in progress */
  Working = 'WORKING'
}

/** Type for CollectionMetadataType */
export type CollectionMetadata = {
  __typename?: 'CollectionMetadata';
  /** Current Page of loaded data */
  currentPage: Scalars['Int']['output'];
  /** The number of items per page */
  limitValue: Scalars['Int']['output'];
  /** The total number of items to be paginated */
  totalCount: Scalars['Int']['output'];
  /** The total number of pages in the pagination */
  totalPages: Scalars['Int']['output'];
};

/** Available colors */
export enum ColorEnum {
  Aquamarine = 'AQUAMARINE',
  Black = 'BLACK',
  Blue = 'BLUE',
  Brown = 'BROWN',
  Coral = 'CORAL',
  Gray = 'GRAY',
  Green = 'GREEN',
  Lime = 'LIME',
  Orange = 'ORANGE',
  Pink = 'PINK',
  Red = 'RED',
  Violet = 'VIOLET',
  White = 'WHITE',
  Yellow = 'YELLOW'
}

/** Company entity */
export type Company = TimestampInterface & {
  __typename?: 'Company';
  /** Active users count in the company */
  activeUsersCount: Scalars['Int']['output'];
  /**
   * Share of the AI budget consumed this cycle, as a percentage (0–100); null when no budget is enforced.
   * ATTENTION: Access allowed for system admins.
   */
  aiAssistancePercentage: Maybe<Scalars['Float']['output']>;
  /**
   * The company's AI budget for the current cycle — AI credits + Total/User/System usage percentages (plus the raw euro ledger and cycle dates, system-admin only).
   * ATTENTION: Access allowed for system admins.
   */
  aiBudgetStatus: AiBudgetStatus;
  /**
   * Estimated AI cost for the current budget cycle, in EUR micros (millionths of a euro); null when no budget is enforced.
   * ATTENTION: Access allowed for system admins.
   */
  aiEstimatedPriceMicros: Maybe<Scalars['BigInt']['output']>;
  /**
   * Document indexing coverage counts for this company.
   * ATTENTION: Access allowed for system admins.
   */
  aiIndexingCoverage: AiIndexingCoverage;
  /** Country */
  country: CountryEnum;
  /** Time when was created */
  createdAt: Scalars['ISO8601DateTime']['output'];
  /** Indicates if company is deactivated */
  deactivated: Scalars['Boolean']['output'];
  /** Description */
  description: Scalars['String']['output'];
  /** Company ID */
  id: Scalars['ID']['output'];
  /** Industry */
  industry: Maybe<Industry>;
  /** Name */
  name: Scalars['String']['output'];
  /** Company full admin owner entity */
  owner: Maybe<User>;
  /** Plan entity */
  plan: CompanyPlan;
  /** Timezone name */
  timezone: Scalars['String']['output'];
  /** Last update time */
  updatedAt: Scalars['ISO8601DateTime']['output'];
  /** Active users as a percentage (0–100) of the plan's user limit; null when no limit is set. */
  usersLimitPercentage: Maybe<Scalars['Float']['output']>;
  /** Website */
  website: Maybe<Scalars['String']['output']>;
};


/** Company entity */
export type CompanyAiIndexingCoverageArgs = {
  region?: InputMaybe<CompanyPlanAiRegionEnum>;
};

/** CompanyCollection type */
export type CompanyCollection = {
  __typename?: 'CompanyCollection';
  /** A collection of paginated CompanyCollection */
  collection: Array<Company>;
  /** Pagination Metadata for navigating the Pagination */
  metadata: CollectionMetadata;
};

/** Description from base input object. Please set your description for child object. */
export type CompanyCreateInput = {
  /** Create attributes */
  attributes: CompanyCreateInputObject;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Url to confirm registration */
  redirectUrl: Scalars['String']['input'];
};

/** Company attributes */
export type CompanyCreateInputObject = {
  /** Admin attributes */
  admin: UserCreateOwnerInputObject;
  /** Country */
  country: CountryEnum;
  /** Description */
  description: Scalars['String']['input'];
  /** Industry ID */
  industryId?: InputMaybe<Scalars['ID']['input']>;
  /** Name */
  name: Scalars['String']['input'];
  /** Plan attributes */
  plan: CompanyPlanCuInputObject;
  /** Website */
  website?: InputMaybe<Scalars['String']['input']>;
};

/** Description from base input object. Please set your description for child object. */
export type CompanyDestroyInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** 2FA code for verification */
  code: Scalars['String']['input'];
  /** Type of code (totp, email, backup) */
  codeType: AuthenticationTwoFactorCodeTypeEnum;
  /** Company ID */
  id: Scalars['ID']['input'];
};

/** Company Domain entity */
export type CompanyDomain = TimestampInterface & {
  __typename?: 'CompanyDomain';
  /** Time when was created */
  createdAt: Scalars['ISO8601DateTime']['output'];
  /** Full DNS TXT record for domain verification */
  dnsTxtRecord: Scalars['String']['output'];
  /** Domain name */
  domain: Scalars['String']['output'];
  /** Company Domain ID */
  id: Scalars['ID']['output'];
  /** Last update time */
  updatedAt: Scalars['ISO8601DateTime']['output'];
  /** DNS verification token */
  verificationToken: Scalars['String']['output'];
  /** Indicates if domain is verified */
  verified: Scalars['Boolean']['output'];
  /** Verification timestamp */
  verifiedAt: Maybe<Scalars['ISO8601DateTime']['output']>;
};

/** CompanyDomainCollection type */
export type CompanyDomainCollection = {
  __typename?: 'CompanyDomainCollection';
  /** A collection of paginated CompanyDomainCollection */
  collection: Array<CompanyDomain>;
  /** Pagination Metadata for navigating the Pagination */
  metadata: CollectionMetadata;
};

/** Description from base input object. Please set your description for child object. */
export type CompanyDomainCreateInput = {
  /** Create attributes */
  attributes: CompanyDomainCreateInputObject;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Company Domain attributes */
export type CompanyDomainCreateInputObject = {
  /** Domain name (e.g., example.com) */
  domain: Scalars['String']['input'];
};

/** Description from base input object. Please set your description for child object. */
export type CompanyDomainDestroyInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Company Domain ID */
  id: Scalars['ID']['input'];
};

/** Company Domain filters */
export type CompanyDomainFilterInputObject = {
  /** Created at */
  createdAt?: InputMaybe<FilterDateInputObject>;
  /** Domain name */
  domain?: InputMaybe<FilterInputObject>;
  /** Company Domain ID */
  id?: InputMaybe<FilterIdInputObject>;
  /** Verification timestamp */
  verifiedAt?: InputMaybe<FilterDateInputObject>;
};

/** Company Domain sorts */
export type CompanyDomainSortInputObject = {
  /** Created at */
  createdAt?: InputMaybe<SortDirectionEnum>;
  /** Domain name */
  domain?: InputMaybe<SortDirectionEnum>;
  /** Verification timestamp */
  verifiedAt?: InputMaybe<SortDirectionEnum>;
};

/** Description from base input object. Please set your description for child object. */
export type CompanyDomainVerifyInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Company Domain ID */
  id: Scalars['ID']['input'];
};

/** Company filters */
export type CompanyFilterInputObject = {
  /** Country name */
  country?: InputMaybe<FilterInputObject>;
  /** Industry ID */
  industryId?: InputMaybe<FilterIdInputObject>;
  /** Industry name */
  industryName?: InputMaybe<FilterInputObject>;
  /** Company name */
  name?: InputMaybe<FilterInputObject>;
  /** Owner full name */
  ownerFullName?: InputMaybe<FilterInputObject>;
  /**
   * Plan kind
   * ATTENTION: Access allowed for system admins.
   */
  planKind?: InputMaybe<FilterIntInputObject>;
};

/** Company plan entity */
export type CompanyPlan = TimestampInterface & {
  __typename?: 'CompanyPlan';
  /** Accesses */
  accesses: Array<Access>;
  /**
   * AI budget cap for the current cycle, in EUR micros (millionths of a euro); null when no budget is set.
   * ATTENTION: Access allowed for system admins.
   */
  aiBudgetLimitMicros: Maybe<Scalars['BigInt']['output']>;
  /**
   * The media kinds the company's AI indexing pipeline turns into searchable text, derived from the plan's hosting region; an absent kind is not indexed.
   * ATTENTION: Requires plan upgrade for feature: AI_ASSISTANCE.
   */
  aiIndexableMediaKinds: Array<AiMediaKindEnum>;
  /**
   * The plan's AI hosting region and model configuration.
   * ATTENTION: Access allowed for system admins.
   */
  aiModelConfig: CompanyPlanAiModelConfig;
  /** Shows a list of available access components to create or edit for company users */
  allowedUsersAccessComponents: Array<AccessComponentEnum>;
  /** Time when was created */
  createdAt: Scalars['ISO8601DateTime']['output'];
  /**
   * Currency
   * ATTENTION: Access allowed for system admins.
   */
  currency: Maybe<CompanyPlanCurrencyEnum>;
  /** Company plan ID */
  id: Scalars['ID']['output'];
  /**
   * Kind
   * ATTENTION: Access allowed for system admins.
   */
  kind: Maybe<CompanyPlanKindEnum>;
  /**
   * Payment period
   * ATTENTION: Access allowed for system admins.
   */
  paymentPeriod: Maybe<CompanyPlanPaymentPeriodEnum>;
  /**
   * Price
   * ATTENTION: Access allowed for system admins.
   */
  price: Maybe<Scalars['Float']['output']>;
  /** Last update time */
  updatedAt: Scalars['ISO8601DateTime']['output'];
  /** Shows a list of features that require a plan upgrade for the company */
  upgradeFeatures: Array<AccessComponentEnum>;
  /** Maximum active users */
  usersLimit: Maybe<Scalars['Int']['output']>;
};

/** AI spending cap for the current billing period and the billing cycle anchor date. */
export type CompanyPlanAiBudgetInputObject = {
  /** Cap amount for the current billing period in euros (EUR). Provider-billed AI usage is converted to EUR at the exchange rate in effect when it occurred. */
  currentPeriod: Scalars['Float']['input'];
  /** Date the current billing cycle starts. Subsequent cycles roll over on the same day-of-month. Must be today or in the past. */
  cycleStartedAt: Scalars['ISO8601Date']['input'];
  /** When true, zeroes the counted spend now, making the full cap available for the rest of the current cycle. Billing cycle dates are unchanged, and a new cycle always starts counting from zero regardless of past resets. One-shot action, not a stored setting. */
  resetUsage?: InputMaybe<Scalars['Boolean']['input']>;
};

/** A company plan's AI hosting region and model configuration. The region-derived embedding/extraction models are not repeated here — read them from aiModelCatalog by region. */
export type CompanyPlanAiModelConfig = {
  __typename?: 'CompanyPlanAiModelConfig';
  /** The stored chat model selection; null when the region default applies. */
  chatModelId: Maybe<Scalars['String']['output']>;
  /** The chat model actually in effect — the stored selection, or the region default when none (or a delisted one) is stored. */
  effectiveChatModelId: Scalars['String']['output'];
  /** The display name of the effective chat model. */
  effectiveChatModelName: Scalars['String']['output'];
  /** The hosting and data region. */
  region: CompanyPlanAiRegionEnum;
};

/** AI hosting region and chat model selection. The embedding and extraction models are derived from the region and cannot be set. */
export type CompanyPlanAiModelConfigInputObject = {
  /** Chat model id from the chosen region's catalog (see aiModelCatalog). Omitted or null selects the region's default. */
  chatModelId?: InputMaybe<Scalars['String']['input']>;
  /** Hosting and data region. It derives the embedding and extraction models; changing it re-indexes every document with the new region's embedding model. */
  region: CompanyPlanAiRegionEnum;
};

/** AI hosting and data regions */
export enum CompanyPlanAiRegionEnum {
  /** Mistral models via their direct EU API (data stays in the EU) */
  EuSovereign = 'EU_SOVEREIGN',
  /** Google + OpenAI models via OpenRouter (US-hosted, zero data retention) */
  Standard = 'STANDARD'
}

/** Description from base input object. Please set your description for child object. */
export type CompanyPlanChangeRequestInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Params */
  params: CompanyPlanChangeRequestInputObject;
};

/** Company Plan change params */
export type CompanyPlanChangeRequestInputObject = {
  /**  Link to open the company profile page for system admins. Supported variables: `companyId`. Example: `https://system.datizy.com/dashboard/accounts/:companyId/view`  */
  companyProfileLink: Scalars['String']['input'];
  /** Email to contact */
  contactEmail: Scalars['String']['input'];
  /** Topics the request is about */
  features?: InputMaybe<Array<CompanyPlanUpgradeFeatureEnum>>;
  /** Message */
  message: Scalars['String']['input'];
};

/** Company Plan attributes */
export type CompanyPlanCuInputObject = {
  /** Accesses */
  accesses: Array<AccessCuInputObject>;
  /** AI spending cap for the current billing period (in euros) and billing cycle anchor. Null removes the budget — all AI features stay blocked until a budget is configured. */
  aiBudget?: InputMaybe<CompanyPlanAiBudgetInputObject>;
  /** AI hosting region and chat model powering the company's assistant. Null resets to the standard-region defaults. A region change switches the embedding model and automatically re-indexes the company's documents. */
  aiModelConfig?: InputMaybe<CompanyPlanAiModelConfigInputObject>;
  /** Currency */
  currency: CompanyPlanCurrencyEnum;
  /** Kind */
  kind: CompanyPlanKindEnum;
  /** Payment period */
  paymentPeriod: CompanyPlanPaymentPeriodEnum;
  /** Price */
  price: Scalars['Float']['input'];
  /** Limit of users */
  usersLimit?: InputMaybe<Scalars['Int']['input']>;
};

/** Available currencies */
export enum CompanyPlanCurrencyEnum {
  Eur = 'EUR'
}

/** Available plans */
export enum CompanyPlanKindEnum {
  Custom = 'CUSTOM',
  Gold = 'GOLD',
  Silver = 'SILVER',
  Starter = 'STARTER'
}

/** Available payment periods */
export enum CompanyPlanPaymentPeriodEnum {
  Month = 'MONTH'
}

/** Topics a plan change request can be about */
export enum CompanyPlanUpgradeFeatureEnum {
  /** AI assistance */
  AiAssistance = 'AI_ASSISTANCE',
  /** Billing or contract */
  BillingOrContract = 'BILLING_OR_CONTRACT',
  /** Documentation */
  Documentation = 'DOCUMENTATION',
  /** Feature question */
  FeatureQuestion = 'FEATURE_QUESTION',
  /** Interventions */
  Interventions = 'INTERVENTIONS',
  /** Other */
  Other = 'OTHER',
  /** Plan change */
  PlanChange = 'PLAN_CHANGE',
  /** User limit */
  UserLimit = 'USER_LIMIT',
  /** User limit change */
  UserLimitChange = 'USER_LIMIT_CHANGE'
}

/** Company sorts */
export type CompanySortInputObject = {
  /** Active users count */
  activeUsersCount?: InputMaybe<SortDirectionEnum>;
  /**
   * Share of the AI budget consumed this cycle
   * ATTENTION: Access allowed for system admins.
   */
  aiAssistancePercentage?: InputMaybe<SortDirectionEnum>;
  /**
   * Estimated AI cost for the current budget cycle
   * ATTENTION: Access allowed for system admins.
   */
  aiEstimatedPriceMicros?: InputMaybe<SortDirectionEnum>;
  /** Country name */
  country?: InputMaybe<SortDirectionEnum>;
  /** Created at */
  createdAt?: InputMaybe<SortDirectionEnum>;
  /** Industry name */
  industryName?: InputMaybe<SortDirectionEnum>;
  /** Company name */
  name?: InputMaybe<SortDirectionEnum>;
  /** Owner full name */
  ownerFullName?: InputMaybe<SortDirectionEnum>;
  /**
   * Plan kind
   * ATTENTION: Access allowed for system admins.
   */
  planKind?: InputMaybe<SortDirectionEnum>;
  /** Maximum users allowed by the plan */
  planUsersLimit?: InputMaybe<SortDirectionEnum>;
  /** Active users as a percentage of the plan's user limit */
  usersLimitPercentage?: InputMaybe<SortDirectionEnum>;
};

/** Description from base input object. Please set your description for child object. */
export type CompanyUpdateInput = {
  /** Update attributes */
  attributes: CompanyUpdateInputObject;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Company ID */
  id: Scalars['ID']['input'];
};

/** Company attributes */
export type CompanyUpdateInputObject = {
  /** Admin ID */
  adminId?: InputMaybe<Scalars['ID']['input']>;
  /** Country */
  country?: InputMaybe<CountryEnum>;
  /** Deactivate company */
  deactivated?: InputMaybe<Scalars['Boolean']['input']>;
  /** Description */
  description?: InputMaybe<Scalars['String']['input']>;
  /** Industry ID */
  industryId?: InputMaybe<Scalars['ID']['input']>;
  /** Name */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Plan attributes */
  plan?: InputMaybe<CompanyPlanCuInputObject>;
  /** Website */
  website?: InputMaybe<Scalars['String']['input']>;
};

/** Counter entity */
export type Counter = TimestampInterface & {
  __typename?: 'Counter';
  /**
   * Asset entity
   * NOTE: if you only need an Object ID, please use the assetId field to reduce the load on the database.
   */
  asset: Asset;
  /** Asset ID */
  assetId: Scalars['ID']['output'];
  /** Code */
  code: Scalars['String']['output'];
  /** Time when was created */
  createdAt: Scalars['ISO8601DateTime']['output'];
  /** Full code (As on the QR code) */
  fullCode: Scalars['String']['output'];
  /** Counter ID */
  id: Scalars['ID']['output'];
  /** Last check at */
  lastCheckAt: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** Latest index value */
  latestIndex: Maybe<Scalars['Float']['output']>;
  /** Measure type */
  measureType: CounterMeasureTypeEnum;
  /** Measure unit */
  measureUnit: CounterMeasureUnitEnum;
  /** Name */
  name: Scalars['String']['output'];
  /** Prohibit lower index. The next index must be higher than the previous one. The cumulative usage is calculated by adding the gap to the last cumulative total that is stored after the counter is reset. Allow lower index. The next index can be lower than the previous one. The cumulative usage is calculated by adding the index to the last cumulative total that is stored after the counter is reset. */
  prohibitLowerIndexThanPrevious: Scalars['Boolean']['output'];
  /** Last update time */
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

/** Description from base input object. Please set your description for child object. */
export type CounterBulkDestroyInput = {
  /** Asset ID */
  assetId: Scalars['ID']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Counter IDs */
  ids: Array<Scalars['ID']['input']>;
};

/** Description from base input object. Please set your description for child object. */
export type CounterBulkQrCodeCreateInput = {
  /** Asset ID */
  assetId: Scalars['ID']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Create params */
  params: QrCodesCreateInputObject;
};

/** CounterCollection type */
export type CounterCollection = {
  __typename?: 'CounterCollection';
  /** A collection of paginated CounterCollection */
  collection: Array<Counter>;
  /** Pagination Metadata for navigating the Pagination */
  metadata: CollectionMetadata;
};

/** Description from base input object. Please set your description for child object. */
export type CounterCreateInput = {
  /** Create attributes */
  attributes: CounterCreateInputObject;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Counter attributes */
export type CounterCreateInputObject = {
  /** Asset ID */
  assetId: Scalars['ID']['input'];
  /** Code */
  code: Scalars['String']['input'];
  /** Measure type */
  measureType: CounterMeasureTypeEnum;
  /** Measure unit */
  measureUnit: CounterMeasureUnitEnum;
  /** Name */
  name: Scalars['String']['input'];
  /** Prohibit lower index. The next index must be higher than the previous one. The cumulative usage is calculated by adding the gap to the last cumulative total that is stored after the counter is reset. Allow lower index. The next index can be lower than the previous one. The cumulative usage is calculated by adding the index to the last cumulative total that is stored after the counter is reset. */
  prohibitLowerIndexThanPrevious: Scalars['Boolean']['input'];
};

/** Counter filters */
export type CounterFilterInputObject = {
  /** Code */
  code?: InputMaybe<FilterInputObject>;
};

/** Counter attributes */
export type CounterFindByInputObject = {
  /** Code */
  code?: InputMaybe<Scalars['String']['input']>;
  /** ID */
  id?: InputMaybe<Scalars['ID']['input']>;
};

/** Counter Measure entity */
export type CounterMeasure = TimestampInterface & {
  __typename?: 'CounterMeasure';
  /**
   * Counter entity
   * NOTE: if you only need an Object ID, please use the counterId field to reduce the load on the database.
   */
  counter: Counter;
  /** Counter ID */
  counterId: Scalars['ID']['output'];
  /** Time when was created */
  createdAt: Scalars['ISO8601DateTime']['output'];
  /** (Total Consumption) - Previous cumulative value + the gap (to get the total usage over time) */
  cumulativeUsage: Scalars['Float']['output'];
  /** (Consumption) - The difference between the current index and the previous check index. If a new meter is installed, calculate the difference accordingly */
  gap: Scalars['Float']['output'];
  /** Counter ID */
  id: Scalars['ID']['output'];
  /** Manually entered the reading value */
  index: Scalars['Float']['output'];
  /** Indicates if the measure was reset to zero */
  resetToZero: Scalars['Boolean']['output'];
  /** Last update time */
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

/** CounterMeasureCollection type */
export type CounterMeasureCollection = {
  __typename?: 'CounterMeasureCollection';
  /** A collection of paginated CounterMeasureCollection */
  collection: Array<CounterMeasure>;
  /** Pagination Metadata for navigating the Pagination */
  metadata: CollectionMetadata;
};

/** Description from base input object. Please set your description for child object. */
export type CounterMeasureCreateInput = {
  /** Asset ID */
  assetId: Scalars['ID']['input'];
  /** Create attributes */
  attributes: CounterMeasureCreateInputObject;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Counter Measure attributes */
export type CounterMeasureCreateInputObject = {
  /** Counter ID */
  counterId: Scalars['ID']['input'];
  /** Manually entered the reading value */
  index: Scalars['Float']['input'];
};

/** Counter Measure filters */
export type CounterMeasureFilterInputObject = {
  /** Created at */
  createdAt?: InputMaybe<FilterDateInputObject>;
};

/** Counter Measure graph data */
export type CounterMeasureGraphData = {
  __typename?: 'CounterMeasureGraphData';
  /** Created at */
  createdAt: Scalars['ISO8601DateTime']['output'];
  /** (Total Consumption) - Previous cumulative value + the gap (to get the total usage over time) */
  cumulativeUsage: Scalars['Float']['output'];
  /** (Consumption) - The difference between the current index and the previous check index. If a new meter is installed, calculate the difference accordingly */
  gap: Scalars['Float']['output'];
};

/** Counter Measure sorts */
export type CounterMeasureSortInputObject = {
  /** Created at */
  createdAt?: InputMaybe<SortDirectionEnum>;
};

/** All available measure types */
export enum CounterMeasureTypeEnum {
  Distance = 'DISTANCE',
  Energy = 'ENERGY',
  Mass = 'MASS',
  Quantity = 'QUANTITY',
  Time = 'TIME'
}

/** All available measure units */
export enum CounterMeasureUnitEnum {
  Centimeter = 'CENTIMETER',
  Foot = 'FOOT',
  Gram = 'GRAM',
  Hour = 'HOUR',
  Kilogram = 'KILOGRAM',
  Kilometer = 'KILOMETER',
  KilowattHour = 'KILOWATT_HOUR',
  Meter = 'METER',
  Mile = 'MILE',
  Minute = 'MINUTE',
  Piece = 'PIECE',
  Second = 'SECOND',
  Ton = 'TON',
  Yard = 'YARD'
}

/** Description from base input object. Please set your description for child object. */
export type CounterResetToZeroInput = {
  /** Asset ID */
  assetId: Scalars['ID']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Counter ID */
  id: Scalars['ID']['input'];
};

/** Counter sorts */
export type CounterSortInputObject = {
  /** Code */
  code?: InputMaybe<SortDirectionEnum>;
  /** Created at */
  createdAt?: InputMaybe<SortDirectionEnum>;
  /** Last check at */
  lastCheckAt?: InputMaybe<SortDirectionEnum>;
  /** Latest index value */
  latestIndex?: InputMaybe<SortDirectionEnum>;
  /** Name */
  name?: InputMaybe<SortDirectionEnum>;
  /** Updated at */
  updatedAt?: InputMaybe<SortDirectionEnum>;
};

/** Description from base input object. Please set your description for child object. */
export type CounterUpdateInput = {
  /** Counter ID */
  assetId: Scalars['ID']['input'];
  /** Update attributes */
  attributes: CounterUpdateInputObject;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Counter ID */
  id: Scalars['ID']['input'];
};

/** Counter attributes */
export type CounterUpdateInputObject = {
  /** Name */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Prohibit lower index. The next index must be higher than the previous one. The cumulative usage is calculated by adding the gap to the last cumulative total that is stored after the counter is reset. Allow lower index. The next index can be lower than the previous one. The cumulative usage is calculated by adding the index to the last cumulative total that is stored after the counter is reset. */
  prohibitLowerIndexThanPrevious?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Available countries */
export enum CountryEnum {
  /** Andorra */
  Ad = 'AD',
  /** Albania */
  Al = 'AL',
  /** Austria */
  At = 'AT',
  /** Bosnia and Herzegovina */
  Ba = 'BA',
  /** Belgium */
  Be = 'BE',
  /** Bulgaria */
  Bg = 'BG',
  /** Canada */
  Ca = 'CA',
  /** Switzerland */
  Ch = 'CH',
  /** Cyprus */
  Cy = 'CY',
  /** Czech Republic */
  Cz = 'CZ',
  /** Germany */
  De = 'DE',
  /** Denmark */
  Dk = 'DK',
  /** Estonia */
  Ee = 'EE',
  /** Spain */
  Es = 'ES',
  /** Finland */
  Fi = 'FI',
  /** France */
  Fr = 'FR',
  /** United Kingdom */
  Gb = 'GB',
  /** Greenland */
  Gl = 'GL',
  /** Greece */
  Gr = 'GR',
  /** Croatia */
  Hr = 'HR',
  /** Hungary */
  Hu = 'HU',
  /** Ireland */
  Ie = 'IE',
  /** Iceland */
  Is = 'IS',
  /** Italy */
  It = 'IT',
  /** Lithuania */
  Lt = 'LT',
  /** Luxembourg */
  Lu = 'LU',
  /** Latvia */
  Lv = 'LV',
  /** Monaco */
  Mc = 'MC',
  /** Moldova */
  Md = 'MD',
  /** Montenegro */
  Me = 'ME',
  /** North Macedonia */
  Mk = 'MK',
  /** Malta */
  Mt = 'MT',
  /** Mexico */
  Mx = 'MX',
  /** Netherlands */
  Nl = 'NL',
  /** Norway */
  No = 'NO',
  /** Poland */
  Pl = 'PL',
  /** Saint Pierre and Miquelon */
  Pm = 'PM',
  /** Portugal */
  Pt = 'PT',
  /** Romania */
  Ro = 'RO',
  /** Serbia */
  Rs = 'RS',
  /** Sweden */
  Se = 'SE',
  /** Slovenia */
  Si = 'SI',
  /** Slovakia */
  Sk = 'SK',
  /** San Marino */
  Sm = 'SM',
  /** Ukraine */
  Ua = 'UA',
  /** United States of America */
  Us = 'US',
  /** Vatican City */
  Va = 'VA'
}

/** Data Import entity */
export type DataImport = TimestampInterface & {
  __typename?: 'DataImport';
  /** Attachment to import */
  attachmentAttached: Maybe<Attachment>;
  /** Background job tracking this import (status, progress, result) */
  backgroundJob: Maybe<BackgroundJob>;
  canDestroy: AuthorizationResult;
  canUpdate: AuthorizationResult;
  /** Time when was created */
  createdAt: Scalars['ISO8601DateTime']['output'];
  /** Failure error details */
  failureDetails: Maybe<Scalars['CamelizedJson']['output']>;
  /** File exception (use when failureDetails is empty and there is a file exception) */
  fileException: Maybe<Array<Scalars['String']['output']>>;
  /** Data Import ID */
  id: Scalars['ID']['output'];
  /** Indicator to ignore rows with errors and import only valid rows */
  ignoreRowsWithErrors: Scalars['Boolean']['output'];
  /** Imported rows */
  importedRows: Maybe<Scalars['Int']['output']>;
  /** Kind of import */
  kind: DataImportKindEnum;
  /** Current status */
  status: DataImportStatusEnum;
  /** Total rows to import */
  totalRows: Maybe<Scalars['Int']['output']>;
  /** Last update time */
  updatedAt: Scalars['ISO8601DateTime']['output'];
  /**
   * Created by User
   * NOTE: if you only need an Object ID, please use the userId field to reduce the load on the database.
   */
  user: Maybe<User>;
  /** Created by User ID */
  userId: Scalars['ID']['output'];
};

/** DataImportCollection type */
export type DataImportCollection = {
  __typename?: 'DataImportCollection';
  /** A collection of paginated DataImportCollection */
  collection: Array<DataImport>;
  /** Pagination Metadata for navigating the Pagination */
  metadata: CollectionMetadata;
};

/** Description from base input object. Please set your description for child object. */
export type DataImportCreateInput = {
  /** Create attributes */
  attributes: DataImportCreateInputObject;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Data Import attributes */
export type DataImportCreateInputObject = {
  /** Attachment to import */
  attachmentAttached: AttachmentCuInputObject;
  /** Indicator to ignore rows with errors and import only valid rows */
  ignoreRowsWithErrors?: InputMaybe<Scalars['Boolean']['input']>;
  /** Kind of import */
  kind: DataImportKindEnum;
};

/** Description from base input object. Please set your description for child object. */
export type DataImportDestroyInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Data Import ID */
  id: Scalars['ID']['input'];
};

/** Data Import filters */
export type DataImportFilterInputObject = {
  /** Created at */
  createdAt?: InputMaybe<FilterInputObject>;
  /** Data Import ID */
  id?: InputMaybe<FilterIdInputObject>;
  /** Kind of import */
  kind?: InputMaybe<FilterInputObject>;
};

/** Available data import kinds */
export enum DataImportKindEnum {
  Asset = 'ASSET',
  Site = 'SITE',
  SiteArea = 'SITE_AREA'
}

/** Data Import sorts */
export type DataImportSortInputObject = {
  /** Attachment filename */
  attachmentFilename?: InputMaybe<SortDirectionEnum>;
  /** Created at */
  createdAt?: InputMaybe<SortDirectionEnum>;
  /** Kind of import */
  kind?: InputMaybe<SortDirectionEnum>;
  /** Created by user full name */
  userFullName?: InputMaybe<SortDirectionEnum>;
};

/** Available data import statuses */
export enum DataImportStatusEnum {
  /** Completed successfully */
  Complete = 'COMPLETE',
  /** Failed (after all retries) */
  Failed = 'FAILED',
  /** Interrupted (process ended before finishing) */
  Interrupted = 'INTERRUPTED',
  /** Queued (waiting to be processed) */
  Queued = 'QUEUED',
  /** Still in progress: an attempt failed and another is scheduled. Not an outcome — use display_status, which presents it as working */
  Retrying = 'RETRYING',
  /** Stopped (cancelled) */
  Stopped = 'STOPPED',
  /** Work in progress */
  Working = 'WORKING'
}

/** Description from base input object. Please set your description for child object. */
export type DataImportUpdateInput = {
  /** Update attributes */
  attributes: DataImportUpdateInputObject;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Data Import ID */
  id: Scalars['ID']['input'];
};

/** Data Import attributes */
export type DataImportUpdateInputObject = {
  /** Attachment to import */
  attachmentAttached?: InputMaybe<AttachmentCuInputObject>;
  /** Indicator to ignore rows with errors and import only valid rows */
  ignoreRowsWithErrors?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Date range attributes */
export type DateRangeInputObject = {
  /** End date */
  endDate: Scalars['ISO8601Date']['input'];
  /** Start date */
  startDate: Scalars['ISO8601Date']['input'];
};

/** Department entity */
export type Department = TimestampInterface & {
  __typename?: 'Department';
  canDestroy: AuthorizationResult;
  /** Direct sub-departments (nest to descend the tree; empty for a leaf) */
  children: Array<Department>;
  /** Direct sub-departments count (positive when the department can be unfolded) */
  childrenCount: Maybe<Scalars['Int']['output']>;
  /** Color */
  color: ColorEnum;
  /** Time when was created */
  createdAt: Scalars['ISO8601DateTime']['output'];
  /** Description */
  description: Maybe<Scalars['String']['output']>;
  /** Department ID */
  id: Scalars['ID']['output'];
  /** Directly linked interventions count */
  interventionsOwnCount: Maybe<Scalars['Int']['output']>;
  /** Responsible manager */
  manager: Maybe<User>;
  /** Directly assigned members count */
  membersOwnCount: Maybe<Scalars['Int']['output']>;
  /** Members count including all sub-departments (distinct users) */
  membersTotalCount: Maybe<Scalars['Int']['output']>;
  /** Name */
  name: Scalars['String']['output'];
  /** Parent department (walk ancestors by nesting; empty for a top-level department) */
  parent: Maybe<Department>;
  /** Parent department ID (empty for a top-level department) */
  parentId: Maybe<Scalars['ID']['output']>;
  /** Full hierarchy path (ancestor names joined by " / ") */
  path: Maybe<Scalars['String']['output']>;
  /** Directly linked task groups count */
  tasksOwnCount: Maybe<Scalars['Int']['output']>;
  /** Linked task groups count including all sub-departments */
  tasksTotalCount: Maybe<Scalars['Int']['output']>;
  /** Last update time */
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

/** DepartmentCollection type */
export type DepartmentCollection = {
  __typename?: 'DepartmentCollection';
  /** A collection of paginated DepartmentCollection */
  collection: Array<Department>;
  /** Pagination Metadata for navigating the Pagination */
  metadata: CollectionMetadata;
};

/** Description from base input object. Please set your description for child object. */
export type DepartmentCreateInput = {
  /** Create attributes */
  attributes: DepartmentCreateInputObject;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Department attributes */
export type DepartmentCreateInputObject = {
  /** Color */
  color: ColorEnum;
  /** Description */
  description?: InputMaybe<Scalars['String']['input']>;
  /** Intervention links attributes array */
  interventionLinks?: InputMaybe<Array<LinkingInputObject>>;
  /** Responsible manager ID */
  managerId?: InputMaybe<Scalars['ID']['input']>;
  /** Members attributes array */
  members?: InputMaybe<Array<LinkingInputObject>>;
  /** Name */
  name: Scalars['String']['input'];
  /** Parent department ID (leave empty for a top-level department) */
  parentId?: InputMaybe<Scalars['ID']['input']>;
  /** Task links attributes array (a link applies to the whole recurring task group) */
  taskLinks?: InputMaybe<Array<LinkingInputObject>>;
  /** Access group links attributes array */
  teamLinks?: InputMaybe<Array<LinkingInputObject>>;
};

/** Description from base input object. Please set your description for child object. */
export type DepartmentDestroyInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Department ID */
  id: Scalars['ID']['input'];
};

/** Department filters */
export type DepartmentFilterInputObject = {
  /** Filter to departments linked to this intervention */
  departmentInterventionsInterventionId?: InputMaybe<FilterIdInputObject>;
  /** Filter to departments linked to the task group with this group key */
  departmentTaskGroupsGroupKey?: InputMaybe<FilterIdInputObject>;
  /** Responsible manager full name */
  managerFullName?: InputMaybe<FilterInputObject>;
  /** Responsible manager ID */
  managerId?: InputMaybe<FilterIdInputObject>;
  /** Name */
  name?: InputMaybe<FilterInputObject>;
  /** Filter to departments linked to this access group */
  teamsId?: InputMaybe<FilterIdInputObject>;
  /** Members full name */
  usersFullName?: InputMaybe<FilterInputObject>;
  /** Filter to departments this user is a member of */
  usersId?: InputMaybe<FilterIdInputObject>;
};

/** Department sorts */
export type DepartmentSortInputObject = {
  /** Created at */
  createdAt?: InputMaybe<SortDirectionEnum>;
  /** Name */
  name?: InputMaybe<SortDirectionEnum>;
};

/** Description from base input object. Please set your description for child object. */
export type DepartmentUpdateInput = {
  /** Update attributes */
  attributes: DepartmentUpdateInputObject;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Department ID */
  id: Scalars['ID']['input'];
};

/** Department attributes */
export type DepartmentUpdateInputObject = {
  /** Color */
  color?: InputMaybe<ColorEnum>;
  /** Description */
  description?: InputMaybe<Scalars['String']['input']>;
  /** Intervention links attributes array */
  interventionLinks?: InputMaybe<Array<LinkingInputObject>>;
  /** Responsible manager ID */
  managerId?: InputMaybe<Scalars['ID']['input']>;
  /** Members attributes array */
  members?: InputMaybe<Array<LinkingInputObject>>;
  /** Name */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Parent department ID (leave empty for a top-level department) */
  parentId?: InputMaybe<Scalars['ID']['input']>;
  /** Task links attributes array (a link applies to the whole recurring task group) */
  taskLinks?: InputMaybe<Array<LinkingInputObject>>;
  /** Access group links attributes array */
  teamLinks?: InputMaybe<Array<LinkingInputObject>>;
};

/** Company-wide default values for document renewal reminders (singleton per company) */
export type DocumentRenewalReminderTemplate = TimestampInterface & {
  __typename?: 'DocumentRenewalReminderTemplate';
  /** Time when was created */
  createdAt: Scalars['ISO8601DateTime']['output'];
  /** Document Renewal Reminder Template ID */
  id: Scalars['ID']['output'];
  /** Recurring renewal anchor in MM-DD format — two-digit month (01-12), dash, two-digit day (01-31). Examples: "10-15" for October 15, "02-29" for February 29. The year is intentionally not stored; FE picks the next concrete deadline at doc-create time. */
  renewalDeadlineMd: Maybe<Scalars['String']['output']>;
  /** Days before the deadline when an early reminder should be triggered */
  renewalEarlyReminderDays: Maybe<Scalars['Int']['output']>;
  /** Recurring renewal cadence (MONTHLY, QUARTERLY, HALF_YEARLY, YEARLY, CUSTOM) */
  renewalRepetition: Maybe<DocumentationRenewalRepetitionEnum>;
  /** Custom interval in days when renewal_repetition is CUSTOM */
  renewalRepetitionCustomDays: Maybe<Scalars['Int']['output']>;
  /** Last update time */
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

/** Description from base input object. Please set your description for child object. */
export type DocumentRenewalReminderTemplateUpdateInput = {
  /** Update attributes */
  attributes: DocumentRenewalReminderTemplateUpdateInputObject;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Document Renewal Reminder Template update attributes */
export type DocumentRenewalReminderTemplateUpdateInputObject = {
  /** Recurring renewal anchor in MM-DD format — two-digit month (01-12), dash, two-digit day (01-31). Examples: "10-15" for October 15, "02-29" for February 29. The year is intentionally not stored; FE picks the next concrete deadline at doc-create time. */
  renewalDeadlineMd?: InputMaybe<Scalars['String']['input']>;
  /** Days before the deadline when an early reminder should be triggered */
  renewalEarlyReminderDays?: InputMaybe<Scalars['Int']['input']>;
  /** Recurring renewal cadence (MONTHLY, QUARTERLY, HALF_YEARLY, YEARLY, CUSTOM) */
  renewalRepetition?: InputMaybe<DocumentationRenewalRepetitionEnum>;
  /** Custom interval in days when renewal_repetition is CUSTOM */
  renewalRepetitionCustomDays?: InputMaybe<Scalars['Int']['input']>;
};

/** Documentation entity */
export type Documentation = TimestampInterface & {
  __typename?: 'Documentation';
  /**
   * Whether the current version's file can be attached to an AI chat, or the reason it cannot
   * ATTENTION: Requires plan upgrade for feature: DOCUMENTATION_MANAGEMENT, AI_ASSISTANCE.
   */
  aiAttachability: Maybe<AiAttachabilityStatusEnum>;
  /**
   * Per-field AI-detection status (one entry per field AI is detecting)
   * ATTENTION: Requires plan upgrade for feature: DOCUMENTATION_MANAGEMENT, AI_ASSISTANCE.
   */
  aiDetectionStatus: Array<DocumentationFieldDetectionStatus>;
  /**
   * Machine-readable reason the current version's processing failed; null while nothing has failed.
   * ATTENTION: Access allowed for full admins.
   * ATTENTION: Requires plan upgrade for feature: DOCUMENTATION_MANAGEMENT, AI_ASSISTANCE.
   */
  aiIndexingError: Maybe<Scalars['String']['output']>;
  /**
   * Which automatic pass, if any, will come back to this document next; null when nothing needs indexing. Says whether a document that is not searchable will fix itself — which the status alone cannot, since FAILED only means processing has not completed yet.
   * ATTENTION: Access allowed for full admins.
   * ATTENTION: Requires plan upgrade for feature: DOCUMENTATION_MANAGEMENT, AI_ASSISTANCE.
   */
  aiIndexingRetryLane: Maybe<AiIndexingRetryLaneEnum>;
  /**
   * Where the current version stands in AI processing, including whether it yielded searchable content (SKIPPED). Only INDEXED documents are reachable by assistant search.
   * ATTENTION: Access allowed for full admins.
   * ATTENTION: Requires plan upgrade for feature: DOCUMENTATION_MANAGEMENT, AI_ASSISTANCE.
   */
  aiIndexingStatus: Maybe<AiIndexingStatusEnum>;
  /**
   * Approver user entity
   * ATTENTION: Requires plan upgrade for feature: DOCUMENTATION_MANAGEMENT.
   */
  approver: Maybe<User>;
  /**
   * Approver user ID
   * ATTENTION: Requires plan upgrade for feature: DOCUMENTATION_MANAGEMENT.
   */
  approverId: Maybe<Scalars['ID']['output']>;
  canDestroy: AuthorizationResult;
  canUpdate: AuthorizationResult;
  canUpdateValidationStatus: AuthorizationResult;
  /**
   * Category entity
   * ATTENTION: Requires plan upgrade for feature: DOCUMENTATION_MANAGEMENT.
   */
  category: Maybe<DocumentationCategory>;
  /**
   * Category ID
   * ATTENTION: Requires plan upgrade for feature: DOCUMENTATION_MANAGEMENT.
   */
  categoryId: Maybe<Scalars['ID']['output']>;
  /** Code */
  code: Maybe<Scalars['String']['output']>;
  /** Time when was created */
  createdAt: Scalars['ISO8601DateTime']['output'];
  /**
   * User entity
   * NOTE: if you only need an Object ID, please use the createdById field to reduce the load on the database.
   */
  createdBy: Maybe<User>;
  /** User ID */
  createdById: Maybe<Scalars['ID']['output']>;
  /** Current version */
  currentVersion: Maybe<DocumentationVersion>;
  /** Description */
  description: Maybe<Scalars['String']['output']>;
  /**
   * Whether the current user has favorited this documentation
   * ATTENTION: Requires plan upgrade for feature: DOCUMENTATION_MANAGEMENT.
   */
  favorited: Scalars['Boolean']['output'];
  /** Documentation ID */
  id: Scalars['ID']['output'];
  /** Name */
  name: Maybe<Scalars['String']['output']>;
  /**
   * Whether the current user has explicitly confirmed reading the required version of this documentation, via documentationVersionMarkAsRead. Opening a document does not set it (null when not computed)
   * ATTENTION: Requires plan upgrade for feature: DOCUMENTATION_MANAGEMENT.
   */
  read: Maybe<Scalars['Boolean']['output']>;
  /**
   * Renewal deadline date
   * ATTENTION: Requires plan upgrade for feature: DOCUMENTATION_MANAGEMENT.
   */
  renewalDeadlineDate: Maybe<Scalars['ISO8601Date']['output']>;
  /**
   * Days before deadline to send early reminder
   * ATTENTION: Requires plan upgrade for feature: DOCUMENTATION_MANAGEMENT.
   */
  renewalEarlyReminderDays: Maybe<Scalars['Int']['output']>;
  /**
   * Renewal repetition frequency
   * ATTENTION: Requires plan upgrade for feature: DOCUMENTATION_MANAGEMENT.
   */
  renewalRepetition: Maybe<DocumentationRenewalRepetitionEnum>;
  /**
   * Custom repetition interval in days
   * ATTENTION: Requires plan upgrade for feature: DOCUMENTATION_MANAGEMENT.
   */
  renewalRepetitionCustomDays: Maybe<Scalars['Int']['output']>;
  /**
   * AI-suggested alternative codes, for the user to choose from (populated on import when several codes are detected)
   * ATTENTION: Requires plan upgrade for feature: DOCUMENTATION_MANAGEMENT, AI_ASSISTANCE.
   */
  suggestedCodes: Array<Scalars['String']['output']>;
  /** Tags collection */
  tags: Array<Tag>;
  /**
   * Sum of reading_duration_seconds across all read documentation version reads for the documentation (null when not computed)
   * ATTENTION: Requires plan upgrade for feature: DOCUMENTATION_MANAGEMENT.
   */
  totalEngagementSeconds: Maybe<Scalars['Int']['output']>;
  /** Last update time */
  updatedAt: Scalars['ISO8601DateTime']['output'];
  /**
   * Validation status
   * ATTENTION: Requires plan upgrade for feature: DOCUMENTATION_MANAGEMENT.
   */
  validationStatus: Maybe<DocumentationValidationStatusEnum>;
};

/** Per-category analytics row — view totals and share of total within the requested period */
export type DocumentationAnalyticsByCategory = {
  __typename?: 'DocumentationAnalyticsByCategory';
  /** Documentation category ID */
  categoryId: Scalars['ID']['output'];
  /** Share of total views (0–100) */
  percentage: Scalars['Float']['output'];
  /** Total views across all documents in this category */
  viewCount: Scalars['Int']['output'];
};

/** Documentation analytics sorts (per-category table) */
export type DocumentationAnalyticsByCategorySortInputObject = {
  /** Category name */
  categoryName?: InputMaybe<SortDirectionEnum>;
  /** Share of total views */
  percentage?: InputMaybe<SortDirectionEnum>;
  /** View count */
  viewCount?: InputMaybe<SortDirectionEnum>;
};

/** Per-document analytics row — view metrics for a single documentation within the requested period */
export type DocumentationAnalyticsByDocument = {
  __typename?: 'DocumentationAnalyticsByDocument';
  /** Average viewing time in seconds (null when no duration data) */
  avgTime: Maybe<Scalars['Float']['output']>;
  /** Documentation ID */
  documentationId: Scalars['ID']['output'];
  /** Longest viewing time in seconds (null when no duration data) */
  maxTime: Maybe<Scalars['Int']['output']>;
  /** Shortest viewing time in seconds (null when no duration data) */
  minTime: Maybe<Scalars['Int']['output']>;
  /** Total viewing time in seconds across all views (null when no duration data) */
  totalTime: Maybe<Scalars['Int']['output']>;
  /** Distinct users who opened the documentation */
  uniqueViews: Scalars['Int']['output'];
  /** Total views (each open creates a row) */
  viewCount: Scalars['Int']['output'];
};

/** DocumentationAnalyticsByDocumentCollection type */
export type DocumentationAnalyticsByDocumentCollection = {
  __typename?: 'DocumentationAnalyticsByDocumentCollection';
  /** A collection of paginated DocumentationAnalyticsByDocumentCollection */
  collection: Array<DocumentationAnalyticsByDocument>;
  /** Pagination Metadata for navigating the Pagination */
  metadata: CollectionMetadata;
};

/** Per-linked-entity analytics row — views of documents linked to one site/sector/form template/area/asset within the requested period. A document linked to several targets counts under each, so percentages can sum past 100. */
export type DocumentationAnalyticsByLinkable = {
  __typename?: 'DocumentationAnalyticsByLinkable';
  /** Linked entity ID */
  linkableId: Scalars['ID']['output'];
  /** Linked entity name */
  name: Scalars['String']['output'];
  /** Share of linkable-attributed views in the period */
  percentage: Scalars['Float']['output'];
  /** Distinct users who viewed documents linked to this entity */
  uniqueViews: Scalars['Int']['output'];
  /** Views of documents linked to this entity */
  viewCount: Scalars['Int']['output'];
};

/** Documentation analytics sorts (per-linked-entity table) */
export type DocumentationAnalyticsByLinkableSortInputObject = {
  /** Linked entity name */
  name?: InputMaybe<SortDirectionEnum>;
  /** Share of linkable-attributed views */
  percentage?: InputMaybe<SortDirectionEnum>;
  /** Unique views */
  uniqueViews?: InputMaybe<SortDirectionEnum>;
  /** View count */
  viewCount?: InputMaybe<SortDirectionEnum>;
};

/** Per-user analytics row — one user's viewing activity within the requested period. Returned only for reads the requester is allowed to see. */
export type DocumentationAnalyticsByUser = {
  __typename?: 'DocumentationAnalyticsByUser';
  /** Average viewing time in seconds (null when no duration data) */
  avgTime: Maybe<Scalars['Float']['output']>;
  /** Total viewing time in seconds (null when no duration data) */
  totalTime: Maybe<Scalars['Int']['output']>;
  /** Distinct documents this user viewed */
  uniqueDocuments: Scalars['Int']['output'];
  /**
   * The user, resolved from %{id_field}
   * NOTE: if you only need an Object ID, please use the userId field to reduce the load on the database.
   */
  user: Maybe<User>;
  /** User ID */
  userId: Scalars['ID']['output'];
  /** Views by this user (each open creates a row) */
  viewCount: Scalars['Int']['output'];
};

/** Documentation analytics sorts (per-user table) */
export type DocumentationAnalyticsByUserSortInputObject = {
  /** Average viewing time */
  avgTime?: InputMaybe<SortDirectionEnum>;
  /** Total viewing time */
  totalTime?: InputMaybe<SortDirectionEnum>;
  /** Distinct documents viewed */
  uniqueDocuments?: InputMaybe<SortDirectionEnum>;
  /** User full name */
  userFullName?: InputMaybe<SortDirectionEnum>;
  /** View count */
  viewCount?: InputMaybe<SortDirectionEnum>;
};

/** The linked-entity dimension a documentation-views rollup groups by. */
export enum DocumentationAnalyticsLinkableDimensionEnum {
  /** Views grouped by linked site area. */
  Areas = 'AREAS',
  /** Views grouped by linked asset. */
  Assets = 'ASSETS',
  /** Views grouped by linked form template. */
  FormTemplates = 'FORM_TEMPLATES',
  /** Views grouped by linked sector. */
  Sectors = 'SECTORS',
  /** Views grouped by linked site. */
  Sites = 'SITES'
}

/** Documentation analytics sorts (per-document table) */
export type DocumentationAnalyticsSortInputObject = {
  /** Average viewing time */
  avgTime?: InputMaybe<SortDirectionEnum>;
  /** Category name */
  categoryName?: InputMaybe<SortDirectionEnum>;
  /** Maximum viewing time */
  maxTime?: InputMaybe<SortDirectionEnum>;
  /** Minimum viewing time */
  minTime?: InputMaybe<SortDirectionEnum>;
  /** Name */
  name?: InputMaybe<SortDirectionEnum>;
  /** Total viewing time */
  totalTime?: InputMaybe<SortDirectionEnum>;
  /** Unique views */
  uniqueViews?: InputMaybe<SortDirectionEnum>;
  /** View count */
  viewCount?: InputMaybe<SortDirectionEnum>;
};

/** Time-series data point for the documentation views trend */
export type DocumentationAnalyticsTrendPoint = {
  __typename?: 'DocumentationAnalyticsTrendPoint';
  /** Total views in this bucket */
  allViews: Scalars['Int']['output'];
  /** Bucket start date */
  period: Scalars['ISO8601Date']['output'];
  /** Distinct users who opened any documentation in this bucket */
  uniqueViews: Scalars['Int']['output'];
};

/** Description from base input object. Please set your description for child object. */
export type DocumentationBulkDestroyInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Documentation IDs */
  ids: Array<Scalars['ID']['input']>;
};

/** Description from base input object. Please set your description for child object. */
export type DocumentationBulkEditInput = {
  /** Edit attributes */
  attributes: DocumentationBulkEditInputObject;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Documentation IDs */
  ids: Array<Scalars['ID']['input']>;
};

/** Documentation attributes */
export type DocumentationBulkEditInputObject = {
  /**
   * Approver ID
   * ATTENTION: Requires plan upgrade for feature: DOCUMENTATION_MANAGEMENT.
   */
  approverId?: InputMaybe<Scalars['ID']['input']>;
  /**
   * Site area links
   * ATTENTION: Requires plan upgrade for feature: DOCUMENTATION_MANAGEMENT.
   */
  areaLinks?: InputMaybe<Array<DocumentationLinkInputObject>>;
  /** Asset links */
  assetLinks?: InputMaybe<Array<DocumentationLinkInputObject>>;
  /**
   * Category ID
   * ATTENTION: Requires plan upgrade for feature: DOCUMENTATION_MANAGEMENT.
   */
  categoryId?: InputMaybe<Scalars['ID']['input']>;
  /**
   * Form template links
   * ATTENTION: Requires plan upgrade for feature: DOCUMENTATION_MANAGEMENT.
   */
  formTemplateLinks?: InputMaybe<Array<LinkingInputObject>>;
  /**
   * Renewal deadline date
   * ATTENTION: Requires plan upgrade for feature: DOCUMENTATION_MANAGEMENT.
   */
  renewalDeadlineDate?: InputMaybe<Scalars['ISO8601Date']['input']>;
  /**
   * Days before deadline to send early reminder
   * ATTENTION: Requires plan upgrade for feature: DOCUMENTATION_MANAGEMENT.
   */
  renewalEarlyReminderDays?: InputMaybe<Scalars['Int']['input']>;
  /**
   * Renewal repetition frequency
   * ATTENTION: Requires plan upgrade for feature: DOCUMENTATION_MANAGEMENT.
   */
  renewalRepetition?: InputMaybe<DocumentationRenewalRepetitionEnum>;
  /**
   * Custom repetition interval in days
   * ATTENTION: Requires plan upgrade for feature: DOCUMENTATION_MANAGEMENT.
   */
  renewalRepetitionCustomDays?: InputMaybe<Scalars['Int']['input']>;
  /**
   * Sector links
   * ATTENTION: Requires plan upgrade for feature: DOCUMENTATION_MANAGEMENT.
   */
  sectorLinks?: InputMaybe<Array<LinkingInputObject>>;
  /**
   * Site links
   * ATTENTION: Requires plan upgrade for feature: DOCUMENTATION_MANAGEMENT.
   */
  siteLinks?: InputMaybe<Array<LinkingInputObject>>;
  /**
   * Task group links
   * ATTENTION: Requires plan upgrade for feature: DOCUMENTATION_MANAGEMENT.
   */
  taskGroupLinks?: InputMaybe<Array<LinkingInputObject>>;
};

/** Description from base input object. Please set your description for child object. */
export type DocumentationBulkFavoriteInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Documentation IDs */
  ids: Array<Scalars['ID']['input']>;
};

/** Description from base input object. Please set your description for child object. */
export type DocumentationBulkUnfavoriteInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Documentation IDs */
  ids: Array<Scalars['ID']['input']>;
};

/** Description from base input object. Please set your description for child object. */
export type DocumentationBulkUpdateValidationStatusInput = {
  /** Update attributes */
  attributes: DocumentationUpdateValidationStatusInputObject;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Documentation IDs */
  ids: Array<Scalars['ID']['input']>;
};

/** Documentation Category entity */
export type DocumentationCategory = TimestampInterface & {
  __typename?: 'DocumentationCategory';
  canDestroy: AuthorizationResult;
  canUpdate: AuthorizationResult;
  /** Color */
  color: ColorEnum;
  /** Time when was created */
  createdAt: Scalars['ISO8601DateTime']['output'];
  /** Default category flag */
  default: Scalars['Boolean']['output'];
  /** Description */
  description: Maybe<Scalars['String']['output']>;
  /** Number of Documentations */
  documentationsCount: Scalars['Int']['output'];
  /** Documentation Category ID */
  id: Scalars['ID']['output'];
  /** Name */
  name: Scalars['String']['output'];
  /** Last update time */
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

/** DocumentationCategoryCollection type */
export type DocumentationCategoryCollection = {
  __typename?: 'DocumentationCategoryCollection';
  /** A collection of paginated DocumentationCategoryCollection */
  collection: Array<DocumentationCategory>;
  /** Pagination Metadata for navigating the Pagination */
  metadata: CollectionMetadata;
};

/** Description from base input object. Please set your description for child object. */
export type DocumentationCategoryCreateInput = {
  /** Create attributes */
  attributes: DocumentationCategoryCreateInputObject;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Documentation Category attributes */
export type DocumentationCategoryCreateInputObject = {
  /** Color */
  color: ColorEnum;
  /** Description */
  description?: InputMaybe<Scalars['String']['input']>;
  /** Name */
  name: Scalars['String']['input'];
};

/** Description from base input object. Please set your description for child object. */
export type DocumentationCategoryDestroyInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** ID */
  id: Scalars['ID']['input'];
};

/** Documentation Category filters */
export type DocumentationCategoryFilterInputObject = {
  /** Whether this is the company's default category */
  default?: InputMaybe<FilterBooleanInputObject>;
  /** Documentation Category ID */
  id?: InputMaybe<FilterIdInputObject>;
  /** Documentation Category name */
  name?: InputMaybe<FilterInputObject>;
};

/** Documentation Category sorts */
export type DocumentationCategorySortInputObject = {
  /** Created at */
  createdAt?: InputMaybe<SortDirectionEnum>;
  /** Number of Documentations in this category */
  documentationsCount?: InputMaybe<SortDirectionEnum>;
  /** Name */
  name?: InputMaybe<SortDirectionEnum>;
};

/** Description from base input object. Please set your description for child object. */
export type DocumentationCategoryUpdateInput = {
  /** Update attributes */
  attributes: DocumentationCategoryUpdateInputObject;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** ID */
  id: Scalars['ID']['input'];
};

/** Documentation Category attributes */
export type DocumentationCategoryUpdateInputObject = {
  /** Color */
  color?: InputMaybe<ColorEnum>;
  /** Description */
  description?: InputMaybe<Scalars['String']['input']>;
  /** Name */
  name?: InputMaybe<Scalars['String']['input']>;
};

/** DocumentationCollection type */
export type DocumentationCollection = {
  __typename?: 'DocumentationCollection';
  /** A collection of paginated DocumentationCollection */
  collection: Array<Documentation>;
  /** Pagination Metadata for navigating the Pagination */
  metadata: CollectionMetadata;
};

/** Description from base input object. Please set your description for child object. */
export type DocumentationCreateInput = {
  /** Create attributes */
  attributes: DocumentationCreateInputObject;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Documentation attributes */
export type DocumentationCreateInputObject = {
  /**
   * Approver ID
   * ATTENTION: Requires plan upgrade for feature: DOCUMENTATION_MANAGEMENT.
   */
  approverId?: InputMaybe<Scalars['ID']['input']>;
  /**
   * Site area links
   * ATTENTION: Requires plan upgrade for feature: DOCUMENTATION_MANAGEMENT.
   */
  areaLinks?: InputMaybe<Array<DocumentationLinkInputObject>>;
  /** Asset links */
  assetLinks?: InputMaybe<Array<DocumentationLinkInputObject>>;
  /** File */
  attachmentAttached: AttachmentCuInputObject;
  /**
   * Category ID
   * ATTENTION: Requires plan upgrade for feature: DOCUMENTATION_MANAGEMENT.
   */
  categoryId?: InputMaybe<Scalars['ID']['input']>;
  /** Code */
  code?: InputMaybe<Scalars['String']['input']>;
  /** Description */
  description?: InputMaybe<Scalars['String']['input']>;
  /** Tags */
  documentationTags?: InputMaybe<Array<LinkingInputObject>>;
  /**
   * Form template links
   * ATTENTION: Requires plan upgrade for feature: DOCUMENTATION_MANAGEMENT.
   */
  formTemplateLinks?: InputMaybe<Array<LinkingInputObject>>;
  /** Name */
  name: Scalars['String']['input'];
  /**
   * Renewal deadline date
   * ATTENTION: Requires plan upgrade for feature: DOCUMENTATION_MANAGEMENT.
   */
  renewalDeadlineDate?: InputMaybe<Scalars['ISO8601Date']['input']>;
  /**
   * Days before deadline to send early reminder
   * ATTENTION: Requires plan upgrade for feature: DOCUMENTATION_MANAGEMENT.
   */
  renewalEarlyReminderDays?: InputMaybe<Scalars['Int']['input']>;
  /**
   * Renewal repetition frequency
   * ATTENTION: Requires plan upgrade for feature: DOCUMENTATION_MANAGEMENT.
   */
  renewalRepetition?: InputMaybe<DocumentationRenewalRepetitionEnum>;
  /**
   * Custom repetition interval in days
   * ATTENTION: Requires plan upgrade for feature: DOCUMENTATION_MANAGEMENT.
   */
  renewalRepetitionCustomDays?: InputMaybe<Scalars['Int']['input']>;
  /**
   * Sector links
   * ATTENTION: Requires plan upgrade for feature: DOCUMENTATION_MANAGEMENT.
   */
  sectorLinks?: InputMaybe<Array<LinkingInputObject>>;
  /**
   * Site links
   * ATTENTION: Requires plan upgrade for feature: DOCUMENTATION_MANAGEMENT.
   */
  siteLinks?: InputMaybe<Array<LinkingInputObject>>;
  /**
   * Task group links
   * ATTENTION: Requires plan upgrade for feature: DOCUMENTATION_MANAGEMENT.
   */
  taskGroupLinks?: InputMaybe<Array<LinkingInputObject>>;
};

/** The AI-detection status of one field on a document */
export type DocumentationFieldDetectionStatus = {
  __typename?: 'DocumentationFieldDetectionStatus';
  /** The document field being detected */
  field: AiDocumentationFieldEnum;
  /** The current detection status of that field */
  status: AiFieldDetectionStatusEnum;
};

/** Documentation filters */
export type DocumentationFilterInputObject = {
  /**
   * Which automatic pass will revisit the document next (RETRYING_SOON, RETRYING_DAILY, PARKED); null when nothing needs indexing, so not_null selects the whole backlog.
   * ATTENTION: Access allowed for full admins.
   * ATTENTION: Requires plan upgrade for feature: DOCUMENTATION_MANAGEMENT, AI_ASSISTANCE.
   */
  aiIndexingRetryLane?: InputMaybe<FilterIntInputObject>;
  /**
   * AI processing state of the current version (INDEXED, SKIPPED, STALE, PENDING, FAILED); null for a document with no version.
   * ATTENTION: Access allowed for full admins.
   * ATTENTION: Requires plan upgrade for feature: DOCUMENTATION_MANAGEMENT, AI_ASSISTANCE.
   */
  aiIndexingStatus?: InputMaybe<FilterIntInputObject>;
  /**
   * Approver full name
   * ATTENTION: Requires plan upgrade for feature: DOCUMENTATION_MANAGEMENT.
   */
  approverFullName?: InputMaybe<FilterInputObject>;
  /**
   * Approver ID
   * ATTENTION: Requires plan upgrade for feature: DOCUMENTATION_MANAGEMENT.
   */
  approverId?: InputMaybe<FilterIdInputObject>;
  /**
   * Documentation Category ID
   * ATTENTION: Requires plan upgrade for feature: DOCUMENTATION_MANAGEMENT.
   */
  categoryId?: InputMaybe<FilterIdInputObject>;
  /**
   * Category name
   * ATTENTION: Requires plan upgrade for feature: DOCUMENTATION_MANAGEMENT.
   */
  categoryName?: InputMaybe<FilterInputObject>;
  /** Code */
  code?: InputMaybe<FilterInputObject>;
  /** Created at */
  createdAt?: InputMaybe<FilterDateInputObject>;
  /** Created by user full name */
  createdByFullName?: InputMaybe<FilterInputObject>;
  /**
   * Task group key
   * ATTENTION: Requires plan upgrade for feature: DOCUMENTATION_MANAGEMENT.
   */
  documentationTaskGroupsGroupKey?: InputMaybe<FilterIdInputObject>;
  /** Documentation ID */
  id?: InputMaybe<FilterIdInputObject>;
  /**
   * Imported at (filter to find imported documents)
   * ATTENTION: Requires plan upgrade for feature: DOCUMENTATION_MANAGEMENT.
   */
  importedAt?: InputMaybe<FilterDateInputObject>;
  /**
   * Site area ID
   * ATTENTION: Requires plan upgrade for feature: DOCUMENTATION_MANAGEMENT.
   */
  linkedAreasId?: InputMaybe<FilterIdInputObject>;
  /**
   * Linked site area name
   * ATTENTION: Requires plan upgrade for feature: DOCUMENTATION_MANAGEMENT.
   */
  linkedAreasName?: InputMaybe<FilterInputObject>;
  /** Asset ID */
  linkedAssetsId?: InputMaybe<FilterIdInputObject>;
  /** Linked asset name */
  linkedAssetsName?: InputMaybe<FilterInputObject>;
  /**
   * Form template ID
   * ATTENTION: Requires plan upgrade for feature: DOCUMENTATION_MANAGEMENT.
   */
  linkedFormTemplatesId?: InputMaybe<FilterIdInputObject>;
  /**
   * Linked form template name
   * ATTENTION: Requires plan upgrade for feature: DOCUMENTATION_MANAGEMENT.
   */
  linkedFormTemplatesName?: InputMaybe<FilterInputObject>;
  /** Current file media type (IMAGE, PDF, VIDEO) */
  mediaType?: InputMaybe<FilterIntInputObject>;
  /** Name */
  name?: InputMaybe<FilterInputObject>;
  /**
   * Renewal deadline date
   * ATTENTION: Requires plan upgrade for feature: DOCUMENTATION_MANAGEMENT.
   */
  renewalDeadlineDate?: InputMaybe<FilterDateInputObject>;
  /**
   * Renewal repetition
   * ATTENTION: Requires plan upgrade for feature: DOCUMENTATION_MANAGEMENT.
   */
  renewalRepetition?: InputMaybe<FilterIntInputObject>;
  /**
   * Sector ID
   * ATTENTION: Requires plan upgrade for feature: DOCUMENTATION_MANAGEMENT.
   */
  sectorsId?: InputMaybe<FilterIdInputObject>;
  /**
   * Sector name
   * ATTENTION: Requires plan upgrade for feature: DOCUMENTATION_MANAGEMENT.
   */
  sectorsName?: InputMaybe<FilterInputObject>;
  /**
   * Site ID
   * ATTENTION: Requires plan upgrade for feature: DOCUMENTATION_MANAGEMENT.
   */
  sitesId?: InputMaybe<FilterIdInputObject>;
  /**
   * Site name
   * ATTENTION: Requires plan upgrade for feature: DOCUMENTATION_MANAGEMENT.
   */
  sitesName?: InputMaybe<FilterInputObject>;
  /** Tag name */
  tagsName?: InputMaybe<FilterInputObject>;
  /**
   * Validation status
   * ATTENTION: Requires plan upgrade for feature: DOCUMENTATION_MANAGEMENT.
   */
  validationStatus?: InputMaybe<FilterIntInputObject>;
};

/** Documentation History data. Each record contains exactly one key indicating the change type. Format: [old_value, new_value] for changes, [value] for events. */
export type DocumentationHistoryData = {
  __typename?: 'DocumentationHistoryData';
  /** Approver changed. Format: [old_id | null, new_id | null]. null→id = 'approver assigned', id→null = 'approver removed', id→id = 'approver changed' */
  approverId: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Renewal deadline changed. Format: [old_date | null, new_date | null]. null→date = 'renewal reminder enabled', date→null = 'renewal reminder disabled', date→date = 'renewal date updated' */
  renewalDeadlineDate: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Renewal overdue (system event). Format: [deadline_date]. Label: 'update overdue'. Actor: Datizy system */
  renewalOverdue: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Renewal skipped by user. Format: [next_deadline_date]. Label: 'renewal skipped' */
  renewalSkipped: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Validation status changed. Format: [old_status, new_status]. Label: 'status changed' */
  validationStatus: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Version updated. Format: [old_number | null, new_number]. Label: 'version updated' */
  versionNumber: Maybe<Array<Maybe<Scalars['Int']['output']>>>;
  /** User confirmed reading a version. Format: [version_number]. Label: 'marked as read'. Returned by the 'reads' scope, not 'activity' */
  versionRead: Maybe<Array<Maybe<Scalars['Int']['output']>>>;
  /** User withdrew a read confirmation. Format: [version_number]. Label: 'marked as unread'. Returned by the 'reads' scope, not 'activity' */
  versionUnread: Maybe<Array<Maybe<Scalars['Int']['output']>>>;
};

/** Documentation Import entity */
export type DocumentationImport = TimestampInterface & {
  __typename?: 'DocumentationImport';
  /** Uploaded ZIP archive (when kind is ARCHIVE) */
  archiveAttachmentAttached: Maybe<Attachment>;
  /** Background job tracking this import (status, progress, result) */
  backgroundJob: Maybe<BackgroundJob>;
  canDestroy: AuthorizationResult;
  /** Time when was created */
  createdAt: Scalars['ISO8601DateTime']['output'];
  /** Per-file error details */
  failureDetails: Maybe<Scalars['CamelizedJson']['output']>;
  /** Uploaded files (when kind is FILES) */
  fileAttachmentsAttached: Maybe<Array<Attachment>>;
  /** Top-level error (e.g., zip extraction or FTP connection) */
  fileException: Maybe<Array<Scalars['String']['output']>>;
  /** FTP connection details (excluding password) */
  ftpConfig: Maybe<DocumentationImportFtpConfig>;
  /** Documentation Import ID */
  id: Scalars['ID']['output'];
  /** Timestamp shared by all documents created in this import */
  importedAt: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** Files successfully imported so far */
  importedFiles: Maybe<Scalars['Int']['output']>;
  /** Source kind (FILES, ARCHIVE, FTP) */
  kind: DocumentationImportKindEnum;
  /** Current status */
  status: DocumentationImportStatusEnum;
  /** Total files to import (after unsupported are filtered out) */
  totalFiles: Maybe<Scalars['Int']['output']>;
  /** Last update time */
  updatedAt: Scalars['ISO8601DateTime']['output'];
  /**
   * Created by User
   * NOTE: if you only need an Object ID, please use the userId field to reduce the load on the database.
   */
  user: Maybe<User>;
  /** Created by User ID */
  userId: Scalars['ID']['output'];
};

/** DocumentationImportCollection type */
export type DocumentationImportCollection = {
  __typename?: 'DocumentationImportCollection';
  /** A collection of paginated DocumentationImportCollection */
  collection: Array<DocumentationImport>;
  /** Pagination Metadata for navigating the Pagination */
  metadata: CollectionMetadata;
};

/** Description from base input object. Please set your description for child object. */
export type DocumentationImportCreateInput = {
  /** Create attributes */
  attributes: DocumentationImportCreateInputObject;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Documentation Import attributes */
export type DocumentationImportCreateInputObject = {
  /** Approver ID applied to all imported documents */
  approverId?: InputMaybe<Scalars['ID']['input']>;
  /** Area links applied to all imported documents */
  areaLinks?: InputMaybe<Array<DocumentationLinkInputObject>>;
  /** Asset links applied to all imported documents */
  assetLinks?: InputMaybe<Array<DocumentationLinkInputObject>>;
  /** Category ID applied to all imported documents */
  categoryId?: InputMaybe<Scalars['ID']['input']>;
  /**
   * Which fields AI should detect on each imported document, and the optional hint for the code field. Omit it to import without AI detection
   * ATTENTION: Requires plan upgrade for feature: DOCUMENTATION_MANAGEMENT, AI_ASSISTANCE.
   */
  detectFields?: InputMaybe<DocumentationImportDetectFieldsInputObject>;
  /** Form template links applied to all imported documents */
  formTemplateLinks?: InputMaybe<Array<LinkingInputObject>>;
  /** Source kind (FILES, ARCHIVE, FTP) */
  kind: DocumentationImportKindEnum;
  /** Renewal deadline date applied to all imported documents */
  renewalDeadlineDate?: InputMaybe<Scalars['ISO8601Date']['input']>;
  /** Days before deadline to send early reminder */
  renewalEarlyReminderDays?: InputMaybe<Scalars['Int']['input']>;
  /** Renewal repetition frequency applied to all imported documents */
  renewalRepetition?: InputMaybe<DocumentationRenewalRepetitionEnum>;
  /** Custom repetition interval in days */
  renewalRepetitionCustomDays?: InputMaybe<Scalars['Int']['input']>;
  /** Sector links applied to all imported documents */
  sectorLinks?: InputMaybe<Array<LinkingInputObject>>;
  /** Site links applied to all imported documents */
  siteLinks?: InputMaybe<Array<LinkingInputObject>>;
  /** Source-specific input (one of file_attachments_attached, archive_attachment_attached, ftp_config) */
  source: DocumentationImportSourceInputObject;
  /** Task group links applied to all imported documents */
  taskGroupLinks?: InputMaybe<Array<LinkingInputObject>>;
};

/** Description from base input object. Please set your description for child object. */
export type DocumentationImportDestroyInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Documentation Import ID */
  id: Scalars['ID']['input'];
};

/** AI field-detection opt-in for a documentation import */
export type DocumentationImportDetectFieldsInputObject = {
  /** When true, AI detects the category of each imported document from its content, replacing only the default (Uncategorized) — a category the importer explicitly chose is kept */
  category?: InputMaybe<Scalars['Boolean']['input']>;
  /** When true, AI detects the code(s) of each imported document — a single code fills the code field, several are stored as suggestions */
  code?: InputMaybe<Scalars['Boolean']['input']>;
  /** Optional user hint guiding how the AI should detect the code (applies only when code is true) */
  codePrompt?: InputMaybe<Scalars['String']['input']>;
  /** When true, AI detects and fills the description of each imported document */
  description?: InputMaybe<Scalars['Boolean']['input']>;
  /** When true, AI detects and fills the name of each imported document from its content (a readable file with no clear name is left blank for the user to set) */
  name?: InputMaybe<Scalars['Boolean']['input']>;
  /** When true, AI detects and links tags on each imported document */
  tags?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Documentation Import filters */
export type DocumentationImportFilterInputObject = {
  /** Created at */
  createdAt?: InputMaybe<FilterDateInputObject>;
  /** Documentation Import ID */
  id?: InputMaybe<FilterIdInputObject>;
  /** Source kind */
  kind?: InputMaybe<FilterIntInputObject>;
  /** Current status */
  status?: InputMaybe<FilterIntInputObject>;
};

/** FTP connection details exposed on a Documentation Import (password is never stored or returned) */
export type DocumentationImportFtpConfig = {
  __typename?: 'DocumentationImportFtpConfig';
  /** Full FTP/SFTP/FTPS URL including host, port and path */
  url: Scalars['String']['output'];
  /** Username used for authentication, if any */
  username: Maybe<Scalars['String']['output']>;
};

/** Documentation Import FTP/SFTP connection details */
export type DocumentationImportFtpConfigInputObject = {
  /** Optional password (never persisted) */
  password?: InputMaybe<Scalars['String']['input']>;
  /** Server URL with scheme (ftp://, ftps://, sftp://) */
  url: Scalars['String']['input'];
  /** Optional username */
  username?: InputMaybe<Scalars['String']['input']>;
};

/** Description from base input object. Please set your description for child object. */
export type DocumentationImportFtpPreviewInput = {
  /** FTP connection attributes */
  attributes: DocumentationImportFtpConfigInputObject;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Result of an FTP preview call */
export type DocumentationImportFtpPreviewResult = {
  __typename?: 'DocumentationImportFtpPreviewResult';
  /** First few supported filenames as preview */
  sampleFilenames: Array<Scalars['String']['output']>;
  /** Files that can be imported (matching supported extensions) */
  supportedFilesCount: Scalars['Int']['output'];
  /** Total files visible in the directory */
  totalFilesCount: Scalars['Int']['output'];
  /** Files that will be skipped */
  unsupportedFilesCount: Scalars['Int']['output'];
};

/** Documentation Import source kinds */
export enum DocumentationImportKindEnum {
  /** Single ZIP archive containing multiple files */
  Archive = 'ARCHIVE',
  /** Multiple individual files uploaded directly */
  Files = 'FILES',
  /** Remote FTP/SFTP server */
  Ftp = 'FTP'
}

/** Documentation Import sorts */
export type DocumentationImportSortInputObject = {
  /** Created at */
  createdAt?: InputMaybe<SortDirectionEnum>;
  /** Source kind */
  kind?: InputMaybe<SortDirectionEnum>;
  /** Current status */
  status?: InputMaybe<SortDirectionEnum>;
};

/** Documentation Import source (exactly one must be present) */
export type DocumentationImportSourceInputObject = {
  /** Single ZIP archive (when kind is ARCHIVE) */
  archiveAttachmentAttached?: InputMaybe<AttachmentCuInputObject>;
  /** Individual files (when kind is FILES) */
  fileAttachmentsAttached?: InputMaybe<Array<AttachmentCuInputObject>>;
  /** Remote FTP/SFTP server connection (when kind is FTP) */
  ftpConfig?: InputMaybe<DocumentationImportFtpConfigInputObject>;
};

/** Documentation Import statuses */
export enum DocumentationImportStatusEnum {
  /** Import completed successfully */
  Complete = 'COMPLETE',
  /** Import failed with errors */
  Failed = 'FAILED',
  /** Import was interrupted (timeout or worker crash) */
  Interrupted = 'INTERRUPTED',
  /** Queued, waiting for worker to start */
  Queued = 'QUEUED',
  /** Still in progress: the worker is retrying after a transient failure */
  Retrying = 'RETRYING',
  /** Import was cancelled by the user */
  Stopped = 'STOPPED',
  /** Worker is processing the import */
  Working = 'WORKING'
}

/** Join row between a Documentation and one of its linkables (Asset, SiteArea, FormTemplate) */
export type DocumentationLink = TimestampInterface & {
  __typename?: 'DocumentationLink';
  /** Time when was created */
  createdAt: Scalars['ISO8601DateTime']['output'];
  /** Linked Documentation ID */
  documentationId: Scalars['ID']['output'];
  /** Documentation Link ID */
  id: Scalars['ID']['output'];
  /** Linkable ID */
  linkableId: Scalars['ID']['output'];
  /** Linkable type */
  linkableType: DocumentationLinkLinkableTypeEnum;
  /** Last update time */
  updatedAt: Scalars['ISO8601DateTime']['output'];
  /** Whether the linked documentation is exposed when scanning the linkable's QR code */
  visibleViaQr: Scalars['Boolean']['output'];
};

/** DocumentationLinkCollection type */
export type DocumentationLinkCollection = {
  __typename?: 'DocumentationLinkCollection';
  /** A collection of paginated DocumentationLinkCollection */
  collection: Array<DocumentationLink>;
  /** Pagination Metadata for navigating the Pagination */
  metadata: CollectionMetadata;
};

/** Documentation link filters */
export type DocumentationLinkFilterInputObject = {
  /** Documentation ID */
  documentationId?: InputMaybe<FilterIdInputObject>;
  /** Linkable ID */
  linkableId?: InputMaybe<FilterIdInputObject>;
  /** Linkable type */
  linkableType?: InputMaybe<FilterInputObject>;
};

/** Anchor for the documentation links query — exactly one of documentation_id or linkable */
export type DocumentationLinkFindByInputObject = {
  /** Anchor by documentation; returns links of that documentation */
  documentationId?: InputMaybe<Scalars['ID']['input']>;
  /** Anchor by linkable; returns links to that asset, site area, or form template */
  linkable?: InputMaybe<DocumentationLinkLinkableInputObject>;
};

/** Documentation link attributes */
export type DocumentationLinkInputObject = {
  /** Linked entity ID (asset or area) */
  id: Scalars['ID']['input'];
  /** Unlink flag */
  unlink?: InputMaybe<Scalars['Boolean']['input']>;
  /**
   * Whether the document is visible when scanning QR code
   * ATTENTION: Requires plan upgrade for feature: DOCUMENTATION_MANAGEMENT.
   */
  visibleViaQr?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Polymorphic linkable reference */
export type DocumentationLinkLinkableInputObject = {
  /** Linkable ID */
  id: Scalars['ID']['input'];
  /** Linkable type */
  type: DocumentationLinkLinkableTypeEnum;
};

/** Available types a documentation can be linked to */
export enum DocumentationLinkLinkableTypeEnum {
  /** Asset (equipment) */
  Asset = 'Asset',
  /** Form template */
  FormTemplate = 'FormTemplate',
  /** Site area */
  SiteArea = 'SiteArea'
}

/** Documentation link sorts */
export type DocumentationLinkSortInputObject = {
  /** Created at */
  createdAt?: InputMaybe<SortDirectionEnum>;
  /** Updated at */
  updatedAt?: InputMaybe<SortDirectionEnum>;
  /** Visible via QR */
  visibleViaQr?: InputMaybe<SortDirectionEnum>;
};

/** Available renewal repetition frequencies */
export enum DocumentationRenewalRepetitionEnum {
  /** Custom interval in days */
  Custom = 'CUSTOM',
  /** Half-yearly */
  HalfYearly = 'HALF_YEARLY',
  /** Monthly */
  Monthly = 'MONTHLY',
  /** Quarterly */
  Quarterly = 'QUARTERLY',
  /** Yearly */
  Yearly = 'YEARLY'
}

/** Documentation scope */
export type DocumentationScopeInputObject = {
  /** Scope name */
  name: DocumentationScopeNameEnum;
};

/** Available documentation scope names */
export enum DocumentationScopeNameEnum {
  /**
   * Favorited documentations
   * ATTENTION: Requires plan upgrade for feature: DOCUMENTATION_MANAGEMENT.
   */
  Favorited = 'FAVORITED',
  /**
   * Documentations linked to any task, form template, form question, or asset the current user can access
   * ATTENTION: Requires plan upgrade for feature: DOCUMENTATION_MANAGEMENT.
   */
  LinkedToAccessible = 'LINKED_TO_ACCESSIBLE',
  /**
   * Accessible documentations (see linked_to_accessible) that the current user has favorited
   * ATTENTION: Requires plan upgrade for feature: DOCUMENTATION_MANAGEMENT.
   */
  LinkedToAccessibleFavorited = 'LINKED_TO_ACCESSIBLE_FAVORITED',
  /**
   * Accessible documentations (see linked_to_accessible) that the current user has not read at the latest required version
   * ATTENTION: Requires plan upgrade for feature: DOCUMENTATION_MANAGEMENT.
   */
  LinkedToAccessibleUnread = 'LINKED_TO_ACCESSIBLE_UNREAD',
  /**
   * Documentations linked to site areas
   * ATTENTION: Requires plan upgrade for feature: DOCUMENTATION_MANAGEMENT.
   */
  LinkedToAreas = 'LINKED_TO_AREAS',
  /**
   * Documentations linked to assets (equipment)
   * ATTENTION: Requires plan upgrade for feature: DOCUMENTATION_MANAGEMENT.
   */
  LinkedToAssets = 'LINKED_TO_ASSETS',
  /**
   * Documentations linked to form templates
   * ATTENTION: Requires plan upgrade for feature: DOCUMENTATION_MANAGEMENT.
   */
  LinkedToForms = 'LINKED_TO_FORMS',
  /**
   * Documentations linked to tasks
   * ATTENTION: Requires plan upgrade for feature: DOCUMENTATION_MANAGEMENT.
   */
  LinkedToTasks = 'LINKED_TO_TASKS',
  /**
   * Unread documentations for the current user
   * ATTENTION: Requires plan upgrade for feature: DOCUMENTATION_MANAGEMENT.
   */
  Unread = 'UNREAD'
}

/** Description from base input object. Please set your description for child object. */
export type DocumentationSkipRenewalInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Documentation ID */
  id: Scalars['ID']['input'];
};

/** Documentation sorts */
export type DocumentationSortInputObject = {
  /**
   * Category name
   * ATTENTION: Requires plan upgrade for feature: DOCUMENTATION_MANAGEMENT.
   */
  categoryName?: InputMaybe<SortDirectionEnum>;
  /** Code */
  code?: InputMaybe<SortDirectionEnum>;
  /** Created at */
  createdAt?: InputMaybe<SortDirectionEnum>;
  /** Created by user full name */
  createdByFullName?: InputMaybe<SortDirectionEnum>;
  /**
   * Imported at
   * ATTENTION: Requires plan upgrade for feature: DOCUMENTATION_MANAGEMENT.
   */
  importedAt?: InputMaybe<SortDirectionEnum>;
  /** Name */
  name?: InputMaybe<SortDirectionEnum>;
  /**
   * Renewal deadline date
   * ATTENTION: Requires plan upgrade for feature: DOCUMENTATION_MANAGEMENT.
   */
  renewalDeadlineDate?: InputMaybe<SortDirectionEnum>;
  /** Updated at */
  updatedAt?: InputMaybe<SortDirectionEnum>;
  /**
   * Validation status
   * ATTENTION: Requires plan upgrade for feature: DOCUMENTATION_MANAGEMENT.
   */
  validationStatus?: InputMaybe<SortDirectionEnum>;
};

/** Description from base input object. Please set your description for child object. */
export type DocumentationUpdateInput = {
  /** Update attributes */
  attributes: DocumentationUpdateInputObject;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Documentation ID */
  id: Scalars['ID']['input'];
};

/** Documentation attributes */
export type DocumentationUpdateInputObject = {
  /**
   * Approver ID
   * ATTENTION: Requires plan upgrade for feature: DOCUMENTATION_MANAGEMENT.
   */
  approverId?: InputMaybe<Scalars['ID']['input']>;
  /**
   * Site area links
   * ATTENTION: Requires plan upgrade for feature: DOCUMENTATION_MANAGEMENT.
   */
  areaLinks?: InputMaybe<Array<DocumentationLinkInputObject>>;
  /** Asset links */
  assetLinks?: InputMaybe<Array<DocumentationLinkInputObject>>;
  /**
   * Category ID
   * ATTENTION: Requires plan upgrade for feature: DOCUMENTATION_MANAGEMENT.
   */
  categoryId?: InputMaybe<Scalars['ID']['input']>;
  /** Code */
  code?: InputMaybe<Scalars['String']['input']>;
  /** Description */
  description?: InputMaybe<Scalars['String']['input']>;
  /** Tags */
  documentationTags?: InputMaybe<Array<LinkingInputObject>>;
  /**
   * Form template links
   * ATTENTION: Requires plan upgrade for feature: DOCUMENTATION_MANAGEMENT.
   */
  formTemplateLinks?: InputMaybe<Array<LinkingInputObject>>;
  /** Name */
  name?: InputMaybe<Scalars['String']['input']>;
  /**
   * Renewal deadline date
   * ATTENTION: Requires plan upgrade for feature: DOCUMENTATION_MANAGEMENT.
   */
  renewalDeadlineDate?: InputMaybe<Scalars['ISO8601Date']['input']>;
  /**
   * Days before deadline to send early reminder
   * ATTENTION: Requires plan upgrade for feature: DOCUMENTATION_MANAGEMENT.
   */
  renewalEarlyReminderDays?: InputMaybe<Scalars['Int']['input']>;
  /**
   * Renewal repetition frequency
   * ATTENTION: Requires plan upgrade for feature: DOCUMENTATION_MANAGEMENT.
   */
  renewalRepetition?: InputMaybe<DocumentationRenewalRepetitionEnum>;
  /**
   * Custom repetition interval in days
   * ATTENTION: Requires plan upgrade for feature: DOCUMENTATION_MANAGEMENT.
   */
  renewalRepetitionCustomDays?: InputMaybe<Scalars['Int']['input']>;
  /**
   * Sector links
   * ATTENTION: Requires plan upgrade for feature: DOCUMENTATION_MANAGEMENT.
   */
  sectorLinks?: InputMaybe<Array<LinkingInputObject>>;
  /**
   * Site links
   * ATTENTION: Requires plan upgrade for feature: DOCUMENTATION_MANAGEMENT.
   */
  siteLinks?: InputMaybe<Array<LinkingInputObject>>;
  /**
   * Task group links
   * ATTENTION: Requires plan upgrade for feature: DOCUMENTATION_MANAGEMENT.
   */
  taskGroupLinks?: InputMaybe<Array<LinkingInputObject>>;
};

/** Documentation attributes */
export type DocumentationUpdateValidationStatusInputObject = {
  /** Validation status */
  validationStatus: DocumentationValidationStatusEnum;
};

/** Available documentation validation statuses */
export enum DocumentationValidationStatusEnum {
  OnValidation = 'ON_VALIDATION',
  Rejected = 'REJECTED',
  Validated = 'VALIDATED'
}

/** Documentation Version entity */
export type DocumentationVersion = TimestampInterface & {
  __typename?: 'DocumentationVersion';
  /**
   * Whether this version's file can be attached to an AI chat, or the reason it cannot
   * ATTENTION: Requires plan upgrade for feature: DOCUMENTATION_MANAGEMENT, AI_ASSISTANCE.
   */
  aiAttachability: Maybe<AiAttachabilityStatusEnum>;
  /**
   * Machine-readable reason this version's processing failed; null while nothing has failed.
   * ATTENTION: Access allowed for full admins.
   * ATTENTION: Requires plan upgrade for feature: DOCUMENTATION_MANAGEMENT, AI_ASSISTANCE.
   */
  aiIndexingError: Maybe<Scalars['String']['output']>;
  /**
   * Where this version stands in AI processing. Never SKIPPED — whether processing yielded searchable content is a document-level answer (Documentation.aiIndexingStatus).
   * ATTENTION: Access allowed for full admins.
   * ATTENTION: Requires plan upgrade for feature: DOCUMENTATION_MANAGEMENT, AI_ASSISTANCE.
   */
  aiIndexingStatus: AiIndexingStatusEnum;
  /** File */
  attachmentAttached: Maybe<Attachment>;
  /** Time when was created */
  createdAt: Scalars['ISO8601DateTime']['output'];
  /** User entity */
  createdBy: Maybe<User>;
  /** Documentation Version ID */
  id: Scalars['ID']['output'];
  /** Version notes */
  notes: Maybe<Scalars['String']['output']>;
  /** Last update time */
  updatedAt: Scalars['ISO8601DateTime']['output'];
  /** Version number */
  versionNumber: Scalars['Int']['output'];
};

/** DocumentationVersionCollection type */
export type DocumentationVersionCollection = {
  __typename?: 'DocumentationVersionCollection';
  /** A collection of paginated DocumentationVersionCollection */
  collection: Array<DocumentationVersion>;
  /** Pagination Metadata for navigating the Pagination */
  metadata: CollectionMetadata;
};

/** Description from base input object. Please set your description for child object. */
export type DocumentationVersionCreateInput = {
  /** Create attributes */
  attributes: DocumentationVersionCreateInputObject;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Documentation ID */
  documentationId: Scalars['ID']['input'];
};

/** Documentation Version attributes */
export type DocumentationVersionCreateInputObject = {
  /** File */
  attachmentAttached: AttachmentCuInputObject;
  /** Version notes */
  notes?: InputMaybe<Scalars['String']['input']>;
  /**
   * Whether users must reread this version
   * ATTENTION: Requires plan upgrade for feature: DOCUMENTATION_MANAGEMENT.
   */
  requiredToReread?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Description from base input object. Please set your description for child object. */
export type DocumentationVersionMarkAsReadInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Documentation Version ID */
  id: Scalars['ID']['input'];
};

/** Description from base input object. Please set your description for child object. */
export type DocumentationVersionMarkAsUnreadInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Documentation Version ID */
  id: Scalars['ID']['input'];
};

/** Documentation version sorts */
export type DocumentationVersionSortInputObject = {
  /** Created at */
  createdAt?: InputMaybe<SortDirectionEnum>;
  /** Version number */
  versionNumber?: InputMaybe<SortDirectionEnum>;
};

/** One viewing session of a documentation version — when it was opened and how long it was open. Engagement tracking only; it does not mean the user has read the document */
export type DocumentationVersionView = TimestampInterface & {
  __typename?: 'DocumentationVersionView';
  /** Time when was created */
  createdAt: Scalars['ISO8601DateTime']['output'];
  /** Documentation ID */
  documentationId: Scalars['ID']['output'];
  /** Documentation Version ID */
  documentationVersionId: Maybe<Scalars['ID']['output']>;
  /** Document View ID */
  id: Scalars['ID']['output'];
  /** Time spent reading in seconds */
  readingDurationSeconds: Maybe<Scalars['Int']['output']>;
  /** Last update time */
  updatedAt: Scalars['ISO8601DateTime']['output'];
  /**
   * Viewer User entity. %{prefer_id}
   * NOTE: if you only need an Object ID, please use the userId field to reduce the load on the database.
   */
  user: Maybe<User>;
  /** Viewer User ID */
  userId: Maybe<Scalars['ID']['output']>;
  /** Date and time the document was opened */
  viewedAt: Maybe<Scalars['ISO8601DateTime']['output']>;
};

/** DocumentationVersionViewCollection type */
export type DocumentationVersionViewCollection = {
  __typename?: 'DocumentationVersionViewCollection';
  /** A collection of paginated DocumentationVersionViewCollection */
  collection: Array<DocumentationVersionView>;
  /** Pagination Metadata for navigating the Pagination */
  metadata: CollectionMetadata;
};

/** Description from base input object. Please set your description for child object. */
export type DocumentationVersionViewCreateInput = {
  /** View attributes */
  attributes: DocumentationVersionViewCreateInputObject;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Documentation version view attributes */
export type DocumentationVersionViewCreateInputObject = {
  /** Documentation Version ID */
  documentationVersionId: Scalars['ID']['input'];
  /** Time spent reading in seconds */
  readingDurationSeconds: Scalars['Int']['input'];
  /** Date and time the document was opened */
  viewedAt: Scalars['ISO8601DateTime']['input'];
};

/** Documentation Version View filters */
export type DocumentationVersionViewFilterInputObject = {
  /** Documentation ID */
  documentationId?: InputMaybe<FilterIdInputObject>;
  /** Documentation Version ID */
  documentationVersionId?: InputMaybe<FilterIdInputObject>;
  /** Viewer User ID */
  userId?: InputMaybe<FilterIdInputObject>;
};

/** Description from base input object. Please set your description for child object. */
export type DocumentationVersionViewIncrementInput = {
  /** Increment attributes */
  attributes: DocumentationVersionViewIncrementInputObject;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Documentation Version View ID */
  id: Scalars['ID']['input'];
};

/** Documentation version view attributes */
export type DocumentationVersionViewIncrementInputObject = {
  /** Time spent reading in seconds */
  readingDurationSeconds: Scalars['Int']['input'];
};

/** Documentation Version View sorts */
export type DocumentationVersionViewSortInputObject = {
  /** Created at */
  createdAt?: InputMaybe<SortDirectionEnum>;
  /** View timestamp */
  viewedAt?: InputMaybe<SortDirectionEnum>;
};

export type FailureReasons = {
  __typename?: 'FailureReasons';
  /** JSON-encoded map of reasons */
  details: Scalars['String']['output'];
  /** Human-readable errors */
  fullMessages: Array<Scalars['String']['output']>;
};

/** Fake DNS record entity (non-production only) */
export type FakeDnsRecord = TimestampInterface & {
  __typename?: 'FakeDnsRecord';
  /** Time when was created */
  createdAt: Scalars['ISO8601DateTime']['output'];
  /** Domain name */
  domain: Scalars['String']['output'];
  /** Fake DNS record ID */
  id: Scalars['ID']['output'];
  /** DNS record type */
  recordType: FakeDnsRecordTypeEnum;
  /** Last update time */
  updatedAt: Scalars['ISO8601DateTime']['output'];
  /** Record value */
  value: Maybe<Scalars['String']['output']>;
};

/** FakeDnsRecordCollection type */
export type FakeDnsRecordCollection = {
  __typename?: 'FakeDnsRecordCollection';
  /** A collection of paginated FakeDnsRecordCollection */
  collection: Array<FakeDnsRecord>;
  /** Pagination Metadata for navigating the Pagination */
  metadata: CollectionMetadata;
};

/** Description from base input object. Please set your description for child object. */
export type FakeDnsRecordCreateInput = {
  /** Create attributes */
  attributes: FakeDnsRecordCreateInputObject;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Fake DNS record attributes (non-production only) */
export type FakeDnsRecordCreateInputObject = {
  /** Domain name */
  domain: Scalars['String']['input'];
  /** DNS record type (txt, a, cname, mx) */
  recordType?: InputMaybe<FakeDnsRecordTypeEnum>;
  /** Record value */
  value?: InputMaybe<Scalars['String']['input']>;
};

/** Description from base input object. Please set your description for child object. */
export type FakeDnsRecordDestroyInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Fake DNS record ID */
  id: Scalars['ID']['input'];
};

/** Available fake DNS record types (non-production only) */
export enum FakeDnsRecordTypeEnum {
  /** A record */
  A = 'A',
  /** CNAME record */
  Cname = 'CNAME',
  /** MX record */
  Mx = 'MX',
  /** TXT record */
  Txt = 'TXT'
}

/** Description from base input object. Please set your description for child object. */
export type FakeDnsRecordUpdateInput = {
  /** Update attributes */
  attributes: FakeDnsRecordUpdateInputObject;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Fake DNS record ID */
  id: Scalars['ID']['input'];
};

/** Fake DNS record attributes (non-production only) */
export type FakeDnsRecordUpdateInputObject = {
  /** Domain name */
  domain?: InputMaybe<Scalars['String']['input']>;
  /** DNS record type (txt, a, cname, mx) */
  recordType?: InputMaybe<FakeDnsRecordTypeEnum>;
  /** Record value */
  value?: InputMaybe<Scalars['String']['input']>;
};

/** Frontend Filter Preset entity */
export type FeFilterPreset = TimestampInterface & {
  __typename?: 'FeFilterPreset';
  /** Time when was created */
  createdAt: Scalars['ISO8601DateTime']['output'];
  /** Untyped data in any format that frontend will understand. */
  data: Scalars['JSON']['output'];
  /** Entities attributes array. Used for storing entity IDs. Will be automatically deleted from preset when entity is deleted. */
  entities: FeFilterPresetEntities;
  /** Frontend Filter Preset ID */
  id: Scalars['ID']['output'];
  /** Kind */
  kind: Scalars['String']['output'];
  /** Name */
  name: Scalars['String']['output'];
  /** Last update time */
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

/** FeFilterPresetCollection type */
export type FeFilterPresetCollection = {
  __typename?: 'FeFilterPresetCollection';
  /** A collection of paginated FeFilterPresetCollection */
  collection: Array<FeFilterPreset>;
  /** Pagination Metadata for navigating the Pagination */
  metadata: CollectionMetadata;
};

/** Description from base input object. Please set your description for child object. */
export type FeFilterPresetCreateInput = {
  /** Create attributes */
  attributes: FeFilterPresetCreateInputObject;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Frontend Filter Preset attributes */
export type FeFilterPresetCreateInputObject = {
  /** Untyped data in any format that frontend will understand. */
  data?: InputMaybe<Scalars['JSON']['input']>;
  /** Entities attributes array. Used for storing entity IDs. Will be automatically deleted from preset when entity is deleted. */
  entities?: InputMaybe<FeFilterPresetEntitiesInputObject>;
  /** Kind */
  kind: Scalars['String']['input'];
  /** Name */
  name: Scalars['String']['input'];
};

/** Description from base input object. Please set your description for child object. */
export type FeFilterPresetDestroyInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Frontend Filter Preset ID */
  id: Scalars['ID']['input'];
};

/** Frontend Filter Preset Entities entity */
export type FeFilterPresetEntities = {
  __typename?: 'FeFilterPresetEntities';
  /** Form Categories collection */
  formCategories: Maybe<Array<FeFilterPresetEntity>>;
  /** Form Templates collection */
  formTemplates: Maybe<Array<FeFilterPresetEntity>>;
  /** Sectors collection */
  sectors: Maybe<Array<FeFilterPresetEntity>>;
  /** Sites collection */
  sites: Maybe<Array<FeFilterPresetEntity>>;
};

/** Entities attributes array. Used for storing entity IDs. Will be automatically deleted from preset when entity is deleted. */
export type FeFilterPresetEntitiesInputObject = {
  /** Form Categories attributes array */
  formCategories?: InputMaybe<Array<FeFilterPresetEntityInputObject>>;
  /** Form Templates attributes array */
  formTemplates?: InputMaybe<Array<FeFilterPresetEntityInputObject>>;
  /** Sectors attributes array */
  sectors?: InputMaybe<Array<FeFilterPresetEntityInputObject>>;
  /** Sites attributes array */
  sites?: InputMaybe<Array<FeFilterPresetEntityInputObject>>;
};

/** Frontend Filter Preset Entity entity */
export type FeFilterPresetEntity = {
  __typename?: 'FeFilterPresetEntity';
  /** Entity ID */
  id: Scalars['ID']['output'];
};

/** Entity attributes */
export type FeFilterPresetEntityInputObject = {
  /** Entity ID */
  id: Scalars['ID']['input'];
};

/** Frontend Filter Preset filters */
export type FeFilterPresetFilterInputObject = {
  /** Frontend Filter Preset ID */
  id?: InputMaybe<FilterIdInputObject>;
  /** Kind */
  kind?: InputMaybe<FilterInputObject>;
  /** Name */
  name?: InputMaybe<FilterInputObject>;
};

/** Frontend Filter Preset sorts */
export type FeFilterPresetSortInputObject = {
  /** Created at */
  createdAt?: InputMaybe<SortDirectionEnum>;
  /** Name */
  name?: InputMaybe<SortDirectionEnum>;
};

/** Description from base input object. Please set your description for child object. */
export type FeFilterPresetUpdateInput = {
  /** Update attributes */
  attributes: FeFilterPresetUpdateInputObject;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Frontend Filter Preset ID */
  id: Scalars['ID']['input'];
};

/** Frontend Filter Preset attributes */
export type FeFilterPresetUpdateInputObject = {
  /** Untyped data in any format that frontend will understand. */
  data?: InputMaybe<Scalars['JSON']['input']>;
  /** Entities attributes array. Used for storing entity IDs. Will be automatically deleted from preset when entity is deleted. */
  entities?: InputMaybe<FeFilterPresetEntitiesInputObject>;
  /** Name */
  name?: InputMaybe<Scalars['String']['input']>;
};

/**
 * Filters
 * Examples:
 *   ```
 *   {
 *       "siteId": {
 *       "grouping": "or",
 *       "predicate": {
 *           "in": [
 *             "bab53e5d-be4b-4f5d-8429-ff5d3521d08e",
 *             "14fd0a18-6a3c-4523-aa68-a661641360f6"
 *           ]
 *       },
 *       "filterGroup": "filter1"
 *     }
 *   },
 *   {
 *       "siteAreaId": {
 *           "grouping": "or",
 *           "predicate": {
 *               "in": [
 *                   "57c6364d-0f55-43b0-8e7c-776011f8e2a9",
 *                   "e226b0e1-6ffd-4918-9aad-bbf217258ea7"
 *               ]
 *           },
 *           "filterGroup": "filter1"
 *       }
 *   },
 *   {
 *       "name": {
 *           "grouping": "or",
 *           "predicate": { "cont": "cleaning" },
 *           "filterGroup": "filter2"
 *       }
 *   },
 *   {
 *       "priority": {
 *           "grouping": "or",
 *           "predicate": { "in": ["HIGH", "MEDIUM", "LOW"] },
 *           "filterGroup": "filter2"
 *       }
 *   }
 *   ```
 *
 */
export type FilterBooleanInputObject = {
  /** Allows to group many filters by AND. For example, if you want to filter by (name or email) AND by (site or area), you can group them together. Specify the same group for the (name and email) and then specify an another group for (site and area). The filters in the same group will be combined by AND/OR (depends on grouping attribute) and the groups will be combined by AND. The filter_group is a string and it can be any string. It is used to group filters together. You can see the example in the description, where the filter_group is 'filter1' and 'filter2'. In the example, the result will be in the following format: (siteId OR siteAreaId) AND (name OR priority) */
  filterGroup?: InputMaybe<Scalars['String']['input']>;
  /** Determines if result must be matched with all filters ('AND') or any of them ('OR') */
  grouping?: InputMaybe<FilterGroupingEnum>;
  /** Predicate */
  predicate: FilterBooleanPredicateInputObject;
};

/** Filters */
export type FilterBooleanPredicateInputObject = {
  /** false */
  false?: InputMaybe<Scalars['Boolean']['input']>;
  /** Is not null */
  notNull?: InputMaybe<Scalars['Boolean']['input']>;
  /** Is null */
  null?: InputMaybe<Scalars['Boolean']['input']>;
  /** true */
  true?: InputMaybe<Scalars['Boolean']['input']>;
};

/**
 * Filters
 * Examples:
 *   ```
 *   {
 *       "siteId": {
 *       "grouping": "or",
 *       "predicate": {
 *           "in": [
 *             "bab53e5d-be4b-4f5d-8429-ff5d3521d08e",
 *             "14fd0a18-6a3c-4523-aa68-a661641360f6"
 *           ]
 *       },
 *       "filterGroup": "filter1"
 *     }
 *   },
 *   {
 *       "siteAreaId": {
 *           "grouping": "or",
 *           "predicate": {
 *               "in": [
 *                   "57c6364d-0f55-43b0-8e7c-776011f8e2a9",
 *                   "e226b0e1-6ffd-4918-9aad-bbf217258ea7"
 *               ]
 *           },
 *           "filterGroup": "filter1"
 *       }
 *   },
 *   {
 *       "name": {
 *           "grouping": "or",
 *           "predicate": { "cont": "cleaning" },
 *           "filterGroup": "filter2"
 *       }
 *   },
 *   {
 *       "priority": {
 *           "grouping": "or",
 *           "predicate": { "in": ["HIGH", "MEDIUM", "LOW"] },
 *           "filterGroup": "filter2"
 *       }
 *   }
 *   ```
 *
 */
export type FilterDateInputObject = {
  /** Allows to group many filters by AND. For example, if you want to filter by (name or email) AND by (site or area), you can group them together. Specify the same group for the (name and email) and then specify an another group for (site and area). The filters in the same group will be combined by AND/OR (depends on grouping attribute) and the groups will be combined by AND. The filter_group is a string and it can be any string. It is used to group filters together. You can see the example in the description, where the filter_group is 'filter1' and 'filter2'. In the example, the result will be in the following format: (siteId OR siteAreaId) AND (name OR priority) */
  filterGroup?: InputMaybe<Scalars['String']['input']>;
  /** Determines if result must be matched with all filters ('AND') or any of them ('OR') */
  grouping?: InputMaybe<FilterGroupingEnum>;
  /** Predicate */
  predicate: FilterDatePredicateInputObject;
};

/** Filters */
export type FilterDatePredicateInputObject = {
  /** Equal to */
  eq?: InputMaybe<Scalars['String']['input']>;
  /** Greater than */
  gt?: InputMaybe<Scalars['String']['input']>;
  /** Greater than or equal to */
  gteq?: InputMaybe<Scalars['String']['input']>;
  /** Less than */
  lt?: InputMaybe<Scalars['String']['input']>;
  /** Less than or equal to */
  lteq?: InputMaybe<Scalars['String']['input']>;
  /** Not equal to */
  notEq?: InputMaybe<Scalars['String']['input']>;
  /** Is not null */
  notNull?: InputMaybe<Scalars['Boolean']['input']>;
  /** Is null */
  null?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Determines if result must be matched with all filters ('and') or any of them ('or') */
export enum FilterGroupingEnum {
  /** All */
  And = 'and',
  /** Any */
  Or = 'or'
}

/**
 * Filters
 * Examples:
 *   ```
 *   {
 *       "siteId": {
 *       "grouping": "or",
 *       "predicate": {
 *           "in": [
 *             "bab53e5d-be4b-4f5d-8429-ff5d3521d08e",
 *             "14fd0a18-6a3c-4523-aa68-a661641360f6"
 *           ]
 *       },
 *       "filterGroup": "filter1"
 *     }
 *   },
 *   {
 *       "siteAreaId": {
 *           "grouping": "or",
 *           "predicate": {
 *               "in": [
 *                   "57c6364d-0f55-43b0-8e7c-776011f8e2a9",
 *                   "e226b0e1-6ffd-4918-9aad-bbf217258ea7"
 *               ]
 *           },
 *           "filterGroup": "filter1"
 *       }
 *   },
 *   {
 *       "name": {
 *           "grouping": "or",
 *           "predicate": { "cont": "cleaning" },
 *           "filterGroup": "filter2"
 *       }
 *   },
 *   {
 *       "priority": {
 *           "grouping": "or",
 *           "predicate": { "in": ["HIGH", "MEDIUM", "LOW"] },
 *           "filterGroup": "filter2"
 *       }
 *   }
 *   ```
 *
 */
export type FilterIdInputObject = {
  /** Allows to group many filters by AND. For example, if you want to filter by (name or email) AND by (site or area), you can group them together. Specify the same group for the (name and email) and then specify an another group for (site and area). The filters in the same group will be combined by AND/OR (depends on grouping attribute) and the groups will be combined by AND. The filter_group is a string and it can be any string. It is used to group filters together. You can see the example in the description, where the filter_group is 'filter1' and 'filter2'. In the example, the result will be in the following format: (siteId OR siteAreaId) AND (name OR priority) */
  filterGroup?: InputMaybe<Scalars['String']['input']>;
  /** Determines if result must be matched with all filters ('AND') or any of them ('OR') */
  grouping?: InputMaybe<FilterGroupingEnum>;
  /** Predicate */
  predicate: FilterIdPredicateInputObject;
};

/** Filters */
export type FilterIdPredicateInputObject = {
  /** Is null or empty (SQL: col is null OR col = '') */
  blank?: InputMaybe<Scalars['Boolean']['input']>;
  /** Equal to */
  eq?: InputMaybe<Scalars['String']['input']>;
  /** In */
  in?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Not equal to */
  notEq?: InputMaybe<Scalars['String']['input']>;
  /** Not in */
  notIn?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Is not null */
  notNull?: InputMaybe<Scalars['Boolean']['input']>;
  /** Is null */
  null?: InputMaybe<Scalars['Boolean']['input']>;
  /** Not null and not empty (SQL: col is not null AND col != '') */
  present?: InputMaybe<Scalars['Boolean']['input']>;
};

/**
 * Filters
 * Examples:
 *   ```
 *   {
 *       "siteId": {
 *       "grouping": "or",
 *       "predicate": {
 *           "in": [
 *             "bab53e5d-be4b-4f5d-8429-ff5d3521d08e",
 *             "14fd0a18-6a3c-4523-aa68-a661641360f6"
 *           ]
 *       },
 *       "filterGroup": "filter1"
 *     }
 *   },
 *   {
 *       "siteAreaId": {
 *           "grouping": "or",
 *           "predicate": {
 *               "in": [
 *                   "57c6364d-0f55-43b0-8e7c-776011f8e2a9",
 *                   "e226b0e1-6ffd-4918-9aad-bbf217258ea7"
 *               ]
 *           },
 *           "filterGroup": "filter1"
 *       }
 *   },
 *   {
 *       "name": {
 *           "grouping": "or",
 *           "predicate": { "cont": "cleaning" },
 *           "filterGroup": "filter2"
 *       }
 *   },
 *   {
 *       "priority": {
 *           "grouping": "or",
 *           "predicate": { "in": ["HIGH", "MEDIUM", "LOW"] },
 *           "filterGroup": "filter2"
 *       }
 *   }
 *   ```
 *
 */
export type FilterInputObject = {
  /** Allows to group many filters by AND. For example, if you want to filter by (name or email) AND by (site or area), you can group them together. Specify the same group for the (name and email) and then specify an another group for (site and area). The filters in the same group will be combined by AND/OR (depends on grouping attribute) and the groups will be combined by AND. The filter_group is a string and it can be any string. It is used to group filters together. You can see the example in the description, where the filter_group is 'filter1' and 'filter2'. In the example, the result will be in the following format: (siteId OR siteAreaId) AND (name OR priority) */
  filterGroup?: InputMaybe<Scalars['String']['input']>;
  /** Determines if result must be matched with all filters ('AND') or any of them ('OR') */
  grouping?: InputMaybe<FilterGroupingEnum>;
  /** Predicate */
  predicate: FilterPredicateInputObject;
};

/**
 * Filters
 * Examples:
 *   ```
 *   {
 *       "siteId": {
 *       "grouping": "or",
 *       "predicate": {
 *           "in": [
 *             "bab53e5d-be4b-4f5d-8429-ff5d3521d08e",
 *             "14fd0a18-6a3c-4523-aa68-a661641360f6"
 *           ]
 *       },
 *       "filterGroup": "filter1"
 *     }
 *   },
 *   {
 *       "siteAreaId": {
 *           "grouping": "or",
 *           "predicate": {
 *               "in": [
 *                   "57c6364d-0f55-43b0-8e7c-776011f8e2a9",
 *                   "e226b0e1-6ffd-4918-9aad-bbf217258ea7"
 *               ]
 *           },
 *           "filterGroup": "filter1"
 *       }
 *   },
 *   {
 *       "name": {
 *           "grouping": "or",
 *           "predicate": { "cont": "cleaning" },
 *           "filterGroup": "filter2"
 *       }
 *   },
 *   {
 *       "priority": {
 *           "grouping": "or",
 *           "predicate": { "in": ["HIGH", "MEDIUM", "LOW"] },
 *           "filterGroup": "filter2"
 *       }
 *   }
 *   ```
 *
 */
export type FilterIntInputObject = {
  /** Allows to group many filters by AND. For example, if you want to filter by (name or email) AND by (site or area), you can group them together. Specify the same group for the (name and email) and then specify an another group for (site and area). The filters in the same group will be combined by AND/OR (depends on grouping attribute) and the groups will be combined by AND. The filter_group is a string and it can be any string. It is used to group filters together. You can see the example in the description, where the filter_group is 'filter1' and 'filter2'. In the example, the result will be in the following format: (siteId OR siteAreaId) AND (name OR priority) */
  filterGroup?: InputMaybe<Scalars['String']['input']>;
  /** Determines if result must be matched with all filters ('AND') or any of them ('OR') */
  grouping?: InputMaybe<FilterGroupingEnum>;
  /** Predicate */
  predicate: FilterIntPredicateInputObject;
};

/** Filters */
export type FilterIntPredicateInputObject = {
  /** Is null or empty (SQL: col is null OR col = '') */
  blank?: InputMaybe<Scalars['Boolean']['input']>;
  /** Equal to */
  eq?: InputMaybe<Scalars['String']['input']>;
  /** Equal to all */
  eqAll?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Greater than */
  gt?: InputMaybe<Scalars['String']['input']>;
  /** Greater than all */
  gtAll?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Greater than any */
  gtAny?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Greater than or equal to */
  gteq?: InputMaybe<Scalars['String']['input']>;
  /** Greater than or equal to all */
  gteqAll?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Greater than or equal to any */
  gteqAny?: InputMaybe<Array<Scalars['String']['input']>>;
  /** In */
  in?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Less than */
  lt?: InputMaybe<Scalars['String']['input']>;
  /** Less than all */
  ltAll?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Less than any */
  ltAny?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Less than or equal to */
  lteq?: InputMaybe<Scalars['String']['input']>;
  /** Less than or equal to all */
  lteqAll?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Less than or equal to any */
  lteqAny?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Not equal to */
  notEq?: InputMaybe<Scalars['String']['input']>;
  /** Not equal to all */
  notEqAll?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Not in */
  notIn?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Is not null */
  notNull?: InputMaybe<Scalars['Boolean']['input']>;
  /** Is null */
  null?: InputMaybe<Scalars['Boolean']['input']>;
  /** Not null and not empty (SQL: col is not null AND col != '') */
  present?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Filters */
export type FilterPredicateInputObject = {
  /** Is null or empty (SQL: col is null OR col = '') */
  blank?: InputMaybe<Scalars['Boolean']['input']>;
  /** Contains (ILIKE %value%) */
  cont?: InputMaybe<Scalars['String']['input']>;
  /** Contains all (ILIKE %all values%) */
  contAll?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Contains any (ILIKE %any value%) */
  contAny?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Does not match (NOT ILIKE value) */
  doesNotMatch?: InputMaybe<Scalars['String']['input']>;
  /** Does not match all (NOT ILIKE all values) */
  doesNotMatchAll?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Does not match any (NOT ILIKE any value) */
  doesNotMatchAny?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Ends with (ILIKE %value) */
  end?: InputMaybe<Scalars['String']['input']>;
  /** Ends with all (ILIKE %all values) */
  endAll?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Ends with any (ILIKE %any value) */
  endAny?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Equal to */
  eq?: InputMaybe<Scalars['String']['input']>;
  /** Equal to all */
  eqAll?: InputMaybe<Array<Scalars['String']['input']>>;
  /** false */
  false?: InputMaybe<Scalars['Boolean']['input']>;
  /** Greater than */
  gt?: InputMaybe<Scalars['String']['input']>;
  /** Greater than all */
  gtAll?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Greater than any */
  gtAny?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Greater than or equal to */
  gteq?: InputMaybe<Scalars['String']['input']>;
  /** Greater than or equal to all */
  gteqAll?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Greater than or equal to any */
  gteqAny?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Contains value with case insensitive */
  iCont?: InputMaybe<Scalars['String']['input']>;
  /** Contains all values with case insensitive */
  iContAll?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Contains any value with case insensitive */
  iContAny?: InputMaybe<Array<Scalars['String']['input']>>;
  /** In */
  in?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Less than */
  lt?: InputMaybe<Scalars['String']['input']>;
  /** Less than all */
  ltAll?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Less than any */
  ltAny?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Less than or equal to */
  lteq?: InputMaybe<Scalars['String']['input']>;
  /** Less than or equal to all */
  lteqAll?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Less than or equal to any */
  lteqAny?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Matches (ILIKE value) */
  matches?: InputMaybe<Scalars['String']['input']>;
  /** Matches all (ILIKE all values) */
  matchesAll?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Matches any (ILIKE any value) */
  matchesAny?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Does not contain (NOT ILIKE %value%) */
  notCont?: InputMaybe<Scalars['String']['input']>;
  /** Does not contain all (NOT ILIKE %all values%) */
  notContAll?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Does not contain any (NOT ILIKE %any value%) */
  notContAny?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Does not end with (NOT ILIKE %value) */
  notEnd?: InputMaybe<Scalars['String']['input']>;
  /** Does not end with all (NOT ILIKE %all values) */
  notEndAll?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Does not end with any (NOT ILIKE %any value) */
  notEndAny?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Not equal to */
  notEq?: InputMaybe<Scalars['String']['input']>;
  /** Not equal to all */
  notEqAll?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Does not contain value with case insensitive */
  notICont?: InputMaybe<Scalars['String']['input']>;
  /** Does not contain all values with case insensitive */
  notIContAll?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Does not contain any value with case insensitive */
  notIContAny?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Not in */
  notIn?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Is not null */
  notNull?: InputMaybe<Scalars['Boolean']['input']>;
  /** Does not start with (NOT ILIKE value%) */
  notStart?: InputMaybe<Scalars['String']['input']>;
  /** Does not start with all (NOT ILIKE all values%) */
  notStartAll?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Does not start with any (NOT ILIKE any value%) */
  notStartAny?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Is null */
  null?: InputMaybe<Scalars['Boolean']['input']>;
  /** Not null and not empty (SQL: col is not null AND col != '') */
  present?: InputMaybe<Scalars['Boolean']['input']>;
  /** Starts with (ILIKE value%) */
  start?: InputMaybe<Scalars['String']['input']>;
  /** Starts with all (ILIKE all values%) */
  startAll?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Starts with any (ILIKE any value%) */
  startAny?: InputMaybe<Array<Scalars['String']['input']>>;
  /** true */
  true?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Form Answer entity */
export type FormAnswer = TimestampInterface & {
  __typename?: 'FormAnswer';
  /** Attachments */
  attachmentsAttached: Array<Attachment>;
  /** Time when was created */
  createdAt: Scalars['ISO8601DateTime']['output'];
  /** Documentation version viewing records */
  documentationVersionViews: Array<DocumentationVersionView>;
  /** Form Template Question Field */
  field: FormTemplateQuestionField;
  /** Form Template Question Field ID */
  fieldId: Scalars['ID']['output'];
  /** Form Answer ID */
  id: Scalars['ID']['output'];
  /** Form Template Question Field kind */
  kind: FormTemplateQuestionFieldsKindEnum;
  /**
   * Performer entity
   * NOTE: if you only need an Object ID, please use the performerId field to reduce the load on the database.
   */
  performer: Maybe<User>;
  /** Performer ID */
  performerId: Maybe<Scalars['ID']['output']>;
  /** Position */
  position: Scalars['Int']['output'];
  /** Form Template Question description */
  questionDescription: Maybe<Scalars['String']['output']>;
  /** Form Template Question ID */
  questionId: Scalars['ID']['output'];
  /** Form Template Question name */
  questionName: Maybe<Scalars['String']['output']>;
  /** Response object to a Form Answer */
  resp: Array<FormAnswerResp>;
  /** Task Completion ID */
  taskCompletionId: Scalars['ID']['output'];
  /** Form Template Version ID */
  templateVersionId: Scalars['ID']['output'];
  /** Last update time */
  updatedAt: Scalars['ISO8601DateTime']['output'];
  /**
   * Indicates if response is expected to be valid
   * ATTENTION: Access allowed for users: [TASKS_MANAGEMENT:READ].
   */
  validityHint: Maybe<FormTemplateQuestionFieldOptionsValidityHintEnum>;
};

/** Form Answer attributes */
export type FormAnswerCreateInputObject = {
  /** Attachments */
  attachmentsAttached?: InputMaybe<Array<AttachmentCuInputObject>>;
  /** Form Template Question Field ID */
  fieldId: Scalars['ID']['input'];
  /** Form Template Question ID */
  questionId: Scalars['ID']['input'];
  /** Response object */
  resp?: InputMaybe<Array<FormAnswerRespInputObject>>;
};

/** What the operator did with a document attached to a form question */
export enum FormAnswerDocumentStatusEnum {
  /** Document has been read during this task */
  Read = 'READ',
  /** Document was already read in a previous session and no re-read was required */
  ReadPreviously = 'READ_PREVIOUSLY',
  /** Document was not available */
  Unavailable = 'UNAVAILABLE',
  /** Document has not been read */
  Unread = 'UNREAD'
}

/** Reasons for the document status */
export enum FormAnswerDocumentStatusReasonEnum {
  /** Document was deleted */
  Deleted = 'DELETED',
  /** Document was unavailable due to free plan */
  FreePlan = 'FREE_PLAN',
  /** Document was not validated */
  NotValidated = 'NOT_VALIDATED',
  /** Operator's access level does not allow opening documents at all */
  NoAccess = 'NO_ACCESS',
  /** Document was unavailable because task was completed offline */
  Offline = 'OFFLINE'
}

/** Response type */
export type FormAnswerResp = {
  __typename?: 'FormAnswerResp';
  /** ID of the DocumentationVersionView row created for a READ status */
  documentationVersionViewId: Maybe<Scalars['ID']['output']>;
  /** Group */
  group: Maybe<FormAnswerRespGroupEnum>;
  /** Form Template Question Field Option ID (Row of the checkbox button grid) */
  optionId: Maybe<Scalars['ID']['output']>;
  /** Position */
  position: Maybe<Scalars['Int']['output']>;
  /** Indicates if option is selected */
  selected: Maybe<Scalars['Boolean']['output']>;
  /** Read status recorded for a Document-kind option at submission time */
  status: Maybe<FormAnswerDocumentStatusEnum>;
  /** Reason accompanying an UNAVAILABLE status */
  statusReason: Maybe<FormAnswerDocumentStatusReasonEnum>;
  /**
   * Indicates if option is expected to be valid
   * ATTENTION: Access allowed for users: [TASKS_MANAGEMENT:READ].
   */
  validityHint: Maybe<FormTemplateQuestionFieldOptionsValidityHintEnum>;
  /** Value */
  value: Maybe<Scalars['String']['output']>;
  /** Form Template Question Field Option ID (Column for the checkbox button grid and only for the checkbox button grid) */
  valueId: Maybe<Scalars['ID']['output']>;
};

/** All available form answer response groups */
export enum FormAnswerRespGroupEnum {
  EndDate = 'END_DATE',
  EndTime = 'END_TIME',
  Max = 'MAX',
  Min = 'MIN',
  No = 'NO',
  StartDate = 'START_DATE',
  StartTime = 'START_TIME',
  Yes = 'YES'
}

/** Response object */
export type FormAnswerRespInputObject = {
  /** Fresh DocumentationVersionView ID when status is read */
  documentationVersionViewId?: InputMaybe<Scalars['ID']['input']>;
  /** Group */
  group?: InputMaybe<FormAnswerRespGroupEnum>;
  /** Form Template Question Field Option ID (Row of the checkbox button grid) */
  optionId?: InputMaybe<Scalars['ID']['input']>;
  /** Indicates if option is selected */
  selected?: InputMaybe<Scalars['Boolean']['input']>;
  /** Document read status for document-kind fields (read, read_previously, unread, unavailable) */
  status?: InputMaybe<FormAnswerDocumentStatusEnum>;
  /** Reason when status is unavailable (not_validated, deleted, free_plan, offline) */
  statusReason?: InputMaybe<FormAnswerDocumentStatusReasonEnum>;
  /** Value */
  value?: InputMaybe<Scalars['String']['input']>;
  /** Form Template Question Field Option ID (Column for the checkbox button grid and only for the checkbox button grid) */
  valueId?: InputMaybe<Scalars['ID']['input']>;
};

/** Form Category entity */
export type FormCategory = TimestampInterface & {
  __typename?: 'FormCategory';
  canDestroy: AuthorizationResult;
  /** Color */
  color: ColorEnum;
  /** Time when was created */
  createdAt: Scalars['ISO8601DateTime']['output'];
  /** Form Templates collection */
  formTemplates: FormTemplateCollection;
  /** Number of form templates */
  formTemplatesCount: Scalars['Int']['output'];
  /** Form Category ID */
  id: Scalars['ID']['output'];
  /** Name */
  name: Scalars['String']['output'];
  /** Last update time */
  updatedAt: Scalars['ISO8601DateTime']['output'];
};


/** Form Category entity */
export type FormCategoryFormTemplatesArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
};

/** FormCategoryCollection type */
export type FormCategoryCollection = {
  __typename?: 'FormCategoryCollection';
  /** A collection of paginated FormCategoryCollection */
  collection: Array<FormCategory>;
  /** Pagination Metadata for navigating the Pagination */
  metadata: CollectionMetadata;
};

/** Description from base input object. Please set your description for child object. */
export type FormCategoryCreateInput = {
  /** Create attributes */
  attributes: FormCategoryCreateInputObject;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Form Category attributes */
export type FormCategoryCreateInputObject = {
  /** Color */
  color: ColorEnum;
  /** Name */
  name: Scalars['String']['input'];
};

/** Description from base input object. Please set your description for child object. */
export type FormCategoryDestroyInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Form Category ID */
  id: Scalars['ID']['input'];
};

/** Form Category filters */
export type FormCategoryFilterInputObject = {
  /** Form Category ID */
  id?: InputMaybe<FilterIdInputObject>;
  /** Form Category name */
  name?: InputMaybe<FilterInputObject>;
};

/** Form Category sorts */
export type FormCategorySortInputObject = {
  /** Created at */
  createdAt?: InputMaybe<SortDirectionEnum>;
  /** Number of form templates in this category */
  formTemplatesCount?: InputMaybe<SortDirectionEnum>;
  /** Name */
  name?: InputMaybe<SortDirectionEnum>;
};

/** Description from base input object. Please set your description for child object. */
export type FormCategoryUpdateInput = {
  /** Update attributes */
  attributes: FormCategoryUpdateInputObject;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Form Category ID */
  id: Scalars['ID']['input'];
};

/** Form Category attributes */
export type FormCategoryUpdateInputObject = {
  /** Color */
  color?: InputMaybe<ColorEnum>;
  /** Name */
  name?: InputMaybe<Scalars['String']['input']>;
};

/** Form Checklist Template entity */
export type FormChecklistTemplate = TimestampInterface & {
  __typename?: 'FormChecklistTemplate';
  canDestroy: AuthorizationResult;
  canUpdate: AuthorizationResult;
  /** Time when was created */
  createdAt: Scalars['ISO8601DateTime']['output'];
  /** Description */
  description: Maybe<Scalars['String']['output']>;
  /** Form Checklist Template ID */
  id: Scalars['ID']['output'];
  /** Name */
  name: Scalars['String']['output'];
  /** Form Checklist Template Options collection */
  options: Array<FormChecklistTemplateOption>;
  /** Number of options */
  optionsCount: Scalars['Int']['output'];
  /** Last update time */
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

/** FormChecklistTemplateCollection type */
export type FormChecklistTemplateCollection = {
  __typename?: 'FormChecklistTemplateCollection';
  /** A collection of paginated FormChecklistTemplateCollection */
  collection: Array<FormChecklistTemplate>;
  /** Pagination Metadata for navigating the Pagination */
  metadata: CollectionMetadata;
};

/** Description from base input object. Please set your description for child object. */
export type FormChecklistTemplateCreateInput = {
  /** Create attributes */
  attributes: FormChecklistTemplateCreateInputObject;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Form Checklist Template attributes */
export type FormChecklistTemplateCreateInputObject = {
  /** Description */
  description?: InputMaybe<Scalars['String']['input']>;
  /** Name */
  name: Scalars['String']['input'];
  /** Form Checklist Template Options attributes array */
  options: Array<FormChecklistTemplateOptionUpdateInputObject>;
};

/** Description from base input object. Please set your description for child object. */
export type FormChecklistTemplateDestroyInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Form Checklist Template ID */
  id: Scalars['ID']['input'];
};

/** Form Checklist Template filters */
export type FormChecklistTemplateFilterInputObject = {
  /** Form Checklist Template name */
  name?: InputMaybe<FilterInputObject>;
};

/** Form Checklist Template Option entity */
export type FormChecklistTemplateOption = TimestampInterface & {
  __typename?: 'FormChecklistTemplateOption';
  /** Time when was created */
  createdAt: Scalars['ISO8601DateTime']['output'];
  /** Form Checklist Template Option ID */
  id: Scalars['ID']['output'];
  /** Position */
  position: Scalars['Int']['output'];
  /** Last update time */
  updatedAt: Scalars['ISO8601DateTime']['output'];
  /** Value */
  value: Scalars['String']['output'];
};

/** Form Checklist Template Option attributes */
export type FormChecklistTemplateOptionUpdateInputObject = {
  /** Form Checklist Template Option ID (to update existing option pass ID. To create new option do not pass ID) */
  id?: InputMaybe<Scalars['ID']['input']>;
  /** Position */
  position: Scalars['Int']['input'];
  /** Value */
  value: Scalars['String']['input'];
};

/** Form Checklist Template sorts */
export type FormChecklistTemplateSortInputObject = {
  /** Created at */
  createdAt?: InputMaybe<SortDirectionEnum>;
  /** Name */
  name?: InputMaybe<SortDirectionEnum>;
  /** Number of options */
  optionsCount?: InputMaybe<SortDirectionEnum>;
};

/** Description from base input object. Please set your description for child object. */
export type FormChecklistTemplateUpdateInput = {
  /** Update attributes */
  attributes: FormChecklistTemplateUpdateInputObject;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Form Checklist Template ID */
  id: Scalars['ID']['input'];
};

/** Form Checklist Template attributes */
export type FormChecklistTemplateUpdateInputObject = {
  /** Description */
  description?: InputMaybe<Scalars['String']['input']>;
  /** Name */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Form Checklist Template Options attributes array */
  options: Array<FormChecklistTemplateOptionUpdateInputObject>;
};

/** Form Template entity */
export type FormTemplate = TimestampInterface & {
  __typename?: 'FormTemplate';
  /** Archived date */
  archivedAt: Maybe<Scalars['ISO8601DateTime']['output']>;
  canArchive: AuthorizationResult;
  canDestroy: AuthorizationResult;
  canRestore: AuthorizationResult;
  canUpdate: AuthorizationResult;
  /**
   * Form Category entity
   * NOTE: if you only need an Object ID, please use the categoryId field to reduce the load on the database.
   */
  category: Maybe<FormCategory>;
  /** Form Category ID */
  categoryId: Maybe<Scalars['ID']['output']>;
  /** Time when was created */
  createdAt: Scalars['ISO8601DateTime']['output'];
  /** Latest Form Template Version entity */
  currentVersion: Maybe<FormTemplateVersion>;
  /** Description */
  description: Maybe<Scalars['String']['output']>;
  /** Whether this Form Template has at least one documentation directly linked at the template level */
  hasLinkedDocumentations: Maybe<Scalars['Boolean']['output']>;
  /** Form Template ID */
  id: Scalars['ID']['output'];
  /** Name */
  name: Scalars['String']['output'];
  /** Last update time */
  updatedAt: Scalars['ISO8601DateTime']['output'];
  /** Number of versions */
  versionsCount: Scalars['Int']['output'];
  /** Number of visible linked tasks for current user */
  visibleLinkedTasksCount: Scalars['Int']['output'];
};

/** Description from base input object. Please set your description for child object. */
export type FormTemplateBulkArchiveInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** IDs */
  ids: Array<Scalars['ID']['input']>;
};

/** Description from base input object. Please set your description for child object. */
export type FormTemplateBulkDestroyInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** IDs */
  ids: Array<Scalars['ID']['input']>;
};

/** Description from base input object. Please set your description for child object. */
export type FormTemplateBulkRestoreInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** IDs */
  ids: Array<Scalars['ID']['input']>;
};

/** FormTemplateCollection type */
export type FormTemplateCollection = {
  __typename?: 'FormTemplateCollection';
  /** A collection of paginated FormTemplateCollection */
  collection: Array<FormTemplate>;
  /** Pagination Metadata for navigating the Pagination */
  metadata: CollectionMetadata;
};

/** Description from base input object. Please set your description for child object. */
export type FormTemplateCreateInput = {
  /** Create attributes */
  attributes: FormTemplateCreateInputObject;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Form Template attributes */
export type FormTemplateCreateInputObject = {
  /** Form Category ID */
  categoryId: Scalars['ID']['input'];
  /** Description */
  description?: InputMaybe<Scalars['String']['input']>;
  /**
   * Documentation links
   * ATTENTION: Requires plan upgrade for feature: DOCUMENTATION_MANAGEMENT.
   */
  documentationLinks?: InputMaybe<Array<DocumentationLinkInputObject>>;
  /** Name */
  name: Scalars['String']['input'];
  /** Version */
  version: FormTemplateVersionCuInputObject;
};

/** Form Template filters */
export type FormTemplateFilterInputObject = {
  /** Form Category ID */
  categoryId?: InputMaybe<FilterIdInputObject>;
  /** Form Category name */
  categoryName?: InputMaybe<FilterInputObject>;
  /**
   * Filter to form templates linked to one of these documentation IDs
   * ATTENTION: Requires plan upgrade for feature: DOCUMENTATION_MANAGEMENT.
   */
  documentationsId?: InputMaybe<FilterIdInputObject>;
  /** Form Template name */
  name?: InputMaybe<FilterInputObject>;
};

/** Form Question entity */
export type FormTemplateQuestion = TimestampInterface & {
  __typename?: 'FormTemplateQuestion';
  /** Related Attachments */
  attachmentsAttached: Array<Attachment>;
  /** Time when was created */
  createdAt: Scalars['ISO8601DateTime']['output'];
  /** Description */
  description: Maybe<Scalars['String']['output']>;
  /** Related Form Question Fields */
  fields: Array<FormTemplateQuestionField>;
  /** Form Question ID */
  id: Scalars['ID']['output'];
  /** Name */
  name: Maybe<Scalars['String']['output']>;
  /** Position */
  position: Scalars['Int']['output'];
  /** Form Template ID */
  templateId: Scalars['ID']['output'];
  /** Form Template Version ID */
  templateVersionId: Scalars['ID']['output'];
  /** Last update time */
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

/** Form Question Field entity */
export type FormTemplateQuestionField = TimestampInterface & {
  __typename?: 'FormTemplateQuestionField';
  /** Time when was created */
  createdAt: Scalars['ISO8601DateTime']['output'];
  /** Form Question Field ID */
  id: Scalars['ID']['output'];
  /** Kind */
  kind: FormTemplateQuestionFieldsKindEnum;
  /** Related Form Question Field Options */
  options: Array<FormTemplateQuestionFieldOption>;
  /** Position */
  position: Scalars['Int']['output'];
  /** Form Question ID */
  questionId: Scalars['ID']['output'];
  /** Indicates if field is required */
  required: Scalars['Boolean']['output'];
  /** Field settings */
  settings: FormTemplateQuestionFieldSettings;
  /** Form Template ID */
  templateId: Scalars['ID']['output'];
  /** Form Template Version ID */
  templateVersionId: Scalars['ID']['output'];
  /** Last update time */
  updatedAt: Scalars['ISO8601DateTime']['output'];
  /**
   * Validity hint config
   * ATTENTION: Access allowed for users: [TASKS_MANAGEMENT:READ].
   */
  validityHintConfig: Array<FormTemplateQuestionFieldValidityHintConfig>;
};

/** Form Question Field Option entity */
export type FormTemplateQuestionFieldOption = TimestampInterface & {
  __typename?: 'FormTemplateQuestionFieldOption';
  /**
   * Condition
   * ATTENTION: Access allowed for users: [TASKS_MANAGEMENT:READ].
   */
  condition: Maybe<FormTemplateQuestionFieldOptionConditionEnum>;
  /** Time when was created */
  createdAt: Scalars['ISO8601DateTime']['output'];
  /** Form Question Field ID */
  fieldId: Scalars['ID']['output'];
  /** Group */
  group: Maybe<FormTemplateQuestionFieldOptionGroupEnum>;
  /** Form Question Field Option ID */
  id: Scalars['ID']['output'];
  /**
   * Linked documentation (for document kind options)
   * ATTENTION: Requires plan upgrade for feature: DOCUMENTATION_MANAGEMENT.
   */
  optionDocumentation: Maybe<FormTemplateQuestionFieldOptionDocumentation>;
  /** Position */
  position: Scalars['Int']['output'];
  /** Form Question ID */
  questionId: Scalars['ID']['output'];
  /** Form Template ID */
  templateId: Scalars['ID']['output'];
  /** Form Template Version ID */
  templateVersionId: Scalars['ID']['output'];
  /** Last update time */
  updatedAt: Scalars['ISO8601DateTime']['output'];
  /**
   * Indicates if option will have expected result after user input in answers
   * ATTENTION: Access allowed for users: [TASKS_MANAGEMENT:READ].
   */
  validityHint: Maybe<FormTemplateQuestionFieldOptionsValidityHintEnum>;
  /** Array of values which will be used to validate user input or to display in the form (depends on the kind of the field) */
  values: Array<Scalars['String']['output']>;
};

/** All available form template question field option conditions */
export enum FormTemplateQuestionFieldOptionConditionEnum {
  Between = 'BETWEEN',
  Equal = 'EQUAL',
  GreaterThan = 'GREATER_THAN',
  LessThan = 'LESS_THAN',
  NotEqual = 'NOT_EQUAL'
}

/** Form Question Field Option Documentation link entity */
export type FormTemplateQuestionFieldOptionDocumentation = TimestampInterface & {
  __typename?: 'FormTemplateQuestionFieldOptionDocumentation';
  /** Time when was created */
  createdAt: Scalars['ISO8601DateTime']['output'];
  /** Documentation ID */
  documentationId: Scalars['ID']['output'];
  /** Option Documentation ID */
  id: Scalars['ID']['output'];
  /** Indicates if user must read this document */
  requiredToRead: Scalars['Boolean']['output'];
  /** Last update time */
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

/** Option documentation link attributes */
export type FormTemplateQuestionFieldOptionDocumentationCuInputObject = {
  /** Documentation ID */
  documentationId: Scalars['ID']['input'];
  /** Indicates if user must read this document */
  requiredToRead: Scalars['Boolean']['input'];
};

/** All available form template question field option groups */
export enum FormTemplateQuestionFieldOptionGroupEnum {
  Columns = 'COLUMNS',
  Max = 'MAX',
  Min = 'MIN',
  No = 'NO',
  Rows = 'ROWS',
  Yes = 'YES'
}

/** Form Question Field Option attributes */
export type FormTemplateQuestionFieldOptionUpdateInputObject = {
  /** Condition */
  condition?: InputMaybe<FormTemplateQuestionFieldOptionConditionEnum>;
  /** Group */
  group?: InputMaybe<FormTemplateQuestionFieldOptionGroupEnum>;
  /** Form Question Field Option ID (to update existing question pass ID. To create new question do not pass ID) */
  id?: InputMaybe<Scalars['ID']['input']>;
  /**
   * Document link (for document kind options)
   * ATTENTION: Requires plan upgrade for feature: DOCUMENTATION_MANAGEMENT.
   */
  optionDocumentation?: InputMaybe<FormTemplateQuestionFieldOptionDocumentationCuInputObject>;
  /** Position */
  position: Scalars['Int']['input'];
  /** Indicates if option will have expected result after user input in answers */
  validityHint?: InputMaybe<FormTemplateQuestionFieldOptionsValidityHintEnum>;
  /** Values */
  values?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** All available form template question field option validity hints */
export enum FormTemplateQuestionFieldOptionsValidityHintEnum {
  Failure = 'FAILURE',
  Success = 'SUCCESS',
  Warning = 'WARNING'
}

/** Field settings */
export type FormTemplateQuestionFieldSettings = {
  __typename?: 'FormTemplateQuestionFieldSettings';
  /** Indicates if field should display last response for the same question */
  allowDisplayLastAnswer: Maybe<Scalars['Boolean']['output']>;
  /** Indicates if field should limit responses to one (currently only for checklist field) */
  limitToOneResp: Maybe<Scalars['Boolean']['output']>;
  /** Indicates if checkbox_button_grid field should limit responses to one per column */
  limitToOneRespPerColumn: Maybe<Scalars['Boolean']['output']>;
  /** Indicates if checkbox_button_grid field should limit responses to one per row */
  limitToOneRespPerRow: Maybe<Scalars['Boolean']['output']>;
};

/** Field settings */
export type FormTemplateQuestionFieldSettingsInputObject = {
  /** Allow display last answer */
  allowDisplayLastAnswer?: InputMaybe<Scalars['Boolean']['input']>;
  /** Indicates if field should limit responses to one (currently only for checklist field) */
  limitToOneResp?: InputMaybe<Scalars['Boolean']['input']>;
  /** Indicates if checkbox_button_grid field should limit responses to one per column */
  limitToOneRespPerColumn?: InputMaybe<Scalars['Boolean']['input']>;
  /** Indicates if checkbox_button_grid field should limit responses to one per row */
  limitToOneRespPerRow?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Form Question Field attributes */
export type FormTemplateQuestionFieldUpdateInputObject = {
  /** Form Question Field ID (to update existing field pass ID. To create new field do not pass ID) */
  id?: InputMaybe<Scalars['ID']['input']>;
  /** Kind */
  kind: FormTemplateQuestionFieldsKindEnum;
  /** Form Question Field Options attributes array */
  options?: InputMaybe<Array<FormTemplateQuestionFieldOptionUpdateInputObject>>;
  /** Position */
  position: Scalars['Int']['input'];
  /** Indicates if field is required */
  required: Scalars['Boolean']['input'];
  /** Field settings */
  settings?: InputMaybe<FormTemplateQuestionFieldSettingsInputObject>;
  /** Validity hint config */
  validityHintConfig?: InputMaybe<Array<FormTemplateQuestionFieldValidityHintConfigInputObject>>;
};

/** Validity hint config */
export type FormTemplateQuestionFieldValidityHintConfig = {
  __typename?: 'FormTemplateQuestionFieldValidityHintConfig';
  /** Option positions */
  optionPositions: Array<Scalars['Int']['output']>;
  /** Validity hint */
  validityHint: FormTemplateQuestionFieldOptionsValidityHintEnum;
};

/** Validity hint config */
export type FormTemplateQuestionFieldValidityHintConfigInputObject = {
  /** Option positions */
  optionPositions: Array<Scalars['Int']['input']>;
  /** Validity hint */
  validityHint?: InputMaybe<FormTemplateQuestionFieldOptionsValidityHintEnum>;
};

/** Available form template question field kinds */
export enum FormTemplateQuestionFieldsKindEnum {
  /** Attachment */
  Attachment = 'ATTACHMENT',
  /** Multi select */
  Checkbox = 'CHECKBOX',
  /** Checkbox grid in table */
  CheckboxButtonGrid = 'CHECKBOX_BUTTON_GRID',
  /** Checklist */
  Checklist = 'CHECKLIST',
  /** Date */
  Date = 'DATE',
  /** Date and time */
  Datetime = 'DATETIME',
  /** Date range */
  DateRange = 'DATE_RANGE',
  /** Decision box */
  DecisionBox = 'DECISION_BOX',
  /** Document */
  Document = 'DOCUMENT',
  /** Important notice */
  ImportantNotice = 'IMPORTANT_NOTICE',
  /** Single line text */
  Input = 'INPUT',
  /** Numeric range */
  MinMax = 'MIN_MAX',
  /** Numeric */
  NumberInput = 'NUMBER_INPUT',
  /** Single select */
  RadioButton = 'RADIO_BUTTON',
  /** Rating */
  Rating = 'RATING',
  /** Section */
  Section = 'SECTION',
  /** Dropdown */
  SingleSelect = 'SINGLE_SELECT',
  /** Multi line text */
  TextArea = 'TEXT_AREA',
  /** Time */
  Time = 'TIME',
  /** Time range */
  TimeRange = 'TIME_RANGE',
  /** Yes/no */
  YesNo = 'YES_NO'
}

/** Form Question attributes */
export type FormTemplateQuestionUpdateInputObject = {
  /** Attachments */
  attachmentsAttached?: InputMaybe<Array<AttachmentCuInputObject>>;
  /** Description */
  description?: InputMaybe<Scalars['String']['input']>;
  /** Form Question Fields attributes array */
  fields: Array<FormTemplateQuestionFieldUpdateInputObject>;
  /** Form Question ID (to update existing question pass ID. To create new question do not pass ID) */
  id?: InputMaybe<Scalars['ID']['input']>;
  /** Name */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Position */
  position: Scalars['Int']['input'];
};

/** Available form template scope names */
export enum FormTemplateScopeNameEnum {
  /** Active form templates */
  Active = 'ACTIVE',
  /** Archived form templates */
  Archived = 'ARCHIVED'
}

/** Form Template sorts */
export type FormTemplateSortInputObject = {
  /** Archived at */
  archivedAt?: InputMaybe<SortDirectionEnum>;
  /** Form Category name */
  categoryName?: InputMaybe<SortDirectionEnum>;
  /** Created at */
  createdAt?: InputMaybe<SortDirectionEnum>;
  /** Name */
  name?: InputMaybe<SortDirectionEnum>;
  /** Number of versions */
  versionsCount?: InputMaybe<SortDirectionEnum>;
  /** Number of visible linked tasks for current user */
  visibleLinkedTasksCount?: InputMaybe<SortDirectionEnum>;
};

/** Description from base input object. Please set your description for child object. */
export type FormTemplateUnlinkAllDocumentationsInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Form Template ID */
  id: Scalars['ID']['input'];
};

/** Description from base input object. Please set your description for child object. */
export type FormTemplateUpdateInput = {
  /** Update attributes */
  attributes: FormTemplateUpdateInputObject;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Form Template ID */
  id: Scalars['ID']['input'];
};

/** Form Template attributes */
export type FormTemplateUpdateInputObject = {
  /** Form Category ID */
  categoryId?: InputMaybe<Scalars['ID']['input']>;
  /** Description */
  description?: InputMaybe<Scalars['String']['input']>;
  /**
   * Documentation links
   * ATTENTION: Requires plan upgrade for feature: DOCUMENTATION_MANAGEMENT.
   */
  documentationLinks?: InputMaybe<Array<DocumentationLinkInputObject>>;
  /** Name */
  name?: InputMaybe<Scalars['String']['input']>;
};

/** Form Template Version entity */
export type FormTemplateVersion = TimestampInterface & {
  __typename?: 'FormTemplateVersion';
  /** Archived date */
  archivedAt: Maybe<Scalars['ISO8601DateTime']['output']>;
  canArchive: AuthorizationResult;
  canDestroy: AuthorizationResult;
  canRestore: AuthorizationResult;
  canUpdate: AuthorizationResult;
  /** Time when was created */
  createdAt: Scalars['ISO8601DateTime']['output'];
  /** Form Template ID */
  id: Scalars['ID']['output'];
  /** Related Form Questions */
  questions: Array<FormTemplateQuestion>;
  /** Status (Virtual field) */
  status: FormTemplateVersionStatusEnum;
  /** Form Template ID */
  templateId: Scalars['ID']['output'];
  /** Last update time */
  updatedAt: Scalars['ISO8601DateTime']['output'];
  /** Version */
  version: Maybe<Scalars['String']['output']>;
  /** Number of visible linked tasks for current user */
  visibleLinkedTasksCount: Scalars['Int']['output'];
};

/** Description from base input object. Please set your description for child object. */
export type FormTemplateVersionArchiveInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Form Template ID */
  formTemplateId: Scalars['ID']['input'];
  /** Form Template Version ID */
  id: Scalars['ID']['input'];
};

/** FormTemplateVersionCollection type */
export type FormTemplateVersionCollection = {
  __typename?: 'FormTemplateVersionCollection';
  /** A collection of paginated FormTemplateVersionCollection */
  collection: Array<FormTemplateVersion>;
  /** Pagination Metadata for navigating the Pagination */
  metadata: CollectionMetadata;
};

/** Description from base input object. Please set your description for child object. */
export type FormTemplateVersionCreateInput = {
  /** Create attributes */
  attributes: FormTemplateVersionCuInputObject;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Form Template ID */
  formTemplateId: Scalars['ID']['input'];
};

/** Form Template Version attributes */
export type FormTemplateVersionCuInputObject = {
  /** Form Template Questions attributes array */
  questions: Array<FormTemplateQuestionUpdateInputObject>;
  /** Task IDs to link */
  taskIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};

/** Description from base input object. Please set your description for child object. */
export type FormTemplateVersionDestroyInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Form Template ID */
  formTemplateId: Scalars['ID']['input'];
  /** Form Template Version ID */
  id: Scalars['ID']['input'];
};

/** Form Template Version filters */
export type FormTemplateVersionFilterInputObject = {
  /** Archived at */
  archivedAt?: InputMaybe<FilterDateInputObject>;
  /** Version */
  version?: InputMaybe<FilterIntInputObject>;
};

/** Description from base input object. Please set your description for child object. */
export type FormTemplateVersionRestoreInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Form Template ID */
  formTemplateId: Scalars['ID']['input'];
  /** Form Template Version ID */
  id: Scalars['ID']['input'];
};

/** Form Template Version sorts */
export type FormTemplateVersionSortInputObject = {
  /** Archived at */
  archivedAt?: InputMaybe<SortDirectionEnum>;
  /** Created at */
  createdAt?: InputMaybe<SortDirectionEnum>;
  /** Version */
  version?: InputMaybe<SortDirectionEnum>;
  /** Number of visible linked tasks for current user */
  visibleLinkedTasksCount?: InputMaybe<SortDirectionEnum>;
};

/** Available form template version statuses */
export enum FormTemplateVersionStatusEnum {
  Active = 'ACTIVE',
  Archived = 'ARCHIVED',
  Unused = 'UNUSED'
}

/** Description from base input object. Please set your description for child object. */
export type FormTemplateVersionUpdateInput = {
  /** Update attributes */
  attributes: FormTemplateVersionCuInputObject;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Form Template ID */
  formTemplateId: Scalars['ID']['input'];
  /** Form Template Version ID */
  id: Scalars['ID']['input'];
};

/** Country */
export type GeoCountry = {
  __typename?: 'GeoCountry';
  /** Country code */
  code: Scalars['String']['output'];
  /** Country name */
  name: Scalars['String']['output'];
};

/** GeoJSON Feature entity */
export type GeojsonFeature = {
  __typename?: 'GeojsonFeature';
  /** Feature geometry */
  geometry: GeojsonGeometry;
  /** Feature properties */
  properties: Maybe<GeojsonProperties>;
  /** Feature type */
  type: GeojsonFeatureTypeEnum;
};

/** GeoJSON Feature Collection entity */
export type GeojsonFeatureCollection = {
  __typename?: 'GeojsonFeatureCollection';
  /** Features collection */
  features: Array<GeojsonFeature>;
  /** Feature Collection type */
  type: GeojsonFeatureCollectionTypeEnum;
};

/** GeoJSON Feature Collection input */
export type GeojsonFeatureCollectionInputObject = {
  /** Features collection */
  features: Array<GeojsonFeatureInputObject>;
  /** Feature Collection type */
  type: GeojsonFeatureCollectionTypeEnum;
};

/** Available GeoJSON feature collection types */
export enum GeojsonFeatureCollectionTypeEnum {
  /** Feature Collection */
  FeatureCollection = 'FeatureCollection'
}

/** GeoJSON Feature input */
export type GeojsonFeatureInputObject = {
  /** Feature geometry */
  geometry: GeojsonGeometryInputObject;
  /** Feature properties */
  properties?: InputMaybe<GeojsonPropertiesInputObject>;
  /** Feature type */
  type: GeojsonFeatureTypeEnum;
};

/** Available GeoJSON feature types */
export enum GeojsonFeatureTypeEnum {
  /** Feature */
  Feature = 'Feature'
}

/** GeoJSON Geometry entity */
export type GeojsonGeometry = {
  __typename?: 'GeojsonGeometry';
  /** Geometry coordinates (Point, Polygon); Point -> [longitude, latitude]; Polygon -> [[[longitude, latitude], ...], ...]; */
  coordinates: Scalars['JSON']['output'];
  /** Geometry type */
  type: GeojsonGeometryTypeEnum;
};

/** GeoJSON Geometry input */
export type GeojsonGeometryInputObject = {
  /** Geometry coordinates (Point, Polygon); Point -> [longitude, latitude]; Polygon -> [[[longitude, latitude], ...], ...]; */
  coordinates: Scalars['JSON']['input'];
  /** Geometry type */
  type: GeojsonGeometryTypeEnum;
};

/** Available GeoJSON geometry types */
export enum GeojsonGeometryTypeEnum {
  /** Point */
  Point = 'Point',
  /** Polygon */
  Polygon = 'Polygon'
}

/** GeoJSON Properties entity */
export type GeojsonProperties = {
  __typename?: 'GeojsonProperties';
  /** Address (exact address that syncs with the coordinates) */
  address: Maybe<Scalars['String']['output']>;
  /** Address details (any other details, for example, a building name, a floor number, etc.) */
  addressDetails: Maybe<Scalars['String']['output']>;
  /** Color */
  color: Maybe<ColorEnum>;
  /** Icon */
  icon: Maybe<Scalars['String']['output']>;
  /** ID (must be used by FE to recognize the same object on the map if it is returned multiple times during multiple requests) */
  id: Maybe<Scalars['String']['output']>;
  /** Point count (number of points in the cluster) */
  pointCount: Maybe<Scalars['Int']['output']>;
  /** Shape */
  shape: Maybe<Scalars['String']['output']>;
  /** Sourceables Collection. A set of unique object classes and identifiers associated with the cluster. This indicates that the cluster contains defined locations for each of these objects. */
  sourceables: Maybe<Array<GeojsonPropertiesPolymorphicIdentity>>;
  /** Type (cluster, polygon, point, line, etc.). Must be used by FE to identify the type of the feature and to render it correctly. */
  type: Maybe<GeojsonPropertiesTypeEnum>;
};

/** GeoJSON Properties input */
export type GeojsonPropertiesInputObject = {
  /** Address (exact address that syncs with the coordinates) */
  address?: InputMaybe<Scalars['String']['input']>;
  /** Address details (any other details, for example, a building name, a floor number, etc.) */
  addressDetails?: InputMaybe<Scalars['String']['input']>;
  /** Color */
  color?: InputMaybe<ColorEnum>;
  /** Icon */
  icon?: InputMaybe<Scalars['String']['input']>;
  /** Shape */
  shape?: InputMaybe<Scalars['String']['input']>;
};

/** Polymorphic identity entity */
export type GeojsonPropertiesPolymorphicIdentity = {
  __typename?: 'GeojsonPropertiesPolymorphicIdentity';
  /** ID */
  id: Scalars['ID']['output'];
  /** Type (Class name) */
  type: GeojsonPropertiesPolymorphicIdentityTypeEnum;
};

/** Available GeoJSON properties polymorphic identity types */
export enum GeojsonPropertiesPolymorphicIdentityTypeEnum {
  /** Sector */
  Sector = 'SECTOR',
  /** Site */
  Site = 'SITE'
}

/** Available GeoJSON properties types */
export enum GeojsonPropertiesTypeEnum {
  /** Cluster */
  Cluster = 'CLUSTER',
  /** Line */
  Line = 'LINE',
  /** Point */
  Point = 'POINT',
  /** Polygon */
  Polygon = 'POLYGON'
}

/** History entity */
export type History = {
  __typename?: 'History';
  /** Diff data */
  data: Maybe<HistoryDataUnion>;
  /** History ID */
  id: Scalars['ID']['output'];
  /** Kind of operation */
  kind: HistoryKindEnum;
  /** Metadata */
  metadata: Maybe<HistoryMetadataUnion>;
  /** Occurred at (actual time when a record was created/updated/etc.) */
  occurredAt: Scalars['ISO8601DateTime']['output'];
  /** Indicates if operation was done by the Datizy system */
  system: Maybe<Scalars['Boolean']['output']>;
  /**
   * User entity who made the operation
   * NOTE: if you only need an Object ID, please use the userId field to reduce the load on the database.
   */
  user: Maybe<User>;
  /** User ID who made the operation */
  userId: Maybe<Scalars['ID']['output']>;
};

/** HistoryCollection type */
export type HistoryCollection = {
  __typename?: 'HistoryCollection';
  /** A collection of paginated HistoryCollection */
  collection: Array<History>;
  /** Pagination Metadata for navigating the Pagination */
  metadata: CollectionMetadata;
};

/** History data */
export type HistoryDataUnion = DocumentationHistoryData | InterventionActionHistoryData;

/** Available intervention action history metadata reasons */
export enum HistoryInterventionActionHistoryMetadataReasonEnum {
  /** When intervention was closed */
  InterventionClosed = 'INTERVENTION_CLOSED'
}

/** Available history kinds */
export enum HistoryKindEnum {
  /** Created action */
  Created = 'CREATED',
  /** Updated action */
  Updated = 'UPDATED'
}

/** History metadata */
export type HistoryMetadataUnion = InterventionActionHistoryMetadata;

/** History sorts */
export type HistorySortInputObject = {
  /** Occurred at (actual time when a record was created/updated/etc.) */
  occurredAt?: InputMaybe<SortDirectionEnum>;
};

/** Available source types */
export enum HistorySourceableTypeEnum {
  /** Documentation entity */
  Documentation = 'DOCUMENTATION',
  /** Intervention Action entity */
  InterventionAction = 'INTERVENTION_ACTION'
}

/** Home Page entity */
export type HomePage = TimestampInterface & {
  __typename?: 'HomePage';
  canDestroy: AuthorizationResult;
  canUpdate: AuthorizationResult;
  /** Time when was created */
  createdAt: Scalars['ISO8601DateTime']['output'];
  /** Home Page ID */
  id: Scalars['ID']['output'];
  /** Indicates if Home Page is default */
  isDefault: Scalars['Boolean']['output'];
  /** Name */
  name: Maybe<Scalars['String']['output']>;
  /** Position */
  position: Scalars['Int']['output'];
  /** Last update time */
  updatedAt: Scalars['ISO8601DateTime']['output'];
  /** User ID */
  userId: Maybe<Scalars['ID']['output']>;
};

/** Description from base input object. Please set your description for child object. */
export type HomePageBulkUpdateInput = {
  /** Update attributes */
  attributes: Array<HomePageUpdateInputObject>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** HomePageCollection type */
export type HomePageCollection = {
  __typename?: 'HomePageCollection';
  /** A collection of paginated HomePageCollection */
  collection: Array<HomePage>;
  /** Pagination Metadata for navigating the Pagination */
  metadata: CollectionMetadata;
};

/** Home Page attributes */
export type HomePageUpdateInputObject = {
  /** Destroy home page (if true, home page will be destroyed) */
  _destroy?: InputMaybe<Scalars['Boolean']['input']>;
  /** ID */
  id?: InputMaybe<Scalars['ID']['input']>;
  /** Name */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Position */
  position?: InputMaybe<Scalars['Int']['input']>;
};

/** Industry entity */
export type Industry = TimestampInterface & {
  __typename?: 'Industry';
  /** Color */
  color: ColorEnum;
  /** Companies */
  companies: CompanyCollection;
  /** Number of companies in this industry */
  companiesCount: Scalars['Int']['output'];
  /** Time when was created */
  createdAt: Scalars['ISO8601DateTime']['output'];
  /** Industry ID */
  id: Scalars['ID']['output'];
  /** Name */
  name: Scalars['String']['output'];
  /** Last update time */
  updatedAt: Scalars['ISO8601DateTime']['output'];
};


/** Industry entity */
export type IndustryCompaniesArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
};

/** IndustryCollection type */
export type IndustryCollection = {
  __typename?: 'IndustryCollection';
  /** A collection of paginated IndustryCollection */
  collection: Array<Industry>;
  /** Pagination Metadata for navigating the Pagination */
  metadata: CollectionMetadata;
};

/** Description from base input object. Please set your description for child object. */
export type IndustryCreateInput = {
  /** Create attributes */
  attributes: IndustryCreateInputObject;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Industry attributes */
export type IndustryCreateInputObject = {
  /** Color */
  color: ColorEnum;
  /** Companies attributes array */
  companies?: InputMaybe<Array<LinkingInputObject>>;
  /** Name */
  name: Scalars['String']['input'];
};

/** Description from base input object. Please set your description for child object. */
export type IndustryDestroyInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Industry ID */
  id: Scalars['ID']['input'];
};

/** Industry filters */
export type IndustryFilterInputObject = {
  /** Industry name */
  name?: InputMaybe<FilterInputObject>;
};

/** Industry sorts */
export type IndustrySortInputObject = {
  /** Number of companies in this industry */
  companiesCount?: InputMaybe<SortDirectionEnum>;
  /** Created at */
  createdAt?: InputMaybe<SortDirectionEnum>;
  /** Name */
  name?: InputMaybe<SortDirectionEnum>;
};

/** Description from base input object. Please set your description for child object. */
export type IndustryUpdateInput = {
  /** Update attributes */
  attributes: IndustryUpdateInputObject;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Industry ID */
  id: Scalars['ID']['input'];
};

/** Industry attributes */
export type IndustryUpdateInputObject = {
  /** Color */
  color?: InputMaybe<ColorEnum>;
  /** Companies attributes array */
  companies?: InputMaybe<Array<LinkingInputObject>>;
  /** Name */
  name?: InputMaybe<Scalars['String']['input']>;
};

/** Intervention entity */
export type Intervention = TimestampInterface & {
  __typename?: 'Intervention';
  /**
   * Asset entity
   * NOTE: if you only need an Object ID, please use the assetId field to reduce the load on the database.
   */
  asset: Maybe<Asset>;
  /** Asset ID */
  assetId: Maybe<Scalars['ID']['output']>;
  /** Related Attachments */
  attachmentsAttached: Array<Attachment>;
  canClose: AuthorizationResult;
  canCreate: AuthorizationResult;
  canCreateAction: AuthorizationResult;
  canDestroy: AuthorizationResult;
  canUpdate: AuthorizationResult;
  /**
   * Intervention Category entity
   * NOTE: if you only need an Object ID, please use the categoryId field to reduce the load on the database.
   */
  category: Maybe<InterventionCategory>;
  /** Intervention Category ID */
  categoryId: Maybe<Scalars['ID']['output']>;
  /** Closed date */
  closedAt: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** Code */
  code: Maybe<Scalars['String']['output']>;
  /** Time when was created */
  createdAt: Scalars['ISO8601DateTime']['output'];
  /**
   * User entity
   * NOTE: if you only need an Object ID, please use the createdById field to reduce the load on the database.
   */
  createdBy: Maybe<User>;
  /** User ID */
  createdById: Maybe<Scalars['ID']['output']>;
  /** Description */
  description: Maybe<Scalars['String']['output']>;
  /** Duration time (in minutes) */
  durationTime: Maybe<Scalars['Int']['output']>;
  /** Estimated date */
  estimatedDate: Maybe<Scalars['ISO8601Date']['output']>;
  /** Estimated time (in minutes) */
  estimatedTime: Maybe<Scalars['Int']['output']>;
  /** Intervention ID */
  id: Scalars['ID']['output'];
  /** Logistic time (in minutes) */
  logisticTime: Maybe<Scalars['Int']['output']>;
  /** Name */
  name: Scalars['String']['output'];
  /** Priority */
  priority: InterventionPriorityEnum;
  /**
   * Site entity
   * NOTE: if you only need an Object ID, please use the siteId field to reduce the load on the database.
   */
  site: Maybe<Site>;
  /**
   * Site Area entity
   * NOTE: if you only need an Object ID, please use the siteAreaId field to reduce the load on the database.
   */
  siteArea: Maybe<SiteArea>;
  /** Site Area ID */
  siteAreaId: Maybe<Scalars['ID']['output']>;
  /** Site ID */
  siteId: Maybe<Scalars['ID']['output']>;
  /** Status */
  status: InterventionStatusEnum;
  /**
   * User entity
   * NOTE: if you only need an Object ID, please use the supervisorId field to reduce the load on the database.
   */
  supervisor: Maybe<User>;
  /** User ID */
  supervisorId: Maybe<Scalars['ID']['output']>;
  /**
   * Task entity
   * NOTE: if you only need an Object ID, please use the taskId field to reduce the load on the database.
   */
  task: Maybe<Task>;
  /** Key to group the same tasks which are recurring or have been recurred (if recurring rule was deleted in some point) */
  taskGroupKey: Maybe<Scalars['ID']['output']>;
  /** Task ID */
  taskId: Maybe<Scalars['ID']['output']>;
  /** Total duration time (in minutes) (intervention.duration_time + SUM(intervention_actions.duration_time)) */
  totalDurationTime: Maybe<Scalars['Int']['output']>;
  /** Total estimated time (in minutes) (intervention.estimated_time + SUM(intervention_actions.estimated_time)) */
  totalEstimatedTime: Maybe<Scalars['Int']['output']>;
  /** Total logistic time (in minutes) (intervention.logistic_time + SUM(intervention_actions.logistic_time)) */
  totalLogisticTime: Maybe<Scalars['Int']['output']>;
  /** Total duration time + Total logistic time */
  totalTime: Maybe<Scalars['Int']['output']>;
  /** Last update time */
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

/** Intervention Action entity */
export type InterventionAction = TimestampInterface & {
  __typename?: 'InterventionAction';
  /** Related Attachments */
  attachmentsAttached: Array<Attachment>;
  canDestroy: AuthorizationResult;
  canUpdate: AuthorizationResult;
  /** Closed date */
  closedAt: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** Time when was created */
  createdAt: Scalars['ISO8601DateTime']['output'];
  /**
   * User entity
   * NOTE: if you only need an Object ID, please use the createdById field to reduce the load on the database.
   */
  createdBy: Maybe<User>;
  /** User ID */
  createdById: Maybe<Scalars['ID']['output']>;
  /** Duration time (in minutes) */
  durationTime: Maybe<Scalars['Int']['output']>;
  /** Estimated date */
  estimatedDate: Maybe<Scalars['ISO8601Date']['output']>;
  /** Estimated time (in minutes) */
  estimatedTime: Maybe<Scalars['Int']['output']>;
  /** Intervention Action ID */
  id: Scalars['ID']['output'];
  /** Intervention ID */
  interventionId: Maybe<Scalars['ID']['output']>;
  /** Logistic time (in minutes) */
  logisticTime: Maybe<Scalars['Int']['output']>;
  /** Status */
  status: InterventionActionStatusEnum;
  /** Test */
  text: Maybe<Scalars['String']['output']>;
  /** Last update time */
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

/** InterventionActionCollection type */
export type InterventionActionCollection = {
  __typename?: 'InterventionActionCollection';
  /** A collection of paginated InterventionActionCollection */
  collection: Array<InterventionAction>;
  /** Pagination Metadata for navigating the Pagination */
  metadata: CollectionMetadata;
};

/** Description from base input object. Please set your description for child object. */
export type InterventionActionCreateInput = {
  /**  Link to open the intervention action from notification. Supported variables: `interventionId` and `interventionActionId`. Example: `https://admin.datizy.com/interventions/:interventionId/:interventionActionId`  */
  assigneeRedirectUrl: Scalars['String']['input'];
  /** Create attributes */
  attributes: InterventionActionCreateInputObject;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Create attributes */
  interventionId: Scalars['ID']['input'];
  /**  Link to open the intervention action from notification where user was mentioned. Supported variables: `interventionId` and `interventionActionId`. Example: `https://admin.datizy.com/interventions/:interventionId/:interventionActionId`  */
  mentionRedirectUrl: Scalars['String']['input'];
};

/** Intervention action attributes */
export type InterventionActionCreateInputObject = {
  /** Assignees attributes array */
  assignees?: InputMaybe<Array<LinkingInputObject>>;
  /** Attachments */
  attachmentsAttached?: InputMaybe<Array<AttachmentCuInputObject>>;
  /** Duration time (in minutes) */
  durationTime?: InputMaybe<Scalars['Int']['input']>;
  /** Estimated date */
  estimatedDate?: InputMaybe<Scalars['ISO8601Date']['input']>;
  /** Estimated time (in minutes) */
  estimatedTime?: InputMaybe<Scalars['Int']['input']>;
  /** Logistic time (in minutes) */
  logisticTime?: InputMaybe<Scalars['Int']['input']>;
  /** Status */
  status: InterventionActionStatusEnum;
  /** Text */
  text: Scalars['String']['input'];
  /** Mentions attributes array for text field */
  textMentions?: InputMaybe<Array<LinkingInputObject>>;
};

/** Description from base input object. Please set your description for child object. */
export type InterventionActionDestroyInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Intervention Action ID */
  id: Scalars['ID']['input'];
  /** Intervention ID */
  interventionId: Scalars['ID']['input'];
};

/** Intervention Action filters */
export type InterventionActionFilterInputObject = {
  /** Assignee users */
  assigneeUsersId?: InputMaybe<FilterIdInputObject>;
  /** Created at */
  createdAt?: InputMaybe<FilterDateInputObject>;
  /** Created by user */
  createdById?: InputMaybe<FilterIdInputObject>;
  /** Mentioned users in text field */
  textMentionsUsersId?: InputMaybe<FilterIdInputObject>;
};

/** Intervention Action entity */
export type InterventionActionHistoryData = {
  __typename?: 'InterventionActionHistoryData';
  /** Duration time (in minutes) */
  durationTime: Maybe<Array<Maybe<Scalars['Int']['output']>>>;
  /** Estimated date */
  estimatedDate: Maybe<Array<Maybe<Scalars['ISO8601Date']['output']>>>;
  /** Estimated time (in minutes) */
  estimatedTime: Maybe<Array<Maybe<Scalars['Int']['output']>>>;
  /** Logistic time (in minutes) */
  logisticTime: Maybe<Array<Maybe<Scalars['Int']['output']>>>;
  /** Status */
  status: Maybe<Array<InterventionActionStatusEnum>>;
};

/** Intervention Action History Metadata entity */
export type InterventionActionHistoryMetadata = {
  __typename?: 'InterventionActionHistoryMetadata';
  /** Reason */
  reason: Maybe<HistoryInterventionActionHistoryMetadataReasonEnum>;
};

/** Intervention Action sorts */
export type InterventionActionSortInputObject = {
  /** Created at */
  createdAt?: InputMaybe<SortDirectionEnum>;
};

/** Available intervention action statuses */
export enum InterventionActionStatusEnum {
  ClassifiedSatsContinued = 'CLASSIFIED_SATS_CONTINUED',
  Closed = 'CLOSED',
  InCheck = 'IN_CHECK',
  InProgress = 'IN_PROGRESS',
  MaterialOrdered = 'MATERIAL_ORDERED',
  MaterialReceived = 'MATERIAL_RECEIVED',
  Planned = 'PLANNED'
}

/** Description from base input object. Please set your description for child object. */
export type InterventionActionUpdateInput = {
  /**  Link to open the intervention action from notification. Supported variables: `interventionId` and `interventionActionId`. Example: `https://admin.datizy.com/interventions/:interventionId/:interventionActionId`  */
  assigneeRedirectUrl: Scalars['String']['input'];
  /** Update attributes */
  attributes: InterventionActionUpdateInputObject;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Intervention Action ID */
  id: Scalars['ID']['input'];
  /** Intervention ID */
  interventionId: Scalars['ID']['input'];
  /**  Link to open the intervention action from notification where user was mentioned. Supported variables: `interventionId` and `interventionActionId`. Example: `https://admin.datizy.com/interventions/:interventionId/:interventionActionId`  */
  mentionRedirectUrl: Scalars['String']['input'];
};

/** Intervention action attributes */
export type InterventionActionUpdateInputObject = {
  /** Assignees attributes array */
  assignees?: InputMaybe<Array<LinkingInputObject>>;
  /** Attachments */
  attachmentsAttached?: InputMaybe<Array<AttachmentCuInputObject>>;
  /** Duration time (in minutes) */
  durationTime?: InputMaybe<Scalars['Int']['input']>;
  /** Estimated date */
  estimatedDate?: InputMaybe<Scalars['ISO8601Date']['input']>;
  /** Estimated time (in minutes) */
  estimatedTime?: InputMaybe<Scalars['Int']['input']>;
  /** Logistic time (in minutes) */
  logisticTime?: InputMaybe<Scalars['Int']['input']>;
  /** Status */
  status?: InputMaybe<InterventionActionStatusEnum>;
  /** Text */
  text?: InputMaybe<Scalars['String']['input']>;
  /** Mentions attributes array for text field */
  textMentions?: InputMaybe<Array<LinkingInputObject>>;
};

/** Description from base input object. Please set your description for child object. */
export type InterventionBulkCloseInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Intervention IDs */
  ids: Array<Scalars['ID']['input']>;
};

/** Intervention Category entity */
export type InterventionCategory = TimestampInterface & {
  __typename?: 'InterventionCategory';
  canDestroy: AuthorizationResult;
  /** Color */
  color: ColorEnum;
  /** Time when was created */
  createdAt: Scalars['ISO8601DateTime']['output'];
  /** Description */
  description: Maybe<Scalars['String']['output']>;
  /** Intervention Category ID */
  id: Scalars['ID']['output'];
  /** Intervention collection */
  interventions: InterventionCollection;
  /** Name */
  name: Scalars['String']['output'];
  /** Last update time */
  updatedAt: Scalars['ISO8601DateTime']['output'];
  /** Number of visible Interventions */
  visibleInterventionsCount: Scalars['Int']['output'];
};


/** Intervention Category entity */
export type InterventionCategoryInterventionsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
};

/** InterventionCategoryCollection type */
export type InterventionCategoryCollection = {
  __typename?: 'InterventionCategoryCollection';
  /** A collection of paginated InterventionCategoryCollection */
  collection: Array<InterventionCategory>;
  /** Pagination Metadata for navigating the Pagination */
  metadata: CollectionMetadata;
};

/** Description from base input object. Please set your description for child object. */
export type InterventionCategoryCreateInput = {
  /** Create attributes */
  attributes: InterventionCategoryCreateInputObject;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Intervention Category attributes */
export type InterventionCategoryCreateInputObject = {
  /** Color */
  color: ColorEnum;
  /** Description */
  description?: InputMaybe<Scalars['String']['input']>;
  /** Name */
  name: Scalars['String']['input'];
};

/** Description from base input object. Please set your description for child object. */
export type InterventionCategoryDestroyInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Intervention Category ID */
  id: Scalars['ID']['input'];
};

/** Intervention Category filters */
export type InterventionCategoryFilterInputObject = {
  /** Intervention ID */
  id?: InputMaybe<FilterIdInputObject>;
  /** Intervention Category name */
  name?: InputMaybe<FilterInputObject>;
};

/** Intervention Category sorts */
export type InterventionCategorySortInputObject = {
  /** Created at */
  createdAt?: InputMaybe<SortDirectionEnum>;
  /** Name */
  name?: InputMaybe<SortDirectionEnum>;
  /** Number of visible Interventions in this category */
  visibleInterventionsCount?: InputMaybe<SortDirectionEnum>;
};

/** Description from base input object. Please set your description for child object. */
export type InterventionCategoryUpdateInput = {
  /** Update attributes */
  attributes: InterventionCategoryUpdateInputObject;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Intervention Category ID */
  id: Scalars['ID']['input'];
};

/** Intervention Category attributes */
export type InterventionCategoryUpdateInputObject = {
  /** Color */
  color?: InputMaybe<ColorEnum>;
  /** Description */
  description?: InputMaybe<Scalars['String']['input']>;
  /** Name */
  name?: InputMaybe<Scalars['String']['input']>;
};

/** InterventionCollection type */
export type InterventionCollection = {
  __typename?: 'InterventionCollection';
  /** A collection of paginated InterventionCollection */
  collection: Array<Intervention>;
  /** Pagination Metadata for navigating the Pagination */
  metadata: CollectionMetadata;
};

/** Description from base input object. Please set your description for child object. */
export type InterventionCreateInput = {
  /**  Link to open the intervention from notification. Supported variables: `interventionId`. Example: `https://admin.datizy.com/interventions/:interventionId`  */
  assigneeRedirectUrl: Scalars['String']['input'];
  /** Create attributes */
  attributes: InterventionCreateInputObject;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Intervention attributes */
export type InterventionCreateInputObject = {
  /** Asset ID */
  assetId?: InputMaybe<Scalars['ID']['input']>;
  /** Assignees attributes array */
  assignees?: InputMaybe<Array<LinkingInputObject>>;
  /** Attachments */
  attachmentsAttached?: InputMaybe<Array<AttachmentCuInputObject>>;
  /** Intervention Category ID */
  categoryId: Scalars['ID']['input'];
  /** Code */
  code?: InputMaybe<Scalars['String']['input']>;
  /** Department links */
  departmentLinks?: InputMaybe<Array<LinkingInputObject>>;
  /** Description */
  description: Scalars['String']['input'];
  /** Duration time (in minutes) */
  durationTime?: InputMaybe<Scalars['Int']['input']>;
  /** Estimated date */
  estimatedDate?: InputMaybe<Scalars['ISO8601Date']['input']>;
  /** Estimated time (in minutes) */
  estimatedTime?: InputMaybe<Scalars['Int']['input']>;
  /** Logistic time (in minutes) */
  logisticTime?: InputMaybe<Scalars['Int']['input']>;
  /** Name */
  name: Scalars['String']['input'];
  /** Priority */
  priority: InterventionPriorityEnum;
  /** Site Area ID */
  siteAreaId?: InputMaybe<Scalars['ID']['input']>;
  /** Site ID */
  siteId: Scalars['ID']['input'];
  /** Status */
  status: InterventionStatusEnum;
  /** User ID */
  supervisorId?: InputMaybe<Scalars['ID']['input']>;
  /** Task ID */
  taskId?: InputMaybe<Scalars['ID']['input']>;
};

/** Description from base input object. Please set your description for child object. */
export type InterventionDestroyInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Intervention ID */
  id: Scalars['ID']['input'];
};

/** Intervention filters */
export type InterventionFilterInputObject = {
  /** Asset code */
  assetCode?: InputMaybe<FilterInputObject>;
  /** Asset ID */
  assetId?: InputMaybe<FilterIdInputObject>;
  /** Asset name */
  assetName?: InputMaybe<FilterInputObject>;
  /** Asset QR prefix */
  assetQrPrefix?: InputMaybe<FilterInputObject>;
  /** Assignee users */
  assigneeUsersId?: InputMaybe<FilterIdInputObject>;
  /** Intervention Category ID */
  categoryId?: InputMaybe<FilterIdInputObject>;
  /** Intervention Category name */
  categoryName?: InputMaybe<FilterInputObject>;
  /** Code */
  code?: InputMaybe<FilterInputObject>;
  /** Created at */
  createdAt?: InputMaybe<FilterDateInputObject>;
  /** Created by user */
  createdById?: InputMaybe<FilterIdInputObject>;
  /** Department ID */
  departmentsId?: InputMaybe<FilterIdInputObject>;
  /** Name */
  name?: InputMaybe<FilterInputObject>;
  /** Priority */
  priority?: InputMaybe<FilterIntInputObject>;
  /** Site Area code */
  siteAreaCode?: InputMaybe<FilterInputObject>;
  /** Site Area ID */
  siteAreaId?: InputMaybe<FilterIdInputObject>;
  /** Site Area name */
  siteAreaName?: InputMaybe<FilterInputObject>;
  /** Site code */
  siteCode?: InputMaybe<FilterInputObject>;
  /** Site ID */
  siteId?: InputMaybe<FilterIdInputObject>;
  /** Site name */
  siteName?: InputMaybe<FilterInputObject>;
  /** Status */
  status?: InputMaybe<FilterIntInputObject>;
  /** Task group key */
  taskGroupKey?: InputMaybe<FilterIdInputObject>;
};

/** Available intervention priorities */
export enum InterventionPriorityEnum {
  High = 'HIGH',
  Low = 'LOW',
  Medium = 'MEDIUM'
}

/** Available intervention scope names */
export enum InterventionScopeNameEnum {
  /** All */
  All = 'ALL',
  /** Closed interventions */
  Closed = 'CLOSED',
  /** Opened interventions */
  Opened = 'OPENED',
  /** Opened interventions where user is participant (creator, supervisor, assignee, action creator, action assignee or mentioned in comments) */
  OpenedMyParticipation = 'OPENED_MY_PARTICIPATION'
}

/** Intervention sorts */
export type InterventionSortInputObject = {
  /** Asset name */
  assetName?: InputMaybe<SortDirectionEnum>;
  /** Intervention Category name */
  categoryName?: InputMaybe<SortDirectionEnum>;
  /** Closed at */
  closedAt?: InputMaybe<SortDirectionEnum>;
  /** Code */
  code?: InputMaybe<SortDirectionEnum>;
  /** Created at */
  createdAt?: InputMaybe<SortDirectionEnum>;
  /** Name */
  name?: InputMaybe<SortDirectionEnum>;
  /** Priority */
  priority?: InputMaybe<SortDirectionEnum>;
  /** Site Area name */
  siteAreaName?: InputMaybe<SortDirectionEnum>;
  /** Site name */
  siteName?: InputMaybe<SortDirectionEnum>;
  /** Status */
  status?: InputMaybe<SortDirectionEnum>;
};

/** Available intervention statuses */
export enum InterventionStatusEnum {
  ClassifiedSatsContinued = 'CLASSIFIED_SATS_CONTINUED',
  Closed = 'CLOSED',
  InCheck = 'IN_CHECK',
  InProgress = 'IN_PROGRESS',
  MaterialOrdered = 'MATERIAL_ORDERED',
  MaterialReceived = 'MATERIAL_RECEIVED',
  Planned = 'PLANNED'
}

/** Description from base input object. Please set your description for child object. */
export type InterventionUpdateInput = {
  /**  Link to open the intervention from notification. Supported variables: `interventionId`. Example: `https://admin.datizy.com/interventions/:interventionId`  */
  assigneeRedirectUrl: Scalars['String']['input'];
  /** Update attributes */
  attributes: InterventionUpdateInputObject;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Intervention ID */
  id: Scalars['ID']['input'];
};

/** Intervention attributes */
export type InterventionUpdateInputObject = {
  /** Assignees attributes array */
  assignees?: InputMaybe<Array<LinkingInputObject>>;
  /** Attachments */
  attachmentsAttached?: InputMaybe<Array<AttachmentCuInputObject>>;
  /** Intervention Category ID */
  categoryId?: InputMaybe<Scalars['ID']['input']>;
  /** Code */
  code?: InputMaybe<Scalars['String']['input']>;
  /** Department links */
  departmentLinks?: InputMaybe<Array<LinkingInputObject>>;
  /** Description */
  description?: InputMaybe<Scalars['String']['input']>;
  /** Duration time (in minutes) */
  durationTime?: InputMaybe<Scalars['Int']['input']>;
  /** Estimated date */
  estimatedDate?: InputMaybe<Scalars['ISO8601Date']['input']>;
  /** Estimated time (in minutes) */
  estimatedTime?: InputMaybe<Scalars['Int']['input']>;
  /** Logistic time (in minutes) */
  logisticTime?: InputMaybe<Scalars['Int']['input']>;
  /** Name */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Priority */
  priority?: InputMaybe<InterventionPriorityEnum>;
  /** Status */
  status?: InputMaybe<InterventionStatusEnum>;
  /** User ID */
  supervisorId?: InputMaybe<Scalars['ID']['input']>;
};

/** Available languages */
export enum LanguageEnum {
  /** English */
  En = 'en',
  /** Spanish */
  Es = 'es',
  /** French */
  Fr = 'fr',
  /** Polish */
  Pl = 'pl',
  /** Romanian */
  Ro = 'ro',
  /** Ukrainian */
  Uk = 'uk'
}

/** Linking attributes */
export type LinkingInputObject = {
  /** Entity ID */
  id: Scalars['ID']['input'];
  /** Unlink entity */
  unlink?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Location entity */
export type Location = TimestampInterface & {
  __typename?: 'Location';
  /** Time when was created */
  createdAt: Scalars['ISO8601DateTime']['output'];
  /** GeoJSON */
  geojson: Maybe<GeojsonFeatureCollection>;
  /** Location ID */
  id: Scalars['ID']['output'];
  /** Kind */
  kind: Scalars['String']['output'];
  /** Last update time */
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

/** Location attributes */
export type LocationCuInputObject = {
  /** GeoJSON */
  geojson?: InputMaybe<GeojsonFeatureCollectionInputObject>;
};

/** Location filters */
export type LocationFilterInputObject = {
  /** Location kind (site location => point; sector location => boundary) */
  kind?: InputMaybe<FilterInputObject>;
};

/** Location geographical center entity */
export type LocationGeographicalCenter = {
  __typename?: 'LocationGeographicalCenter';
  /** Latitude */
  lat: Maybe<Scalars['Float']['output']>;
  /** Longitude */
  lon: Maybe<Scalars['Float']['output']>;
};

/** Location Map Params input (current visible area on map) */
export type LocationMapParamsInputObject = {
  /** Maximum latitude */
  maxLat: Scalars['Float']['input'];
  /** Maximum longitude */
  maxLon: Scalars['Float']['input'];
  /** Minimum latitude */
  minLat: Scalars['Float']['input'];
  /** Minimum longitude */
  minLon: Scalars['Float']['input'];
  /** Zoom level */
  zoom: Scalars['Int']['input'];
};

/** List of mutations */
export type Mutation = {
  __typename?: 'Mutation';
  /**
   *
   * ATTENTION: Requires plan upgrade for feature: DOCUMENTATION_MANAGEMENT, AI_ASSISTANCE.
   */
  aiConversationDestroy: Maybe<AiConversation>;
  /**
   *
   * ATTENTION: Requires plan upgrade for feature: DOCUMENTATION_MANAGEMENT, AI_ASSISTANCE.
   */
  aiConversationUpdate: Maybe<AiConversation>;
  /**
   *
   * ATTENTION: Requires plan upgrade for feature: DOCUMENTATION_MANAGEMENT, AI_ASSISTANCE.
   */
  aiDismissDocumentationDetection: Maybe<Documentation>;
  /**
   *
   * ATTENTION: Requires plan upgrade for feature: DOCUMENTATION_MANAGEMENT, AI_ASSISTANCE.
   */
  aiGenerateDocumentationFields: AiFieldGenerationRequest;
  /**
   *
   * ATTENTION: Requires plan upgrade for feature: DOCUMENTATION_MANAGEMENT, AI_ASSISTANCE.
   */
  aiGenerateDocumentationVersionFields: AiFieldGenerationRequest;
  /**
   *
   * ATTENTION: Requires plan upgrade for feature: DOCUMENTATION_MANAGEMENT, AI_ASSISTANCE.
   */
  aiIndexingRetryParked: Maybe<AiIndexingCoverage>;
  /**
   *
   * ATTENTION: Access allowed for system admins.
   */
  aiIndexingRetryParkedForCompany: Maybe<AiIndexingCoverage>;
  /**
   *
   * ATTENTION: Requires plan upgrade for feature: DOCUMENTATION_MANAGEMENT, AI_ASSISTANCE.
   */
  aiMessageFeedbackCreate: Maybe<AiMessage>;
  /**
   *
   * ATTENTION: Requires plan upgrade for feature: DOCUMENTATION_MANAGEMENT, AI_ASSISTANCE.
   */
  aiMessageFeedbackDestroy: Maybe<AiMessage>;
  /**
   *
   * ATTENTION: Requires plan upgrade for feature: DOCUMENTATION_MANAGEMENT, AI_ASSISTANCE.
   */
  aiSendMessage: Maybe<AiConversation>;
  /**
   *
   * ATTENTION: Requires plan upgrade for feature: DOCUMENTATION_MANAGEMENT, AI_ASSISTANCE.
   */
  aiSendMessageStop: Maybe<AiConversation>;
  /** Create an ApiToken */
  apiTokenCreate: Maybe<ApiToken>;
  /** Destroy an ApiToken */
  apiTokenDestroy: Maybe<Scalars['Boolean']['output']>;
  /** Update an ApiToken */
  apiTokenUpdate: Maybe<ApiToken>;
  /** Bulk destroy Assets */
  assetBulkDestroy: Maybe<Scalars['Boolean']['output']>;
  /** Create QR codes for Assets in bulk */
  assetBulkQrCodeCreate: Maybe<BackgroundJob>;
  /** Create an Asset Category */
  assetCategoryCreate: Maybe<AssetCategory>;
  /** Destroy an Asset Category */
  assetCategoryDestroy: Maybe<Scalars['Boolean']['output']>;
  /** Update an Asset Category */
  assetCategoryUpdate: Maybe<AssetCategory>;
  /** Create an Asset */
  assetCreate: Maybe<Asset>;
  /** Update an Asset */
  assetUpdate: Maybe<Asset>;
  /** Confirm email changing by token */
  authenticationConfirmationsEmailConfirmation: Whoami;
  /** Confirm registration by token */
  authenticationConfirmationsRegistrationConfirmation: Whoami;
  /** Resend email confirmation email */
  authenticationConfirmationsResendEmailConfirmation: ResponseMessage;
  /** Resend registration confirmation */
  authenticationConfirmationsResendRegistrationConfirmation: ResponseMessage;
  /** Complete password setup for newly created accounts */
  authenticationPasswordSetup: Scalars['Boolean']['output'];
  /** Send password reset instructions */
  authenticationPasswordsForgot: ResponseMessage;
  /** Reset password by token */
  authenticationPasswordsReset: Whoami;
  /** Change or set password. Requires session older than 24 hours and step-up 2FA verification (30-min window). Users with an existing password must provide password_challenge. SSO users without a password can set one without providing password_challenge. */
  authenticationPasswordsUpdate: Whoami;
  /** Resend account locked email */
  authenticationResendAccountLockedEmail: ResponseMessage;
  /** Resend account locked email to another system admin. Requires session older than 24 hours. */
  authenticationResendAccountLockedEmailForAdmin: Scalars['Boolean']['output'];
  /** Restore a locked account by token from email */
  authenticationRestoreAccount: Whoami;
  /** Create a session (aka Login) */
  authenticationSessionCreate: Whoami;
  /** End current session (aka Logout) */
  authenticationSessionEnd: Maybe<Scalars['Boolean']['output']>;
  /** End all sessions for the current user. Requires session older than 24 hours. */
  authenticationSessionEndAll: Scalars['Boolean']['output'];
  /** End a specific session by ID. Requires session older than 24 hours. */
  authenticationSessionEndSpecific: Scalars['Boolean']['output'];
  /** Report current session as suspicious and end all other sessions. Requires session older than 24 hours and step-up 2FA verification (30-min window). */
  authenticationSessionReportSuspicious: Scalars['Boolean']['output'];
  /** Report session as suspicious by token from email */
  authenticationSessionReportSuspiciousByToken: Scalars['Boolean']['output'];
  /** Disable email-based two-factor authentication method. Requires session older than 24 hours. */
  authenticationTwoFactorDisableEmailOtp: Scalars['Boolean']['output'];
  /** Disable TOTP (authenticator app) two-factor authentication method. Requires session older than 24 hours. */
  authenticationTwoFactorDisableTotp: Scalars['Boolean']['output'];
  /** Enable email-based two-factor authentication by verifying code from email. Requires session older than 24 hours. */
  authenticationTwoFactorEnableEmailOtp: TwoFactorSetupResult;
  /** Enable TOTP by verifying code from authenticator app. Requires session older than 24 hours. */
  authenticationTwoFactorEnableTotp: TwoFactorSetupResult;
  /** Generate new backup codes for two-factor authentication. Requires session older than 24 hours and fresh 2FA verification on every call. */
  authenticationTwoFactorGenerateBackupCodes: TwoFactorBackupCodes;
  /** Resend email OTP code */
  authenticationTwoFactorResendEmailOtp: Scalars['Boolean']['output'];
  /** Reset two-factor authentication for another admin. Requires session older than 24 hours and fresh 2FA verification on every call. */
  authenticationTwoFactorReset: Scalars['Boolean']['output'];
  /** Setup email OTP for two-factor authentication by sending verification code. Requires session older than 24 hours. Fresh 2FA verification required when adding second method. */
  authenticationTwoFactorSetupEmailOtp: Scalars['Boolean']['output'];
  /** Setup TOTP (authenticator app) for two-factor authentication. Requires session older than 24 hours. Fresh 2FA verification required when adding second method. */
  authenticationTwoFactorSetupTotp: TwoFactorTotpSetup;
  /** Verify two-factor authentication code during login */
  authenticationTwoFactorVerify: Whoami;
  /** Cancel a background job (removes a not-yet-running job, or asks a running one to stop) */
  backgroundJobCancel: Maybe<BackgroundJob>;
  /** Close a background job from your list (a view preference; does not affect execution) */
  backgroundJobDismiss: Maybe<BackgroundJob>;
  /** Ask to be emailed the job's result when it finishes (only while still running, and only once) */
  backgroundJobRequestDelivery: Maybe<BackgroundJob>;
  /** Re-run a failed job from its retry/dead set */
  backgroundJobRequeue: Maybe<BackgroundJob>;
  /** Create a Company */
  companyCreate: Maybe<Company>;
  /** Destroy a Company. Requires session older than 24 hours and fresh 2FA verification on every call. */
  companyDestroy: Maybe<Scalars['Boolean']['output']>;
  /** Create a Company Domain */
  companyDomainCreate: Maybe<CompanyDomain>;
  /** Destroy a Company Domain */
  companyDomainDestroy: Maybe<Scalars['Boolean']['output']>;
  /** Verify a Company Domain via DNS TXT record */
  companyDomainVerify: Maybe<CompanyDomain>;
  /** Plan change request */
  companyPlanChangeRequest: Maybe<Scalars['Boolean']['output']>;
  /** Update a Company */
  companyUpdate: Maybe<Company>;
  /** Bulk Destroy Counters */
  counterBulkDestroy: Maybe<Scalars['Boolean']['output']>;
  /** Create QR codes for Counter in bulk */
  counterBulkQrCodeCreate: Maybe<BackgroundJob>;
  /** Create a Counter */
  counterCreate: Maybe<Counter>;
  /** Create a Counter Measure */
  counterMeasureCreate: Maybe<CounterMeasure>;
  /** Reset to zero a Counter */
  counterResetToZero: Maybe<Counter>;
  /** Update a Counter */
  counterUpdate: Maybe<Counter>;
  /** Create a Data Import */
  dataImportCreate: Maybe<DataImport>;
  /** Destroy a Data Import */
  dataImportDestroy: Maybe<Scalars['Boolean']['output']>;
  /** Update a Data Import */
  dataImportUpdate: Maybe<DataImport>;
  /** Department creation */
  departmentCreate: Maybe<Department>;
  /** Department destroy */
  departmentDestroy: Maybe<Scalars['Boolean']['output']>;
  /** Department update */
  departmentUpdate: Maybe<Department>;
  /**
   *
   * ATTENTION: Requires plan upgrade for feature: DOCUMENTATION_MANAGEMENT.
   */
  documentRenewalReminderTemplateUpdate: Maybe<DocumentRenewalReminderTemplate>;
  /** Bulk Destroy Documentations */
  documentationBulkDestroy: Maybe<Scalars['Boolean']['output']>;
  /**
   *
   * ATTENTION: Requires plan upgrade for feature: DOCUMENTATION_MANAGEMENT.
   */
  documentationBulkEdit: Maybe<Scalars['Boolean']['output']>;
  /**
   *
   * ATTENTION: Requires plan upgrade for feature: DOCUMENTATION_MANAGEMENT.
   */
  documentationBulkFavorite: Maybe<Scalars['Boolean']['output']>;
  /**
   *
   * ATTENTION: Requires plan upgrade for feature: DOCUMENTATION_MANAGEMENT.
   */
  documentationBulkUnfavorite: Maybe<Scalars['Boolean']['output']>;
  /**
   *
   * ATTENTION: Requires plan upgrade for feature: DOCUMENTATION_MANAGEMENT.
   */
  documentationBulkUpdateValidationStatus: Maybe<Scalars['Boolean']['output']>;
  /**
   *
   * ATTENTION: Requires plan upgrade for feature: DOCUMENTATION_MANAGEMENT.
   */
  documentationCategoryCreate: Maybe<DocumentationCategory>;
  /**
   *
   * ATTENTION: Requires plan upgrade for feature: DOCUMENTATION_MANAGEMENT.
   */
  documentationCategoryDestroy: Maybe<Scalars['Boolean']['output']>;
  /**
   *
   * ATTENTION: Requires plan upgrade for feature: DOCUMENTATION_MANAGEMENT.
   */
  documentationCategoryUpdate: Maybe<DocumentationCategory>;
  /** Create a Documentation */
  documentationCreate: Maybe<Documentation>;
  /**
   *
   * ATTENTION: Requires plan upgrade for feature: DOCUMENTATION_MANAGEMENT.
   */
  documentationImportCreate: Maybe<DocumentationImport>;
  /**
   *
   * ATTENTION: Requires plan upgrade for feature: DOCUMENTATION_MANAGEMENT.
   */
  documentationImportDestroy: Maybe<Scalars['Boolean']['output']>;
  /**
   *
   * ATTENTION: Requires plan upgrade for feature: DOCUMENTATION_MANAGEMENT.
   */
  documentationImportFtpPreview: Maybe<DocumentationImportFtpPreviewResult>;
  /**
   *
   * ATTENTION: Requires plan upgrade for feature: DOCUMENTATION_MANAGEMENT.
   */
  documentationSkipRenewal: Maybe<Documentation>;
  /** Update a Documentation */
  documentationUpdate: Maybe<Documentation>;
  /** Create a new Documentation Version */
  documentationVersionCreate: Maybe<DocumentationVersion>;
  /**
   *
   * ATTENTION: Requires plan upgrade for feature: DOCUMENTATION_MANAGEMENT.
   */
  documentationVersionMarkAsRead: Maybe<Documentation>;
  /**
   *
   * ATTENTION: Requires plan upgrade for feature: DOCUMENTATION_MANAGEMENT.
   */
  documentationVersionMarkAsUnread: Maybe<Documentation>;
  /**
   *
   * ATTENTION: Requires plan upgrade for feature: DOCUMENTATION_MANAGEMENT.
   */
  documentationVersionViewCreate: Maybe<DocumentationVersionView>;
  /**
   *
   * ATTENTION: Requires plan upgrade for feature: DOCUMENTATION_MANAGEMENT.
   */
  documentationVersionViewIncrement: Maybe<DocumentationVersionView>;
  /** Create a fake DNS record (non-production only) */
  fakeDnsRecordCreate: Maybe<FakeDnsRecord>;
  /** Destroy a fake DNS record (non-production only) */
  fakeDnsRecordDestroy: Maybe<Scalars['Boolean']['output']>;
  /** Update a fake DNS record (non-production only) */
  fakeDnsRecordUpdate: Maybe<FakeDnsRecord>;
  /** Create a Frontend Filter Preset */
  feFilterPresetCreate: Maybe<FeFilterPreset>;
  /** Destroy a Frontend Filter Preset */
  feFilterPresetDestroy: Maybe<Scalars['Boolean']['output']>;
  /** Update a Frontend Filter Preset */
  feFilterPresetUpdate: Maybe<FeFilterPreset>;
  /** Create a Form Category */
  formCategoryCreate: Maybe<FormCategory>;
  /** Destroy a Form Category */
  formCategoryDestroy: Maybe<Scalars['Boolean']['output']>;
  /** Update a Form Category */
  formCategoryUpdate: Maybe<FormCategory>;
  /** Create a Form Checklist Template */
  formChecklistTemplateCreate: Maybe<FormChecklistTemplate>;
  /** Destroy a Form Checklist Template */
  formChecklistTemplateDestroy: Maybe<Scalars['Boolean']['output']>;
  /** Update a Form Checklist Template */
  formChecklistTemplateUpdate: Maybe<FormChecklistTemplate>;
  /** Bulk archive Form Templates */
  formTemplateBulkArchive: Maybe<Scalars['Boolean']['output']>;
  /** Bulk destroy Form Templates */
  formTemplateBulkDestroy: Maybe<Scalars['Boolean']['output']>;
  /** Bulk restore Form Templates */
  formTemplateBulkRestore: Maybe<Scalars['Boolean']['output']>;
  /** Create a Form Template */
  formTemplateCreate: Maybe<FormTemplate>;
  /** Unlink every documentation associated with a Form Template (template-level links only; per-question option documents are not touched) */
  formTemplateUnlinkAllDocumentations: Maybe<Scalars['Boolean']['output']>;
  /** Update a Form Template */
  formTemplateUpdate: Maybe<FormTemplate>;
  /** Archive a Form Template Version */
  formTemplateVersionArchive: Maybe<FormTemplateVersion>;
  /** Create a Form Template Version */
  formTemplateVersionCreate: Maybe<FormTemplateVersion>;
  /** Destroy a Form Template Version */
  formTemplateVersionDestroy: Maybe<Scalars['Boolean']['output']>;
  /** Restore a Form Template Version */
  formTemplateVersionRestore: Maybe<FormTemplateVersion>;
  /** Update a Form Template Version */
  formTemplateVersionUpdate: Maybe<FormTemplateVersion>;
  /** Bulk update Home Pages */
  homePageBulkUpdate: Maybe<Scalars['Boolean']['output']>;
  /** Create an Industry */
  industryCreate: Maybe<Industry>;
  /** Destroy an Industry */
  industryDestroy: Maybe<Scalars['Boolean']['output']>;
  /** Update an Industry */
  industryUpdate: Maybe<Industry>;
  /** Create an Intervention Action */
  interventionActionCreate: Maybe<InterventionAction>;
  /** Destroy an Intervention Action */
  interventionActionDestroy: Maybe<Scalars['Boolean']['output']>;
  /** Update an Intervention Action */
  interventionActionUpdate: Maybe<InterventionAction>;
  /** Bulk close Interventions */
  interventionBulkClose: Maybe<Scalars['Boolean']['output']>;
  /** Create an Intervention Category */
  interventionCategoryCreate: Maybe<InterventionCategory>;
  /** Destroy an Intervention Category */
  interventionCategoryDestroy: Maybe<Scalars['Boolean']['output']>;
  /** Update an Intervention Category */
  interventionCategoryUpdate: Maybe<InterventionCategory>;
  /** Create an Intervention */
  interventionCreate: Maybe<Intervention>;
  /** Destroy an Intervention */
  interventionDestroy: Maybe<Scalars['Boolean']['output']>;
  /** Update an Intervention */
  interventionUpdate: Maybe<Intervention>;
  /** Bulk Destroy Nomenclatures */
  nomenclatureBulkDestroy: Maybe<Scalars['Boolean']['output']>;
  /** Create QR codes for component assets of Nomenclatures in bulk */
  nomenclatureBulkQrCodeCreate: Maybe<BackgroundJob>;
  /** Create a Nomenclature */
  nomenclatureCreate: Maybe<Nomenclature>;
  /** Update a Nomenclature */
  nomenclatureUpdate: Maybe<Nomenclature>;
  /** Create a Sector */
  sectorCreate: Maybe<Sector>;
  /** Destroy a Sector */
  sectorDestroy: Maybe<Scalars['Boolean']['output']>;
  /** Update a Sector */
  sectorUpdate: Maybe<Sector>;
  /** Destroy Site Areas in bulk. Site Areas that cannot be deleted are skipped and returned in the result instead of failing the whole call */
  siteAreaBulkDestroy: Maybe<SiteAreaBulkDestroyResult>;
  /** Create QR codes for Site Areas in bulk */
  siteAreaBulkQrCodeCreate: Maybe<BackgroundJob>;
  /** Update a Site Area */
  siteAreaUpdate: Maybe<SiteArea>;
  /** Create a Site */
  siteCreate: Maybe<Site>;
  /** Destroy a Site */
  siteDestroy: Maybe<Scalars['Boolean']['output']>;
  /** Update a Site */
  siteUpdate: Maybe<Site>;
  /** Activate an SSO integration */
  ssoIntegrationActivate: Maybe<SsoIntegration>;
  /** Create an SSO integration */
  ssoIntegrationCreate: Maybe<SsoIntegration>;
  /** Deactivate an SSO integration */
  ssoIntegrationDeactivate: Maybe<SsoIntegration>;
  /** Destroy an SSO integration */
  ssoIntegrationDestroy: Maybe<Scalars['Boolean']['output']>;
  /** Update an SSO integration */
  ssoIntegrationUpdate: Maybe<SsoIntegration>;
  /** Create a System Admin */
  systemAdminCreate: Maybe<SystemAdmin>;
  /** Destroy a System Admin. Requires session older than 24 hours. */
  systemAdminDestroy: Maybe<Scalars['Boolean']['output']>;
  /** Update self System Admin. When changing email, requires session older than 24 hours and step-up 2FA verification (30-min window). */
  systemAdminSelfUpdate: Maybe<SystemAdmin>;
  /** Update a System Admin by other System Admin */
  systemAdminUpdate: Maybe<SystemAdmin>;
  /** Create a User by System Admin */
  systemAdminUserCreate: Maybe<User>;
  /** Create a Tag */
  tagCreate: Maybe<Tag>;
  /** Destroy a Tag */
  tagDestroy: Maybe<Scalars['Boolean']['output']>;
  /** Create same Tasks in bulk */
  taskBulkCreateSame: Maybe<Array<Scalars['ID']['output']>>;
  /** Bulk update a Task's Deadline Missed Reason */
  taskBulkDeadlineMissedReasonUpdate: Maybe<Scalars['Boolean']['output']>;
  /** Bulk schedule Tasks */
  taskBulkScheduling: Maybe<Scalars['Boolean']['output']>;
  /** Bulk update a Task's Template Version */
  taskBulkTemplateVersionUpdate: Maybe<Scalars['Boolean']['output']>;
  /** Update Tasks status */
  taskBulkUpdateStatus: Maybe<Scalars['Boolean']['output']>;
  /** Create a Task Completion */
  taskCompletionCreate: Maybe<TaskCompletion>;
  /** Update a Task's Completion status */
  taskCompletionStatusUpdate: Maybe<TaskCompletion>;
  /** Destroy a Task */
  taskDestroy: Maybe<Scalars['Boolean']['output']>;
  /** Generate a Tasks Timeline Report */
  taskTimelineReportCreate: Maybe<BackgroundJob>;
  /** Unlink every documentation associated with the tasks of a given recurring group_key */
  taskUnlinkAllDocumentations: Maybe<Scalars['Boolean']['output']>;
  /** Update a Task */
  taskUpdate: Maybe<Task>;
  /** Team creation */
  teamCreate: Maybe<Team>;
  /** Team destroy */
  teamDestroy: Maybe<Scalars['Boolean']['output']>;
  /** Team update */
  teamUpdate: Maybe<Team>;
  /** Create a Technical Pause. Requires fresh 2FA verification on every call. */
  technicalPauseCreate: Maybe<TechnicalPause>;
  /** Destroy a Technical Pause. Requires fresh 2FA verification on every call. */
  technicalPauseDestroy: Maybe<Scalars['Boolean']['output']>;
  /** Update a Technical Pause. Requires fresh 2FA verification on every call. */
  technicalPauseUpdate: Maybe<TechnicalPause>;
  /** Activate Users in bulk */
  userBulkActivate: Maybe<Scalars['Boolean']['output']>;
  /** Deactivate Users in bulk */
  userBulkDeactivate: Maybe<Scalars['Boolean']['output']>;
  /** Accept the Code of Conduct */
  userCodeOfConductAccept: Maybe<User>;
  /** Create a User */
  userCreate: Maybe<User>;
  /** Destroy a User */
  userDestroy: Maybe<Scalars['Boolean']['output']>;
  /** Update self User */
  userSelfUpdate: Maybe<User>;
  /** Update a User by other Full Admin/Admin */
  userUpdate: Maybe<User>;
  /** Bulk update Widgets for a Home Page */
  widgetBulkUpdate: Maybe<Scalars['Boolean']['output']>;
  /** Create a new Widget Template (only announcement and external_link kinds) */
  widgetTemplateCreate: Maybe<WidgetTemplate>;
  /** Delete a Widget Template (deletes all associated widgets for external_link kind) */
  widgetTemplateDestroy: Maybe<Scalars['Boolean']['output']>;
  /** Update an existing Widget Template */
  widgetTemplateUpdate: Maybe<WidgetTemplate>;
};


/** List of mutations */
export type MutationAiConversationDestroyArgs = {
  input: AiConversationDestroyInput;
};


/** List of mutations */
export type MutationAiConversationUpdateArgs = {
  input: AiConversationUpdateInput;
};


/** List of mutations */
export type MutationAiDismissDocumentationDetectionArgs = {
  input: AiDismissDocumentationDetectionInput;
};


/** List of mutations */
export type MutationAiGenerateDocumentationFieldsArgs = {
  input: AiGenerateDocumentationFieldsInput;
};


/** List of mutations */
export type MutationAiGenerateDocumentationVersionFieldsArgs = {
  input: AiGenerateDocumentationVersionFieldsInput;
};


/** List of mutations */
export type MutationAiIndexingRetryParkedArgs = {
  input: AiIndexingRetryParkedInput;
};


/** List of mutations */
export type MutationAiIndexingRetryParkedForCompanyArgs = {
  input: AiIndexingRetryParkedForCompanyInput;
};


/** List of mutations */
export type MutationAiMessageFeedbackCreateArgs = {
  input: AiMessageFeedbackCreateInput;
};


/** List of mutations */
export type MutationAiMessageFeedbackDestroyArgs = {
  input: AiMessageFeedbackDestroyInput;
};


/** List of mutations */
export type MutationAiSendMessageArgs = {
  input: AiSendMessageInput;
};


/** List of mutations */
export type MutationAiSendMessageStopArgs = {
  input: AiSendMessageStopInput;
};


/** List of mutations */
export type MutationApiTokenCreateArgs = {
  input: ApiTokenCreateInput;
};


/** List of mutations */
export type MutationApiTokenDestroyArgs = {
  input: ApiTokenDestroyInput;
};


/** List of mutations */
export type MutationApiTokenUpdateArgs = {
  input: ApiTokenUpdateInput;
};


/** List of mutations */
export type MutationAssetBulkDestroyArgs = {
  input: AssetBulkDestroyInput;
};


/** List of mutations */
export type MutationAssetBulkQrCodeCreateArgs = {
  input: AssetBulkQrCodeCreateInput;
};


/** List of mutations */
export type MutationAssetCategoryCreateArgs = {
  input: AssetCategoryCreateInput;
};


/** List of mutations */
export type MutationAssetCategoryDestroyArgs = {
  input: AssetCategoryDestroyInput;
};


/** List of mutations */
export type MutationAssetCategoryUpdateArgs = {
  input: AssetCategoryUpdateInput;
};


/** List of mutations */
export type MutationAssetCreateArgs = {
  input: AssetCreateInput;
};


/** List of mutations */
export type MutationAssetUpdateArgs = {
  input: AssetUpdateInput;
};


/** List of mutations */
export type MutationAuthenticationConfirmationsEmailConfirmationArgs = {
  input: AuthenticationConfirmationsEmailConfirmationInput;
};


/** List of mutations */
export type MutationAuthenticationConfirmationsRegistrationConfirmationArgs = {
  input: AuthenticationConfirmationsRegistrationConfirmationInput;
};


/** List of mutations */
export type MutationAuthenticationConfirmationsResendEmailConfirmationArgs = {
  input: AuthenticationConfirmationsResendEmailConfirmationInput;
};


/** List of mutations */
export type MutationAuthenticationConfirmationsResendRegistrationConfirmationArgs = {
  input: AuthenticationConfirmationsResendRegistrationConfirmationInput;
};


/** List of mutations */
export type MutationAuthenticationPasswordSetupArgs = {
  input: AuthenticationPasswordSetupInput;
};


/** List of mutations */
export type MutationAuthenticationPasswordsForgotArgs = {
  input: AuthenticationPasswordsForgotInput;
};


/** List of mutations */
export type MutationAuthenticationPasswordsResetArgs = {
  input: AuthenticationPasswordsResetInput;
};


/** List of mutations */
export type MutationAuthenticationPasswordsUpdateArgs = {
  input: AuthenticationPasswordsUpdateInput;
};


/** List of mutations */
export type MutationAuthenticationResendAccountLockedEmailArgs = {
  input: AuthenticationResendAccountLockedEmailInput;
};


/** List of mutations */
export type MutationAuthenticationResendAccountLockedEmailForAdminArgs = {
  input: AuthenticationResendAccountLockedEmailForAdminInput;
};


/** List of mutations */
export type MutationAuthenticationRestoreAccountArgs = {
  input: AuthenticationRestoreAccountInput;
};


/** List of mutations */
export type MutationAuthenticationSessionCreateArgs = {
  input: AuthenticationSessionCreateInput;
};


/** List of mutations */
export type MutationAuthenticationSessionEndArgs = {
  input: AuthenticationSessionEndInput;
};


/** List of mutations */
export type MutationAuthenticationSessionEndAllArgs = {
  input: AuthenticationSessionEndAllInput;
};


/** List of mutations */
export type MutationAuthenticationSessionEndSpecificArgs = {
  input: AuthenticationSessionEndSpecificInput;
};


/** List of mutations */
export type MutationAuthenticationSessionReportSuspiciousArgs = {
  input: AuthenticationSessionReportSuspiciousInput;
};


/** List of mutations */
export type MutationAuthenticationSessionReportSuspiciousByTokenArgs = {
  input: AuthenticationSessionReportSuspiciousByTokenInput;
};


/** List of mutations */
export type MutationAuthenticationTwoFactorDisableEmailOtpArgs = {
  input: AuthenticationTwoFactorDisableEmailOtpInput;
};


/** List of mutations */
export type MutationAuthenticationTwoFactorDisableTotpArgs = {
  input: AuthenticationTwoFactorDisableTotpInput;
};


/** List of mutations */
export type MutationAuthenticationTwoFactorEnableEmailOtpArgs = {
  input: AuthenticationTwoFactorEnableEmailOtpInput;
};


/** List of mutations */
export type MutationAuthenticationTwoFactorEnableTotpArgs = {
  input: AuthenticationTwoFactorEnableTotpInput;
};


/** List of mutations */
export type MutationAuthenticationTwoFactorGenerateBackupCodesArgs = {
  input: AuthenticationTwoFactorGenerateBackupCodesInput;
};


/** List of mutations */
export type MutationAuthenticationTwoFactorResendEmailOtpArgs = {
  input: AuthenticationTwoFactorResendEmailOtpInput;
};


/** List of mutations */
export type MutationAuthenticationTwoFactorResetArgs = {
  input: AuthenticationTwoFactorResetInput;
};


/** List of mutations */
export type MutationAuthenticationTwoFactorSetupEmailOtpArgs = {
  input: AuthenticationTwoFactorSetupEmailOtpInput;
};


/** List of mutations */
export type MutationAuthenticationTwoFactorSetupTotpArgs = {
  input: AuthenticationTwoFactorSetupTotpInput;
};


/** List of mutations */
export type MutationAuthenticationTwoFactorVerifyArgs = {
  input: AuthenticationTwoFactorVerifyInput;
};


/** List of mutations */
export type MutationBackgroundJobCancelArgs = {
  input: BackgroundJobCancelInput;
};


/** List of mutations */
export type MutationBackgroundJobDismissArgs = {
  input: BackgroundJobDismissInput;
};


/** List of mutations */
export type MutationBackgroundJobRequestDeliveryArgs = {
  input: BackgroundJobRequestDeliveryInput;
};


/** List of mutations */
export type MutationBackgroundJobRequeueArgs = {
  input: BackgroundJobRequeueInput;
};


/** List of mutations */
export type MutationCompanyCreateArgs = {
  input: CompanyCreateInput;
};


/** List of mutations */
export type MutationCompanyDestroyArgs = {
  input: CompanyDestroyInput;
};


/** List of mutations */
export type MutationCompanyDomainCreateArgs = {
  input: CompanyDomainCreateInput;
};


/** List of mutations */
export type MutationCompanyDomainDestroyArgs = {
  input: CompanyDomainDestroyInput;
};


/** List of mutations */
export type MutationCompanyDomainVerifyArgs = {
  input: CompanyDomainVerifyInput;
};


/** List of mutations */
export type MutationCompanyPlanChangeRequestArgs = {
  input: CompanyPlanChangeRequestInput;
};


/** List of mutations */
export type MutationCompanyUpdateArgs = {
  input: CompanyUpdateInput;
};


/** List of mutations */
export type MutationCounterBulkDestroyArgs = {
  input: CounterBulkDestroyInput;
};


/** List of mutations */
export type MutationCounterBulkQrCodeCreateArgs = {
  input: CounterBulkQrCodeCreateInput;
};


/** List of mutations */
export type MutationCounterCreateArgs = {
  input: CounterCreateInput;
};


/** List of mutations */
export type MutationCounterMeasureCreateArgs = {
  input: CounterMeasureCreateInput;
};


/** List of mutations */
export type MutationCounterResetToZeroArgs = {
  input: CounterResetToZeroInput;
};


/** List of mutations */
export type MutationCounterUpdateArgs = {
  input: CounterUpdateInput;
};


/** List of mutations */
export type MutationDataImportCreateArgs = {
  input: DataImportCreateInput;
};


/** List of mutations */
export type MutationDataImportDestroyArgs = {
  input: DataImportDestroyInput;
};


/** List of mutations */
export type MutationDataImportUpdateArgs = {
  input: DataImportUpdateInput;
};


/** List of mutations */
export type MutationDepartmentCreateArgs = {
  input: DepartmentCreateInput;
};


/** List of mutations */
export type MutationDepartmentDestroyArgs = {
  input: DepartmentDestroyInput;
};


/** List of mutations */
export type MutationDepartmentUpdateArgs = {
  input: DepartmentUpdateInput;
};


/** List of mutations */
export type MutationDocumentRenewalReminderTemplateUpdateArgs = {
  input: DocumentRenewalReminderTemplateUpdateInput;
};


/** List of mutations */
export type MutationDocumentationBulkDestroyArgs = {
  input: DocumentationBulkDestroyInput;
};


/** List of mutations */
export type MutationDocumentationBulkEditArgs = {
  input: DocumentationBulkEditInput;
};


/** List of mutations */
export type MutationDocumentationBulkFavoriteArgs = {
  input: DocumentationBulkFavoriteInput;
};


/** List of mutations */
export type MutationDocumentationBulkUnfavoriteArgs = {
  input: DocumentationBulkUnfavoriteInput;
};


/** List of mutations */
export type MutationDocumentationBulkUpdateValidationStatusArgs = {
  input: DocumentationBulkUpdateValidationStatusInput;
};


/** List of mutations */
export type MutationDocumentationCategoryCreateArgs = {
  input: DocumentationCategoryCreateInput;
};


/** List of mutations */
export type MutationDocumentationCategoryDestroyArgs = {
  input: DocumentationCategoryDestroyInput;
};


/** List of mutations */
export type MutationDocumentationCategoryUpdateArgs = {
  input: DocumentationCategoryUpdateInput;
};


/** List of mutations */
export type MutationDocumentationCreateArgs = {
  input: DocumentationCreateInput;
};


/** List of mutations */
export type MutationDocumentationImportCreateArgs = {
  input: DocumentationImportCreateInput;
};


/** List of mutations */
export type MutationDocumentationImportDestroyArgs = {
  input: DocumentationImportDestroyInput;
};


/** List of mutations */
export type MutationDocumentationImportFtpPreviewArgs = {
  input: DocumentationImportFtpPreviewInput;
};


/** List of mutations */
export type MutationDocumentationSkipRenewalArgs = {
  input: DocumentationSkipRenewalInput;
};


/** List of mutations */
export type MutationDocumentationUpdateArgs = {
  input: DocumentationUpdateInput;
};


/** List of mutations */
export type MutationDocumentationVersionCreateArgs = {
  input: DocumentationVersionCreateInput;
};


/** List of mutations */
export type MutationDocumentationVersionMarkAsReadArgs = {
  input: DocumentationVersionMarkAsReadInput;
};


/** List of mutations */
export type MutationDocumentationVersionMarkAsUnreadArgs = {
  input: DocumentationVersionMarkAsUnreadInput;
};


/** List of mutations */
export type MutationDocumentationVersionViewCreateArgs = {
  input: DocumentationVersionViewCreateInput;
};


/** List of mutations */
export type MutationDocumentationVersionViewIncrementArgs = {
  input: DocumentationVersionViewIncrementInput;
};


/** List of mutations */
export type MutationFakeDnsRecordCreateArgs = {
  input: FakeDnsRecordCreateInput;
};


/** List of mutations */
export type MutationFakeDnsRecordDestroyArgs = {
  input: FakeDnsRecordDestroyInput;
};


/** List of mutations */
export type MutationFakeDnsRecordUpdateArgs = {
  input: FakeDnsRecordUpdateInput;
};


/** List of mutations */
export type MutationFeFilterPresetCreateArgs = {
  input: FeFilterPresetCreateInput;
};


/** List of mutations */
export type MutationFeFilterPresetDestroyArgs = {
  input: FeFilterPresetDestroyInput;
};


/** List of mutations */
export type MutationFeFilterPresetUpdateArgs = {
  input: FeFilterPresetUpdateInput;
};


/** List of mutations */
export type MutationFormCategoryCreateArgs = {
  input: FormCategoryCreateInput;
};


/** List of mutations */
export type MutationFormCategoryDestroyArgs = {
  input: FormCategoryDestroyInput;
};


/** List of mutations */
export type MutationFormCategoryUpdateArgs = {
  input: FormCategoryUpdateInput;
};


/** List of mutations */
export type MutationFormChecklistTemplateCreateArgs = {
  input: FormChecklistTemplateCreateInput;
};


/** List of mutations */
export type MutationFormChecklistTemplateDestroyArgs = {
  input: FormChecklistTemplateDestroyInput;
};


/** List of mutations */
export type MutationFormChecklistTemplateUpdateArgs = {
  input: FormChecklistTemplateUpdateInput;
};


/** List of mutations */
export type MutationFormTemplateBulkArchiveArgs = {
  input: FormTemplateBulkArchiveInput;
};


/** List of mutations */
export type MutationFormTemplateBulkDestroyArgs = {
  input: FormTemplateBulkDestroyInput;
};


/** List of mutations */
export type MutationFormTemplateBulkRestoreArgs = {
  input: FormTemplateBulkRestoreInput;
};


/** List of mutations */
export type MutationFormTemplateCreateArgs = {
  input: FormTemplateCreateInput;
};


/** List of mutations */
export type MutationFormTemplateUnlinkAllDocumentationsArgs = {
  input: FormTemplateUnlinkAllDocumentationsInput;
};


/** List of mutations */
export type MutationFormTemplateUpdateArgs = {
  input: FormTemplateUpdateInput;
};


/** List of mutations */
export type MutationFormTemplateVersionArchiveArgs = {
  input: FormTemplateVersionArchiveInput;
};


/** List of mutations */
export type MutationFormTemplateVersionCreateArgs = {
  input: FormTemplateVersionCreateInput;
};


/** List of mutations */
export type MutationFormTemplateVersionDestroyArgs = {
  input: FormTemplateVersionDestroyInput;
};


/** List of mutations */
export type MutationFormTemplateVersionRestoreArgs = {
  input: FormTemplateVersionRestoreInput;
};


/** List of mutations */
export type MutationFormTemplateVersionUpdateArgs = {
  input: FormTemplateVersionUpdateInput;
};


/** List of mutations */
export type MutationHomePageBulkUpdateArgs = {
  input: HomePageBulkUpdateInput;
};


/** List of mutations */
export type MutationIndustryCreateArgs = {
  input: IndustryCreateInput;
};


/** List of mutations */
export type MutationIndustryDestroyArgs = {
  input: IndustryDestroyInput;
};


/** List of mutations */
export type MutationIndustryUpdateArgs = {
  input: IndustryUpdateInput;
};


/** List of mutations */
export type MutationInterventionActionCreateArgs = {
  input: InterventionActionCreateInput;
};


/** List of mutations */
export type MutationInterventionActionDestroyArgs = {
  input: InterventionActionDestroyInput;
};


/** List of mutations */
export type MutationInterventionActionUpdateArgs = {
  input: InterventionActionUpdateInput;
};


/** List of mutations */
export type MutationInterventionBulkCloseArgs = {
  input: InterventionBulkCloseInput;
};


/** List of mutations */
export type MutationInterventionCategoryCreateArgs = {
  input: InterventionCategoryCreateInput;
};


/** List of mutations */
export type MutationInterventionCategoryDestroyArgs = {
  input: InterventionCategoryDestroyInput;
};


/** List of mutations */
export type MutationInterventionCategoryUpdateArgs = {
  input: InterventionCategoryUpdateInput;
};


/** List of mutations */
export type MutationInterventionCreateArgs = {
  input: InterventionCreateInput;
};


/** List of mutations */
export type MutationInterventionDestroyArgs = {
  input: InterventionDestroyInput;
};


/** List of mutations */
export type MutationInterventionUpdateArgs = {
  input: InterventionUpdateInput;
};


/** List of mutations */
export type MutationNomenclatureBulkDestroyArgs = {
  input: NomenclatureBulkDestroyInput;
};


/** List of mutations */
export type MutationNomenclatureBulkQrCodeCreateArgs = {
  input: NomenclatureBulkQrCodeCreateInput;
};


/** List of mutations */
export type MutationNomenclatureCreateArgs = {
  input: NomenclatureCreateInput;
};


/** List of mutations */
export type MutationNomenclatureUpdateArgs = {
  input: NomenclatureUpdateInput;
};


/** List of mutations */
export type MutationSectorCreateArgs = {
  input: SectorCreateInput;
};


/** List of mutations */
export type MutationSectorDestroyArgs = {
  input: SectorDestroyInput;
};


/** List of mutations */
export type MutationSectorUpdateArgs = {
  input: SectorUpdateInput;
};


/** List of mutations */
export type MutationSiteAreaBulkDestroyArgs = {
  input: SiteAreaBulkDestroyInput;
};


/** List of mutations */
export type MutationSiteAreaBulkQrCodeCreateArgs = {
  input: SiteAreaBulkQrCodeCreateInput;
};


/** List of mutations */
export type MutationSiteAreaUpdateArgs = {
  input: SiteAreaUpdateInput;
};


/** List of mutations */
export type MutationSiteCreateArgs = {
  input: SiteCreateInput;
};


/** List of mutations */
export type MutationSiteDestroyArgs = {
  input: SiteDestroyInput;
};


/** List of mutations */
export type MutationSiteUpdateArgs = {
  input: SiteUpdateInput;
};


/** List of mutations */
export type MutationSsoIntegrationActivateArgs = {
  input: SsoIntegrationActivateInput;
};


/** List of mutations */
export type MutationSsoIntegrationCreateArgs = {
  input: SsoIntegrationCreateInput;
};


/** List of mutations */
export type MutationSsoIntegrationDeactivateArgs = {
  input: SsoIntegrationDeactivateInput;
};


/** List of mutations */
export type MutationSsoIntegrationDestroyArgs = {
  input: SsoIntegrationDestroyInput;
};


/** List of mutations */
export type MutationSsoIntegrationUpdateArgs = {
  input: SsoIntegrationUpdateInput;
};


/** List of mutations */
export type MutationSystemAdminCreateArgs = {
  input: SystemAdminCreateInput;
};


/** List of mutations */
export type MutationSystemAdminDestroyArgs = {
  input: SystemAdminDestroyInput;
};


/** List of mutations */
export type MutationSystemAdminSelfUpdateArgs = {
  input: SystemAdminSelfUpdateInput;
};


/** List of mutations */
export type MutationSystemAdminUpdateArgs = {
  input: SystemAdminUpdateInput;
};


/** List of mutations */
export type MutationSystemAdminUserCreateArgs = {
  input: SystemAdminUserCreateInput;
};


/** List of mutations */
export type MutationTagCreateArgs = {
  input: TagCreateInput;
};


/** List of mutations */
export type MutationTagDestroyArgs = {
  input: TagDestroyInput;
};


/** List of mutations */
export type MutationTaskBulkCreateSameArgs = {
  input: TaskBulkCreateSameInput;
};


/** List of mutations */
export type MutationTaskBulkDeadlineMissedReasonUpdateArgs = {
  input: TaskBulkDeadlineMissedReasonUpdateInput;
};


/** List of mutations */
export type MutationTaskBulkSchedulingArgs = {
  input: TaskBulkSchedulingInput;
};


/** List of mutations */
export type MutationTaskBulkTemplateVersionUpdateArgs = {
  input: TaskBulkTemplateVersionUpdateInput;
};


/** List of mutations */
export type MutationTaskBulkUpdateStatusArgs = {
  input: TaskBulkUpdateStatusInput;
};


/** List of mutations */
export type MutationTaskCompletionCreateArgs = {
  input: TaskCompletionCreateInput;
};


/** List of mutations */
export type MutationTaskCompletionStatusUpdateArgs = {
  input: TaskCompletionStatusUpdateInput;
};


/** List of mutations */
export type MutationTaskDestroyArgs = {
  input: TaskDestroyInput;
};


/** List of mutations */
export type MutationTaskTimelineReportCreateArgs = {
  input: TasksTimelineReportCreateInput;
};


/** List of mutations */
export type MutationTaskUnlinkAllDocumentationsArgs = {
  input: TaskUnlinkAllDocumentationsInput;
};


/** List of mutations */
export type MutationTaskUpdateArgs = {
  input: TaskUpdateInput;
};


/** List of mutations */
export type MutationTeamCreateArgs = {
  input: TeamCreateInput;
};


/** List of mutations */
export type MutationTeamDestroyArgs = {
  input: TeamDestroyInput;
};


/** List of mutations */
export type MutationTeamUpdateArgs = {
  input: TeamUpdateInput;
};


/** List of mutations */
export type MutationTechnicalPauseCreateArgs = {
  input: TechnicalPauseCreateInput;
};


/** List of mutations */
export type MutationTechnicalPauseDestroyArgs = {
  input: TechnicalPauseDestroyInput;
};


/** List of mutations */
export type MutationTechnicalPauseUpdateArgs = {
  input: TechnicalPauseUpdateInput;
};


/** List of mutations */
export type MutationUserBulkActivateArgs = {
  input: UserBulkActivateInput;
};


/** List of mutations */
export type MutationUserBulkDeactivateArgs = {
  input: UserBulkDeactivateInput;
};


/** List of mutations */
export type MutationUserCodeOfConductAcceptArgs = {
  input: UserCodeOfConductAcceptInput;
};


/** List of mutations */
export type MutationUserCreateArgs = {
  input: UserCreateInput;
};


/** List of mutations */
export type MutationUserDestroyArgs = {
  input: UserDestroyInput;
};


/** List of mutations */
export type MutationUserSelfUpdateArgs = {
  input: UserSelfUpdateInput;
};


/** List of mutations */
export type MutationUserUpdateArgs = {
  input: UserUpdateInput;
};


/** List of mutations */
export type MutationWidgetBulkUpdateArgs = {
  input: WidgetBulkUpdateInput;
};


/** List of mutations */
export type MutationWidgetTemplateCreateArgs = {
  input: WidgetTemplateCreateInput;
};


/** List of mutations */
export type MutationWidgetTemplateDestroyArgs = {
  input: WidgetTemplateDestroyInput;
};


/** List of mutations */
export type MutationWidgetTemplateUpdateArgs = {
  input: WidgetTemplateUpdateInput;
};

/** Nomenclature entity */
export type Nomenclature = TimestampInterface & {
  __typename?: 'Nomenclature';
  /**
   * Component Asset entity
   * NOTE: if you only need an Object ID, please use the componentAssetId field to reduce the load on the database.
   */
  componentAsset: Maybe<Asset>;
  /** Component Asset ID */
  componentAssetId: Maybe<Scalars['ID']['output']>;
  /** Time when was created */
  createdAt: Scalars['ISO8601DateTime']['output'];
  /** Nomenclature ID */
  id: Scalars['ID']['output'];
  /**
   * Main Asset entity
   * NOTE: if you only need an Object ID, please use the mainAssetId field to reduce the load on the database.
   */
  mainAsset: Maybe<Asset>;
  /** Main Asset ID */
  mainAssetId: Maybe<Scalars['ID']['output']>;
  /** Quantity */
  quantity: Scalars['Int']['output'];
  /** Last update time */
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

/** Description from base input object. Please set your description for child object. */
export type NomenclatureBulkDestroyInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Nomenclature IDs */
  ids: Array<Scalars['ID']['input']>;
  /** Main Asset ID */
  mainAssetId: Scalars['ID']['input'];
};

/** Description from base input object. Please set your description for child object. */
export type NomenclatureBulkQrCodeCreateInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Create params */
  params: QrCodesCreateInputObject;
};

/** NomenclatureCollection type */
export type NomenclatureCollection = {
  __typename?: 'NomenclatureCollection';
  /** A collection of paginated NomenclatureCollection */
  collection: Array<Nomenclature>;
  /** Pagination Metadata for navigating the Pagination */
  metadata: CollectionMetadata;
};

/** Description from base input object. Please set your description for child object. */
export type NomenclatureCreateInput = {
  /** Create attributes */
  attributes: NomenclatureCreateInputObject;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Nomenclature attributes */
export type NomenclatureCreateInputObject = {
  /** Component asset ID */
  componentAssetId: Scalars['ID']['input'];
  /** Main asset ID (Asset nomenclature for) */
  mainAssetId: Scalars['ID']['input'];
  /** Quantity */
  quantity: Scalars['Int']['input'];
};

/** Nomenclature filters */
export type NomenclatureFilterInputObject = {
  /** Component Asset code */
  componentAssetCode?: InputMaybe<FilterInputObject>;
  /** Component Asset name */
  componentAssetName?: InputMaybe<FilterInputObject>;
};

/** Nomenclature sorts */
export type NomenclatureSortInputObject = {
  /** Component Asset code */
  componentAssetCode?: InputMaybe<SortDirectionEnum>;
  /** Component Asset name */
  componentAssetName?: InputMaybe<SortDirectionEnum>;
  /** Created at */
  createdAt?: InputMaybe<SortDirectionEnum>;
  /** Quantity */
  quantity?: InputMaybe<SortDirectionEnum>;
};

/** Description from base input object. Please set your description for child object. */
export type NomenclatureUpdateInput = {
  /** Update attributes */
  attributes: NomenclatureUpdateInputObject;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Nomenclature ID */
  id: Scalars['ID']['input'];
  /** Main Asset ID */
  mainAssetId: Scalars['ID']['input'];
};

/** Nomenclature attributes */
export type NomenclatureUpdateInputObject = {
  /** Quantity */
  quantity: Scalars['Int']['input'];
};

/** Available period group by options */
export enum PeriodGroupByEnum {
  Day = 'DAY',
  Month = 'MONTH',
  Week = 'WEEK',
  Year = 'YEAR'
}

/** Available QR code file formats */
export enum QrCodeFileFormatEnum {
  /** EPS */
  Eps = 'EPS',
  /** PDF */
  Pdf = 'PDF',
  /** PNG */
  Png = 'PNG',
  /** SVG */
  Svg = 'SVG'
}

/** Available QR code file layouts */
export enum QrCodeFileLayoutEnum {
  /** Single file */
  SingleFile = 'SINGLE_FILE',
  /** Single page */
  SinglePage = 'SINGLE_PAGE'
}

/** Available QR code page sizes */
export enum QrCodePageSizeEnum {
  /** 29x39 mm */
  W29H39 = 'W29H39',
  /** 60x80 mm */
  W60H80 = 'W60H80',
  /** 67x76 mm */
  W67H76 = 'W67H76',
  /** A5 (148x210 mm) */
  W148H210 = 'W148H210'
}

/** QR codes attributes */
export type QrCodesCreateInputObject = {
  /** File format */
  fileFormat: QrCodeFileFormatEnum;
  /** File layout */
  fileLayout: QrCodeFileLayoutEnum;
  /** IDs */
  ids: Array<Scalars['ID']['input']>;
  /** Message to recipient */
  message?: InputMaybe<Scalars['String']['input']>;
  /** Page size */
  pageSize: QrCodePageSizeEnum;
  /** Recipient user ID */
  userId?: InputMaybe<Scalars['ID']['input']>;
};

/** List of queries */
export type Query = {
  __typename?: 'Query';
  /**
   *
   * ATTENTION: Requires plan upgrade for feature: DOCUMENTATION_MANAGEMENT, AI_ASSISTANCE.
   */
  aiBudgetStatus: AiBudgetStatus;
  /**
   *
   * ATTENTION: Requires plan upgrade for feature: DOCUMENTATION_MANAGEMENT, AI_ASSISTANCE.
   */
  aiCompanyIndexingCoverage: AiIndexingCoverage;
  /**
   *
   * ATTENTION: Requires plan upgrade for feature: DOCUMENTATION_MANAGEMENT, AI_ASSISTANCE.
   */
  aiConversation: AiConversation;
  /**
   *
   * ATTENTION: Requires plan upgrade for feature: DOCUMENTATION_MANAGEMENT, AI_ASSISTANCE.
   */
  aiConversations: AiConversationCollection;
  /**
   *
   * ATTENTION: Requires plan upgrade for feature: DOCUMENTATION_MANAGEMENT, AI_ASSISTANCE.
   */
  aiMediaConstraints: Array<AiMediaConstraint>;
  /**
   *
   * ATTENTION: Requires plan upgrade for feature: DOCUMENTATION_MANAGEMENT, AI_ASSISTANCE.
   */
  aiMessages: AiMessageCollection;
  /** The AI model offer per hosting region — selectable chat models plus the region-derived embedding and extraction models, each with pricing (system admins only). */
  aiModelCatalog: Array<AiModelCatalogRegion>;
  /** What a customer's AI workload costs us and what it could be sold for — the form to render, per-unit rate cards for every region and assistant model, the costed workload, and the caveats that apply to it (system admins only). */
  aiPriceCalculator: AiPriceCalculator;
  /**
   *
   * ATTENTION: Requires plan upgrade for feature: DOCUMENTATION_MANAGEMENT, AI_ASSISTANCE.
   */
  aiThinkingCapability: AiThinkingCapability;
  /**
   *
   * ATTENTION: Requires plan upgrade for feature: DOCUMENTATION_MANAGEMENT, AI_ASSISTANCE.
   */
  aiUsageByUser: AiUsageByUserCollection;
  /** Show an ApiToken */
  apiToken: Maybe<ApiToken>;
  /** List of ApiTokens */
  apiTokens: ApiTokenCollection;
  /** Asset */
  asset: Maybe<Asset>;
  /** List of Asset Categories */
  assetCategories: AssetCategoryCollection;
  /** Show an Asset Category */
  assetCategory: Maybe<AssetCategory>;
  /** List of Assets */
  assets: AssetCollection;
  /** Check if an email domain has SSO integrations configured. Used on login page to show SSO options. */
  authenticationSsoCheck: SsoCheck;
  /** Show one background job (its tree) by ID */
  backgroundJob: Maybe<BackgroundJob>;
  /** List background jobs you own (roots only, each with its children tree) */
  backgroundJobs: BackgroundJobCollection;
  /** List of Companies */
  companies: CompanyCollection;
  /** Show a Company */
  company: Maybe<Company>;
  /** Show a Company Domain */
  companyDomain: Maybe<CompanyDomain>;
  /** List of Company Domains */
  companyDomains: CompanyDomainCollection;
  /** Raw text report of aggregate statistics for a company (system admins only). */
  companyStatistics: Scalars['String']['output'];
  /** Show a Counter */
  counter: Maybe<Counter>;
  /** Show a Counter Measure */
  counterMeasure: Maybe<CounterMeasure>;
  /** List of Counter Measures */
  counterMeasures: CounterMeasureCollection;
  /** Counter Measures Graph Data */
  counterMeasuresGraphData: Array<CounterMeasureGraphData>;
  /** List of Counters */
  counters: CounterCollection;
  /** List of countries */
  countries: Array<GeoCountry>;
  /** Show a Data Import */
  dataImport: Maybe<DataImport>;
  /** Data Import Config */
  dataImportConfig: Maybe<Scalars['CamelizedJson']['output']>;
  /** List of Data Imports */
  dataImports: DataImportCollection;
  /** Show a Department */
  department: Maybe<Department>;
  /** List of Departments — root departments by default; with a filter, a flat search across every depth (descend the tree via the Department.children field) */
  departments: DepartmentCollection;
  /**
   *
   * ATTENTION: Requires plan upgrade for feature: DOCUMENTATION_MANAGEMENT.
   */
  documentRenewalReminderTemplate: Maybe<DocumentRenewalReminderTemplate>;
  /** Show a documentation */
  documentation: Maybe<Documentation>;
  /**
   *
   * ATTENTION: Requires plan upgrade for feature: DOCUMENTATION_MANAGEMENT.
   */
  documentationCategories: DocumentationCategoryCollection;
  /**
   *
   * ATTENTION: Requires plan upgrade for feature: DOCUMENTATION_MANAGEMENT.
   */
  documentationCategory: Maybe<DocumentationCategory>;
  /**
   *
   * ATTENTION: Requires plan upgrade for feature: DOCUMENTATION_MANAGEMENT.
   */
  documentationImport: Maybe<DocumentationImport>;
  /**
   *
   * ATTENTION: Requires plan upgrade for feature: DOCUMENTATION_MANAGEMENT.
   */
  documentationImports: DocumentationImportCollection;
  /**
   *
   * ATTENTION: Requires plan upgrade for feature: DOCUMENTATION_MANAGEMENT.
   */
  documentationLinks: DocumentationLinkCollection;
  /** Show a documentation version */
  documentationVersion: Maybe<DocumentationVersion>;
  /**
   *
   * ATTENTION: Requires plan upgrade for feature: DOCUMENTATION_MANAGEMENT.
   */
  documentationVersionViews: DocumentationVersionViewCollection;
  /** List of documentation versions */
  documentationVersions: DocumentationVersionCollection;
  /** List of documentations */
  documentations: DocumentationCollection;
  /**
   *
   * ATTENTION: Requires plan upgrade for feature: DOCUMENTATION_MANAGEMENT.
   */
  documentationsAnalyticsByCategory: Array<DocumentationAnalyticsByCategory>;
  /**
   *
   * ATTENTION: Requires plan upgrade for feature: DOCUMENTATION_MANAGEMENT.
   */
  documentationsAnalyticsByDocument: DocumentationAnalyticsByDocumentCollection;
  /**
   *
   * ATTENTION: Requires plan upgrade for feature: DOCUMENTATION_MANAGEMENT.
   */
  documentationsAnalyticsByLinkable: Array<DocumentationAnalyticsByLinkable>;
  /**
   *
   * ATTENTION: Requires plan upgrade for feature: DOCUMENTATION_MANAGEMENT.
   */
  documentationsAnalyticsByUser: Array<DocumentationAnalyticsByUser>;
  /**
   *
   * ATTENTION: Requires plan upgrade for feature: DOCUMENTATION_MANAGEMENT.
   */
  documentationsAnalyticsTrend: Array<DocumentationAnalyticsTrendPoint>;
  /** Show a fake DNS record (non-production only) */
  fakeDnsRecord: Maybe<FakeDnsRecord>;
  /** List of fake DNS records (non-production only) */
  fakeDnsRecords: FakeDnsRecordCollection;
  /** Show a Frontend Filter Preset */
  feFilterPreset: Maybe<FeFilterPreset>;
  /** List of Frontend Filter Presets */
  feFilterPresets: FeFilterPresetCollection;
  /** List of Form Categories */
  formCategories: FormCategoryCollection;
  /** Show a Form Category */
  formCategory: Maybe<FormCategory>;
  /** Show a Form Checklist Template */
  formChecklistTemplate: Maybe<FormChecklistTemplate>;
  /** List of Form Checklist Templates */
  formChecklistTemplates: FormChecklistTemplateCollection;
  /** Show a Form Template */
  formTemplate: Maybe<FormTemplate>;
  /** Show a Form Template Version */
  formTemplateVersion: Maybe<FormTemplateVersion>;
  /** List of Form Template Versions */
  formTemplateVersions: FormTemplateVersionCollection;
  /** List of Form Templates */
  formTemplates: FormTemplateCollection;
  /** List of Histories */
  histories: HistoryCollection;
  /** Show a Home Page */
  homePage: Maybe<HomePage>;
  /** List of Home Pages */
  homePages: HomePageCollection;
  /** List of Industries */
  industries: IndustryCollection;
  /** Show an Industry */
  industry: Maybe<Industry>;
  /** Show an Intervention */
  intervention: Maybe<Intervention>;
  /** Show an Intervention Action */
  interventionAction: Maybe<InterventionAction>;
  /** List of Intervention Actions */
  interventionActions: InterventionActionCollection;
  /** List of Intervention Categories */
  interventionCategories: InterventionCategoryCollection;
  /** Show an Intervention Category */
  interventionCategory: Maybe<InterventionCategory>;
  /** List of Interventions */
  interventions: InterventionCollection;
  /** Show a Nomenclature */
  nomenclature: Maybe<Nomenclature>;
  /** List of Nomenclatures */
  nomenclatures: NomenclatureCollection;
  /** Show a Sector */
  sector: Maybe<Sector>;
  /** Sector Location Center */
  sectorLocationCenter: Maybe<LocationGeographicalCenter>;
  /** List of Sector Locations */
  sectorLocations: Maybe<GeojsonFeatureCollection>;
  /** List of Sectors */
  sectors: SectorCollection;
  /** Sectors performance metrics by task deadlines missed */
  sectorsPerformanceMetricsByTaskDeadlinesMissed: Maybe<Array<SectorPerformanceMetricByTaskDeadlinesMissed>>;
  /** Sectors performance metrics by task deadlines missed by date */
  sectorsPerformanceMetricsByTaskDeadlinesMissedByDate: Maybe<Array<SectorPerformanceMetricByTaskDeadlinesMissedByDate>>;
  /** Sectors performance metrics by task results */
  sectorsPerformanceMetricsByTaskResults: Maybe<Array<SectorPerformanceMetricByTaskResults>>;
  /** Sectors performance metrics by task results by date */
  sectorsPerformanceMetricsByTaskResultsByDate: Maybe<Array<SectorPerformanceMetricByTaskResultsByDate>>;
  /** List of user sessions */
  sessions: SessionCollection;
  /** Show a Site */
  site: Maybe<Site>;
  /** Show a Site Area */
  siteArea: Maybe<SiteArea>;
  /** List of Site Areas */
  siteAreas: SiteAreaCollection;
  /** Site Location Center */
  siteLocationCenter: Maybe<LocationGeographicalCenter>;
  /** List of Site Locations */
  siteLocations: Maybe<GeojsonFeatureCollection>;
  /** List of Sites */
  sites: SiteCollection;
  /** Sites performance metrics by task deadlines missed */
  sitesPerformanceMetricsByTaskDeadlinesMissed: Maybe<Array<SitePerformanceMetricByTaskDeadlinesMissed>>;
  /** Sites performance metrics by task deadlines missed by date */
  sitesPerformanceMetricsByTaskDeadlinesMissedByDate: Maybe<Array<SitePerformanceMetricByTaskDeadlinesMissedByDate>>;
  /** Sites performance metrics by task results */
  sitesPerformanceMetricsByTaskResults: Maybe<Array<SitePerformanceMetricByTaskResults>>;
  /** Sites performance metrics by task results by date */
  sitesPerformanceMetricsByTaskResultsByDate: Maybe<Array<SitePerformanceMetricByTaskResultsByDate>>;
  /** Show an SSO integration */
  ssoIntegration: Maybe<SsoIntegration>;
  /** Generate a new SSO code with SP URLs for IdP configuration */
  ssoIntegrationGenerateCode: SsoGeneratedCode;
  /** Get default attribute mapping and settings for a provider preset */
  ssoIntegrationPresetDefaults: Scalars['JSON']['output'];
  /** List of supported user fields for SSO attribute mapping */
  ssoIntegrationSupportedMappingFields: Array<SsoMappingField>;
  /** List of SSO integrations */
  ssoIntegrations: SsoIntegrationCollection;
  /** Show a System Admin */
  systemAdmin: Maybe<SystemAdmin>;
  /** List of System Admins */
  systemAdmins: SystemAdminCollection;
  /** Show a tag */
  tag: Maybe<Tag>;
  /** List of tags */
  tags: TagCollection;
  /** Task */
  task: Maybe<Task>;
  /** Get unique task kinds for given task IDs available for scheduling */
  taskAvailableForSchedulingKindsByIds: Array<TaskKindEnum>;
  /** Show a Task Completion */
  taskCompletion: Maybe<TaskCompletion>;
  /** List of Task Completions */
  taskCompletions: TaskCompletionCollection;
  /** List of Tasks */
  tasks: TaskCollection;
  /** Tasks data which can be completed from today until a provided date and assigned to the current user */
  tasksMyTodoCompletableByDateData: Array<TasksTodoCompletableByDateData>;
  /** Tasks Timeline */
  tasksTimeline: Array<TaskTimeline>;
  /** Show a Team */
  team: Maybe<Team>;
  /** List of Teams */
  teams: TeamCollection;
  /** Show a Technical Pause */
  technicalPause: Maybe<TechnicalPause>;
  /** List of Technical Pauses */
  technicalPauses: TechnicalPauseCollection;
  /** Show a User */
  user: Maybe<User>;
  /** List of Users */
  users: UserCollection;
  /** Show current user */
  whoami: Whoami;
  /** Show a Widget */
  widget: Maybe<Widget>;
  /** Show a Widget Template */
  widgetTemplate: Maybe<WidgetTemplate>;
  /** List of Widget Templates */
  widgetTemplates: WidgetTemplateCollection;
  /** List of Widgets */
  widgets: Array<Widget>;
};


/** List of queries */
export type QueryAiConversationArgs = {
  id: Scalars['ID']['input'];
};


/** List of queries */
export type QueryAiConversationsArgs = {
  filters?: InputMaybe<Array<AiConversationFilterInputObject>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  sorts?: InputMaybe<AiConversationSortInputObject>;
};


/** List of queries */
export type QueryAiMessagesArgs = {
  conversationId: Scalars['ID']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  sorts?: InputMaybe<AiMessageSortInputObject>;
};


/** List of queries */
export type QueryAiPriceCalculatorArgs = {
  input?: InputMaybe<AiPriceCalculatorInput>;
};


/** List of queries */
export type QueryAiUsageByUserArgs = {
  filters?: InputMaybe<Array<AiUsageByUserFilterInputObject>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  sorts?: InputMaybe<AiUsageByUserSortInputObject>;
};


/** List of queries */
export type QueryApiTokenArgs = {
  id: Scalars['ID']['input'];
};


/** List of queries */
export type QueryApiTokensArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
};


/** List of queries */
export type QueryAssetArgs = {
  findBy: AssetFindByInputObject;
  siteFindBy?: InputMaybe<SiteFindByInputObject>;
};


/** List of queries */
export type QueryAssetCategoriesArgs = {
  filters?: InputMaybe<Array<AssetCategoryFilterInputObject>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  sorts?: InputMaybe<AssetCategorySortInputObject>;
};


/** List of queries */
export type QueryAssetCategoryArgs = {
  id: Scalars['ID']['input'];
};


/** List of queries */
export type QueryAssetsArgs = {
  filters?: InputMaybe<Array<AssetFilterInputObject>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  onlyIds?: InputMaybe<Scalars['Boolean']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  sorts?: InputMaybe<AssetSortInputObject>;
};


/** List of queries */
export type QueryAuthenticationSsoCheckArgs = {
  email: Scalars['String']['input'];
};


/** List of queries */
export type QueryBackgroundJobArgs = {
  id: Scalars['ID']['input'];
};


/** List of queries */
export type QueryBackgroundJobsArgs = {
  filters?: InputMaybe<Array<BackgroundJobFilterInputObject>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  scope?: InputMaybe<BackgroundJobScopeEnum>;
  sorts?: InputMaybe<BackgroundJobSortInputObject>;
};


/** List of queries */
export type QueryCompaniesArgs = {
  filters?: InputMaybe<Array<CompanyFilterInputObject>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  sorts?: InputMaybe<CompanySortInputObject>;
};


/** List of queries */
export type QueryCompanyArgs = {
  id: Scalars['ID']['input'];
};


/** List of queries */
export type QueryCompanyDomainArgs = {
  id: Scalars['ID']['input'];
};


/** List of queries */
export type QueryCompanyDomainsArgs = {
  filters?: InputMaybe<Array<CompanyDomainFilterInputObject>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  sorts?: InputMaybe<CompanyDomainSortInputObject>;
};


/** List of queries */
export type QueryCompanyStatisticsArgs = {
  id: Scalars['ID']['input'];
  period?: InputMaybe<TimePeriodEnum>;
};


/** List of queries */
export type QueryCounterArgs = {
  assetFindBy: AssetFindByInputObject;
  findBy: CounterFindByInputObject;
};


/** List of queries */
export type QueryCounterMeasureArgs = {
  assetId: Scalars['ID']['input'];
  counterId: Scalars['ID']['input'];
  id: Scalars['ID']['input'];
};


/** List of queries */
export type QueryCounterMeasuresArgs = {
  assetId: Scalars['ID']['input'];
  counterId: Scalars['ID']['input'];
  filters?: InputMaybe<Array<CounterMeasureFilterInputObject>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  onlyIds?: InputMaybe<Scalars['Boolean']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  sorts?: InputMaybe<CounterMeasureSortInputObject>;
};


/** List of queries */
export type QueryCounterMeasuresGraphDataArgs = {
  assetId: Scalars['ID']['input'];
  counterId: Scalars['ID']['input'];
  dateRange: DateRangeInputObject;
};


/** List of queries */
export type QueryCountersArgs = {
  assetId: Scalars['ID']['input'];
  filters?: InputMaybe<Array<CounterFilterInputObject>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  onlyIds?: InputMaybe<Scalars['Boolean']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  sorts?: InputMaybe<CounterSortInputObject>;
};


/** List of queries */
export type QueryDataImportArgs = {
  id: Scalars['ID']['input'];
};


/** List of queries */
export type QueryDataImportsArgs = {
  filters?: InputMaybe<Array<DataImportFilterInputObject>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  onlyIds?: InputMaybe<Scalars['Boolean']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  sorts?: InputMaybe<DataImportSortInputObject>;
};


/** List of queries */
export type QueryDepartmentArgs = {
  id: Scalars['ID']['input'];
};


/** List of queries */
export type QueryDepartmentsArgs = {
  filters?: InputMaybe<Array<DepartmentFilterInputObject>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  onlyIds?: InputMaybe<Scalars['Boolean']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  sorts?: InputMaybe<DepartmentSortInputObject>;
};


/** List of queries */
export type QueryDocumentationArgs = {
  id: Scalars['ID']['input'];
};


/** List of queries */
export type QueryDocumentationCategoriesArgs = {
  filters?: InputMaybe<Array<DocumentationCategoryFilterInputObject>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  sorts?: InputMaybe<DocumentationCategorySortInputObject>;
};


/** List of queries */
export type QueryDocumentationCategoryArgs = {
  id: Scalars['ID']['input'];
};


/** List of queries */
export type QueryDocumentationImportArgs = {
  id: Scalars['ID']['input'];
};


/** List of queries */
export type QueryDocumentationImportsArgs = {
  filters?: InputMaybe<Array<DocumentationImportFilterInputObject>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  sorts?: InputMaybe<DocumentationImportSortInputObject>;
};


/** List of queries */
export type QueryDocumentationLinksArgs = {
  filters?: InputMaybe<Array<DocumentationLinkFilterInputObject>>;
  findBy: DocumentationLinkFindByInputObject;
  limit?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  sorts?: InputMaybe<DocumentationLinkSortInputObject>;
};


/** List of queries */
export type QueryDocumentationVersionArgs = {
  documentationId: Scalars['ID']['input'];
  id: Scalars['ID']['input'];
};


/** List of queries */
export type QueryDocumentationVersionViewsArgs = {
  filters?: InputMaybe<Array<DocumentationVersionViewFilterInputObject>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  sorts?: InputMaybe<DocumentationVersionViewSortInputObject>;
};


/** List of queries */
export type QueryDocumentationVersionsArgs = {
  documentationId: Scalars['ID']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  sorts?: InputMaybe<DocumentationVersionSortInputObject>;
};


/** List of queries */
export type QueryDocumentationsArgs = {
  filters?: InputMaybe<Array<DocumentationFilterInputObject>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  onlyIds?: InputMaybe<Scalars['Boolean']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  scope?: InputMaybe<DocumentationScopeInputObject>;
  sorts?: InputMaybe<DocumentationSortInputObject>;
};


/** List of queries */
export type QueryDocumentationsAnalyticsByCategoryArgs = {
  filters?: InputMaybe<Array<DocumentationFilterInputObject>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  period: DateRangeInputObject;
  sorts?: InputMaybe<DocumentationAnalyticsByCategorySortInputObject>;
};


/** List of queries */
export type QueryDocumentationsAnalyticsByDocumentArgs = {
  filters?: InputMaybe<Array<DocumentationFilterInputObject>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  period: DateRangeInputObject;
  sorts?: InputMaybe<DocumentationAnalyticsSortInputObject>;
};


/** List of queries */
export type QueryDocumentationsAnalyticsByLinkableArgs = {
  dimension: DocumentationAnalyticsLinkableDimensionEnum;
  filters?: InputMaybe<Array<DocumentationFilterInputObject>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  period: DateRangeInputObject;
  sorts?: InputMaybe<DocumentationAnalyticsByLinkableSortInputObject>;
};


/** List of queries */
export type QueryDocumentationsAnalyticsByUserArgs = {
  filters?: InputMaybe<Array<DocumentationFilterInputObject>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  period: DateRangeInputObject;
  sorts?: InputMaybe<DocumentationAnalyticsByUserSortInputObject>;
};


/** List of queries */
export type QueryDocumentationsAnalyticsTrendArgs = {
  filters?: InputMaybe<Array<DocumentationFilterInputObject>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  period: DateRangeInputObject;
  periodGroupBy: PeriodGroupByEnum;
};


/** List of queries */
export type QueryFakeDnsRecordArgs = {
  id: Scalars['ID']['input'];
};


/** List of queries */
export type QueryFakeDnsRecordsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
};


/** List of queries */
export type QueryFeFilterPresetArgs = {
  id: Scalars['ID']['input'];
};


/** List of queries */
export type QueryFeFilterPresetsArgs = {
  filters?: InputMaybe<Array<FeFilterPresetFilterInputObject>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  sorts?: InputMaybe<FeFilterPresetSortInputObject>;
};


/** List of queries */
export type QueryFormCategoriesArgs = {
  filters?: InputMaybe<Array<FormCategoryFilterInputObject>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  sorts?: InputMaybe<FormCategorySortInputObject>;
};


/** List of queries */
export type QueryFormCategoryArgs = {
  id: Scalars['ID']['input'];
};


/** List of queries */
export type QueryFormChecklistTemplateArgs = {
  id: Scalars['ID']['input'];
};


/** List of queries */
export type QueryFormChecklistTemplatesArgs = {
  filters?: InputMaybe<Array<FormChecklistTemplateFilterInputObject>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  onlyIds?: InputMaybe<Scalars['Boolean']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  sorts?: InputMaybe<FormChecklistTemplateSortInputObject>;
};


/** List of queries */
export type QueryFormTemplateArgs = {
  id: Scalars['ID']['input'];
};


/** List of queries */
export type QueryFormTemplateVersionArgs = {
  formTemplateId: Scalars['ID']['input'];
  id: Scalars['ID']['input'];
};


/** List of queries */
export type QueryFormTemplateVersionsArgs = {
  filters?: InputMaybe<Array<FormTemplateVersionFilterInputObject>>;
  formTemplateId: Scalars['ID']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  sorts?: InputMaybe<FormTemplateVersionSortInputObject>;
};


/** List of queries */
export type QueryFormTemplatesArgs = {
  filters?: InputMaybe<Array<FormTemplateFilterInputObject>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  onlyIds?: InputMaybe<Scalars['Boolean']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  scopeName: FormTemplateScopeNameEnum;
  sorts?: InputMaybe<FormTemplateSortInputObject>;
};


/** List of queries */
export type QueryHistoriesArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  scope?: InputMaybe<Scalars['String']['input']>;
  sorts?: InputMaybe<HistorySortInputObject>;
  sourceableId: Scalars['ID']['input'];
  sourceableType: HistorySourceableTypeEnum;
};


/** List of queries */
export type QueryHomePageArgs = {
  id: Scalars['ID']['input'];
};


/** List of queries */
export type QueryHomePagesArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
};


/** List of queries */
export type QueryIndustriesArgs = {
  filters?: InputMaybe<Array<IndustryFilterInputObject>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  sorts?: InputMaybe<IndustrySortInputObject>;
};


/** List of queries */
export type QueryIndustryArgs = {
  id: Scalars['ID']['input'];
};


/** List of queries */
export type QueryInterventionArgs = {
  id: Scalars['ID']['input'];
};


/** List of queries */
export type QueryInterventionActionArgs = {
  id: Scalars['ID']['input'];
  interventionId: Scalars['ID']['input'];
};


/** List of queries */
export type QueryInterventionActionsArgs = {
  filters?: InputMaybe<Array<InterventionActionFilterInputObject>>;
  interventionId: Scalars['ID']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  onlyIds?: InputMaybe<Scalars['Boolean']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  sorts?: InputMaybe<InterventionActionSortInputObject>;
};


/** List of queries */
export type QueryInterventionCategoriesArgs = {
  filters?: InputMaybe<Array<InterventionCategoryFilterInputObject>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  sorts?: InputMaybe<InterventionCategorySortInputObject>;
};


/** List of queries */
export type QueryInterventionCategoryArgs = {
  id: Scalars['ID']['input'];
};


/** List of queries */
export type QueryInterventionsArgs = {
  filters?: InputMaybe<Array<InterventionFilterInputObject>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  onlyIds?: InputMaybe<Scalars['Boolean']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  scopeName: InterventionScopeNameEnum;
  sorts?: InputMaybe<InterventionSortInputObject>;
};


/** List of queries */
export type QueryNomenclatureArgs = {
  id: Scalars['ID']['input'];
  mainAssetId: Scalars['ID']['input'];
};


/** List of queries */
export type QueryNomenclaturesArgs = {
  filters?: InputMaybe<Array<NomenclatureFilterInputObject>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  mainAssetId: Scalars['ID']['input'];
  onlyIds?: InputMaybe<Scalars['Boolean']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  sorts?: InputMaybe<NomenclatureSortInputObject>;
};


/** List of queries */
export type QuerySectorArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
};


/** List of queries */
export type QuerySectorLocationCenterArgs = {
  filters?: InputMaybe<Array<LocationFilterInputObject>>;
  sectorFilters?: InputMaybe<Array<SectorFilterInputObject>>;
};


/** List of queries */
export type QuerySectorLocationsArgs = {
  filters?: InputMaybe<Array<LocationFilterInputObject>>;
  mapParams: LocationMapParamsInputObject;
  sectorFilters?: InputMaybe<Array<SectorFilterInputObject>>;
};


/** List of queries */
export type QuerySectorsArgs = {
  filters?: InputMaybe<Array<SectorFilterInputObject>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  sorts?: InputMaybe<SectorSortInputObject>;
  taskFilters?: InputMaybe<Array<TaskFilterInputObject>>;
};


/** List of queries */
export type QuerySectorsPerformanceMetricsByTaskDeadlinesMissedArgs = {
  ids: Array<Scalars['ID']['input']>;
  taskFilters?: InputMaybe<Array<TaskFilterInputObject>>;
};


/** List of queries */
export type QuerySectorsPerformanceMetricsByTaskDeadlinesMissedByDateArgs = {
  ids: Array<Scalars['ID']['input']>;
  periodGroupBy: PeriodGroupByEnum;
  taskFilters?: InputMaybe<Array<TaskFilterInputObject>>;
};


/** List of queries */
export type QuerySectorsPerformanceMetricsByTaskResultsArgs = {
  ids: Array<Scalars['ID']['input']>;
  taskFilters?: InputMaybe<Array<TaskFilterInputObject>>;
};


/** List of queries */
export type QuerySectorsPerformanceMetricsByTaskResultsByDateArgs = {
  ids: Array<Scalars['ID']['input']>;
  periodGroupBy: PeriodGroupByEnum;
  taskFilters?: InputMaybe<Array<TaskFilterInputObject>>;
};


/** List of queries */
export type QuerySessionsArgs = {
  currentFirst?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  scope: SessionScopeEnum;
  sorts?: InputMaybe<SessionSortInputObject>;
};


/** List of queries */
export type QuerySiteArgs = {
  findBy: SiteFindByInputObject;
};


/** List of queries */
export type QuerySiteAreaArgs = {
  findBy: SiteAreaFindByInputObject;
  siteFindBy?: InputMaybe<SiteFindByInputObject>;
};


/** List of queries */
export type QuerySiteAreasArgs = {
  filters?: InputMaybe<Array<SiteAreaFilterInputObject>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  onlyIds?: InputMaybe<Scalars['Boolean']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  sorts?: InputMaybe<SiteAreaSortInputObject>;
};


/** List of queries */
export type QuerySiteLocationCenterArgs = {
  filters?: InputMaybe<Array<LocationFilterInputObject>>;
  siteFilters?: InputMaybe<Array<SiteFilterInputObject>>;
};


/** List of queries */
export type QuerySiteLocationsArgs = {
  filters?: InputMaybe<Array<LocationFilterInputObject>>;
  mapParams: LocationMapParamsInputObject;
  siteFilters?: InputMaybe<Array<SiteFilterInputObject>>;
};


/** List of queries */
export type QuerySitesArgs = {
  filters?: InputMaybe<Array<SiteFilterInputObject>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  onlyIds?: InputMaybe<Scalars['Boolean']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  sorts?: InputMaybe<SiteSortInputObject>;
  taskFilters?: InputMaybe<Array<TaskFilterInputObject>>;
};


/** List of queries */
export type QuerySitesPerformanceMetricsByTaskDeadlinesMissedArgs = {
  ids: Array<Scalars['ID']['input']>;
  taskFilters?: InputMaybe<Array<TaskFilterInputObject>>;
};


/** List of queries */
export type QuerySitesPerformanceMetricsByTaskDeadlinesMissedByDateArgs = {
  ids: Array<Scalars['ID']['input']>;
  periodGroupBy: PeriodGroupByEnum;
  taskFilters?: InputMaybe<Array<TaskFilterInputObject>>;
};


/** List of queries */
export type QuerySitesPerformanceMetricsByTaskResultsArgs = {
  ids: Array<Scalars['ID']['input']>;
  taskFilters?: InputMaybe<Array<TaskFilterInputObject>>;
};


/** List of queries */
export type QuerySitesPerformanceMetricsByTaskResultsByDateArgs = {
  ids: Array<Scalars['ID']['input']>;
  periodGroupBy: PeriodGroupByEnum;
  taskFilters?: InputMaybe<Array<TaskFilterInputObject>>;
};


/** List of queries */
export type QuerySsoIntegrationArgs = {
  id: Scalars['ID']['input'];
};


/** List of queries */
export type QuerySsoIntegrationPresetDefaultsArgs = {
  preset: SsoIntegrationProviderPresetEnum;
};


/** List of queries */
export type QuerySsoIntegrationsArgs = {
  filters?: InputMaybe<Array<SsoIntegrationFilterInputObject>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  sorts?: InputMaybe<SsoIntegrationSortInputObject>;
};


/** List of queries */
export type QuerySystemAdminArgs = {
  id: Scalars['ID']['input'];
};


/** List of queries */
export type QuerySystemAdminsArgs = {
  filters?: InputMaybe<Array<SystemAdminFilterInputObject>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  sorts?: InputMaybe<SystemAdminSortInputObject>;
};


/** List of queries */
export type QueryTagArgs = {
  id: Scalars['ID']['input'];
};


/** List of queries */
export type QueryTagsArgs = {
  filters?: InputMaybe<Array<TagFilterInputObject>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  onlyIds?: InputMaybe<Scalars['Boolean']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  sorts?: InputMaybe<TagSortInputObject>;
};


/** List of queries */
export type QueryTaskArgs = {
  id: Scalars['ID']['input'];
};


/** List of queries */
export type QueryTaskAvailableForSchedulingKindsByIdsArgs = {
  ids: Array<Scalars['ID']['input']>;
};


/** List of queries */
export type QueryTaskCompletionArgs = {
  id: Scalars['ID']['input'];
};


/** List of queries */
export type QueryTaskCompletionsArgs = {
  filters?: InputMaybe<Array<TaskCompletionFilterInputObject>>;
  groupKey: Scalars['ID']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  onlyIds?: InputMaybe<Scalars['Boolean']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  sorts?: InputMaybe<TaskCompletionSortInputObject>;
};


/** List of queries */
export type QueryTasksArgs = {
  filters?: InputMaybe<Array<TaskFilterInputObject>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  onlyIds?: InputMaybe<Scalars['Boolean']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  scope: TaskScopeInputObject;
  sorts?: InputMaybe<TaskSortInputObject>;
};


/** List of queries */
export type QueryTasksMyTodoCompletableByDateDataArgs = {
  date: Scalars['ISO8601DateTime']['input'];
};


/** List of queries */
export type QueryTasksTimelineArgs = {
  queryData: TaskTimelineQueryDataInputObject;
  taskIds: Array<Scalars['ID']['input']>;
};


/** List of queries */
export type QueryTeamArgs = {
  id: Scalars['ID']['input'];
};


/** List of queries */
export type QueryTeamsArgs = {
  filters?: InputMaybe<Array<TeamFilterInputObject>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  onlyIds?: InputMaybe<Scalars['Boolean']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  sorts?: InputMaybe<TeamSortInputObject>;
};


/** List of queries */
export type QueryTechnicalPauseArgs = {
  id: Scalars['ID']['input'];
};


/** List of queries */
export type QueryTechnicalPausesArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  sorts?: InputMaybe<TechnicalPauseSortInputObject>;
};


/** List of queries */
export type QueryUserArgs = {
  id: Scalars['ID']['input'];
};


/** List of queries */
export type QueryUsersArgs = {
  companyId?: InputMaybe<Scalars['ID']['input']>;
  filters?: InputMaybe<Array<UserFilterInputObject>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  onlyIds?: InputMaybe<Scalars['Boolean']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  scope?: InputMaybe<UserScopeInputObject>;
  sorts?: InputMaybe<UserSortInputObject>;
};


/** List of queries */
export type QueryWidgetArgs = {
  homePageId: Scalars['ID']['input'];
  id: Scalars['ID']['input'];
};


/** List of queries */
export type QueryWidgetTemplateArgs = {
  id: Scalars['ID']['input'];
};


/** List of queries */
export type QueryWidgetTemplatesArgs = {
  filters?: InputMaybe<Array<WidgetTemplateFilterInputObject>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  onlyIds?: InputMaybe<Scalars['Boolean']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  sorts?: InputMaybe<WidgetTemplateSortInputObject>;
};


/** List of queries */
export type QueryWidgetsArgs = {
  homePageId: Scalars['ID']['input'];
};

/** Recurring rule entity */
export type RecurringRule = TimestampInterface & {
  __typename?: 'RecurringRule';
  /** Countdown type */
  countdownType: Maybe<RecurringRuleCountdownTypeEnum>;
  /** Time when was created */
  createdAt: Scalars['ISO8601DateTime']['output'];
  /** End time */
  endTime: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** Number of occurrences after which recurring rule will be stopped */
  endsAfterOccurrences: Maybe<Scalars['Int']['output']>;
  /** Days that should be moved to the nearest available day */
  excludedWdays: Maybe<Array<Scalars['Int']['output']>>;
  /** Recurring rule ID */
  id: Scalars['ID']['output'];
  /** Recurring rule schema */
  schema: RecurringRuleSchema;
  /** Start time */
  startTime: Scalars['ISO8601DateTime']['output'];
  /** Last update time */
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

/** Available countdown types */
export enum RecurringRuleCountdownTypeEnum {
  Completion = 'COMPLETION',
  Deadline = 'DEADLINE'
}

/** Recurring rule attributes */
export type RecurringRuleInputObject = {
  /** Countdown type */
  countdownType: RecurringRuleCountdownTypeEnum;
  /** End time */
  endTime?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  /** Number of occurrences after which recurring rule will be stopped */
  endsAfterOccurrences?: InputMaybe<Scalars['Int']['input']>;
  /** Days that should be moved to the nearest available day */
  excludedWdays: Array<Scalars['Int']['input']>;
  /** Schema attributes */
  schema: RecurringRuleSchemaInputObject;
  /** Start time */
  startTime: Scalars['ISO8601DateTime']['input'];
};

/** Available recurring rule types */
export enum RecurringRuleRuleTypeEnum {
  Daily = 'DAILY',
  Monthly = 'MONTHLY',
  Weekly = 'WEEKLY',
  Yearly = 'YEARLY'
}

/** Recurring rule schema type */
export type RecurringRuleSchema = {
  __typename?: 'RecurringRuleSchema';
  /** Recurring rule schema metadata */
  metadata: Maybe<RecurringRuleSchemaMetadata>;
  /** Recurring schema rule */
  rrules: Array<RecurringRuleSchemaRule>;
};

/**
 * Recurring rule schema attributes
 * Examples:
 *
 *   - Daily:
 *     ```
 *     [
 *       {
 *         "ruleType": "DAILY",
 *         "interval": 1
 *       }
 *     ]
 *     ```
 *
 *   - Weekly on Sundays, Mondays, Wednesdays, and Fridays:
 *     ```
 *     [
 *       {
 *         "ruleType": "WEEKLY",
 *         "interval": 1,
 *         "validations": {
 *           "day": [0,1,3,5]
 *         }
 *       }
 *     ]
 *     ```
 *
 *   - Monthly on the 1st, 15th, and 31st days of the month:
 *     ```
 *     [
 *       {
 *         "ruleType": "MONTHLY",
 *         "interval": 1,
 *         "validations": {
 *           "dayOfMonth": [1,15,31]
 *         }
 *       }
 *     ]
 *     ```
 *
 *   - Monthly on the 1st Monday and on the last day of the month
 *     ```
 *     [
 *       {
 *         "ruleType": "MONTHLY",
 *         "interval": 1,
 *         "validations": {
 *           "dayOfWeek": {
 *             "1": [1]
 *           }
 *         }
 *       },
 *       {
 *         "ruleType": "MONTHLY",
 *         "interval": 1,
 *         "validations": {
 *           "dayOfMonth": [-1]
 *         }
 *       }
 *     ]
 *     ```
 *
 *   - Yearly:
 *     ```
 *     [
 *       {
 *         "ruleType": "YEARLY",
 *         "interval": 1
 *       }
 *     ]
 *     ```
 *
 *   - Every 2 years on the 1st and last days of the month in January, February, and December:
 *     ```
 *     [
 *       {
 *         "ruleType": "YEARLY",
 *         "interval": 2,
 *         "validations": {
 *           "dayOfMonth": [1,-1],
 *           "monthOfYear": [1,2,12]
 *         }
 *       }
 *     ]
 *     ```
 *   - Every 2 years on the 1st Monday and last Friday (1) and on the last day of the month (2) in January and February
 *     ```
 *     [
 *       {
 *         "ruleType": "YEARLY",
 *         "interval": 2,
 *         "validations": {
 *           "dayOfWeek": {
 *             "1": [1],
 *             "5": [-1]
 *           },
 *           "monthOfYear": [1,2]
 *         }
 *       },
 *       {
 *         "ruleType": "YEARLY",
 *         "interval": 2,
 *         "validations": {
 *           "dayOfMonth": [-1],
 *           "monthOfYear": [1,2]
 *         }
 *       }
 *     ]
 *     ```
 *
 */
export type RecurringRuleSchemaInputObject = {
  /** Metadata */
  metadata?: InputMaybe<RecurringRuleSchemaMetadataInputObject>;
  /** Recurring schema rule */
  rrules: Array<RecurringRuleSchemaRuleInputObject>;
};

/** Recurring rule schema metadata */
export type RecurringRuleSchemaMetadata = {
  __typename?: 'RecurringRuleSchemaMetadata';
  /** Recurring rule schema option */
  schemaOption: RecurringRuleSchemaOptionEnum;
};

/** Recurring rule schema metadata attributes */
export type RecurringRuleSchemaMetadataInputObject = {
  /** Schema option */
  schemaOption?: InputMaybe<RecurringRuleSchemaOptionEnum>;
};

/** Available recurring rule schema options */
export enum RecurringRuleSchemaOptionEnum {
  Each = 'EACH',
  OnThe = 'ON_THE'
}

/**
 * Recurring schema rule
 * Examples:
 *
 * - Daily:
 *   ```
 *   [
 *     {
 *       "ruleType": "DAILY",
 *       "interval": 1
 *     }
 *   ]
 *   ```
 *
 * - Weekly on Sundays, Mondays, Wednesdays, and Fridays:
 *   ```
 *   [
 *     {
 *       "ruleType": "WEEKLY",
 *       "interval": 1,
 *       "validations": {
 *         "day": [0,1,3,5]
 *       }
 *     }
 *   ]
 *   ```
 *
 * - Monthly on the 1st, 15th, and 31st days of the month:
 *   ```
 *   [
 *     {
 *       "ruleType": "MONTHLY",
 *       "interval": 1,
 *       "validations": {
 *         "dayOfMonth": [1,15,31]
 *       }
 *     }
 *   ]
 *   ```
 *
 * - Monthly on the 1st Monday and on the last day of the month
 *   ```
 *   [
 *     {
 *       "ruleType": "MONTHLY",
 *       "interval": 1,
 *       "validations": {
 *         "dayOfWeek": {
 *           "1": [1]
 *         }
 *       }
 *     },
 *     {
 *       "ruleType": "MONTHLY",
 *       "interval": 1,
 *       "validations": {
 *         "dayOfMonth": [-1]
 *       }
 *     }
 *   ]
 *   ```
 *
 * - Yearly:
 *   ```
 *   [
 *     {
 *       "ruleType": "YEARLY",
 *       "interval": 1
 *     }
 *   ]
 *   ```
 *
 * - Every 2 years on the 1st and last days of the month in January, February, and December:
 *   ```
 *   [
 *     {
 *       "ruleType": "YEARLY",
 *       "interval": 2,
 *       "validations": {
 *         "dayOfMonth": [1,-1],
 *         "monthOfYear": [1,2,12]
 *       }
 *     }
 *   ]
 *   ```
 * - Every 2 years on the 1st Monday and last Friday (1) and on the last day of the month (2) in January and February
 *   ```
 *   [
 *     {
 *       "ruleType": "YEARLY",
 *       "interval": 2,
 *       "validations": {
 *         "dayOfWeek": {
 *           "1": [1],
 *           "5": [-1]
 *         },
 *         "monthOfYear": [1,2]
 *       }
 *     },
 *     {
 *       "ruleType": "YEARLY",
 *       "interval": 2,
 *       "validations": {
 *         "dayOfMonth": [-1],
 *         "monthOfYear": [1,2]
 *       }
 *     }
 *   ]
 *   ```
 *
 */
export type RecurringRuleSchemaRule = {
  __typename?: 'RecurringRuleSchemaRule';
  /** Interval */
  interval: Scalars['Int']['output'];
  /** Rule type */
  ruleType: RecurringRuleRuleTypeEnum;
  /** Recurring schema rule validations */
  validations: Maybe<RecurringRuleValidations>;
};

/** Recurring rule schema rule attributes */
export type RecurringRuleSchemaRuleInputObject = {
  /** Interval */
  interval: Scalars['Int']['input'];
  /** Rule type */
  ruleType: RecurringRuleRuleTypeEnum;
  /** Validations attributes */
  validations?: InputMaybe<RecurringRuleValidationsInputObject>;
};

/** Recurring schema rule validations */
export type RecurringRuleValidations = {
  __typename?: 'RecurringRuleValidations';
  /** Day (1..31) */
  day: Maybe<Array<Scalars['Int']['output']>>;
  /** Days of month (-1, 1..31) where -1 is the last day of the month, 1 is the first day of the month, etc. */
  dayOfMonth: Maybe<Array<Scalars['Int']['output']>>;
  /**
   * Days of week.
   * Example: `{"1": [-1,1,3,5]}` where key `1` is the day of the week (Monday) and value `[-1,1,3,5]` are the number of the day in the month (last, 1st, 3rd, 5th)
   *
   */
  dayOfWeek: Maybe<Scalars['JSON']['output']>;
  /** Month of year (1..12) */
  monthOfYear: Maybe<Array<Scalars['Int']['output']>>;
};

/** Recurring rule validations */
export type RecurringRuleValidationsInputObject = {
  /** Day (1..31) */
  day?: InputMaybe<Array<Scalars['Int']['input']>>;
  /** Day of month (-1, 1..31) where -1 is the last day of the month, 1 is the first day of the month, etc. */
  dayOfMonth?: InputMaybe<Array<Scalars['Int']['input']>>;
  /**
   * Days of week.
   * Example: `{"1": [-1,1,3,5]}` where key `1` is the day of the week (Monday) and value `[-1,1,3,5]` are the number of the day in the month (last, 1st, 3rd, 5th)
   *
   */
  dayOfWeek?: InputMaybe<Scalars['JSON']['input']>;
  /** Month of year (1..12) */
  monthOfYear?: InputMaybe<Array<Scalars['Int']['input']>>;
};

/** Response message */
export type ResponseMessage = {
  __typename?: 'ResponseMessage';
  /** Message */
  message: Scalars['String']['output'];
};

/** Sector entity */
export type Sector = TimestampInterface & {
  __typename?: 'Sector';
  canDestroy: AuthorizationResult;
  /** Code */
  code: Maybe<Scalars['String']['output']>;
  /** Color */
  color: Maybe<ColorEnum>;
  /** Time when was created */
  createdAt: Scalars['ISO8601DateTime']['output'];
  /** Description */
  description: Maybe<Scalars['String']['output']>;
  /** Sector ID */
  id: Scalars['ID']['output'];
  /** Location boundary */
  locationBoundary: Maybe<Location>;
  /** Name */
  name: Maybe<Scalars['String']['output']>;
  /** Indicates if sector is read only (default system sector) */
  readOnly: Scalars['Boolean']['output'];
  /** Sites collection */
  sites: SiteCollection;
  /** Sites count */
  sitesCount: Scalars['Int']['output'];
  /** [Performance metrics] Success percentage (deadlines missed) according to the task filters */
  successPercentageByTaskDeadlinesMissed: Maybe<Scalars['Float']['output']>;
  /** [Performance metrics] Success percentage according to the task filters */
  successPercentageByTaskResults: Maybe<Scalars['Float']['output']>;
  /** [Performance metrics] Total anomalies (deadlines missed) according to the task filters */
  totalAnomaliesByTaskDeadlinesMissed: Maybe<Scalars['Int']['output']>;
  /** [Performance metrics] Total anomalies (warning and failure completions) according to the task filters */
  totalAnomaliesByTaskResults: Maybe<Scalars['Int']['output']>;
  /** Last update time */
  updatedAt: Scalars['ISO8601DateTime']['output'];
  /**
   * Responsible User entity
   * NOTE: if you only need an Object ID, please use the userId field to reduce the load on the database.
   */
  user: Maybe<User>;
  /** Responsible User ID */
  userId: Maybe<Scalars['ID']['output']>;
  /** Users count (memberships + full admins) */
  usersCount: Scalars['Int']['output'];
};


/** Sector entity */
export type SectorSitesArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
};

/** SectorCollection type */
export type SectorCollection = {
  __typename?: 'SectorCollection';
  /** A collection of paginated SectorCollection */
  collection: Array<Sector>;
  /** Pagination Metadata for navigating the Pagination */
  metadata: CollectionMetadata;
};

/** Description from base input object. Please set your description for child object. */
export type SectorCreateInput = {
  /** Create attributes */
  attributes: SectorCreateInputObject;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Sector attributes */
export type SectorCreateInputObject = {
  /** Code */
  code?: InputMaybe<Scalars['String']['input']>;
  /** Color */
  color: ColorEnum;
  /** Description */
  description?: InputMaybe<Scalars['String']['input']>;
  /** Location boundary */
  locationBoundary?: InputMaybe<LocationCuInputObject>;
  /** Name */
  name: Scalars['String']['input'];
  /** Sites linking attributes array */
  sites?: InputMaybe<Array<LinkingInputObject>>;
  /** Responsible User ID */
  userId?: InputMaybe<Scalars['ID']['input']>;
  /** Users linking attributes array (not full admins) */
  userMemberships?: InputMaybe<Array<LinkingInputObject>>;
};

/** Description from base input object. Please set your description for child object. */
export type SectorDestroyInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Sector ID */
  id: Scalars['ID']['input'];
};

/** Sector filters */
export type SectorFilterInputObject = {
  /** Sector code */
  code?: InputMaybe<FilterInputObject>;
  /**
   * Documentation ID
   * ATTENTION: Requires plan upgrade for feature: DOCUMENTATION_MANAGEMENT.
   */
  documentationsId?: InputMaybe<FilterIdInputObject>;
  /** Sector ID */
  id?: InputMaybe<FilterIdInputObject>;
  /** Sector name */
  name?: InputMaybe<FilterInputObject>;
  /** Sites ID */
  sitesId?: InputMaybe<FilterIdInputObject>;
};

/** Sector performance metric by task deadlines missed entity */
export type SectorPerformanceMetricByTaskDeadlinesMissed = {
  __typename?: 'SectorPerformanceMetricByTaskDeadlinesMissed';
  /** Sector ID */
  id: Scalars['ID']['output'];
  /** [Performance metrics] Success percentage (deadlines missed) according to the task filters */
  successPercentageByTaskDeadlinesMissed: Maybe<Scalars['Float']['output']>;
  /** [Performance metrics] Total anomalies (deadlines missed) according to the task filters */
  totalAnomaliesByTaskDeadlinesMissed: Maybe<Scalars['Int']['output']>;
};

/** Sector performance metric by task deadlines missed by date entity */
export type SectorPerformanceMetricByTaskDeadlinesMissedByDate = {
  __typename?: 'SectorPerformanceMetricByTaskDeadlinesMissedByDate';
  /** Sector ID */
  id: Scalars['ID']['output'];
  /** Period */
  period: Scalars['ISO8601Date']['output'];
  /** [Performance metrics] Total anomalies (deadlines missed) according to the task filters */
  totalAnomaliesByTaskDeadlinesMissed: Scalars['Int']['output'];
};

/** Sector performance metric by task results entity */
export type SectorPerformanceMetricByTaskResults = {
  __typename?: 'SectorPerformanceMetricByTaskResults';
  /** Sector ID */
  id: Scalars['ID']['output'];
  /** [Performance metrics] Success percentage according to the task filters */
  successPercentageByTaskResults: Maybe<Scalars['Float']['output']>;
  /** [Performance metrics] Total anomalies (warning and failure completions) according to the task filters */
  totalAnomaliesByTaskResults: Maybe<Scalars['Int']['output']>;
};

/** Sector performance metric by task results by date entity */
export type SectorPerformanceMetricByTaskResultsByDate = {
  __typename?: 'SectorPerformanceMetricByTaskResultsByDate';
  /** Sector ID */
  id: Scalars['ID']['output'];
  /** Period */
  period: Scalars['ISO8601Date']['output'];
  /** [Performance metrics] Total anomalies (warning and failure completions) according to the task filters */
  totalAnomaliesByTaskResults: Scalars['Int']['output'];
};

/** Sector sorts */
export type SectorSortInputObject = {
  /** Code */
  code?: InputMaybe<SortDirectionEnum>;
  /** Created at */
  createdAt?: InputMaybe<SortDirectionEnum>;
  /** Name */
  name?: InputMaybe<SortDirectionEnum>;
  /** Sites count */
  sitesCount?: InputMaybe<SortDirectionEnum>;
  /** [Performance metrics] Success percentage (deadlines missed) according to the task filters */
  successPercentageByTaskDeadlinesMissed?: InputMaybe<SortDirectionEnum>;
  /** [Performance metrics] Success percentage according to the task filters */
  successPercentageByTaskResults?: InputMaybe<SortDirectionEnum>;
  /** [Performance metrics] Total anomalies (deadlines missed) according to the task filters */
  totalAnomaliesByTaskDeadlinesMissed?: InputMaybe<SortDirectionEnum>;
  /** [Performance metrics] Total anomalies (warning and failure completions) according to the task filters */
  totalAnomaliesByTaskResults?: InputMaybe<SortDirectionEnum>;
  /** Users count (memberships + full admins) */
  usersCount?: InputMaybe<SortDirectionEnum>;
};

/** Description from base input object. Please set your description for child object. */
export type SectorUpdateInput = {
  /** Update attributes */
  attributes: SectorUpdateInputObject;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Sector ID */
  id: Scalars['ID']['input'];
};

/** Sector attributes */
export type SectorUpdateInputObject = {
  /** Code */
  code?: InputMaybe<Scalars['String']['input']>;
  /** Color */
  color?: InputMaybe<ColorEnum>;
  /** Description */
  description?: InputMaybe<Scalars['String']['input']>;
  /** Location boundary */
  locationBoundary?: InputMaybe<LocationCuInputObject>;
  /** Name */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Sites linking attributes array */
  sites?: InputMaybe<Array<LinkingInputObject>>;
  /** Responsible User ID */
  userId?: InputMaybe<Scalars['ID']['input']>;
  /** Users linking attributes array (not full admins) */
  userMemberships?: InputMaybe<Array<LinkingInputObject>>;
};

/** Session */
export type Session = {
  __typename?: 'Session';
  /** Minimum session age in hours required for sensitive operations */
  ageMinimumHours: Scalars['Int']['output'];
  /** Browser name */
  browserName: Scalars['String']['output'];
  /** Browser version */
  browserVersion: Scalars['String']['output'];
  /** City from IP geolocation */
  city: Scalars['String']['output'];
  /** Country from IP geolocation */
  country: Scalars['String']['output'];
  /** ISO 3166-1 alpha-2 country code */
  countryCode: Maybe<Scalars['String']['output']>;
  /** Creation time */
  createdAt: Scalars['ISO8601DateTime']['output'];
  /** Combined device info (e.g., "Desktop, Chrome 120.0") */
  device: Scalars['String']['output'];
  /** Device type (Desktop, Smartphone, Tablet, etc.) */
  deviceType: Scalars['String']['output'];
  /** Expiration time */
  expiresAt: Scalars['ISO8601DateTime']['output'];
  /** Session ID */
  id: Scalars['ID']['output'];
  /** IP address */
  ip: Maybe<Scalars['String']['output']>;
  /** Last activity time */
  lastActivityAt: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** Combined location info (e.g., "Kyiv, Kyiv Oblast, Ukraine") */
  location: Scalars['String']['output'];
  /** Operating system name */
  osName: Scalars['String']['output'];
  /** Region/state from IP geolocation */
  region: Scalars['String']['output'];
  /** Whether this session belongs to the current device */
  thisDevice: Scalars['Boolean']['output'];
  /** Whether session is too young for sensitive operations */
  tooYoung: Scalars['Boolean']['output'];
  /** Indicates if session is pending two-factor authentication verification */
  twoFactorPending: Scalars['Boolean']['output'];
  /** Indicates if two-factor authentication has been verified for this session */
  twoFactorVerified: Scalars['Boolean']['output'];
  /** User agent */
  userAgent: Maybe<Scalars['String']['output']>;
};

/** SessionCollection type */
export type SessionCollection = {
  __typename?: 'SessionCollection';
  /** A collection of paginated SessionCollection */
  collection: Array<Session>;
  /** Pagination Metadata for navigating the Pagination */
  metadata: CollectionMetadata;
};

/** Available session scopes */
export enum SessionScopeEnum {
  /** Active sessions (not expired) */
  Active = 'ACTIVE',
  /** Ended sessions (expired) */
  Ended = 'ENDED'
}

/** Session sorts */
export type SessionSortInputObject = {
  /** Created at */
  createdAt?: InputMaybe<SortDirectionEnum>;
  /** Expires at */
  expiresAt?: InputMaybe<SortDirectionEnum>;
  /** Last activity at */
  lastActivityAt?: InputMaybe<SortDirectionEnum>;
};

/** Site entity */
export type Site = TimestampInterface & {
  __typename?: 'Site';
  /** Site cellphone */
  cellphone: Maybe<Scalars['String']['output']>;
  /** Code */
  code: Scalars['String']['output'];
  /** Time when was created */
  createdAt: Scalars['ISO8601DateTime']['output'];
  /** Description */
  description: Maybe<Scalars['String']['output']>;
  /** Site contact email */
  email: Scalars['String']['output'];
  /** Site ID */
  id: Scalars['ID']['output'];
  /** Site location photo */
  locationPhotoAttached: Maybe<Attachment>;
  /** Location point */
  locationPoint: Maybe<Location>;
  /** Name */
  name: Scalars['String']['output'];
  /** Site contact phone number */
  phoneNumber: Maybe<Scalars['String']['output']>;
  /**
   * Sector
   * NOTE: if you only need an Object ID, please use the sectorId field to reduce the load on the database.
   */
  sector: Maybe<Sector>;
  /** Sector ID */
  sectorId: Maybe<Scalars['ID']['output']>;
  /** Number of Site Areas */
  siteAreasCount: Scalars['Int']['output'];
  /** Site Code of Conduct sections */
  siteConductCodeSections: Array<SiteConductCodeSection>;
  /** [Performance metrics] Success percentage (deadlines missed) according to the task filters */
  successPercentageByTaskDeadlinesMissed: Maybe<Scalars['Float']['output']>;
  /** [Performance metrics] Success percentage according to the task filters */
  successPercentageByTaskResults: Maybe<Scalars['Float']['output']>;
  /** [Performance metrics] Total anomalies (deadlines missed) according to the task filters */
  totalAnomaliesByTaskDeadlinesMissed: Maybe<Scalars['Int']['output']>;
  /** [Performance metrics] Total anomalies (warning and failure completions) according to the task filters */
  totalAnomaliesByTaskResults: Maybe<Scalars['Int']['output']>;
  /** Last update time */
  updatedAt: Scalars['ISO8601DateTime']['output'];
  /**
   * Responsible user
   * NOTE: if you only need an Object ID, please use the userId field to reduce the load on the database.
   */
  user: Maybe<User>;
  /** Responsible user ID */
  userId: Maybe<Scalars['ID']['output']>;
  /** Number of Users (memberships + full admins) */
  usersCount: Scalars['Int']['output'];
};

/** Site Area entity */
export type SiteArea = TimestampInterface & {
  __typename?: 'SiteArea';
  /** Site Area address */
  address: Maybe<Scalars['String']['output']>;
  canDestroy: AuthorizationResult;
  /** Code */
  code: Scalars['String']['output'];
  /** Time when was created */
  createdAt: Scalars['ISO8601DateTime']['output'];
  /** Description */
  description: Maybe<Scalars['String']['output']>;
  /** Full code (As on the QR code) */
  fullCode: Scalars['String']['output'];
  /** Site Area ID */
  id: Scalars['ID']['output'];
  /** Name */
  name: Scalars['String']['output'];
  /** Indicates if site area location has poor wifi or does not have wifi */
  poorWifi: Scalars['Boolean']['output'];
  /**
   * Site entity
   * NOTE: if you only need an Object ID, please use the siteId field to reduce the load on the database.
   */
  site: Maybe<Site>;
  /** Site ID */
  siteId: Maybe<Scalars['ID']['output']>;
  /** Last update time */
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

/** Description from base input object. Please set your description for child object. */
export type SiteAreaBulkDestroyInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** IDs */
  ids: Array<Scalars['ID']['input']>;
};

/** Outcome of a Site Area bulk destroy */
export type SiteAreaBulkDestroyResult = {
  __typename?: 'SiteAreaBulkDestroyResult';
  /** Site Areas that were not deleted; read each one's canDestroy for the reason */
  blocked: Array<SiteArea>;
  /** Number of records actually deleted */
  destroyedCount: Scalars['Int']['output'];
};

/** Description from base input object. Please set your description for child object. */
export type SiteAreaBulkQrCodeCreateInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Create params */
  params: QrCodesCreateInputObject;
};

/** SiteAreaCollection type */
export type SiteAreaCollection = {
  __typename?: 'SiteAreaCollection';
  /** A collection of paginated SiteAreaCollection */
  collection: Array<SiteArea>;
  /** Pagination Metadata for navigating the Pagination */
  metadata: CollectionMetadata;
};

/** Site area attributes */
export type SiteAreaCreateInputObject = {
  /** Address */
  address?: InputMaybe<Scalars['String']['input']>;
  /** Code */
  code?: InputMaybe<Scalars['String']['input']>;
  /** Description */
  description?: InputMaybe<Scalars['String']['input']>;
  /**
   * Documentation links
   * ATTENTION: Requires plan upgrade for feature: DOCUMENTATION_MANAGEMENT.
   */
  documentationLinks?: InputMaybe<Array<DocumentationLinkInputObject>>;
  /** Name */
  name: Scalars['String']['input'];
  /** Indicates if site area location has poor wifi or does not have wifi */
  poorWifi?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Site Area filters */
export type SiteAreaFilterInputObject = {
  /** Site Area code */
  code?: InputMaybe<FilterInputObject>;
  /**
   * Documentation ID
   * ATTENTION: Requires plan upgrade for feature: DOCUMENTATION_MANAGEMENT.
   */
  documentationsId?: InputMaybe<FilterIdInputObject>;
  /** Site Area ID */
  id?: InputMaybe<FilterIdInputObject>;
  /** Site Area name */
  name?: InputMaybe<FilterInputObject>;
  /** Sector ID */
  sectorId?: InputMaybe<FilterIdInputObject>;
  /** Sector name */
  sectorName?: InputMaybe<FilterInputObject>;
  /** Site code */
  siteCode?: InputMaybe<FilterInputObject>;
  /** Site ID */
  siteId?: InputMaybe<FilterIdInputObject>;
  /** Site name */
  siteName?: InputMaybe<FilterInputObject>;
};

/** Site area attributes */
export type SiteAreaFindByInputObject = {
  /** Code */
  code?: InputMaybe<Scalars['String']['input']>;
  /** ID */
  id?: InputMaybe<Scalars['ID']['input']>;
};

/** Site Area sorts */
export type SiteAreaSortInputObject = {
  /** Code */
  code?: InputMaybe<SortDirectionEnum>;
  /** Created at */
  createdAt?: InputMaybe<SortDirectionEnum>;
  /** Name */
  name?: InputMaybe<SortDirectionEnum>;
  /** Sector name */
  sectorName?: InputMaybe<SortDirectionEnum>;
  /** Site code */
  siteCode?: InputMaybe<SortDirectionEnum>;
  /** Site name */
  siteName?: InputMaybe<SortDirectionEnum>;
};

/** Description from base input object. Please set your description for child object. */
export type SiteAreaUpdateInput = {
  /** Update attributes */
  attributes: SiteAreaUpdateInputObject;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Site Area ID */
  id: Scalars['ID']['input'];
};

/** Site area attributes */
export type SiteAreaUpdateInputObject = {
  /** Address */
  address?: InputMaybe<Scalars['String']['input']>;
  /** Description */
  description?: InputMaybe<Scalars['String']['input']>;
  /**
   * Documentation links
   * ATTENTION: Requires plan upgrade for feature: DOCUMENTATION_MANAGEMENT.
   */
  documentationLinks?: InputMaybe<Array<DocumentationLinkInputObject>>;
  /** Name */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Indicates if site area location has poor wifi or does not have wifi */
  poorWifi?: InputMaybe<Scalars['Boolean']['input']>;
};

/** SiteCollection type */
export type SiteCollection = {
  __typename?: 'SiteCollection';
  /** A collection of paginated SiteCollection */
  collection: Array<Site>;
  /** Pagination Metadata for navigating the Pagination */
  metadata: CollectionMetadata;
};

/** Site Code of Conduct section entity */
export type SiteConductCodeSection = TimestampInterface & {
  __typename?: 'SiteConductCodeSection';
  /** Body text */
  body: Scalars['String']['output'];
  /** Time when was created */
  createdAt: Scalars['ISO8601DateTime']['output'];
  /** Site Code of Conduct section ID */
  id: Scalars['ID']['output'];
  /** Position */
  position: Scalars['Int']['output'];
  /** Title */
  title: Scalars['String']['output'];
  /** Last update time */
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

/** Site conduct code section attributes */
export type SiteConductCodeSectionCreateInputObject = {
  /** Body */
  body: Scalars['String']['input'];
  /** Position */
  position: Scalars['Int']['input'];
  /** Title */
  title: Scalars['String']['input'];
};

/** Description from base input object. Please set your description for child object. */
export type SiteCreateInput = {
  /** Create attributes */
  attributes: SiteCreateInputObject;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Site attributes */
export type SiteCreateInputObject = {
  /** Create Site Areas attributes array */
  areas?: InputMaybe<Array<SiteAreaCreateInputObject>>;
  /** Site cellphone */
  cellphone?: InputMaybe<Scalars['String']['input']>;
  /** Code */
  code?: InputMaybe<Scalars['String']['input']>;
  /** Create Conduct Code sections attributes array */
  conductCodeSections?: InputMaybe<Array<SiteConductCodeSectionCreateInputObject>>;
  /** Description */
  description?: InputMaybe<Scalars['String']['input']>;
  /** Site contact email */
  email: Scalars['String']['input'];
  /** Location photo */
  locationPhotoAttached?: InputMaybe<AttachmentCuInputObject>;
  /** Location point */
  locationPoint: LocationCuInputObject;
  /** Name */
  name: Scalars['String']['input'];
  /** Site contact phone number */
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  /** Sector ID */
  sectorId?: InputMaybe<Scalars['ID']['input']>;
  /** Responsible user ID */
  userId: Scalars['ID']['input'];
  /** User memberships attributes array (not full admins) */
  userMemberships?: InputMaybe<Array<LinkingInputObject>>;
};

/** Description from base input object. Please set your description for child object. */
export type SiteDestroyInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Site ID */
  id: Scalars['ID']['input'];
};

/** Site filters */
export type SiteFilterInputObject = {
  /** Site area code */
  areasCode?: InputMaybe<FilterInputObject>;
  /** Site area name */
  areasName?: InputMaybe<FilterInputObject>;
  /** Site code */
  code?: InputMaybe<FilterInputObject>;
  /**
   * Documentation ID
   * ATTENTION: Requires plan upgrade for feature: DOCUMENTATION_MANAGEMENT.
   */
  documentationsId?: InputMaybe<FilterIdInputObject>;
  /** Site ID */
  id?: InputMaybe<FilterIdInputObject>;
  /** Site name */
  name?: InputMaybe<FilterInputObject>;
  /** Sector ID */
  sectorId?: InputMaybe<FilterInputObject>;
  /** Sector name */
  sectorName?: InputMaybe<FilterInputObject>;
  /** Responsible user full name */
  userFullName?: InputMaybe<FilterInputObject>;
};

/** Site attributes */
export type SiteFindByInputObject = {
  /** Code */
  code?: InputMaybe<Scalars['String']['input']>;
  /** ID */
  id?: InputMaybe<Scalars['ID']['input']>;
};

/** Site performance metric by task deadlines missed entity */
export type SitePerformanceMetricByTaskDeadlinesMissed = {
  __typename?: 'SitePerformanceMetricByTaskDeadlinesMissed';
  /** Site ID */
  id: Scalars['ID']['output'];
  /** [Performance metrics] Success percentage (deadlines missed) according to the task filters */
  successPercentageByTaskDeadlinesMissed: Maybe<Scalars['Float']['output']>;
  /** [Performance metrics] Total anomalies (deadlines missed) according to the task filters */
  totalAnomaliesByTaskDeadlinesMissed: Maybe<Scalars['Int']['output']>;
};

/** Sector performance metric by task deadlines missed by date entity */
export type SitePerformanceMetricByTaskDeadlinesMissedByDate = {
  __typename?: 'SitePerformanceMetricByTaskDeadlinesMissedByDate';
  /** Sector ID */
  id: Scalars['ID']['output'];
  /** Period */
  period: Scalars['ISO8601Date']['output'];
  /** [Performance metrics] Total anomalies (deadlines missed) according to the task filters */
  totalAnomaliesByTaskDeadlinesMissed: Scalars['Int']['output'];
};

/** Site performance metric by task results entity */
export type SitePerformanceMetricByTaskResults = {
  __typename?: 'SitePerformanceMetricByTaskResults';
  /** Site ID */
  id: Scalars['ID']['output'];
  /** [Performance metrics] Success percentage according to the task filters */
  successPercentageByTaskResults: Maybe<Scalars['Float']['output']>;
  /** [Performance metrics] Total anomalies (warning and failure completions) according to the task filters */
  totalAnomaliesByTaskResults: Maybe<Scalars['Int']['output']>;
};

/** Site performance metric by task results by date entity */
export type SitePerformanceMetricByTaskResultsByDate = {
  __typename?: 'SitePerformanceMetricByTaskResultsByDate';
  /** Site ID */
  id: Scalars['ID']['output'];
  /** Period */
  period: Scalars['ISO8601Date']['output'];
  /** [Performance metrics] Total anomalies (warning and failure completions) according to the task filters */
  totalAnomaliesByTaskResults: Scalars['Int']['output'];
};

/** Site sorts */
export type SiteSortInputObject = {
  /** Created at */
  createdAt?: InputMaybe<SortDirectionEnum>;
  /** Name */
  name?: InputMaybe<SortDirectionEnum>;
  /** Sector name */
  sectorName?: InputMaybe<SortDirectionEnum>;
  /** Number of site areas */
  siteAreasCount?: InputMaybe<SortDirectionEnum>;
  /** [Performance metrics] Success percentage (deadlines missed) according to the task filters */
  successPercentageByTaskDeadlinesMissed?: InputMaybe<SortDirectionEnum>;
  /** [Performance metrics] Success percentage according to the task filters */
  successPercentageByTaskResults?: InputMaybe<SortDirectionEnum>;
  /** [Performance metrics] Total anomalies (deadlines missed) according to the task filters */
  totalAnomaliesByTaskDeadlinesMissed?: InputMaybe<SortDirectionEnum>;
  /** [Performance metrics] Total anomalies (warning and failure completions) according to the task filters */
  totalAnomaliesByTaskResults?: InputMaybe<SortDirectionEnum>;
  /** Number of users (memberships + full admins) */
  usersCount?: InputMaybe<SortDirectionEnum>;
};

/** Description from base input object. Please set your description for child object. */
export type SiteUpdateInput = {
  /** Update attributes */
  attributes: SiteUpdateInputObject;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Site ID */
  id: Scalars['ID']['input'];
};

/** Site attributes */
export type SiteUpdateInputObject = {
  /** Create Site Areas attributes array */
  areas?: InputMaybe<Array<SiteAreaCreateInputObject>>;
  /** Site cellphone */
  cellphone?: InputMaybe<Scalars['String']['input']>;
  /** Create Conduct Code sections attributes array */
  conductCodeSections?: InputMaybe<Array<SiteConductCodeSectionCreateInputObject>>;
  /** Description */
  description?: InputMaybe<Scalars['String']['input']>;
  /** Site contact email */
  email?: InputMaybe<Scalars['String']['input']>;
  /** Location photo */
  locationPhotoAttached?: InputMaybe<AttachmentCuInputObject>;
  /** Location point */
  locationPoint?: InputMaybe<LocationCuInputObject>;
  /** Name */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Site contact phone number */
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  /** Sector ID */
  sectorId?: InputMaybe<Scalars['ID']['input']>;
  /** Responsible user ID */
  userId?: InputMaybe<Scalars['ID']['input']>;
  /** User memberships attributes array (not full admins) */
  userMemberships?: InputMaybe<Array<LinkingInputObject>>;
};

/** Sort directions */
export enum SortDirectionEnum {
  /** Ascending */
  Asc = 'asc',
  /** Descending */
  Desc = 'desc'
}

/** SSO availability check result */
export type SsoCheck = {
  __typename?: 'SsoCheck';
  /** Indicates if password login is allowed (always true) */
  passwordAllowed: Scalars['Boolean']['output'];
  /** Indicates if SSO is available for this email domain */
  ssoEnabled: Scalars['Boolean']['output'];
  /** List of available SSO integrations for this domain */
  ssoIntegrations: Array<SsoIntegrationPreview>;
};

/** Generated SSO code */
export type SsoGeneratedCode = {
  __typename?: 'SsoGeneratedCode';
  /** Assertion Consumer Service URL */
  acsUrl: Scalars['String']['output'];
  /** Unique code for the SSO integration */
  code: Scalars['String']['output'];
  /** Service Provider entity ID */
  entityId: Scalars['String']['output'];
  /** Service Provider metadata URL */
  metadataUrl: Scalars['String']['output'];
};

/** SSO integration entity */
export type SsoIntegration = TimestampInterface & {
  __typename?: 'SsoIntegration';
  /** Whether IdP-initiated SSO login is allowed */
  allowIdpInitiated: Scalars['Boolean']['output'];
  /** Attribute mapping configuration */
  attributeMapping: Maybe<Scalars['JSON']['output']>;
  /** Unique code for the SSO integration */
  code: Scalars['String']['output'];
  /** Associated company domains */
  companyDomains: Array<CompanyDomain>;
  /** Time when was created */
  createdAt: Scalars['ISO8601DateTime']['output'];
  /** Display status (computed based on status and domain verification) */
  displayStatus: SsoIntegrationDisplayStatusEnum;
  /** SSO integration icon */
  icon: Maybe<Attachment>;
  /** SSO integration ID */
  id: Scalars['ID']['output'];
  /** IdP metadata XML */
  idpMetadata: Maybe<Scalars['String']['output']>;
  /** Indicates if Just-In-Time provisioning is enabled */
  jitProvisioningEnabled: Scalars['Boolean']['output'];
  /** Name */
  name: Scalars['String']['output'];
  /** Indicates if the SSO integration is pinned */
  pinned: Scalars['Boolean']['output'];
  /** Provider preset */
  providerPreset: SsoIntegrationProviderPresetEnum;
  /** Provider type */
  providerType: SsoIntegrationProviderTypeEnum;
  /** Status (admin-controlled) */
  status: SsoIntegrationStatusEnum;
  /** Sync user attributes from IdP on each login */
  syncUserAttributes: Scalars['Boolean']['output'];
  /** Time tolerance for SAML assertions in seconds */
  timeToleranceSeconds: Maybe<Scalars['Int']['output']>;
  /** Last update time */
  updatedAt: Scalars['ISO8601DateTime']['output'];
  /** Warning key for configuration issues */
  warningKey: Maybe<SsoIntegrationWarningKeyEnum>;
};

/** Description from base input object. Please set your description for child object. */
export type SsoIntegrationActivateInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** SSO integration ID */
  id: Scalars['ID']['input'];
};

/** SsoIntegrationCollection type */
export type SsoIntegrationCollection = {
  __typename?: 'SsoIntegrationCollection';
  /** A collection of paginated SsoIntegrationCollection */
  collection: Array<SsoIntegration>;
  /** Pagination Metadata for navigating the Pagination */
  metadata: CollectionMetadata;
};

/** Description from base input object. Please set your description for child object. */
export type SsoIntegrationCreateInput = {
  /** Create attributes */
  attributes: SsoIntegrationCreateInputObject;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** SSO integration attributes */
export type SsoIntegrationCreateInputObject = {
  /** Allow Identity Provider initiated SSO login */
  allowIdpInitiated?: InputMaybe<Scalars['Boolean']['input']>;
  /** Attribute mapping configuration */
  attributeMapping: Scalars['JSON']['input'];
  /** Unique code for the SSO integration. Becomes a URL path segment, so letters, digits, hyphens and underscores only. Generated when omitted. */
  code?: InputMaybe<Scalars['String']['input']>;
  /** Company domain IDs to associate */
  companyDomainIds: Array<LinkingInputObject>;
  /** SSO integration icon */
  iconAttached?: InputMaybe<AttachmentCuInputObject>;
  /** IdP metadata (raw XML or base64-encoded XML) */
  idpMetadata: Scalars['String']['input'];
  /** Indicates if Just-In-Time provisioning is enabled */
  jitProvisioningEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** Name */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Indicates if the SSO integration is pinned */
  pinned?: InputMaybe<Scalars['Boolean']['input']>;
  /** Provider preset */
  providerPreset: SsoIntegrationProviderPresetEnum;
  /** Provider type */
  providerType: SsoIntegrationProviderTypeEnum;
  /** Sync user attributes from IdP on each login */
  syncUserAttributes?: InputMaybe<Scalars['Boolean']['input']>;
  /** Time tolerance for SAML assertions in seconds */
  timeToleranceSeconds?: InputMaybe<Scalars['Int']['input']>;
};

/** Description from base input object. Please set your description for child object. */
export type SsoIntegrationDeactivateInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** SSO integration ID */
  id: Scalars['ID']['input'];
};

/** Description from base input object. Please set your description for child object. */
export type SsoIntegrationDestroyInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** SSO integration ID */
  id: Scalars['ID']['input'];
};

/** Available SSO integration display statuses */
export enum SsoIntegrationDisplayStatusEnum {
  Active = 'ACTIVE',
  Deactivated = 'DEACTIVATED',
  Misconfigured = 'MISCONFIGURED'
}

/** SSO integration filters */
export type SsoIntegrationFilterInputObject = {
  /** Company domain ID */
  companyDomainsId?: InputMaybe<FilterIdInputObject>;
  /** SSO integration name */
  name?: InputMaybe<FilterInputObject>;
  /** Provider type */
  providerType?: InputMaybe<FilterInputObject>;
};

/** SSO integration preview for login page */
export type SsoIntegrationPreview = {
  __typename?: 'SsoIntegrationPreview';
  /** SSO integration code for constructing init URL */
  code: Scalars['String']['output'];
  /** Custom icon (for custom preset) */
  icon: Maybe<Attachment>;
  /** Display name */
  name: Scalars['String']['output'];
  /** Provider preset (for displaying provider icon) */
  providerPreset: SsoIntegrationProviderPresetEnum;
};

/** Available SSO provider presets */
export enum SsoIntegrationProviderPresetEnum {
  Auth0 = 'AUTH0',
  Custom = 'CUSTOM',
  Google = 'GOOGLE',
  Microsoft = 'MICROSOFT',
  Okta = 'OKTA',
  Onelogin = 'ONELOGIN'
}

/** Available SSO provider types */
export enum SsoIntegrationProviderTypeEnum {
  Saml = 'SAML'
}

/** SSO integration sorts */
export type SsoIntegrationSortInputObject = {
  /** Created at */
  createdAt?: InputMaybe<SortDirectionEnum>;
  /** Name */
  name?: InputMaybe<SortDirectionEnum>;
  /** Updated at */
  updatedAt?: InputMaybe<SortDirectionEnum>;
};

/** Available SSO integration statuses */
export enum SsoIntegrationStatusEnum {
  Active = 'ACTIVE',
  Deactivated = 'DEACTIVATED'
}

/** Description from base input object. Please set your description for child object. */
export type SsoIntegrationUpdateInput = {
  /** Update attributes */
  attributes: SsoIntegrationUpdateInputObject;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** SSO integration ID */
  id: Scalars['ID']['input'];
};

/** SSO integration attributes */
export type SsoIntegrationUpdateInputObject = {
  /** Allow Identity Provider initiated SSO login */
  allowIdpInitiated?: InputMaybe<Scalars['Boolean']['input']>;
  /** Attribute mapping configuration */
  attributeMapping?: InputMaybe<Scalars['JSON']['input']>;
  /** Company domain IDs to associate */
  companyDomainIds?: InputMaybe<Array<LinkingInputObject>>;
  /** SSO integration icon */
  iconAttached?: InputMaybe<AttachmentCuInputObject>;
  /** IdP metadata (raw XML or base64-encoded XML) */
  idpMetadata?: InputMaybe<Scalars['String']['input']>;
  /** Indicates if Just-In-Time provisioning is enabled */
  jitProvisioningEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** Name */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Indicates if the SSO integration is pinned */
  pinned?: InputMaybe<Scalars['Boolean']['input']>;
  /** Sync user attributes from IdP on each login */
  syncUserAttributes?: InputMaybe<Scalars['Boolean']['input']>;
  /** Time tolerance for SAML assertions in seconds */
  timeToleranceSeconds?: InputMaybe<Scalars['Int']['input']>;
};

/** SSO integration warning keys */
export enum SsoIntegrationWarningKeyEnum {
  NoVerifiedDomains = 'NO_VERIFIED_DOMAINS',
  SomeDomainsNotVerified = 'SOME_DOMAINS_NOT_VERIFIED'
}

/** SSO attribute mapping field */
export type SsoMappingField = {
  __typename?: 'SsoMappingField';
  /** Help text explaining the field purpose and constraints */
  description: Maybe<Scalars['String']['output']>;
  /** Field key */
  key: Scalars['String']['output'];
  /** Field label */
  label: Scalars['String']['output'];
  /** Indicates if the field is required */
  required: Scalars['Boolean']['output'];
  /** Display order index for the field */
  sortIndex: Scalars['Int']['output'];
};

/** List of subscriptions */
export type Subscription = {
  __typename?: 'Subscription';
  /**
   *
   * ATTENTION: Requires plan upgrade for feature: DOCUMENTATION_MANAGEMENT, AI_ASSISTANCE.
   */
  aiBudgetStatus: AiBudgetStatus;
  /**
   *
   * ATTENTION: Requires plan upgrade for feature: DOCUMENTATION_MANAGEMENT, AI_ASSISTANCE.
   */
  aiCompanyIndexingCoverageChanged: AiIndexingCoverage;
  /**
   *
   * ATTENTION: Requires plan upgrade for feature: DOCUMENTATION_MANAGEMENT, AI_ASSISTANCE.
   */
  aiConversationStream: AiConversationStreamEvent;
  /**
   *
   * ATTENTION: Requires plan upgrade for feature: DOCUMENTATION_MANAGEMENT, AI_ASSISTANCE.
   */
  aiDocumentationFieldsGenerated: AiFieldsGeneration;
  /**
   *
   * ATTENTION: Requires plan upgrade for feature: DOCUMENTATION_MANAGEMENT, AI_ASSISTANCE.
   */
  aiDocumentationVersionFieldsGenerated: AiFieldsGeneration;
  /** Streams the document-indexing coverage of the company identified by companyId as it changes — the counterpart of aiCompanyIndexingCoverageChanged (which streams the requesting company's own) for a specified company. Same frames and rollup. Restricted to system administrators. */
  aiIndexingCoverageChanged: AiIndexingCoverage;
  /** Streams progress and status frames for background jobs. Pass rootId to follow a single tree, or omit it to receive every one of your jobs on one stream. Each frame carries the changed node (status, counters, estimatedFinishAt); the client holds the tree(s) and applies the node delta by id. Scoped to the requesting owner. */
  backgroundJobProgress: BackgroundJobProgressEvent;
};


/** List of subscriptions */
export type SubscriptionAiConversationStreamArgs = {
  conversationId: Scalars['ID']['input'];
};


/** List of subscriptions */
export type SubscriptionAiDocumentationFieldsGeneratedArgs = {
  generationId: Scalars['ID']['input'];
};


/** List of subscriptions */
export type SubscriptionAiDocumentationVersionFieldsGeneratedArgs = {
  generationId: Scalars['ID']['input'];
};


/** List of subscriptions */
export type SubscriptionAiIndexingCoverageChangedArgs = {
  companyId: Scalars['ID']['input'];
};


/** List of subscriptions */
export type SubscriptionBackgroundJobProgressArgs = {
  rootId?: InputMaybe<Scalars['ID']['input']>;
};

/** SystemAdmin entity */
export type SystemAdmin = TimestampInterface & TwoFactorAuthenticatableInterface & UserInterface & {
  __typename?: 'SystemAdmin';
  /** Avatar */
  avatarAttached: Maybe<Attachment>;
  /** Time when was created */
  createdAt: Scalars['ISO8601DateTime']['output'];
  /** Deactivation time */
  deactivatedAt: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** Time until debug mode is active */
  debugModeUntil: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** Email */
  email: Maybe<Scalars['String']['output']>;
  /** First name */
  firstName: Scalars['String']['output'];
  /** Indicates if user has a password set */
  hasPassword: Scalars['Boolean']['output'];
  /** SystemAdmin ID */
  id: Scalars['ID']['output'];
  /** Job title */
  jobTitle: Maybe<Scalars['String']['output']>;
  /** Preferred language */
  lang: LanguageEnum;
  /** Last name */
  lastName: Scalars['String']['output'];
  /** Lock time */
  lockedAt: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** Lock reason */
  lockedReason: Maybe<SystemAdminLockedReasonEnum>;
  /** Indicates if password change is required */
  passwordChangeRequired: Scalars['Boolean']['output'];
  /** Password change required reason */
  passwordChangeRequiredReason: Maybe<SystemAdminPasswordChangeRequiredReasonEnum>;
  /** Indicates if user needs to set up password */
  passwordSetupRequired: Scalars['Boolean']['output'];
  /**
   * Last password update time
   * ATTENTION: Access allowed for current resource only.
   */
  passwordUpdatedAt: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** Number of available backup codes */
  twoFactorBackupCodesCount: Scalars['Int']['output'];
  /** Indicates if email OTP method is enabled */
  twoFactorEmailOtpEnabled: Scalars['Boolean']['output'];
  /** Indicates if two-factor authentication is enabled */
  twoFactorEnabled: Scalars['Boolean']['output'];
  /** List of enabled two-factor authentication methods */
  twoFactorEnabledMethods: Array<AuthenticationTwoFactorOtpMethodEnum>;
  /** Timestamp of last successful two-factor verification */
  twoFactorLastVerifiedAt: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** Indicates if two-factor authentication is required for this account */
  twoFactorRequired: Scalars['Boolean']['output'];
  /** Indicates if two-factor authentication reset is required */
  twoFactorResetRequired: Scalars['Boolean']['output'];
  /** Two-factor authentication reset required reason */
  twoFactorResetRequiredReason: Maybe<SystemAdminTwoFactorResetRequiredReasonEnum>;
  /** Indicates if two-factor authentication setup is required */
  twoFactorSetupRequired: Scalars['Boolean']['output'];
  /** Indicates if TOTP (authenticator app) method is enabled */
  twoFactorTotpEnabled: Scalars['Boolean']['output'];
  /** Email awaiting confirmation */
  unconfirmedEmail: Maybe<Scalars['String']['output']>;
  /** Last update time */
  updatedAt: Scalars['ISO8601DateTime']['output'];
  /** Indicates if user has verified email */
  verified: Maybe<Scalars['Boolean']['output']>;
};

/** SystemAdminCollection type */
export type SystemAdminCollection = {
  __typename?: 'SystemAdminCollection';
  /** A collection of paginated SystemAdminCollection */
  collection: Array<SystemAdmin>;
  /** Pagination Metadata for navigating the Pagination */
  metadata: CollectionMetadata;
};

/** Description from base input object. Please set your description for child object. */
export type SystemAdminCreateInput = {
  /** Create attributes */
  attributes: SystemAdminCreateInputObject;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Url to confirm registration */
  redirectUrl: Scalars['String']['input'];
};

/** System Admin attributes */
export type SystemAdminCreateInputObject = {
  /** Email */
  email: Scalars['String']['input'];
  /** First name */
  firstName: Scalars['String']['input'];
  /** Job title */
  jobTitle?: InputMaybe<Scalars['String']['input']>;
  /** Interface preferred language */
  lang: LanguageEnum;
  /** Last name */
  lastName: Scalars['String']['input'];
};

/** Description from base input object. Please set your description for child object. */
export type SystemAdminDestroyInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** System Admin ID */
  id: Scalars['ID']['input'];
};

/** System Admin filters */
export type SystemAdminFilterInputObject = {
  /** Full name */
  fullName?: InputMaybe<FilterInputObject>;
  /** Job title */
  jobTitle?: InputMaybe<FilterInputObject>;
};

/** Available locked reasons */
export enum SystemAdminLockedReasonEnum {
  SecurityNotYou = 'SECURITY__NOT_YOU'
}

/** Available password change required reasons */
export enum SystemAdminPasswordChangeRequiredReasonEnum {
  SecurityNotYou = 'SECURITY__NOT_YOU'
}

/** Description from base input object. Please set your description for child object. */
export type SystemAdminSelfUpdateInput = {
  /** Update attributes */
  attributes: SystemAdminSelfUpdateInputObject;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Url to confirm new email */
  redirectUrl: Scalars['String']['input'];
};

/** System Admin attributes */
export type SystemAdminSelfUpdateInputObject = {
  /** Avatar */
  avatarAttached?: InputMaybe<AttachmentCuInputObject>;
  /** Cancel email changing */
  cancelConfirmation?: InputMaybe<Scalars['Boolean']['input']>;
  /** Email */
  email?: InputMaybe<Scalars['String']['input']>;
  /** First name */
  firstName?: InputMaybe<Scalars['String']['input']>;
  /** Job title */
  jobTitle?: InputMaybe<Scalars['String']['input']>;
  /** Interface preferred language */
  lang?: InputMaybe<LanguageEnum>;
  /** Last name */
  lastName?: InputMaybe<Scalars['String']['input']>;
};

/** System Admin sorts */
export type SystemAdminSortInputObject = {
  /** Created at */
  createdAt?: InputMaybe<SortDirectionEnum>;
  /** Full name */
  fullName?: InputMaybe<SortDirectionEnum>;
  /** Job title */
  jobTitle?: InputMaybe<SortDirectionEnum>;
};

/** Available two-factor reset required reasons */
export enum SystemAdminTwoFactorResetRequiredReasonEnum {
  SecurityNotYou = 'SECURITY__NOT_YOU'
}

/** Description from base input object. Please set your description for child object. */
export type SystemAdminUpdateInput = {
  /** Update attributes */
  attributes: SystemAdminUpdateInputObject;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Url to confirm new email */
  confirmEmailRedirectUrl: Scalars['String']['input'];
  /** Url to finish registration */
  finishRegistrationRedirectUrl: Scalars['String']['input'];
  /** System Admin ID */
  id: Scalars['ID']['input'];
};

/** System Admin attributes */
export type SystemAdminUpdateInputObject = {
  /** Email */
  email?: InputMaybe<Scalars['String']['input']>;
  /** First name */
  firstName?: InputMaybe<Scalars['String']['input']>;
  /** Job title */
  jobTitle?: InputMaybe<Scalars['String']['input']>;
  /** Last name */
  lastName?: InputMaybe<Scalars['String']['input']>;
};

/** Description from base input object. Please set your description for child object. */
export type SystemAdminUserCreateInput = {
  /** Create attributes */
  attributes: SystemAdminUserCreateInputObject;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Company ID */
  companyId: Scalars['ID']['input'];
  /** Url to confirm registration */
  redirectUrl: Scalars['String']['input'];
};

/** User attributes */
export type SystemAdminUserCreateInputObject = {
  /** Email */
  email: Scalars['String']['input'];
  /** First name */
  firstName: Scalars['String']['input'];
  /** Last name */
  lastName: Scalars['String']['input'];
  /** Role */
  role: UserRoleEnum;
};

/** Tag entity */
export type Tag = TimestampInterface & {
  __typename?: 'Tag';
  canDestroy: AuthorizationResult;
  /** Time when was created */
  createdAt: Scalars['ISO8601DateTime']['output'];
  /** Tag ID */
  id: Scalars['ID']['output'];
  /** Name */
  name: Scalars['String']['output'];
  /** Last update time */
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

/** TagCollection type */
export type TagCollection = {
  __typename?: 'TagCollection';
  /** A collection of paginated TagCollection */
  collection: Array<Tag>;
  /** Pagination Metadata for navigating the Pagination */
  metadata: CollectionMetadata;
};

/** Description from base input object. Please set your description for child object. */
export type TagCreateInput = {
  /** Create attributes */
  attributes: TagCreateInputObject;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Tag attributes */
export type TagCreateInputObject = {
  /** Name */
  name: Scalars['String']['input'];
};

/** Description from base input object. Please set your description for child object. */
export type TagDestroyInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** ID */
  id: Scalars['ID']['input'];
};

/** Tag filters */
export type TagFilterInputObject = {
  /** Name */
  name?: InputMaybe<FilterInputObject>;
};

/** Tag sorts */
export type TagSortInputObject = {
  /** Created at */
  createdAt?: InputMaybe<SortDirectionEnum>;
  /** Name */
  name?: InputMaybe<SortDirectionEnum>;
};

/** Task entity */
export type Task = TimestampInterface & {
  __typename?: 'Task';
  /**
   * User entity
   * NOTE: if you only need an Object ID, please use the approverId field to reduce the load on the database.
   */
  approver: Maybe<User>;
  /** Approver ID */
  approverId: Maybe<Scalars['ID']['output']>;
  /** Archived date */
  archivedAt: Maybe<Scalars['ISO8601DateTime']['output']>;
  /**
   * Asset entity
   * NOTE: if you only need an Object ID, please use the assetId field to reduce the load on the database.
   */
  asset: Maybe<Asset>;
  /** Asset ID */
  assetId: Maybe<Scalars['ID']['output']>;
  canArchive: AuthorizationResult;
  canCompletionCreate: AuthorizationResult;
  canDestroy: AuthorizationResult;
  canFormTemplateVersionUpdate: AuthorizationResult;
  canInterventionCreate: AuthorizationResult;
  canQrCodeRelatedInfoUpdate: AuthorizationResult;
  canReschedule: AuthorizationResult;
  canUpdate: AuthorizationResult;
  /** Completed date */
  completedAt: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** Task completion entity */
  completion: Maybe<TaskCompletion>;
  /** Time when was created */
  createdAt: Scalars['ISO8601DateTime']['output'];
  /** Deadline date (On date or Next check - for non completed tasks) */
  deadlineAt: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** Shows the reason why the deadline was missed. */
  deadlineMissedReason: Maybe<TaskDeadlineMissedReasonEnum>;
  /** Indicates if the deadline was missed before. */
  deadlineWasMissed: Scalars['Boolean']['output'];
  /** Description */
  description: Maybe<Scalars['String']['output']>;
  /** Early completion */
  earlyCompletion: Maybe<Scalars['Int']['output']>;
  /** Early completion unit */
  earlyCompletionUnit: Maybe<TaskEarlyCompletionUnitEnum>;
  /** Form Template entity */
  formTemplate: FormTemplate;
  /** Form Template Version entity */
  formTemplateVersion: FormTemplateVersion;
  /** Key to group the same tasks which are recurring or have been recurred (if recurring rule was deleted in some point) */
  groupKey: Scalars['ID']['output'];
  /** Whether this task's recurring chain (shared group_key) has at least one documentation linked */
  hasLinkedDocumentations: Maybe<Scalars['Boolean']['output']>;
  /** Task ID */
  id: Scalars['ID']['output'];
  /** Intervention entity */
  intervention: Maybe<Intervention>;
  /** Task kind (standard or on-demand) */
  kind: TaskKindEnum;
  /** Form Answers from previous completion that allowed to be shown in the form */
  lastAllowedAnswers: Array<FormAnswer>;
  /** Last check date (Completion date for previous task completion) */
  lastCheckAt: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** Last deadline date */
  lastDeadlineAt: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** Shows how many days the missed deadline. If the task is not missed, the value is null. */
  lateFor: Maybe<Scalars['Int']['output']>;
  /** Name */
  name: Scalars['String']['output'];
  /** Next deadline date (Next check date - for recurring tasks which have the next created task) */
  nextDeadlineAt: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** Important data digest for todo tasks (changes when the data is changed) [NULL means that not implemented for the query] */
  offlineImportantDataDigest: Maybe<Scalars['String']['output']>;
  /** Original creation date (for recurring tasks) */
  originalCreatedAt: Scalars['ISO8601DateTime']['output'];
  /** Priority */
  priority: TaskPriorityEnum;
  /**
   * Recurring rule entity
   * NOTE: if you only need an Object ID, please use the recurringRuleId field to reduce the load on the database.
   */
  recurringRule: Maybe<RecurringRule>;
  /** Recurring rule ID */
  recurringRuleId: Maybe<Scalars['ID']['output']>;
  /**
   * Site entity
   * NOTE: if you only need an Object ID, please use the siteId field to reduce the load on the database.
   */
  site: Maybe<Site>;
  /**
   * Site Area entity
   * NOTE: if you only need an Object ID, please use the siteAreaId field to reduce the load on the database.
   */
  siteArea: Maybe<SiteArea>;
  /** Site Area ID */
  siteAreaId: Maybe<Scalars['ID']['output']>;
  /** Site ID */
  siteId: Maybe<Scalars['ID']['output']>;
  /** Status */
  status: TaskStatusEnum;
  /** Last update time */
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

/** Task attributes */
export type TaskAssignationsInputObject = {
  /** Asset ID */
  assetIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Site Area ID */
  siteAreaIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};

/** Description from base input object. Please set your description for child object. */
export type TaskBulkCreateSameInput = {
  /** Create attributes */
  attributes: TaskBulkCreateSameInputObject;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Task attributes */
export type TaskBulkCreateSameInputObject = {
  /** Approver ID */
  approverId: Scalars['ID']['input'];
  /** Assignations attributes array */
  assignations: TaskAssignationsInputObject;
  /** Deadline at (On date) */
  deadlineAt?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  /** Department links (a link applies to the whole recurring task group) */
  departmentLinks?: InputMaybe<Array<LinkingInputObject>>;
  /** Description */
  description?: InputMaybe<Scalars['String']['input']>;
  /**
   * Documentation links
   * ATTENTION: Requires plan upgrade for feature: DOCUMENTATION_MANAGEMENT.
   */
  documentationLinks?: InputMaybe<Array<DocumentationLinkInputObject>>;
  /** Early completion */
  earlyCompletion?: InputMaybe<Scalars['Int']['input']>;
  /** Early completion unit */
  earlyCompletionUnit?: InputMaybe<TaskEarlyCompletionUnitEnum>;
  /** Task kind (standard or on-demand) */
  kind: TaskKindEnum;
  /** Name */
  name: Scalars['String']['input'];
  /** Priority */
  priority: TaskPriorityEnum;
  /** Recurring rule attributes */
  recurringRule?: InputMaybe<RecurringRuleInputObject>;
  /** Form Template ID */
  templateId: Scalars['ID']['input'];
  /** Form Template Version ID */
  templateVersionId: Scalars['ID']['input'];
};

/** Description from base input object. Please set your description for child object. */
export type TaskBulkDeadlineMissedReasonUpdateInput = {
  /** Update attributes */
  attributes: TaskUpdateDeadlineMissedReasonInputObject;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Task IDs */
  ids: Array<Scalars['ID']['input']>;
};

/** Description from base input object. Please set your description for child object. */
export type TaskBulkSchedulingInput = {
  /** Scheduling params */
  attributes: TaskBulkSchedulingInputObject;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Task IDs */
  ids: Array<Scalars['ID']['input']>;
};

/** Task attributes */
export type TaskBulkSchedulingInputObject = {
  /** Deadline at (On date) */
  deadlineAt?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  /** Early completion */
  earlyCompletion?: InputMaybe<Scalars['Int']['input']>;
  /** Early completion unit */
  earlyCompletionUnit?: InputMaybe<TaskEarlyCompletionUnitEnum>;
  /** Task kind (standard or on-demand) */
  kind: TaskKindEnum;
  /** Recurring rule attributes */
  recurringRule?: InputMaybe<RecurringRuleInputObject>;
};

/** Description from base input object. Please set your description for child object. */
export type TaskBulkTemplateVersionUpdateInput = {
  /** Update attributes */
  attributes: TaskUpdateTemplateVersionInputObject;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Task IDs */
  ids: Array<Scalars['ID']['input']>;
  /** Form Template ID */
  templateId: Scalars['ID']['input'];
};

/** Description from base input object. Please set your description for child object. */
export type TaskBulkUpdateStatusInput = {
  /** Update attributes */
  attributes: TaskUpdateStatusInputObject;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Task IDs */
  ids: Array<Scalars['ID']['input']>;
};

/** TaskCollection type */
export type TaskCollection = {
  __typename?: 'TaskCollection';
  /** A collection of paginated TaskCollection */
  collection: Array<Task>;
  /** Pagination Metadata for navigating the Pagination */
  metadata: CollectionMetadata;
};

/** Task completion entity */
export type TaskCompletion = TimestampInterface & {
  __typename?: 'TaskCompletion';
  /** Form Answers collection */
  answers: Maybe<Array<FormAnswer>>;
  canStatusUpdate: AuthorizationResult;
  /** Time when was created */
  createdAt: Scalars['ISO8601DateTime']['output'];
  /** Task Completion ID */
  id: Scalars['ID']['output'];
  /**
   * Performer entity
   * NOTE: if you only need an Object ID, please use the performerId field to reduce the load on the database.
   */
  performer: Maybe<User>;
  /** Performer ID */
  performerId: Maybe<Scalars['ID']['output']>;
  /**
   * Solved date
   * ATTENTION: Access allowed for users: [TASKS_MANAGEMENT:READ].
   */
  solvedAt: Maybe<Scalars['ISO8601DateTime']['output']>;
  /**
   * Result status
   * ATTENTION: Access allowed for users: [TASKS_MANAGEMENT:READ].
   */
  status: Maybe<TaskCompletionStatusEnum>;
  /**
   * Task entity
   * NOTE: if you only need an Object ID, please use the taskId field to reduce the load on the database.
   */
  task: Maybe<Task>;
  /** Task ID */
  taskId: Maybe<Scalars['ID']['output']>;
  /** Last update time */
  updatedAt: Scalars['ISO8601DateTime']['output'];
  /**
   * Indicates if task completion is expected to be valid
   * ATTENTION: Access allowed for users: [TASKS_MANAGEMENT:READ].
   */
  validityHint: Maybe<FormTemplateQuestionFieldOptionsValidityHintEnum>;
};

/** TaskCompletionCollection type */
export type TaskCompletionCollection = {
  __typename?: 'TaskCompletionCollection';
  /** A collection of paginated TaskCompletionCollection */
  collection: Array<TaskCompletion>;
  /** Pagination Metadata for navigating the Pagination */
  metadata: CollectionMetadata;
};

/** Description from base input object. Please set your description for child object. */
export type TaskCompletionCreateInput = {
  /** Create attributes */
  attributes: TaskCompletionCreateInputObject;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Task completion attributes */
export type TaskCompletionCreateInputObject = {
  /** Answers attributes array */
  answers: Array<FormAnswerCreateInputObject>;
  /** Task ID */
  taskId: Scalars['ID']['input'];
};

/** Task completion filters */
export type TaskCompletionFilterInputObject = {
  /** Created at */
  createdAt?: InputMaybe<FilterDateInputObject>;
  /**
   * Performer ID
   * ATTENTION: Access allowed for users: [TASKS_MANAGEMENT:READ].
   */
  performerId?: InputMaybe<FilterIdInputObject>;
  /**
   * Validity hint
   * ATTENTION: Access allowed for users: [TASKS_MANAGEMENT:READ].
   */
  validityHint?: InputMaybe<FilterInputObject>;
};

/** Task completion sorts */
export type TaskCompletionSortInputObject = {
  /** Created at */
  createdAt?: InputMaybe<SortDirectionEnum>;
  /** Performer full name */
  performerFullName?: InputMaybe<SortDirectionEnum>;
  /** Solved at */
  solvedAt?: InputMaybe<SortDirectionEnum>;
  /** Status */
  status?: InputMaybe<SortDirectionEnum>;
};

/** Available task completion statuses */
export enum TaskCompletionStatusEnum {
  InProgress = 'IN_PROGRESS',
  Solved = 'SOLVED',
  Unsolved = 'UNSOLVED'
}

/** Description from base input object. Please set your description for child object. */
export type TaskCompletionStatusUpdateInput = {
  /** Update attributes */
  attributes: TaskCompletionUpdateStatusInputObject;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Task ID */
  taskId: Scalars['ID']['input'];
};

/** Task completion attributes */
export type TaskCompletionUpdateStatusInputObject = {
  /** Status */
  status: TaskCompletionStatusEnum;
};

/** Available deadline missed reasons */
export enum TaskDeadlineMissedReasonEnum {
  Inaccessible = 'INACCESSIBLE',
  Other = 'OTHER',
  SiteClosed = 'SITE_CLOSED',
  StaffProblem = 'STAFF_PROBLEM',
  UnderConstruction = 'UNDER_CONSTRUCTION'
}

/** Description from base input object. Please set your description for child object. */
export type TaskDestroyInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Task ID */
  id: Scalars['ID']['input'];
};

/** Available early completion units */
export enum TaskEarlyCompletionUnitEnum {
  Day = 'DAY',
  Month = 'MONTH',
  Week = 'WEEK'
}

/** Task filters */
export type TaskFilterInputObject = {
  /** Asset code */
  assetCode?: InputMaybe<FilterInputObject>;
  /** Asset ID */
  assetId?: InputMaybe<FilterIdInputObject>;
  /** Asset name */
  assetName?: InputMaybe<FilterInputObject>;
  /** Asset QR prefix */
  assetQrPrefix?: InputMaybe<FilterInputObject>;
  /** Completed at */
  completedAt?: InputMaybe<FilterDateInputObject>;
  /**
   * Completion validity hint
   * ATTENTION: Access allowed for users: [TASKS_MANAGEMENT:READ].
   */
  completionValidityHint?: InputMaybe<FilterInputObject>;
  /** Deadline at */
  deadlineAt?: InputMaybe<FilterDateInputObject>;
  /** Filter to tasks linked to one of these department IDs (matched via shared group_key) */
  departmentsId?: InputMaybe<FilterIdInputObject>;
  /**
   * Filter to tasks linked to one of these documentation IDs (matched via shared group_key)
   * ATTENTION: Requires plan upgrade for feature: DOCUMENTATION_MANAGEMENT.
   */
  documentationsId?: InputMaybe<FilterIdInputObject>;
  /** Form Category ID */
  formCategoryId?: InputMaybe<FilterIdInputObject>;
  /** Form Category name */
  formCategoryName?: InputMaybe<FilterInputObject>;
  /** Recurring group key shared by all occurrences of the same recurring task */
  groupKey?: InputMaybe<FilterIdInputObject>;
  /** Task kind */
  kind?: InputMaybe<FilterIntInputObject>;
  /** Task name */
  name?: InputMaybe<FilterInputObject>;
  /** Task priority */
  priority?: InputMaybe<FilterIntInputObject>;
  /** Site Area code */
  siteAreaCode?: InputMaybe<FilterInputObject>;
  /** Site Area ID */
  siteAreaId?: InputMaybe<FilterIdInputObject>;
  /** Site Area name */
  siteAreaName?: InputMaybe<FilterInputObject>;
  /** Site code */
  siteCode?: InputMaybe<FilterInputObject>;
  /** Site ID */
  siteId?: InputMaybe<FilterIdInputObject>;
  /** Site name */
  siteName?: InputMaybe<FilterInputObject>;
  /** Form Template ID */
  templateId?: InputMaybe<FilterIdInputObject>;
  /** Form Template Version ID */
  templateVersionId?: InputMaybe<FilterIdInputObject>;
};

/** Available task kinds */
export enum TaskKindEnum {
  OnDemand = 'ON_DEMAND',
  Standard = 'STANDARD'
}

/** Available task priorities */
export enum TaskPriorityEnum {
  High = 'HIGH',
  Low = 'LOW',
  Medium = 'MEDIUM'
}

/** Tasks which are linked to form template and grouped by recurring rule */
export type TaskScopeArgsLinkedToFormTemplateGroupedInputObject = {
  /** Form Template ID */
  templateId: Scalars['ID']['input'];
};

/** Custom scope attributes */
export type TaskScopeCustomInputObject = {
  /** Tasks which are linked to form template and grouped by recurring rule */
  linkedToFormTemplateGrouped?: InputMaybe<TaskScopeArgsLinkedToFormTemplateGroupedInputObject>;
};

/** Task scope attributes */
export type TaskScopeInputObject = {
  /** Custom scope attributes */
  custom?: InputMaybe<TaskScopeCustomInputObject>;
  /** Scope name */
  name?: InputMaybe<TaskScopeNameEnum>;
};

/** Available task scope names */
export enum TaskScopeNameEnum {
  /** Current active tasks (not completed yet but validated) */
  Active = 'ACTIVE',
  /** Archived tasks */
  Archived = 'ARCHIVED',
  /** Archived tasks grouped by recurrence */
  ArchivedGrouped = 'ARCHIVED_GROUPED',
  /** Completed tasks */
  Completed = 'COMPLETED',
  /** Completed tasks grouped by recurrence */
  CompletedGrouped = 'COMPLETED_GROUPED',
  /** Tasks that are the latest occurrence in their recurring chain (not yet superseded by a regenerated task) */
  Current = 'CURRENT',
  /** All tasks for dashboard */
  DashboardAll = 'DASHBOARD_ALL',
  /** All tasks for dashboard and grouped by recurring rule */
  DashboardAllGrouped = 'DASHBOARD_ALL_GROUPED',
  /** Tasks with missed deadline */
  DeadlineMissed = 'DEADLINE_MISSED',
  /** Tasks with missed deadline without selected deadline missed reason */
  DeadlineMissedWithoutReason = 'DEADLINE_MISSED_WITHOUT_REASON',
  /** Completed tasks with failure result */
  Failure = 'FAILURE',
  /** Solved completed tasks with failure result */
  FailureSolved = 'FAILURE_SOLVED',
  /** Unsolved completed tasks with failure result */
  FailureUnsolved = 'FAILURE_UNSOLVED',
  /** Current tasks need to be validated */
  MyApprovals = 'MY_APPROVALS',
  /** Completed tasks assigned to me */
  MyCompleted = 'MY_COMPLETED',
  /** Tasks assigned to me and available to complete */
  MyTodoAvailableToComplete = 'MY_TODO_AVAILABLE_TO_COMPLETE',
  /** Tasks assigned to me and not available to complete yet because of deadline date */
  MyTodoUpcoming = 'MY_TODO_UPCOMING',
  /** Completed tasks with non success result and without intervention */
  NonSuccessWithoutIntervention = 'NON_SUCCESS_WITHOUT_INTERVENTION',
  /** Tasks which have not processed yet and grouped by recurring rule */
  NotProcessedGrouped = 'NOT_PROCESSED_GROUPED',
  /** Current tasks that are on validation or validated */
  OnValidationOrValidated = 'ON_VALIDATION_OR_VALIDATED',
  /** Current pending tasks (not completed nor validated yet) */
  Pending = 'PENDING',
  /** Solved completed tasks (with warning or failure result) */
  Solved = 'SOLVED',
  /** Completed tasks with success result */
  Success = 'SUCCESS',
  /** Completed tasks with warning result */
  Warning = 'WARNING',
  /** Solved completed tasks with warning result */
  WarningSolved = 'WARNING_SOLVED',
  /** Unsolved completed tasks with warning result */
  WarningUnsolved = 'WARNING_UNSOLVED'
}

/** Task sorts */
export type TaskSortInputObject = {
  /** Archived at */
  archivedAt?: InputMaybe<SortDirectionEnum>;
  /** Asset name */
  assetName?: InputMaybe<SortDirectionEnum>;
  /** Completed at */
  completedAt?: InputMaybe<SortDirectionEnum>;
  /** Completion solved at */
  completionSolvedAt?: InputMaybe<SortDirectionEnum>;
  /** Completion status */
  completionStatus?: InputMaybe<SortDirectionEnum>;
  /** Created at */
  createdAt?: InputMaybe<SortDirectionEnum>;
  /** Deadline date (On date or Next check - for non completed tasks) */
  deadlineAt?: InputMaybe<SortDirectionEnum>;
  /** Deadline missed reason */
  deadlineMissedReason?: InputMaybe<SortDirectionEnum>;
  /** Form Category name */
  formCategoryName?: InputMaybe<SortDirectionEnum>;
  /** Task kind */
  kind?: InputMaybe<SortDirectionEnum>;
  /** Last check at */
  lastCheckAt?: InputMaybe<SortDirectionEnum>;
  /** Last deadline date */
  lastDeadlineAt?: InputMaybe<SortDirectionEnum>;
  /** Shows how many days the missed deadline. If the task is not missed, the value is null. */
  lateFor?: InputMaybe<SortDirectionEnum>;
  /** Name */
  name?: InputMaybe<SortDirectionEnum>;
  /** Next deadline date (Next check date - for recurring tasks which have the next created task) */
  nextDeadlineAt?: InputMaybe<SortDirectionEnum>;
  /** Priority */
  priority?: InputMaybe<SortDirectionEnum>;
  /** Site Area name */
  siteAreaName?: InputMaybe<SortDirectionEnum>;
  /** Site name */
  siteName?: InputMaybe<SortDirectionEnum>;
  /** Status */
  status?: InputMaybe<SortDirectionEnum>;
  /** Form Template name */
  templateName?: InputMaybe<SortDirectionEnum>;
  /** Form Template Version version */
  templateVersionVersion?: InputMaybe<SortDirectionEnum>;
};

/** Available task statuses */
export enum TaskStatusEnum {
  Archived = 'ARCHIVED',
  Completed = 'COMPLETED',
  OnValidation = 'ON_VALIDATION',
  Rejected = 'REJECTED',
  Validated = 'VALIDATED'
}

/** Task timeline */
export type TaskTimeline = {
  __typename?: 'TaskTimeline';
  /** Task ID */
  id: Scalars['ID']['output'];
  /** Timeline rows */
  rows: Array<TaskTimelineRow>;
};

/** Available timeline completion group by options */
export enum TaskTimelineCompletionGroupByEnum {
  FormCategory = 'FORM_CATEGORY',
  FormTemplate = 'FORM_TEMPLATE',
  SiteArea = 'SITE_AREA'
}

/** Available timeline frames */
export enum TaskTimelineFrameEnum {
  Month = 'MONTH',
  Quarter = 'QUARTER',
  Week = 'WEEK',
  Year = 'YEAR'
}

/** Available timeline group by options */
export enum TaskTimelineGroupByEnum {
  Day = 'DAY',
  Month = 'MONTH'
}

/** Timeline query data attributes */
export type TaskTimelineQueryDataInputObject = {
  /** Date range */
  dateRange: DateRangeInputObject;
  /** Group by */
  groupBy: TaskTimelineGroupByEnum;
  /** Validity hints */
  validityHints?: InputMaybe<Array<FormTemplateQuestionFieldOptionsValidityHintEnum>>;
};

/** Timeline report attributes */
export type TaskTimelineReportCreateInputObject = {
  /** Completion group by */
  completionGroupBy: TaskTimelineCompletionGroupByEnum;
  /** Message to recipient */
  message?: InputMaybe<Scalars['String']['input']>;
  /** Query data */
  queryData: TaskTimelineQueryDataInputObject;
  /** Task IDs */
  taskIds: Array<Scalars['ID']['input']>;
  /** Time frame */
  timeFrame: TaskTimelineFrameEnum;
  /** Recipient user ID */
  userId?: InputMaybe<Scalars['ID']['input']>;
};

/** Timeline row */
export type TaskTimelineRow = {
  __typename?: 'TaskTimelineRow';
  /** Date */
  date: Scalars['String']['output'];
  /** Validity hint counters */
  validityHintCounters: TaskTimelineValidityHintCounter;
};

/** Validity hint counter */
export type TaskTimelineValidityHintCounter = {
  __typename?: 'TaskTimelineValidityHintCounter';
  /** Failure */
  failure: Maybe<Scalars['Int']['output']>;
  /** Hint is absent (no answers where hint was set) */
  none: Maybe<Scalars['Int']['output']>;
  /** Success */
  success: Maybe<Scalars['Int']['output']>;
  /** Warning */
  warning: Maybe<Scalars['Int']['output']>;
};

/** Description from base input object. Please set your description for child object. */
export type TaskUnlinkAllDocumentationsInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Recurring group key shared by all occurrences of the same recurring task */
  groupKey: Scalars['ID']['input'];
};

/** Task attributes */
export type TaskUpdateDeadlineMissedReasonInputObject = {
  /** Deadline missed reason */
  deadlineMissedReason: TaskDeadlineMissedReasonEnum;
};

/** Description from base input object. Please set your description for child object. */
export type TaskUpdateInput = {
  /** Update attributes */
  attributes: TaskUpdateInputObject;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Task ID */
  id: Scalars['ID']['input'];
};

/** Task attributes */
export type TaskUpdateInputObject = {
  /** Approver ID */
  approverId?: InputMaybe<Scalars['ID']['input']>;
  /** Asset ID */
  assetId?: InputMaybe<Scalars['ID']['input']>;
  /** Department links (a link applies to the whole recurring task group) */
  departmentLinks?: InputMaybe<Array<LinkingInputObject>>;
  /** Description */
  description?: InputMaybe<Scalars['String']['input']>;
  /**
   * Documentation links
   * ATTENTION: Requires plan upgrade for feature: DOCUMENTATION_MANAGEMENT.
   */
  documentationLinks?: InputMaybe<Array<DocumentationLinkInputObject>>;
  /** Name */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Priority */
  priority?: InputMaybe<TaskPriorityEnum>;
  /** Site Area ID */
  siteAreaId?: InputMaybe<Scalars['ID']['input']>;
  /** Form Template ID */
  templateId?: InputMaybe<Scalars['ID']['input']>;
  /** Form Template Version ID */
  templateVersionId?: InputMaybe<Scalars['ID']['input']>;
};

/** Task attributes */
export type TaskUpdateStatusInputObject = {
  /** Status */
  status: TaskStatusEnum;
};

/** Task attributes */
export type TaskUpdateTemplateVersionInputObject = {
  /** Form Template Version ID */
  templateVersionId: Scalars['ID']['input'];
};

/** Description from base input object. Please set your description for child object. */
export type TasksTimelineReportCreateInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Params */
  params: TaskTimelineReportCreateInputObject;
};

/** Task entity */
export type TasksTodoCompletableByDateData = {
  __typename?: 'TasksTodoCompletableByDateData';
  /** Task ID */
  id: Scalars['ID']['output'];
  /** Important data digest for todo tasks (changes when the data is changed) [NULL means that not implemented for the query] */
  offlineImportantDataDigest: Scalars['String']['output'];
};

/** Team entity */
export type Team = TimestampInterface & {
  __typename?: 'Team';
  /** Related accesses */
  accesses: Array<Access>;
  canDestroy: AuthorizationResult;
  /** Color */
  color: ColorEnum;
  /** Time when was created */
  createdAt: Scalars['ISO8601DateTime']['output'];
  /** Description */
  description: Maybe<Scalars['String']['output']>;
  /** Team ID */
  id: Scalars['ID']['output'];
  /** Name */
  name: Maybe<Scalars['String']['output']>;
  /** Indicates if team is read only (default system team) */
  readOnly: Scalars['Boolean']['output'];
  /** Last update time */
  updatedAt: Scalars['ISO8601DateTime']['output'];
  /** Assigned users count (only visible by site memberships) */
  visibleUsersCount: Maybe<Scalars['Int']['output']>;
};

/** TeamCollection type */
export type TeamCollection = {
  __typename?: 'TeamCollection';
  /** A collection of paginated TeamCollection */
  collection: Array<Team>;
  /** Pagination Metadata for navigating the Pagination */
  metadata: CollectionMetadata;
};

/** Description from base input object. Please set your description for child object. */
export type TeamCreateInput = {
  /** Create attributes */
  attributes: TeamCreateInputObject;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Team attributes */
export type TeamCreateInputObject = {
  /** Accesses attributes array */
  accesses: Array<AccessCuInputObject>;
  /** Color */
  color: ColorEnum;
  /** Department links */
  departmentLinks?: InputMaybe<Array<LinkingInputObject>>;
  /** Description */
  description?: InputMaybe<Scalars['String']['input']>;
  /** Name */
  name: Scalars['String']['input'];
  /** Users attributes array */
  users?: InputMaybe<Array<LinkingInputObject>>;
};

/** Description from base input object. Please set your description for child object. */
export type TeamDestroyInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Team ID */
  id: Scalars['ID']['input'];
};

/** Team filters */
export type TeamFilterInputObject = {
  /** Department ID */
  departmentsId?: InputMaybe<FilterIdInputObject>;
  /** Name */
  name?: InputMaybe<FilterInputObject>;
  /** Users full name */
  usersFullName?: InputMaybe<FilterInputObject>;
};

/** Team sorts */
export type TeamSortInputObject = {
  /** Created at */
  createdAt?: InputMaybe<SortDirectionEnum>;
  /** Name */
  name?: InputMaybe<SortDirectionEnum>;
  /** Assigned users count (only visible by site memberships) */
  visibleUsersCount?: InputMaybe<SortDirectionEnum>;
};

/** Description from base input object. Please set your description for child object. */
export type TeamUpdateInput = {
  /** Update attributes */
  attributes: TeamUpdateInputObject;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Team ID */
  id: Scalars['ID']['input'];
};

/** Team attributes */
export type TeamUpdateInputObject = {
  /** Accesses attributes array */
  accesses?: InputMaybe<Array<AccessCuInputObject>>;
  /** Color */
  color?: InputMaybe<ColorEnum>;
  /** Department links */
  departmentLinks?: InputMaybe<Array<LinkingInputObject>>;
  /** Description */
  description?: InputMaybe<Scalars['String']['input']>;
  /** Name */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Users attributes array */
  users?: InputMaybe<Array<LinkingInputObject>>;
};

/** Technical pause entity */
export type TechnicalPause = TimestampInterface & {
  __typename?: 'TechnicalPause';
  /** Time when was created */
  createdAt: Scalars['ISO8601DateTime']['output'];
  /** Created by */
  createdBy: SystemAdmin;
  /** Early terminated at */
  earlyTerminatedAt: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** End time of the technical pause */
  endAt: Scalars['ISO8601DateTime']['output'];
  /** Technical pause ID */
  id: Scalars['ID']['output'];
  /** Start time of the technical pause */
  startAt: Scalars['ISO8601DateTime']['output'];
  /** Status */
  status: TechnicalPauseStatusEnum;
  /** Time left to start/end of the technical pause */
  time: Maybe<Scalars['Int']['output']>;
  /** Last update time */
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

/** TechnicalPauseCollection type */
export type TechnicalPauseCollection = {
  __typename?: 'TechnicalPauseCollection';
  /** A collection of paginated TechnicalPauseCollection */
  collection: Array<TechnicalPause>;
  /** Pagination Metadata for navigating the Pagination */
  metadata: CollectionMetadata;
};

/** Description from base input object. Please set your description for child object. */
export type TechnicalPauseCreateInput = {
  /** Create attributes */
  attributes: TechnicalPauseCreateInputObject;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** 2FA code for verification */
  code: Scalars['String']['input'];
  /** Type of code (totp, email, backup) */
  codeType: AuthenticationTwoFactorCodeTypeEnum;
};

/** Technical Pause attributes */
export type TechnicalPauseCreateInputObject = {
  /** End at */
  endAt: Scalars['ISO8601DateTime']['input'];
  /** Start at */
  startAt: Scalars['ISO8601DateTime']['input'];
};

/** Description from base input object. Please set your description for child object. */
export type TechnicalPauseDestroyInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** 2FA code for verification */
  code: Scalars['String']['input'];
  /** Type of code (totp, email, backup) */
  codeType: AuthenticationTwoFactorCodeTypeEnum;
  /** Technical Pause ID */
  id: Scalars['ID']['input'];
};

/** Technical Pause sorts */
export type TechnicalPauseSortInputObject = {
  /** Created at */
  createdAt?: InputMaybe<SortDirectionEnum>;
  /** Created by full name */
  createdByFullName?: InputMaybe<SortDirectionEnum>;
  /** End at */
  endAt?: InputMaybe<SortDirectionEnum>;
  /** Start at */
  startAt?: InputMaybe<SortDirectionEnum>;
};

/** Available statuses */
export enum TechnicalPauseStatusEnum {
  Completed = 'COMPLETED',
  Ongoing = 'ONGOING',
  Scheduled = 'SCHEDULED'
}

/** Description from base input object. Please set your description for child object. */
export type TechnicalPauseUpdateInput = {
  /** Update attributes */
  attributes: TechnicalPauseUpdateInputObject;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** 2FA code for verification */
  code: Scalars['String']['input'];
  /** Type of code (totp, email, backup) */
  codeType: AuthenticationTwoFactorCodeTypeEnum;
  /** Technical Pause ID */
  id: Scalars['ID']['input'];
};

/** Technical Pause attributes */
export type TechnicalPauseUpdateInputObject = {
  /** Early terminated */
  earlyTerminated?: InputMaybe<Scalars['Boolean']['input']>;
  /** End at */
  endAt?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  /** Start at */
  startAt?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
};

/** Available time periods for scoping activity metrics */
export enum TimePeriodEnum {
  /** All time */
  AllTime = 'ALL_TIME',
  /** Last 30 days */
  Last_30Days = 'LAST_30_DAYS',
  /** Last 90 days */
  Last_90Days = 'LAST_90_DAYS',
  /** Last 365 days */
  Last_365Days = 'LAST_365_DAYS',
  /** Year to date */
  YearToDate = 'YEAR_TO_DATE'
}

/** Shows timestamp */
export type TimestampInterface = {
  /** Time when was created */
  createdAt: Scalars['ISO8601DateTime']['output'];
  /** Last update time */
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

/** Two-factor authentication fields */
export type TwoFactorAuthenticatableInterface = {
  /** Number of available backup codes */
  twoFactorBackupCodesCount: Scalars['Int']['output'];
  /** Indicates if email OTP method is enabled */
  twoFactorEmailOtpEnabled: Scalars['Boolean']['output'];
  /** Indicates if two-factor authentication is enabled */
  twoFactorEnabled: Scalars['Boolean']['output'];
  /** List of enabled two-factor authentication methods */
  twoFactorEnabledMethods: Array<AuthenticationTwoFactorOtpMethodEnum>;
  /** Timestamp of last successful two-factor verification */
  twoFactorLastVerifiedAt: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** Indicates if two-factor authentication is required for this account */
  twoFactorRequired: Scalars['Boolean']['output'];
  /** Indicates if two-factor authentication reset is required */
  twoFactorResetRequired: Scalars['Boolean']['output'];
  /** Indicates if two-factor authentication setup is required */
  twoFactorSetupRequired: Scalars['Boolean']['output'];
  /** Indicates if TOTP (authenticator app) method is enabled */
  twoFactorTotpEnabled: Scalars['Boolean']['output'];
};

/** Backup codes information */
export type TwoFactorBackupCodes = {
  __typename?: 'TwoFactorBackupCodes';
  /** List of backup codes */
  codes: Array<Scalars['String']['output']>;
  /** Number of backup codes */
  count: Scalars['Int']['output'];
};

/** Two-factor authentication setup result */
export type TwoFactorSetupResult = {
  __typename?: 'TwoFactorSetupResult';
  /** Generated backup codes (if requested) */
  backupCodes: Array<Scalars['String']['output']>;
  /** Number of generated backup codes */
  backupCodesCount: Scalars['Int']['output'];
};

/** TOTP setup information */
export type TwoFactorTotpSetup = {
  __typename?: 'TwoFactorTotpSetup';
  /** TOTP secret key */
  secret: Scalars['String']['output'];
  /** TOTP URI for QR code generation */
  uri: Scalars['String']['output'];
};

/** User entity */
export type User = TimestampInterface & UserInterface & {
  __typename?: 'User';
  /** Avatar */
  avatarAttached: Maybe<Attachment>;
  /** Indicates if user accepted the Code of Conduct */
  codeOfConductAccepted: Scalars['Boolean']['output'];
  /**
   * Company
   * NOTE: if you only need an Object ID, please use the companyId field to reduce the load on the database.
   */
  company: Company;
  /** Company ID */
  companyId: Scalars['ID']['output'];
  /** Time when was created */
  createdAt: Scalars['ISO8601DateTime']['output'];
  /** Deactivation time */
  deactivatedAt: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** Time until debug mode is active */
  debugModeUntil: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** Email */
  email: Maybe<Scalars['String']['output']>;
  /** Final Access setup */
  finalAccesses: Maybe<Array<Access>>;
  /** First name */
  firstName: Scalars['String']['output'];
  /** Indicates if user has a password set */
  hasPassword: Scalars['Boolean']['output'];
  /** User ID */
  id: Scalars['ID']['output'];
  /** Preferred language */
  lang: LanguageEnum;
  /** Last name */
  lastName: Scalars['String']['output'];
  /** Owned company */
  ownedCompany: Maybe<Company>;
  /** Indicates if user needs to set up password */
  passwordSetupRequired: Scalars['Boolean']['output'];
  /**
   * Last password update time
   * ATTENTION: Access allowed for current resource only.
   */
  passwordUpdatedAt: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** Related personal accesses */
  personalAccesses: Array<Access>;
  /** Personal ID */
  personalId: Maybe<Scalars['String']['output']>;
  /** Phone number in E.164 format */
  phoneNumber: Maybe<Scalars['String']['output']>;
  /** Role */
  role: UserRoleEnum;
  /** Sectors collection */
  sectors: SectorCollection;
  /** Sites collection */
  sites: SiteCollection;
  /**
   * Team entity
   * NOTE: if you only need an Object ID, please use the teamId field to reduce the load on the database.
   */
  team: Team;
  /** Team ID */
  teamId: Maybe<Scalars['ID']['output']>;
  /** Email awaiting confirmation */
  unconfirmedEmail: Maybe<Scalars['String']['output']>;
  /** Last update time */
  updatedAt: Scalars['ISO8601DateTime']['output'];
  /** Username */
  username: Maybe<Scalars['String']['output']>;
  /** Indicates if user has verified email */
  verified: Maybe<Scalars['Boolean']['output']>;
};


/** User entity */
export type UserSectorsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
};


/** User entity */
export type UserSitesArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
};

/** Description from base input object. Please set your description for child object. */
export type UserBulkActivateInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** IDs */
  ids: Array<Scalars['ID']['input']>;
};

/** Description from base input object. Please set your description for child object. */
export type UserBulkDeactivateInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** IDs */
  ids: Array<Scalars['ID']['input']>;
};

/** Description from base input object. Please set your description for child object. */
export type UserCodeOfConductAcceptInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Indicates if user accepted the Code of Conduct */
  codeOfConductAccepted: Scalars['Boolean']['input'];
};

/** UserCollection type */
export type UserCollection = {
  __typename?: 'UserCollection';
  /** A collection of paginated UserCollection */
  collection: Array<User>;
  /** Pagination Metadata for navigating the Pagination */
  metadata: CollectionMetadata;
};

/** Description from base input object. Please set your description for child object. */
export type UserCreateInput = {
  /** Create attributes */
  attributes: UserCreateInputObject;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Url to confirm registration */
  redirectUrl: Scalars['String']['input'];
};

/** User attributes */
export type UserCreateInputObject = {
  /** Department memberships attributes array */
  departmentMemberships?: InputMaybe<Array<LinkingInputObject>>;
  /** Email */
  email?: InputMaybe<Scalars['String']['input']>;
  /** First name */
  firstName: Scalars['String']['input'];
  /** Last name */
  lastName: Scalars['String']['input'];
  /** Password */
  password?: InputMaybe<Scalars['String']['input']>;
  /** Personal ID */
  personalId?: InputMaybe<Scalars['String']['input']>;
  /** Phone number */
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  /** Role */
  role: UserRoleEnum;
  /** Sector memberships attributes array */
  sectorMemberships?: InputMaybe<Array<LinkingInputObject>>;
  /** Site memberships attributes array */
  siteMemberships?: InputMaybe<Array<LinkingInputObject>>;
  /** Team ID */
  teamId?: InputMaybe<Scalars['String']['input']>;
  /** Username */
  username?: InputMaybe<Scalars['String']['input']>;
};

/** User attributes */
export type UserCreateOwnerInputObject = {
  /** Email */
  email: Scalars['String']['input'];
  /** First name */
  firstName: Scalars['String']['input'];
  /** Last name */
  lastName: Scalars['String']['input'];
};

/** Description from base input object. Please set your description for child object. */
export type UserDestroyInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** User ID */
  id: Scalars['ID']['input'];
};

/** User filters */
export type UserFilterInputObject = {
  /** Department memberships ID */
  departmentMembershipsId?: InputMaybe<FilterIdInputObject>;
  /** User email */
  email?: InputMaybe<FilterInputObject>;
  /** User full name */
  fullName?: InputMaybe<FilterInputObject>;
  /** Intervention Action assignees */
  interventionActionAssigneesActionId?: InputMaybe<FilterIdInputObject>;
  /** Intervention Action mentioned users */
  interventionActionsTextMentionsId?: InputMaybe<FilterIdInputObject>;
  /** Intervention assignees */
  interventionAssigneesInterventionId?: InputMaybe<FilterIdInputObject>;
  /** Assigned Department ID */
  memberAssignedDepartmentsId?: InputMaybe<FilterIdInputObject>;
  /** Assigned Sector ID */
  memberAssignedSectorsId?: InputMaybe<FilterIdInputObject>;
  /** Assigned Sector name */
  memberAssignedSectorsName?: InputMaybe<FilterInputObject>;
  /** Assigned Site ID */
  memberAssignedSitesId?: InputMaybe<FilterIdInputObject>;
  /** Assigned Site name */
  memberAssignedSitesName?: InputMaybe<FilterInputObject>;
  /** User personal ID */
  personalId?: InputMaybe<FilterInputObject>;
  /** User role */
  role?: InputMaybe<FilterIntInputObject>;
  /** Sector memberships ID */
  sectorMembershipsId?: InputMaybe<FilterIdInputObject>;
  /** Site memberships ID */
  siteMembershipsId?: InputMaybe<FilterIdInputObject>;
  /** Team ID */
  teamId?: InputMaybe<FilterIdInputObject>;
  /** Team name */
  teamName?: InputMaybe<FilterInputObject>;
  /** User username */
  username?: InputMaybe<FilterInputObject>;
};

/** Common user fields */
export type UserInterface = {
  /** Avatar */
  avatarAttached: Maybe<Attachment>;
  /** Deactivation time */
  deactivatedAt: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** Time until debug mode is active */
  debugModeUntil: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** Email */
  email: Maybe<Scalars['String']['output']>;
  /** First name */
  firstName: Scalars['String']['output'];
  /** Indicates if user has a password set */
  hasPassword: Scalars['Boolean']['output'];
  /** Preferred language */
  lang: LanguageEnum;
  /** Last name */
  lastName: Scalars['String']['output'];
  /** Indicates if user needs to set up password */
  passwordSetupRequired: Scalars['Boolean']['output'];
  /**
   * Last password update time
   * ATTENTION: Access allowed for current resource only.
   */
  passwordUpdatedAt: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** Email awaiting confirmation */
  unconfirmedEmail: Maybe<Scalars['String']['output']>;
  /** Indicates if user has verified email */
  verified: Maybe<Scalars['Boolean']['output']>;
};

/** Available roles */
export enum UserRoleEnum {
  FullAdmin = 'FULL_ADMIN',
  User = 'USER'
}

/** User access */
export type UserScopeArgsAccessInputObject = {
  /** Component name */
  component: AccessComponentEnum;
  /** Min level of access (Means provided value or higher) */
  level: AccessLevelEnum;
  /** Sourceable ID */
  sourceableId?: InputMaybe<Scalars['ID']['input']>;
};

/** Users core filter */
export type UserScopeArgsByCoreInputObject = {
  /** User access */
  access?: InputMaybe<UserScopeArgsAccessInputObject>;
  /** When set to `true`, this filter ensures that only users who have access to **every site** listed in the `siteId` array are returned. If a user lacks access to any one of the specified sites, they will be excluded from the results. */
  allSitesAccessible?: InputMaybe<Scalars['Boolean']['input']>;
  /** Only active users */
  onlyActive?: InputMaybe<Scalars['Boolean']['input']>;
  /** Site ID or array of site IDs */
  siteId?: InputMaybe<Array<Scalars['ID']['input']>>;
};

/** Custom scope attributes */
export type UserScopeCustomInputObject = {
  /** Users core filter */
  byCore?: InputMaybe<UserScopeArgsByCoreInputObject>;
};

/** User scope attributes */
export type UserScopeInputObject = {
  /** Custom scope attributes */
  custom?: InputMaybe<UserScopeCustomInputObject>;
  /** Scope name */
  name?: InputMaybe<UserScopeNameEnum>;
};

/** Available user scope names */
export enum UserScopeNameEnum {
  /** Active users */
  Active = 'ACTIVE'
}

/** Description from base input object. Please set your description for child object. */
export type UserSelfUpdateInput = {
  /** Update attributes */
  attributes: UserSelfUpdateInputObject;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Url to confirm new email */
  redirectUrl: Scalars['String']['input'];
};

/** User attributes */
export type UserSelfUpdateInputObject = {
  /** Avatar */
  avatarAttached?: InputMaybe<AttachmentCuInputObject>;
  /** Cancel email changing */
  cancelConfirmation?: InputMaybe<Scalars['Boolean']['input']>;
  /** Email */
  email?: InputMaybe<Scalars['String']['input']>;
  /** First name */
  firstName?: InputMaybe<Scalars['String']['input']>;
  /** Interface preferred language */
  lang?: InputMaybe<LanguageEnum>;
  /** Last name */
  lastName?: InputMaybe<Scalars['String']['input']>;
  /** Personal ID */
  personalId?: InputMaybe<Scalars['String']['input']>;
  /** Phone number */
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
};

/** User sorts */
export type UserSortInputObject = {
  /** Created at */
  createdAt?: InputMaybe<SortDirectionEnum>;
  /** User email */
  email?: InputMaybe<SortDirectionEnum>;
  /** Full name */
  fullName?: InputMaybe<SortDirectionEnum>;
  /** Personal ID */
  personalId?: InputMaybe<SortDirectionEnum>;
  /** Role */
  role?: InputMaybe<SortDirectionEnum>;
  /** Team name */
  teamName?: InputMaybe<SortDirectionEnum>;
  /** User username */
  username?: InputMaybe<SortDirectionEnum>;
};

/** Description from base input object. Please set your description for child object. */
export type UserUpdateInput = {
  /** Update attributes */
  attributes: UserUpdateInputObject;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Url to confirm new email */
  confirmEmailRedirectUrl: Scalars['String']['input'];
  /** Url to finish registration */
  finishRegistrationRedirectUrl: Scalars['String']['input'];
  /** User ID */
  id: Scalars['ID']['input'];
};

/** User attributes */
export type UserUpdateInputObject = {
  /** Accesses attributes array */
  accesses?: InputMaybe<Array<AccessCuInputObject>>;
  /** Department memberships attributes array */
  departmentMemberships?: InputMaybe<Array<LinkingInputObject>>;
  /** Email */
  email?: InputMaybe<Scalars['String']['input']>;
  /** First name */
  firstName?: InputMaybe<Scalars['String']['input']>;
  /** Last name */
  lastName?: InputMaybe<Scalars['String']['input']>;
  /** Password */
  password?: InputMaybe<Scalars['String']['input']>;
  /** Personal ID */
  personalId?: InputMaybe<Scalars['String']['input']>;
  /** Phone number */
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  /** Role */
  role?: InputMaybe<UserRoleEnum>;
  /** Sector memberships attributes array */
  sectorMemberships?: InputMaybe<Array<LinkingInputObject>>;
  /** Site memberships attributes array */
  siteMemberships?: InputMaybe<Array<LinkingInputObject>>;
  /** Team ID */
  teamId?: InputMaybe<Scalars['String']['input']>;
  /** Username */
  username?: InputMaybe<Scalars['String']['input']>;
};

/** Current resource */
export type Whoami = {
  __typename?: 'Whoami';
  /** Entrypoint entity */
  entrypoint: AuthenticationEntrypointUnion;
  /** Resource entity */
  resource: AuthenticationWhoamiUnion;
};

/** Widget entity */
export type Widget = TimestampInterface & {
  __typename?: 'Widget';
  /** Attachments */
  attachmentsAttached: Array<Attachment>;
  /** Time when was created */
  createdAt: Scalars['ISO8601DateTime']['output'];
  /** Description */
  description: Maybe<Scalars['String']['output']>;
  /** Widget fields configuration */
  fields: WidgetsField;
  /** Widget grid configuration */
  grid: Scalars['JSON']['output'];
  /** Home Page ID */
  homePageId: Scalars['ID']['output'];
  /** Widget ID */
  id: Scalars['ID']['output'];
  /** Widget kind */
  kind: WidgetsKindEnum;
  /** Position */
  position: Scalars['Int']['output'];
  /** Title */
  title: Maybe<Scalars['String']['output']>;
  /** Last update time */
  updatedAt: Scalars['ISO8601DateTime']['output'];
  /** Widget Template ID */
  widgetTemplateId: Maybe<Scalars['ID']['output']>;
};

/** Description from base input object. Please set your description for child object. */
export type WidgetBulkUpdateInput = {
  /** Update attributes */
  attributes: Array<WidgetUpdateInputObject>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Home Page ID */
  homePageId: Scalars['ID']['input'];
};

/** Widget button item configuration */
export type WidgetFieldsButtonItemInputObject = {
  /** Indicates if button is enabled */
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** Last update timestamp for the button */
  updatedAt?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
};

/** Widget buttons configuration */
export type WidgetFieldsButtonsInputObject = {
  /** Asset button configuration */
  asset?: InputMaybe<WidgetFieldsButtonItemInputObject>;
  /** Form template button configuration */
  formTemplate?: InputMaybe<WidgetFieldsButtonItemInputObject>;
  /** Intervention button configuration */
  intervention?: InputMaybe<WidgetFieldsButtonItemInputObject>;
  /** Site button configuration */
  site?: InputMaybe<WidgetFieldsButtonItemInputObject>;
  /** Task button configuration */
  task?: InputMaybe<WidgetFieldsButtonItemInputObject>;
  /** Team member button configuration */
  teamMember?: InputMaybe<WidgetFieldsButtonItemInputObject>;
};

/** Widget fields configuration */
export type WidgetFieldsInputObject = {
  /** Background color */
  backgroundColor?: InputMaybe<ColorEnum>;
  /** Widget buttons configuration */
  buttons?: InputMaybe<WidgetFieldsButtonsInputObject>;
  /** End at */
  endAt?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  /** Link */
  link?: InputMaybe<Scalars['String']['input']>;
  /** Location */
  location?: InputMaybe<Scalars['String']['input']>;
  /** Only my */
  onlyMy?: InputMaybe<Scalars['Boolean']['input']>;
  /** Start at */
  startAt?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  /** Timezone */
  timezone?: InputMaybe<Scalars['String']['input']>;
};

/** Widget Template entity */
export type WidgetTemplate = TimestampInterface & {
  __typename?: 'WidgetTemplate';
  /** Attachments */
  attachmentsAttached: Array<Attachment>;
  /** Time when was created */
  createdAt: Scalars['ISO8601DateTime']['output'];
  /** Subtitle */
  description: Maybe<Scalars['String']['output']>;
  /** Widget Template fields configuration */
  fields: WidgetTemplatesField;
  /** Widget Template ID */
  id: Scalars['ID']['output'];
  /** Is default template */
  isDefault: Scalars['Boolean']['output'];
  /** Widget Template kind */
  kind: WidgetTemplatesKindEnum;
  /** Title */
  title: Maybe<Scalars['String']['output']>;
  /** Last update time */
  updatedAt: Scalars['ISO8601DateTime']['output'];
  /** User ID (creator) */
  userId: Maybe<Scalars['ID']['output']>;
  /** Visibility */
  visibility: WidgetTemplatesVisibilityEnum;
};

/** WidgetTemplateCollection type */
export type WidgetTemplateCollection = {
  __typename?: 'WidgetTemplateCollection';
  /** A collection of paginated WidgetTemplateCollection */
  collection: Array<WidgetTemplate>;
  /** Pagination Metadata for navigating the Pagination */
  metadata: CollectionMetadata;
};

/** Description from base input object. Please set your description for child object. */
export type WidgetTemplateCreateInput = {
  /** Widget Template creation attributes */
  attributes: WidgetTemplateCreateInputObject;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Widget Template attributes */
export type WidgetTemplateCreateInputObject = {
  /** Attachments (icon and/or image) */
  attachmentsAttached?: InputMaybe<Array<AttachmentCuInputObject>>;
  /** Subtitle */
  description?: InputMaybe<Scalars['String']['input']>;
  /** Widget Template fields configuration */
  fields?: InputMaybe<WidgetTemplateFieldsInputObject>;
  /** Widget Template kind */
  kind: WidgetTemplatesKindEnum;
  /** Title */
  title: Scalars['String']['input'];
  /** Visibility (prv for private, pub for public) */
  visibility?: InputMaybe<WidgetTemplatesVisibilityEnum>;
};

/** Description from base input object. Please set your description for child object. */
export type WidgetTemplateDestroyInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Widget Template ID */
  id: Scalars['ID']['input'];
};

/** Widget Template fields configuration */
export type WidgetTemplateFieldsInputObject = {
  /** Background color (for announcement only) */
  backgroundColor?: InputMaybe<ColorEnum>;
  /** Rich text content (for announcement only) */
  content?: InputMaybe<Scalars['String']['input']>;
  /** Link URL (for external_link only) */
  link?: InputMaybe<Scalars['String']['input']>;
};

/** Widget Template filters */
export type WidgetTemplateFilterInputObject = {
  /** Is default filter */
  isDefault?: InputMaybe<FilterInputObject>;
  /** Kind filter */
  kind?: InputMaybe<FilterInputObject>;
  /** Title filter */
  title?: InputMaybe<FilterInputObject>;
  /** Visibility filter */
  visibility?: InputMaybe<FilterInputObject>;
};

/** Widget Template sorting */
export type WidgetTemplateSortInputObject = {
  /** Sort by title */
  title?: InputMaybe<SortDirectionEnum>;
};

/** Description from base input object. Please set your description for child object. */
export type WidgetTemplateUpdateInput = {
  /** Widget Template update attributes */
  attributes: WidgetTemplateUpdateInputObject;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Widget Template ID */
  id: Scalars['ID']['input'];
};

/** Widget Template attributes */
export type WidgetTemplateUpdateInputObject = {
  /** Attachments (icon and/or image) */
  attachmentsAttached?: InputMaybe<Array<AttachmentCuInputObject>>;
  /** Subtitle */
  description?: InputMaybe<Scalars['String']['input']>;
  /** Widget Template fields configuration */
  fields?: InputMaybe<WidgetTemplateFieldsInputObject>;
  /** Title */
  title?: InputMaybe<Scalars['String']['input']>;
  /** Visibility (prv for private, pub for public) */
  visibility?: InputMaybe<WidgetTemplatesVisibilityEnum>;
};

/** Widget Template fields configuration */
export type WidgetTemplatesField = {
  __typename?: 'WidgetTemplatesField';
  /** Background color */
  backgroundColor: Maybe<ColorEnum>;
  /** Rich text content */
  content: Maybe<Scalars['String']['output']>;
  /** Link URL */
  link: Maybe<Scalars['String']['output']>;
};

/** Available widget template kinds */
export enum WidgetTemplatesKindEnum {
  ActiveInterventions = 'ACTIVE_INTERVENTIONS',
  Announcement = 'ANNOUNCEMENT',
  Clock = 'CLOCK',
  ExternalLink = 'EXTERNAL_LINK',
  QuickCreation = 'QUICK_CREATION',
  SectorsPerformanceMetricsByDeadlinesMissed = 'SECTORS_PERFORMANCE_METRICS_BY_DEADLINES_MISSED',
  SitesMap = 'SITES_MAP',
  SitesPerformanceMetricsByDeadlinesMissed = 'SITES_PERFORMANCE_METRICS_BY_DEADLINES_MISSED',
  WeatherToday = 'WEATHER_TODAY',
  WeatherWeek = 'WEATHER_WEEK'
}

/** Widget template visibility options (prv for private, pub for public) */
export enum WidgetTemplatesVisibilityEnum {
  Prv = 'PRV',
  Pub = 'PUB'
}

/** Widget attributes */
export type WidgetUpdateInputObject = {
  /** Destroy widget (if true, widget will be destroyed) */
  _destroy?: InputMaybe<Scalars['Boolean']['input']>;
  /** Attachments */
  attachmentsAttached?: InputMaybe<Array<AttachmentCuInputObject>>;
  /** Description */
  description?: InputMaybe<Scalars['String']['input']>;
  /** Widget fields configuration */
  fields?: InputMaybe<WidgetFieldsInputObject>;
  /** Widget grid configuration */
  grid?: InputMaybe<Scalars['JSON']['input']>;
  /** ID */
  id?: InputMaybe<Scalars['ID']['input']>;
  /** Kind */
  kind?: InputMaybe<WidgetsKindEnum>;
  /** Position */
  position?: InputMaybe<Scalars['Int']['input']>;
  /** Title */
  title?: InputMaybe<Scalars['String']['input']>;
  /** Widget Template ID */
  widgetTemplateId?: InputMaybe<Scalars['ID']['input']>;
};

/** Widget fields configuration */
export type WidgetsField = {
  __typename?: 'WidgetsField';
  /** Background color */
  backgroundColor: Maybe<ColorEnum>;
  /** Widget fields buttons configuration */
  buttons: Maybe<WidgetsFieldsButtons>;
  /** End at */
  endAt: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** Link */
  link: Maybe<Scalars['String']['output']>;
  /** Location */
  location: Maybe<Scalars['String']['output']>;
  /** Only my */
  onlyMy: Maybe<Scalars['Boolean']['output']>;
  /** Start at */
  startAt: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** Timezone */
  timezone: Maybe<Scalars['String']['output']>;
};

/** Widget button item configuration */
export type WidgetsFieldsButtonItem = {
  __typename?: 'WidgetsFieldsButtonItem';
  /** Indicates if button is enabled */
  enabled: Maybe<Scalars['Boolean']['output']>;
  /** Last update timestamp for the button */
  updatedAt: Maybe<Scalars['ISO8601DateTime']['output']>;
};

/** Widget fields buttons configuration */
export type WidgetsFieldsButtons = {
  __typename?: 'WidgetsFieldsButtons';
  /** Asset button configuration */
  asset: Maybe<WidgetsFieldsButtonItem>;
  /** Form template button configuration */
  formTemplate: Maybe<WidgetsFieldsButtonItem>;
  /** Intervention button configuration */
  intervention: Maybe<WidgetsFieldsButtonItem>;
  /** Site button configuration */
  site: Maybe<WidgetsFieldsButtonItem>;
  /** Task button configuration */
  task: Maybe<WidgetsFieldsButtonItem>;
  /** Team member button configuration */
  teamMember: Maybe<WidgetsFieldsButtonItem>;
};

/** Available widget kinds */
export enum WidgetsKindEnum {
  ActiveInterventions = 'ACTIVE_INTERVENTIONS',
  Announcement = 'ANNOUNCEMENT',
  Clock = 'CLOCK',
  ExternalLink = 'EXTERNAL_LINK',
  QuickCreation = 'QUICK_CREATION',
  SectorsPerformanceMetricsByDeadlinesMissed = 'SECTORS_PERFORMANCE_METRICS_BY_DEADLINES_MISSED',
  SitesMap = 'SITES_MAP',
  SitesPerformanceMetricsByDeadlinesMissed = 'SITES_PERFORMANCE_METRICS_BY_DEADLINES_MISSED',
  WeatherToday = 'WEATHER_TODAY',
  WeatherWeek = 'WEATHER_WEEK'
}

export type AiConversationFragmentFragment = { __typename?: 'AiConversation', id: string, title: string | null, titleAutoGenerated: boolean, status: AiConversationStatusEnum, feature: AiConversationFeatureEnum, initiator: AiConversationInitiatorEnum, messagesCount: number, busy: boolean | null, thinkingLevel: AiThinkingLevelEnum, createdAt: any, updatedAt: any };

export type AiMessageFragmentFragment = { __typename?: 'AiMessage', id: string, role: AiMessageRoleEnum, status: AiMessageStatusEnum, content: string | null, contentBlocks: any | null, thinking: string | null, errorCode: string | null, suggestedFollowups: Array<string>, createdAt: any, feedback: AiMessageFeedbackEnum | null, feedbackReason: AiMessageFeedbackReasonEnum | null, feedbackComment: string | null, feedbackAt: any | null, toolCalls: Array<{ __typename?: 'AiToolCall', id: string, toolCallId: string, toolName: string, createdAt: any }> };

export type AiConversationsQueryVariables = Exact<{
  page?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  sorts?: InputMaybe<AiConversationSortInputObject>;
  filters?: InputMaybe<Array<AiConversationFilterInputObject> | AiConversationFilterInputObject>;
}>;


export type AiConversationsQuery = { __typename?: 'Query', data: { __typename?: 'AiConversationCollection', collection: Array<{ __typename?: 'AiConversation', id: string, title: string | null, titleAutoGenerated: boolean, status: AiConversationStatusEnum, feature: AiConversationFeatureEnum, initiator: AiConversationInitiatorEnum, messagesCount: number, busy: boolean | null, thinkingLevel: AiThinkingLevelEnum, createdAt: any, updatedAt: any }>, metadata: { __typename?: 'CollectionMetadata', currentPage: number, limitValue: number, totalCount: number, totalPages: number } } };

export type AiConversationQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type AiConversationQuery = { __typename?: 'Query', data: { __typename?: 'AiConversation', id: string, title: string | null, titleAutoGenerated: boolean, status: AiConversationStatusEnum, feature: AiConversationFeatureEnum, initiator: AiConversationInitiatorEnum, messagesCount: number, busy: boolean | null, thinkingLevel: AiThinkingLevelEnum, createdAt: any, updatedAt: any } };

export type AiMessagesQueryVariables = Exact<{
  conversationId: Scalars['ID']['input'];
  page?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  sorts?: InputMaybe<AiMessageSortInputObject>;
}>;


export type AiMessagesQuery = { __typename?: 'Query', data: { __typename?: 'AiMessageCollection', collection: Array<{ __typename?: 'AiMessage', id: string, role: AiMessageRoleEnum, status: AiMessageStatusEnum, content: string | null, contentBlocks: any | null, thinking: string | null, errorCode: string | null, suggestedFollowups: Array<string>, createdAt: any, feedback: AiMessageFeedbackEnum | null, feedbackReason: AiMessageFeedbackReasonEnum | null, feedbackComment: string | null, feedbackAt: any | null, toolCalls: Array<{ __typename?: 'AiToolCall', id: string, toolCallId: string, toolName: string, createdAt: any }> }>, metadata: { __typename?: 'CollectionMetadata', currentPage: number, limitValue: number, totalCount: number, totalPages: number } } };

export type AiSourceDocumentationsQueryVariables = Exact<{
  filters?: InputMaybe<Array<DocumentationFilterInputObject> | DocumentationFilterInputObject>;
}>;


export type AiSourceDocumentationsQuery = { __typename?: 'Query', data: { __typename?: 'DocumentationCollection', collection: Array<{ __typename?: 'Documentation', id: string, name: string | null, favorited: boolean, currentVersion: { __typename?: 'DocumentationVersion', id: string, versionNumber: number, notes: string | null, attachmentAttached: { __typename?: 'Attachment', id: string, processed: boolean, fileTag: string | null, fileData: any | null, filename: string | null, urls: { __typename?: 'AttachmentUrl', large: string | null, medium: string | null, original: string | null, small: string | null, imagePreview: string | null, originalDirectDownload: string | null, video480p: string | null, video720p: string | null, video1080p: string | null } | null, metadata: { __typename?: 'AttachmentMetadata', intendedUse: string | null } | null } | null } | null }> } };

export type AiBudgetStatusQueryVariables = Exact<{ [key: string]: never; }>;


export type AiBudgetStatusQuery = { __typename?: 'Query', data: { __typename?: 'AiBudgetStatus', enforced: boolean, blockedReason: AiBudgetBlockedReasonEnum | null, usedCredits: number, remainingCredits: number | null, totalCredits: number | null, percentage: number | null, userPercentage: number | null, systemPercentage: number | null, updatedAt: any } };

export type AiBudgetStatusLiveSubscriptionVariables = Exact<{ [key: string]: never; }>;


export type AiBudgetStatusLiveSubscription = { __typename?: 'Subscription', aiBudgetStatus: { __typename?: 'AiBudgetStatus', enforced: boolean, blockedReason: AiBudgetBlockedReasonEnum | null, usedCredits: number, remainingCredits: number | null, totalCredits: number | null, percentage: number | null, userPercentage: number | null, systemPercentage: number | null, updatedAt: any } };

export type AiBudgetStatusFragmentFragment = { __typename?: 'AiBudgetStatus', enforced: boolean, blockedReason: AiBudgetBlockedReasonEnum | null, usedCredits: number, remainingCredits: number | null, totalCredits: number | null, percentage: number | null, userPercentage: number | null, systemPercentage: number | null, updatedAt: any };

export type AiThinkingCapabilityQueryVariables = Exact<{ [key: string]: never; }>;


export type AiThinkingCapabilityQuery = { __typename?: 'Query', data: { __typename?: 'AiThinkingCapability', mode: AiThinkingModeEnum, levels: Array<AiThinkingLevelEnum>, selectable: boolean } };

export type AiIndexableMediaKindsQueryVariables = Exact<{ [key: string]: never; }>;


export type AiIndexableMediaKindsQuery = { __typename?: 'Query', whoami: { __typename?: 'Whoami', resource: { __typename: 'SystemAdmin' } | { __typename: 'User', company: { __typename?: 'Company', plan: { __typename?: 'CompanyPlan', aiIndexableMediaKinds: Array<AiMediaKindEnum> } } } } };

export type AiUsageByUserQueryVariables = Exact<{
  filters?: InputMaybe<Array<AiUsageByUserFilterInputObject> | AiUsageByUserFilterInputObject>;
  sorts?: InputMaybe<AiUsageByUserSortInputObject>;
  page?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
}>;


export type AiUsageByUserQuery = { __typename?: 'Query', data: { __typename?: 'AiUsageByUserCollection', collection: Array<{ __typename?: 'AiUsageByUser', creditsUsed: number, sharePercentage: number, user: { __typename?: 'User', id: string, firstName: string, lastName: string, avatarAttached: { __typename?: 'Attachment', id: string, urls: { __typename?: 'AttachmentUrl', small: string | null, original: string | null } | null } | null } }>, metadata: { __typename?: 'CollectionMetadata', currentPage: number, limitValue: number, totalCount: number, totalPages: number } } };

export type AiCompanyIndexingCoverageQueryVariables = Exact<{ [key: string]: never; }>;


export type AiCompanyIndexingCoverageQuery = { __typename?: 'Query', data: { __typename?: 'AiIndexingCoverage', total: number, indexed: number, skipped: number, stale: number, pending: number, failed: number, retryingSoon: number, retryingDaily: number, parked: number, indexingState: AiIndexingStateEnum, indexingInFlight: number, progress: number, estimatedReindexSeconds: number, lastIndexedAt: any | null, lastIndexingAttemptAt: any | null, parkedReasons: Array<{ __typename?: 'AiIndexingFailureReason', reason: string, count: number }> } };

export type AiIndexingCoverageFragmentFragment = { __typename?: 'AiIndexingCoverage', total: number, indexed: number, skipped: number, stale: number, pending: number, failed: number, retryingSoon: number, retryingDaily: number, parked: number, indexingState: AiIndexingStateEnum, indexingInFlight: number, progress: number, estimatedReindexSeconds: number, lastIndexedAt: any | null, lastIndexingAttemptAt: any | null, parkedReasons: Array<{ __typename?: 'AiIndexingFailureReason', reason: string, count: number }> };

export type AiIndexingRetryParkedMutationVariables = Exact<{ [key: string]: never; }>;


export type AiIndexingRetryParkedMutation = { __typename?: 'Mutation', data: { __typename?: 'AiIndexingCoverage', total: number, indexed: number, skipped: number, stale: number, pending: number, failed: number, retryingSoon: number, retryingDaily: number, parked: number, indexingState: AiIndexingStateEnum, indexingInFlight: number, progress: number, estimatedReindexSeconds: number, lastIndexedAt: any | null, lastIndexingAttemptAt: any | null, parkedReasons: Array<{ __typename?: 'AiIndexingFailureReason', reason: string, count: number }> } | null };

export type AiIndexingDocumentationsQueryVariables = Exact<{
  page?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  sorts?: InputMaybe<DocumentationSortInputObject>;
  filters?: InputMaybe<Array<DocumentationFilterInputObject> | DocumentationFilterInputObject>;
}>;


export type AiIndexingDocumentationsQuery = { __typename?: 'Query', data: { __typename?: 'DocumentationCollection', collection: Array<{ __typename?: 'Documentation', id: string, name: string | null, code: string | null, aiIndexingError: string | null, category: { __typename?: 'DocumentationCategory', id: string, name: string, color: ColorEnum } | null, currentVersion: { __typename?: 'DocumentationVersion', id: string, attachmentAttached: { __typename?: 'Attachment', id: string, processed: boolean, fileTag: string | null, fileData: any | null, filename: string | null, urls: { __typename?: 'AttachmentUrl', large: string | null, medium: string | null, original: string | null, small: string | null, imagePreview: string | null, originalDirectDownload: string | null, video480p: string | null, video720p: string | null, video1080p: string | null } | null, metadata: { __typename?: 'AttachmentMetadata', intendedUse: string | null } | null } | null } | null }>, metadata: { __typename?: 'CollectionMetadata', currentPage: number, limitValue: number, totalCount: number, totalPages: number } } };

export type AiSendMessageMutationVariables = Exact<{
  attributes: AiSendMessageInputObject;
}>;


export type AiSendMessageMutation = { __typename?: 'Mutation', data: { __typename?: 'AiConversation', id: string, title: string | null, titleAutoGenerated: boolean, status: AiConversationStatusEnum, feature: AiConversationFeatureEnum, initiator: AiConversationInitiatorEnum, messagesCount: number, busy: boolean | null, thinkingLevel: AiThinkingLevelEnum, createdAt: any, updatedAt: any } | null };

export type AiConversationUpdateMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  attributes: AiConversationUpdateInputObject;
}>;


export type AiConversationUpdateMutation = { __typename?: 'Mutation', data: { __typename?: 'AiConversation', id: string, title: string | null, titleAutoGenerated: boolean, status: AiConversationStatusEnum, feature: AiConversationFeatureEnum, initiator: AiConversationInitiatorEnum, messagesCount: number, busy: boolean | null, thinkingLevel: AiThinkingLevelEnum, createdAt: any, updatedAt: any } | null };

export type AiConversationDestroyMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type AiConversationDestroyMutation = { __typename?: 'Mutation', data: { __typename?: 'AiConversation', id: string } | null };

export type AiSendMessageStopMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type AiSendMessageStopMutation = { __typename?: 'Mutation', data: { __typename?: 'AiConversation', id: string, title: string | null, titleAutoGenerated: boolean, status: AiConversationStatusEnum, feature: AiConversationFeatureEnum, initiator: AiConversationInitiatorEnum, messagesCount: number, busy: boolean | null, thinkingLevel: AiThinkingLevelEnum, createdAt: any, updatedAt: any } | null };

export type AiMessageFeedbackCreateMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  attributes: AiMessageFeedbackInputObject;
}>;


export type AiMessageFeedbackCreateMutation = { __typename?: 'Mutation', data: { __typename?: 'AiMessage', id: string, role: AiMessageRoleEnum, status: AiMessageStatusEnum, content: string | null, contentBlocks: any | null, thinking: string | null, errorCode: string | null, suggestedFollowups: Array<string>, createdAt: any, feedback: AiMessageFeedbackEnum | null, feedbackReason: AiMessageFeedbackReasonEnum | null, feedbackComment: string | null, feedbackAt: any | null, toolCalls: Array<{ __typename?: 'AiToolCall', id: string, toolCallId: string, toolName: string, createdAt: any }> } | null };

export type AiMessageFeedbackDestroyMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type AiMessageFeedbackDestroyMutation = { __typename?: 'Mutation', data: { __typename?: 'AiMessage', id: string, role: AiMessageRoleEnum, status: AiMessageStatusEnum, content: string | null, contentBlocks: any | null, thinking: string | null, errorCode: string | null, suggestedFollowups: Array<string>, createdAt: any, feedback: AiMessageFeedbackEnum | null, feedbackReason: AiMessageFeedbackReasonEnum | null, feedbackComment: string | null, feedbackAt: any | null, toolCalls: Array<{ __typename?: 'AiToolCall', id: string, toolCallId: string, toolName: string, createdAt: any }> } | null };

export type AiGenerateDocumentationFieldsMutationVariables = Exact<{
  attributes: AiGenerateDocumentationFieldsInputObject;
}>;


export type AiGenerateDocumentationFieldsMutation = { __typename?: 'Mutation', data: { __typename?: 'AiFieldGenerationRequest', generationId: string } };

export type AiGenerateDocumentationVersionFieldsMutationVariables = Exact<{
  attributes: AiGenerateDocumentationVersionFieldsInputObject;
}>;


export type AiGenerateDocumentationVersionFieldsMutation = { __typename?: 'Mutation', data: { __typename?: 'AiFieldGenerationRequest', generationId: string } };

export type AiDismissDocumentationDetectionMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  attributes: AiDismissDocumentationDetectionInputObject;
}>;


export type AiDismissDocumentationDetectionMutation = { __typename?: 'Mutation', data: { __typename?: 'Documentation', id: string, code: string | null, suggestedCodes: Array<string>, aiDetectionStatus: Array<{ __typename?: 'DocumentationFieldDetectionStatus', field: AiDocumentationFieldEnum, status: AiFieldDetectionStatusEnum }> } | null };

export type AiDocumentationPreviewQueryVariables = Exact<{
  id: Scalars['ID']['input'];
  versionId?: Scalars['ID']['input'];
  hasVersion?: Scalars['Boolean']['input'];
  isViewLocked?: Scalars['Boolean']['input'];
}>;


export type AiDocumentationPreviewQuery = { __typename?: 'Query', data: { __typename?: 'Documentation', id: string, name: string | null, read?: boolean | null, favorited?: boolean, currentVersion: { __typename?: 'DocumentationVersion', id: string, versionNumber: number, notes: string | null, attachmentAttached: { __typename?: 'Attachment', id: string, processed: boolean, fileTag: string | null, fileData: any | null, filename: string | null, urls: { __typename?: 'AttachmentUrl', large: string | null, medium: string | null, original: string | null, small: string | null, imagePreview: string | null, originalDirectDownload: string | null, video480p: string | null, video720p: string | null, video1080p: string | null } | null, metadata: { __typename?: 'AttachmentMetadata', intendedUse: string | null } | null } | null } | null } | null, pinnedVersion?: { __typename?: 'DocumentationVersion', id: string, versionNumber: number, notes: string | null, attachmentAttached: { __typename?: 'Attachment', id: string, processed: boolean, fileTag: string | null, fileData: any | null, filename: string | null, urls: { __typename?: 'AttachmentUrl', large: string | null, medium: string | null, original: string | null, small: string | null, imagePreview: string | null, originalDirectDownload: string | null, video480p: string | null, video720p: string | null, video1080p: string | null } | null, metadata: { __typename?: 'AttachmentMetadata', intendedUse: string | null } | null } | null } | null };

export type AiCompanyIndexingCoverageChangedSubscriptionVariables = Exact<{ [key: string]: never; }>;


export type AiCompanyIndexingCoverageChangedSubscription = { __typename?: 'Subscription', data: { __typename?: 'AiIndexingCoverage', total: number, indexed: number, skipped: number, stale: number, pending: number, failed: number, retryingSoon: number, retryingDaily: number, parked: number, indexingState: AiIndexingStateEnum, indexingInFlight: number, progress: number, estimatedReindexSeconds: number, lastIndexedAt: any | null, lastIndexingAttemptAt: any | null, parkedReasons: Array<{ __typename?: 'AiIndexingFailureReason', reason: string, count: number }> } };

export type AiConversationStreamSubscriptionVariables = Exact<{
  conversationId: Scalars['ID']['input'];
}>;


export type AiConversationStreamSubscription = { __typename?: 'Subscription', data: { __typename?: 'AiConversationStreamEvent', eventType: AiStreamEventTypeEnum, messageId: string | null, delta: string | null, sequence: number | null, status: AiMessageStatusEnum | null, errorCode: string | null, toolCallId: string | null, toolName: string | null, toolStatus: AiToolStatusEnum | null, suggestedFollowups: Array<string> | null, conversationTitle: string | null } };

export type AiDocumentationFieldsGeneratedSubscriptionVariables = Exact<{
  generationId: Scalars['ID']['input'];
}>;


export type AiDocumentationFieldsGeneratedSubscription = { __typename?: 'Subscription', data: { __typename?: 'AiFieldsGeneration', generationId: string, errorCode: string | null, results: Array<{ __typename?: 'AiFieldGeneration', field: AiDocumentationFieldEnum, text: string | null, values: Array<string> | null, categoryId: string | null, notFound: boolean, errorCode: string | null }> } };

export type AiDocumentationVersionFieldsGeneratedSubscriptionVariables = Exact<{
  generationId: Scalars['ID']['input'];
}>;


export type AiDocumentationVersionFieldsGeneratedSubscription = { __typename?: 'Subscription', data: { __typename?: 'AiFieldsGeneration', generationId: string, errorCode: string | null, results: Array<{ __typename?: 'AiFieldGeneration', field: AiDocumentationFieldEnum, text: string | null, values: Array<string> | null, categoryId: string | null, notFound: boolean, errorCode: string | null }> } };

export type ApiTokenQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type ApiTokenQuery = { __typename?: 'Query', data: { __typename?: 'ApiToken', id: string, createdAt: any, updatedAt: any, label: string | null, status: ApiTokenStatusEnum | null } | null };

export type ApiTokensQueryVariables = Exact<{
  page?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
}>;


export type ApiTokensQuery = { __typename?: 'Query', data: { __typename?: 'ApiTokenCollection', collection: Array<{ __typename?: 'ApiToken', id: string, createdAt: any, label: string | null, status: ApiTokenStatusEnum | null }>, metadata: { __typename?: 'CollectionMetadata', currentPage: number, limitValue: number, totalCount: number, totalPages: number } } };

export type ApiTokenCreateMutationVariables = Exact<{
  attributes: ApiTokenCreateInputObject;
}>;


export type ApiTokenCreateMutation = { __typename?: 'Mutation', data: { __typename?: 'ApiToken', id: string, label: string | null, token: string | null } | null };

export type ApiTokenUpdateMutationVariables = Exact<{
  attributes: ApiTokenUpdateInputObject;
  id: Scalars['ID']['input'];
}>;


export type ApiTokenUpdateMutation = { __typename?: 'Mutation', data: { __typename?: 'ApiToken', label: string | null } | null };

export type ApiTokenDestroyMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type ApiTokenDestroyMutation = { __typename?: 'Mutation', apiTokenDestroy: boolean | null };

export type AssetCategoryFragmentFragment = { __typename?: 'AssetCategory', color: ColorEnum, name: string, id: string, prefix: string | null };

export type AssetFragmentFragment = { __typename?: 'Asset', id: string, qrPrefix: string | null, code: string, fullCode: string, manufacturer: string | null, model: string | null, name: string, serialNumber: string | null, serviceDate: any | null, description: string | null, poorWifi: boolean, category: { __typename?: 'AssetCategory', color: ColorEnum, name: string, id: string, prefix: string | null } | null, site: { __typename?: 'Site', id: string, name: string } | null, siteArea: { __typename?: 'SiteArea', id: string, name: string } | null, iconAttached: { __typename?: 'Attachment', id: string, processed: boolean, fileTag: string | null, fileData: any | null, filename: string | null, urls: { __typename?: 'AttachmentUrl', large: string | null, medium: string | null, original: string | null, small: string | null, imagePreview: string | null, originalDirectDownload: string | null, video480p: string | null, video720p: string | null, video1080p: string | null } | null, metadata: { __typename?: 'AttachmentMetadata', intendedUse: string | null } | null } | null };

export type AssetsQueryVariables = Exact<{
  page?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  sorts?: InputMaybe<AssetSortInputObject>;
  filters?: InputMaybe<Array<AssetFilterInputObject> | AssetFilterInputObject>;
  includeFullData?: InputMaybe<Scalars['Boolean']['input']>;
  includeCategoryData?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type AssetsQuery = { __typename?: 'Query', data: { __typename?: 'AssetCollection', collection: Array<{ __typename?: 'Asset', id: string, code: string, fullCode: string, manufacturer?: string | null, model?: string | null, name: string, serialNumber?: string | null, category?: { __typename?: 'AssetCategory', color: ColorEnum, name: string, id: string } | null, site: { __typename?: 'Site', id: string, name: string, code: string } | null, siteArea: { __typename?: 'SiteArea', id: string, name: string, code: string } | null, iconAttached: { __typename?: 'Attachment', id: string, processed: boolean, fileTag: string | null, fileData: any | null, filename: string | null, urls: { __typename?: 'AttachmentUrl', large: string | null, medium: string | null, original: string | null, small: string | null, imagePreview: string | null, originalDirectDownload: string | null, video480p: string | null, video720p: string | null, video1080p: string | null } | null, metadata: { __typename?: 'AttachmentMetadata', intendedUse: string | null } | null } | null, canDestroy: { __typename?: 'AuthorizationResult', value: boolean, message: string | null, reasons: { __typename?: 'FailureReasons', details: string, fullMessages: Array<string> } | null } }>, metadata: { __typename?: 'CollectionMetadata', currentPage: number, limitValue: number, totalCount: number, totalPages: number } } };

export type AssetIdsQueryVariables = Exact<{
  sorts?: InputMaybe<AssetSortInputObject>;
  filters?: InputMaybe<Array<AssetFilterInputObject> | AssetFilterInputObject>;
  onlyIds?: InputMaybe<Scalars['Boolean']['input']>;
  includeSiteId?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type AssetIdsQuery = { __typename?: 'Query', data: { __typename?: 'AssetCollection', collection: Array<{ __typename?: 'Asset', id: string, siteId?: string | null }> } };

export type AssetsSearchListQueryVariables = Exact<{
  page?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  sorts?: InputMaybe<AssetSortInputObject>;
  filters?: InputMaybe<Array<AssetFilterInputObject> | AssetFilterInputObject>;
}>;


export type AssetsSearchListQuery = { __typename?: 'Query', data: { __typename?: 'AssetCollection', collection: Array<{ __typename?: 'Asset', id: string, fullCode: string, name: string, poorWifi: boolean, usesAsNomenclatureCount: number, iconAttached: { __typename?: 'Attachment', id: string, processed: boolean, fileTag: string | null, fileData: any | null, filename: string | null, urls: { __typename?: 'AttachmentUrl', large: string | null, medium: string | null, original: string | null, small: string | null, imagePreview: string | null, originalDirectDownload: string | null, video480p: string | null, video720p: string | null, video1080p: string | null } | null, metadata: { __typename?: 'AttachmentMetadata', intendedUse: string | null } | null } | null }>, metadata: { __typename?: 'CollectionMetadata', currentPage: number, limitValue: number, totalCount: number, totalPages: number } } };

export type AssetQueryVariables = Exact<{
  findBy: AssetFindByInputObject;
  includeFullData?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type AssetQuery = { __typename?: 'Query', data: { __typename?: 'Asset', id: string, name: string, fullCode: string, siteId: string | null, qrPrefix: string | null, code: string, manufacturer: string | null, model: string | null, serialNumber: string | null, serviceDate: any | null, description: string | null, poorWifi: boolean, canDestroy: { __typename?: 'AuthorizationResult', value: boolean, message: string | null, reasons: { __typename?: 'FailureReasons', details: string, fullMessages: Array<string> } | null }, category: { __typename?: 'AssetCategory', color: ColorEnum, name: string, id: string, prefix: string | null } | null, site: { __typename?: 'Site', id: string, name: string } | null, siteArea: { __typename?: 'SiteArea', id: string, name: string } | null, iconAttached: { __typename?: 'Attachment', id: string, processed: boolean, fileTag: string | null, fileData: any | null, filename: string | null, urls: { __typename?: 'AttachmentUrl', large: string | null, medium: string | null, original: string | null, small: string | null, imagePreview: string | null, originalDirectDownload: string | null, video480p: string | null, video720p: string | null, video1080p: string | null } | null, metadata: { __typename?: 'AttachmentMetadata', intendedUse: string | null } | null } | null } | null };

export type AssetWithCountersQueryVariables = Exact<{
  findBy: AssetFindByInputObject;
  includeFullData?: InputMaybe<Scalars['Boolean']['input']>;
  mainAssetId: Scalars['ID']['input'];
  nomenclaturesFilters?: InputMaybe<Array<NomenclatureFilterInputObject> | NomenclatureFilterInputObject>;
  countersFilters?: InputMaybe<Array<CounterFilterInputObject> | CounterFilterInputObject>;
  documentationsFilters?: InputMaybe<Array<DocumentationFilterInputObject> | DocumentationFilterInputObject>;
  interventionsFilters?: InputMaybe<Array<InterventionFilterInputObject> | InterventionFilterInputObject>;
  interventionsScopeName: InterventionScopeNameEnum;
  isDocumentationLocked?: Scalars['Boolean']['input'];
  isInterventionsLocked?: Scalars['Boolean']['input'];
}>;


export type AssetWithCountersQuery = { __typename?: 'Query', data: { __typename?: 'Asset', id: string, name: string, fullCode: string, qrPrefix: string | null, code: string, manufacturer: string | null, model: string | null, serialNumber: string | null, serviceDate: any | null, description: string | null, poorWifi: boolean, site?: { __typename?: 'Site', id: string, name: string } | null, siteArea?: { __typename?: 'SiteArea', id: string, name: string } | null, canDestroy: { __typename?: 'AuthorizationResult', value: boolean, message: string | null, reasons: { __typename?: 'FailureReasons', details: string, fullMessages: Array<string> } | null }, category: { __typename?: 'AssetCategory', color: ColorEnum, name: string, id: string, prefix: string | null } | null, iconAttached: { __typename?: 'Attachment', id: string, processed: boolean, fileTag: string | null, fileData: any | null, filename: string | null, urls: { __typename?: 'AttachmentUrl', large: string | null, medium: string | null, original: string | null, small: string | null, imagePreview: string | null, originalDirectDownload: string | null, video480p: string | null, video720p: string | null, video1080p: string | null } | null, metadata: { __typename?: 'AttachmentMetadata', intendedUse: string | null } | null } | null } | null, nomenclatures: { __typename?: 'NomenclatureCollection', metadata: { __typename?: 'CollectionMetadata', totalCount: number } }, counters: { __typename?: 'CounterCollection', metadata: { __typename?: 'CollectionMetadata', totalCount: number } }, documentations?: { __typename?: 'DocumentationCollection', metadata: { __typename?: 'CollectionMetadata', totalCount: number } }, interventions?: { __typename?: 'InterventionCollection', metadata: { __typename?: 'CollectionMetadata', totalCount: number } } };

export type AssetCategoryQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type AssetCategoryQuery = { __typename?: 'Query', data: { __typename?: 'AssetCategory', color: ColorEnum, name: string, id: string, prefix: string | null } | null };

export type AssetCategoriesQueryVariables = Exact<{
  page?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  filters?: InputMaybe<Array<AssetCategoryFilterInputObject> | AssetCategoryFilterInputObject>;
  sorts?: InputMaybe<AssetCategorySortInputObject>;
}>;


export type AssetCategoriesQuery = { __typename?: 'Query', data: { __typename?: 'AssetCategoryCollection', collection: Array<{ __typename?: 'AssetCategory', visibleAssetsCount: number, color: ColorEnum, name: string, id: string, prefix: string | null, assets: { __typename?: 'AssetCollection', collection: Array<{ __typename?: 'Asset', id: string, name: string }> }, canDestroy: { __typename?: 'AuthorizationResult', value: boolean } }>, metadata: { __typename?: 'CollectionMetadata', currentPage: number, limitValue: number, totalCount: number, totalPages: number } } };

export type AssetCategoriesSearchListQueryVariables = Exact<{
  page?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  filters?: InputMaybe<Array<AssetCategoryFilterInputObject> | AssetCategoryFilterInputObject>;
  sorts?: InputMaybe<AssetCategorySortInputObject>;
}>;


export type AssetCategoriesSearchListQuery = { __typename?: 'Query', data: { __typename?: 'AssetCategoryCollection', collection: Array<{ __typename?: 'AssetCategory', color: ColorEnum, name: string, id: string, prefix: string | null }>, metadata: { __typename?: 'CollectionMetadata', currentPage: number, limitValue: number, totalCount: number, totalPages: number } } };

export type AssetBulkDestroyMutationVariables = Exact<{
  input: AssetBulkDestroyInput;
}>;


export type AssetBulkDestroyMutation = { __typename?: 'Mutation', data: boolean | null };

export type AssetCategoryCreateMutationVariables = Exact<{
  attributes: AssetCategoryCreateInputObject;
}>;


export type AssetCategoryCreateMutation = { __typename?: 'Mutation', data: { __typename?: 'AssetCategory', color: ColorEnum, name: string, id: string, prefix: string | null } | null };

export type AssetCategoryUpdateMutationVariables = Exact<{
  attributes: AssetCategoryUpdateInputObject;
  id: Scalars['ID']['input'];
  refreshQrPrefixForAssets?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type AssetCategoryUpdateMutation = { __typename?: 'Mutation', data: { __typename?: 'AssetCategory', color: ColorEnum, name: string, id: string, prefix: string | null } | null };

export type AssetCategoryDestroyMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type AssetCategoryDestroyMutation = { __typename?: 'Mutation', assetCategoryDestroy: boolean | null };

export type AssetCreateMutationVariables = Exact<{
  attributes: AssetCreateInputObject;
}>;


export type AssetCreateMutation = { __typename?: 'Mutation', data: { __typename?: 'Asset', id: string, qrPrefix: string | null, code: string, fullCode: string, manufacturer: string | null, model: string | null, name: string, serialNumber: string | null, serviceDate: any | null, description: string | null, poorWifi: boolean, category: { __typename?: 'AssetCategory', color: ColorEnum, name: string, id: string, prefix: string | null } | null, site: { __typename?: 'Site', id: string, name: string } | null, siteArea: { __typename?: 'SiteArea', id: string, name: string } | null, iconAttached: { __typename?: 'Attachment', id: string, processed: boolean, fileTag: string | null, fileData: any | null, filename: string | null, urls: { __typename?: 'AttachmentUrl', large: string | null, medium: string | null, original: string | null, small: string | null, imagePreview: string | null, originalDirectDownload: string | null, video480p: string | null, video720p: string | null, video1080p: string | null } | null, metadata: { __typename?: 'AttachmentMetadata', intendedUse: string | null } | null } | null } | null };

export type AssetUpdateMutationVariables = Exact<{
  attributes: AssetUpdateInputObject;
  id: Scalars['ID']['input'];
}>;


export type AssetUpdateMutation = { __typename?: 'Mutation', data: { __typename?: 'Asset', id: string, qrPrefix: string | null, code: string, fullCode: string, manufacturer: string | null, model: string | null, name: string, serialNumber: string | null, serviceDate: any | null, description: string | null, poorWifi: boolean, category: { __typename?: 'AssetCategory', color: ColorEnum, name: string, id: string, prefix: string | null } | null, site: { __typename?: 'Site', id: string, name: string } | null, siteArea: { __typename?: 'SiteArea', id: string, name: string } | null, iconAttached: { __typename?: 'Attachment', id: string, processed: boolean, fileTag: string | null, fileData: any | null, filename: string | null, urls: { __typename?: 'AttachmentUrl', large: string | null, medium: string | null, original: string | null, small: string | null, imagePreview: string | null, originalDirectDownload: string | null, video480p: string | null, video720p: string | null, video1080p: string | null } | null, metadata: { __typename?: 'AttachmentMetadata', intendedUse: string | null } | null } | null } | null };

export type AssetBulkQrCodeCreateMutationVariables = Exact<{
  params: QrCodesCreateInputObject;
}>;


export type AssetBulkQrCodeCreateMutation = { __typename?: 'Mutation', data: { __typename?: 'BackgroundJob', id: string, jid: string | null, parentId: string | null, rootId: string, kind: BackgroundJobKindEnum, status: BackgroundJobStatusEnum, displayStatus: BackgroundJobStatusEnum, treeStatus: BackgroundJobStatusEnum, done: number, total: number, failed: number, pctComplete: number, message: string | null, errorCode: string | null, result: any | null, estimatedFinishAt: any | null, startedAt: any | null, finishedAt: any | null, cancelRequestedAt: any | null, deliveryRequestedAt: any | null, dismissed: boolean, createdAt: any, updatedAt: any, children: Array<{ __typename?: 'BackgroundJob', id: string, jid: string | null, parentId: string | null, rootId: string, kind: BackgroundJobKindEnum, status: BackgroundJobStatusEnum, displayStatus: BackgroundJobStatusEnum, treeStatus: BackgroundJobStatusEnum, done: number, total: number, failed: number, pctComplete: number, message: string | null, errorCode: string | null, result: any | null, estimatedFinishAt: any | null, startedAt: any | null, finishedAt: any | null, cancelRequestedAt: any | null, deliveryRequestedAt: any | null, dismissed: boolean, createdAt: any, updatedAt: any, canCancel: { __typename?: 'AuthorizationResult', value: boolean, message: string | null, reasons: { __typename?: 'FailureReasons', details: string, fullMessages: Array<string> } | null }, canDismiss: { __typename?: 'AuthorizationResult', value: boolean, message: string | null, reasons: { __typename?: 'FailureReasons', details: string, fullMessages: Array<string> } | null }, canRequestDelivery: { __typename?: 'AuthorizationResult', value: boolean, message: string | null, reasons: { __typename?: 'FailureReasons', details: string, fullMessages: Array<string> } | null }, canRequeue: { __typename?: 'AuthorizationResult', value: boolean, message: string | null, reasons: { __typename?: 'FailureReasons', details: string, fullMessages: Array<string> } | null } }>, canCancel: { __typename?: 'AuthorizationResult', value: boolean, message: string | null, reasons: { __typename?: 'FailureReasons', details: string, fullMessages: Array<string> } | null }, canDismiss: { __typename?: 'AuthorizationResult', value: boolean, message: string | null, reasons: { __typename?: 'FailureReasons', details: string, fullMessages: Array<string> } | null }, canRequestDelivery: { __typename?: 'AuthorizationResult', value: boolean, message: string | null, reasons: { __typename?: 'FailureReasons', details: string, fullMessages: Array<string> } | null }, canRequeue: { __typename?: 'AuthorizationResult', value: boolean, message: string | null, reasons: { __typename?: 'FailureReasons', details: string, fullMessages: Array<string> } | null } } | null };

export type AssetNomenclatureBulkQrCodeCreateMutationVariables = Exact<{
  params: QrCodesCreateInputObject;
}>;


export type AssetNomenclatureBulkQrCodeCreateMutation = { __typename?: 'Mutation', data: { __typename?: 'BackgroundJob', id: string, jid: string | null, parentId: string | null, rootId: string, kind: BackgroundJobKindEnum, status: BackgroundJobStatusEnum, displayStatus: BackgroundJobStatusEnum, treeStatus: BackgroundJobStatusEnum, done: number, total: number, failed: number, pctComplete: number, message: string | null, errorCode: string | null, result: any | null, estimatedFinishAt: any | null, startedAt: any | null, finishedAt: any | null, cancelRequestedAt: any | null, deliveryRequestedAt: any | null, dismissed: boolean, createdAt: any, updatedAt: any, children: Array<{ __typename?: 'BackgroundJob', id: string, jid: string | null, parentId: string | null, rootId: string, kind: BackgroundJobKindEnum, status: BackgroundJobStatusEnum, displayStatus: BackgroundJobStatusEnum, treeStatus: BackgroundJobStatusEnum, done: number, total: number, failed: number, pctComplete: number, message: string | null, errorCode: string | null, result: any | null, estimatedFinishAt: any | null, startedAt: any | null, finishedAt: any | null, cancelRequestedAt: any | null, deliveryRequestedAt: any | null, dismissed: boolean, createdAt: any, updatedAt: any, canCancel: { __typename?: 'AuthorizationResult', value: boolean, message: string | null, reasons: { __typename?: 'FailureReasons', details: string, fullMessages: Array<string> } | null }, canDismiss: { __typename?: 'AuthorizationResult', value: boolean, message: string | null, reasons: { __typename?: 'FailureReasons', details: string, fullMessages: Array<string> } | null }, canRequestDelivery: { __typename?: 'AuthorizationResult', value: boolean, message: string | null, reasons: { __typename?: 'FailureReasons', details: string, fullMessages: Array<string> } | null }, canRequeue: { __typename?: 'AuthorizationResult', value: boolean, message: string | null, reasons: { __typename?: 'FailureReasons', details: string, fullMessages: Array<string> } | null } }>, canCancel: { __typename?: 'AuthorizationResult', value: boolean, message: string | null, reasons: { __typename?: 'FailureReasons', details: string, fullMessages: Array<string> } | null }, canDismiss: { __typename?: 'AuthorizationResult', value: boolean, message: string | null, reasons: { __typename?: 'FailureReasons', details: string, fullMessages: Array<string> } | null }, canRequestDelivery: { __typename?: 'AuthorizationResult', value: boolean, message: string | null, reasons: { __typename?: 'FailureReasons', details: string, fullMessages: Array<string> } | null }, canRequeue: { __typename?: 'AuthorizationResult', value: boolean, message: string | null, reasons: { __typename?: 'FailureReasons', details: string, fullMessages: Array<string> } | null } } | null };

export type AssetCountersQueryVariables = Exact<{
  page?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  sorts?: InputMaybe<CounterSortInputObject>;
  filters?: InputMaybe<Array<CounterFilterInputObject> | CounterFilterInputObject>;
  assetId: Scalars['ID']['input'];
}>;


export type AssetCountersQuery = { __typename?: 'Query', data: { __typename?: 'CounterCollection', collection: Array<{ __typename?: 'Counter', code: string, fullCode: string, id: string, lastCheckAt: any | null, latestIndex: number | null, measureType: CounterMeasureTypeEnum, measureUnit: CounterMeasureUnitEnum, name: string }>, metadata: { __typename?: 'CollectionMetadata', currentPage: number, limitValue: number, totalCount: number, totalPages: number } } };

export type AssetCountersIdsQueryVariables = Exact<{
  sorts?: InputMaybe<CounterSortInputObject>;
  filters?: InputMaybe<Array<CounterFilterInputObject> | CounterFilterInputObject>;
  onlyIds?: InputMaybe<Scalars['Boolean']['input']>;
  assetId: Scalars['ID']['input'];
}>;


export type AssetCountersIdsQuery = { __typename?: 'Query', data: { __typename?: 'CounterCollection', collection: Array<{ __typename?: 'Counter', id: string }> } };

export type AssetCounterQueryVariables = Exact<{
  findBy: CounterFindByInputObject;
  assetFindBy: AssetFindByInputObject;
}>;


export type AssetCounterQuery = { __typename?: 'Query', data: { __typename?: 'Counter', id: string, name: string, code: string, fullCode: string, measureType: CounterMeasureTypeEnum, measureUnit: CounterMeasureUnitEnum, prohibitLowerIndexThanPrevious: boolean, latestIndex: number | null, lastCheckAt: any | null } | null };

export type AssetCounterMeasureQueryVariables = Exact<{
  id: Scalars['ID']['input'];
  assetId: Scalars['ID']['input'];
  counterId: Scalars['ID']['input'];
}>;


export type AssetCounterMeasureQuery = { __typename?: 'Query', data: { __typename?: 'CounterMeasure', id: string, index: number } | null };

export type AssetCounterMeasuresQueryVariables = Exact<{
  page?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  sorts?: InputMaybe<CounterMeasureSortInputObject>;
  filters?: InputMaybe<Array<CounterMeasureFilterInputObject> | CounterMeasureFilterInputObject>;
  assetId: Scalars['ID']['input'];
  counterId: Scalars['ID']['input'];
}>;


export type AssetCounterMeasuresQuery = { __typename?: 'Query', data: { __typename?: 'CounterMeasureCollection', collection: Array<{ __typename?: 'CounterMeasure', id: string, createdAt: any, cumulativeUsage: number, index: number, gap: number, resetToZero: boolean }>, metadata: { __typename?: 'CollectionMetadata', currentPage: number, limitValue: number, totalCount: number, totalPages: number } } };

export type AssetCounterMeasuresGraphDataQueryVariables = Exact<{
  assetId: Scalars['ID']['input'];
  counterId: Scalars['ID']['input'];
  dateRange: DateRangeInputObject;
}>;


export type AssetCounterMeasuresGraphDataQuery = { __typename?: 'Query', data: Array<{ __typename?: 'CounterMeasureGraphData', createdAt: any, cumulativeUsage: number, gap: number }> };

export type AssetCounterCreateMutationVariables = Exact<{
  attributes: CounterCreateInputObject;
}>;


export type AssetCounterCreateMutation = { __typename?: 'Mutation', data: { __typename?: 'Counter', id: string } | null };

export type AssetCounterUpdateMutationVariables = Exact<{
  attributes: CounterUpdateInputObject;
  id: Scalars['ID']['input'];
  assetId: Scalars['ID']['input'];
}>;


export type AssetCounterUpdateMutation = { __typename?: 'Mutation', data: { __typename?: 'Counter', id: string, name: string, code: string, fullCode: string, measureType: CounterMeasureTypeEnum, measureUnit: CounterMeasureUnitEnum, prohibitLowerIndexThanPrevious: boolean } | null };

export type AssetCounterDestroyMutationVariables = Exact<{
  ids: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
  assetId: Scalars['ID']['input'];
}>;


export type AssetCounterDestroyMutation = { __typename?: 'Mutation', counterBulkDestroy: boolean | null };

export type AssetCounterMeasureCreateMutationVariables = Exact<{
  attributes: CounterMeasureCreateInputObject;
  assetId: Scalars['ID']['input'];
}>;


export type AssetCounterMeasureCreateMutation = { __typename?: 'Mutation', data: { __typename?: 'CounterMeasure', id: string } | null };

export type AssetCounterResetToZeroMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  assetId: Scalars['ID']['input'];
}>;


export type AssetCounterResetToZeroMutation = { __typename?: 'Mutation', data: { __typename?: 'Counter', id: string } | null };

export type AssetCounterBulkQrCodeCreateMutationVariables = Exact<{
  params: QrCodesCreateInputObject;
  assetId: Scalars['ID']['input'];
}>;


export type AssetCounterBulkQrCodeCreateMutation = { __typename?: 'Mutation', data: { __typename?: 'BackgroundJob', id: string, jid: string | null, parentId: string | null, rootId: string, kind: BackgroundJobKindEnum, status: BackgroundJobStatusEnum, displayStatus: BackgroundJobStatusEnum, treeStatus: BackgroundJobStatusEnum, done: number, total: number, failed: number, pctComplete: number, message: string | null, errorCode: string | null, result: any | null, estimatedFinishAt: any | null, startedAt: any | null, finishedAt: any | null, cancelRequestedAt: any | null, deliveryRequestedAt: any | null, dismissed: boolean, createdAt: any, updatedAt: any, children: Array<{ __typename?: 'BackgroundJob', id: string, jid: string | null, parentId: string | null, rootId: string, kind: BackgroundJobKindEnum, status: BackgroundJobStatusEnum, displayStatus: BackgroundJobStatusEnum, treeStatus: BackgroundJobStatusEnum, done: number, total: number, failed: number, pctComplete: number, message: string | null, errorCode: string | null, result: any | null, estimatedFinishAt: any | null, startedAt: any | null, finishedAt: any | null, cancelRequestedAt: any | null, deliveryRequestedAt: any | null, dismissed: boolean, createdAt: any, updatedAt: any, canCancel: { __typename?: 'AuthorizationResult', value: boolean, message: string | null, reasons: { __typename?: 'FailureReasons', details: string, fullMessages: Array<string> } | null }, canDismiss: { __typename?: 'AuthorizationResult', value: boolean, message: string | null, reasons: { __typename?: 'FailureReasons', details: string, fullMessages: Array<string> } | null }, canRequestDelivery: { __typename?: 'AuthorizationResult', value: boolean, message: string | null, reasons: { __typename?: 'FailureReasons', details: string, fullMessages: Array<string> } | null }, canRequeue: { __typename?: 'AuthorizationResult', value: boolean, message: string | null, reasons: { __typename?: 'FailureReasons', details: string, fullMessages: Array<string> } | null } }>, canCancel: { __typename?: 'AuthorizationResult', value: boolean, message: string | null, reasons: { __typename?: 'FailureReasons', details: string, fullMessages: Array<string> } | null }, canDismiss: { __typename?: 'AuthorizationResult', value: boolean, message: string | null, reasons: { __typename?: 'FailureReasons', details: string, fullMessages: Array<string> } | null }, canRequestDelivery: { __typename?: 'AuthorizationResult', value: boolean, message: string | null, reasons: { __typename?: 'FailureReasons', details: string, fullMessages: Array<string> } | null }, canRequeue: { __typename?: 'AuthorizationResult', value: boolean, message: string | null, reasons: { __typename?: 'FailureReasons', details: string, fullMessages: Array<string> } | null } } | null };

export type AssetNomenclaturesQueryVariables = Exact<{
  page?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  sorts?: InputMaybe<NomenclatureSortInputObject>;
  filters?: InputMaybe<Array<NomenclatureFilterInputObject> | NomenclatureFilterInputObject>;
  mainAssetId: Scalars['ID']['input'];
}>;


export type AssetNomenclaturesQuery = { __typename?: 'Query', data: { __typename?: 'NomenclatureCollection', collection: Array<{ __typename?: 'Nomenclature', id: string, quantity: number, componentAsset: { __typename?: 'Asset', id: string, name: string, code: string, fullCode: string, usesAsNomenclatureCount: number, iconAttached: { __typename?: 'Attachment', id: string, processed: boolean, fileTag: string | null, fileData: any | null, filename: string | null, urls: { __typename?: 'AttachmentUrl', large: string | null, medium: string | null, original: string | null, small: string | null, imagePreview: string | null, originalDirectDownload: string | null, video480p: string | null, video720p: string | null, video1080p: string | null } | null, metadata: { __typename?: 'AttachmentMetadata', intendedUse: string | null } | null } | null } | null }>, metadata: { __typename?: 'CollectionMetadata', currentPage: number, limitValue: number, totalCount: number, totalPages: number } } };

export type AssetNomenclaturesIdsQueryVariables = Exact<{
  sorts?: InputMaybe<NomenclatureSortInputObject>;
  filters?: InputMaybe<Array<NomenclatureFilterInputObject> | NomenclatureFilterInputObject>;
  onlyIds?: InputMaybe<Scalars['Boolean']['input']>;
  mainAssetId: Scalars['ID']['input'];
}>;


export type AssetNomenclaturesIdsQuery = { __typename?: 'Query', data: { __typename?: 'NomenclatureCollection', collection: Array<{ __typename?: 'Nomenclature', id: string }> } };

export type AssetNomenclatureQueryVariables = Exact<{
  id: Scalars['ID']['input'];
  mainAssetId: Scalars['ID']['input'];
}>;


export type AssetNomenclatureQuery = { __typename?: 'Query', data: { __typename?: 'Nomenclature', id: string, quantity: number, componentAsset: { __typename?: 'Asset', id: string, name: string, fullCode: string, iconAttached: { __typename?: 'Attachment', id: string, processed: boolean, fileTag: string | null, fileData: any | null, filename: string | null, urls: { __typename?: 'AttachmentUrl', large: string | null, medium: string | null, original: string | null, small: string | null, imagePreview: string | null, originalDirectDownload: string | null, video480p: string | null, video720p: string | null, video1080p: string | null } | null, metadata: { __typename?: 'AttachmentMetadata', intendedUse: string | null } | null } | null } | null } | null };

export type AssetNomenclatureCreateMutationVariables = Exact<{
  attributes: NomenclatureCreateInputObject;
}>;


export type AssetNomenclatureCreateMutation = { __typename?: 'Mutation', data: { __typename?: 'Nomenclature', quantity: number, componentAsset: { __typename?: 'Asset', id: string, name: string } | null } | null };

export type AssetNomenclatureUpdateMutationVariables = Exact<{
  attributes: NomenclatureUpdateInputObject;
  id: Scalars['ID']['input'];
  mainAssetId: Scalars['ID']['input'];
}>;


export type AssetNomenclatureUpdateMutation = { __typename?: 'Mutation', data: { __typename?: 'Nomenclature', quantity: number, componentAsset: { __typename?: 'Asset', id: string, name: string } | null } | null };

export type AssetNomenclatureDestroyMutationVariables = Exact<{
  ids: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
  mainAssetId: Scalars['ID']['input'];
}>;


export type AssetNomenclatureDestroyMutation = { __typename?: 'Mutation', nomenclatureBulkDestroy: boolean | null };

export type AuthenticationConfirmationsEmailConfirmationMutationVariables = Exact<{
  input: AuthenticationConfirmationsEmailConfirmationInput;
}>;


export type AuthenticationConfirmationsEmailConfirmationMutation = { __typename?: 'Mutation', data: { __typename?: 'Whoami', resource: { __typename?: 'SystemAdmin', id: string } | { __typename?: 'User' } } };

export type AuthenticationConfirmationsRegistrationConfirmationMutationVariables = Exact<{
  input: AuthenticationConfirmationsRegistrationConfirmationInput;
}>;


export type AuthenticationConfirmationsRegistrationConfirmationMutation = { __typename?: 'Mutation', data: { __typename?: 'Whoami', resource: { __typename?: 'SystemAdmin', id: string } | { __typename?: 'User' } } };

export type AuthenticationConfirmationsResendEmailConfirmationMutationVariables = Exact<{
  input: AuthenticationConfirmationsResendEmailConfirmationInput;
}>;


export type AuthenticationConfirmationsResendEmailConfirmationMutation = { __typename?: 'Mutation', data: { __typename?: 'ResponseMessage', message: string } };

export type AuthenticationConfirmationsResendRegistrationConfirmationMutationVariables = Exact<{
  input: AuthenticationConfirmationsResendRegistrationConfirmationInput;
}>;


export type AuthenticationConfirmationsResendRegistrationConfirmationMutation = { __typename?: 'Mutation', data: { __typename?: 'ResponseMessage', message: string } };

export type AuthenticationPasswordsForgotMutationVariables = Exact<{
  input: AuthenticationPasswordsForgotInput;
}>;


export type AuthenticationPasswordsForgotMutation = { __typename?: 'Mutation', data: { __typename?: 'ResponseMessage', message: string } };

export type AuthenticationPasswordsUpdateMutationVariables = Exact<{
  input: AuthenticationPasswordsUpdateInput;
}>;


export type AuthenticationPasswordsUpdateMutation = { __typename?: 'Mutation', data: { __typename?: 'Whoami', resource: { __typename?: 'SystemAdmin', id: string } | { __typename?: 'User' } } };

export type AuthenticationSessionEndMutationVariables = Exact<{
  input: AuthenticationSessionEndInput;
}>;


export type AuthenticationSessionEndMutation = { __typename?: 'Mutation', data: boolean | null };

export type BackgroundJobsQueryVariables = Exact<{
  page?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  scope?: InputMaybe<BackgroundJobScopeEnum>;
  filters?: InputMaybe<Array<BackgroundJobFilterInputObject> | BackgroundJobFilterInputObject>;
  sorts?: InputMaybe<BackgroundJobSortInputObject>;
}>;


export type BackgroundJobsQuery = { __typename?: 'Query', data: { __typename?: 'BackgroundJobCollection', collection: Array<{ __typename?: 'BackgroundJob', id: string, jid: string | null, parentId: string | null, rootId: string, kind: BackgroundJobKindEnum, status: BackgroundJobStatusEnum, displayStatus: BackgroundJobStatusEnum, treeStatus: BackgroundJobStatusEnum, done: number, total: number, failed: number, pctComplete: number, message: string | null, errorCode: string | null, result: any | null, estimatedFinishAt: any | null, startedAt: any | null, finishedAt: any | null, cancelRequestedAt: any | null, deliveryRequestedAt: any | null, dismissed: boolean, createdAt: any, updatedAt: any, children: Array<{ __typename?: 'BackgroundJob', id: string, jid: string | null, parentId: string | null, rootId: string, kind: BackgroundJobKindEnum, status: BackgroundJobStatusEnum, displayStatus: BackgroundJobStatusEnum, treeStatus: BackgroundJobStatusEnum, done: number, total: number, failed: number, pctComplete: number, message: string | null, errorCode: string | null, result: any | null, estimatedFinishAt: any | null, startedAt: any | null, finishedAt: any | null, cancelRequestedAt: any | null, deliveryRequestedAt: any | null, dismissed: boolean, createdAt: any, updatedAt: any, canCancel: { __typename?: 'AuthorizationResult', value: boolean, message: string | null, reasons: { __typename?: 'FailureReasons', details: string, fullMessages: Array<string> } | null }, canDismiss: { __typename?: 'AuthorizationResult', value: boolean, message: string | null, reasons: { __typename?: 'FailureReasons', details: string, fullMessages: Array<string> } | null }, canRequestDelivery: { __typename?: 'AuthorizationResult', value: boolean, message: string | null, reasons: { __typename?: 'FailureReasons', details: string, fullMessages: Array<string> } | null }, canRequeue: { __typename?: 'AuthorizationResult', value: boolean, message: string | null, reasons: { __typename?: 'FailureReasons', details: string, fullMessages: Array<string> } | null } }>, canCancel: { __typename?: 'AuthorizationResult', value: boolean, message: string | null, reasons: { __typename?: 'FailureReasons', details: string, fullMessages: Array<string> } | null }, canDismiss: { __typename?: 'AuthorizationResult', value: boolean, message: string | null, reasons: { __typename?: 'FailureReasons', details: string, fullMessages: Array<string> } | null }, canRequestDelivery: { __typename?: 'AuthorizationResult', value: boolean, message: string | null, reasons: { __typename?: 'FailureReasons', details: string, fullMessages: Array<string> } | null }, canRequeue: { __typename?: 'AuthorizationResult', value: boolean, message: string | null, reasons: { __typename?: 'FailureReasons', details: string, fullMessages: Array<string> } | null } }>, metadata: { __typename?: 'CollectionMetadata', currentPage: number, limitValue: number, totalCount: number, totalPages: number } } };

export type BackgroundJobQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type BackgroundJobQuery = { __typename?: 'Query', data: { __typename?: 'BackgroundJob', id: string, jid: string | null, parentId: string | null, rootId: string, kind: BackgroundJobKindEnum, status: BackgroundJobStatusEnum, displayStatus: BackgroundJobStatusEnum, treeStatus: BackgroundJobStatusEnum, done: number, total: number, failed: number, pctComplete: number, message: string | null, errorCode: string | null, result: any | null, estimatedFinishAt: any | null, startedAt: any | null, finishedAt: any | null, cancelRequestedAt: any | null, deliveryRequestedAt: any | null, dismissed: boolean, createdAt: any, updatedAt: any, children: Array<{ __typename?: 'BackgroundJob', id: string, jid: string | null, parentId: string | null, rootId: string, kind: BackgroundJobKindEnum, status: BackgroundJobStatusEnum, displayStatus: BackgroundJobStatusEnum, treeStatus: BackgroundJobStatusEnum, done: number, total: number, failed: number, pctComplete: number, message: string | null, errorCode: string | null, result: any | null, estimatedFinishAt: any | null, startedAt: any | null, finishedAt: any | null, cancelRequestedAt: any | null, deliveryRequestedAt: any | null, dismissed: boolean, createdAt: any, updatedAt: any, canCancel: { __typename?: 'AuthorizationResult', value: boolean, message: string | null, reasons: { __typename?: 'FailureReasons', details: string, fullMessages: Array<string> } | null }, canDismiss: { __typename?: 'AuthorizationResult', value: boolean, message: string | null, reasons: { __typename?: 'FailureReasons', details: string, fullMessages: Array<string> } | null }, canRequestDelivery: { __typename?: 'AuthorizationResult', value: boolean, message: string | null, reasons: { __typename?: 'FailureReasons', details: string, fullMessages: Array<string> } | null }, canRequeue: { __typename?: 'AuthorizationResult', value: boolean, message: string | null, reasons: { __typename?: 'FailureReasons', details: string, fullMessages: Array<string> } | null } }>, canCancel: { __typename?: 'AuthorizationResult', value: boolean, message: string | null, reasons: { __typename?: 'FailureReasons', details: string, fullMessages: Array<string> } | null }, canDismiss: { __typename?: 'AuthorizationResult', value: boolean, message: string | null, reasons: { __typename?: 'FailureReasons', details: string, fullMessages: Array<string> } | null }, canRequestDelivery: { __typename?: 'AuthorizationResult', value: boolean, message: string | null, reasons: { __typename?: 'FailureReasons', details: string, fullMessages: Array<string> } | null }, canRequeue: { __typename?: 'AuthorizationResult', value: boolean, message: string | null, reasons: { __typename?: 'FailureReasons', details: string, fullMessages: Array<string> } | null } } | null };

export type BackgroundJobProgressSubscriptionVariables = Exact<{ [key: string]: never; }>;


export type BackgroundJobProgressSubscription = { __typename?: 'Subscription', backgroundJobProgress: { __typename?: 'BackgroundJobProgressEvent', rootId: string, node: { __typename?: 'BackgroundJob', id: string, jid: string | null, parentId: string | null, rootId: string, kind: BackgroundJobKindEnum, status: BackgroundJobStatusEnum, displayStatus: BackgroundJobStatusEnum, treeStatus: BackgroundJobStatusEnum, done: number, total: number, failed: number, pctComplete: number, message: string | null, errorCode: string | null, result: any | null, estimatedFinishAt: any | null, startedAt: any | null, finishedAt: any | null, cancelRequestedAt: any | null, deliveryRequestedAt: any | null, dismissed: boolean, createdAt: any, updatedAt: any, children: Array<{ __typename?: 'BackgroundJob', id: string, jid: string | null, parentId: string | null, rootId: string, kind: BackgroundJobKindEnum, status: BackgroundJobStatusEnum, displayStatus: BackgroundJobStatusEnum, treeStatus: BackgroundJobStatusEnum, done: number, total: number, failed: number, pctComplete: number, message: string | null, errorCode: string | null, result: any | null, estimatedFinishAt: any | null, startedAt: any | null, finishedAt: any | null, cancelRequestedAt: any | null, deliveryRequestedAt: any | null, dismissed: boolean, createdAt: any, updatedAt: any, canCancel: { __typename?: 'AuthorizationResult', value: boolean, message: string | null, reasons: { __typename?: 'FailureReasons', details: string, fullMessages: Array<string> } | null }, canDismiss: { __typename?: 'AuthorizationResult', value: boolean, message: string | null, reasons: { __typename?: 'FailureReasons', details: string, fullMessages: Array<string> } | null }, canRequestDelivery: { __typename?: 'AuthorizationResult', value: boolean, message: string | null, reasons: { __typename?: 'FailureReasons', details: string, fullMessages: Array<string> } | null }, canRequeue: { __typename?: 'AuthorizationResult', value: boolean, message: string | null, reasons: { __typename?: 'FailureReasons', details: string, fullMessages: Array<string> } | null } }>, canCancel: { __typename?: 'AuthorizationResult', value: boolean, message: string | null, reasons: { __typename?: 'FailureReasons', details: string, fullMessages: Array<string> } | null }, canDismiss: { __typename?: 'AuthorizationResult', value: boolean, message: string | null, reasons: { __typename?: 'FailureReasons', details: string, fullMessages: Array<string> } | null }, canRequestDelivery: { __typename?: 'AuthorizationResult', value: boolean, message: string | null, reasons: { __typename?: 'FailureReasons', details: string, fullMessages: Array<string> } | null }, canRequeue: { __typename?: 'AuthorizationResult', value: boolean, message: string | null, reasons: { __typename?: 'FailureReasons', details: string, fullMessages: Array<string> } | null } } | null } };

export type BackgroundJobCancelMutationVariables = Exact<{
  input: BackgroundJobCancelInput;
}>;


export type BackgroundJobCancelMutation = { __typename?: 'Mutation', data: { __typename?: 'BackgroundJob', id: string, jid: string | null, parentId: string | null, rootId: string, kind: BackgroundJobKindEnum, status: BackgroundJobStatusEnum, displayStatus: BackgroundJobStatusEnum, treeStatus: BackgroundJobStatusEnum, done: number, total: number, failed: number, pctComplete: number, message: string | null, errorCode: string | null, result: any | null, estimatedFinishAt: any | null, startedAt: any | null, finishedAt: any | null, cancelRequestedAt: any | null, deliveryRequestedAt: any | null, dismissed: boolean, createdAt: any, updatedAt: any, canCancel: { __typename?: 'AuthorizationResult', value: boolean, message: string | null, reasons: { __typename?: 'FailureReasons', details: string, fullMessages: Array<string> } | null }, canDismiss: { __typename?: 'AuthorizationResult', value: boolean, message: string | null, reasons: { __typename?: 'FailureReasons', details: string, fullMessages: Array<string> } | null }, canRequestDelivery: { __typename?: 'AuthorizationResult', value: boolean, message: string | null, reasons: { __typename?: 'FailureReasons', details: string, fullMessages: Array<string> } | null }, canRequeue: { __typename?: 'AuthorizationResult', value: boolean, message: string | null, reasons: { __typename?: 'FailureReasons', details: string, fullMessages: Array<string> } | null } } | null };

export type BackgroundJobDismissMutationVariables = Exact<{
  input: BackgroundJobDismissInput;
}>;


export type BackgroundJobDismissMutation = { __typename?: 'Mutation', data: { __typename?: 'BackgroundJob', id: string, jid: string | null, parentId: string | null, rootId: string, kind: BackgroundJobKindEnum, status: BackgroundJobStatusEnum, displayStatus: BackgroundJobStatusEnum, treeStatus: BackgroundJobStatusEnum, done: number, total: number, failed: number, pctComplete: number, message: string | null, errorCode: string | null, result: any | null, estimatedFinishAt: any | null, startedAt: any | null, finishedAt: any | null, cancelRequestedAt: any | null, deliveryRequestedAt: any | null, dismissed: boolean, createdAt: any, updatedAt: any, canCancel: { __typename?: 'AuthorizationResult', value: boolean, message: string | null, reasons: { __typename?: 'FailureReasons', details: string, fullMessages: Array<string> } | null }, canDismiss: { __typename?: 'AuthorizationResult', value: boolean, message: string | null, reasons: { __typename?: 'FailureReasons', details: string, fullMessages: Array<string> } | null }, canRequestDelivery: { __typename?: 'AuthorizationResult', value: boolean, message: string | null, reasons: { __typename?: 'FailureReasons', details: string, fullMessages: Array<string> } | null }, canRequeue: { __typename?: 'AuthorizationResult', value: boolean, message: string | null, reasons: { __typename?: 'FailureReasons', details: string, fullMessages: Array<string> } | null } } | null };

export type BackgroundJobRequestDeliveryMutationVariables = Exact<{
  input: BackgroundJobRequestDeliveryInput;
}>;


export type BackgroundJobRequestDeliveryMutation = { __typename?: 'Mutation', data: { __typename?: 'BackgroundJob', id: string, jid: string | null, parentId: string | null, rootId: string, kind: BackgroundJobKindEnum, status: BackgroundJobStatusEnum, displayStatus: BackgroundJobStatusEnum, treeStatus: BackgroundJobStatusEnum, done: number, total: number, failed: number, pctComplete: number, message: string | null, errorCode: string | null, result: any | null, estimatedFinishAt: any | null, startedAt: any | null, finishedAt: any | null, cancelRequestedAt: any | null, deliveryRequestedAt: any | null, dismissed: boolean, createdAt: any, updatedAt: any, canCancel: { __typename?: 'AuthorizationResult', value: boolean, message: string | null, reasons: { __typename?: 'FailureReasons', details: string, fullMessages: Array<string> } | null }, canDismiss: { __typename?: 'AuthorizationResult', value: boolean, message: string | null, reasons: { __typename?: 'FailureReasons', details: string, fullMessages: Array<string> } | null }, canRequestDelivery: { __typename?: 'AuthorizationResult', value: boolean, message: string | null, reasons: { __typename?: 'FailureReasons', details: string, fullMessages: Array<string> } | null }, canRequeue: { __typename?: 'AuthorizationResult', value: boolean, message: string | null, reasons: { __typename?: 'FailureReasons', details: string, fullMessages: Array<string> } | null } } | null };

export type BackgroundJobRequeueMutationVariables = Exact<{
  input: BackgroundJobRequeueInput;
}>;


export type BackgroundJobRequeueMutation = { __typename?: 'Mutation', data: { __typename?: 'BackgroundJob', id: string, jid: string | null, parentId: string | null, rootId: string, kind: BackgroundJobKindEnum, status: BackgroundJobStatusEnum, displayStatus: BackgroundJobStatusEnum, treeStatus: BackgroundJobStatusEnum, done: number, total: number, failed: number, pctComplete: number, message: string | null, errorCode: string | null, result: any | null, estimatedFinishAt: any | null, startedAt: any | null, finishedAt: any | null, cancelRequestedAt: any | null, deliveryRequestedAt: any | null, dismissed: boolean, createdAt: any, updatedAt: any, canCancel: { __typename?: 'AuthorizationResult', value: boolean, message: string | null, reasons: { __typename?: 'FailureReasons', details: string, fullMessages: Array<string> } | null }, canDismiss: { __typename?: 'AuthorizationResult', value: boolean, message: string | null, reasons: { __typename?: 'FailureReasons', details: string, fullMessages: Array<string> } | null }, canRequestDelivery: { __typename?: 'AuthorizationResult', value: boolean, message: string | null, reasons: { __typename?: 'FailureReasons', details: string, fullMessages: Array<string> } | null }, canRequeue: { __typename?: 'AuthorizationResult', value: boolean, message: string | null, reasons: { __typename?: 'FailureReasons', details: string, fullMessages: Array<string> } | null } } | null };

export type WhoamiQueryVariables = Exact<{
  includeFullData?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type WhoamiQuery = { __typename?: 'Query', whoami: { __typename?: 'Whoami', resource: { __typename: 'SystemAdmin' } | { __typename: 'User', deactivatedAt?: any | null, debugModeUntil: any | null, createdAt?: any, email?: string | null, firstName?: string, id: string, lang?: LanguageEnum, lastName?: string, personalId?: string | null, passwordSetupRequired?: boolean, passwordUpdatedAt?: any | null, unconfirmedEmail?: string | null, updatedAt?: any, username?: string | null, verified?: boolean | null, phoneNumber?: string | null, role: UserRoleEnum, codeOfConductAccepted?: boolean, avatarAttached?: { __typename?: 'Attachment', id: string, processed: boolean, fileTag: string | null, fileData: any | null, filename: string | null, urls: { __typename?: 'AttachmentUrl', large: string | null, medium: string | null, original: string | null, small: string | null, imagePreview: string | null, originalDirectDownload: string | null, video480p: string | null, video720p: string | null, video1080p: string | null } | null, metadata: { __typename?: 'AttachmentMetadata', intendedUse: string | null } | null } | null, sites?: { __typename?: 'SiteCollection', collection: Array<{ __typename?: 'Site', id: string, name: string }> }, finalAccesses: Array<{ __typename?: 'Access', component: AccessComponentEnum, itemIds: Array<string>, level: AccessLevelEnum | null, scopeLevel: AccessScopeLevelEnum | null, policy: AccessPolicyEnum | null }> | null, company: { __typename?: 'Company', id: string, activeUsersCount: number, createdAt: any, plan: { __typename?: 'CompanyPlan', usersLimit: number | null, upgradeFeatures: Array<AccessComponentEnum>, accesses: Array<{ __typename?: 'Access', component: AccessComponentEnum, level: AccessLevelEnum | null }> } } } } };

export type CountriesQueryVariables = Exact<{ [key: string]: never; }>;


export type CountriesQuery = { __typename?: 'Query', data: Array<{ __typename?: 'GeoCountry', code: string, name: string }> };

export type DataImportFragmentFragment = { __typename?: 'DataImport', importedRows: number | null, failureDetails: any | null, fileException: Array<string> | null, id: string, kind: DataImportKindEnum, status: DataImportStatusEnum, totalRows: number | null, createdAt: any, attachmentAttached: { __typename?: 'Attachment', id: string, processed: boolean, fileTag: string | null, fileData: any | null, filename: string | null, urls: { __typename?: 'AttachmentUrl', large: string | null, medium: string | null, original: string | null, small: string | null, imagePreview: string | null, originalDirectDownload: string | null, video480p: string | null, video720p: string | null, video1080p: string | null } | null, metadata: { __typename?: 'AttachmentMetadata', intendedUse: string | null } | null } | null, backgroundJob: { __typename?: 'BackgroundJob', id: string, jid: string | null, parentId: string | null, rootId: string, kind: BackgroundJobKindEnum, status: BackgroundJobStatusEnum, displayStatus: BackgroundJobStatusEnum, treeStatus: BackgroundJobStatusEnum, done: number, total: number, failed: number, pctComplete: number, message: string | null, errorCode: string | null, result: any | null, estimatedFinishAt: any | null, startedAt: any | null, finishedAt: any | null, cancelRequestedAt: any | null, deliveryRequestedAt: any | null, dismissed: boolean, createdAt: any, updatedAt: any, children: Array<{ __typename?: 'BackgroundJob', id: string, jid: string | null, parentId: string | null, rootId: string, kind: BackgroundJobKindEnum, status: BackgroundJobStatusEnum, displayStatus: BackgroundJobStatusEnum, treeStatus: BackgroundJobStatusEnum, done: number, total: number, failed: number, pctComplete: number, message: string | null, errorCode: string | null, result: any | null, estimatedFinishAt: any | null, startedAt: any | null, finishedAt: any | null, cancelRequestedAt: any | null, deliveryRequestedAt: any | null, dismissed: boolean, createdAt: any, updatedAt: any, canCancel: { __typename?: 'AuthorizationResult', value: boolean, message: string | null, reasons: { __typename?: 'FailureReasons', details: string, fullMessages: Array<string> } | null }, canDismiss: { __typename?: 'AuthorizationResult', value: boolean, message: string | null, reasons: { __typename?: 'FailureReasons', details: string, fullMessages: Array<string> } | null }, canRequestDelivery: { __typename?: 'AuthorizationResult', value: boolean, message: string | null, reasons: { __typename?: 'FailureReasons', details: string, fullMessages: Array<string> } | null }, canRequeue: { __typename?: 'AuthorizationResult', value: boolean, message: string | null, reasons: { __typename?: 'FailureReasons', details: string, fullMessages: Array<string> } | null } }>, canCancel: { __typename?: 'AuthorizationResult', value: boolean, message: string | null, reasons: { __typename?: 'FailureReasons', details: string, fullMessages: Array<string> } | null }, canDismiss: { __typename?: 'AuthorizationResult', value: boolean, message: string | null, reasons: { __typename?: 'FailureReasons', details: string, fullMessages: Array<string> } | null }, canRequestDelivery: { __typename?: 'AuthorizationResult', value: boolean, message: string | null, reasons: { __typename?: 'FailureReasons', details: string, fullMessages: Array<string> } | null }, canRequeue: { __typename?: 'AuthorizationResult', value: boolean, message: string | null, reasons: { __typename?: 'FailureReasons', details: string, fullMessages: Array<string> } | null } } | null, user: { __typename?: 'User', id: string, firstName: string, lastName: string, email: string | null, avatarAttached: { __typename?: 'Attachment', id: string, processed: boolean, fileTag: string | null, fileData: any | null, filename: string | null, urls: { __typename?: 'AttachmentUrl', large: string | null, medium: string | null, original: string | null, small: string | null, imagePreview: string | null, originalDirectDownload: string | null, video480p: string | null, video720p: string | null, video1080p: string | null } | null, metadata: { __typename?: 'AttachmentMetadata', intendedUse: string | null } | null } | null } | null, canDestroy: { __typename?: 'AuthorizationResult', value: boolean, message: string | null, reasons: { __typename?: 'FailureReasons', details: string, fullMessages: Array<string> } | null }, canUpdate: { __typename?: 'AuthorizationResult', value: boolean, message: string | null, reasons: { __typename?: 'FailureReasons', details: string, fullMessages: Array<string> } | null } };

export type DataImportQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DataImportQuery = { __typename?: 'Query', data: { __typename?: 'DataImport', importedRows: number | null, failureDetails: any | null, fileException: Array<string> | null, id: string, kind: DataImportKindEnum, status: DataImportStatusEnum, totalRows: number | null, createdAt: any, attachmentAttached: { __typename?: 'Attachment', id: string, processed: boolean, fileTag: string | null, fileData: any | null, filename: string | null, urls: { __typename?: 'AttachmentUrl', large: string | null, medium: string | null, original: string | null, small: string | null, imagePreview: string | null, originalDirectDownload: string | null, video480p: string | null, video720p: string | null, video1080p: string | null } | null, metadata: { __typename?: 'AttachmentMetadata', intendedUse: string | null } | null } | null, backgroundJob: { __typename?: 'BackgroundJob', id: string, jid: string | null, parentId: string | null, rootId: string, kind: BackgroundJobKindEnum, status: BackgroundJobStatusEnum, displayStatus: BackgroundJobStatusEnum, treeStatus: BackgroundJobStatusEnum, done: number, total: number, failed: number, pctComplete: number, message: string | null, errorCode: string | null, result: any | null, estimatedFinishAt: any | null, startedAt: any | null, finishedAt: any | null, cancelRequestedAt: any | null, deliveryRequestedAt: any | null, dismissed: boolean, createdAt: any, updatedAt: any, children: Array<{ __typename?: 'BackgroundJob', id: string, jid: string | null, parentId: string | null, rootId: string, kind: BackgroundJobKindEnum, status: BackgroundJobStatusEnum, displayStatus: BackgroundJobStatusEnum, treeStatus: BackgroundJobStatusEnum, done: number, total: number, failed: number, pctComplete: number, message: string | null, errorCode: string | null, result: any | null, estimatedFinishAt: any | null, startedAt: any | null, finishedAt: any | null, cancelRequestedAt: any | null, deliveryRequestedAt: any | null, dismissed: boolean, createdAt: any, updatedAt: any, canCancel: { __typename?: 'AuthorizationResult', value: boolean, message: string | null, reasons: { __typename?: 'FailureReasons', details: string, fullMessages: Array<string> } | null }, canDismiss: { __typename?: 'AuthorizationResult', value: boolean, message: string | null, reasons: { __typename?: 'FailureReasons', details: string, fullMessages: Array<string> } | null }, canRequestDelivery: { __typename?: 'AuthorizationResult', value: boolean, message: string | null, reasons: { __typename?: 'FailureReasons', details: string, fullMessages: Array<string> } | null }, canRequeue: { __typename?: 'AuthorizationResult', value: boolean, message: string | null, reasons: { __typename?: 'FailureReasons', details: string, fullMessages: Array<string> } | null } }>, canCancel: { __typename?: 'AuthorizationResult', value: boolean, message: string | null, reasons: { __typename?: 'FailureReasons', details: string, fullMessages: Array<string> } | null }, canDismiss: { __typename?: 'AuthorizationResult', value: boolean, message: string | null, reasons: { __typename?: 'FailureReasons', details: string, fullMessages: Array<string> } | null }, canRequestDelivery: { __typename?: 'AuthorizationResult', value: boolean, message: string | null, reasons: { __typename?: 'FailureReasons', details: string, fullMessages: Array<string> } | null }, canRequeue: { __typename?: 'AuthorizationResult', value: boolean, message: string | null, reasons: { __typename?: 'FailureReasons', details: string, fullMessages: Array<string> } | null } } | null, user: { __typename?: 'User', id: string, firstName: string, lastName: string, email: string | null, avatarAttached: { __typename?: 'Attachment', id: string, processed: boolean, fileTag: string | null, fileData: any | null, filename: string | null, urls: { __typename?: 'AttachmentUrl', large: string | null, medium: string | null, original: string | null, small: string | null, imagePreview: string | null, originalDirectDownload: string | null, video480p: string | null, video720p: string | null, video1080p: string | null } | null, metadata: { __typename?: 'AttachmentMetadata', intendedUse: string | null } | null } | null } | null, canDestroy: { __typename?: 'AuthorizationResult', value: boolean, message: string | null, reasons: { __typename?: 'FailureReasons', details: string, fullMessages: Array<string> } | null }, canUpdate: { __typename?: 'AuthorizationResult', value: boolean, message: string | null, reasons: { __typename?: 'FailureReasons', details: string, fullMessages: Array<string> } | null } } | null };

export type DataImportsQueryVariables = Exact<{
  page?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  filters?: InputMaybe<Array<DataImportFilterInputObject> | DataImportFilterInputObject>;
  sorts?: InputMaybe<DataImportSortInputObject>;
  onlyIds?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type DataImportsQuery = { __typename?: 'Query', data: { __typename?: 'DataImportCollection', collection: Array<{ __typename?: 'DataImport', importedRows: number | null, failureDetails: any | null, fileException: Array<string> | null, id: string, kind: DataImportKindEnum, status: DataImportStatusEnum, totalRows: number | null, createdAt: any, attachmentAttached: { __typename?: 'Attachment', id: string, processed: boolean, fileTag: string | null, fileData: any | null, filename: string | null, urls: { __typename?: 'AttachmentUrl', large: string | null, medium: string | null, original: string | null, small: string | null, imagePreview: string | null, originalDirectDownload: string | null, video480p: string | null, video720p: string | null, video1080p: string | null } | null, metadata: { __typename?: 'AttachmentMetadata', intendedUse: string | null } | null } | null, backgroundJob: { __typename?: 'BackgroundJob', id: string, jid: string | null, parentId: string | null, rootId: string, kind: BackgroundJobKindEnum, status: BackgroundJobStatusEnum, displayStatus: BackgroundJobStatusEnum, treeStatus: BackgroundJobStatusEnum, done: number, total: number, failed: number, pctComplete: number, message: string | null, errorCode: string | null, result: any | null, estimatedFinishAt: any | null, startedAt: any | null, finishedAt: any | null, cancelRequestedAt: any | null, deliveryRequestedAt: any | null, dismissed: boolean, createdAt: any, updatedAt: any, children: Array<{ __typename?: 'BackgroundJob', id: string, jid: string | null, parentId: string | null, rootId: string, kind: BackgroundJobKindEnum, status: BackgroundJobStatusEnum, displayStatus: BackgroundJobStatusEnum, treeStatus: BackgroundJobStatusEnum, done: number, total: number, failed: number, pctComplete: number, message: string | null, errorCode: string | null, result: any | null, estimatedFinishAt: any | null, startedAt: any | null, finishedAt: any | null, cancelRequestedAt: any | null, deliveryRequestedAt: any | null, dismissed: boolean, createdAt: any, updatedAt: any, canCancel: { __typename?: 'AuthorizationResult', value: boolean, message: string | null, reasons: { __typename?: 'FailureReasons', details: string, fullMessages: Array<string> } | null }, canDismiss: { __typename?: 'AuthorizationResult', value: boolean, message: string | null, reasons: { __typename?: 'FailureReasons', details: string, fullMessages: Array<string> } | null }, canRequestDelivery: { __typename?: 'AuthorizationResult', value: boolean, message: string | null, reasons: { __typename?: 'FailureReasons', details: string, fullMessages: Array<string> } | null }, canRequeue: { __typename?: 'AuthorizationResult', value: boolean, message: string | null, reasons: { __typename?: 'FailureReasons', details: string, fullMessages: Array<string> } | null } }>, canCancel: { __typename?: 'AuthorizationResult', value: boolean, message: string | null, reasons: { __typename?: 'FailureReasons', details: string, fullMessages: Array<string> } | null }, canDismiss: { __typename?: 'AuthorizationResult', value: boolean, message: string | null, reasons: { __typename?: 'FailureReasons', details: string, fullMessages: Array<string> } | null }, canRequestDelivery: { __typename?: 'AuthorizationResult', value: boolean, message: string | null, reasons: { __typename?: 'FailureReasons', details: string, fullMessages: Array<string> } | null }, canRequeue: { __typename?: 'AuthorizationResult', value: boolean, message: string | null, reasons: { __typename?: 'FailureReasons', details: string, fullMessages: Array<string> } | null } } | null, user: { __typename?: 'User', id: string, firstName: string, lastName: string, email: string | null, avatarAttached: { __typename?: 'Attachment', id: string, processed: boolean, fileTag: string | null, fileData: any | null, filename: string | null, urls: { __typename?: 'AttachmentUrl', large: string | null, medium: string | null, original: string | null, small: string | null, imagePreview: string | null, originalDirectDownload: string | null, video480p: string | null, video720p: string | null, video1080p: string | null } | null, metadata: { __typename?: 'AttachmentMetadata', intendedUse: string | null } | null } | null } | null, canDestroy: { __typename?: 'AuthorizationResult', value: boolean, message: string | null, reasons: { __typename?: 'FailureReasons', details: string, fullMessages: Array<string> } | null }, canUpdate: { __typename?: 'AuthorizationResult', value: boolean, message: string | null, reasons: { __typename?: 'FailureReasons', details: string, fullMessages: Array<string> } | null } }>, metadata: { __typename?: 'CollectionMetadata', currentPage: number, limitValue: number, totalCount: number, totalPages: number } } };

export type DataImportIdsQueryVariables = Exact<{
  page?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  filters?: InputMaybe<Array<DataImportFilterInputObject> | DataImportFilterInputObject>;
  sorts?: InputMaybe<DataImportSortInputObject>;
  onlyIds?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type DataImportIdsQuery = { __typename?: 'Query', data: { __typename?: 'DataImportCollection', collection: Array<{ __typename?: 'DataImport', id: string }> } };

export type DataImportConfigQueryVariables = Exact<{ [key: string]: never; }>;


export type DataImportConfigQuery = { __typename?: 'Query', data: any | null };

export type DataImportCreateMutationVariables = Exact<{
  attributes: DataImportCreateInputObject;
}>;


export type DataImportCreateMutation = { __typename?: 'Mutation', data: { __typename?: 'DataImport', importedRows: number | null, failureDetails: any | null, fileException: Array<string> | null, id: string, kind: DataImportKindEnum, status: DataImportStatusEnum, totalRows: number | null, createdAt: any, attachmentAttached: { __typename?: 'Attachment', id: string, processed: boolean, fileTag: string | null, fileData: any | null, filename: string | null, urls: { __typename?: 'AttachmentUrl', large: string | null, medium: string | null, original: string | null, small: string | null, imagePreview: string | null, originalDirectDownload: string | null, video480p: string | null, video720p: string | null, video1080p: string | null } | null, metadata: { __typename?: 'AttachmentMetadata', intendedUse: string | null } | null } | null, backgroundJob: { __typename?: 'BackgroundJob', id: string, jid: string | null, parentId: string | null, rootId: string, kind: BackgroundJobKindEnum, status: BackgroundJobStatusEnum, displayStatus: BackgroundJobStatusEnum, treeStatus: BackgroundJobStatusEnum, done: number, total: number, failed: number, pctComplete: number, message: string | null, errorCode: string | null, result: any | null, estimatedFinishAt: any | null, startedAt: any | null, finishedAt: any | null, cancelRequestedAt: any | null, deliveryRequestedAt: any | null, dismissed: boolean, createdAt: any, updatedAt: any, children: Array<{ __typename?: 'BackgroundJob', id: string, jid: string | null, parentId: string | null, rootId: string, kind: BackgroundJobKindEnum, status: BackgroundJobStatusEnum, displayStatus: BackgroundJobStatusEnum, treeStatus: BackgroundJobStatusEnum, done: number, total: number, failed: number, pctComplete: number, message: string | null, errorCode: string | null, result: any | null, estimatedFinishAt: any | null, startedAt: any | null, finishedAt: any | null, cancelRequestedAt: any | null, deliveryRequestedAt: any | null, dismissed: boolean, createdAt: any, updatedAt: any, canCancel: { __typename?: 'AuthorizationResult', value: boolean, message: string | null, reasons: { __typename?: 'FailureReasons', details: string, fullMessages: Array<string> } | null }, canDismiss: { __typename?: 'AuthorizationResult', value: boolean, message: string | null, reasons: { __typename?: 'FailureReasons', details: string, fullMessages: Array<string> } | null }, canRequestDelivery: { __typename?: 'AuthorizationResult', value: boolean, message: string | null, reasons: { __typename?: 'FailureReasons', details: string, fullMessages: Array<string> } | null }, canRequeue: { __typename?: 'AuthorizationResult', value: boolean, message: string | null, reasons: { __typename?: 'FailureReasons', details: string, fullMessages: Array<string> } | null } }>, canCancel: { __typename?: 'AuthorizationResult', value: boolean, message: string | null, reasons: { __typename?: 'FailureReasons', details: string, fullMessages: Array<string> } | null }, canDismiss: { __typename?: 'AuthorizationResult', value: boolean, message: string | null, reasons: { __typename?: 'FailureReasons', details: string, fullMessages: Array<string> } | null }, canRequestDelivery: { __typename?: 'AuthorizationResult', value: boolean, message: string | null, reasons: { __typename?: 'FailureReasons', details: string, fullMessages: Array<string> } | null }, canRequeue: { __typename?: 'AuthorizationResult', value: boolean, message: string | null, reasons: { __typename?: 'FailureReasons', details: string, fullMessages: Array<string> } | null } } | null, user: { __typename?: 'User', id: string, firstName: string, lastName: string, email: string | null, avatarAttached: { __typename?: 'Attachment', id: string, processed: boolean, fileTag: string | null, fileData: any | null, filename: string | null, urls: { __typename?: 'AttachmentUrl', large: string | null, medium: string | null, original: string | null, small: string | null, imagePreview: string | null, originalDirectDownload: string | null, video480p: string | null, video720p: string | null, video1080p: string | null } | null, metadata: { __typename?: 'AttachmentMetadata', intendedUse: string | null } | null } | null } | null, canDestroy: { __typename?: 'AuthorizationResult', value: boolean, message: string | null, reasons: { __typename?: 'FailureReasons', details: string, fullMessages: Array<string> } | null }, canUpdate: { __typename?: 'AuthorizationResult', value: boolean, message: string | null, reasons: { __typename?: 'FailureReasons', details: string, fullMessages: Array<string> } | null } } | null };

export type DataImportUpdateMutationVariables = Exact<{
  attributes: DataImportUpdateInputObject;
  id: Scalars['ID']['input'];
}>;


export type DataImportUpdateMutation = { __typename?: 'Mutation', data: { __typename?: 'DataImport', importedRows: number | null, failureDetails: any | null, fileException: Array<string> | null, id: string, kind: DataImportKindEnum, status: DataImportStatusEnum, totalRows: number | null, createdAt: any, attachmentAttached: { __typename?: 'Attachment', id: string, processed: boolean, fileTag: string | null, fileData: any | null, filename: string | null, urls: { __typename?: 'AttachmentUrl', large: string | null, medium: string | null, original: string | null, small: string | null, imagePreview: string | null, originalDirectDownload: string | null, video480p: string | null, video720p: string | null, video1080p: string | null } | null, metadata: { __typename?: 'AttachmentMetadata', intendedUse: string | null } | null } | null, backgroundJob: { __typename?: 'BackgroundJob', id: string, jid: string | null, parentId: string | null, rootId: string, kind: BackgroundJobKindEnum, status: BackgroundJobStatusEnum, displayStatus: BackgroundJobStatusEnum, treeStatus: BackgroundJobStatusEnum, done: number, total: number, failed: number, pctComplete: number, message: string | null, errorCode: string | null, result: any | null, estimatedFinishAt: any | null, startedAt: any | null, finishedAt: any | null, cancelRequestedAt: any | null, deliveryRequestedAt: any | null, dismissed: boolean, createdAt: any, updatedAt: any, children: Array<{ __typename?: 'BackgroundJob', id: string, jid: string | null, parentId: string | null, rootId: string, kind: BackgroundJobKindEnum, status: BackgroundJobStatusEnum, displayStatus: BackgroundJobStatusEnum, treeStatus: BackgroundJobStatusEnum, done: number, total: number, failed: number, pctComplete: number, message: string | null, errorCode: string | null, result: any | null, estimatedFinishAt: any | null, startedAt: any | null, finishedAt: any | null, cancelRequestedAt: any | null, deliveryRequestedAt: any | null, dismissed: boolean, createdAt: any, updatedAt: any, canCancel: { __typename?: 'AuthorizationResult', value: boolean, message: string | null, reasons: { __typename?: 'FailureReasons', details: string, fullMessages: Array<string> } | null }, canDismiss: { __typename?: 'AuthorizationResult', value: boolean, message: string | null, reasons: { __typename?: 'FailureReasons', details: string, fullMessages: Array<string> } | null }, canRequestDelivery: { __typename?: 'AuthorizationResult', value: boolean, message: string | null, reasons: { __typename?: 'FailureReasons', details: string, fullMessages: Array<string> } | null }, canRequeue: { __typename?: 'AuthorizationResult', value: boolean, message: string | null, reasons: { __typename?: 'FailureReasons', details: string, fullMessages: Array<string> } | null } }>, canCancel: { __typename?: 'AuthorizationResult', value: boolean, message: string | null, reasons: { __typename?: 'FailureReasons', details: string, fullMessages: Array<string> } | null }, canDismiss: { __typename?: 'AuthorizationResult', value: boolean, message: string | null, reasons: { __typename?: 'FailureReasons', details: string, fullMessages: Array<string> } | null }, canRequestDelivery: { __typename?: 'AuthorizationResult', value: boolean, message: string | null, reasons: { __typename?: 'FailureReasons', details: string, fullMessages: Array<string> } | null }, canRequeue: { __typename?: 'AuthorizationResult', value: boolean, message: string | null, reasons: { __typename?: 'FailureReasons', details: string, fullMessages: Array<string> } | null } } | null, user: { __typename?: 'User', id: string, firstName: string, lastName: string, email: string | null, avatarAttached: { __typename?: 'Attachment', id: string, processed: boolean, fileTag: string | null, fileData: any | null, filename: string | null, urls: { __typename?: 'AttachmentUrl', large: string | null, medium: string | null, original: string | null, small: string | null, imagePreview: string | null, originalDirectDownload: string | null, video480p: string | null, video720p: string | null, video1080p: string | null } | null, metadata: { __typename?: 'AttachmentMetadata', intendedUse: string | null } | null } | null } | null, canDestroy: { __typename?: 'AuthorizationResult', value: boolean, message: string | null, reasons: { __typename?: 'FailureReasons', details: string, fullMessages: Array<string> } | null }, canUpdate: { __typename?: 'AuthorizationResult', value: boolean, message: string | null, reasons: { __typename?: 'FailureReasons', details: string, fullMessages: Array<string> } | null } } | null };

export type DataImportDestroyMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DataImportDestroyMutation = { __typename?: 'Mutation', dataImportDestroy: boolean | null };

export type DepartmentFragmentFragment = { __typename?: 'Department', id: string, name: string, description: string | null, color: ColorEnum, createdAt: any, parentId: string | null, parent: { __typename?: 'Department', id: string, name: string, path: string | null } | null, manager: { __typename?: 'User', id: string, firstName: string, lastName: string, email: string | null, avatarAttached: { __typename?: 'Attachment', id: string, processed: boolean, fileTag: string | null, fileData: any | null, filename: string | null, urls: { __typename?: 'AttachmentUrl', large: string | null, medium: string | null, original: string | null, small: string | null, imagePreview: string | null, originalDirectDownload: string | null, video480p: string | null, video720p: string | null, video1080p: string | null } | null, metadata: { __typename?: 'AttachmentMetadata', intendedUse: string | null } | null } | null } | null, canDestroy: { __typename?: 'AuthorizationResult', value: boolean, message: string | null, reasons: { __typename?: 'FailureReasons', details: string, fullMessages: Array<string> } | null } };

export type DepartmentHierarchyNodeFragmentFragment = { __typename?: 'Department', id: string, name: string, color: ColorEnum, childrenCount: number | null };

export type DepartmentListItemFragmentFragment = { __typename?: 'Department', id: string, name: string, path: string | null, color: ColorEnum, childrenCount: number | null, membersOwnCount: number | null, membersTotalCount: number | null, tasksOwnCount: number | null, tasksTotalCount: number | null, manager: { __typename?: 'User', id: string, firstName: string, lastName: string, email: string | null, avatarAttached: { __typename?: 'Attachment', id: string, processed: boolean, fileTag: string | null, fileData: any | null, filename: string | null, urls: { __typename?: 'AttachmentUrl', large: string | null, medium: string | null, original: string | null, small: string | null, imagePreview: string | null, originalDirectDownload: string | null, video480p: string | null, video720p: string | null, video1080p: string | null } | null, metadata: { __typename?: 'AttachmentMetadata', intendedUse: string | null } | null } | null } | null, canDestroy: { __typename?: 'AuthorizationResult', value: boolean, message: string | null, reasons: { __typename?: 'FailureReasons', details: string, fullMessages: Array<string> } | null } };

export type DepartmentsQueryVariables = Exact<{
  page?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  sorts?: InputMaybe<DepartmentSortInputObject>;
  filters?: InputMaybe<Array<DepartmentFilterInputObject> | DepartmentFilterInputObject>;
}>;


export type DepartmentsQuery = { __typename?: 'Query', data: { __typename?: 'DepartmentCollection', collection: Array<{ __typename?: 'Department', id: string, name: string, path: string | null, color: ColorEnum, childrenCount: number | null, membersOwnCount: number | null, membersTotalCount: number | null, tasksOwnCount: number | null, tasksTotalCount: number | null, manager: { __typename?: 'User', id: string, firstName: string, lastName: string, email: string | null, avatarAttached: { __typename?: 'Attachment', id: string, processed: boolean, fileTag: string | null, fileData: any | null, filename: string | null, urls: { __typename?: 'AttachmentUrl', large: string | null, medium: string | null, original: string | null, small: string | null, imagePreview: string | null, originalDirectDownload: string | null, video480p: string | null, video720p: string | null, video1080p: string | null } | null, metadata: { __typename?: 'AttachmentMetadata', intendedUse: string | null } | null } | null } | null, canDestroy: { __typename?: 'AuthorizationResult', value: boolean, message: string | null, reasons: { __typename?: 'FailureReasons', details: string, fullMessages: Array<string> } | null } }>, metadata: { __typename?: 'CollectionMetadata', currentPage: number, limitValue: number, totalCount: number, totalPages: number } } };

export type DepartmentQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DepartmentQuery = { __typename?: 'Query', data: { __typename?: 'Department', id: string, name: string, description: string | null, color: ColorEnum, createdAt: any, parentId: string | null, parent: { __typename?: 'Department', id: string, name: string, path: string | null } | null, manager: { __typename?: 'User', id: string, firstName: string, lastName: string, email: string | null, avatarAttached: { __typename?: 'Attachment', id: string, processed: boolean, fileTag: string | null, fileData: any | null, filename: string | null, urls: { __typename?: 'AttachmentUrl', large: string | null, medium: string | null, original: string | null, small: string | null, imagePreview: string | null, originalDirectDownload: string | null, video480p: string | null, video720p: string | null, video1080p: string | null } | null, metadata: { __typename?: 'AttachmentMetadata', intendedUse: string | null } | null } | null } | null, canDestroy: { __typename?: 'AuthorizationResult', value: boolean, message: string | null, reasons: { __typename?: 'FailureReasons', details: string, fullMessages: Array<string> } | null } } | null };

export type DepartmentIdsQueryVariables = Exact<{
  sorts?: InputMaybe<DepartmentSortInputObject>;
  filters?: InputMaybe<Array<DepartmentFilterInputObject> | DepartmentFilterInputObject>;
  onlyIds?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type DepartmentIdsQuery = { __typename?: 'Query', data: { __typename?: 'DepartmentCollection', collection: Array<{ __typename?: 'Department', id: string }> } };

export type DepartmentsSearchListQueryVariables = Exact<{
  page?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  sorts?: InputMaybe<DepartmentSortInputObject>;
  filters?: InputMaybe<Array<DepartmentFilterInputObject> | DepartmentFilterInputObject>;
}>;


export type DepartmentsSearchListQuery = { __typename?: 'Query', data: { __typename?: 'DepartmentCollection', collection: Array<{ __typename?: 'Department', id: string, name: string, path: string | null, color: ColorEnum }>, metadata: { __typename?: 'CollectionMetadata', currentPage: number, limitValue: number, totalCount: number, totalPages: number } } };

export type DepartmentCreateMutationVariables = Exact<{
  attributes: DepartmentCreateInputObject;
}>;


export type DepartmentCreateMutation = { __typename?: 'Mutation', data: { __typename?: 'Department', id: string, name: string, description: string | null, color: ColorEnum, createdAt: any, parentId: string | null, parent: { __typename?: 'Department', id: string, name: string, path: string | null } | null, manager: { __typename?: 'User', id: string, firstName: string, lastName: string, email: string | null, avatarAttached: { __typename?: 'Attachment', id: string, processed: boolean, fileTag: string | null, fileData: any | null, filename: string | null, urls: { __typename?: 'AttachmentUrl', large: string | null, medium: string | null, original: string | null, small: string | null, imagePreview: string | null, originalDirectDownload: string | null, video480p: string | null, video720p: string | null, video1080p: string | null } | null, metadata: { __typename?: 'AttachmentMetadata', intendedUse: string | null } | null } | null } | null, canDestroy: { __typename?: 'AuthorizationResult', value: boolean, message: string | null, reasons: { __typename?: 'FailureReasons', details: string, fullMessages: Array<string> } | null } } | null };

export type DepartmentUpdateMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  attributes: DepartmentUpdateInputObject;
}>;


export type DepartmentUpdateMutation = { __typename?: 'Mutation', data: { __typename?: 'Department', id: string, name: string, description: string | null, color: ColorEnum, createdAt: any, parentId: string | null, parent: { __typename?: 'Department', id: string, name: string, path: string | null } | null, manager: { __typename?: 'User', id: string, firstName: string, lastName: string, email: string | null, avatarAttached: { __typename?: 'Attachment', id: string, processed: boolean, fileTag: string | null, fileData: any | null, filename: string | null, urls: { __typename?: 'AttachmentUrl', large: string | null, medium: string | null, original: string | null, small: string | null, imagePreview: string | null, originalDirectDownload: string | null, video480p: string | null, video720p: string | null, video1080p: string | null } | null, metadata: { __typename?: 'AttachmentMetadata', intendedUse: string | null } | null } | null } | null, canDestroy: { __typename?: 'AuthorizationResult', value: boolean, message: string | null, reasons: { __typename?: 'FailureReasons', details: string, fullMessages: Array<string> } | null } } | null };

export type DepartmentDestroyMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DepartmentDestroyMutation = { __typename?: 'Mutation', data: boolean | null };

export type DepartmentHierarchyQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DepartmentHierarchyQuery = { __typename?: 'Query', data: { __typename?: 'Department', id: string, name: string, color: ColorEnum, childrenCount: number | null, parent: { __typename?: 'Department', id: string, name: string, color: ColorEnum, childrenCount: number | null, parent: { __typename?: 'Department', id: string, name: string, color: ColorEnum, childrenCount: number | null, parent: { __typename?: 'Department', id: string, name: string, color: ColorEnum, childrenCount: number | null, parent: { __typename?: 'Department', id: string, name: string, color: ColorEnum, childrenCount: number | null } | null } | null } | null } | null } | null };

export type DepartmentHierarchyChildrenQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DepartmentHierarchyChildrenQuery = { __typename?: 'Query', data: { __typename?: 'Department', children: Array<{ __typename?: 'Department', id: string, name: string, color: ColorEnum, childrenCount: number | null }> } | null };

export type DepartmentChildrenQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DepartmentChildrenQuery = { __typename?: 'Query', data: { __typename?: 'Department', children: Array<{ __typename?: 'Department', id: string, name: string, path: string | null, color: ColorEnum, childrenCount: number | null, membersOwnCount: number | null, membersTotalCount: number | null, tasksOwnCount: number | null, tasksTotalCount: number | null, manager: { __typename?: 'User', id: string, firstName: string, lastName: string, email: string | null, avatarAttached: { __typename?: 'Attachment', id: string, processed: boolean, fileTag: string | null, fileData: any | null, filename: string | null, urls: { __typename?: 'AttachmentUrl', large: string | null, medium: string | null, original: string | null, small: string | null, imagePreview: string | null, originalDirectDownload: string | null, video480p: string | null, video720p: string | null, video1080p: string | null } | null, metadata: { __typename?: 'AttachmentMetadata', intendedUse: string | null } | null } | null } | null, canDestroy: { __typename?: 'AuthorizationResult', value: boolean, message: string | null, reasons: { __typename?: 'FailureReasons', details: string, fullMessages: Array<string> } | null } }> } | null };

export type DocumentationQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DocumentationQuery = { __typename?: 'Query', data: { __typename?: 'Documentation', id: string, name: string | null, tags: Array<{ __typename?: 'Tag', id: string, name: string }> } | null };

export type DocumentationCreateMutationVariables = Exact<{
  attributes: DocumentationCreateInputObject;
}>;


export type DocumentationCreateMutation = { __typename?: 'Mutation', data: { __typename?: 'Documentation', id: string, name: string | null, tags: Array<{ __typename?: 'Tag', id: string, name: string }> } | null };

export type DocumentationUpdateMutationVariables = Exact<{
  attributes: DocumentationUpdateInputObject;
  id: Scalars['ID']['input'];
}>;


export type DocumentationUpdateMutation = { __typename?: 'Mutation', data: { __typename?: 'Documentation', id: string, name: string | null, tags: Array<{ __typename?: 'Tag', id: string, name: string }> } | null };

export type DocumentationBulkDestroyMutationVariables = Exact<{
  ids: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;


export type DocumentationBulkDestroyMutation = { __typename?: 'Mutation', documentationBulkDestroy: boolean | null };

export type EdmDocumentationCategoryFragmentFragment = { __typename?: 'DocumentationCategory', id: string, name: string, color: ColorEnum };

export type EdmDocumentationBaseFragmentFragment = { __typename?: 'Documentation', id: string, name: string | null, code: string | null, createdAt: any, updatedAt: any, createdBy: { __typename?: 'User', id: string, firstName: string, lastName: string, avatarAttached: { __typename?: 'Attachment', id: string, processed: boolean, fileTag: string | null, fileData: any | null, filename: string | null, urls: { __typename?: 'AttachmentUrl', large: string | null, medium: string | null, original: string | null, small: string | null, imagePreview: string | null, originalDirectDownload: string | null, video480p: string | null, video720p: string | null, video1080p: string | null } | null, metadata: { __typename?: 'AttachmentMetadata', intendedUse: string | null } | null } | null } | null, canUpdateValidationStatus: { __typename?: 'AuthorizationResult', value: boolean, message: string | null, reasons: { __typename?: 'FailureReasons', details: string, fullMessages: Array<string> } | null }, canUpdate: { __typename?: 'AuthorizationResult', value: boolean, message: string | null, reasons: { __typename?: 'FailureReasons', details: string, fullMessages: Array<string> } | null }, canDestroy: { __typename?: 'AuthorizationResult', value: boolean, message: string | null, reasons: { __typename?: 'FailureReasons', details: string, fullMessages: Array<string> } | null }, currentVersion: { __typename?: 'DocumentationVersion', id: string, notes: string | null, attachmentAttached: { __typename?: 'Attachment', id: string, processed: boolean, fileTag: string | null, fileData: any | null, filename: string | null, urls: { __typename?: 'AttachmentUrl', large: string | null, medium: string | null, original: string | null, small: string | null, imagePreview: string | null, originalDirectDownload: string | null, video480p: string | null, video720p: string | null, video1080p: string | null } | null, metadata: { __typename?: 'AttachmentMetadata', intendedUse: string | null } | null } | null } | null, tags: Array<{ __typename?: 'Tag', id: string, name: string }> };

export type EdmDocumentationAiDetectionFragmentFragment = { __typename?: 'Documentation', suggestedCodes: Array<string>, aiDetectionStatus: Array<{ __typename?: 'DocumentationFieldDetectionStatus', field: AiDocumentationFieldEnum, status: AiFieldDetectionStatusEnum }> };

export type EdmDocumentationPremiumFragmentFragment = { __typename?: 'Documentation', validationStatus: DocumentationValidationStatusEnum | null, renewalDeadlineDate: any | null, renewalRepetition: DocumentationRenewalRepetitionEnum | null, renewalEarlyReminderDays: number | null, renewalRepetitionCustomDays: number | null, category: { __typename?: 'DocumentationCategory', id: string, name: string, color: ColorEnum } | null, approver: { __typename?: 'User', id: string, firstName: string, lastName: string, email: string | null, avatarAttached: { __typename?: 'Attachment', id: string, processed: boolean, fileTag: string | null, fileData: any | null, filename: string | null, urls: { __typename?: 'AttachmentUrl', large: string | null, medium: string | null, original: string | null, small: string | null, imagePreview: string | null, originalDirectDownload: string | null, video480p: string | null, video720p: string | null, video1080p: string | null } | null, metadata: { __typename?: 'AttachmentMetadata', intendedUse: string | null } | null } | null } | null };

export type EdmDocumentationFragmentFragment = { __typename?: 'Documentation', id: string, name: string | null, code: string | null, createdAt: any, updatedAt: any, validationStatus: DocumentationValidationStatusEnum | null, renewalDeadlineDate: any | null, renewalRepetition: DocumentationRenewalRepetitionEnum | null, renewalEarlyReminderDays: number | null, renewalRepetitionCustomDays: number | null, createdBy: { __typename?: 'User', id: string, firstName: string, lastName: string, avatarAttached: { __typename?: 'Attachment', id: string, processed: boolean, fileTag: string | null, fileData: any | null, filename: string | null, urls: { __typename?: 'AttachmentUrl', large: string | null, medium: string | null, original: string | null, small: string | null, imagePreview: string | null, originalDirectDownload: string | null, video480p: string | null, video720p: string | null, video1080p: string | null } | null, metadata: { __typename?: 'AttachmentMetadata', intendedUse: string | null } | null } | null } | null, canUpdateValidationStatus: { __typename?: 'AuthorizationResult', value: boolean, message: string | null, reasons: { __typename?: 'FailureReasons', details: string, fullMessages: Array<string> } | null }, canUpdate: { __typename?: 'AuthorizationResult', value: boolean, message: string | null, reasons: { __typename?: 'FailureReasons', details: string, fullMessages: Array<string> } | null }, canDestroy: { __typename?: 'AuthorizationResult', value: boolean, message: string | null, reasons: { __typename?: 'FailureReasons', details: string, fullMessages: Array<string> } | null }, currentVersion: { __typename?: 'DocumentationVersion', id: string, notes: string | null, attachmentAttached: { __typename?: 'Attachment', id: string, processed: boolean, fileTag: string | null, fileData: any | null, filename: string | null, urls: { __typename?: 'AttachmentUrl', large: string | null, medium: string | null, original: string | null, small: string | null, imagePreview: string | null, originalDirectDownload: string | null, video480p: string | null, video720p: string | null, video1080p: string | null } | null, metadata: { __typename?: 'AttachmentMetadata', intendedUse: string | null } | null } | null } | null, tags: Array<{ __typename?: 'Tag', id: string, name: string }>, category: { __typename?: 'DocumentationCategory', id: string, name: string, color: ColorEnum } | null, approver: { __typename?: 'User', id: string, firstName: string, lastName: string, email: string | null, avatarAttached: { __typename?: 'Attachment', id: string, processed: boolean, fileTag: string | null, fileData: any | null, filename: string | null, urls: { __typename?: 'AttachmentUrl', large: string | null, medium: string | null, original: string | null, small: string | null, imagePreview: string | null, originalDirectDownload: string | null, video480p: string | null, video720p: string | null, video1080p: string | null } | null, metadata: { __typename?: 'AttachmentMetadata', intendedUse: string | null } | null } | null } | null };

export type EdmDocumentationsIdsQueryVariables = Exact<{
  page?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  sorts?: InputMaybe<DocumentationSortInputObject>;
  filters?: InputMaybe<Array<DocumentationFilterInputObject> | DocumentationFilterInputObject>;
  onlyIds?: InputMaybe<Scalars['Boolean']['input']>;
  scope?: InputMaybe<DocumentationScopeInputObject>;
}>;


export type EdmDocumentationsIdsQuery = { __typename?: 'Query', data: { __typename?: 'DocumentationCollection', collection: Array<{ __typename?: 'Documentation', id: string }> } };

export type EdmDocumentationsCounterQueryVariables = Exact<{
  filters?: InputMaybe<Array<DocumentationFilterInputObject> | DocumentationFilterInputObject>;
}>;


export type EdmDocumentationsCounterQuery = { __typename?: 'Query', myApprovals: { __typename?: 'DocumentationCollection', metadata: { __typename?: 'CollectionMetadata', totalCount: number } } };

export type EdmDocumentationQueryVariables = Exact<{
  id: Scalars['ID']['input'];
  isViewLocked?: Scalars['Boolean']['input'];
  isAiDetectionEnabled?: Scalars['Boolean']['input'];
}>;


export type EdmDocumentationQuery = { __typename?: 'Query', data: { __typename?: 'Documentation', favorited?: boolean, description: string | null, totalEngagementSeconds?: number | null, id: string, name: string | null, code: string | null, createdAt: any, updatedAt: any, validationStatus: DocumentationValidationStatusEnum | null, renewalDeadlineDate: any | null, renewalRepetition: DocumentationRenewalRepetitionEnum | null, renewalEarlyReminderDays: number | null, renewalRepetitionCustomDays: number | null, suggestedCodes: Array<string>, currentVersion: { __typename?: 'DocumentationVersion', id: string, notes: string | null, attachmentAttached: { __typename?: 'Attachment', id: string, processed: boolean, fileTag: string | null, fileData: any | null, filename: string | null, urls: { __typename?: 'AttachmentUrl', large: string | null, medium: string | null, original: string | null, small: string | null, imagePreview: string | null, originalDirectDownload: string | null, video480p: string | null, video720p: string | null, video1080p: string | null } | null, metadata: { __typename?: 'AttachmentMetadata', intendedUse: string | null } | null } | null } | null, createdBy: { __typename?: 'User', id: string, firstName: string, lastName: string, avatarAttached: { __typename?: 'Attachment', id: string, processed: boolean, fileTag: string | null, fileData: any | null, filename: string | null, urls: { __typename?: 'AttachmentUrl', large: string | null, medium: string | null, original: string | null, small: string | null, imagePreview: string | null, originalDirectDownload: string | null, video480p: string | null, video720p: string | null, video1080p: string | null } | null, metadata: { __typename?: 'AttachmentMetadata', intendedUse: string | null } | null } | null } | null, canUpdateValidationStatus: { __typename?: 'AuthorizationResult', value: boolean, message: string | null, reasons: { __typename?: 'FailureReasons', details: string, fullMessages: Array<string> } | null }, canUpdate: { __typename?: 'AuthorizationResult', value: boolean, message: string | null, reasons: { __typename?: 'FailureReasons', details: string, fullMessages: Array<string> } | null }, canDestroy: { __typename?: 'AuthorizationResult', value: boolean, message: string | null, reasons: { __typename?: 'FailureReasons', details: string, fullMessages: Array<string> } | null }, tags: Array<{ __typename?: 'Tag', id: string, name: string }>, category: { __typename?: 'DocumentationCategory', id: string, name: string, color: ColorEnum } | null, approver: { __typename?: 'User', id: string, firstName: string, lastName: string, email: string | null, avatarAttached: { __typename?: 'Attachment', id: string, processed: boolean, fileTag: string | null, fileData: any | null, filename: string | null, urls: { __typename?: 'AttachmentUrl', large: string | null, medium: string | null, original: string | null, small: string | null, imagePreview: string | null, originalDirectDownload: string | null, video480p: string | null, video720p: string | null, video1080p: string | null } | null, metadata: { __typename?: 'AttachmentMetadata', intendedUse: string | null } | null } | null } | null, aiDetectionStatus: Array<{ __typename?: 'DocumentationFieldDetectionStatus', field: AiDocumentationFieldEnum, status: AiFieldDetectionStatusEnum }> } | null };

export type EdmDocumentationNameQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type EdmDocumentationNameQuery = { __typename?: 'Query', data: { __typename?: 'Documentation', id: string, name: string | null } | null };

export type EdmDocumentationAccessesCountsQueryVariables = Exact<{
  documentationId: Scalars['String']['input'];
}>;


export type EdmDocumentationAccessesCountsQuery = { __typename?: 'Query', sectors: { __typename?: 'SectorCollection', metadata: { __typename?: 'CollectionMetadata', totalCount: number } }, sites: { __typename?: 'SiteCollection', metadata: { __typename?: 'CollectionMetadata', totalCount: number } } };

export type EdmDocumentationOperationalScopeCountsQueryVariables = Exact<{
  documentationId: Scalars['String']['input'];
  includeAssets: Scalars['Boolean']['input'];
  includeAreas: Scalars['Boolean']['input'];
  includeTasks: Scalars['Boolean']['input'];
  isViewLocked?: Scalars['Boolean']['input'];
}>;


export type EdmDocumentationOperationalScopeCountsQuery = { __typename?: 'Query', assets?: { __typename?: 'AssetCollection', metadata: { __typename?: 'CollectionMetadata', totalCount: number } }, siteAreas?: { __typename?: 'SiteAreaCollection', metadata: { __typename?: 'CollectionMetadata', totalCount: number } }, formTemplates?: { __typename?: 'FormTemplateCollection', metadata: { __typename?: 'CollectionMetadata', totalCount: number } }, tasks?: { __typename?: 'TaskCollection', metadata: { __typename?: 'CollectionMetadata', totalCount: number } } };

export type EdmDocumentationHistoryCountersQueryVariables = Exact<{
  documentationId: Scalars['ID']['input'];
  documentationIdFilter: Scalars['String']['input'];
  isViewLocked?: Scalars['Boolean']['input'];
}>;


export type EdmDocumentationHistoryCountersQuery = { __typename?: 'Query', versions: { __typename?: 'DocumentationVersionCollection', metadata: { __typename?: 'CollectionMetadata', totalCount: number } }, views?: { __typename?: 'DocumentationVersionViewCollection', metadata: { __typename?: 'CollectionMetadata', totalCount: number } } };

export type EdmDocumentationVersionsQueryVariables = Exact<{
  documentationId: Scalars['ID']['input'];
  page?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  sorts?: InputMaybe<DocumentationVersionSortInputObject>;
}>;


export type EdmDocumentationVersionsQuery = { __typename?: 'Query', data: { __typename?: 'DocumentationVersionCollection', collection: Array<{ __typename?: 'DocumentationVersion', id: string, versionNumber: number, notes: string | null, createdAt: any, createdBy: { __typename?: 'User', id: string, firstName: string, lastName: string, avatarAttached: { __typename?: 'Attachment', id: string, processed: boolean, fileTag: string | null, fileData: any | null, filename: string | null, urls: { __typename?: 'AttachmentUrl', large: string | null, medium: string | null, original: string | null, small: string | null, imagePreview: string | null, originalDirectDownload: string | null, video480p: string | null, video720p: string | null, video1080p: string | null } | null, metadata: { __typename?: 'AttachmentMetadata', intendedUse: string | null } | null } | null } | null, attachmentAttached: { __typename?: 'Attachment', id: string, processed: boolean, fileTag: string | null, fileData: any | null, filename: string | null, urls: { __typename?: 'AttachmentUrl', large: string | null, medium: string | null, original: string | null, small: string | null, imagePreview: string | null, originalDirectDownload: string | null, video480p: string | null, video720p: string | null, video1080p: string | null } | null, metadata: { __typename?: 'AttachmentMetadata', intendedUse: string | null } | null } | null }>, metadata: { __typename?: 'CollectionMetadata', currentPage: number, limitValue: number, totalCount: number, totalPages: number } } };

export type EdmDocumentationCategoriesQueryVariables = Exact<{
  page?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  sorts?: InputMaybe<DocumentationCategorySortInputObject>;
  filters?: InputMaybe<Array<DocumentationCategoryFilterInputObject> | DocumentationCategoryFilterInputObject>;
}>;


export type EdmDocumentationCategoriesQuery = { __typename?: 'Query', data: { __typename?: 'DocumentationCategoryCollection', collection: Array<{ __typename?: 'DocumentationCategory', description: string | null, documentationsCount: number, id: string, name: string, color: ColorEnum, canDestroy: { __typename?: 'AuthorizationResult', value: boolean, message: string | null, reasons: { __typename?: 'FailureReasons', details: string, fullMessages: Array<string> } | null } }>, metadata: { __typename?: 'CollectionMetadata', currentPage: number, limitValue: number, totalCount: number, totalPages: number } } };

export type EdmDocumentationCategoriesSearchListQueryVariables = Exact<{
  page?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  sorts?: InputMaybe<DocumentationCategorySortInputObject>;
  filters?: InputMaybe<Array<DocumentationCategoryFilterInputObject> | DocumentationCategoryFilterInputObject>;
}>;


export type EdmDocumentationCategoriesSearchListQuery = { __typename?: 'Query', data: { __typename?: 'DocumentationCategoryCollection', collection: Array<{ __typename?: 'DocumentationCategory', id: string, name: string, color: ColorEnum }>, metadata: { __typename?: 'CollectionMetadata', currentPage: number, limitValue: number, totalCount: number, totalPages: number } } };

export type EdmDocumentationCategoryQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type EdmDocumentationCategoryQuery = { __typename?: 'Query', data: { __typename?: 'DocumentationCategory', description: string | null, id: string, name: string, color: ColorEnum } | null };

export type EdmDocumentationCreateMutationVariables = Exact<{
  attributes: DocumentationCreateInputObject;
  isViewLocked?: Scalars['Boolean']['input'];
}>;


export type EdmDocumentationCreateMutation = { __typename?: 'Mutation', data: { __typename?: 'Documentation', id: string, name: string | null, code: string | null, createdAt: any, updatedAt: any, validationStatus: DocumentationValidationStatusEnum | null, renewalDeadlineDate: any | null, renewalRepetition: DocumentationRenewalRepetitionEnum | null, renewalEarlyReminderDays: number | null, renewalRepetitionCustomDays: number | null, createdBy: { __typename?: 'User', id: string, firstName: string, lastName: string, avatarAttached: { __typename?: 'Attachment', id: string, processed: boolean, fileTag: string | null, fileData: any | null, filename: string | null, urls: { __typename?: 'AttachmentUrl', large: string | null, medium: string | null, original: string | null, small: string | null, imagePreview: string | null, originalDirectDownload: string | null, video480p: string | null, video720p: string | null, video1080p: string | null } | null, metadata: { __typename?: 'AttachmentMetadata', intendedUse: string | null } | null } | null } | null, canUpdateValidationStatus: { __typename?: 'AuthorizationResult', value: boolean, message: string | null, reasons: { __typename?: 'FailureReasons', details: string, fullMessages: Array<string> } | null }, canUpdate: { __typename?: 'AuthorizationResult', value: boolean, message: string | null, reasons: { __typename?: 'FailureReasons', details: string, fullMessages: Array<string> } | null }, canDestroy: { __typename?: 'AuthorizationResult', value: boolean, message: string | null, reasons: { __typename?: 'FailureReasons', details: string, fullMessages: Array<string> } | null }, currentVersion: { __typename?: 'DocumentationVersion', id: string, notes: string | null, attachmentAttached: { __typename?: 'Attachment', id: string, processed: boolean, fileTag: string | null, fileData: any | null, filename: string | null, urls: { __typename?: 'AttachmentUrl', large: string | null, medium: string | null, original: string | null, small: string | null, imagePreview: string | null, originalDirectDownload: string | null, video480p: string | null, video720p: string | null, video1080p: string | null } | null, metadata: { __typename?: 'AttachmentMetadata', intendedUse: string | null } | null } | null } | null, tags: Array<{ __typename?: 'Tag', id: string, name: string }>, category: { __typename?: 'DocumentationCategory', id: string, name: string, color: ColorEnum } | null, approver: { __typename?: 'User', id: string, firstName: string, lastName: string, email: string | null, avatarAttached: { __typename?: 'Attachment', id: string, processed: boolean, fileTag: string | null, fileData: any | null, filename: string | null, urls: { __typename?: 'AttachmentUrl', large: string | null, medium: string | null, original: string | null, small: string | null, imagePreview: string | null, originalDirectDownload: string | null, video480p: string | null, video720p: string | null, video1080p: string | null } | null, metadata: { __typename?: 'AttachmentMetadata', intendedUse: string | null } | null } | null } | null } | null };

export type EdmDocumentationUpdateMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  attributes: DocumentationUpdateInputObject;
  isViewLocked?: Scalars['Boolean']['input'];
  isAiDetectionEnabled?: Scalars['Boolean']['input'];
}>;


export type EdmDocumentationUpdateMutation = { __typename?: 'Mutation', data: { __typename?: 'Documentation', description: string | null, id: string, name: string | null, code: string | null, createdAt: any, updatedAt: any, validationStatus: DocumentationValidationStatusEnum | null, renewalDeadlineDate: any | null, renewalRepetition: DocumentationRenewalRepetitionEnum | null, renewalEarlyReminderDays: number | null, renewalRepetitionCustomDays: number | null, suggestedCodes: Array<string>, createdBy: { __typename?: 'User', id: string, firstName: string, lastName: string, avatarAttached: { __typename?: 'Attachment', id: string, processed: boolean, fileTag: string | null, fileData: any | null, filename: string | null, urls: { __typename?: 'AttachmentUrl', large: string | null, medium: string | null, original: string | null, small: string | null, imagePreview: string | null, originalDirectDownload: string | null, video480p: string | null, video720p: string | null, video1080p: string | null } | null, metadata: { __typename?: 'AttachmentMetadata', intendedUse: string | null } | null } | null } | null, canUpdateValidationStatus: { __typename?: 'AuthorizationResult', value: boolean, message: string | null, reasons: { __typename?: 'FailureReasons', details: string, fullMessages: Array<string> } | null }, canUpdate: { __typename?: 'AuthorizationResult', value: boolean, message: string | null, reasons: { __typename?: 'FailureReasons', details: string, fullMessages: Array<string> } | null }, canDestroy: { __typename?: 'AuthorizationResult', value: boolean, message: string | null, reasons: { __typename?: 'FailureReasons', details: string, fullMessages: Array<string> } | null }, currentVersion: { __typename?: 'DocumentationVersion', id: string, notes: string | null, attachmentAttached: { __typename?: 'Attachment', id: string, processed: boolean, fileTag: string | null, fileData: any | null, filename: string | null, urls: { __typename?: 'AttachmentUrl', large: string | null, medium: string | null, original: string | null, small: string | null, imagePreview: string | null, originalDirectDownload: string | null, video480p: string | null, video720p: string | null, video1080p: string | null } | null, metadata: { __typename?: 'AttachmentMetadata', intendedUse: string | null } | null } | null } | null, tags: Array<{ __typename?: 'Tag', id: string, name: string }>, category: { __typename?: 'DocumentationCategory', id: string, name: string, color: ColorEnum } | null, approver: { __typename?: 'User', id: string, firstName: string, lastName: string, email: string | null, avatarAttached: { __typename?: 'Attachment', id: string, processed: boolean, fileTag: string | null, fileData: any | null, filename: string | null, urls: { __typename?: 'AttachmentUrl', large: string | null, medium: string | null, original: string | null, small: string | null, imagePreview: string | null, originalDirectDownload: string | null, video480p: string | null, video720p: string | null, video1080p: string | null } | null, metadata: { __typename?: 'AttachmentMetadata', intendedUse: string | null } | null } | null } | null, aiDetectionStatus: Array<{ __typename?: 'DocumentationFieldDetectionStatus', field: AiDocumentationFieldEnum, status: AiFieldDetectionStatusEnum }> } | null };

export type EdmDocumentationBulkDestroyMutationVariables = Exact<{
  ids: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;


export type EdmDocumentationBulkDestroyMutation = { __typename?: 'Mutation', edmDocumentationBulkDestroy: boolean | null };

export type EdmDocumentationVersionCreateMutationVariables = Exact<{
  documentationId: Scalars['ID']['input'];
  attributes: DocumentationVersionCreateInputObject;
}>;


export type EdmDocumentationVersionCreateMutation = { __typename?: 'Mutation', data: { __typename?: 'DocumentationVersion', id: string, versionNumber: number, notes: string | null, createdAt: any, attachmentAttached: { __typename?: 'Attachment', id: string, processed: boolean, fileTag: string | null, fileData: any | null, filename: string | null, urls: { __typename?: 'AttachmentUrl', large: string | null, medium: string | null, original: string | null, small: string | null, imagePreview: string | null, originalDirectDownload: string | null, video480p: string | null, video720p: string | null, video1080p: string | null } | null, metadata: { __typename?: 'AttachmentMetadata', intendedUse: string | null } | null } | null } | null };

export type EdmDocumentationCategoryCreateMutationVariables = Exact<{
  attributes: DocumentationCategoryCreateInputObject;
}>;


export type EdmDocumentationCategoryCreateMutation = { __typename?: 'Mutation', data: { __typename?: 'DocumentationCategory', id: string, name: string, color: ColorEnum } | null };

export type EdmDocumentationCategoryUpdateMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  attributes: DocumentationCategoryUpdateInputObject;
}>;


export type EdmDocumentationCategoryUpdateMutation = { __typename?: 'Mutation', data: { __typename?: 'DocumentationCategory', description: string | null, id: string, name: string, color: ColorEnum } | null };

export type EdmDocumentationCategoryDestroyMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type EdmDocumentationCategoryDestroyMutation = { __typename?: 'Mutation', documentationCategoryDestroy: boolean | null };

export type EdmDocumentationBulkUpdateValidationStatusMutationVariables = Exact<{
  ids: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
  attributes: DocumentationUpdateValidationStatusInputObject;
}>;


export type EdmDocumentationBulkUpdateValidationStatusMutation = { __typename?: 'Mutation', documentationBulkUpdateValidationStatus: boolean | null };

export type EdmDocumentationBulkEditMutationVariables = Exact<{
  ids: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
  attributes: DocumentationBulkEditInputObject;
}>;


export type EdmDocumentationBulkEditMutation = { __typename?: 'Mutation', documentationBulkEdit: boolean | null };

export type EdmDocumentationSkipRenewalMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type EdmDocumentationSkipRenewalMutation = { __typename?: 'Mutation', data: { __typename?: 'Documentation', id: string, name: string | null, code: string | null, createdAt: any, updatedAt: any, validationStatus: DocumentationValidationStatusEnum | null, renewalDeadlineDate: any | null, renewalRepetition: DocumentationRenewalRepetitionEnum | null, renewalEarlyReminderDays: number | null, renewalRepetitionCustomDays: number | null, createdBy: { __typename?: 'User', id: string, firstName: string, lastName: string, avatarAttached: { __typename?: 'Attachment', id: string, processed: boolean, fileTag: string | null, fileData: any | null, filename: string | null, urls: { __typename?: 'AttachmentUrl', large: string | null, medium: string | null, original: string | null, small: string | null, imagePreview: string | null, originalDirectDownload: string | null, video480p: string | null, video720p: string | null, video1080p: string | null } | null, metadata: { __typename?: 'AttachmentMetadata', intendedUse: string | null } | null } | null } | null, canUpdateValidationStatus: { __typename?: 'AuthorizationResult', value: boolean, message: string | null, reasons: { __typename?: 'FailureReasons', details: string, fullMessages: Array<string> } | null }, canUpdate: { __typename?: 'AuthorizationResult', value: boolean, message: string | null, reasons: { __typename?: 'FailureReasons', details: string, fullMessages: Array<string> } | null }, canDestroy: { __typename?: 'AuthorizationResult', value: boolean, message: string | null, reasons: { __typename?: 'FailureReasons', details: string, fullMessages: Array<string> } | null }, currentVersion: { __typename?: 'DocumentationVersion', id: string, notes: string | null, attachmentAttached: { __typename?: 'Attachment', id: string, processed: boolean, fileTag: string | null, fileData: any | null, filename: string | null, urls: { __typename?: 'AttachmentUrl', large: string | null, medium: string | null, original: string | null, small: string | null, imagePreview: string | null, originalDirectDownload: string | null, video480p: string | null, video720p: string | null, video1080p: string | null } | null, metadata: { __typename?: 'AttachmentMetadata', intendedUse: string | null } | null } | null } | null, tags: Array<{ __typename?: 'Tag', id: string, name: string }>, category: { __typename?: 'DocumentationCategory', id: string, name: string, color: ColorEnum } | null, approver: { __typename?: 'User', id: string, firstName: string, lastName: string, email: string | null, avatarAttached: { __typename?: 'Attachment', id: string, processed: boolean, fileTag: string | null, fileData: any | null, filename: string | null, urls: { __typename?: 'AttachmentUrl', large: string | null, medium: string | null, original: string | null, small: string | null, imagePreview: string | null, originalDirectDownload: string | null, video480p: string | null, video720p: string | null, video1080p: string | null } | null, metadata: { __typename?: 'AttachmentMetadata', intendedUse: string | null } | null } | null } | null } | null };

export type EdmDocumentationImportCreateMutationVariables = Exact<{
  attributes: DocumentationImportCreateInputObject;
}>;


export type EdmDocumentationImportCreateMutation = { __typename?: 'Mutation', data: { __typename?: 'DocumentationImport', id: string, backgroundJob: { __typename?: 'BackgroundJob', id: string, jid: string | null, parentId: string | null, rootId: string, kind: BackgroundJobKindEnum, status: BackgroundJobStatusEnum, displayStatus: BackgroundJobStatusEnum, treeStatus: BackgroundJobStatusEnum, done: number, total: number, failed: number, pctComplete: number, message: string | null, errorCode: string | null, result: any | null, estimatedFinishAt: any | null, startedAt: any | null, finishedAt: any | null, cancelRequestedAt: any | null, deliveryRequestedAt: any | null, dismissed: boolean, createdAt: any, updatedAt: any, children: Array<{ __typename?: 'BackgroundJob', id: string, jid: string | null, parentId: string | null, rootId: string, kind: BackgroundJobKindEnum, status: BackgroundJobStatusEnum, displayStatus: BackgroundJobStatusEnum, treeStatus: BackgroundJobStatusEnum, done: number, total: number, failed: number, pctComplete: number, message: string | null, errorCode: string | null, result: any | null, estimatedFinishAt: any | null, startedAt: any | null, finishedAt: any | null, cancelRequestedAt: any | null, deliveryRequestedAt: any | null, dismissed: boolean, createdAt: any, updatedAt: any, canCancel: { __typename?: 'AuthorizationResult', value: boolean, message: string | null, reasons: { __typename?: 'FailureReasons', details: string, fullMessages: Array<string> } | null }, canDismiss: { __typename?: 'AuthorizationResult', value: boolean, message: string | null, reasons: { __typename?: 'FailureReasons', details: string, fullMessages: Array<string> } | null }, canRequestDelivery: { __typename?: 'AuthorizationResult', value: boolean, message: string | null, reasons: { __typename?: 'FailureReasons', details: string, fullMessages: Array<string> } | null }, canRequeue: { __typename?: 'AuthorizationResult', value: boolean, message: string | null, reasons: { __typename?: 'FailureReasons', details: string, fullMessages: Array<string> } | null } }>, canCancel: { __typename?: 'AuthorizationResult', value: boolean, message: string | null, reasons: { __typename?: 'FailureReasons', details: string, fullMessages: Array<string> } | null }, canDismiss: { __typename?: 'AuthorizationResult', value: boolean, message: string | null, reasons: { __typename?: 'FailureReasons', details: string, fullMessages: Array<string> } | null }, canRequestDelivery: { __typename?: 'AuthorizationResult', value: boolean, message: string | null, reasons: { __typename?: 'FailureReasons', details: string, fullMessages: Array<string> } | null }, canRequeue: { __typename?: 'AuthorizationResult', value: boolean, message: string | null, reasons: { __typename?: 'FailureReasons', details: string, fullMessages: Array<string> } | null } } | null } | null };

export type EdmDocumentationImportFtpPreviewMutationVariables = Exact<{
  attributes: DocumentationImportFtpConfigInputObject;
}>;


export type EdmDocumentationImportFtpPreviewMutation = { __typename?: 'Mutation', data: { __typename?: 'DocumentationImportFtpPreviewResult', totalFilesCount: number, supportedFilesCount: number, unsupportedFilesCount: number, sampleFilenames: Array<string> } | null };

export type EdmDocumentRenewalReminderTemplateFragmentFragment = { __typename?: 'DocumentRenewalReminderTemplate', id: string, renewalRepetition: DocumentationRenewalRepetitionEnum | null, renewalRepetitionCustomDays: number | null, renewalDeadlineMd: string | null, renewalEarlyReminderDays: number | null };

export type EdmDocumentRenewalReminderTemplateQueryVariables = Exact<{ [key: string]: never; }>;


export type EdmDocumentRenewalReminderTemplateQuery = { __typename?: 'Query', data: { __typename?: 'DocumentRenewalReminderTemplate', id: string, renewalRepetition: DocumentationRenewalRepetitionEnum | null, renewalRepetitionCustomDays: number | null, renewalDeadlineMd: string | null, renewalEarlyReminderDays: number | null } | null };

export type EdmDocumentRenewalReminderTemplateUpdateMutationVariables = Exact<{
  attributes: DocumentRenewalReminderTemplateUpdateInputObject;
}>;


export type EdmDocumentRenewalReminderTemplateUpdateMutation = { __typename?: 'Mutation', data: { __typename?: 'DocumentRenewalReminderTemplate', id: string, renewalRepetition: DocumentationRenewalRepetitionEnum | null, renewalRepetitionCustomDays: number | null, renewalDeadlineMd: string | null, renewalEarlyReminderDays: number | null } | null };

export type EdmDocumentationActivityHistoriesQueryVariables = Exact<{
  sourceableId: Scalars['ID']['input'];
  sourceableType: HistorySourceableTypeEnum;
  scope?: InputMaybe<Scalars['String']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  sorts?: InputMaybe<HistorySortInputObject>;
}>;


export type EdmDocumentationActivityHistoriesQuery = { __typename?: 'Query', data: { __typename?: 'HistoryCollection', collection: Array<{ __typename?: 'History', id: string, kind: HistoryKindEnum, system: boolean | null, occurredAt: any, user: { __typename?: 'User', id: string, firstName: string, lastName: string, avatarAttached: { __typename?: 'Attachment', id: string, processed: boolean, fileTag: string | null, fileData: any | null, filename: string | null, urls: { __typename?: 'AttachmentUrl', large: string | null, medium: string | null, original: string | null, small: string | null, imagePreview: string | null, originalDirectDownload: string | null, video480p: string | null, video720p: string | null, video1080p: string | null } | null, metadata: { __typename?: 'AttachmentMetadata', intendedUse: string | null } | null } | null } | null, data: { __typename: 'DocumentationHistoryData', versionNumber: Array<number | null> | null, renewalDeadlineDate: Array<string | null> | null, renewalOverdue: Array<string | null> | null, renewalSkipped: Array<string | null> | null, validationStatus: Array<string | null> | null, approverId: Array<string | null> | null } | { __typename: 'InterventionActionHistoryData' } | null }>, metadata: { __typename?: 'CollectionMetadata', currentPage: number, limitValue: number, totalCount: number, totalPages: number } } };

export type EdmDocumentationVersionViewsQueryVariables = Exact<{
  filters?: InputMaybe<Array<DocumentationVersionViewFilterInputObject> | DocumentationVersionViewFilterInputObject>;
  sorts?: InputMaybe<DocumentationVersionViewSortInputObject>;
  page?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
}>;


export type EdmDocumentationVersionViewsQuery = { __typename?: 'Query', data: { __typename?: 'DocumentationVersionViewCollection', collection: Array<{ __typename?: 'DocumentationVersionView', id: string, viewedAt: any | null, readingDurationSeconds: number | null, createdAt: any, user: { __typename?: 'User', id: string, firstName: string, lastName: string, avatarAttached: { __typename?: 'Attachment', id: string, processed: boolean, fileTag: string | null, fileData: any | null, filename: string | null, urls: { __typename?: 'AttachmentUrl', large: string | null, medium: string | null, original: string | null, small: string | null, imagePreview: string | null, originalDirectDownload: string | null, video480p: string | null, video720p: string | null, video1080p: string | null } | null, metadata: { __typename?: 'AttachmentMetadata', intendedUse: string | null } | null } | null } | null }>, metadata: { __typename?: 'CollectionMetadata', currentPage: number, limitValue: number, totalCount: number, totalPages: number } } };

export type EdmDocumentationsAnalyticsByDocumentQueryVariables = Exact<{
  period: DateRangeInputObject;
  sorts?: InputMaybe<DocumentationAnalyticsSortInputObject>;
  filters?: InputMaybe<Array<DocumentationFilterInputObject> | DocumentationFilterInputObject>;
  page?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
}>;


export type EdmDocumentationsAnalyticsByDocumentQuery = { __typename?: 'Query', data: { __typename?: 'DocumentationAnalyticsByDocumentCollection', collection: Array<{ __typename?: 'DocumentationAnalyticsByDocument', documentationId: string, viewCount: number, uniqueViews: number, avgTime: number | null, minTime: number | null, maxTime: number | null }>, metadata: { __typename?: 'CollectionMetadata', currentPage: number, limitValue: number, totalCount: number, totalPages: number } } };

export type EdmDocumentationsAnalyticsTrendQueryVariables = Exact<{
  period: DateRangeInputObject;
  periodGroupBy: PeriodGroupByEnum;
  filters?: InputMaybe<Array<DocumentationFilterInputObject> | DocumentationFilterInputObject>;
  limit?: InputMaybe<Scalars['Int']['input']>;
}>;


export type EdmDocumentationsAnalyticsTrendQuery = { __typename?: 'Query', data: Array<{ __typename?: 'DocumentationAnalyticsTrendPoint', period: any, allViews: number, uniqueViews: number }> };

export type EdmDocumentationsAnalyticsByCategoryQueryVariables = Exact<{
  period: DateRangeInputObject;
  sorts?: InputMaybe<DocumentationAnalyticsByCategorySortInputObject>;
  filters?: InputMaybe<Array<DocumentationFilterInputObject> | DocumentationFilterInputObject>;
  limit?: InputMaybe<Scalars['Int']['input']>;
}>;


export type EdmDocumentationsAnalyticsByCategoryQuery = { __typename?: 'Query', data: Array<{ __typename?: 'DocumentationAnalyticsByCategory', categoryId: string, viewCount: number, percentage: number }> };

export type EdmDocumentationLinksQueryVariables = Exact<{
  findBy: DocumentationLinkFindByInputObject;
  filters?: InputMaybe<Array<DocumentationLinkFilterInputObject> | DocumentationLinkFilterInputObject>;
  page?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
}>;


export type EdmDocumentationLinksQuery = { __typename?: 'Query', data: { __typename?: 'DocumentationLinkCollection', collection: Array<{ __typename?: 'DocumentationLink', id: string, documentationId: string, linkableId: string, linkableType: DocumentationLinkLinkableTypeEnum, visibleViaQr: boolean }> } };

export type EdmDocumentationLinkedTasksQueryVariables = Exact<{
  scope: TaskScopeInputObject;
  filters?: InputMaybe<Array<TaskFilterInputObject> | TaskFilterInputObject>;
}>;


export type EdmDocumentationLinkedTasksQuery = { __typename?: 'Query', data: { __typename?: 'TaskCollection', collection: Array<{ __typename?: 'Task', id: string, groupKey: string }> } };

export type EdmDocumentationLinkedTasksListQueryVariables = Exact<{
  page?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  scope: TaskScopeInputObject;
  filters?: InputMaybe<Array<TaskFilterInputObject> | TaskFilterInputObject>;
  sorts?: InputMaybe<TaskSortInputObject>;
}>;


export type EdmDocumentationLinkedTasksListQuery = { __typename?: 'Query', tasks: { __typename?: 'TaskCollection', collection: Array<{ __typename?: 'Task', id: string, name: string, status: TaskStatusEnum, kind: TaskKindEnum, priority: TaskPriorityEnum, recurringRuleId: string | null, site: { __typename?: 'Site', id: string, name: string } | null, siteArea: { __typename?: 'SiteArea', id: string, name: string } | null, formTemplate: { __typename?: 'FormTemplate', id: string, category: { __typename?: 'FormCategory', color: ColorEnum, name: string, id: string } | null } }>, metadata: { __typename?: 'CollectionMetadata', currentPage: number, limitValue: number, totalCount: number, totalPages: number } } };

export type FeFilterPresetFragment = { __typename?: 'FeFilterPreset', data: any, id: string, kind: string, name: string, entities: { __typename?: 'FeFilterPresetEntities', sites: Array<{ __typename?: 'FeFilterPresetEntity', id: string }> | null, sectors: Array<{ __typename?: 'FeFilterPresetEntity', id: string }> | null, formCategories: Array<{ __typename?: 'FeFilterPresetEntity', id: string }> | null, formTemplates: Array<{ __typename?: 'FeFilterPresetEntity', id: string }> | null } };

export type FeFilterPresetsQueryVariables = Exact<{
  filters?: InputMaybe<Array<FeFilterPresetFilterInputObject> | FeFilterPresetFilterInputObject>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  sorts?: InputMaybe<FeFilterPresetSortInputObject>;
}>;


export type FeFilterPresetsQuery = { __typename?: 'Query', data: { __typename?: 'FeFilterPresetCollection', collection: Array<{ __typename?: 'FeFilterPreset', data: any, id: string, kind: string, name: string, entities: { __typename?: 'FeFilterPresetEntities', sites: Array<{ __typename?: 'FeFilterPresetEntity', id: string }> | null, sectors: Array<{ __typename?: 'FeFilterPresetEntity', id: string }> | null, formCategories: Array<{ __typename?: 'FeFilterPresetEntity', id: string }> | null, formTemplates: Array<{ __typename?: 'FeFilterPresetEntity', id: string }> | null } }>, metadata: { __typename?: 'CollectionMetadata', currentPage: number, limitValue: number, totalCount: number, totalPages: number } } };

export type FeFilterPresetQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type FeFilterPresetQuery = { __typename?: 'Query', data: { __typename?: 'FeFilterPreset', data: any, id: string, kind: string, name: string, entities: { __typename?: 'FeFilterPresetEntities', sites: Array<{ __typename?: 'FeFilterPresetEntity', id: string }> | null, sectors: Array<{ __typename?: 'FeFilterPresetEntity', id: string }> | null, formCategories: Array<{ __typename?: 'FeFilterPresetEntity', id: string }> | null, formTemplates: Array<{ __typename?: 'FeFilterPresetEntity', id: string }> | null } } | null };

export type FeFilterPresetCreateMutationVariables = Exact<{
  attributes: FeFilterPresetCreateInputObject;
}>;


export type FeFilterPresetCreateMutation = { __typename?: 'Mutation', data: { __typename?: 'FeFilterPreset', data: any, id: string, kind: string, name: string, entities: { __typename?: 'FeFilterPresetEntities', sites: Array<{ __typename?: 'FeFilterPresetEntity', id: string }> | null, sectors: Array<{ __typename?: 'FeFilterPresetEntity', id: string }> | null, formCategories: Array<{ __typename?: 'FeFilterPresetEntity', id: string }> | null, formTemplates: Array<{ __typename?: 'FeFilterPresetEntity', id: string }> | null } } | null };

export type FeFilterPresetUpdateMutationVariables = Exact<{
  attributes: FeFilterPresetUpdateInputObject;
  id: Scalars['ID']['input'];
}>;


export type FeFilterPresetUpdateMutation = { __typename?: 'Mutation', data: { __typename?: 'FeFilterPreset', data: any, id: string, kind: string, name: string, entities: { __typename?: 'FeFilterPresetEntities', sites: Array<{ __typename?: 'FeFilterPresetEntity', id: string }> | null, sectors: Array<{ __typename?: 'FeFilterPresetEntity', id: string }> | null, formCategories: Array<{ __typename?: 'FeFilterPresetEntity', id: string }> | null, formTemplates: Array<{ __typename?: 'FeFilterPresetEntity', id: string }> | null } } | null };

export type FeFilterPresetDestroyMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type FeFilterPresetDestroyMutation = { __typename?: 'Mutation', feFilterPresetDestroy: boolean | null };

export type FormCategoryFragmentFragment = { __typename?: 'FormCategory', color: ColorEnum, name: string, id: string };

export type QuestionsFragmentFragment = { __typename?: 'FormTemplateVersion', questions: Array<{ __typename?: 'FormTemplateQuestion', id: string, templateId: string, position: number, description: string | null, name: string | null, attachmentsAttached: Array<{ __typename?: 'Attachment', id: string, processed: boolean, fileTag: string | null, fileData: any | null, filename: string | null, urls: { __typename?: 'AttachmentUrl', large: string | null, medium: string | null, original: string | null, small: string | null, imagePreview: string | null, originalDirectDownload: string | null, video480p: string | null, video720p: string | null, video1080p: string | null } | null, metadata: { __typename?: 'AttachmentMetadata', intendedUse: string | null } | null }>, fields: Array<{ __typename?: 'FormTemplateQuestionField', id: string, kind: FormTemplateQuestionFieldsKindEnum, required: boolean, settings: { __typename?: 'FormTemplateQuestionFieldSettings', allowDisplayLastAnswer: boolean | null, limitToOneRespPerColumn: boolean | null, limitToOneRespPerRow: boolean | null, limitToOneResp: boolean | null }, options: Array<{ __typename?: 'FormTemplateQuestionFieldOption', id: string, group: FormTemplateQuestionFieldOptionGroupEnum | null, position: number, values: Array<string>, validityHint: FormTemplateQuestionFieldOptionsValidityHintEnum | null, condition: FormTemplateQuestionFieldOptionConditionEnum | null, optionDocumentation?: { __typename?: 'FormTemplateQuestionFieldOptionDocumentation', id: string, documentationId: string, requiredToRead: boolean } | null }>, validityHintConfig: Array<{ __typename?: 'FormTemplateQuestionFieldValidityHintConfig', optionPositions: Array<number>, validityHint: FormTemplateQuestionFieldOptionsValidityHintEnum }> }> }> };

export type FormTemplateFragmentFragment = { __typename?: 'FormTemplate', description: string | null, id: string, name: string, createdAt: any, updatedAt: any, category: { __typename?: 'FormCategory', color: ColorEnum, name: string, id: string } | null };

export type FormTemplateFullFragmentFragment = { __typename?: 'FormTemplate', visibleLinkedTasksCount: number, description: string | null, id: string, name: string, createdAt: any, updatedAt: any, currentVersion: { __typename?: 'FormTemplateVersion', id: string, version: string | null } | null, category: { __typename?: 'FormCategory', color: ColorEnum, name: string, id: string } | null };

export type FormTemplateVersionFragmentFragment = { __typename?: 'FormTemplateVersion', id: string, templateId: string, version: string | null, createdAt: any, archivedAt: any | null, status: FormTemplateVersionStatusEnum, questions: Array<{ __typename?: 'FormTemplateQuestion', id: string, templateId: string, position: number, description: string | null, name: string | null, attachmentsAttached: Array<{ __typename?: 'Attachment', id: string, processed: boolean, fileTag: string | null, fileData: any | null, filename: string | null, urls: { __typename?: 'AttachmentUrl', large: string | null, medium: string | null, original: string | null, small: string | null, imagePreview: string | null, originalDirectDownload: string | null, video480p: string | null, video720p: string | null, video1080p: string | null } | null, metadata: { __typename?: 'AttachmentMetadata', intendedUse: string | null } | null }>, fields: Array<{ __typename?: 'FormTemplateQuestionField', id: string, kind: FormTemplateQuestionFieldsKindEnum, required: boolean, settings: { __typename?: 'FormTemplateQuestionFieldSettings', allowDisplayLastAnswer: boolean | null, limitToOneRespPerColumn: boolean | null, limitToOneRespPerRow: boolean | null, limitToOneResp: boolean | null }, options: Array<{ __typename?: 'FormTemplateQuestionFieldOption', id: string, group: FormTemplateQuestionFieldOptionGroupEnum | null, position: number, values: Array<string>, validityHint: FormTemplateQuestionFieldOptionsValidityHintEnum | null, condition: FormTemplateQuestionFieldOptionConditionEnum | null, optionDocumentation?: { __typename?: 'FormTemplateQuestionFieldOptionDocumentation', id: string, documentationId: string, requiredToRead: boolean } | null }>, validityHintConfig: Array<{ __typename?: 'FormTemplateQuestionFieldValidityHintConfig', optionPositions: Array<number>, validityHint: FormTemplateQuestionFieldOptionsValidityHintEnum }> }> }> };

export type FullFormTemplateVersionFragmentFragment = { __typename?: 'FormTemplateVersion', id: string, templateId: string, version: string | null, createdAt: any, archivedAt: any | null, status: FormTemplateVersionStatusEnum, canUpdate: { __typename?: 'AuthorizationResult', value: boolean }, canDestroy: { __typename?: 'AuthorizationResult', value: boolean }, canArchive: { __typename?: 'AuthorizationResult', value: boolean }, canRestore: { __typename?: 'AuthorizationResult', value: boolean }, questions: Array<{ __typename?: 'FormTemplateQuestion', id: string, templateId: string, position: number, description: string | null, name: string | null, attachmentsAttached: Array<{ __typename?: 'Attachment', id: string, processed: boolean, fileTag: string | null, fileData: any | null, filename: string | null, urls: { __typename?: 'AttachmentUrl', large: string | null, medium: string | null, original: string | null, small: string | null, imagePreview: string | null, originalDirectDownload: string | null, video480p: string | null, video720p: string | null, video1080p: string | null } | null, metadata: { __typename?: 'AttachmentMetadata', intendedUse: string | null } | null }>, fields: Array<{ __typename?: 'FormTemplateQuestionField', id: string, kind: FormTemplateQuestionFieldsKindEnum, required: boolean, settings: { __typename?: 'FormTemplateQuestionFieldSettings', allowDisplayLastAnswer: boolean | null, limitToOneRespPerColumn: boolean | null, limitToOneRespPerRow: boolean | null, limitToOneResp: boolean | null }, options: Array<{ __typename?: 'FormTemplateQuestionFieldOption', id: string, group: FormTemplateQuestionFieldOptionGroupEnum | null, position: number, values: Array<string>, validityHint: FormTemplateQuestionFieldOptionsValidityHintEnum | null, condition: FormTemplateQuestionFieldOptionConditionEnum | null, optionDocumentation?: { __typename?: 'FormTemplateQuestionFieldOptionDocumentation', id: string, documentationId: string, requiredToRead: boolean } | null }>, validityHintConfig: Array<{ __typename?: 'FormTemplateQuestionFieldValidityHintConfig', optionPositions: Array<number>, validityHint: FormTemplateQuestionFieldOptionsValidityHintEnum }> }> }> };

export type FormTemplateQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type FormTemplateQuery = { __typename?: 'Query', data: { __typename?: 'FormTemplate', archivedAt: any | null, hasLinkedDocumentations: boolean | null, visibleLinkedTasksCount: number, description: string | null, id: string, name: string, createdAt: any, updatedAt: any, canArchive: { __typename?: 'AuthorizationResult', value: boolean }, canDestroy: { __typename?: 'AuthorizationResult', value: boolean }, canUpdate: { __typename?: 'AuthorizationResult', value: boolean }, currentVersion: { __typename?: 'FormTemplateVersion', id: string, version: string | null } | null, category: { __typename?: 'FormCategory', color: ColorEnum, name: string, id: string } | null } | null };

export type FormTemplateVersionsSearchListQueryVariables = Exact<{
  filters?: InputMaybe<Array<FormTemplateVersionFilterInputObject> | FormTemplateVersionFilterInputObject>;
  formTemplateId: Scalars['ID']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  sorts?: InputMaybe<FormTemplateVersionSortInputObject>;
}>;


export type FormTemplateVersionsSearchListQuery = { __typename?: 'Query', data: { __typename?: 'FormTemplateVersionCollection', collection: Array<{ __typename?: 'FormTemplateVersion', id: string, version: string | null, createdAt: any, status: FormTemplateVersionStatusEnum }>, metadata: { __typename?: 'CollectionMetadata', currentPage: number, limitValue: number, totalCount: number, totalPages: number } } };

export type FormTemplateVersionQueryVariables = Exact<{
  formTemplateId: Scalars['ID']['input'];
  id: Scalars['ID']['input'];
  isViewLocked?: Scalars['Boolean']['input'];
}>;


export type FormTemplateVersionQuery = { __typename?: 'Query', data: { __typename?: 'FormTemplateVersion', visibleLinkedTasksCount: number, id: string, templateId: string, version: string | null, createdAt: any, archivedAt: any | null, status: FormTemplateVersionStatusEnum, canUpdate: { __typename?: 'AuthorizationResult', value: boolean }, canDestroy: { __typename?: 'AuthorizationResult', value: boolean }, canArchive: { __typename?: 'AuthorizationResult', value: boolean }, canRestore: { __typename?: 'AuthorizationResult', value: boolean }, questions: Array<{ __typename?: 'FormTemplateQuestion', id: string, templateId: string, position: number, description: string | null, name: string | null, attachmentsAttached: Array<{ __typename?: 'Attachment', id: string, processed: boolean, fileTag: string | null, fileData: any | null, filename: string | null, urls: { __typename?: 'AttachmentUrl', large: string | null, medium: string | null, original: string | null, small: string | null, imagePreview: string | null, originalDirectDownload: string | null, video480p: string | null, video720p: string | null, video1080p: string | null } | null, metadata: { __typename?: 'AttachmentMetadata', intendedUse: string | null } | null }>, fields: Array<{ __typename?: 'FormTemplateQuestionField', id: string, kind: FormTemplateQuestionFieldsKindEnum, required: boolean, settings: { __typename?: 'FormTemplateQuestionFieldSettings', allowDisplayLastAnswer: boolean | null, limitToOneRespPerColumn: boolean | null, limitToOneRespPerRow: boolean | null, limitToOneResp: boolean | null }, options: Array<{ __typename?: 'FormTemplateQuestionFieldOption', id: string, group: FormTemplateQuestionFieldOptionGroupEnum | null, position: number, values: Array<string>, validityHint: FormTemplateQuestionFieldOptionsValidityHintEnum | null, condition: FormTemplateQuestionFieldOptionConditionEnum | null, optionDocumentation?: { __typename?: 'FormTemplateQuestionFieldOptionDocumentation', id: string, documentationId: string, requiredToRead: boolean } | null }>, validityHintConfig: Array<{ __typename?: 'FormTemplateQuestionFieldValidityHintConfig', optionPositions: Array<number>, validityHint: FormTemplateQuestionFieldOptionsValidityHintEnum }> }> }> } | null };

export type FormCategoryQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type FormCategoryQuery = { __typename?: 'Query', data: { __typename?: 'FormCategory', id: string, name: string, color: ColorEnum } | null };

export type FormCategoriesQueryVariables = Exact<{
  filters?: InputMaybe<Array<FormCategoryFilterInputObject> | FormCategoryFilterInputObject>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  sorts?: InputMaybe<FormCategorySortInputObject>;
}>;


export type FormCategoriesQuery = { __typename?: 'Query', data: { __typename?: 'FormCategoryCollection', collection: Array<{ __typename?: 'FormCategory', formTemplatesCount: number, color: ColorEnum, name: string, id: string, formTemplates: { __typename?: 'FormTemplateCollection', collection: Array<{ __typename?: 'FormTemplate', id: string, name: string, currentVersion: { __typename?: 'FormTemplateVersion', id: string } | null }> }, canDestroy: { __typename?: 'AuthorizationResult', value: boolean } }>, metadata: { __typename?: 'CollectionMetadata', currentPage: number, limitValue: number, totalCount: number, totalPages: number } } };

export type FormCategoriesSearchListQueryVariables = Exact<{
  filters?: InputMaybe<Array<FormCategoryFilterInputObject> | FormCategoryFilterInputObject>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  sorts?: InputMaybe<FormCategorySortInputObject>;
}>;


export type FormCategoriesSearchListQuery = { __typename?: 'Query', data: { __typename?: 'FormCategoryCollection', collection: Array<{ __typename?: 'FormCategory', color: ColorEnum, name: string, id: string }>, metadata: { __typename?: 'CollectionMetadata', currentPage: number, limitValue: number, totalCount: number, totalPages: number } } };

export type FormTemplatesQueryVariables = Exact<{
  filters?: InputMaybe<Array<FormTemplateFilterInputObject> | FormTemplateFilterInputObject>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  scopeName: FormTemplateScopeNameEnum;
  sorts?: InputMaybe<FormTemplateSortInputObject>;
}>;


export type FormTemplatesQuery = { __typename?: 'Query', data: { __typename?: 'FormTemplateCollection', collection: Array<{ __typename?: 'FormTemplate', id: string, name: string, createdAt: any, archivedAt: any | null, versionsCount: number, visibleLinkedTasksCount: number, category: { __typename?: 'FormCategory', color: ColorEnum, name: string, id: string } | null, currentVersion: { __typename?: 'FormTemplateVersion', id: string, version: string | null } | null, canDestroy: { __typename?: 'AuthorizationResult', value: boolean }, canArchive: { __typename?: 'AuthorizationResult', value: boolean }, canUpdate: { __typename?: 'AuthorizationResult', value: boolean } }>, metadata: { __typename?: 'CollectionMetadata', currentPage: number, limitValue: number, totalCount: number, totalPages: number } }, activeCounter: { __typename?: 'FormTemplateCollection', metadata: { __typename?: 'CollectionMetadata', totalCount: number } }, archivedCounter: { __typename?: 'FormTemplateCollection', metadata: { __typename?: 'CollectionMetadata', totalCount: number } } };

export type FormTemplateIdsQueryVariables = Exact<{
  filters?: InputMaybe<Array<FormTemplateFilterInputObject> | FormTemplateFilterInputObject>;
  onlyIds?: InputMaybe<Scalars['Boolean']['input']>;
  scopeName: FormTemplateScopeNameEnum;
  sorts?: InputMaybe<FormTemplateSortInputObject>;
}>;


export type FormTemplateIdsQuery = { __typename?: 'Query', data: { __typename?: 'FormTemplateCollection', collection: Array<{ __typename?: 'FormTemplate', id: string }> } };

export type FormTemplatesSearchListQueryVariables = Exact<{
  filters?: InputMaybe<Array<FormTemplateFilterInputObject> | FormTemplateFilterInputObject>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  scopeName: FormTemplateScopeNameEnum;
  sorts?: InputMaybe<FormTemplateSortInputObject>;
}>;


export type FormTemplatesSearchListQuery = { __typename?: 'Query', data: { __typename?: 'FormTemplateCollection', collection: Array<{ __typename?: 'FormTemplate', id: string, name: string }>, metadata: { __typename?: 'CollectionMetadata', currentPage: number, limitValue: number, totalCount: number, totalPages: number } } };

export type FormCategoryCreateMutationVariables = Exact<{
  attributes: FormCategoryCreateInputObject;
}>;


export type FormCategoryCreateMutation = { __typename?: 'Mutation', data: { __typename?: 'FormCategory', color: ColorEnum, name: string, id: string } | null };

export type FormCategoryUpdateMutationVariables = Exact<{
  attributes: FormCategoryUpdateInputObject;
  id: Scalars['ID']['input'];
}>;


export type FormCategoryUpdateMutation = { __typename?: 'Mutation', data: { __typename?: 'FormCategory', color: ColorEnum, name: string, id: string } | null };

export type FormCategoryDestroyMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type FormCategoryDestroyMutation = { __typename?: 'Mutation', formCategoryDestroy: boolean | null };

export type FormTemplateCreateMutationVariables = Exact<{
  attributes: FormTemplateCreateInputObject;
}>;


export type FormTemplateCreateMutation = { __typename?: 'Mutation', data: { __typename?: 'FormTemplate', visibleLinkedTasksCount: number, description: string | null, id: string, name: string, createdAt: any, updatedAt: any, currentVersion: { __typename?: 'FormTemplateVersion', id: string, version: string | null } | null, category: { __typename?: 'FormCategory', color: ColorEnum, name: string, id: string } | null } | null };

export type FormTemplateUpdateMutationVariables = Exact<{
  attributes: FormTemplateUpdateInputObject;
  id: Scalars['ID']['input'];
}>;


export type FormTemplateUpdateMutation = { __typename?: 'Mutation', data: { __typename?: 'FormTemplate', visibleLinkedTasksCount: number, description: string | null, id: string, name: string, createdAt: any, updatedAt: any, currentVersion: { __typename?: 'FormTemplateVersion', id: string, version: string | null } | null, category: { __typename?: 'FormCategory', color: ColorEnum, name: string, id: string } | null } | null };

export type FormTemplateBulkDestroyMutationVariables = Exact<{
  ids: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;


export type FormTemplateBulkDestroyMutation = { __typename?: 'Mutation', data: boolean | null };

export type FormTemplateBulkArchiveMutationVariables = Exact<{
  ids: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;


export type FormTemplateBulkArchiveMutation = { __typename?: 'Mutation', data: boolean | null };

export type FormTemplateBulkRestoreMutationVariables = Exact<{
  ids: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;


export type FormTemplateBulkRestoreMutation = { __typename?: 'Mutation', data: boolean | null };

export type FormTemplateUnlinkAllDocumentationsMutationVariables = Exact<{
  input: FormTemplateUnlinkAllDocumentationsInput;
}>;


export type FormTemplateUnlinkAllDocumentationsMutation = { __typename?: 'Mutation', data: boolean | null };

export type FormTemplateVersionCreateMutationVariables = Exact<{
  attributes: FormTemplateVersionCuInputObject;
  formTemplateId: Scalars['ID']['input'];
  isViewLocked?: Scalars['Boolean']['input'];
}>;


export type FormTemplateVersionCreateMutation = { __typename?: 'Mutation', data: { __typename?: 'FormTemplateVersion', id: string, templateId: string, version: string | null, createdAt: any, archivedAt: any | null, status: FormTemplateVersionStatusEnum, canUpdate: { __typename?: 'AuthorizationResult', value: boolean }, canDestroy: { __typename?: 'AuthorizationResult', value: boolean }, canArchive: { __typename?: 'AuthorizationResult', value: boolean }, canRestore: { __typename?: 'AuthorizationResult', value: boolean }, questions: Array<{ __typename?: 'FormTemplateQuestion', id: string, templateId: string, position: number, description: string | null, name: string | null, attachmentsAttached: Array<{ __typename?: 'Attachment', id: string, processed: boolean, fileTag: string | null, fileData: any | null, filename: string | null, urls: { __typename?: 'AttachmentUrl', large: string | null, medium: string | null, original: string | null, small: string | null, imagePreview: string | null, originalDirectDownload: string | null, video480p: string | null, video720p: string | null, video1080p: string | null } | null, metadata: { __typename?: 'AttachmentMetadata', intendedUse: string | null } | null }>, fields: Array<{ __typename?: 'FormTemplateQuestionField', id: string, kind: FormTemplateQuestionFieldsKindEnum, required: boolean, settings: { __typename?: 'FormTemplateQuestionFieldSettings', allowDisplayLastAnswer: boolean | null, limitToOneRespPerColumn: boolean | null, limitToOneRespPerRow: boolean | null, limitToOneResp: boolean | null }, options: Array<{ __typename?: 'FormTemplateQuestionFieldOption', id: string, group: FormTemplateQuestionFieldOptionGroupEnum | null, position: number, values: Array<string>, validityHint: FormTemplateQuestionFieldOptionsValidityHintEnum | null, condition: FormTemplateQuestionFieldOptionConditionEnum | null, optionDocumentation?: { __typename?: 'FormTemplateQuestionFieldOptionDocumentation', id: string, documentationId: string, requiredToRead: boolean } | null }>, validityHintConfig: Array<{ __typename?: 'FormTemplateQuestionFieldValidityHintConfig', optionPositions: Array<number>, validityHint: FormTemplateQuestionFieldOptionsValidityHintEnum }> }> }> } | null };

export type FormTemplateVersionUpdateMutationVariables = Exact<{
  attributes: FormTemplateVersionCuInputObject;
  id: Scalars['ID']['input'];
  formTemplateId: Scalars['ID']['input'];
}>;


export type FormTemplateVersionUpdateMutation = { __typename?: 'Mutation', data: { __typename?: 'FormTemplateVersion', id: string } | null };

export type FormTemplateVersionArchiveMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  formTemplateId: Scalars['ID']['input'];
  isViewLocked?: Scalars['Boolean']['input'];
}>;


export type FormTemplateVersionArchiveMutation = { __typename?: 'Mutation', data: { __typename?: 'FormTemplateVersion', id: string, templateId: string, version: string | null, createdAt: any, archivedAt: any | null, status: FormTemplateVersionStatusEnum, canUpdate: { __typename?: 'AuthorizationResult', value: boolean }, canDestroy: { __typename?: 'AuthorizationResult', value: boolean }, canArchive: { __typename?: 'AuthorizationResult', value: boolean }, canRestore: { __typename?: 'AuthorizationResult', value: boolean }, questions: Array<{ __typename?: 'FormTemplateQuestion', id: string, templateId: string, position: number, description: string | null, name: string | null, attachmentsAttached: Array<{ __typename?: 'Attachment', id: string, processed: boolean, fileTag: string | null, fileData: any | null, filename: string | null, urls: { __typename?: 'AttachmentUrl', large: string | null, medium: string | null, original: string | null, small: string | null, imagePreview: string | null, originalDirectDownload: string | null, video480p: string | null, video720p: string | null, video1080p: string | null } | null, metadata: { __typename?: 'AttachmentMetadata', intendedUse: string | null } | null }>, fields: Array<{ __typename?: 'FormTemplateQuestionField', id: string, kind: FormTemplateQuestionFieldsKindEnum, required: boolean, settings: { __typename?: 'FormTemplateQuestionFieldSettings', allowDisplayLastAnswer: boolean | null, limitToOneRespPerColumn: boolean | null, limitToOneRespPerRow: boolean | null, limitToOneResp: boolean | null }, options: Array<{ __typename?: 'FormTemplateQuestionFieldOption', id: string, group: FormTemplateQuestionFieldOptionGroupEnum | null, position: number, values: Array<string>, validityHint: FormTemplateQuestionFieldOptionsValidityHintEnum | null, condition: FormTemplateQuestionFieldOptionConditionEnum | null, optionDocumentation?: { __typename?: 'FormTemplateQuestionFieldOptionDocumentation', id: string, documentationId: string, requiredToRead: boolean } | null }>, validityHintConfig: Array<{ __typename?: 'FormTemplateQuestionFieldValidityHintConfig', optionPositions: Array<number>, validityHint: FormTemplateQuestionFieldOptionsValidityHintEnum }> }> }> } | null };

export type FormTemplateVersionRestoreMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  formTemplateId: Scalars['ID']['input'];
  isViewLocked?: Scalars['Boolean']['input'];
}>;


export type FormTemplateVersionRestoreMutation = { __typename?: 'Mutation', data: { __typename?: 'FormTemplateVersion', visibleLinkedTasksCount: number, id: string, templateId: string, version: string | null, createdAt: any, archivedAt: any | null, status: FormTemplateVersionStatusEnum, canUpdate: { __typename?: 'AuthorizationResult', value: boolean }, canDestroy: { __typename?: 'AuthorizationResult', value: boolean }, canArchive: { __typename?: 'AuthorizationResult', value: boolean }, canRestore: { __typename?: 'AuthorizationResult', value: boolean }, questions: Array<{ __typename?: 'FormTemplateQuestion', id: string, templateId: string, position: number, description: string | null, name: string | null, attachmentsAttached: Array<{ __typename?: 'Attachment', id: string, processed: boolean, fileTag: string | null, fileData: any | null, filename: string | null, urls: { __typename?: 'AttachmentUrl', large: string | null, medium: string | null, original: string | null, small: string | null, imagePreview: string | null, originalDirectDownload: string | null, video480p: string | null, video720p: string | null, video1080p: string | null } | null, metadata: { __typename?: 'AttachmentMetadata', intendedUse: string | null } | null }>, fields: Array<{ __typename?: 'FormTemplateQuestionField', id: string, kind: FormTemplateQuestionFieldsKindEnum, required: boolean, settings: { __typename?: 'FormTemplateQuestionFieldSettings', allowDisplayLastAnswer: boolean | null, limitToOneRespPerColumn: boolean | null, limitToOneRespPerRow: boolean | null, limitToOneResp: boolean | null }, options: Array<{ __typename?: 'FormTemplateQuestionFieldOption', id: string, group: FormTemplateQuestionFieldOptionGroupEnum | null, position: number, values: Array<string>, validityHint: FormTemplateQuestionFieldOptionsValidityHintEnum | null, condition: FormTemplateQuestionFieldOptionConditionEnum | null, optionDocumentation?: { __typename?: 'FormTemplateQuestionFieldOptionDocumentation', id: string, documentationId: string, requiredToRead: boolean } | null }>, validityHintConfig: Array<{ __typename?: 'FormTemplateQuestionFieldValidityHintConfig', optionPositions: Array<number>, validityHint: FormTemplateQuestionFieldOptionsValidityHintEnum }> }> }> } | null };

export type FormTemplateVersionDestroyMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  formTemplateId: Scalars['ID']['input'];
}>;


export type FormTemplateVersionDestroyMutation = { __typename?: 'Mutation', data: boolean | null };

export type FormChecklistTemplateFragmentFragment = { __typename?: 'FormChecklistTemplate', id: string, name: string, description: string | null, optionsCount: number, canUpdate: { __typename?: 'AuthorizationResult', value: boolean, message: string | null, reasons: { __typename?: 'FailureReasons', details: string, fullMessages: Array<string> } | null }, canDestroy: { __typename?: 'AuthorizationResult', value: boolean, message: string | null, reasons: { __typename?: 'FailureReasons', details: string, fullMessages: Array<string> } | null } };

export type FormChecklistTemplateWithOptionsFragmentFragment = { __typename?: 'FormChecklistTemplate', id: string, name: string, description: string | null, optionsCount: number, options: Array<{ __typename?: 'FormChecklistTemplateOption', id: string, value: string, position: number, updatedAt: any }>, canUpdate: { __typename?: 'AuthorizationResult', value: boolean, message: string | null, reasons: { __typename?: 'FailureReasons', details: string, fullMessages: Array<string> } | null }, canDestroy: { __typename?: 'AuthorizationResult', value: boolean, message: string | null, reasons: { __typename?: 'FailureReasons', details: string, fullMessages: Array<string> } | null } };

export type FormChecklistTemplateQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type FormChecklistTemplateQuery = { __typename?: 'Query', data: { __typename?: 'FormChecklistTemplate', id: string, name: string, description: string | null, optionsCount: number, options: Array<{ __typename?: 'FormChecklistTemplateOption', id: string, value: string, position: number, updatedAt: any }>, canUpdate: { __typename?: 'AuthorizationResult', value: boolean, message: string | null, reasons: { __typename?: 'FailureReasons', details: string, fullMessages: Array<string> } | null }, canDestroy: { __typename?: 'AuthorizationResult', value: boolean, message: string | null, reasons: { __typename?: 'FailureReasons', details: string, fullMessages: Array<string> } | null } } | null };

export type FormChecklistTemplatesQueryVariables = Exact<{
  page?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  filters?: InputMaybe<Array<FormChecklistTemplateFilterInputObject> | FormChecklistTemplateFilterInputObject>;
  sorts?: InputMaybe<FormChecklistTemplateSortInputObject>;
}>;


export type FormChecklistTemplatesQuery = { __typename?: 'Query', data: { __typename?: 'FormChecklistTemplateCollection', collection: Array<{ __typename?: 'FormChecklistTemplate', id: string, name: string, description: string | null, optionsCount: number, canUpdate: { __typename?: 'AuthorizationResult', value: boolean, message: string | null, reasons: { __typename?: 'FailureReasons', details: string, fullMessages: Array<string> } | null }, canDestroy: { __typename?: 'AuthorizationResult', value: boolean, message: string | null, reasons: { __typename?: 'FailureReasons', details: string, fullMessages: Array<string> } | null } }>, metadata: { __typename?: 'CollectionMetadata', currentPage: number, limitValue: number, totalCount: number, totalPages: number } } };

export type FormChecklistTemplateIdsQueryVariables = Exact<{
  filters?: InputMaybe<Array<FormChecklistTemplateFilterInputObject> | FormChecklistTemplateFilterInputObject>;
  sorts?: InputMaybe<FormChecklistTemplateSortInputObject>;
  onlyIds?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type FormChecklistTemplateIdsQuery = { __typename?: 'Query', data: { __typename?: 'FormChecklistTemplateCollection', collection: Array<{ __typename?: 'FormChecklistTemplate', id: string }> } };

export type FormChecklistTemplatesSearchListQueryVariables = Exact<{
  page?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  filters?: InputMaybe<Array<FormChecklistTemplateFilterInputObject> | FormChecklistTemplateFilterInputObject>;
  sorts?: InputMaybe<FormChecklistTemplateSortInputObject>;
}>;


export type FormChecklistTemplatesSearchListQuery = { __typename?: 'Query', data: { __typename?: 'FormChecklistTemplateCollection', collection: Array<{ __typename?: 'FormChecklistTemplate', id: string, name: string }>, metadata: { __typename?: 'CollectionMetadata', currentPage: number, limitValue: number, totalCount: number, totalPages: number } } };

export type FormChecklistTemplateCreateMutationVariables = Exact<{
  attributes: FormChecklistTemplateCreateInputObject;
}>;


export type FormChecklistTemplateCreateMutation = { __typename?: 'Mutation', data: { __typename?: 'FormChecklistTemplate', id: string, name: string, description: string | null, optionsCount: number, options: Array<{ __typename?: 'FormChecklistTemplateOption', value: string, position: number, updatedAt: any, id: string }>, canUpdate: { __typename?: 'AuthorizationResult', value: boolean, message: string | null, reasons: { __typename?: 'FailureReasons', details: string, fullMessages: Array<string> } | null }, canDestroy: { __typename?: 'AuthorizationResult', value: boolean, message: string | null, reasons: { __typename?: 'FailureReasons', details: string, fullMessages: Array<string> } | null } } | null };

export type FormChecklistTemplateUpdateMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  attributes: FormChecklistTemplateUpdateInputObject;
}>;


export type FormChecklistTemplateUpdateMutation = { __typename?: 'Mutation', data: { __typename?: 'FormChecklistTemplate', id: string, name: string, description: string | null, optionsCount: number, options: Array<{ __typename?: 'FormChecklistTemplateOption', value: string, position: number, updatedAt: any, id: string }>, canUpdate: { __typename?: 'AuthorizationResult', value: boolean, message: string | null, reasons: { __typename?: 'FailureReasons', details: string, fullMessages: Array<string> } | null }, canDestroy: { __typename?: 'AuthorizationResult', value: boolean, message: string | null, reasons: { __typename?: 'FailureReasons', details: string, fullMessages: Array<string> } | null } } | null };

export type FormChecklistTemplateDestroyMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type FormChecklistTemplateDestroyMutation = { __typename?: 'Mutation', data: boolean | null };

export type AttachmentFragmentFragment = { __typename?: 'Attachment', id: string, processed: boolean, fileTag: string | null, fileData: any | null, filename: string | null, urls: { __typename?: 'AttachmentUrl', large: string | null, medium: string | null, original: string | null, small: string | null, imagePreview: string | null, originalDirectDownload: string | null, video480p: string | null, video720p: string | null, video1080p: string | null } | null, metadata: { __typename?: 'AttachmentMetadata', intendedUse: string | null } | null };

export type MetadataFragmentFragment = { __typename?: 'CollectionMetadata', currentPage: number, limitValue: number, totalCount: number, totalPages: number };

export type AuthorizationResultFragmentFragment = { __typename?: 'AuthorizationResult', value: boolean, message: string | null, reasons: { __typename?: 'FailureReasons', details: string, fullMessages: Array<string> } | null };

export type BackgroundJobFragmentFragment = { __typename?: 'BackgroundJob', id: string, jid: string | null, parentId: string | null, rootId: string, kind: BackgroundJobKindEnum, status: BackgroundJobStatusEnum, displayStatus: BackgroundJobStatusEnum, treeStatus: BackgroundJobStatusEnum, done: number, total: number, failed: number, pctComplete: number, message: string | null, errorCode: string | null, result: any | null, estimatedFinishAt: any | null, startedAt: any | null, finishedAt: any | null, cancelRequestedAt: any | null, deliveryRequestedAt: any | null, dismissed: boolean, createdAt: any, updatedAt: any, canCancel: { __typename?: 'AuthorizationResult', value: boolean, message: string | null, reasons: { __typename?: 'FailureReasons', details: string, fullMessages: Array<string> } | null }, canDismiss: { __typename?: 'AuthorizationResult', value: boolean, message: string | null, reasons: { __typename?: 'FailureReasons', details: string, fullMessages: Array<string> } | null }, canRequestDelivery: { __typename?: 'AuthorizationResult', value: boolean, message: string | null, reasons: { __typename?: 'FailureReasons', details: string, fullMessages: Array<string> } | null }, canRequeue: { __typename?: 'AuthorizationResult', value: boolean, message: string | null, reasons: { __typename?: 'FailureReasons', details: string, fullMessages: Array<string> } | null } };

export type BackgroundJobTreeFragmentFragment = { __typename?: 'BackgroundJob', id: string, jid: string | null, parentId: string | null, rootId: string, kind: BackgroundJobKindEnum, status: BackgroundJobStatusEnum, displayStatus: BackgroundJobStatusEnum, treeStatus: BackgroundJobStatusEnum, done: number, total: number, failed: number, pctComplete: number, message: string | null, errorCode: string | null, result: any | null, estimatedFinishAt: any | null, startedAt: any | null, finishedAt: any | null, cancelRequestedAt: any | null, deliveryRequestedAt: any | null, dismissed: boolean, createdAt: any, updatedAt: any, children: Array<{ __typename?: 'BackgroundJob', id: string, jid: string | null, parentId: string | null, rootId: string, kind: BackgroundJobKindEnum, status: BackgroundJobStatusEnum, displayStatus: BackgroundJobStatusEnum, treeStatus: BackgroundJobStatusEnum, done: number, total: number, failed: number, pctComplete: number, message: string | null, errorCode: string | null, result: any | null, estimatedFinishAt: any | null, startedAt: any | null, finishedAt: any | null, cancelRequestedAt: any | null, deliveryRequestedAt: any | null, dismissed: boolean, createdAt: any, updatedAt: any, canCancel: { __typename?: 'AuthorizationResult', value: boolean, message: string | null, reasons: { __typename?: 'FailureReasons', details: string, fullMessages: Array<string> } | null }, canDismiss: { __typename?: 'AuthorizationResult', value: boolean, message: string | null, reasons: { __typename?: 'FailureReasons', details: string, fullMessages: Array<string> } | null }, canRequestDelivery: { __typename?: 'AuthorizationResult', value: boolean, message: string | null, reasons: { __typename?: 'FailureReasons', details: string, fullMessages: Array<string> } | null }, canRequeue: { __typename?: 'AuthorizationResult', value: boolean, message: string | null, reasons: { __typename?: 'FailureReasons', details: string, fullMessages: Array<string> } | null } }>, canCancel: { __typename?: 'AuthorizationResult', value: boolean, message: string | null, reasons: { __typename?: 'FailureReasons', details: string, fullMessages: Array<string> } | null }, canDismiss: { __typename?: 'AuthorizationResult', value: boolean, message: string | null, reasons: { __typename?: 'FailureReasons', details: string, fullMessages: Array<string> } | null }, canRequestDelivery: { __typename?: 'AuthorizationResult', value: boolean, message: string | null, reasons: { __typename?: 'FailureReasons', details: string, fullMessages: Array<string> } | null }, canRequeue: { __typename?: 'AuthorizationResult', value: boolean, message: string | null, reasons: { __typename?: 'FailureReasons', details: string, fullMessages: Array<string> } | null } };

export type GeojsonFragmentFragment = { __typename?: 'GeojsonFeatureCollection', type: GeojsonFeatureCollectionTypeEnum, features: Array<{ __typename?: 'GeojsonFeature', type: GeojsonFeatureTypeEnum, geometry: { __typename?: 'GeojsonGeometry', coordinates: any, type: GeojsonGeometryTypeEnum }, properties: { __typename?: 'GeojsonProperties', address: string | null, addressDetails: string | null, color: ColorEnum | null, icon: string | null, shape: string | null, type: GeojsonPropertiesTypeEnum | null } | null }> };

export type GeojsonFullFragmentFragment = { __typename?: 'GeojsonFeatureCollection', type: GeojsonFeatureCollectionTypeEnum, features: Array<{ __typename?: 'GeojsonFeature', type: GeojsonFeatureTypeEnum, geometry: { __typename?: 'GeojsonGeometry', coordinates: any, type: GeojsonGeometryTypeEnum }, properties: { __typename?: 'GeojsonProperties', address: string | null, addressDetails: string | null, color: ColorEnum | null, icon: string | null, shape: string | null, type: GeojsonPropertiesTypeEnum | null, pointCount: number | null, sourceables: Array<{ __typename?: 'GeojsonPropertiesPolymorphicIdentity', id: string, type: GeojsonPropertiesPolymorphicIdentityTypeEnum }> | null } | null }> };

export type LocationBoundaryFragmentFragment = { __typename?: 'Location', kind: string, id: string, geojson: { __typename?: 'GeojsonFeatureCollection', type: GeojsonFeatureCollectionTypeEnum, features: Array<{ __typename?: 'GeojsonFeature', type: GeojsonFeatureTypeEnum, geometry: { __typename?: 'GeojsonGeometry', coordinates: any, type: GeojsonGeometryTypeEnum }, properties: { __typename?: 'GeojsonProperties', address: string | null, addressDetails: string | null, color: ColorEnum | null, icon: string | null, shape: string | null, type: GeojsonPropertiesTypeEnum | null } | null }> } | null };

export type HomePageFragmentFragment = { __typename?: 'HomePage', id: string, name: string | null, position: number, isDefault: boolean, userId: string | null, createdAt: any, updatedAt: any, canUpdate: { __typename?: 'AuthorizationResult', value: boolean, message: string | null, reasons: { __typename?: 'FailureReasons', details: string, fullMessages: Array<string> } | null }, canDestroy: { __typename?: 'AuthorizationResult', value: boolean, message: string | null, reasons: { __typename?: 'FailureReasons', details: string, fullMessages: Array<string> } | null } };

export type WidgetFragmentFragment = { __typename?: 'Widget', id: string, homePageId: string, widgetTemplateId: string | null, kind: WidgetsKindEnum, title: string | null, description: string | null, position: number, grid: any, createdAt: any, updatedAt: any, fields: { __typename?: 'WidgetsField', backgroundColor: ColorEnum | null, link: string | null, location: string | null, timezone: string | null, startAt: any | null, endAt: any | null, onlyMy: boolean | null, buttons: { __typename?: 'WidgetsFieldsButtons', asset: { __typename?: 'WidgetsFieldsButtonItem', enabled: boolean | null, updatedAt: any | null } | null, formTemplate: { __typename?: 'WidgetsFieldsButtonItem', enabled: boolean | null, updatedAt: any | null } | null, intervention: { __typename?: 'WidgetsFieldsButtonItem', enabled: boolean | null, updatedAt: any | null } | null, site: { __typename?: 'WidgetsFieldsButtonItem', enabled: boolean | null, updatedAt: any | null } | null, task: { __typename?: 'WidgetsFieldsButtonItem', enabled: boolean | null, updatedAt: any | null } | null, teamMember: { __typename?: 'WidgetsFieldsButtonItem', enabled: boolean | null, updatedAt: any | null } | null } | null }, attachmentsAttached: Array<{ __typename?: 'Attachment', id: string, processed: boolean, fileTag: string | null, fileData: any | null, filename: string | null, urls: { __typename?: 'AttachmentUrl', large: string | null, medium: string | null, original: string | null, small: string | null, imagePreview: string | null, originalDirectDownload: string | null, video480p: string | null, video720p: string | null, video1080p: string | null } | null, metadata: { __typename?: 'AttachmentMetadata', intendedUse: string | null } | null }> };

export type WidgetTemplateFragmentFragment = { __typename?: 'WidgetTemplate', id: string, title: string | null, description: string | null, kind: WidgetTemplatesKindEnum, visibility: WidgetTemplatesVisibilityEnum, isDefault: boolean, fields: { __typename?: 'WidgetTemplatesField', backgroundColor: ColorEnum | null, content: string | null, link: string | null }, attachmentsAttached: Array<{ __typename?: 'Attachment', id: string, processed: boolean, fileTag: string | null, fileData: any | null, filename: string | null, urls: { __typename?: 'AttachmentUrl', large: string | null, medium: string | null, original: string | null, small: string | null, imagePreview: string | null, originalDirectDownload: string | null, video480p: string | null, video720p: string | null, video1080p: string | null } | null, metadata: { __typename?: 'AttachmentMetadata', intendedUse: string | null } | null }> };

export type HomePageQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type HomePageQuery = { __typename?: 'Query', data: { __typename?: 'HomePage', id: string, name: string | null, position: number, isDefault: boolean, userId: string | null, createdAt: any, updatedAt: any, canUpdate: { __typename?: 'AuthorizationResult', value: boolean, message: string | null, reasons: { __typename?: 'FailureReasons', details: string, fullMessages: Array<string> } | null }, canDestroy: { __typename?: 'AuthorizationResult', value: boolean, message: string | null, reasons: { __typename?: 'FailureReasons', details: string, fullMessages: Array<string> } | null } } | null };

export type HomePagesQueryVariables = Exact<{
  page?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
}>;


export type HomePagesQuery = { __typename?: 'Query', data: { __typename?: 'HomePageCollection', collection: Array<{ __typename?: 'HomePage', id: string, name: string | null, position: number, isDefault: boolean, userId: string | null, createdAt: any, updatedAt: any, canUpdate: { __typename?: 'AuthorizationResult', value: boolean, message: string | null, reasons: { __typename?: 'FailureReasons', details: string, fullMessages: Array<string> } | null }, canDestroy: { __typename?: 'AuthorizationResult', value: boolean, message: string | null, reasons: { __typename?: 'FailureReasons', details: string, fullMessages: Array<string> } | null } }>, metadata: { __typename?: 'CollectionMetadata', currentPage: number, limitValue: number, totalCount: number, totalPages: number } } };

export type WidgetQueryVariables = Exact<{
  homePageId: Scalars['ID']['input'];
  id: Scalars['ID']['input'];
}>;


export type WidgetQuery = { __typename?: 'Query', data: { __typename?: 'Widget', id: string, homePageId: string, widgetTemplateId: string | null, kind: WidgetsKindEnum, title: string | null, description: string | null, position: number, grid: any, createdAt: any, updatedAt: any, fields: { __typename?: 'WidgetsField', backgroundColor: ColorEnum | null, link: string | null, location: string | null, timezone: string | null, startAt: any | null, endAt: any | null, onlyMy: boolean | null, buttons: { __typename?: 'WidgetsFieldsButtons', asset: { __typename?: 'WidgetsFieldsButtonItem', enabled: boolean | null, updatedAt: any | null } | null, formTemplate: { __typename?: 'WidgetsFieldsButtonItem', enabled: boolean | null, updatedAt: any | null } | null, intervention: { __typename?: 'WidgetsFieldsButtonItem', enabled: boolean | null, updatedAt: any | null } | null, site: { __typename?: 'WidgetsFieldsButtonItem', enabled: boolean | null, updatedAt: any | null } | null, task: { __typename?: 'WidgetsFieldsButtonItem', enabled: boolean | null, updatedAt: any | null } | null, teamMember: { __typename?: 'WidgetsFieldsButtonItem', enabled: boolean | null, updatedAt: any | null } | null } | null }, attachmentsAttached: Array<{ __typename?: 'Attachment', id: string, processed: boolean, fileTag: string | null, fileData: any | null, filename: string | null, urls: { __typename?: 'AttachmentUrl', large: string | null, medium: string | null, original: string | null, small: string | null, imagePreview: string | null, originalDirectDownload: string | null, video480p: string | null, video720p: string | null, video1080p: string | null } | null, metadata: { __typename?: 'AttachmentMetadata', intendedUse: string | null } | null }> } | null };

export type WidgetsQueryVariables = Exact<{
  homePageId: Scalars['ID']['input'];
}>;


export type WidgetsQuery = { __typename?: 'Query', data: Array<{ __typename?: 'Widget', id: string, homePageId: string, widgetTemplateId: string | null, kind: WidgetsKindEnum, title: string | null, description: string | null, position: number, grid: any, createdAt: any, updatedAt: any, fields: { __typename?: 'WidgetsField', backgroundColor: ColorEnum | null, link: string | null, location: string | null, timezone: string | null, startAt: any | null, endAt: any | null, onlyMy: boolean | null, buttons: { __typename?: 'WidgetsFieldsButtons', asset: { __typename?: 'WidgetsFieldsButtonItem', enabled: boolean | null, updatedAt: any | null } | null, formTemplate: { __typename?: 'WidgetsFieldsButtonItem', enabled: boolean | null, updatedAt: any | null } | null, intervention: { __typename?: 'WidgetsFieldsButtonItem', enabled: boolean | null, updatedAt: any | null } | null, site: { __typename?: 'WidgetsFieldsButtonItem', enabled: boolean | null, updatedAt: any | null } | null, task: { __typename?: 'WidgetsFieldsButtonItem', enabled: boolean | null, updatedAt: any | null } | null, teamMember: { __typename?: 'WidgetsFieldsButtonItem', enabled: boolean | null, updatedAt: any | null } | null } | null }, attachmentsAttached: Array<{ __typename?: 'Attachment', id: string, processed: boolean, fileTag: string | null, fileData: any | null, filename: string | null, urls: { __typename?: 'AttachmentUrl', large: string | null, medium: string | null, original: string | null, small: string | null, imagePreview: string | null, originalDirectDownload: string | null, video480p: string | null, video720p: string | null, video1080p: string | null } | null, metadata: { __typename?: 'AttachmentMetadata', intendedUse: string | null } | null }> }> };

export type WidgetTemplateQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type WidgetTemplateQuery = { __typename?: 'Query', data: { __typename?: 'WidgetTemplate', id: string, title: string | null, description: string | null, kind: WidgetTemplatesKindEnum, visibility: WidgetTemplatesVisibilityEnum, isDefault: boolean, fields: { __typename?: 'WidgetTemplatesField', backgroundColor: ColorEnum | null, content: string | null, link: string | null }, attachmentsAttached: Array<{ __typename?: 'Attachment', id: string, processed: boolean, fileTag: string | null, fileData: any | null, filename: string | null, urls: { __typename?: 'AttachmentUrl', large: string | null, medium: string | null, original: string | null, small: string | null, imagePreview: string | null, originalDirectDownload: string | null, video480p: string | null, video720p: string | null, video1080p: string | null } | null, metadata: { __typename?: 'AttachmentMetadata', intendedUse: string | null } | null }> } | null };

export type WidgetTemplatesQueryVariables = Exact<{
  page?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  sorts?: InputMaybe<WidgetTemplateSortInputObject>;
  filters?: InputMaybe<Array<WidgetTemplateFilterInputObject> | WidgetTemplateFilterInputObject>;
  onlyIds?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type WidgetTemplatesQuery = { __typename?: 'Query', data: { __typename?: 'WidgetTemplateCollection', collection: Array<{ __typename?: 'WidgetTemplate', id: string, title: string | null, description: string | null, kind: WidgetTemplatesKindEnum, visibility: WidgetTemplatesVisibilityEnum, isDefault: boolean, fields: { __typename?: 'WidgetTemplatesField', backgroundColor: ColorEnum | null, content: string | null, link: string | null }, attachmentsAttached: Array<{ __typename?: 'Attachment', id: string, processed: boolean, fileTag: string | null, fileData: any | null, filename: string | null, urls: { __typename?: 'AttachmentUrl', large: string | null, medium: string | null, original: string | null, small: string | null, imagePreview: string | null, originalDirectDownload: string | null, video480p: string | null, video720p: string | null, video1080p: string | null } | null, metadata: { __typename?: 'AttachmentMetadata', intendedUse: string | null } | null }> }>, metadata: { __typename?: 'CollectionMetadata', currentPage: number, limitValue: number, totalCount: number, totalPages: number } } };

export type WidgetTemplatesWithCountersQueryVariables = Exact<{
  page?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  sorts?: InputMaybe<WidgetTemplateSortInputObject>;
  filters?: InputMaybe<Array<WidgetTemplateFilterInputObject> | WidgetTemplateFilterInputObject>;
  allTemplatesFilters?: InputMaybe<Array<WidgetTemplateFilterInputObject> | WidgetTemplateFilterInputObject>;
  publicTemplatesFilters?: InputMaybe<Array<WidgetTemplateFilterInputObject> | WidgetTemplateFilterInputObject>;
  privateTemplatesFilters?: InputMaybe<Array<WidgetTemplateFilterInputObject> | WidgetTemplateFilterInputObject>;
}>;


export type WidgetTemplatesWithCountersQuery = { __typename?: 'Query', data: { __typename?: 'WidgetTemplateCollection', collection: Array<{ __typename?: 'WidgetTemplate', id: string, title: string | null, description: string | null, kind: WidgetTemplatesKindEnum, fields: { __typename?: 'WidgetTemplatesField', backgroundColor: ColorEnum | null, content: string | null, link: string | null }, attachmentsAttached: Array<{ __typename?: 'Attachment', id: string, processed: boolean, fileTag: string | null, fileData: any | null, filename: string | null, urls: { __typename?: 'AttachmentUrl', large: string | null, medium: string | null, original: string | null, small: string | null, imagePreview: string | null, originalDirectDownload: string | null, video480p: string | null, video720p: string | null, video1080p: string | null } | null, metadata: { __typename?: 'AttachmentMetadata', intendedUse: string | null } | null }> }>, metadata: { __typename?: 'CollectionMetadata', currentPage: number, limitValue: number, totalCount: number, totalPages: number } }, allTemplates: { __typename?: 'WidgetTemplateCollection', collection: Array<{ __typename?: 'WidgetTemplate', id: string }> }, publicTemplates: { __typename?: 'WidgetTemplateCollection', collection: Array<{ __typename?: 'WidgetTemplate', id: string }> }, privateTemplates: { __typename?: 'WidgetTemplateCollection', collection: Array<{ __typename?: 'WidgetTemplate', id: string }> } };

export type HomePageBulkUpdateMutationVariables = Exact<{
  attributes: Array<HomePageUpdateInputObject> | HomePageUpdateInputObject;
}>;


export type HomePageBulkUpdateMutation = { __typename?: 'Mutation', data: boolean | null };

export type WidgetBulkUpdateMutationVariables = Exact<{
  homePageId: Scalars['ID']['input'];
  attributes: Array<WidgetUpdateInputObject> | WidgetUpdateInputObject;
}>;


export type WidgetBulkUpdateMutation = { __typename?: 'Mutation', data: boolean | null };

export type WidgetTemplateCreateMutationVariables = Exact<{
  attributes: WidgetTemplateCreateInputObject;
}>;


export type WidgetTemplateCreateMutation = { __typename?: 'Mutation', data: { __typename?: 'WidgetTemplate', id: string, title: string | null, description: string | null, kind: WidgetTemplatesKindEnum, visibility: WidgetTemplatesVisibilityEnum, isDefault: boolean, fields: { __typename?: 'WidgetTemplatesField', backgroundColor: ColorEnum | null, content: string | null, link: string | null }, attachmentsAttached: Array<{ __typename?: 'Attachment', id: string, processed: boolean, fileTag: string | null, fileData: any | null, filename: string | null, urls: { __typename?: 'AttachmentUrl', large: string | null, medium: string | null, original: string | null, small: string | null, imagePreview: string | null, originalDirectDownload: string | null, video480p: string | null, video720p: string | null, video1080p: string | null } | null, metadata: { __typename?: 'AttachmentMetadata', intendedUse: string | null } | null }> } | null };

export type WidgetTemplateDestroyMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type WidgetTemplateDestroyMutation = { __typename?: 'Mutation', data: boolean | null };

export type WidgetTemplateUpdateMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  attributes: WidgetTemplateUpdateInputObject;
}>;


export type WidgetTemplateUpdateMutation = { __typename?: 'Mutation', data: { __typename?: 'WidgetTemplate', id: string, title: string | null, description: string | null, kind: WidgetTemplatesKindEnum, visibility: WidgetTemplatesVisibilityEnum, isDefault: boolean, fields: { __typename?: 'WidgetTemplatesField', backgroundColor: ColorEnum | null, content: string | null, link: string | null }, attachmentsAttached: Array<{ __typename?: 'Attachment', id: string, processed: boolean, fileTag: string | null, fileData: any | null, filename: string | null, urls: { __typename?: 'AttachmentUrl', large: string | null, medium: string | null, original: string | null, small: string | null, imagePreview: string | null, originalDirectDownload: string | null, video480p: string | null, video720p: string | null, video1080p: string | null } | null, metadata: { __typename?: 'AttachmentMetadata', intendedUse: string | null } | null }> } | null };

export type InterventionCategoryFragmentFragment = { __typename?: 'InterventionCategory', id: string, name: string, color: ColorEnum, description: string | null };

export type InterventionFragmentFragment = { __typename?: 'Intervention', id: string, name: string, code: string | null, description: string | null, priority: InterventionPriorityEnum, status: InterventionStatusEnum, estimatedDate: any | null, totalLogisticTime: number | null, totalEstimatedTime: number | null, estimatedTime: number | null, logisticTime: number | null, durationTime: number | null, totalTime: number | null, createdAt: any, attachmentsAttached: Array<{ __typename?: 'Attachment', id: string, processed: boolean, fileTag: string | null, fileData: any | null, filename: string | null, urls: { __typename?: 'AttachmentUrl', large: string | null, medium: string | null, original: string | null, small: string | null, imagePreview: string | null, originalDirectDownload: string | null, video480p: string | null, video720p: string | null, video1080p: string | null } | null, metadata: { __typename?: 'AttachmentMetadata', intendedUse: string | null } | null }>, category: { __typename?: 'InterventionCategory', id: string, name: string, color: ColorEnum } | null, site: { __typename?: 'Site', id: string, name: string } | null, siteArea: { __typename?: 'SiteArea', id: string, name: string } | null, asset: { __typename?: 'Asset', id: string, name: string, fullCode: string, iconAttached: { __typename?: 'Attachment', id: string, processed: boolean, fileTag: string | null, fileData: any | null, filename: string | null, urls: { __typename?: 'AttachmentUrl', large: string | null, medium: string | null, original: string | null, small: string | null, imagePreview: string | null, originalDirectDownload: string | null, video480p: string | null, video720p: string | null, video1080p: string | null } | null, metadata: { __typename?: 'AttachmentMetadata', intendedUse: string | null } | null } | null } | null, task: { __typename?: 'Task', id: string, name: string } | null, supervisor: { __typename?: 'User', id: string, firstName: string, lastName: string, avatarAttached: { __typename?: 'Attachment', id: string, processed: boolean, fileTag: string | null, fileData: any | null, filename: string | null, urls: { __typename?: 'AttachmentUrl', large: string | null, medium: string | null, original: string | null, small: string | null, imagePreview: string | null, originalDirectDownload: string | null, video480p: string | null, video720p: string | null, video1080p: string | null } | null, metadata: { __typename?: 'AttachmentMetadata', intendedUse: string | null } | null } | null } | null, createdBy: { __typename?: 'User', id: string, firstName: string, lastName: string, avatarAttached: { __typename?: 'Attachment', id: string, processed: boolean, fileTag: string | null, fileData: any | null, filename: string | null, urls: { __typename?: 'AttachmentUrl', large: string | null, medium: string | null, original: string | null, small: string | null, imagePreview: string | null, originalDirectDownload: string | null, video480p: string | null, video720p: string | null, video1080p: string | null } | null, metadata: { __typename?: 'AttachmentMetadata', intendedUse: string | null } | null } | null } | null, canDestroy: { __typename?: 'AuthorizationResult', value: boolean, message: string | null, reasons: { __typename?: 'FailureReasons', details: string, fullMessages: Array<string> } | null }, canClose: { __typename?: 'AuthorizationResult', value: boolean, message: string | null, reasons: { __typename?: 'FailureReasons', details: string, fullMessages: Array<string> } | null }, canUpdate: { __typename?: 'AuthorizationResult', value: boolean, message: string | null, reasons: { __typename?: 'FailureReasons', details: string, fullMessages: Array<string> } | null }, canCreateAction: { __typename?: 'AuthorizationResult', value: boolean, message: string | null, reasons: { __typename?: 'FailureReasons', details: string, fullMessages: Array<string> } | null } };

export type InterventionActionFragmentFragment = { __typename?: 'InterventionAction', id: string, text: string | null, status: InterventionActionStatusEnum, createdAt: any, updatedAt: any, interventionId: string | null, closedAt: any | null, estimatedDate: any | null, estimatedTime: number | null, logisticTime: number | null, durationTime: number | null, createdBy: { __typename?: 'User', id: string, firstName: string, lastName: string, avatarAttached: { __typename?: 'Attachment', id: string, processed: boolean, fileTag: string | null, fileData: any | null, filename: string | null, urls: { __typename?: 'AttachmentUrl', large: string | null, medium: string | null, original: string | null, small: string | null, imagePreview: string | null, originalDirectDownload: string | null, video480p: string | null, video720p: string | null, video1080p: string | null } | null, metadata: { __typename?: 'AttachmentMetadata', intendedUse: string | null } | null } | null } | null, attachmentsAttached: Array<{ __typename?: 'Attachment', id: string, processed: boolean, fileTag: string | null, fileData: any | null, filename: string | null, urls: { __typename?: 'AttachmentUrl', large: string | null, medium: string | null, original: string | null, small: string | null, imagePreview: string | null, originalDirectDownload: string | null, video480p: string | null, video720p: string | null, video1080p: string | null } | null, metadata: { __typename?: 'AttachmentMetadata', intendedUse: string | null } | null }>, canUpdate: { __typename?: 'AuthorizationResult', value: boolean, message: string | null, reasons: { __typename?: 'FailureReasons', details: string, fullMessages: Array<string> } | null }, canDestroy: { __typename?: 'AuthorizationResult', value: boolean, message: string | null, reasons: { __typename?: 'FailureReasons', details: string, fullMessages: Array<string> } | null } };

export type InterventionsQueryVariables = Exact<{
  page?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  sorts?: InputMaybe<InterventionSortInputObject>;
  filters?: InputMaybe<Array<InterventionFilterInputObject> | InterventionFilterInputObject>;
  scopeName: InterventionScopeNameEnum;
}>;


export type InterventionsQuery = { __typename?: 'Query', data: { __typename?: 'InterventionCollection', collection: Array<{ __typename?: 'Intervention', id: string, name: string, createdAt: any, closedAt: any | null, code: string | null, priority: InterventionPriorityEnum, status: InterventionStatusEnum, category: { __typename?: 'InterventionCategory', id: string, name: string, color: ColorEnum } | null, site: { __typename?: 'Site', id: string, name: string } | null, siteArea: { __typename?: 'SiteArea', id: string, name: string } | null, asset: { __typename?: 'Asset', id: string, name: string, fullCode: string, iconAttached: { __typename?: 'Attachment', id: string, processed: boolean, fileTag: string | null, fileData: any | null, filename: string | null, urls: { __typename?: 'AttachmentUrl', large: string | null, medium: string | null, original: string | null, small: string | null, imagePreview: string | null, originalDirectDownload: string | null, video480p: string | null, video720p: string | null, video1080p: string | null } | null, metadata: { __typename?: 'AttachmentMetadata', intendedUse: string | null } | null } | null } | null, canUpdate: { __typename?: 'AuthorizationResult', value: boolean, message: string | null, reasons: { __typename?: 'FailureReasons', details: string, fullMessages: Array<string> } | null }, canDestroy: { __typename?: 'AuthorizationResult', value: boolean, message: string | null, reasons: { __typename?: 'FailureReasons', details: string, fullMessages: Array<string> } | null }, canClose: { __typename?: 'AuthorizationResult', value: boolean, message: string | null, reasons: { __typename?: 'FailureReasons', details: string, fullMessages: Array<string> } | null } }>, metadata: { __typename?: 'CollectionMetadata', currentPage: number, limitValue: number, totalCount: number, totalPages: number } }, openedCounter: { __typename?: 'InterventionCollection', metadata: { __typename?: 'CollectionMetadata', totalCount: number } }, closedCounter: { __typename?: 'InterventionCollection', metadata: { __typename?: 'CollectionMetadata', totalCount: number } } };

export type InterventionsIdsQueryVariables = Exact<{
  page?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  sorts?: InputMaybe<InterventionSortInputObject>;
  filters?: InputMaybe<Array<InterventionFilterInputObject> | InterventionFilterInputObject>;
  scopeName: InterventionScopeNameEnum;
  onlyIds?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type InterventionsIdsQuery = { __typename?: 'Query', data: { __typename?: 'InterventionCollection', collection: Array<{ __typename?: 'Intervention', id: string }> } };

export type InterventionsSearchListQueryVariables = Exact<{
  page?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  sorts?: InputMaybe<InterventionSortInputObject>;
  filters?: InputMaybe<Array<InterventionFilterInputObject> | InterventionFilterInputObject>;
  scopeName: InterventionScopeNameEnum;
}>;


export type InterventionsSearchListQuery = { __typename?: 'Query', data: { __typename?: 'InterventionCollection', collection: Array<{ __typename?: 'Intervention', id: string, name: string, code: string | null }>, metadata: { __typename?: 'CollectionMetadata', currentPage: number, limitValue: number, totalCount: number, totalPages: number } } };

export type InterventionQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type InterventionQuery = { __typename?: 'Query', data: { __typename?: 'Intervention', id: string, name: string, code: string | null, description: string | null, priority: InterventionPriorityEnum, status: InterventionStatusEnum, estimatedDate: any | null, totalLogisticTime: number | null, totalEstimatedTime: number | null, estimatedTime: number | null, logisticTime: number | null, durationTime: number | null, totalTime: number | null, createdAt: any, attachmentsAttached: Array<{ __typename?: 'Attachment', id: string, processed: boolean, fileTag: string | null, fileData: any | null, filename: string | null, urls: { __typename?: 'AttachmentUrl', large: string | null, medium: string | null, original: string | null, small: string | null, imagePreview: string | null, originalDirectDownload: string | null, video480p: string | null, video720p: string | null, video1080p: string | null } | null, metadata: { __typename?: 'AttachmentMetadata', intendedUse: string | null } | null }>, category: { __typename?: 'InterventionCategory', id: string, name: string, color: ColorEnum } | null, site: { __typename?: 'Site', id: string, name: string } | null, siteArea: { __typename?: 'SiteArea', id: string, name: string } | null, asset: { __typename?: 'Asset', id: string, name: string, fullCode: string, iconAttached: { __typename?: 'Attachment', id: string, processed: boolean, fileTag: string | null, fileData: any | null, filename: string | null, urls: { __typename?: 'AttachmentUrl', large: string | null, medium: string | null, original: string | null, small: string | null, imagePreview: string | null, originalDirectDownload: string | null, video480p: string | null, video720p: string | null, video1080p: string | null } | null, metadata: { __typename?: 'AttachmentMetadata', intendedUse: string | null } | null } | null } | null, task: { __typename?: 'Task', id: string, name: string } | null, supervisor: { __typename?: 'User', id: string, firstName: string, lastName: string, avatarAttached: { __typename?: 'Attachment', id: string, processed: boolean, fileTag: string | null, fileData: any | null, filename: string | null, urls: { __typename?: 'AttachmentUrl', large: string | null, medium: string | null, original: string | null, small: string | null, imagePreview: string | null, originalDirectDownload: string | null, video480p: string | null, video720p: string | null, video1080p: string | null } | null, metadata: { __typename?: 'AttachmentMetadata', intendedUse: string | null } | null } | null } | null, createdBy: { __typename?: 'User', id: string, firstName: string, lastName: string, avatarAttached: { __typename?: 'Attachment', id: string, processed: boolean, fileTag: string | null, fileData: any | null, filename: string | null, urls: { __typename?: 'AttachmentUrl', large: string | null, medium: string | null, original: string | null, small: string | null, imagePreview: string | null, originalDirectDownload: string | null, video480p: string | null, video720p: string | null, video1080p: string | null } | null, metadata: { __typename?: 'AttachmentMetadata', intendedUse: string | null } | null } | null } | null, canDestroy: { __typename?: 'AuthorizationResult', value: boolean, message: string | null, reasons: { __typename?: 'FailureReasons', details: string, fullMessages: Array<string> } | null }, canClose: { __typename?: 'AuthorizationResult', value: boolean, message: string | null, reasons: { __typename?: 'FailureReasons', details: string, fullMessages: Array<string> } | null }, canUpdate: { __typename?: 'AuthorizationResult', value: boolean, message: string | null, reasons: { __typename?: 'FailureReasons', details: string, fullMessages: Array<string> } | null }, canCreateAction: { __typename?: 'AuthorizationResult', value: boolean, message: string | null, reasons: { __typename?: 'FailureReasons', details: string, fullMessages: Array<string> } | null } } | null, actionsCounter: { __typename?: 'InterventionActionCollection', metadata: { __typename?: 'CollectionMetadata', totalCount: number } } };

export type InterventionSiteIdQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type InterventionSiteIdQuery = { __typename?: 'Query', data: { __typename?: 'Intervention', id: string, siteId: string | null, categoryId: string | null } | null };

export type InterventionCategoryQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type InterventionCategoryQuery = { __typename?: 'Query', data: { __typename?: 'InterventionCategory', id: string, name: string, color: ColorEnum, description: string | null } | null };

export type InterventionCategoriesQueryVariables = Exact<{
  page?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  filters?: InputMaybe<Array<InterventionCategoryFilterInputObject> | InterventionCategoryFilterInputObject>;
  sorts?: InputMaybe<InterventionCategorySortInputObject>;
}>;


export type InterventionCategoriesQuery = { __typename?: 'Query', data: { __typename?: 'InterventionCategoryCollection', collection: Array<{ __typename?: 'InterventionCategory', visibleInterventionsCount: number, id: string, name: string, color: ColorEnum, description: string | null, interventions: { __typename?: 'InterventionCollection', collection: Array<{ __typename?: 'Intervention', id: string, name: string }> }, canDestroy: { __typename?: 'AuthorizationResult', value: boolean, message: string | null, reasons: { __typename?: 'FailureReasons', details: string, fullMessages: Array<string> } | null } }>, metadata: { __typename?: 'CollectionMetadata', currentPage: number, limitValue: number, totalCount: number, totalPages: number } } };

export type InterventionCategoriesSearchListQueryVariables = Exact<{
  page?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  filters?: InputMaybe<Array<InterventionCategoryFilterInputObject> | InterventionCategoryFilterInputObject>;
  sorts?: InputMaybe<InterventionCategorySortInputObject>;
}>;


export type InterventionCategoriesSearchListQuery = { __typename?: 'Query', data: { __typename?: 'InterventionCategoryCollection', collection: Array<{ __typename?: 'InterventionCategory', id: string, name: string, color: ColorEnum, description: string | null }>, metadata: { __typename?: 'CollectionMetadata', currentPage: number, limitValue: number, totalCount: number, totalPages: number } } };

export type InterventionActionQueryVariables = Exact<{
  interventionId: Scalars['ID']['input'];
  id: Scalars['ID']['input'];
}>;


export type InterventionActionQuery = { __typename?: 'Query', data: { __typename?: 'InterventionAction', id: string, text: string | null, status: InterventionActionStatusEnum, createdAt: any, updatedAt: any, interventionId: string | null, closedAt: any | null, estimatedDate: any | null, estimatedTime: number | null, logisticTime: number | null, durationTime: number | null, createdBy: { __typename?: 'User', id: string, firstName: string, lastName: string, avatarAttached: { __typename?: 'Attachment', id: string, processed: boolean, fileTag: string | null, fileData: any | null, filename: string | null, urls: { __typename?: 'AttachmentUrl', large: string | null, medium: string | null, original: string | null, small: string | null, imagePreview: string | null, originalDirectDownload: string | null, video480p: string | null, video720p: string | null, video1080p: string | null } | null, metadata: { __typename?: 'AttachmentMetadata', intendedUse: string | null } | null } | null } | null, attachmentsAttached: Array<{ __typename?: 'Attachment', id: string, processed: boolean, fileTag: string | null, fileData: any | null, filename: string | null, urls: { __typename?: 'AttachmentUrl', large: string | null, medium: string | null, original: string | null, small: string | null, imagePreview: string | null, originalDirectDownload: string | null, video480p: string | null, video720p: string | null, video1080p: string | null } | null, metadata: { __typename?: 'AttachmentMetadata', intendedUse: string | null } | null }>, canUpdate: { __typename?: 'AuthorizationResult', value: boolean, message: string | null, reasons: { __typename?: 'FailureReasons', details: string, fullMessages: Array<string> } | null }, canDestroy: { __typename?: 'AuthorizationResult', value: boolean, message: string | null, reasons: { __typename?: 'FailureReasons', details: string, fullMessages: Array<string> } | null } } | null };

export type InterventionActionHistoriesQueryVariables = Exact<{
  page?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  sourceableId: Scalars['ID']['input'];
  sourceableType: HistorySourceableTypeEnum;
  sorts?: InputMaybe<HistorySortInputObject>;
}>;


export type InterventionActionHistoriesQuery = { __typename?: 'Query', data: { __typename?: 'HistoryCollection', collection: Array<{ __typename?: 'History', id: string, kind: HistoryKindEnum, system: boolean | null, occurredAt: any, data: { __typename: 'DocumentationHistoryData' } | { __typename: 'InterventionActionHistoryData', durationTime: Array<number | null> | null, estimatedDate: Array<any | null> | null, estimatedTime: Array<number | null> | null, logisticTime: Array<number | null> | null, status: Array<InterventionActionStatusEnum> | null } | null, metadata: { __typename: 'InterventionActionHistoryMetadata', reason: HistoryInterventionActionHistoryMetadataReasonEnum | null } | null, user: { __typename?: 'User', id: string, firstName: string, lastName: string, email: string | null, avatarAttached: { __typename?: 'Attachment', id: string, processed: boolean, fileTag: string | null, fileData: any | null, filename: string | null, urls: { __typename?: 'AttachmentUrl', large: string | null, medium: string | null, original: string | null, small: string | null, imagePreview: string | null, originalDirectDownload: string | null, video480p: string | null, video720p: string | null, video1080p: string | null } | null, metadata: { __typename?: 'AttachmentMetadata', intendedUse: string | null } | null } | null } | null }>, metadata: { __typename?: 'CollectionMetadata', currentPage: number, limitValue: number, totalCount: number, totalPages: number } } };

export type InterventionActionsQueryVariables = Exact<{
  interventionId: Scalars['ID']['input'];
  page?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  sorts?: InputMaybe<InterventionActionSortInputObject>;
  filters?: InputMaybe<Array<InterventionActionFilterInputObject> | InterventionActionFilterInputObject>;
}>;


export type InterventionActionsQuery = { __typename?: 'Query', data: { __typename?: 'InterventionActionCollection', collection: Array<{ __typename?: 'InterventionAction', id: string, text: string | null, status: InterventionActionStatusEnum, createdAt: any, updatedAt: any, interventionId: string | null, closedAt: any | null, estimatedDate: any | null, estimatedTime: number | null, logisticTime: number | null, durationTime: number | null, createdBy: { __typename?: 'User', id: string, firstName: string, lastName: string, avatarAttached: { __typename?: 'Attachment', id: string, processed: boolean, fileTag: string | null, fileData: any | null, filename: string | null, urls: { __typename?: 'AttachmentUrl', large: string | null, medium: string | null, original: string | null, small: string | null, imagePreview: string | null, originalDirectDownload: string | null, video480p: string | null, video720p: string | null, video1080p: string | null } | null, metadata: { __typename?: 'AttachmentMetadata', intendedUse: string | null } | null } | null } | null, attachmentsAttached: Array<{ __typename?: 'Attachment', id: string, processed: boolean, fileTag: string | null, fileData: any | null, filename: string | null, urls: { __typename?: 'AttachmentUrl', large: string | null, medium: string | null, original: string | null, small: string | null, imagePreview: string | null, originalDirectDownload: string | null, video480p: string | null, video720p: string | null, video1080p: string | null } | null, metadata: { __typename?: 'AttachmentMetadata', intendedUse: string | null } | null }>, canUpdate: { __typename?: 'AuthorizationResult', value: boolean, message: string | null, reasons: { __typename?: 'FailureReasons', details: string, fullMessages: Array<string> } | null }, canDestroy: { __typename?: 'AuthorizationResult', value: boolean, message: string | null, reasons: { __typename?: 'FailureReasons', details: string, fullMessages: Array<string> } | null } }>, metadata: { __typename?: 'CollectionMetadata', currentPage: number, limitValue: number, totalCount: number, totalPages: number } } };

export type InterventionActionIdsQueryVariables = Exact<{
  interventionId: Scalars['ID']['input'];
  page?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  sorts?: InputMaybe<InterventionActionSortInputObject>;
  filters?: InputMaybe<Array<InterventionActionFilterInputObject> | InterventionActionFilterInputObject>;
  onlyIds?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type InterventionActionIdsQuery = { __typename?: 'Query', data: { __typename?: 'InterventionActionCollection', collection: Array<{ __typename?: 'InterventionAction', id: string }> } };

export type InterventionSitePrefillDataQueryVariables = Exact<{
  siteFindBy: SiteFindByInputObject;
}>;


export type InterventionSitePrefillDataQuery = { __typename?: 'Query', site: { __typename?: 'Site', id: string, name: string } | null };

export type InterventionSiteAreaPrefillDataQueryVariables = Exact<{
  siteFindBy: SiteFindByInputObject;
  siteAreaFindBy: SiteAreaFindByInputObject;
}>;


export type InterventionSiteAreaPrefillDataQuery = { __typename?: 'Query', siteArea: { __typename?: 'SiteArea', address: string | null, code: string, description: string | null, fullCode: string, id: string, name: string, poorWifi: boolean, canDestroy: { __typename?: 'AuthorizationResult', value: boolean, message: string | null, reasons: { __typename?: 'FailureReasons', details: string, fullMessages: Array<string> } | null } } | null };

export type InterventionAssetPrefillDataQueryVariables = Exact<{
  assetFindBy: AssetFindByInputObject;
}>;


export type InterventionAssetPrefillDataQuery = { __typename?: 'Query', asset: { __typename?: 'Asset', id: string, name: string, fullCode: string, siteAreaId: string | null, iconAttached: { __typename?: 'Attachment', id: string, processed: boolean, fileTag: string | null, fileData: any | null, filename: string | null, urls: { __typename?: 'AttachmentUrl', large: string | null, medium: string | null, original: string | null, small: string | null, imagePreview: string | null, originalDirectDownload: string | null, video480p: string | null, video720p: string | null, video1080p: string | null } | null, metadata: { __typename?: 'AttachmentMetadata', intendedUse: string | null } | null } | null } | null };

export type InterventionTaskPrefillDataQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type InterventionTaskPrefillDataQuery = { __typename?: 'Query', task: { __typename?: 'Task', id: string, name: string } | null };

export type InterventionCreateMutationVariables = Exact<{
  attributes: InterventionCreateInputObject;
  assigneeRedirectUrl: Scalars['String']['input'];
}>;


export type InterventionCreateMutation = { __typename?: 'Mutation', data: { __typename?: 'Intervention', id: string, name: string, code: string | null, description: string | null, priority: InterventionPriorityEnum, status: InterventionStatusEnum, estimatedDate: any | null, totalLogisticTime: number | null, totalEstimatedTime: number | null, estimatedTime: number | null, logisticTime: number | null, durationTime: number | null, totalTime: number | null, createdAt: any, attachmentsAttached: Array<{ __typename?: 'Attachment', id: string, processed: boolean, fileTag: string | null, fileData: any | null, filename: string | null, urls: { __typename?: 'AttachmentUrl', large: string | null, medium: string | null, original: string | null, small: string | null, imagePreview: string | null, originalDirectDownload: string | null, video480p: string | null, video720p: string | null, video1080p: string | null } | null, metadata: { __typename?: 'AttachmentMetadata', intendedUse: string | null } | null }>, category: { __typename?: 'InterventionCategory', id: string, name: string, color: ColorEnum } | null, site: { __typename?: 'Site', id: string, name: string } | null, siteArea: { __typename?: 'SiteArea', id: string, name: string } | null, asset: { __typename?: 'Asset', id: string, name: string, fullCode: string, iconAttached: { __typename?: 'Attachment', id: string, processed: boolean, fileTag: string | null, fileData: any | null, filename: string | null, urls: { __typename?: 'AttachmentUrl', large: string | null, medium: string | null, original: string | null, small: string | null, imagePreview: string | null, originalDirectDownload: string | null, video480p: string | null, video720p: string | null, video1080p: string | null } | null, metadata: { __typename?: 'AttachmentMetadata', intendedUse: string | null } | null } | null } | null, task: { __typename?: 'Task', id: string, name: string } | null, supervisor: { __typename?: 'User', id: string, firstName: string, lastName: string, avatarAttached: { __typename?: 'Attachment', id: string, processed: boolean, fileTag: string | null, fileData: any | null, filename: string | null, urls: { __typename?: 'AttachmentUrl', large: string | null, medium: string | null, original: string | null, small: string | null, imagePreview: string | null, originalDirectDownload: string | null, video480p: string | null, video720p: string | null, video1080p: string | null } | null, metadata: { __typename?: 'AttachmentMetadata', intendedUse: string | null } | null } | null } | null, createdBy: { __typename?: 'User', id: string, firstName: string, lastName: string, avatarAttached: { __typename?: 'Attachment', id: string, processed: boolean, fileTag: string | null, fileData: any | null, filename: string | null, urls: { __typename?: 'AttachmentUrl', large: string | null, medium: string | null, original: string | null, small: string | null, imagePreview: string | null, originalDirectDownload: string | null, video480p: string | null, video720p: string | null, video1080p: string | null } | null, metadata: { __typename?: 'AttachmentMetadata', intendedUse: string | null } | null } | null } | null, canDestroy: { __typename?: 'AuthorizationResult', value: boolean, message: string | null, reasons: { __typename?: 'FailureReasons', details: string, fullMessages: Array<string> } | null }, canClose: { __typename?: 'AuthorizationResult', value: boolean, message: string | null, reasons: { __typename?: 'FailureReasons', details: string, fullMessages: Array<string> } | null }, canUpdate: { __typename?: 'AuthorizationResult', value: boolean, message: string | null, reasons: { __typename?: 'FailureReasons', details: string, fullMessages: Array<string> } | null }, canCreateAction: { __typename?: 'AuthorizationResult', value: boolean, message: string | null, reasons: { __typename?: 'FailureReasons', details: string, fullMessages: Array<string> } | null } } | null };

export type InterventionUpdateMutationVariables = Exact<{
  attributes: InterventionUpdateInputObject;
  id: Scalars['ID']['input'];
  assigneeRedirectUrl: Scalars['String']['input'];
}>;


export type InterventionUpdateMutation = { __typename?: 'Mutation', data: { __typename?: 'Intervention', id: string, name: string, code: string | null, description: string | null, priority: InterventionPriorityEnum, status: InterventionStatusEnum, estimatedDate: any | null, totalLogisticTime: number | null, totalEstimatedTime: number | null, estimatedTime: number | null, logisticTime: number | null, durationTime: number | null, totalTime: number | null, createdAt: any, attachmentsAttached: Array<{ __typename?: 'Attachment', id: string, processed: boolean, fileTag: string | null, fileData: any | null, filename: string | null, urls: { __typename?: 'AttachmentUrl', large: string | null, medium: string | null, original: string | null, small: string | null, imagePreview: string | null, originalDirectDownload: string | null, video480p: string | null, video720p: string | null, video1080p: string | null } | null, metadata: { __typename?: 'AttachmentMetadata', intendedUse: string | null } | null }>, category: { __typename?: 'InterventionCategory', id: string, name: string, color: ColorEnum } | null, site: { __typename?: 'Site', id: string, name: string } | null, siteArea: { __typename?: 'SiteArea', id: string, name: string } | null, asset: { __typename?: 'Asset', id: string, name: string, fullCode: string, iconAttached: { __typename?: 'Attachment', id: string, processed: boolean, fileTag: string | null, fileData: any | null, filename: string | null, urls: { __typename?: 'AttachmentUrl', large: string | null, medium: string | null, original: string | null, small: string | null, imagePreview: string | null, originalDirectDownload: string | null, video480p: string | null, video720p: string | null, video1080p: string | null } | null, metadata: { __typename?: 'AttachmentMetadata', intendedUse: string | null } | null } | null } | null, task: { __typename?: 'Task', id: string, name: string } | null, supervisor: { __typename?: 'User', id: string, firstName: string, lastName: string, avatarAttached: { __typename?: 'Attachment', id: string, processed: boolean, fileTag: string | null, fileData: any | null, filename: string | null, urls: { __typename?: 'AttachmentUrl', large: string | null, medium: string | null, original: string | null, small: string | null, imagePreview: string | null, originalDirectDownload: string | null, video480p: string | null, video720p: string | null, video1080p: string | null } | null, metadata: { __typename?: 'AttachmentMetadata', intendedUse: string | null } | null } | null } | null, createdBy: { __typename?: 'User', id: string, firstName: string, lastName: string, avatarAttached: { __typename?: 'Attachment', id: string, processed: boolean, fileTag: string | null, fileData: any | null, filename: string | null, urls: { __typename?: 'AttachmentUrl', large: string | null, medium: string | null, original: string | null, small: string | null, imagePreview: string | null, originalDirectDownload: string | null, video480p: string | null, video720p: string | null, video1080p: string | null } | null, metadata: { __typename?: 'AttachmentMetadata', intendedUse: string | null } | null } | null } | null, canDestroy: { __typename?: 'AuthorizationResult', value: boolean, message: string | null, reasons: { __typename?: 'FailureReasons', details: string, fullMessages: Array<string> } | null }, canClose: { __typename?: 'AuthorizationResult', value: boolean, message: string | null, reasons: { __typename?: 'FailureReasons', details: string, fullMessages: Array<string> } | null }, canUpdate: { __typename?: 'AuthorizationResult', value: boolean, message: string | null, reasons: { __typename?: 'FailureReasons', details: string, fullMessages: Array<string> } | null }, canCreateAction: { __typename?: 'AuthorizationResult', value: boolean, message: string | null, reasons: { __typename?: 'FailureReasons', details: string, fullMessages: Array<string> } | null } } | null };

export type InterventionDestroyMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type InterventionDestroyMutation = { __typename?: 'Mutation', interventionDestroy: boolean | null };

export type InterventionBulkCloseMutationVariables = Exact<{
  ids: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;


export type InterventionBulkCloseMutation = { __typename?: 'Mutation', interventionBulkClose: boolean | null };

export type InterventionCategoryCreateMutationVariables = Exact<{
  attributes: InterventionCategoryCreateInputObject;
}>;


export type InterventionCategoryCreateMutation = { __typename?: 'Mutation', data: { __typename?: 'InterventionCategory', id: string, name: string, color: ColorEnum, description: string | null } | null };

export type InterventionCategoryUpdateMutationVariables = Exact<{
  attributes: InterventionCategoryUpdateInputObject;
  id: Scalars['ID']['input'];
}>;


export type InterventionCategoryUpdateMutation = { __typename?: 'Mutation', data: { __typename?: 'InterventionCategory', id: string, name: string, color: ColorEnum, description: string | null } | null };

export type InterventionCategoryDestroyMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type InterventionCategoryDestroyMutation = { __typename?: 'Mutation', interventionCategoryDestroy: boolean | null };

export type InterventionActionCreateMutationVariables = Exact<{
  attributes: InterventionActionCreateInputObject;
  assigneeRedirectUrl: Scalars['String']['input'];
  mentionRedirectUrl: Scalars['String']['input'];
  interventionId: Scalars['ID']['input'];
}>;


export type InterventionActionCreateMutation = { __typename?: 'Mutation', data: { __typename?: 'InterventionAction', id: string, text: string | null, status: InterventionActionStatusEnum, createdAt: any, updatedAt: any, interventionId: string | null, closedAt: any | null, estimatedDate: any | null, estimatedTime: number | null, logisticTime: number | null, durationTime: number | null, createdBy: { __typename?: 'User', id: string, firstName: string, lastName: string, avatarAttached: { __typename?: 'Attachment', id: string, processed: boolean, fileTag: string | null, fileData: any | null, filename: string | null, urls: { __typename?: 'AttachmentUrl', large: string | null, medium: string | null, original: string | null, small: string | null, imagePreview: string | null, originalDirectDownload: string | null, video480p: string | null, video720p: string | null, video1080p: string | null } | null, metadata: { __typename?: 'AttachmentMetadata', intendedUse: string | null } | null } | null } | null, attachmentsAttached: Array<{ __typename?: 'Attachment', id: string, processed: boolean, fileTag: string | null, fileData: any | null, filename: string | null, urls: { __typename?: 'AttachmentUrl', large: string | null, medium: string | null, original: string | null, small: string | null, imagePreview: string | null, originalDirectDownload: string | null, video480p: string | null, video720p: string | null, video1080p: string | null } | null, metadata: { __typename?: 'AttachmentMetadata', intendedUse: string | null } | null }>, canUpdate: { __typename?: 'AuthorizationResult', value: boolean, message: string | null, reasons: { __typename?: 'FailureReasons', details: string, fullMessages: Array<string> } | null }, canDestroy: { __typename?: 'AuthorizationResult', value: boolean, message: string | null, reasons: { __typename?: 'FailureReasons', details: string, fullMessages: Array<string> } | null } } | null };

export type InterventionActionUpdateMutationVariables = Exact<{
  attributes: InterventionActionUpdateInputObject;
  id: Scalars['ID']['input'];
  assigneeRedirectUrl: Scalars['String']['input'];
  mentionRedirectUrl: Scalars['String']['input'];
  interventionId: Scalars['ID']['input'];
}>;


export type InterventionActionUpdateMutation = { __typename?: 'Mutation', data: { __typename?: 'InterventionAction', id: string, text: string | null, status: InterventionActionStatusEnum, createdAt: any, updatedAt: any, interventionId: string | null, closedAt: any | null, estimatedDate: any | null, estimatedTime: number | null, logisticTime: number | null, durationTime: number | null, createdBy: { __typename?: 'User', id: string, firstName: string, lastName: string, avatarAttached: { __typename?: 'Attachment', id: string, processed: boolean, fileTag: string | null, fileData: any | null, filename: string | null, urls: { __typename?: 'AttachmentUrl', large: string | null, medium: string | null, original: string | null, small: string | null, imagePreview: string | null, originalDirectDownload: string | null, video480p: string | null, video720p: string | null, video1080p: string | null } | null, metadata: { __typename?: 'AttachmentMetadata', intendedUse: string | null } | null } | null } | null, attachmentsAttached: Array<{ __typename?: 'Attachment', id: string, processed: boolean, fileTag: string | null, fileData: any | null, filename: string | null, urls: { __typename?: 'AttachmentUrl', large: string | null, medium: string | null, original: string | null, small: string | null, imagePreview: string | null, originalDirectDownload: string | null, video480p: string | null, video720p: string | null, video1080p: string | null } | null, metadata: { __typename?: 'AttachmentMetadata', intendedUse: string | null } | null }>, canUpdate: { __typename?: 'AuthorizationResult', value: boolean, message: string | null, reasons: { __typename?: 'FailureReasons', details: string, fullMessages: Array<string> } | null }, canDestroy: { __typename?: 'AuthorizationResult', value: boolean, message: string | null, reasons: { __typename?: 'FailureReasons', details: string, fullMessages: Array<string> } | null } } | null };

export type InterventionActionDestroyMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  interventionId: Scalars['ID']['input'];
}>;


export type InterventionActionDestroyMutation = { __typename?: 'Mutation', interventionActionDestroy: boolean | null };

export type SectorFragmentFragment = { __typename?: 'Sector', id: string, code: string | null, name: string | null, color: ColorEnum | null, readOnly: boolean, canDestroy: { __typename?: 'AuthorizationResult', value: boolean, message: string | null, reasons: { __typename?: 'FailureReasons', details: string, fullMessages: Array<string> } | null } };

export type SectorFullFragmentFragment = { __typename?: 'Sector', id: string, code: string | null, name: string | null, color: ColorEnum | null, readOnly: boolean, locationBoundary: { __typename?: 'Location', kind: string, id: string, geojson: { __typename?: 'GeojsonFeatureCollection', type: GeojsonFeatureCollectionTypeEnum, features: Array<{ __typename?: 'GeojsonFeature', type: GeojsonFeatureTypeEnum, geometry: { __typename?: 'GeojsonGeometry', coordinates: any, type: GeojsonGeometryTypeEnum }, properties: { __typename?: 'GeojsonProperties', address: string | null, addressDetails: string | null, color: ColorEnum | null, icon: string | null, shape: string | null, type: GeojsonPropertiesTypeEnum | null } | null }> } | null } | null, canDestroy: { __typename?: 'AuthorizationResult', value: boolean, message: string | null, reasons: { __typename?: 'FailureReasons', details: string, fullMessages: Array<string> } | null } };

export type SectorsQueryVariables = Exact<{
  page?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  sorts?: InputMaybe<SectorSortInputObject>;
  filters?: InputMaybe<Array<SectorFilterInputObject> | SectorFilterInputObject>;
  taskFilters?: InputMaybe<Array<TaskFilterInputObject> | TaskFilterInputObject>;
  includeFullData?: InputMaybe<Scalars['Boolean']['input']>;
  includePerformanceDataByTaskDeadlinesMissed?: InputMaybe<Scalars['Boolean']['input']>;
  includePerformanceDataByTaskResults?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type SectorsQuery = { __typename?: 'Query', data: { __typename?: 'SectorCollection', collection: Array<{ __typename?: 'Sector', id: string, name: string | null, sitesCount?: number, totalAnomaliesByTaskDeadlinesMissed?: number | null, totalAnomaliesByTaskResults?: number | null, successPercentageByTaskDeadlinesMissed?: number | null, successPercentageByTaskResults?: number | null, code: string | null, color: ColorEnum | null, readOnly: boolean, sites?: { __typename?: 'SiteCollection', collection: Array<{ __typename?: 'Site', id: string, name: string }> }, canDestroy: { __typename?: 'AuthorizationResult', value: boolean, message: string | null, reasons: { __typename?: 'FailureReasons', details: string, fullMessages: Array<string> } | null } }>, metadata: { __typename?: 'CollectionMetadata', currentPage: number, limitValue: number, totalCount: number, totalPages: number } } };

export type SectorLocationsQueryVariables = Exact<{
  filters?: InputMaybe<Array<LocationFilterInputObject> | LocationFilterInputObject>;
  sectorFilters?: InputMaybe<Array<SectorFilterInputObject> | SectorFilterInputObject>;
  mapParams: LocationMapParamsInputObject;
}>;


export type SectorLocationsQuery = { __typename?: 'Query', data: { __typename?: 'GeojsonFeatureCollection', type: GeojsonFeatureCollectionTypeEnum, features: Array<{ __typename?: 'GeojsonFeature', type: GeojsonFeatureTypeEnum, geometry: { __typename?: 'GeojsonGeometry', coordinates: any, type: GeojsonGeometryTypeEnum }, properties: { __typename?: 'GeojsonProperties', address: string | null, addressDetails: string | null, color: ColorEnum | null, icon: string | null, shape: string | null, type: GeojsonPropertiesTypeEnum | null, pointCount: number | null, sourceables: Array<{ __typename?: 'GeojsonPropertiesPolymorphicIdentity', id: string, type: GeojsonPropertiesPolymorphicIdentityTypeEnum }> | null } | null }> } | null };

export type SectorLocationCenterQueryVariables = Exact<{
  filters?: InputMaybe<Array<LocationFilterInputObject> | LocationFilterInputObject>;
  sectorFilters?: InputMaybe<Array<SectorFilterInputObject> | SectorFilterInputObject>;
}>;


export type SectorLocationCenterQuery = { __typename?: 'Query', data: { __typename?: 'LocationGeographicalCenter', lat: number | null, lon: number | null } | null };

export type SectorsSearchListQueryVariables = Exact<{
  page?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  sorts?: InputMaybe<SectorSortInputObject>;
  filters?: InputMaybe<Array<SectorFilterInputObject> | SectorFilterInputObject>;
}>;


export type SectorsSearchListQuery = { __typename?: 'Query', data: { __typename?: 'SectorCollection', collection: Array<{ __typename?: 'Sector', id: string, name: string | null, color: ColorEnum | null }>, metadata: { __typename?: 'CollectionMetadata', currentPage: number, limitValue: number, totalCount: number, totalPages: number } } };

export type SectorIdsQueryVariables = Exact<{
  filters?: InputMaybe<Array<SectorFilterInputObject> | SectorFilterInputObject>;
  sorts?: InputMaybe<SectorSortInputObject>;
}>;


export type SectorIdsQuery = { __typename?: 'Query', data: { __typename?: 'SectorCollection', collection: Array<{ __typename?: 'Sector', id: string }> } };

export type SectorsPerformanceMetricsByTaskDeadlinesMissedQueryVariables = Exact<{
  ids: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
  taskFilters?: InputMaybe<Array<TaskFilterInputObject> | TaskFilterInputObject>;
}>;


export type SectorsPerformanceMetricsByTaskDeadlinesMissedQuery = { __typename?: 'Query', data: Array<{ __typename?: 'SectorPerformanceMetricByTaskDeadlinesMissed', id: string, successPercentageByTaskDeadlinesMissed: number | null, totalAnomaliesByTaskDeadlinesMissed: number | null }> | null };

export type SectorsPerformanceMetricsByTaskDeadlinesMissedByDateQueryVariables = Exact<{
  ids: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
  taskFilters?: InputMaybe<Array<TaskFilterInputObject> | TaskFilterInputObject>;
  periodGroupBy: PeriodGroupByEnum;
}>;


export type SectorsPerformanceMetricsByTaskDeadlinesMissedByDateQuery = { __typename?: 'Query', data: Array<{ __typename?: 'SectorPerformanceMetricByTaskDeadlinesMissedByDate', id: string, period: any, totalAnomaliesByTaskDeadlinesMissed: number }> | null };

export type SectorsPerformanceMetricsByTaskResultsQueryVariables = Exact<{
  ids: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
  taskFilters?: InputMaybe<Array<TaskFilterInputObject> | TaskFilterInputObject>;
}>;


export type SectorsPerformanceMetricsByTaskResultsQuery = { __typename?: 'Query', data: Array<{ __typename?: 'SectorPerformanceMetricByTaskResults', id: string, successPercentageByTaskResults: number | null, totalAnomaliesByTaskResults: number | null }> | null };

export type SectorsPerformanceMetricsByTaskResultsByDateQueryVariables = Exact<{
  ids: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
  periodGroupBy: PeriodGroupByEnum;
  taskFilters?: InputMaybe<Array<TaskFilterInputObject> | TaskFilterInputObject>;
}>;


export type SectorsPerformanceMetricsByTaskResultsByDateQuery = { __typename?: 'Query', data: Array<{ __typename?: 'SectorPerformanceMetricByTaskResultsByDate', id: string, period: any, totalAnomaliesByTaskResults: number }> | null };

export type SectorQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type SectorQuery = { __typename?: 'Query', data: { __typename?: 'Sector', description: string | null, sitesCount: number, usersCount: number, id: string, code: string | null, name: string | null, color: ColorEnum | null, readOnly: boolean, user: { __typename?: 'User', id: string, lastName: string, firstName: string, email: string | null, phoneNumber: string | null, avatarAttached: { __typename?: 'Attachment', id: string, processed: boolean, fileTag: string | null, fileData: any | null, filename: string | null, urls: { __typename?: 'AttachmentUrl', large: string | null, medium: string | null, original: string | null, small: string | null, imagePreview: string | null, originalDirectDownload: string | null, video480p: string | null, video720p: string | null, video1080p: string | null } | null, metadata: { __typename?: 'AttachmentMetadata', intendedUse: string | null } | null } | null } | null, locationBoundary: { __typename?: 'Location', kind: string, id: string, geojson: { __typename?: 'GeojsonFeatureCollection', type: GeojsonFeatureCollectionTypeEnum, features: Array<{ __typename?: 'GeojsonFeature', type: GeojsonFeatureTypeEnum, geometry: { __typename?: 'GeojsonGeometry', coordinates: any, type: GeojsonGeometryTypeEnum }, properties: { __typename?: 'GeojsonProperties', address: string | null, addressDetails: string | null, color: ColorEnum | null, icon: string | null, shape: string | null, type: GeojsonPropertiesTypeEnum | null } | null }> } | null } | null, canDestroy: { __typename?: 'AuthorizationResult', value: boolean, message: string | null, reasons: { __typename?: 'FailureReasons', details: string, fullMessages: Array<string> } | null } } | null };

export type SectorCreateMutationVariables = Exact<{
  attributes: SectorCreateInputObject;
}>;


export type SectorCreateMutation = { __typename?: 'Mutation', data: { __typename?: 'Sector', description: string | null, id: string, code: string | null, name: string | null, color: ColorEnum | null, readOnly: boolean, locationBoundary: { __typename?: 'Location', kind: string, id: string, geojson: { __typename?: 'GeojsonFeatureCollection', type: GeojsonFeatureCollectionTypeEnum, features: Array<{ __typename?: 'GeojsonFeature', type: GeojsonFeatureTypeEnum, geometry: { __typename?: 'GeojsonGeometry', coordinates: any, type: GeojsonGeometryTypeEnum }, properties: { __typename?: 'GeojsonProperties', address: string | null, addressDetails: string | null, color: ColorEnum | null, icon: string | null, shape: string | null, type: GeojsonPropertiesTypeEnum | null } | null }> } | null } | null, canDestroy: { __typename?: 'AuthorizationResult', value: boolean, message: string | null, reasons: { __typename?: 'FailureReasons', details: string, fullMessages: Array<string> } | null } } | null };

export type SectorUpdateMutationVariables = Exact<{
  attributes: SectorUpdateInputObject;
  id: Scalars['ID']['input'];
}>;


export type SectorUpdateMutation = { __typename?: 'Mutation', data: { __typename?: 'Sector', description: string | null, id: string, code: string | null, name: string | null, color: ColorEnum | null, readOnly: boolean, locationBoundary: { __typename?: 'Location', kind: string, id: string, geojson: { __typename?: 'GeojsonFeatureCollection', type: GeojsonFeatureCollectionTypeEnum, features: Array<{ __typename?: 'GeojsonFeature', type: GeojsonFeatureTypeEnum, geometry: { __typename?: 'GeojsonGeometry', coordinates: any, type: GeojsonGeometryTypeEnum }, properties: { __typename?: 'GeojsonProperties', address: string | null, addressDetails: string | null, color: ColorEnum | null, icon: string | null, shape: string | null, type: GeojsonPropertiesTypeEnum | null } | null }> } | null } | null, canDestroy: { __typename?: 'AuthorizationResult', value: boolean, message: string | null, reasons: { __typename?: 'FailureReasons', details: string, fullMessages: Array<string> } | null } } | null };

export type SectorDestroyMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type SectorDestroyMutation = { __typename?: 'Mutation', sectorDestroy: boolean | null };

export type MainSiteFragmentFragment = { __typename?: 'Site', code: string, id: string, name: string, locationPhotoAttached: { __typename?: 'Attachment', id: string, processed: boolean, fileTag: string | null, fileData: any | null, filename: string | null, urls: { __typename?: 'AttachmentUrl', large: string | null, medium: string | null, original: string | null, small: string | null, imagePreview: string | null, originalDirectDownload: string | null, video480p: string | null, video720p: string | null, video1080p: string | null } | null, metadata: { __typename?: 'AttachmentMetadata', intendedUse: string | null } | null } | null, user: { __typename?: 'User', id: string, firstName: string, lastName: string, email: string | null, phoneNumber: string | null, avatarAttached: { __typename?: 'Attachment', id: string, processed: boolean, fileTag: string | null, fileData: any | null, filename: string | null, urls: { __typename?: 'AttachmentUrl', large: string | null, medium: string | null, original: string | null, small: string | null, imagePreview: string | null, originalDirectDownload: string | null, video480p: string | null, video720p: string | null, video1080p: string | null } | null, metadata: { __typename?: 'AttachmentMetadata', intendedUse: string | null } | null } | null } | null };

export type FullSiteFragmentFragment = { __typename?: 'Site', updatedAt: any, phoneNumber: string | null, description: string | null, email: string, createdAt: any, usersCount: number, siteAreasCount: number, code: string, id: string, name: string, locationPoint: { __typename?: 'Location', kind: string, id: string, geojson: { __typename?: 'GeojsonFeatureCollection', type: GeojsonFeatureCollectionTypeEnum, features: Array<{ __typename?: 'GeojsonFeature', type: GeojsonFeatureTypeEnum, geometry: { __typename?: 'GeojsonGeometry', coordinates: any, type: GeojsonGeometryTypeEnum }, properties: { __typename?: 'GeojsonProperties', address: string | null, addressDetails: string | null, color: ColorEnum | null, icon: string | null, shape: string | null, type: GeojsonPropertiesTypeEnum | null } | null }> } | null } | null, siteConductCodeSections: Array<{ __typename?: 'SiteConductCodeSection', body: string, createdAt: any, id: string, position: number, title: string, updatedAt: any }>, sector: { __typename?: 'Sector', id: string, name: string | null, color: ColorEnum | null } | null, locationPhotoAttached: { __typename?: 'Attachment', id: string, processed: boolean, fileTag: string | null, fileData: any | null, filename: string | null, urls: { __typename?: 'AttachmentUrl', large: string | null, medium: string | null, original: string | null, small: string | null, imagePreview: string | null, originalDirectDownload: string | null, video480p: string | null, video720p: string | null, video1080p: string | null } | null, metadata: { __typename?: 'AttachmentMetadata', intendedUse: string | null } | null } | null, user: { __typename?: 'User', id: string, firstName: string, lastName: string, email: string | null, phoneNumber: string | null, avatarAttached: { __typename?: 'Attachment', id: string, processed: boolean, fileTag: string | null, fileData: any | null, filename: string | null, urls: { __typename?: 'AttachmentUrl', large: string | null, medium: string | null, original: string | null, small: string | null, imagePreview: string | null, originalDirectDownload: string | null, video480p: string | null, video720p: string | null, video1080p: string | null } | null, metadata: { __typename?: 'AttachmentMetadata', intendedUse: string | null } | null } | null } | null };

export type SiteQueryVariables = Exact<{
  findBy: SiteFindByInputObject;
}>;


export type SiteQuery = { __typename?: 'Query', site: { __typename?: 'Site', updatedAt: any, phoneNumber: string | null, description: string | null, email: string, createdAt: any, usersCount: number, siteAreasCount: number, code: string, id: string, name: string, locationPoint: { __typename?: 'Location', kind: string, id: string, geojson: { __typename?: 'GeojsonFeatureCollection', type: GeojsonFeatureCollectionTypeEnum, features: Array<{ __typename?: 'GeojsonFeature', type: GeojsonFeatureTypeEnum, geometry: { __typename?: 'GeojsonGeometry', coordinates: any, type: GeojsonGeometryTypeEnum }, properties: { __typename?: 'GeojsonProperties', address: string | null, addressDetails: string | null, color: ColorEnum | null, icon: string | null, shape: string | null, type: GeojsonPropertiesTypeEnum | null } | null }> } | null } | null, siteConductCodeSections: Array<{ __typename?: 'SiteConductCodeSection', body: string, createdAt: any, id: string, position: number, title: string, updatedAt: any }>, sector: { __typename?: 'Sector', id: string, name: string | null, color: ColorEnum | null } | null, locationPhotoAttached: { __typename?: 'Attachment', id: string, processed: boolean, fileTag: string | null, fileData: any | null, filename: string | null, urls: { __typename?: 'AttachmentUrl', large: string | null, medium: string | null, original: string | null, small: string | null, imagePreview: string | null, originalDirectDownload: string | null, video480p: string | null, video720p: string | null, video1080p: string | null } | null, metadata: { __typename?: 'AttachmentMetadata', intendedUse: string | null } | null } | null, user: { __typename?: 'User', id: string, firstName: string, lastName: string, email: string | null, phoneNumber: string | null, avatarAttached: { __typename?: 'Attachment', id: string, processed: boolean, fileTag: string | null, fileData: any | null, filename: string | null, urls: { __typename?: 'AttachmentUrl', large: string | null, medium: string | null, original: string | null, small: string | null, imagePreview: string | null, originalDirectDownload: string | null, video480p: string | null, video720p: string | null, video1080p: string | null } | null, metadata: { __typename?: 'AttachmentMetadata', intendedUse: string | null } | null } | null } | null } | null };

export type SitesQueryVariables = Exact<{
  page?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  filters?: InputMaybe<Array<SiteFilterInputObject> | SiteFilterInputObject>;
  taskFilters?: InputMaybe<Array<TaskFilterInputObject> | TaskFilterInputObject>;
  sorts?: InputMaybe<SiteSortInputObject>;
  includeFullData?: InputMaybe<Scalars['Boolean']['input']>;
  includePerformanceDataByTaskDeadlinesMissed?: InputMaybe<Scalars['Boolean']['input']>;
  includePerformanceDataByTaskResults?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type SitesQuery = { __typename?: 'Query', data: { __typename?: 'SiteCollection', collection: Array<{ __typename?: 'Site', id: string, name: string, code?: string, siteAreasCount?: number, usersCount?: number, totalAnomaliesByTaskDeadlinesMissed?: number | null, totalAnomaliesByTaskResults?: number | null, successPercentageByTaskDeadlinesMissed?: number | null, successPercentageByTaskResults?: number | null, locationPhotoAttached?: { __typename?: 'Attachment', id: string, processed: boolean, fileTag: string | null, fileData: any | null, filename: string | null, urls: { __typename?: 'AttachmentUrl', large: string | null, medium: string | null, original: string | null, small: string | null, imagePreview: string | null, originalDirectDownload: string | null, video480p: string | null, video720p: string | null, video1080p: string | null } | null, metadata: { __typename?: 'AttachmentMetadata', intendedUse: string | null } | null } | null, sector?: { __typename?: 'Sector', id: string, name: string | null, color: ColorEnum | null } | null }>, metadata: { __typename?: 'CollectionMetadata', currentPage: number, limitValue: number, totalCount: number, totalPages: number } } };

export type SiteLocationsQueryVariables = Exact<{
  filters?: InputMaybe<Array<LocationFilterInputObject> | LocationFilterInputObject>;
  siteFilters?: InputMaybe<Array<SiteFilterInputObject> | SiteFilterInputObject>;
  mapParams: LocationMapParamsInputObject;
}>;


export type SiteLocationsQuery = { __typename?: 'Query', data: { __typename?: 'GeojsonFeatureCollection', type: GeojsonFeatureCollectionTypeEnum, features: Array<{ __typename?: 'GeojsonFeature', type: GeojsonFeatureTypeEnum, geometry: { __typename?: 'GeojsonGeometry', coordinates: any, type: GeojsonGeometryTypeEnum }, properties: { __typename?: 'GeojsonProperties', address: string | null, addressDetails: string | null, color: ColorEnum | null, icon: string | null, shape: string | null, type: GeojsonPropertiesTypeEnum | null, pointCount: number | null, sourceables: Array<{ __typename?: 'GeojsonPropertiesPolymorphicIdentity', id: string, type: GeojsonPropertiesPolymorphicIdentityTypeEnum }> | null } | null }> } | null };

export type SiteLocationCenterQueryVariables = Exact<{
  filters?: InputMaybe<Array<LocationFilterInputObject> | LocationFilterInputObject>;
  siteFilters?: InputMaybe<Array<SiteFilterInputObject> | SiteFilterInputObject>;
}>;


export type SiteLocationCenterQuery = { __typename?: 'Query', data: { __typename?: 'LocationGeographicalCenter', lat: number | null, lon: number | null } | null };

export type SitesIdsQueryVariables = Exact<{
  page?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  filters?: InputMaybe<Array<SiteFilterInputObject> | SiteFilterInputObject>;
  sorts?: InputMaybe<SiteSortInputObject>;
  onlyIds?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type SitesIdsQuery = { __typename?: 'Query', data: { __typename?: 'SiteCollection', collection: Array<{ __typename?: 'Site', id: string }> } };

export type SitesSearchListQueryVariables = Exact<{
  page?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  filters?: InputMaybe<Array<SiteFilterInputObject> | SiteFilterInputObject>;
  sorts?: InputMaybe<SiteSortInputObject>;
  includeSector?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type SitesSearchListQuery = { __typename?: 'Query', data: { __typename?: 'SiteCollection', collection: Array<{ __typename?: 'Site', id: string, name: string, code: string, sector?: { __typename?: 'Sector', id: string, name: string | null, color: ColorEnum | null } | null }>, metadata: { __typename?: 'CollectionMetadata', currentPage: number, limitValue: number, totalCount: number, totalPages: number } } };

export type SitesPerformanceMetricsByTaskDeadlinesMissedQueryVariables = Exact<{
  ids: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
  taskFilters?: InputMaybe<Array<TaskFilterInputObject> | TaskFilterInputObject>;
}>;


export type SitesPerformanceMetricsByTaskDeadlinesMissedQuery = { __typename?: 'Query', data: Array<{ __typename?: 'SitePerformanceMetricByTaskDeadlinesMissed', id: string, successPercentageByTaskDeadlinesMissed: number | null, totalAnomaliesByTaskDeadlinesMissed: number | null }> | null };

export type SitesPerformanceMetricsByTaskDeadlinesMissedByDateQueryVariables = Exact<{
  ids: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
  taskFilters?: InputMaybe<Array<TaskFilterInputObject> | TaskFilterInputObject>;
  periodGroupBy: PeriodGroupByEnum;
}>;


export type SitesPerformanceMetricsByTaskDeadlinesMissedByDateQuery = { __typename?: 'Query', data: Array<{ __typename?: 'SitePerformanceMetricByTaskDeadlinesMissedByDate', id: string, period: any, totalAnomaliesByTaskDeadlinesMissed: number }> | null };

export type SitesPerformanceMetricsByTaskResultsQueryVariables = Exact<{
  ids: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
  taskFilters?: InputMaybe<Array<TaskFilterInputObject> | TaskFilterInputObject>;
}>;


export type SitesPerformanceMetricsByTaskResultsQuery = { __typename?: 'Query', data: Array<{ __typename?: 'SitePerformanceMetricByTaskResults', id: string, successPercentageByTaskResults: number | null, totalAnomaliesByTaskResults: number | null }> | null };

export type SitesPerformanceMetricsByTaskResultsByDateQueryVariables = Exact<{
  ids: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
  periodGroupBy: PeriodGroupByEnum;
  taskFilters?: InputMaybe<Array<TaskFilterInputObject> | TaskFilterInputObject>;
}>;


export type SitesPerformanceMetricsByTaskResultsByDateQuery = { __typename?: 'Query', data: Array<{ __typename?: 'SitePerformanceMetricByTaskResultsByDate', id: string, period: any, totalAnomaliesByTaskResults: number }> | null };

export type SiteCreateMutationVariables = Exact<{
  attributes: SiteCreateInputObject;
}>;


export type SiteCreateMutation = { __typename?: 'Mutation', data: { __typename?: 'Site', updatedAt: any, phoneNumber: string | null, description: string | null, email: string, createdAt: any, usersCount: number, siteAreasCount: number, code: string, id: string, name: string, locationPoint: { __typename?: 'Location', kind: string, id: string, geojson: { __typename?: 'GeojsonFeatureCollection', type: GeojsonFeatureCollectionTypeEnum, features: Array<{ __typename?: 'GeojsonFeature', type: GeojsonFeatureTypeEnum, geometry: { __typename?: 'GeojsonGeometry', coordinates: any, type: GeojsonGeometryTypeEnum }, properties: { __typename?: 'GeojsonProperties', address: string | null, addressDetails: string | null, color: ColorEnum | null, icon: string | null, shape: string | null, type: GeojsonPropertiesTypeEnum | null } | null }> } | null } | null, siteConductCodeSections: Array<{ __typename?: 'SiteConductCodeSection', body: string, createdAt: any, id: string, position: number, title: string, updatedAt: any }>, sector: { __typename?: 'Sector', id: string, name: string | null, color: ColorEnum | null } | null, locationPhotoAttached: { __typename?: 'Attachment', id: string, processed: boolean, fileTag: string | null, fileData: any | null, filename: string | null, urls: { __typename?: 'AttachmentUrl', large: string | null, medium: string | null, original: string | null, small: string | null, imagePreview: string | null, originalDirectDownload: string | null, video480p: string | null, video720p: string | null, video1080p: string | null } | null, metadata: { __typename?: 'AttachmentMetadata', intendedUse: string | null } | null } | null, user: { __typename?: 'User', id: string, firstName: string, lastName: string, email: string | null, phoneNumber: string | null, avatarAttached: { __typename?: 'Attachment', id: string, processed: boolean, fileTag: string | null, fileData: any | null, filename: string | null, urls: { __typename?: 'AttachmentUrl', large: string | null, medium: string | null, original: string | null, small: string | null, imagePreview: string | null, originalDirectDownload: string | null, video480p: string | null, video720p: string | null, video1080p: string | null } | null, metadata: { __typename?: 'AttachmentMetadata', intendedUse: string | null } | null } | null } | null } | null };

export type SiteUpdateMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  attributes: SiteUpdateInputObject;
}>;


export type SiteUpdateMutation = { __typename?: 'Mutation', data: { __typename?: 'Site', updatedAt: any, phoneNumber: string | null, description: string | null, email: string, createdAt: any, usersCount: number, siteAreasCount: number, code: string, id: string, name: string, locationPoint: { __typename?: 'Location', kind: string, id: string, geojson: { __typename?: 'GeojsonFeatureCollection', type: GeojsonFeatureCollectionTypeEnum, features: Array<{ __typename?: 'GeojsonFeature', type: GeojsonFeatureTypeEnum, geometry: { __typename?: 'GeojsonGeometry', coordinates: any, type: GeojsonGeometryTypeEnum }, properties: { __typename?: 'GeojsonProperties', address: string | null, addressDetails: string | null, color: ColorEnum | null, icon: string | null, shape: string | null, type: GeojsonPropertiesTypeEnum | null } | null }> } | null } | null, siteConductCodeSections: Array<{ __typename?: 'SiteConductCodeSection', body: string, createdAt: any, id: string, position: number, title: string, updatedAt: any }>, sector: { __typename?: 'Sector', id: string, name: string | null, color: ColorEnum | null } | null, locationPhotoAttached: { __typename?: 'Attachment', id: string, processed: boolean, fileTag: string | null, fileData: any | null, filename: string | null, urls: { __typename?: 'AttachmentUrl', large: string | null, medium: string | null, original: string | null, small: string | null, imagePreview: string | null, originalDirectDownload: string | null, video480p: string | null, video720p: string | null, video1080p: string | null } | null, metadata: { __typename?: 'AttachmentMetadata', intendedUse: string | null } | null } | null, user: { __typename?: 'User', id: string, firstName: string, lastName: string, email: string | null, phoneNumber: string | null, avatarAttached: { __typename?: 'Attachment', id: string, processed: boolean, fileTag: string | null, fileData: any | null, filename: string | null, urls: { __typename?: 'AttachmentUrl', large: string | null, medium: string | null, original: string | null, small: string | null, imagePreview: string | null, originalDirectDownload: string | null, video480p: string | null, video720p: string | null, video1080p: string | null } | null, metadata: { __typename?: 'AttachmentMetadata', intendedUse: string | null } | null } | null } | null } | null };

export type SiteDestroyMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type SiteDestroyMutation = { __typename?: 'Mutation', data: boolean | null };

export type SiteAreaFragmentFragment = { __typename?: 'SiteArea', address: string | null, code: string, description: string | null, fullCode: string, id: string, name: string, poorWifi: boolean, canDestroy: { __typename?: 'AuthorizationResult', value: boolean, message: string | null, reasons: { __typename?: 'FailureReasons', details: string, fullMessages: Array<string> } | null } };

export type SiteAreaQueryVariables = Exact<{
  findBy: SiteAreaFindByInputObject;
  siteFindBy: SiteFindByInputObject;
}>;


export type SiteAreaQuery = { __typename?: 'Query', data: { __typename?: 'SiteArea', address: string | null, code: string, description: string | null, fullCode: string, id: string, name: string, poorWifi: boolean, canDestroy: { __typename?: 'AuthorizationResult', value: boolean, message: string | null, reasons: { __typename?: 'FailureReasons', details: string, fullMessages: Array<string> } | null } } | null };

export type SiteAreasQueryVariables = Exact<{
  page?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  filters?: InputMaybe<Array<SiteAreaFilterInputObject> | SiteAreaFilterInputObject>;
  sorts?: InputMaybe<SiteAreaSortInputObject>;
  includeFullData?: InputMaybe<Scalars['Boolean']['input']>;
  includeSiteData?: InputMaybe<Scalars['Boolean']['input']>;
  includeCanDestroy?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type SiteAreasQuery = { __typename?: 'Query', data: { __typename?: 'SiteAreaCollection', collection: Array<{ __typename?: 'SiteArea', address?: string | null, code: string, description?: string | null, fullCode: string, id: string, name: string, poorWifi?: boolean, canDestroy?: { __typename?: 'AuthorizationResult', value: boolean, message: string | null, reasons: { __typename?: 'FailureReasons', details: string, fullMessages: Array<string> } | null }, site?: { __typename?: 'Site', id: string, name: string, code: string, sector: { __typename?: 'Sector', id: string, name: string | null, color: ColorEnum | null } | null } | null }>, metadata: { __typename?: 'CollectionMetadata', currentPage: number, limitValue: number, totalCount: number, totalPages: number } } };

export type SiteAreaIdsQueryVariables = Exact<{
  filters?: InputMaybe<Array<SiteAreaFilterInputObject> | SiteAreaFilterInputObject>;
  sorts?: InputMaybe<SiteAreaSortInputObject>;
  onlyIds?: InputMaybe<Scalars['Boolean']['input']>;
  includeSiteId?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type SiteAreaIdsQuery = { __typename?: 'Query', data: { __typename?: 'SiteAreaCollection', collection: Array<{ __typename?: 'SiteArea', id: string, siteId?: string | null }> } };

export type SiteAreasSearchListQueryVariables = Exact<{
  page?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  filters?: InputMaybe<Array<SiteAreaFilterInputObject> | SiteAreaFilterInputObject>;
  sorts?: InputMaybe<SiteAreaSortInputObject>;
}>;


export type SiteAreasSearchListQuery = { __typename?: 'Query', data: { __typename?: 'SiteAreaCollection', collection: Array<{ __typename?: 'SiteArea', id: string, name: string, poorWifi: boolean }>, metadata: { __typename?: 'CollectionMetadata', currentPage: number, limitValue: number, totalCount: number, totalPages: number } } };

export type SiteAreaUpdateMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  attributes: SiteAreaUpdateInputObject;
}>;


export type SiteAreaUpdateMutation = { __typename?: 'Mutation', data: { __typename?: 'SiteArea', address: string | null, code: string, description: string | null, fullCode: string, id: string, name: string, poorWifi: boolean, canDestroy: { __typename?: 'AuthorizationResult', value: boolean, message: string | null, reasons: { __typename?: 'FailureReasons', details: string, fullMessages: Array<string> } | null } } | null };

export type SiteAreaBulkDestroyMutationVariables = Exact<{
  input: SiteAreaBulkDestroyInput;
}>;


export type SiteAreaBulkDestroyMutation = { __typename?: 'Mutation', data: { __typename?: 'SiteAreaBulkDestroyResult', destroyedCount: number, blocked: Array<{ __typename?: 'SiteArea', id: string, name: string, canDestroy: { __typename?: 'AuthorizationResult', value: boolean, message: string | null, reasons: { __typename?: 'FailureReasons', details: string, fullMessages: Array<string> } | null } }> } | null };

export type SiteAreaBulkQrCodeCreateMutationVariables = Exact<{
  params: QrCodesCreateInputObject;
}>;


export type SiteAreaBulkQrCodeCreateMutation = { __typename?: 'Mutation', data: { __typename?: 'BackgroundJob', id: string, jid: string | null, parentId: string | null, rootId: string, kind: BackgroundJobKindEnum, status: BackgroundJobStatusEnum, displayStatus: BackgroundJobStatusEnum, treeStatus: BackgroundJobStatusEnum, done: number, total: number, failed: number, pctComplete: number, message: string | null, errorCode: string | null, result: any | null, estimatedFinishAt: any | null, startedAt: any | null, finishedAt: any | null, cancelRequestedAt: any | null, deliveryRequestedAt: any | null, dismissed: boolean, createdAt: any, updatedAt: any, children: Array<{ __typename?: 'BackgroundJob', id: string, jid: string | null, parentId: string | null, rootId: string, kind: BackgroundJobKindEnum, status: BackgroundJobStatusEnum, displayStatus: BackgroundJobStatusEnum, treeStatus: BackgroundJobStatusEnum, done: number, total: number, failed: number, pctComplete: number, message: string | null, errorCode: string | null, result: any | null, estimatedFinishAt: any | null, startedAt: any | null, finishedAt: any | null, cancelRequestedAt: any | null, deliveryRequestedAt: any | null, dismissed: boolean, createdAt: any, updatedAt: any, canCancel: { __typename?: 'AuthorizationResult', value: boolean, message: string | null, reasons: { __typename?: 'FailureReasons', details: string, fullMessages: Array<string> } | null }, canDismiss: { __typename?: 'AuthorizationResult', value: boolean, message: string | null, reasons: { __typename?: 'FailureReasons', details: string, fullMessages: Array<string> } | null }, canRequestDelivery: { __typename?: 'AuthorizationResult', value: boolean, message: string | null, reasons: { __typename?: 'FailureReasons', details: string, fullMessages: Array<string> } | null }, canRequeue: { __typename?: 'AuthorizationResult', value: boolean, message: string | null, reasons: { __typename?: 'FailureReasons', details: string, fullMessages: Array<string> } | null } }>, canCancel: { __typename?: 'AuthorizationResult', value: boolean, message: string | null, reasons: { __typename?: 'FailureReasons', details: string, fullMessages: Array<string> } | null }, canDismiss: { __typename?: 'AuthorizationResult', value: boolean, message: string | null, reasons: { __typename?: 'FailureReasons', details: string, fullMessages: Array<string> } | null }, canRequestDelivery: { __typename?: 'AuthorizationResult', value: boolean, message: string | null, reasons: { __typename?: 'FailureReasons', details: string, fullMessages: Array<string> } | null }, canRequeue: { __typename?: 'AuthorizationResult', value: boolean, message: string | null, reasons: { __typename?: 'FailureReasons', details: string, fullMessages: Array<string> } | null } } | null };

export type SsoIntegrationFragmentFragment = { __typename?: 'SsoIntegration', id: string, name: string, code: string, providerPreset: SsoIntegrationProviderPresetEnum, providerType: SsoIntegrationProviderTypeEnum, displayStatus: SsoIntegrationDisplayStatusEnum, status: SsoIntegrationStatusEnum, warningKey: SsoIntegrationWarningKeyEnum | null, idpMetadata: string | null, attributeMapping: any | null, allowIdpInitiated: boolean, jitProvisioningEnabled: boolean, syncUserAttributes: boolean, timeToleranceSeconds: number | null, pinned: boolean, createdAt: any, updatedAt: any, icon: { __typename?: 'Attachment', id: string, processed: boolean, fileTag: string | null, fileData: any | null, filename: string | null, urls: { __typename?: 'AttachmentUrl', large: string | null, medium: string | null, original: string | null, small: string | null, imagePreview: string | null, originalDirectDownload: string | null, video480p: string | null, video720p: string | null, video1080p: string | null } | null, metadata: { __typename?: 'AttachmentMetadata', intendedUse: string | null } | null } | null, companyDomains: Array<{ __typename?: 'CompanyDomain', id: string }> };

export type SsoIntegrationsQueryVariables = Exact<{
  page?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  sorts?: InputMaybe<SsoIntegrationSortInputObject>;
  filters?: InputMaybe<Array<SsoIntegrationFilterInputObject> | SsoIntegrationFilterInputObject>;
}>;


export type SsoIntegrationsQuery = { __typename?: 'Query', data: { __typename?: 'SsoIntegrationCollection', collection: Array<{ __typename?: 'SsoIntegration', id: string, name: string, status: SsoIntegrationStatusEnum, providerPreset: SsoIntegrationProviderPresetEnum, providerType: SsoIntegrationProviderTypeEnum, displayStatus: SsoIntegrationDisplayStatusEnum, updatedAt: any, icon: { __typename?: 'Attachment', id: string, processed: boolean, fileTag: string | null, fileData: any | null, filename: string | null, urls: { __typename?: 'AttachmentUrl', large: string | null, medium: string | null, original: string | null, small: string | null, imagePreview: string | null, originalDirectDownload: string | null, video480p: string | null, video720p: string | null, video1080p: string | null } | null, metadata: { __typename?: 'AttachmentMetadata', intendedUse: string | null } | null } | null }>, metadata: { __typename?: 'CollectionMetadata', currentPage: number, limitValue: number, totalCount: number, totalPages: number } } };

export type SsoIntegrationQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type SsoIntegrationQuery = { __typename?: 'Query', data: { __typename?: 'SsoIntegration', id: string, name: string, code: string, providerPreset: SsoIntegrationProviderPresetEnum, providerType: SsoIntegrationProviderTypeEnum, displayStatus: SsoIntegrationDisplayStatusEnum, status: SsoIntegrationStatusEnum, warningKey: SsoIntegrationWarningKeyEnum | null, idpMetadata: string | null, attributeMapping: any | null, allowIdpInitiated: boolean, jitProvisioningEnabled: boolean, syncUserAttributes: boolean, timeToleranceSeconds: number | null, pinned: boolean, createdAt: any, updatedAt: any, icon: { __typename?: 'Attachment', id: string, processed: boolean, fileTag: string | null, fileData: any | null, filename: string | null, urls: { __typename?: 'AttachmentUrl', large: string | null, medium: string | null, original: string | null, small: string | null, imagePreview: string | null, originalDirectDownload: string | null, video480p: string | null, video720p: string | null, video1080p: string | null } | null, metadata: { __typename?: 'AttachmentMetadata', intendedUse: string | null } | null } | null, companyDomains: Array<{ __typename?: 'CompanyDomain', id: string }> } | null };

export type SsoIntegrationCreateMutationVariables = Exact<{
  attributes: SsoIntegrationCreateInputObject;
}>;


export type SsoIntegrationCreateMutation = { __typename?: 'Mutation', data: { __typename?: 'SsoIntegration', id: string, name: string, code: string, providerPreset: SsoIntegrationProviderPresetEnum, providerType: SsoIntegrationProviderTypeEnum, displayStatus: SsoIntegrationDisplayStatusEnum, status: SsoIntegrationStatusEnum, warningKey: SsoIntegrationWarningKeyEnum | null, idpMetadata: string | null, attributeMapping: any | null, allowIdpInitiated: boolean, jitProvisioningEnabled: boolean, syncUserAttributes: boolean, timeToleranceSeconds: number | null, pinned: boolean, createdAt: any, updatedAt: any, icon: { __typename?: 'Attachment', id: string, processed: boolean, fileTag: string | null, fileData: any | null, filename: string | null, urls: { __typename?: 'AttachmentUrl', large: string | null, medium: string | null, original: string | null, small: string | null, imagePreview: string | null, originalDirectDownload: string | null, video480p: string | null, video720p: string | null, video1080p: string | null } | null, metadata: { __typename?: 'AttachmentMetadata', intendedUse: string | null } | null } | null, companyDomains: Array<{ __typename?: 'CompanyDomain', id: string }> } | null };

export type SsoIntegrationUpdateMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  attributes: SsoIntegrationUpdateInputObject;
}>;


export type SsoIntegrationUpdateMutation = { __typename?: 'Mutation', data: { __typename?: 'SsoIntegration', id: string, name: string, code: string, providerPreset: SsoIntegrationProviderPresetEnum, providerType: SsoIntegrationProviderTypeEnum, displayStatus: SsoIntegrationDisplayStatusEnum, status: SsoIntegrationStatusEnum, warningKey: SsoIntegrationWarningKeyEnum | null, idpMetadata: string | null, attributeMapping: any | null, allowIdpInitiated: boolean, jitProvisioningEnabled: boolean, syncUserAttributes: boolean, timeToleranceSeconds: number | null, pinned: boolean, createdAt: any, updatedAt: any, icon: { __typename?: 'Attachment', id: string, processed: boolean, fileTag: string | null, fileData: any | null, filename: string | null, urls: { __typename?: 'AttachmentUrl', large: string | null, medium: string | null, original: string | null, small: string | null, imagePreview: string | null, originalDirectDownload: string | null, video480p: string | null, video720p: string | null, video1080p: string | null } | null, metadata: { __typename?: 'AttachmentMetadata', intendedUse: string | null } | null } | null, companyDomains: Array<{ __typename?: 'CompanyDomain', id: string }> } | null };

export type SsoIntegrationPresetDefaultsQueryVariables = Exact<{
  preset: SsoIntegrationProviderPresetEnum;
}>;


export type SsoIntegrationPresetDefaultsQuery = { __typename?: 'Query', data: any };

export type SsoIntegrationGenerateCodeQueryVariables = Exact<{ [key: string]: never; }>;


export type SsoIntegrationGenerateCodeQuery = { __typename?: 'Query', data: { __typename?: 'SsoGeneratedCode', code: string, acsUrl: string, entityId: string, metadataUrl: string } };

export type SsoIntegrationActivateMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type SsoIntegrationActivateMutation = { __typename?: 'Mutation', data: { __typename?: 'SsoIntegration', id: string, name: string, code: string, providerPreset: SsoIntegrationProviderPresetEnum, providerType: SsoIntegrationProviderTypeEnum, displayStatus: SsoIntegrationDisplayStatusEnum, status: SsoIntegrationStatusEnum, warningKey: SsoIntegrationWarningKeyEnum | null, idpMetadata: string | null, attributeMapping: any | null, allowIdpInitiated: boolean, jitProvisioningEnabled: boolean, syncUserAttributes: boolean, timeToleranceSeconds: number | null, pinned: boolean, createdAt: any, updatedAt: any, icon: { __typename?: 'Attachment', id: string, processed: boolean, fileTag: string | null, fileData: any | null, filename: string | null, urls: { __typename?: 'AttachmentUrl', large: string | null, medium: string | null, original: string | null, small: string | null, imagePreview: string | null, originalDirectDownload: string | null, video480p: string | null, video720p: string | null, video1080p: string | null } | null, metadata: { __typename?: 'AttachmentMetadata', intendedUse: string | null } | null } | null, companyDomains: Array<{ __typename?: 'CompanyDomain', id: string }> } | null };

export type SsoIntegrationDeactivateMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type SsoIntegrationDeactivateMutation = { __typename?: 'Mutation', data: { __typename?: 'SsoIntegration', id: string, name: string, code: string, providerPreset: SsoIntegrationProviderPresetEnum, providerType: SsoIntegrationProviderTypeEnum, displayStatus: SsoIntegrationDisplayStatusEnum, status: SsoIntegrationStatusEnum, warningKey: SsoIntegrationWarningKeyEnum | null, idpMetadata: string | null, attributeMapping: any | null, allowIdpInitiated: boolean, jitProvisioningEnabled: boolean, syncUserAttributes: boolean, timeToleranceSeconds: number | null, pinned: boolean, createdAt: any, updatedAt: any, icon: { __typename?: 'Attachment', id: string, processed: boolean, fileTag: string | null, fileData: any | null, filename: string | null, urls: { __typename?: 'AttachmentUrl', large: string | null, medium: string | null, original: string | null, small: string | null, imagePreview: string | null, originalDirectDownload: string | null, video480p: string | null, video720p: string | null, video1080p: string | null } | null, metadata: { __typename?: 'AttachmentMetadata', intendedUse: string | null } | null } | null, companyDomains: Array<{ __typename?: 'CompanyDomain', id: string }> } | null };

export type SsoIntegrationDestroyMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type SsoIntegrationDestroyMutation = { __typename?: 'Mutation', data: boolean | null };

export type CompanyDomainFragmentFragment = { __typename?: 'CompanyDomain', id: string, domain: string, verified: boolean, verifiedAt: any | null, dnsTxtRecord: string, createdAt: any, updatedAt: any };

export type CompanyDomainsQueryVariables = Exact<{
  page?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  sorts?: InputMaybe<CompanyDomainSortInputObject>;
  filters?: InputMaybe<Array<CompanyDomainFilterInputObject> | CompanyDomainFilterInputObject>;
}>;


export type CompanyDomainsQuery = { __typename?: 'Query', data: { __typename?: 'CompanyDomainCollection', collection: Array<{ __typename?: 'CompanyDomain', id: string, domain: string, verified: boolean, verifiedAt: any | null, dnsTxtRecord: string, createdAt: any, updatedAt: any }>, metadata: { __typename?: 'CollectionMetadata', currentPage: number, limitValue: number, totalCount: number, totalPages: number } } };

export type CompanyDomainCreateMutationVariables = Exact<{
  attributes: CompanyDomainCreateInputObject;
}>;


export type CompanyDomainCreateMutation = { __typename?: 'Mutation', data: { __typename?: 'CompanyDomain', id: string, domain: string, verified: boolean, verifiedAt: any | null, dnsTxtRecord: string, createdAt: any, updatedAt: any } | null };

export type CompanyDomainVerifyMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type CompanyDomainVerifyMutation = { __typename?: 'Mutation', data: { __typename?: 'CompanyDomain', id: string, domain: string, verified: boolean, verifiedAt: any | null, dnsTxtRecord: string, createdAt: any, updatedAt: any } | null };

export type CompanyDomainDestroyMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type CompanyDomainDestroyMutation = { __typename?: 'Mutation', data: boolean | null };

export type SsoIntegrationsDomainCheckQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']['input']>;
  filters?: InputMaybe<Array<SsoIntegrationFilterInputObject> | SsoIntegrationFilterInputObject>;
}>;


export type SsoIntegrationsDomainCheckQuery = { __typename?: 'Query', data: { __typename?: 'SsoIntegrationCollection', collection: Array<{ __typename?: 'SsoIntegration', id: string }> } };

export type CompanyDomainsSearchListQueryVariables = Exact<{
  page?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  sorts?: InputMaybe<CompanyDomainSortInputObject>;
  filters?: InputMaybe<Array<CompanyDomainFilterInputObject> | CompanyDomainFilterInputObject>;
}>;


export type CompanyDomainsSearchListQuery = { __typename?: 'Query', data: { __typename?: 'CompanyDomainCollection', collection: Array<{ __typename?: 'CompanyDomain', id: string, domain: string, verified: boolean }>, metadata: { __typename?: 'CollectionMetadata', currentPage: number, limitValue: number, totalCount: number, totalPages: number } } };

export type SsoIntegrationSupportedMappingFieldsQueryVariables = Exact<{ [key: string]: never; }>;


export type SsoIntegrationSupportedMappingFieldsQuery = { __typename?: 'Query', ssoIntegrationSupportedMappingFields: Array<{ __typename?: 'SsoMappingField', description: string | null, key: string, label: string, required: boolean, sortIndex: number }> };

export type TagsQueryVariables = Exact<{
  page?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  sorts?: InputMaybe<TagSortInputObject>;
  filters?: InputMaybe<Array<TagFilterInputObject> | TagFilterInputObject>;
}>;


export type TagsQuery = { __typename?: 'Query', data: { __typename?: 'TagCollection', collection: Array<{ __typename?: 'Tag', id: string, name: string }>, metadata: { __typename?: 'CollectionMetadata', currentPage: number, limitValue: number, totalCount: number, totalPages: number } } };

export type TagQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type TagQuery = { __typename?: 'Query', data: { __typename?: 'Tag', id: string, name: string } | null };

export type TagCreateMutationVariables = Exact<{
  attributes: TagCreateInputObject;
}>;


export type TagCreateMutation = { __typename?: 'Mutation', data: { __typename?: 'Tag', id: string, name: string } | null };

export type TagDestroyMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type TagDestroyMutation = { __typename?: 'Mutation', tagDestroy: boolean | null };

export type CanActionsTaskFragmentFragment = { __typename?: 'Task', canArchive: { __typename?: 'AuthorizationResult', value: boolean, message: string | null, reasons: { __typename?: 'FailureReasons', details: string, fullMessages: Array<string> } | null }, canDestroy: { __typename?: 'AuthorizationResult', value: boolean, message: string | null, reasons: { __typename?: 'FailureReasons', details: string, fullMessages: Array<string> } | null }, canUpdate: { __typename?: 'AuthorizationResult', value: boolean, message: string | null, reasons: { __typename?: 'FailureReasons', details: string, fullMessages: Array<string> } | null }, canReschedule: { __typename?: 'AuthorizationResult', value: boolean, message: string | null, reasons: { __typename?: 'FailureReasons', details: string, fullMessages: Array<string> } | null }, canQrCodeRelatedInfoUpdate: { __typename?: 'AuthorizationResult', value: boolean, message: string | null, reasons: { __typename?: 'FailureReasons', details: string, fullMessages: Array<string> } | null } };

export type RecurringRuleFragmentFragment = { __typename?: 'RecurringRule', endsAfterOccurrences: number | null, endTime: any | null, id: string, countdownType: RecurringRuleCountdownTypeEnum | null, excludedWdays: Array<number> | null, startTime: any, schema: { __typename?: 'RecurringRuleSchema', rrules: Array<{ __typename?: 'RecurringRuleSchemaRule', interval: number, ruleType: RecurringRuleRuleTypeEnum, validations: { __typename?: 'RecurringRuleValidations', day: Array<number> | null, dayOfWeek: any | null, dayOfMonth: Array<number> | null, monthOfYear: Array<number> | null } | null }>, metadata: { __typename?: 'RecurringRuleSchemaMetadata', schemaOption: RecurringRuleSchemaOptionEnum } | null } };

export type EarlyCompletionFragmentFragment = { __typename?: 'Task', earlyCompletion: number | null, earlyCompletionUnit: TaskEarlyCompletionUnitEnum | null };

export type TaskFragmentFragment = { __typename?: 'Task', id: string, groupKey: string, kind: TaskKindEnum, name: string, description: string | null, priority: TaskPriorityEnum, status: TaskStatusEnum, completedAt: any | null, recurringRuleId: string | null, lastDeadlineAt: any | null, lateFor: number | null, createdAt: any, deadlineAt: any | null, archivedAt: any | null, lastCheckAt: any | null, originalCreatedAt: any, completion: { __typename?: 'TaskCompletion', validityHint: FormTemplateQuestionFieldOptionsValidityHintEnum | null, status: TaskCompletionStatusEnum | null, solvedAt: any | null } | null, site: { __typename?: 'Site', id: string, name: string } | null, siteArea: { __typename?: 'SiteArea', id: string, name: string, fullCode: string } | null, approver: { __typename?: 'User', id: string, firstName: string, lastName: string, avatarAttached: { __typename?: 'Attachment', id: string, processed: boolean, fileTag: string | null, fileData: any | null, filename: string | null, urls: { __typename?: 'AttachmentUrl', large: string | null, medium: string | null, original: string | null, small: string | null, imagePreview: string | null, originalDirectDownload: string | null, video480p: string | null, video720p: string | null, video1080p: string | null } | null, metadata: { __typename?: 'AttachmentMetadata', intendedUse: string | null } | null } | null } | null, asset: { __typename?: 'Asset', id: string, name: string, fullCode: string, siteArea: { __typename?: 'SiteArea', code: string } | null, iconAttached: { __typename?: 'Attachment', id: string, processed: boolean, fileTag: string | null, fileData: any | null, filename: string | null, urls: { __typename?: 'AttachmentUrl', large: string | null, medium: string | null, original: string | null, small: string | null, imagePreview: string | null, originalDirectDownload: string | null, video480p: string | null, video720p: string | null, video1080p: string | null } | null, metadata: { __typename?: 'AttachmentMetadata', intendedUse: string | null } | null } | null } | null, formTemplate: { __typename?: 'FormTemplate', canUpdate: { __typename?: 'AuthorizationResult', value: boolean } }, canArchive: { __typename?: 'AuthorizationResult', value: boolean, message: string | null, reasons: { __typename?: 'FailureReasons', details: string, fullMessages: Array<string> } | null }, canDestroy: { __typename?: 'AuthorizationResult', value: boolean, message: string | null, reasons: { __typename?: 'FailureReasons', details: string, fullMessages: Array<string> } | null }, canUpdate: { __typename?: 'AuthorizationResult', value: boolean, message: string | null, reasons: { __typename?: 'FailureReasons', details: string, fullMessages: Array<string> } | null }, canReschedule: { __typename?: 'AuthorizationResult', value: boolean, message: string | null, reasons: { __typename?: 'FailureReasons', details: string, fullMessages: Array<string> } | null }, canQrCodeRelatedInfoUpdate: { __typename?: 'AuthorizationResult', value: boolean, message: string | null, reasons: { __typename?: 'FailureReasons', details: string, fullMessages: Array<string> } | null } };

export type TaskFormCompletionQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type TaskFormCompletionQuery = { __typename?: 'Query', data: { __typename?: 'Task', id: string, name: string, status: TaskStatusEnum, formTemplate: { __typename?: 'FormTemplate', description: string | null, id: string, name: string, createdAt: any, updatedAt: any, category: { __typename?: 'FormCategory', color: ColorEnum, name: string, id: string } | null }, completion: { __typename?: 'TaskCompletion', id: string, answers: Array<{ __typename?: 'FormAnswer', id: string, kind: FormTemplateQuestionFieldsKindEnum, fieldId: string, questionId: string, field: { __typename?: 'FormTemplateQuestionField', id: string, options: Array<{ __typename?: 'FormTemplateQuestionFieldOption', id: string, fieldId: string, group: FormTemplateQuestionFieldOptionGroupEnum | null, position: number, values: Array<string> }> }, resp: Array<{ __typename?: 'FormAnswerResp', group: FormAnswerRespGroupEnum | null, optionId: string | null, position: number | null, selected: boolean | null, value: string | null, valueId: string | null }>, attachmentsAttached: Array<{ __typename?: 'Attachment', id: string, processed: boolean, fileTag: string | null, fileData: any | null, filename: string | null, urls: { __typename?: 'AttachmentUrl', large: string | null, medium: string | null, original: string | null, small: string | null, imagePreview: string | null, originalDirectDownload: string | null, video480p: string | null, video720p: string | null, video1080p: string | null } | null, metadata: { __typename?: 'AttachmentMetadata', intendedUse: string | null } | null }> }> | null } | null } | null };

export type DashboardTaskCounterQueryVariables = Exact<{
  filters?: InputMaybe<Array<TaskFilterInputObject> | TaskFilterInputObject>;
}>;


export type DashboardTaskCounterQuery = { __typename?: 'Query', myApprovals: { __typename?: 'TaskCollection', metadata: { __typename?: 'CollectionMetadata', totalCount: number } } };

export type DashboardTaskQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DashboardTaskQuery = { __typename?: 'Query', data: { __typename?: 'Task', hasLinkedDocumentations: boolean | null, id: string, groupKey: string, kind: TaskKindEnum, name: string, description: string | null, priority: TaskPriorityEnum, status: TaskStatusEnum, completedAt: any | null, recurringRuleId: string | null, lastDeadlineAt: any | null, lateFor: number | null, createdAt: any, deadlineAt: any | null, archivedAt: any | null, lastCheckAt: any | null, originalCreatedAt: any, formTemplate: { __typename?: 'FormTemplate', id: string, name: string, canUpdate: { __typename?: 'AuthorizationResult', value: boolean } }, formTemplateVersion: { __typename?: 'FormTemplateVersion', id: string, version: string | null }, completion: { __typename?: 'TaskCompletion', validityHint: FormTemplateQuestionFieldOptionsValidityHintEnum | null, status: TaskCompletionStatusEnum | null, solvedAt: any | null } | null, site: { __typename?: 'Site', id: string, name: string } | null, siteArea: { __typename?: 'SiteArea', id: string, name: string, fullCode: string } | null, approver: { __typename?: 'User', id: string, firstName: string, lastName: string, avatarAttached: { __typename?: 'Attachment', id: string, processed: boolean, fileTag: string | null, fileData: any | null, filename: string | null, urls: { __typename?: 'AttachmentUrl', large: string | null, medium: string | null, original: string | null, small: string | null, imagePreview: string | null, originalDirectDownload: string | null, video480p: string | null, video720p: string | null, video1080p: string | null } | null, metadata: { __typename?: 'AttachmentMetadata', intendedUse: string | null } | null } | null } | null, asset: { __typename?: 'Asset', id: string, name: string, fullCode: string, siteArea: { __typename?: 'SiteArea', code: string } | null, iconAttached: { __typename?: 'Attachment', id: string, processed: boolean, fileTag: string | null, fileData: any | null, filename: string | null, urls: { __typename?: 'AttachmentUrl', large: string | null, medium: string | null, original: string | null, small: string | null, imagePreview: string | null, originalDirectDownload: string | null, video480p: string | null, video720p: string | null, video1080p: string | null } | null, metadata: { __typename?: 'AttachmentMetadata', intendedUse: string | null } | null } | null } | null, canArchive: { __typename?: 'AuthorizationResult', value: boolean, message: string | null, reasons: { __typename?: 'FailureReasons', details: string, fullMessages: Array<string> } | null }, canDestroy: { __typename?: 'AuthorizationResult', value: boolean, message: string | null, reasons: { __typename?: 'FailureReasons', details: string, fullMessages: Array<string> } | null }, canUpdate: { __typename?: 'AuthorizationResult', value: boolean, message: string | null, reasons: { __typename?: 'FailureReasons', details: string, fullMessages: Array<string> } | null }, canReschedule: { __typename?: 'AuthorizationResult', value: boolean, message: string | null, reasons: { __typename?: 'FailureReasons', details: string, fullMessages: Array<string> } | null }, canQrCodeRelatedInfoUpdate: { __typename?: 'AuthorizationResult', value: boolean, message: string | null, reasons: { __typename?: 'FailureReasons', details: string, fullMessages: Array<string> } | null } } | null };

export type DashboardFullTaskQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DashboardFullTaskQuery = { __typename?: 'Query', data: { __typename?: 'Task', id: string, groupKey: string, kind: TaskKindEnum, name: string, description: string | null, priority: TaskPriorityEnum, status: TaskStatusEnum, completedAt: any | null, recurringRuleId: string | null, lastDeadlineAt: any | null, lateFor: number | null, createdAt: any, deadlineAt: any | null, archivedAt: any | null, lastCheckAt: any | null, originalCreatedAt: any, earlyCompletion: number | null, earlyCompletionUnit: TaskEarlyCompletionUnitEnum | null, formTemplate: { __typename?: 'FormTemplate', id: string, name: string, canUpdate: { __typename?: 'AuthorizationResult', value: boolean } }, formTemplateVersion: { __typename?: 'FormTemplateVersion', id: string, version: string | null }, recurringRule: { __typename?: 'RecurringRule', endsAfterOccurrences: number | null, endTime: any | null, id: string, countdownType: RecurringRuleCountdownTypeEnum | null, excludedWdays: Array<number> | null, startTime: any, schema: { __typename?: 'RecurringRuleSchema', rrules: Array<{ __typename?: 'RecurringRuleSchemaRule', interval: number, ruleType: RecurringRuleRuleTypeEnum, validations: { __typename?: 'RecurringRuleValidations', day: Array<number> | null, dayOfWeek: any | null, dayOfMonth: Array<number> | null, monthOfYear: Array<number> | null } | null }>, metadata: { __typename?: 'RecurringRuleSchemaMetadata', schemaOption: RecurringRuleSchemaOptionEnum } | null } } | null, completion: { __typename?: 'TaskCompletion', validityHint: FormTemplateQuestionFieldOptionsValidityHintEnum | null, status: TaskCompletionStatusEnum | null, solvedAt: any | null } | null, site: { __typename?: 'Site', id: string, name: string } | null, siteArea: { __typename?: 'SiteArea', id: string, name: string, fullCode: string } | null, approver: { __typename?: 'User', id: string, firstName: string, lastName: string, avatarAttached: { __typename?: 'Attachment', id: string, processed: boolean, fileTag: string | null, fileData: any | null, filename: string | null, urls: { __typename?: 'AttachmentUrl', large: string | null, medium: string | null, original: string | null, small: string | null, imagePreview: string | null, originalDirectDownload: string | null, video480p: string | null, video720p: string | null, video1080p: string | null } | null, metadata: { __typename?: 'AttachmentMetadata', intendedUse: string | null } | null } | null } | null, asset: { __typename?: 'Asset', id: string, name: string, fullCode: string, siteArea: { __typename?: 'SiteArea', code: string } | null, iconAttached: { __typename?: 'Attachment', id: string, processed: boolean, fileTag: string | null, fileData: any | null, filename: string | null, urls: { __typename?: 'AttachmentUrl', large: string | null, medium: string | null, original: string | null, small: string | null, imagePreview: string | null, originalDirectDownload: string | null, video480p: string | null, video720p: string | null, video1080p: string | null } | null, metadata: { __typename?: 'AttachmentMetadata', intendedUse: string | null } | null } | null } | null, canArchive: { __typename?: 'AuthorizationResult', value: boolean, message: string | null, reasons: { __typename?: 'FailureReasons', details: string, fullMessages: Array<string> } | null }, canDestroy: { __typename?: 'AuthorizationResult', value: boolean, message: string | null, reasons: { __typename?: 'FailureReasons', details: string, fullMessages: Array<string> } | null }, canUpdate: { __typename?: 'AuthorizationResult', value: boolean, message: string | null, reasons: { __typename?: 'FailureReasons', details: string, fullMessages: Array<string> } | null }, canReschedule: { __typename?: 'AuthorizationResult', value: boolean, message: string | null, reasons: { __typename?: 'FailureReasons', details: string, fullMessages: Array<string> } | null }, canQrCodeRelatedInfoUpdate: { __typename?: 'AuthorizationResult', value: boolean, message: string | null, reasons: { __typename?: 'FailureReasons', details: string, fullMessages: Array<string> } | null } } | null };

export type DashboardTaskFormTemplateQueryVariables = Exact<{
  id: Scalars['ID']['input'];
  isViewLocked?: Scalars['Boolean']['input'];
}>;


export type DashboardTaskFormTemplateQuery = { __typename?: 'Query', data: { __typename?: 'Task', id: string, name: string, status: TaskStatusEnum, formTemplate: { __typename?: 'FormTemplate', hasLinkedDocumentations: boolean | null, description: string | null, id: string, name: string, createdAt: any, updatedAt: any, canUpdate: { __typename?: 'AuthorizationResult', value: boolean }, category: { __typename?: 'FormCategory', color: ColorEnum, name: string, id: string } | null }, formTemplateVersion: { __typename?: 'FormTemplateVersion', id: string, version: string | null, canUpdate: { __typename?: 'AuthorizationResult', value: boolean }, questions: Array<{ __typename?: 'FormTemplateQuestion', id: string, templateId: string, position: number, description: string | null, name: string | null, attachmentsAttached: Array<{ __typename?: 'Attachment', id: string, processed: boolean, fileTag: string | null, fileData: any | null, filename: string | null, urls: { __typename?: 'AttachmentUrl', large: string | null, medium: string | null, original: string | null, small: string | null, imagePreview: string | null, originalDirectDownload: string | null, video480p: string | null, video720p: string | null, video1080p: string | null } | null, metadata: { __typename?: 'AttachmentMetadata', intendedUse: string | null } | null }>, fields: Array<{ __typename?: 'FormTemplateQuestionField', id: string, kind: FormTemplateQuestionFieldsKindEnum, required: boolean, settings: { __typename?: 'FormTemplateQuestionFieldSettings', allowDisplayLastAnswer: boolean | null, limitToOneRespPerColumn: boolean | null, limitToOneRespPerRow: boolean | null, limitToOneResp: boolean | null }, options: Array<{ __typename?: 'FormTemplateQuestionFieldOption', id: string, group: FormTemplateQuestionFieldOptionGroupEnum | null, position: number, values: Array<string>, validityHint: FormTemplateQuestionFieldOptionsValidityHintEnum | null, condition: FormTemplateQuestionFieldOptionConditionEnum | null, optionDocumentation?: { __typename?: 'FormTemplateQuestionFieldOptionDocumentation', id: string, documentationId: string, requiredToRead: boolean } | null }>, validityHintConfig: Array<{ __typename?: 'FormTemplateQuestionFieldValidityHintConfig', optionPositions: Array<number>, validityHint: FormTemplateQuestionFieldOptionsValidityHintEnum }> }> }> }, canArchive: { __typename?: 'AuthorizationResult', value: boolean, message: string | null, reasons: { __typename?: 'FailureReasons', details: string, fullMessages: Array<string> } | null }, canDestroy: { __typename?: 'AuthorizationResult', value: boolean, message: string | null, reasons: { __typename?: 'FailureReasons', details: string, fullMessages: Array<string> } | null }, canUpdate: { __typename?: 'AuthorizationResult', value: boolean, message: string | null, reasons: { __typename?: 'FailureReasons', details: string, fullMessages: Array<string> } | null }, canReschedule: { __typename?: 'AuthorizationResult', value: boolean, message: string | null, reasons: { __typename?: 'FailureReasons', details: string, fullMessages: Array<string> } | null }, canQrCodeRelatedInfoUpdate: { __typename?: 'AuthorizationResult', value: boolean, message: string | null, reasons: { __typename?: 'FailureReasons', details: string, fullMessages: Array<string> } | null } } | null };

export type DashboardTaskScheduleQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DashboardTaskScheduleQuery = { __typename?: 'Query', data: { __typename?: 'Task', id: string, kind: TaskKindEnum, deadlineAt: any | null, earlyCompletion: number | null, earlyCompletionUnit: TaskEarlyCompletionUnitEnum | null, recurringRule: { __typename?: 'RecurringRule', endsAfterOccurrences: number | null, endTime: any | null, id: string, countdownType: RecurringRuleCountdownTypeEnum | null, excludedWdays: Array<number> | null, startTime: any, schema: { __typename?: 'RecurringRuleSchema', rrules: Array<{ __typename?: 'RecurringRuleSchemaRule', interval: number, ruleType: RecurringRuleRuleTypeEnum, validations: { __typename?: 'RecurringRuleValidations', day: Array<number> | null, dayOfWeek: any | null, dayOfMonth: Array<number> | null, monthOfYear: Array<number> | null } | null }>, metadata: { __typename?: 'RecurringRuleSchemaMetadata', schemaOption: RecurringRuleSchemaOptionEnum } | null } } | null } | null };

export type DashboardTaskShortQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DashboardTaskShortQuery = { __typename?: 'Query', data: { __typename?: 'Task', id: string, name: string, assetId: string | null, siteId: string | null, siteAreaId: string | null, groupKey: string, formTemplate: { __typename?: 'FormTemplate', id: string }, formTemplateVersion: { __typename?: 'FormTemplateVersion', id: string, version: string | null }, canInterventionCreate: { __typename?: 'AuthorizationResult', value: boolean, message: string | null, reasons: { __typename?: 'FailureReasons', details: string, fullMessages: Array<string> } | null } } | null };

export type DashboardTasksQueryVariables = Exact<{
  page?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  scope: TaskScopeInputObject;
  filters?: InputMaybe<Array<TaskFilterInputObject> | TaskFilterInputObject>;
  sorts?: InputMaybe<TaskSortInputObject>;
  includeArchivedAt?: InputMaybe<Scalars['Boolean']['input']>;
  includeCompletedAt?: InputMaybe<Scalars['Boolean']['input']>;
  includeCompletion?: InputMaybe<Scalars['Boolean']['input']>;
  includeDeadlineAt?: InputMaybe<Scalars['Boolean']['input']>;
  includeDeadlineMissedReason?: InputMaybe<Scalars['Boolean']['input']>;
  includeFormTemplate?: InputMaybe<Scalars['Boolean']['input']>;
  includeLastCheckAt?: InputMaybe<Scalars['Boolean']['input']>;
  includeLateFor?: InputMaybe<Scalars['Boolean']['input']>;
  includeAsset?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type DashboardTasksQuery = { __typename?: 'Query', tasks: { __typename?: 'TaskCollection', collection: Array<{ __typename?: 'Task', id: string, name: string, priority: TaskPriorityEnum, status: TaskStatusEnum, kind: TaskKindEnum, recurringRuleId: string | null, deadlineAt?: any | null, lastCheckAt?: any | null, archivedAt?: any | null, completedAt?: any | null, lateFor?: number | null, deadlineMissedReason?: TaskDeadlineMissedReasonEnum | null, site: { __typename?: 'Site', id: string, name: string } | null, siteArea: { __typename?: 'SiteArea', id: string, name: string } | null, canArchive: { __typename?: 'AuthorizationResult', value: boolean, message: string | null, reasons: { __typename?: 'FailureReasons', details: string, fullMessages: Array<string> } | null }, canDestroy: { __typename?: 'AuthorizationResult', value: boolean, message: string | null, reasons: { __typename?: 'FailureReasons', details: string, fullMessages: Array<string> } | null }, canUpdate: { __typename?: 'AuthorizationResult', value: boolean, message: string | null, reasons: { __typename?: 'FailureReasons', details: string, fullMessages: Array<string> } | null }, canReschedule: { __typename?: 'AuthorizationResult', value: boolean, message: string | null, reasons: { __typename?: 'FailureReasons', details: string, fullMessages: Array<string> } | null }, asset?: { __typename?: 'Asset', id: string, name: string, fullCode: string, siteArea: { __typename?: 'SiteArea', code: string } | null, iconAttached: { __typename?: 'Attachment', id: string, processed: boolean, fileTag: string | null, fileData: any | null, filename: string | null, urls: { __typename?: 'AttachmentUrl', large: string | null, medium: string | null, original: string | null, small: string | null, imagePreview: string | null, originalDirectDownload: string | null, video480p: string | null, video720p: string | null, video1080p: string | null } | null, metadata: { __typename?: 'AttachmentMetadata', intendedUse: string | null } | null } | null } | null, formTemplate?: { __typename?: 'FormTemplate', id: string, category: { __typename?: 'FormCategory', id: string, name: string, color: ColorEnum } | null }, completion?: { __typename?: 'TaskCompletion', validityHint: FormTemplateQuestionFieldOptionsValidityHintEnum | null } | null }>, metadata: { __typename?: 'CollectionMetadata', currentPage: number, limitValue: number, totalCount: number, totalPages: number } }, active: { __typename?: 'TaskCollection', metadata: { __typename?: 'CollectionMetadata', totalCount: number } }, archived: { __typename?: 'TaskCollection', metadata: { __typename?: 'CollectionMetadata', totalCount: number } }, completed: { __typename?: 'TaskCollection', metadata: { __typename?: 'CollectionMetadata', totalCount: number } }, myApprovals: { __typename?: 'TaskCollection', metadata: { __typename?: 'CollectionMetadata', totalCount: number } }, pending: { __typename?: 'TaskCollection', metadata: { __typename?: 'CollectionMetadata', totalCount: number } }, deadlineMissed: { __typename?: 'TaskCollection', metadata: { __typename?: 'CollectionMetadata', totalCount: number } } };

export type FormTemplateTasksQueryVariables = Exact<{
  page?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  scope: TaskScopeInputObject;
  filters?: InputMaybe<Array<TaskFilterInputObject> | TaskFilterInputObject>;
  sorts?: InputMaybe<TaskSortInputObject>;
}>;


export type FormTemplateTasksQuery = { __typename?: 'Query', tasks: { __typename?: 'TaskCollection', collection: Array<{ __typename?: 'Task', id: string, name: string, status: TaskStatusEnum, recurringRuleId: string | null, site: { __typename?: 'Site', id: string, name: string } | null, siteArea: { __typename?: 'SiteArea', id: string, name: string } | null, asset: { __typename?: 'Asset', id: string, name: string, fullCode: string, siteArea: { __typename?: 'SiteArea', code: string } | null, iconAttached: { __typename?: 'Attachment', id: string, processed: boolean, fileTag: string | null, fileData: any | null, filename: string | null, urls: { __typename?: 'AttachmentUrl', large: string | null, medium: string | null, original: string | null, small: string | null, imagePreview: string | null, originalDirectDownload: string | null, video480p: string | null, video720p: string | null, video1080p: string | null } | null, metadata: { __typename?: 'AttachmentMetadata', intendedUse: string | null } | null } | null } | null, formTemplateVersion: { __typename?: 'FormTemplateVersion', id: string, version: string | null }, formTemplate: { __typename?: 'FormTemplate', id: string }, canFormTemplateVersionUpdate: { __typename?: 'AuthorizationResult', value: boolean } }>, metadata: { __typename?: 'CollectionMetadata', currentPage: number, limitValue: number, totalCount: number, totalPages: number } } };

export type DashboardTaskIdsQueryVariables = Exact<{
  scope: TaskScopeInputObject;
  filters?: InputMaybe<Array<TaskFilterInputObject> | TaskFilterInputObject>;
  sorts?: InputMaybe<TaskSortInputObject>;
  onlyIds?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type DashboardTaskIdsQuery = { __typename?: 'Query', data: { __typename?: 'TaskCollection', collection: Array<{ __typename?: 'Task', id: string, groupKey: string }> } };

export type DashboardOverviewTasksQueryVariables = Exact<{
  page?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  scope: TaskScopeInputObject;
  filters?: InputMaybe<Array<TaskFilterInputObject> | TaskFilterInputObject>;
  activeTasksFilters?: InputMaybe<Array<TaskFilterInputObject> | TaskFilterInputObject>;
  sorts?: InputMaybe<TaskSortInputObject>;
  includeCompletion?: InputMaybe<Scalars['Boolean']['input']>;
  includeStatus?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type DashboardOverviewTasksQuery = { __typename?: 'Query', tasks: { __typename?: 'TaskCollection', collection: Array<{ __typename?: 'Task', id: string, name: string, deadlineAt: any | null, nextDeadlineAt: any | null, completedAt: any | null, assetId: string | null, priority: TaskPriorityEnum, status?: TaskStatusEnum, recurringRuleId: string | null, site: { __typename?: 'Site', id: string, name: string } | null, siteArea: { __typename?: 'SiteArea', id: string, name: string } | null, completion?: { __typename?: 'TaskCompletion', id: string, validityHint: FormTemplateQuestionFieldOptionsValidityHintEnum | null, status: TaskCompletionStatusEnum | null, solvedAt: any | null, canStatusUpdate: { __typename?: 'AuthorizationResult', value: boolean, message: string | null, reasons: { __typename?: 'FailureReasons', details: string, fullMessages: Array<string> } | null } } | null, intervention: { __typename?: 'Intervention', id: string, closedAt: any | null } | null, canInterventionCreate: { __typename?: 'AuthorizationResult', value: boolean, message: string | null, reasons: { __typename?: 'FailureReasons', details: string, fullMessages: Array<string> } | null }, canCompletionCreate: { __typename?: 'AuthorizationResult', value: boolean, message: string | null, reasons: { __typename?: 'FailureReasons', details: string, fullMessages: Array<string> } | null } }>, metadata: { __typename?: 'CollectionMetadata', currentPage: number, limitValue: number, totalCount: number, totalPages: number } }, active: { __typename?: 'TaskCollection', metadata: { __typename?: 'CollectionMetadata', totalCount: number } }, completed: { __typename?: 'TaskCollection', metadata: { __typename?: 'CollectionMetadata', totalCount: number } }, failure: { __typename?: 'TaskCollection', metadata: { __typename?: 'CollectionMetadata', totalCount: number } }, solved: { __typename?: 'TaskCollection', metadata: { __typename?: 'CollectionMetadata', totalCount: number } }, success: { __typename?: 'TaskCollection', metadata: { __typename?: 'CollectionMetadata', totalCount: number } }, warning: { __typename?: 'TaskCollection', metadata: { __typename?: 'CollectionMetadata', totalCount: number } }, warningUnsolved: { __typename?: 'TaskCollection', metadata: { __typename?: 'CollectionMetadata', totalCount: number } }, warningSolved: { __typename?: 'TaskCollection', metadata: { __typename?: 'CollectionMetadata', totalCount: number } }, failureUnsolved: { __typename?: 'TaskCollection', metadata: { __typename?: 'CollectionMetadata', totalCount: number } }, failureSolved: { __typename?: 'TaskCollection', metadata: { __typename?: 'CollectionMetadata', totalCount: number } }, dashboardAll: { __typename?: 'TaskCollection', metadata: { __typename?: 'CollectionMetadata', totalCount: number } }, deadlineMissedWithoutReason: { __typename?: 'TaskCollection', metadata: { __typename?: 'CollectionMetadata', totalCount: number } } };

export type DashboardTimelineTasksQueryVariables = Exact<{
  page?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  scope: TaskScopeInputObject;
  filters?: InputMaybe<Array<TaskFilterInputObject> | TaskFilterInputObject>;
  sorts?: InputMaybe<TaskSortInputObject>;
}>;


export type DashboardTimelineTasksQuery = { __typename?: 'Query', tasks: { __typename?: 'TaskCollection', collection: Array<{ __typename?: 'Task', id: string, name: string, deadlineAt: any | null, completedAt: any | null, archivedAt: any | null, priority: TaskPriorityEnum, status: TaskStatusEnum, recurringRuleId: string | null, formTemplate: { __typename?: 'FormTemplate', id: string, category: { __typename?: 'FormCategory', id: string, name: string, color: ColorEnum } | null }, site: { __typename?: 'Site', id: string, name: string } | null, siteArea: { __typename?: 'SiteArea', id: string, name: string } | null }>, metadata: { __typename?: 'CollectionMetadata', currentPage: number, limitValue: number, totalCount: number, totalPages: number } }, taskIds: { __typename?: 'TaskCollection', collection: Array<{ __typename?: 'Task', id: string }> }, timelineAll: { __typename?: 'TaskCollection', metadata: { __typename?: 'CollectionMetadata', totalCount: number } }, timelineFailure: { __typename?: 'TaskCollection', metadata: { __typename?: 'CollectionMetadata', totalCount: number } }, timelineWarning: { __typename?: 'TaskCollection', metadata: { __typename?: 'CollectionMetadata', totalCount: number } } };

export type TasksTimelineQueryVariables = Exact<{
  taskIds: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
  queryData: TaskTimelineQueryDataInputObject;
}>;


export type TasksTimelineQuery = { __typename?: 'Query', tasksTimeline: Array<{ __typename?: 'TaskTimeline', id: string, rows: Array<{ __typename?: 'TaskTimelineRow', date: string, validityHintCounters: { __typename?: 'TaskTimelineValidityHintCounter', failure: number | null, none: number | null, success: number | null, warning: number | null } }> }> };

export type TasksSearchListQueryVariables = Exact<{
  page?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  scope: TaskScopeInputObject;
  filters?: InputMaybe<Array<TaskFilterInputObject> | TaskFilterInputObject>;
  sorts?: InputMaybe<TaskSortInputObject>;
}>;


export type TasksSearchListQuery = { __typename?: 'Query', data: { __typename?: 'TaskCollection', collection: Array<{ __typename?: 'Task', id: string, name: string, groupKey: string }>, metadata: { __typename?: 'CollectionMetadata', currentPage: number, limitValue: number, totalCount: number, totalPages: number } } };

export type TaskCompletionsQueryVariables = Exact<{
  page?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  groupKey: Scalars['ID']['input'];
  filters?: InputMaybe<Array<TaskCompletionFilterInputObject> | TaskCompletionFilterInputObject>;
  sorts?: InputMaybe<TaskCompletionSortInputObject>;
}>;


export type TaskCompletionsQuery = { __typename?: 'Query', data: { __typename?: 'TaskCompletionCollection', collection: Array<{ __typename?: 'TaskCompletion', id: string, taskId: string | null, createdAt: any, solvedAt: any | null, status: TaskCompletionStatusEnum | null, answers: Array<{ __typename?: 'FormAnswer', id: string, kind: FormTemplateQuestionFieldsKindEnum, validityHint: FormTemplateQuestionFieldOptionsValidityHintEnum | null, resp: Array<{ __typename?: 'FormAnswerResp', optionId: string | null, selected: boolean | null, value: string | null, valueId: string | null, status: FormAnswerDocumentStatusEnum | null, statusReason: FormAnswerDocumentStatusReasonEnum | null }> }> | null, task: { __typename?: 'Task', assetId: string | null, siteAreaId: string | null, siteId: string | null, formTemplateVersion: { __typename?: 'FormTemplateVersion', id: string, version: string | null }, canInterventionCreate: { __typename?: 'AuthorizationResult', value: boolean, message: string | null, reasons: { __typename?: 'FailureReasons', details: string, fullMessages: Array<string> } | null }, intervention: { __typename?: 'Intervention', id: string } | null } | null, performer: { __typename?: 'User', id: string, firstName: string, lastName: string, avatarAttached: { __typename?: 'Attachment', id: string, processed: boolean, fileTag: string | null, fileData: any | null, filename: string | null, urls: { __typename?: 'AttachmentUrl', large: string | null, medium: string | null, original: string | null, small: string | null, imagePreview: string | null, originalDirectDownload: string | null, video480p: string | null, video720p: string | null, video1080p: string | null } | null, metadata: { __typename?: 'AttachmentMetadata', intendedUse: string | null } | null } | null } | null }>, metadata: { __typename?: 'CollectionMetadata', currentPage: number, limitValue: number, totalCount: number, totalPages: number } } };

export type TaskCompletionsIdsQueryVariables = Exact<{
  page?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  groupKey: Scalars['ID']['input'];
  filters?: InputMaybe<Array<TaskCompletionFilterInputObject> | TaskCompletionFilterInputObject>;
  sorts?: InputMaybe<TaskCompletionSortInputObject>;
}>;


export type TaskCompletionsIdsQuery = { __typename?: 'Query', data: { __typename?: 'TaskCompletionCollection', collection: Array<{ __typename?: 'TaskCompletion', id: string }> } };

export type TaskCompletionQueryVariables = Exact<{
  id: Scalars['ID']['input'];
  isViewLocked?: Scalars['Boolean']['input'];
}>;


export type TaskCompletionQuery = { __typename?: 'Query', data: { __typename?: 'TaskCompletion', id: string, createdAt: any, validityHint: FormTemplateQuestionFieldOptionsValidityHintEnum | null, answers: Array<{ __typename?: 'FormAnswer', id: string, kind: FormTemplateQuestionFieldsKindEnum, fieldId: string, validityHint: FormTemplateQuestionFieldOptionsValidityHintEnum | null, questionId: string, field: { __typename?: 'FormTemplateQuestionField', id: string, options: Array<{ __typename?: 'FormTemplateQuestionFieldOption', id: string, fieldId: string, group: FormTemplateQuestionFieldOptionGroupEnum | null, position: number, values: Array<string>, optionDocumentation?: { __typename?: 'FormTemplateQuestionFieldOptionDocumentation', documentationId: string } | null }> }, resp: Array<{ __typename?: 'FormAnswerResp', validityHint: FormTemplateQuestionFieldOptionsValidityHintEnum | null, group: FormAnswerRespGroupEnum | null, optionId: string | null, position: number | null, selected: boolean | null, value: string | null, valueId: string | null, status: FormAnswerDocumentStatusEnum | null, statusReason: FormAnswerDocumentStatusReasonEnum | null, documentationVersionViewId: string | null }>, documentationVersionViews: Array<{ __typename?: 'DocumentationVersionView', id: string, documentationId: string, readingDurationSeconds: number | null }>, attachmentsAttached: Array<{ __typename?: 'Attachment', id: string, processed: boolean, fileTag: string | null, fileData: any | null, filename: string | null, urls: { __typename?: 'AttachmentUrl', large: string | null, medium: string | null, original: string | null, small: string | null, imagePreview: string | null, originalDirectDownload: string | null, video480p: string | null, video720p: string | null, video1080p: string | null } | null, metadata: { __typename?: 'AttachmentMetadata', intendedUse: string | null } | null }> }> | null, task: { __typename?: 'Task', assetId: string | null, siteAreaId: string | null, siteId: string | null, formTemplateVersion: { __typename?: 'FormTemplateVersion', id: string, version: string | null, questions: Array<{ __typename?: 'FormTemplateQuestion', id: string, position: number, name: string | null, attachmentsAttached: Array<{ __typename?: 'Attachment', id: string, processed: boolean, fileTag: string | null, fileData: any | null, filename: string | null, urls: { __typename?: 'AttachmentUrl', large: string | null, medium: string | null, original: string | null, small: string | null, imagePreview: string | null, originalDirectDownload: string | null, video480p: string | null, video720p: string | null, video1080p: string | null } | null, metadata: { __typename?: 'AttachmentMetadata', intendedUse: string | null } | null }>, fields: Array<{ __typename?: 'FormTemplateQuestionField', id: string, kind: FormTemplateQuestionFieldsKindEnum, required: boolean, position: number, options: Array<{ __typename?: 'FormTemplateQuestionFieldOption', id: string, group: FormTemplateQuestionFieldOptionGroupEnum | null, position: number, values: Array<string>, validityHint: FormTemplateQuestionFieldOptionsValidityHintEnum | null, optionDocumentation?: { __typename?: 'FormTemplateQuestionFieldOptionDocumentation', documentationId: string } | null }>, settings: { __typename?: 'FormTemplateQuestionFieldSettings', limitToOneRespPerColumn: boolean | null, limitToOneRespPerRow: boolean | null, limitToOneResp: boolean | null } }> }> }, canInterventionCreate: { __typename?: 'AuthorizationResult', value: boolean, message: string | null, reasons: { __typename?: 'FailureReasons', details: string, fullMessages: Array<string> } | null }, intervention: { __typename?: 'Intervention', id: string } | null } | null, performer: { __typename?: 'User', id: string, firstName: string, lastName: string, avatarAttached: { __typename?: 'Attachment', id: string, processed: boolean, fileTag: string | null, fileData: any | null, filename: string | null, urls: { __typename?: 'AttachmentUrl', large: string | null, medium: string | null, original: string | null, small: string | null, imagePreview: string | null, originalDirectDownload: string | null, video480p: string | null, video720p: string | null, video1080p: string | null } | null, metadata: { __typename?: 'AttachmentMetadata', intendedUse: string | null } | null } | null } | null } | null };

export type TasksMyTodoCompletableByDateDataQueryVariables = Exact<{
  date: Scalars['ISO8601DateTime']['input'];
}>;


export type TasksMyTodoCompletableByDateDataQuery = { __typename?: 'Query', data: Array<{ __typename?: 'TasksTodoCompletableByDateData', id: string, offlineImportantDataDigest: string }> };

export type TasksDuplicatesListQueryVariables = Exact<{
  page?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  scope: TaskScopeInputObject;
  filters?: InputMaybe<Array<TaskFilterInputObject> | TaskFilterInputObject>;
  sorts?: InputMaybe<TaskSortInputObject>;
}>;


export type TasksDuplicatesListQuery = { __typename?: 'Query', tasks: { __typename?: 'TaskCollection', collection: Array<{ __typename?: 'Task', id: string, name: string, status: TaskStatusEnum, kind: TaskKindEnum, priority: TaskPriorityEnum, recurringRuleId: string | null, site: { __typename?: 'Site', id: string, name: string } | null, siteArea: { __typename?: 'SiteArea', id: string, name: string } | null, formTemplate: { __typename?: 'FormTemplate', id: string, name: string, category: { __typename?: 'FormCategory', color: ColorEnum, name: string, id: string } | null } }>, metadata: { __typename?: 'CollectionMetadata', currentPage: number, limitValue: number, totalCount: number, totalPages: number } } };

export type TasksMultiselectListQueryVariables = Exact<{
  page?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  scope: TaskScopeInputObject;
  filters?: InputMaybe<Array<TaskFilterInputObject> | TaskFilterInputObject>;
  sorts?: InputMaybe<TaskSortInputObject>;
}>;


export type TasksMultiselectListQuery = { __typename?: 'Query', tasks: { __typename?: 'TaskCollection', collection: Array<{ __typename?: 'Task', id: string, name: string, groupKey: string, kind: TaskKindEnum, recurringRuleId: string | null, priority: TaskPriorityEnum, site: { __typename?: 'Site', id: string, name: string } | null, siteArea: { __typename?: 'SiteArea', id: string, name: string } | null, asset: { __typename?: 'Asset', id: string, name: string, fullCode: string, siteArea: { __typename?: 'SiteArea', code: string } | null, iconAttached: { __typename?: 'Attachment', id: string, processed: boolean, fileTag: string | null, fileData: any | null, filename: string | null, urls: { __typename?: 'AttachmentUrl', large: string | null, medium: string | null, original: string | null, small: string | null, imagePreview: string | null, originalDirectDownload: string | null, video480p: string | null, video720p: string | null, video1080p: string | null } | null, metadata: { __typename?: 'AttachmentMetadata', intendedUse: string | null } | null } | null } | null, formTemplate: { __typename?: 'FormTemplate', id: string, name: string, category: { __typename?: 'FormCategory', color: ColorEnum, name: string, id: string } | null } }>, metadata: { __typename?: 'CollectionMetadata', currentPage: number, limitValue: number, totalCount: number, totalPages: number } } };

export type TaskCompletionCreateMutationVariables = Exact<{
  input: TaskCompletionCreateInputObject;
}>;


export type TaskCompletionCreateMutation = { __typename?: 'Mutation', taskCompletionCreate: { __typename?: 'TaskCompletion', id: string } | null };

export type TaskBulkCreateSameMutationVariables = Exact<{
  attributes: TaskBulkCreateSameInputObject;
}>;


export type TaskBulkCreateSameMutation = { __typename?: 'Mutation', data: Array<string> | null };

export type TaskUpdateMutationVariables = Exact<{
  attributes: TaskUpdateInputObject;
  id: Scalars['ID']['input'];
}>;


export type TaskUpdateMutation = { __typename?: 'Mutation', data: { __typename?: 'Task', id: string, groupKey: string, kind: TaskKindEnum, name: string, description: string | null, priority: TaskPriorityEnum, status: TaskStatusEnum, completedAt: any | null, recurringRuleId: string | null, lastDeadlineAt: any | null, lateFor: number | null, createdAt: any, deadlineAt: any | null, archivedAt: any | null, lastCheckAt: any | null, originalCreatedAt: any, completion: { __typename?: 'TaskCompletion', validityHint: FormTemplateQuestionFieldOptionsValidityHintEnum | null, status: TaskCompletionStatusEnum | null, solvedAt: any | null } | null, site: { __typename?: 'Site', id: string, name: string } | null, siteArea: { __typename?: 'SiteArea', id: string, name: string, fullCode: string } | null, approver: { __typename?: 'User', id: string, firstName: string, lastName: string, avatarAttached: { __typename?: 'Attachment', id: string, processed: boolean, fileTag: string | null, fileData: any | null, filename: string | null, urls: { __typename?: 'AttachmentUrl', large: string | null, medium: string | null, original: string | null, small: string | null, imagePreview: string | null, originalDirectDownload: string | null, video480p: string | null, video720p: string | null, video1080p: string | null } | null, metadata: { __typename?: 'AttachmentMetadata', intendedUse: string | null } | null } | null } | null, asset: { __typename?: 'Asset', id: string, name: string, fullCode: string, siteArea: { __typename?: 'SiteArea', code: string } | null, iconAttached: { __typename?: 'Attachment', id: string, processed: boolean, fileTag: string | null, fileData: any | null, filename: string | null, urls: { __typename?: 'AttachmentUrl', large: string | null, medium: string | null, original: string | null, small: string | null, imagePreview: string | null, originalDirectDownload: string | null, video480p: string | null, video720p: string | null, video1080p: string | null } | null, metadata: { __typename?: 'AttachmentMetadata', intendedUse: string | null } | null } | null } | null, formTemplate: { __typename?: 'FormTemplate', canUpdate: { __typename?: 'AuthorizationResult', value: boolean } }, canArchive: { __typename?: 'AuthorizationResult', value: boolean, message: string | null, reasons: { __typename?: 'FailureReasons', details: string, fullMessages: Array<string> } | null }, canDestroy: { __typename?: 'AuthorizationResult', value: boolean, message: string | null, reasons: { __typename?: 'FailureReasons', details: string, fullMessages: Array<string> } | null }, canUpdate: { __typename?: 'AuthorizationResult', value: boolean, message: string | null, reasons: { __typename?: 'FailureReasons', details: string, fullMessages: Array<string> } | null }, canReschedule: { __typename?: 'AuthorizationResult', value: boolean, message: string | null, reasons: { __typename?: 'FailureReasons', details: string, fullMessages: Array<string> } | null }, canQrCodeRelatedInfoUpdate: { __typename?: 'AuthorizationResult', value: boolean, message: string | null, reasons: { __typename?: 'FailureReasons', details: string, fullMessages: Array<string> } | null } } | null };

export type TaskBulkSchedulingMutationVariables = Exact<{
  ids: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
  attributes: TaskBulkSchedulingInputObject;
}>;


export type TaskBulkSchedulingMutation = { __typename?: 'Mutation', data: boolean | null };

export type TaskBulkUpdateStatusMutationVariables = Exact<{
  ids: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
  attributes: TaskUpdateStatusInputObject;
}>;


export type TaskBulkUpdateStatusMutation = { __typename?: 'Mutation', data: boolean | null };

export type TaskBulkDeadlineMissedReasonUpdateMutationVariables = Exact<{
  ids: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
  attributes: TaskUpdateDeadlineMissedReasonInputObject;
}>;


export type TaskBulkDeadlineMissedReasonUpdateMutation = { __typename?: 'Mutation', data: boolean | null };

export type TaskDestroyMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type TaskDestroyMutation = { __typename?: 'Mutation', data: boolean | null };

export type TaskUnlinkAllDocumentationsMutationVariables = Exact<{
  input: TaskUnlinkAllDocumentationsInput;
}>;


export type TaskUnlinkAllDocumentationsMutation = { __typename?: 'Mutation', data: boolean | null };

export type TaskCompletionStatusUpdateMutationVariables = Exact<{
  taskId: Scalars['ID']['input'];
  attributes: TaskCompletionUpdateStatusInputObject;
}>;


export type TaskCompletionStatusUpdateMutation = { __typename?: 'Mutation', data: { __typename?: 'TaskCompletion', id: string } | null };

export type TaskBulkTemplateVersionUpdateMutationVariables = Exact<{
  input: TaskBulkTemplateVersionUpdateInput;
}>;


export type TaskBulkTemplateVersionUpdateMutation = { __typename?: 'Mutation', data: boolean | null };

export type TaskTimelineReportCreateMutationVariables = Exact<{
  input: TasksTimelineReportCreateInput;
}>;


export type TaskTimelineReportCreateMutation = { __typename?: 'Mutation', data: { __typename?: 'BackgroundJob', id: string, jid: string | null, parentId: string | null, rootId: string, kind: BackgroundJobKindEnum, status: BackgroundJobStatusEnum, displayStatus: BackgroundJobStatusEnum, treeStatus: BackgroundJobStatusEnum, done: number, total: number, failed: number, pctComplete: number, message: string | null, errorCode: string | null, result: any | null, estimatedFinishAt: any | null, startedAt: any | null, finishedAt: any | null, cancelRequestedAt: any | null, deliveryRequestedAt: any | null, dismissed: boolean, createdAt: any, updatedAt: any, children: Array<{ __typename?: 'BackgroundJob', id: string, jid: string | null, parentId: string | null, rootId: string, kind: BackgroundJobKindEnum, status: BackgroundJobStatusEnum, displayStatus: BackgroundJobStatusEnum, treeStatus: BackgroundJobStatusEnum, done: number, total: number, failed: number, pctComplete: number, message: string | null, errorCode: string | null, result: any | null, estimatedFinishAt: any | null, startedAt: any | null, finishedAt: any | null, cancelRequestedAt: any | null, deliveryRequestedAt: any | null, dismissed: boolean, createdAt: any, updatedAt: any, canCancel: { __typename?: 'AuthorizationResult', value: boolean, message: string | null, reasons: { __typename?: 'FailureReasons', details: string, fullMessages: Array<string> } | null }, canDismiss: { __typename?: 'AuthorizationResult', value: boolean, message: string | null, reasons: { __typename?: 'FailureReasons', details: string, fullMessages: Array<string> } | null }, canRequestDelivery: { __typename?: 'AuthorizationResult', value: boolean, message: string | null, reasons: { __typename?: 'FailureReasons', details: string, fullMessages: Array<string> } | null }, canRequeue: { __typename?: 'AuthorizationResult', value: boolean, message: string | null, reasons: { __typename?: 'FailureReasons', details: string, fullMessages: Array<string> } | null } }>, canCancel: { __typename?: 'AuthorizationResult', value: boolean, message: string | null, reasons: { __typename?: 'FailureReasons', details: string, fullMessages: Array<string> } | null }, canDismiss: { __typename?: 'AuthorizationResult', value: boolean, message: string | null, reasons: { __typename?: 'FailureReasons', details: string, fullMessages: Array<string> } | null }, canRequestDelivery: { __typename?: 'AuthorizationResult', value: boolean, message: string | null, reasons: { __typename?: 'FailureReasons', details: string, fullMessages: Array<string> } | null }, canRequeue: { __typename?: 'AuthorizationResult', value: boolean, message: string | null, reasons: { __typename?: 'FailureReasons', details: string, fullMessages: Array<string> } | null } } | null };

export type TeamFragmentFragment = { __typename?: 'Team', id: string, name: string | null, description: string | null, color: ColorEnum, readOnly: boolean, canDestroy: { __typename?: 'AuthorizationResult', value: boolean, message: string | null, reasons: { __typename?: 'FailureReasons', details: string, fullMessages: Array<string> } | null }, accesses: Array<{ __typename?: 'Access', component: AccessComponentEnum, itemIds: Array<string>, level: AccessLevelEnum | null, scopeLevel: AccessScopeLevelEnum | null }> };

export type TeamsQueryVariables = Exact<{
  page?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  sorts?: InputMaybe<TeamSortInputObject>;
  filters?: InputMaybe<Array<TeamFilterInputObject> | TeamFilterInputObject>;
}>;


export type TeamsQuery = { __typename?: 'Query', data: { __typename?: 'TeamCollection', collection: Array<{ __typename?: 'Team', id: string, name: string | null, color: ColorEnum, visibleUsersCount: number | null, readOnly: boolean, canDestroy: { __typename?: 'AuthorizationResult', value: boolean, message: string | null, reasons: { __typename?: 'FailureReasons', details: string, fullMessages: Array<string> } | null } }>, metadata: { __typename?: 'CollectionMetadata', currentPage: number, limitValue: number, totalCount: number, totalPages: number } } };

export type TeamsIdsQueryVariables = Exact<{
  page?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  sorts?: InputMaybe<TeamSortInputObject>;
  filters?: InputMaybe<Array<TeamFilterInputObject> | TeamFilterInputObject>;
  onlyIds?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type TeamsIdsQuery = { __typename?: 'Query', data: { __typename?: 'TeamCollection', collection: Array<{ __typename?: 'Team', id: string }> } };

export type TeamsSearchListQueryVariables = Exact<{
  page?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  sorts?: InputMaybe<TeamSortInputObject>;
  filters?: InputMaybe<Array<TeamFilterInputObject> | TeamFilterInputObject>;
}>;


export type TeamsSearchListQuery = { __typename?: 'Query', data: { __typename?: 'TeamCollection', collection: Array<{ __typename?: 'Team', id: string, name: string | null, color: ColorEnum }>, metadata: { __typename?: 'CollectionMetadata', currentPage: number, limitValue: number, totalCount: number, totalPages: number } } };

export type TeamQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type TeamQuery = { __typename?: 'Query', data: { __typename?: 'Team', id: string, name: string | null, description: string | null, color: ColorEnum, readOnly: boolean, canDestroy: { __typename?: 'AuthorizationResult', value: boolean, message: string | null, reasons: { __typename?: 'FailureReasons', details: string, fullMessages: Array<string> } | null }, accesses: Array<{ __typename?: 'Access', component: AccessComponentEnum, itemIds: Array<string>, level: AccessLevelEnum | null, scopeLevel: AccessScopeLevelEnum | null }> } | null };

export type TeamCreateMutationVariables = Exact<{
  attributes: TeamCreateInputObject;
}>;


export type TeamCreateMutation = { __typename?: 'Mutation', data: { __typename?: 'Team', id: string, name: string | null, description: string | null, color: ColorEnum, readOnly: boolean, canDestroy: { __typename?: 'AuthorizationResult', value: boolean, message: string | null, reasons: { __typename?: 'FailureReasons', details: string, fullMessages: Array<string> } | null }, accesses: Array<{ __typename?: 'Access', component: AccessComponentEnum, itemIds: Array<string>, level: AccessLevelEnum | null, scopeLevel: AccessScopeLevelEnum | null }> } | null };

export type TeamUpdateMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  attributes: TeamUpdateInputObject;
}>;


export type TeamUpdateMutation = { __typename?: 'Mutation', data: { __typename?: 'Team', id: string, name: string | null, description: string | null, color: ColorEnum, readOnly: boolean, canDestroy: { __typename?: 'AuthorizationResult', value: boolean, message: string | null, reasons: { __typename?: 'FailureReasons', details: string, fullMessages: Array<string> } | null }, accesses: Array<{ __typename?: 'Access', component: AccessComponentEnum, itemIds: Array<string>, level: AccessLevelEnum | null, scopeLevel: AccessScopeLevelEnum | null }> } | null };

export type TeamDestroyMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type TeamDestroyMutation = { __typename?: 'Mutation', data: boolean | null };

export type FullUserFragmentFragment = { __typename?: 'User', deactivatedAt: any | null, id: string, firstName: string, lastName: string, email: string | null, passwordSetupRequired: boolean, role: UserRoleEnum, personalId: string | null, phoneNumber: string | null, lang: LanguageEnum, verified: boolean | null, unconfirmedEmail: string | null, username: string | null, avatarAttached: { __typename?: 'Attachment', id: string, processed: boolean, fileTag: string | null, fileData: any | null, filename: string | null, urls: { __typename?: 'AttachmentUrl', large: string | null, medium: string | null, original: string | null, small: string | null, imagePreview: string | null, originalDirectDownload: string | null, video480p: string | null, video720p: string | null, video1080p: string | null } | null, metadata: { __typename?: 'AttachmentMetadata', intendedUse: string | null } | null } | null, sites: { __typename?: 'SiteCollection', collection: Array<{ __typename?: 'Site', id: string, name: string }> }, company: { __typename?: 'Company', id: string, name: string }, team: { __typename?: 'Team', id: string, name: string | null, color: ColorEnum } };

export type UsersQueryVariables = Exact<{
  page?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  sorts?: InputMaybe<UserSortInputObject>;
  filters?: InputMaybe<Array<UserFilterInputObject> | UserFilterInputObject>;
  scope?: InputMaybe<UserScopeInputObject>;
  includeFullData?: InputMaybe<Scalars['Boolean']['input']>;
  includeShortData?: InputMaybe<Scalars['Boolean']['input']>;
  includeFinalAccesses?: InputMaybe<Scalars['Boolean']['input']>;
  includePersonalAccesses?: InputMaybe<Scalars['Boolean']['input']>;
  includeTeamAccesses?: InputMaybe<Scalars['Boolean']['input']>;
  includeTeamData?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type UsersQuery = { __typename?: 'Query', data: { __typename?: 'UserCollection', collection: Array<{ __typename?: 'User', id: string, firstName: string, lastName: string, email: string | null, passwordSetupRequired?: boolean, role: UserRoleEnum, personalId?: string | null, unconfirmedEmail?: string | null, verified?: boolean | null, deactivatedAt?: any | null, avatarAttached: { __typename?: 'Attachment', id: string, processed: boolean, fileTag: string | null, fileData: any | null, filename: string | null, urls: { __typename?: 'AttachmentUrl', large: string | null, medium: string | null, original: string | null, small: string | null, imagePreview: string | null, originalDirectDownload: string | null, video480p: string | null, video720p: string | null, video1080p: string | null } | null, metadata: { __typename?: 'AttachmentMetadata', intendedUse: string | null } | null } | null, sites?: { __typename?: 'SiteCollection', collection: Array<{ __typename?: 'Site', id: string, name: string }> }, sectors?: { __typename?: 'SectorCollection', collection: Array<{ __typename?: 'Sector', id: string, name: string | null, color: ColorEnum | null }> }, team?: { __typename?: 'Team', id: string, name: string | null, color: ColorEnum, accesses: Array<{ __typename?: 'Access', component: AccessComponentEnum, itemIds: Array<string>, level: AccessLevelEnum | null, scopeLevel: AccessScopeLevelEnum | null, policy: AccessPolicyEnum | null }> }, finalAccesses?: Array<{ __typename?: 'Access', component: AccessComponentEnum, itemIds: Array<string>, level: AccessLevelEnum | null, scopeLevel: AccessScopeLevelEnum | null, policy: AccessPolicyEnum | null }> | null, personalAccesses?: Array<{ __typename?: 'Access', component: AccessComponentEnum, itemIds: Array<string>, level: AccessLevelEnum | null, scopeLevel: AccessScopeLevelEnum | null, policy: AccessPolicyEnum | null }> }>, metadata: { __typename?: 'CollectionMetadata', currentPage: number, limitValue: number, totalCount: number, totalPages: number } } };

export type UsersIdsQueryVariables = Exact<{
  page?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  sorts?: InputMaybe<UserSortInputObject>;
  filters?: InputMaybe<Array<UserFilterInputObject> | UserFilterInputObject>;
  scope?: InputMaybe<UserScopeInputObject>;
  onlyIds?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type UsersIdsQuery = { __typename?: 'Query', data: { __typename?: 'UserCollection', collection: Array<{ __typename?: 'User', id: string }> } };

export type UsersCountersQueryVariables = Exact<{
  page?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  sorts?: InputMaybe<UserSortInputObject>;
  filters?: InputMaybe<Array<UserFilterInputObject> | UserFilterInputObject>;
  fullAdminsFilters?: InputMaybe<Array<UserFilterInputObject> | UserFilterInputObject>;
  usersFilters?: InputMaybe<Array<UserFilterInputObject> | UserFilterInputObject>;
  unassignedFilters?: InputMaybe<Array<UserFilterInputObject> | UserFilterInputObject>;
  scope?: InputMaybe<UserScopeInputObject>;
  onlyIds?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type UsersCountersQuery = { __typename?: 'Query', all: { __typename?: 'UserCollection', metadata: { __typename?: 'CollectionMetadata', totalCount: number } }, fullAdmins: { __typename?: 'UserCollection', metadata: { __typename?: 'CollectionMetadata', totalCount: number } }, users: { __typename?: 'UserCollection', metadata: { __typename?: 'CollectionMetadata', totalCount: number } }, unassigned: { __typename?: 'UserCollection', metadata: { __typename?: 'CollectionMetadata', totalCount: number } } };

export type UsersSearchListQueryVariables = Exact<{
  page?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  sorts?: InputMaybe<UserSortInputObject>;
  filters?: InputMaybe<Array<UserFilterInputObject> | UserFilterInputObject>;
  scope?: InputMaybe<UserScopeInputObject>;
}>;


export type UsersSearchListQuery = { __typename?: 'Query', data: { __typename?: 'UserCollection', collection: Array<{ __typename?: 'User', id: string, firstName: string, lastName: string, email: string | null, avatarAttached: { __typename?: 'Attachment', id: string, processed: boolean, fileTag: string | null, fileData: any | null, filename: string | null, urls: { __typename?: 'AttachmentUrl', large: string | null, medium: string | null, original: string | null, small: string | null, imagePreview: string | null, originalDirectDownload: string | null, video480p: string | null, video720p: string | null, video1080p: string | null } | null, metadata: { __typename?: 'AttachmentMetadata', intendedUse: string | null } | null } | null }>, metadata: { __typename?: 'CollectionMetadata', currentPage: number, limitValue: number, totalCount: number, totalPages: number } } };

export type UserQueryVariables = Exact<{
  id: Scalars['ID']['input'];
  includeFullData?: InputMaybe<Scalars['Boolean']['input']>;
  includeFinalAccesses?: InputMaybe<Scalars['Boolean']['input']>;
  includePersonalAccesses?: InputMaybe<Scalars['Boolean']['input']>;
  includeTeamAccesses?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type UserQuery = { __typename?: 'Query', data: { __typename?: 'User', id: string, firstName: string, lastName: string, email?: string | null, passwordSetupRequired: boolean, role: UserRoleEnum, personalId?: string | null, phoneNumber?: string | null, verified?: boolean | null, username?: string | null, deactivatedAt: any | null, avatarAttached: { __typename?: 'Attachment', id: string, processed: boolean, fileTag: string | null, fileData: any | null, filename: string | null, urls: { __typename?: 'AttachmentUrl', large: string | null, medium: string | null, original: string | null, small: string | null, imagePreview: string | null, originalDirectDownload: string | null, video480p: string | null, video720p: string | null, video1080p: string | null } | null, metadata: { __typename?: 'AttachmentMetadata', intendedUse: string | null } | null } | null, sites?: { __typename?: 'SiteCollection', collection: Array<{ __typename?: 'Site', id: string, name: string }> }, sectors?: { __typename?: 'SectorCollection', collection: Array<{ __typename?: 'Sector', id: string, name: string | null, color: ColorEnum | null }> }, team?: { __typename?: 'Team', id: string, name: string | null, color: ColorEnum, accesses: Array<{ __typename?: 'Access', component: AccessComponentEnum, itemIds: Array<string>, level: AccessLevelEnum | null, scopeLevel: AccessScopeLevelEnum | null, policy: AccessPolicyEnum | null }> }, finalAccesses?: Array<{ __typename?: 'Access', component: AccessComponentEnum, itemIds: Array<string>, level: AccessLevelEnum | null, scopeLevel: AccessScopeLevelEnum | null, policy: AccessPolicyEnum | null }> | null, personalAccesses?: Array<{ __typename?: 'Access', component: AccessComponentEnum, itemIds: Array<string>, level: AccessLevelEnum | null, scopeLevel: AccessScopeLevelEnum | null, policy: AccessPolicyEnum | null }> } | null };

export type UserCreateMutationVariables = Exact<{
  attributes: UserCreateInputObject;
  redirectUrl: Scalars['String']['input'];
}>;


export type UserCreateMutation = { __typename?: 'Mutation', data: { __typename?: 'User', deactivatedAt: any | null, id: string, firstName: string, lastName: string, email: string | null, passwordSetupRequired: boolean, role: UserRoleEnum, personalId: string | null, phoneNumber: string | null, lang: LanguageEnum, verified: boolean | null, unconfirmedEmail: string | null, username: string | null, avatarAttached: { __typename?: 'Attachment', id: string, processed: boolean, fileTag: string | null, fileData: any | null, filename: string | null, urls: { __typename?: 'AttachmentUrl', large: string | null, medium: string | null, original: string | null, small: string | null, imagePreview: string | null, originalDirectDownload: string | null, video480p: string | null, video720p: string | null, video1080p: string | null } | null, metadata: { __typename?: 'AttachmentMetadata', intendedUse: string | null } | null } | null, sites: { __typename?: 'SiteCollection', collection: Array<{ __typename?: 'Site', id: string, name: string }> }, company: { __typename?: 'Company', id: string, name: string }, team: { __typename?: 'Team', id: string, name: string | null, color: ColorEnum } } | null };

export type UserUpdateMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  attributes: UserUpdateInputObject;
  finishRegistrationRedirectUrl: Scalars['String']['input'];
  confirmEmailRedirectUrl: Scalars['String']['input'];
}>;


export type UserUpdateMutation = { __typename?: 'Mutation', data: { __typename?: 'User', deactivatedAt: any | null, id: string, firstName: string, lastName: string, email: string | null, passwordSetupRequired: boolean, role: UserRoleEnum, personalId: string | null, phoneNumber: string | null, lang: LanguageEnum, verified: boolean | null, unconfirmedEmail: string | null, username: string | null, avatarAttached: { __typename?: 'Attachment', id: string, processed: boolean, fileTag: string | null, fileData: any | null, filename: string | null, urls: { __typename?: 'AttachmentUrl', large: string | null, medium: string | null, original: string | null, small: string | null, imagePreview: string | null, originalDirectDownload: string | null, video480p: string | null, video720p: string | null, video1080p: string | null } | null, metadata: { __typename?: 'AttachmentMetadata', intendedUse: string | null } | null } | null, sites: { __typename?: 'SiteCollection', collection: Array<{ __typename?: 'Site', id: string, name: string }> }, company: { __typename?: 'Company', id: string, name: string }, team: { __typename?: 'Team', id: string, name: string | null, color: ColorEnum } } | null };

export type UserSelfUpdateMutationVariables = Exact<{
  input: UserSelfUpdateInput;
}>;


export type UserSelfUpdateMutation = { __typename?: 'Mutation', data: { __typename?: 'User', deactivatedAt: any | null, id: string, firstName: string, lastName: string, email: string | null, passwordSetupRequired: boolean, role: UserRoleEnum, personalId: string | null, phoneNumber: string | null, lang: LanguageEnum, verified: boolean | null, unconfirmedEmail: string | null, username: string | null, finalAccesses: Array<{ __typename?: 'Access', component: AccessComponentEnum, itemIds: Array<string>, level: AccessLevelEnum | null, scopeLevel: AccessScopeLevelEnum | null, policy: AccessPolicyEnum | null }> | null, avatarAttached: { __typename?: 'Attachment', id: string, processed: boolean, fileTag: string | null, fileData: any | null, filename: string | null, urls: { __typename?: 'AttachmentUrl', large: string | null, medium: string | null, original: string | null, small: string | null, imagePreview: string | null, originalDirectDownload: string | null, video480p: string | null, video720p: string | null, video1080p: string | null } | null, metadata: { __typename?: 'AttachmentMetadata', intendedUse: string | null } | null } | null, sites: { __typename?: 'SiteCollection', collection: Array<{ __typename?: 'Site', id: string, name: string }> }, company: { __typename?: 'Company', id: string, name: string }, team: { __typename?: 'Team', id: string, name: string | null, color: ColorEnum } } | null };

export type UserDestroyMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type UserDestroyMutation = { __typename?: 'Mutation', data: boolean | null };

export type AuthenticationPasswordSetupMutationVariables = Exact<{
  input: AuthenticationPasswordSetupInput;
}>;


export type AuthenticationPasswordSetupMutation = { __typename?: 'Mutation', data: boolean };

export type UserBulkActivateMutationVariables = Exact<{
  input: UserBulkActivateInput;
}>;


export type UserBulkActivateMutation = { __typename?: 'Mutation', data: boolean | null };

export type UserBulkDeactivateMutationVariables = Exact<{
  input: UserBulkDeactivateInput;
}>;


export type UserBulkDeactivateMutation = { __typename?: 'Mutation', data: boolean | null };

export const AiConversationFragmentFragmentDoc = gql`
    fragment aiConversationFragment on AiConversation {
  id
  title
  titleAutoGenerated
  status
  feature
  initiator
  messagesCount
  busy
  thinkingLevel
  createdAt
  updatedAt
}
    `;
export const AiMessageFragmentFragmentDoc = gql`
    fragment aiMessageFragment on AiMessage {
  id
  role
  status
  content
  contentBlocks
  thinking
  errorCode
  suggestedFollowups
  toolCalls {
    id
    toolCallId
    toolName
    createdAt
  }
  createdAt
  feedback
  feedbackReason
  feedbackComment
  feedbackAt
}
    `;
export const AiBudgetStatusFragmentFragmentDoc = gql`
    fragment aiBudgetStatusFragment on AiBudgetStatus {
  enforced
  blockedReason
  usedCredits
  remainingCredits
  totalCredits
  percentage
  userPercentage
  systemPercentage
  updatedAt
}
    `;
export const AiIndexingCoverageFragmentFragmentDoc = gql`
    fragment aiIndexingCoverageFragment on AiIndexingCoverage {
  total
  indexed
  skipped
  stale
  pending
  failed
  retryingSoon
  retryingDaily
  parked
  parkedReasons {
    reason
    count
  }
  indexingState
  indexingInFlight
  progress
  estimatedReindexSeconds
  lastIndexedAt
  lastIndexingAttemptAt
}
    `;
export const AssetCategoryFragmentFragmentDoc = gql`
    fragment assetCategoryFragment on AssetCategory {
  color
  name
  id
  prefix
}
    `;
export const AttachmentFragmentFragmentDoc = gql`
    fragment attachmentFragment on Attachment {
  id
  processed
  fileTag
  fileData
  filename
  urls {
    large
    medium
    original
    small
    imagePreview
    originalDirectDownload
    video480p
    video720p
    video1080p
  }
  metadata {
    intendedUse
  }
}
    `;
export const AssetFragmentFragmentDoc = gql`
    fragment assetFragment on Asset {
  category {
    ...assetCategoryFragment
  }
  id
  qrPrefix
  code
  fullCode
  manufacturer
  model
  name
  serialNumber
  serviceDate
  description
  poorWifi
  site {
    id
    name
  }
  siteArea {
    id
    name
  }
  iconAttached {
    ...attachmentFragment
  }
}
    `;
export const AuthorizationResultFragmentFragmentDoc = gql`
    fragment authorizationResultFragment on AuthorizationResult {
  value
  message
  reasons {
    details
    fullMessages
  }
}
    `;
export const BackgroundJobFragmentFragmentDoc = gql`
    fragment backgroundJobFragment on BackgroundJob {
  id
  jid
  parentId
  rootId
  kind
  status
  displayStatus
  treeStatus
  done
  total
  failed
  pctComplete
  message
  errorCode
  result
  estimatedFinishAt
  startedAt
  finishedAt
  cancelRequestedAt
  deliveryRequestedAt
  dismissed
  createdAt
  updatedAt
  canCancel {
    ...authorizationResultFragment
  }
  canDismiss {
    ...authorizationResultFragment
  }
  canRequestDelivery {
    ...authorizationResultFragment
  }
  canRequeue {
    ...authorizationResultFragment
  }
}
    `;
export const BackgroundJobTreeFragmentFragmentDoc = gql`
    fragment backgroundJobTreeFragment on BackgroundJob {
  ...backgroundJobFragment
  children {
    ...backgroundJobFragment
  }
}
    `;
export const DataImportFragmentFragmentDoc = gql`
    fragment dataImportFragment on DataImport {
  attachmentAttached {
    ...attachmentFragment
  }
  importedRows
  failureDetails
  fileException
  id
  kind
  status
  backgroundJob {
    ...backgroundJobTreeFragment
  }
  totalRows
  createdAt
  user {
    id
    firstName
    lastName
    email
    avatarAttached {
      ...attachmentFragment
    }
  }
  canDestroy {
    ...authorizationResultFragment
  }
  canUpdate {
    ...authorizationResultFragment
  }
}
    `;
export const DepartmentFragmentFragmentDoc = gql`
    fragment departmentFragment on Department {
  id
  name
  description
  color
  createdAt
  parentId
  parent {
    id
    name
    path
  }
  manager {
    id
    firstName
    lastName
    email
    avatarAttached {
      ...attachmentFragment
    }
  }
  canDestroy {
    ...authorizationResultFragment
  }
}
    `;
export const DepartmentHierarchyNodeFragmentFragmentDoc = gql`
    fragment departmentHierarchyNodeFragment on Department {
  id
  name
  color
  childrenCount
}
    `;
export const DepartmentListItemFragmentFragmentDoc = gql`
    fragment departmentListItemFragment on Department {
  id
  name
  path
  color
  childrenCount
  membersOwnCount
  membersTotalCount
  tasksOwnCount
  tasksTotalCount
  manager {
    id
    firstName
    lastName
    email
    avatarAttached {
      ...attachmentFragment
    }
  }
  canDestroy {
    ...authorizationResultFragment
  }
}
    `;
export const EdmDocumentationAiDetectionFragmentFragmentDoc = gql`
    fragment edmDocumentationAiDetectionFragment on Documentation {
  suggestedCodes
  aiDetectionStatus {
    field
    status
  }
}
    `;
export const EdmDocumentationBaseFragmentFragmentDoc = gql`
    fragment edmDocumentationBaseFragment on Documentation {
  id
  name
  code
  createdAt
  updatedAt
  createdBy {
    id
    firstName
    lastName
    avatarAttached {
      ...attachmentFragment
    }
  }
  canUpdateValidationStatus {
    ...authorizationResultFragment
  }
  canUpdate {
    ...authorizationResultFragment
  }
  canDestroy {
    ...authorizationResultFragment
  }
  currentVersion {
    id
    notes
    attachmentAttached {
      ...attachmentFragment
    }
  }
  tags {
    id
    name
  }
}
    `;
export const EdmDocumentationCategoryFragmentFragmentDoc = gql`
    fragment edmDocumentationCategoryFragment on DocumentationCategory {
  id
  name
  color
}
    `;
export const EdmDocumentationPremiumFragmentFragmentDoc = gql`
    fragment edmDocumentationPremiumFragment on Documentation {
  category {
    ...edmDocumentationCategoryFragment
  }
  validationStatus
  approver {
    id
    firstName
    lastName
    email
    avatarAttached {
      ...attachmentFragment
    }
  }
  renewalDeadlineDate
  renewalRepetition
  renewalEarlyReminderDays
  renewalRepetitionCustomDays
}
    `;
export const EdmDocumentationFragmentFragmentDoc = gql`
    fragment edmDocumentationFragment on Documentation {
  ...edmDocumentationBaseFragment
  ...edmDocumentationPremiumFragment
}
    `;
export const EdmDocumentRenewalReminderTemplateFragmentFragmentDoc = gql`
    fragment edmDocumentRenewalReminderTemplateFragment on DocumentRenewalReminderTemplate {
  id
  renewalRepetition
  renewalRepetitionCustomDays
  renewalDeadlineMd
  renewalEarlyReminderDays
}
    `;
export const FeFilterPresetFragmentDoc = gql`
    fragment feFilterPreset on FeFilterPreset {
  data
  id
  kind
  name
  entities {
    sites {
      id
    }
    sectors {
      id
    }
    formCategories {
      id
    }
    formTemplates {
      id
    }
  }
}
    `;
export const FormCategoryFragmentFragmentDoc = gql`
    fragment formCategoryFragment on FormCategory {
  color
  name
  id
}
    `;
export const FormTemplateFragmentFragmentDoc = gql`
    fragment formTemplateFragment on FormTemplate {
  category {
    ...formCategoryFragment
  }
  description
  id
  name
  createdAt
  updatedAt
}
    `;
export const FormTemplateFullFragmentFragmentDoc = gql`
    fragment formTemplateFullFragment on FormTemplate {
  ...formTemplateFragment
  visibleLinkedTasksCount
  currentVersion {
    id
    version
  }
}
    `;
export const QuestionsFragmentFragmentDoc = gql`
    fragment questionsFragment on FormTemplateVersion {
  questions {
    id
    templateId
    position
    description
    attachmentsAttached {
      ...attachmentFragment
    }
    name
    fields {
      id
      kind
      required
      settings {
        allowDisplayLastAnswer
        limitToOneRespPerColumn
        limitToOneRespPerRow
        limitToOneResp
      }
      options {
        id
        group
        position
        values
        validityHint
        condition
        optionDocumentation @skip(if: $isViewLocked) {
          id
          documentationId
          requiredToRead
        }
      }
      validityHintConfig {
        optionPositions
        validityHint
      }
    }
  }
}
    `;
export const FormTemplateVersionFragmentFragmentDoc = gql`
    fragment formTemplateVersionFragment on FormTemplateVersion {
  id
  templateId
  version
  createdAt
  archivedAt
  status
  ...questionsFragment
}
    `;
export const FullFormTemplateVersionFragmentFragmentDoc = gql`
    fragment fullFormTemplateVersionFragment on FormTemplateVersion {
  ...formTemplateVersionFragment
  ...questionsFragment
  canUpdate {
    value
  }
  canDestroy {
    value
  }
  canArchive {
    value
  }
  canRestore {
    value
  }
}
    `;
export const FormChecklistTemplateFragmentFragmentDoc = gql`
    fragment formChecklistTemplateFragment on FormChecklistTemplate {
  id
  name
  description
  optionsCount
  canUpdate {
    ...authorizationResultFragment
  }
  canDestroy {
    ...authorizationResultFragment
  }
}
    `;
export const FormChecklistTemplateWithOptionsFragmentFragmentDoc = gql`
    fragment formChecklistTemplateWithOptionsFragment on FormChecklistTemplate {
  ...formChecklistTemplateFragment
  options {
    id
    value
    position
    updatedAt
  }
}
    `;
export const MetadataFragmentFragmentDoc = gql`
    fragment metadataFragment on CollectionMetadata {
  currentPage
  limitValue
  totalCount
  totalPages
}
    `;
export const GeojsonFullFragmentFragmentDoc = gql`
    fragment geojsonFullFragment on GeojsonFeatureCollection {
  features {
    geometry {
      coordinates
      type
    }
    properties {
      address
      addressDetails
      color
      icon
      shape
      type
      pointCount
      sourceables {
        id
        type
      }
    }
    type
  }
  type
}
    `;
export const HomePageFragmentFragmentDoc = gql`
    fragment homePageFragment on HomePage {
  id
  name
  position
  isDefault
  userId
  createdAt
  updatedAt
  canUpdate {
    ...authorizationResultFragment
  }
  canDestroy {
    ...authorizationResultFragment
  }
}
    `;
export const WidgetFragmentFragmentDoc = gql`
    fragment widgetFragment on Widget {
  id
  homePageId
  widgetTemplateId
  kind
  title
  description
  position
  grid
  fields {
    backgroundColor
    link
    location
    timezone
    startAt
    endAt
    onlyMy
    buttons {
      asset {
        enabled
        updatedAt
      }
      formTemplate {
        enabled
        updatedAt
      }
      intervention {
        enabled
        updatedAt
      }
      site {
        enabled
        updatedAt
      }
      task {
        enabled
        updatedAt
      }
      teamMember {
        enabled
        updatedAt
      }
    }
  }
  attachmentsAttached {
    ...attachmentFragment
  }
  createdAt
  updatedAt
}
    `;
export const WidgetTemplateFragmentFragmentDoc = gql`
    fragment widgetTemplateFragment on WidgetTemplate {
  id
  title
  description
  kind
  visibility
  isDefault
  fields {
    backgroundColor
    content
    link
  }
  attachmentsAttached {
    ...attachmentFragment
  }
}
    `;
export const InterventionCategoryFragmentFragmentDoc = gql`
    fragment interventionCategoryFragment on InterventionCategory {
  id
  name
  color
  description
}
    `;
export const InterventionFragmentFragmentDoc = gql`
    fragment interventionFragment on Intervention {
  id
  name
  code
  description
  attachmentsAttached {
    ...attachmentFragment
  }
  category {
    id
    name
    color
  }
  priority
  status
  site {
    id
    name
  }
  siteArea {
    id
    name
  }
  asset {
    id
    name
    fullCode
    iconAttached {
      ...attachmentFragment
    }
  }
  task {
    id
    name
  }
  supervisor {
    id
    firstName
    lastName
    avatarAttached {
      ...attachmentFragment
    }
  }
  estimatedDate
  totalLogisticTime
  totalEstimatedTime
  estimatedTime
  logisticTime
  durationTime
  totalTime
  createdAt
  createdBy {
    id
    firstName
    lastName
    avatarAttached {
      ...attachmentFragment
    }
  }
  canDestroy {
    ...authorizationResultFragment
  }
  canClose {
    ...authorizationResultFragment
  }
  canUpdate {
    ...authorizationResultFragment
  }
  canCreateAction {
    ...authorizationResultFragment
  }
}
    `;
export const InterventionActionFragmentFragmentDoc = gql`
    fragment interventionActionFragment on InterventionAction {
  id
  text
  status
  createdAt
  updatedAt
  interventionId
  closedAt
  estimatedDate
  estimatedTime
  logisticTime
  durationTime
  createdBy {
    id
    firstName
    lastName
    avatarAttached {
      ...attachmentFragment
    }
  }
  attachmentsAttached {
    ...attachmentFragment
  }
  canUpdate {
    ...authorizationResultFragment
  }
  canDestroy {
    ...authorizationResultFragment
  }
}
    `;
export const SectorFragmentFragmentDoc = gql`
    fragment sectorFragment on Sector {
  id
  code
  name
  color
  readOnly
  canDestroy {
    ...authorizationResultFragment
  }
}
    `;
export const GeojsonFragmentFragmentDoc = gql`
    fragment geojsonFragment on GeojsonFeatureCollection {
  features {
    geometry {
      coordinates
      type
    }
    properties {
      address
      addressDetails
      color
      icon
      shape
      type
    }
    type
  }
  type
}
    `;
export const LocationBoundaryFragmentFragmentDoc = gql`
    fragment locationBoundaryFragment on Location {
  kind
  id
  geojson {
    ...geojsonFragment
  }
}
    `;
export const SectorFullFragmentFragmentDoc = gql`
    fragment sectorFullFragment on Sector {
  ...sectorFragment
  locationBoundary {
    ...locationBoundaryFragment
  }
}
    `;
export const MainSiteFragmentFragmentDoc = gql`
    fragment mainSiteFragment on Site {
  code
  id
  locationPhotoAttached {
    ...attachmentFragment
  }
  name
  user {
    id
    firstName
    lastName
    email
    avatarAttached {
      ...attachmentFragment
    }
    phoneNumber
  }
}
    `;
export const FullSiteFragmentFragmentDoc = gql`
    fragment fullSiteFragment on Site {
  ...mainSiteFragment
  locationPoint {
    ...locationBoundaryFragment
  }
  siteConductCodeSections {
    body
    createdAt
    id
    position
    title
    updatedAt
  }
  updatedAt
  phoneNumber
  description
  email
  createdAt
  usersCount
  siteAreasCount
  sector {
    id
    name
    color
  }
}
    `;
export const SiteAreaFragmentFragmentDoc = gql`
    fragment siteAreaFragment on SiteArea {
  address
  canDestroy {
    ...authorizationResultFragment
  }
  code
  description
  fullCode
  id
  name
  poorWifi
}
    `;
export const SsoIntegrationFragmentFragmentDoc = gql`
    fragment ssoIntegrationFragment on SsoIntegration {
  id
  name
  code
  providerPreset
  providerType
  displayStatus
  status
  warningKey
  idpMetadata
  attributeMapping
  allowIdpInitiated
  jitProvisioningEnabled
  syncUserAttributes
  timeToleranceSeconds
  pinned
  icon {
    ...attachmentFragment
  }
  companyDomains {
    id
  }
  createdAt
  updatedAt
}
    `;
export const CompanyDomainFragmentFragmentDoc = gql`
    fragment companyDomainFragment on CompanyDomain {
  id
  domain
  verified
  verifiedAt
  dnsTxtRecord
  createdAt
  updatedAt
}
    `;
export const RecurringRuleFragmentFragmentDoc = gql`
    fragment recurringRuleFragment on RecurringRule {
  endsAfterOccurrences
  endTime
  id
  schema {
    rrules {
      interval
      ruleType
      validations {
        day
        dayOfWeek
        dayOfMonth
        monthOfYear
      }
    }
    metadata {
      schemaOption
    }
  }
  countdownType
  excludedWdays
  startTime
}
    `;
export const EarlyCompletionFragmentFragmentDoc = gql`
    fragment earlyCompletionFragment on Task {
  earlyCompletion
  earlyCompletionUnit
}
    `;
export const CanActionsTaskFragmentFragmentDoc = gql`
    fragment canActionsTaskFragment on Task {
  canArchive {
    ...authorizationResultFragment
  }
  canDestroy {
    ...authorizationResultFragment
  }
  canUpdate {
    ...authorizationResultFragment
  }
  canReschedule {
    ...authorizationResultFragment
  }
  canQrCodeRelatedInfoUpdate {
    ...authorizationResultFragment
  }
}
    `;
export const TaskFragmentFragmentDoc = gql`
    fragment taskFragment on Task {
  id
  groupKey
  kind
  name
  description
  priority
  status
  completedAt
  completion {
    validityHint
    status
    solvedAt
  }
  recurringRuleId
  lastDeadlineAt
  lateFor
  site {
    id
    name
  }
  siteArea {
    id
    name
    fullCode
  }
  approver {
    id
    firstName
    lastName
    avatarAttached {
      ...attachmentFragment
    }
  }
  asset {
    id
    name
    fullCode
    siteArea {
      code
    }
    iconAttached {
      ...attachmentFragment
    }
  }
  createdAt
  deadlineAt
  archivedAt
  lastCheckAt
  originalCreatedAt
  formTemplate {
    canUpdate {
      value
    }
  }
  ...canActionsTaskFragment
}
    `;
export const TeamFragmentFragmentDoc = gql`
    fragment teamFragment on Team {
  id
  name
  description
  color
  readOnly
  canDestroy {
    ...authorizationResultFragment
  }
  accesses {
    component
    itemIds
    level
    scopeLevel
  }
}
    `;
export const FullUserFragmentFragmentDoc = gql`
    fragment fullUserFragment on User {
  deactivatedAt
  avatarAttached {
    ...attachmentFragment
  }
  id
  firstName
  lastName
  email
  passwordSetupRequired
  role
  personalId
  phoneNumber
  sites {
    collection {
      id
      name
    }
  }
  lang
  verified
  unconfirmedEmail
  company {
    id
    name
  }
  username
  team {
    id
    name
    color
  }
}
    `;
export const AiConversationsDocument = gql`
    query aiConversations($page: Int, $limit: Int, $sorts: AiConversationSortInputObject, $filters: [AiConversationFilterInputObject!]) {
  data: aiConversations(
    page: $page
    limit: $limit
    sorts: $sorts
    filters: $filters
  ) {
    collection {
      ...aiConversationFragment
    }
    metadata {
      ...metadataFragment
    }
  }
}
    ${AiConversationFragmentFragmentDoc}
${MetadataFragmentFragmentDoc}`;

/**
 * __useAiConversationsQuery__
 *
 * To run a query within a React component, call `useAiConversationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAiConversationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAiConversationsQuery({
 *   variables: {
 *      page: // value for 'page'
 *      limit: // value for 'limit'
 *      sorts: // value for 'sorts'
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useAiConversationsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<AiConversationsQuery, AiConversationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<AiConversationsQuery, AiConversationsQueryVariables>(AiConversationsDocument, options);
      }
export function useAiConversationsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<AiConversationsQuery, AiConversationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<AiConversationsQuery, AiConversationsQueryVariables>(AiConversationsDocument, options);
        }
// @ts-ignore
export function useAiConversationsSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<AiConversationsQuery, AiConversationsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<AiConversationsQuery, AiConversationsQueryVariables>;
// @ts-ignore
export function useAiConversationsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<AiConversationsQuery, AiConversationsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<AiConversationsQuery | undefined, AiConversationsQueryVariables>;
export function useAiConversationsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<AiConversationsQuery, AiConversationsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          // @ts-ignore
          return ApolloReactHooks.useSuspenseQuery<AiConversationsQuery, AiConversationsQueryVariables>(AiConversationsDocument, options);
        }
export type AiConversationsQueryHookResult = ReturnType<typeof useAiConversationsQuery>;
export type AiConversationsLazyQueryHookResult = ReturnType<typeof useAiConversationsLazyQuery>;
export type AiConversationsSuspenseQueryHookResult = ReturnType<typeof useAiConversationsSuspenseQuery>;
export type AiConversationsQueryResult = ApolloReactCommon.QueryResult<AiConversationsQuery, AiConversationsQueryVariables>;
export function refetchAiConversationsQuery(variables?: AiConversationsQueryVariables) {
      return { query: AiConversationsDocument, variables: variables }
    }
export const AiConversationDocument = gql`
    query aiConversation($id: ID!) {
  data: aiConversation(id: $id) {
    ...aiConversationFragment
  }
}
    ${AiConversationFragmentFragmentDoc}`;

/**
 * __useAiConversationQuery__
 *
 * To run a query within a React component, call `useAiConversationQuery` and pass it any options that fit your needs.
 * When your component renders, `useAiConversationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAiConversationQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useAiConversationQuery(baseOptions: ApolloReactHooks.QueryHookOptions<AiConversationQuery, AiConversationQueryVariables> & ({ variables: AiConversationQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<AiConversationQuery, AiConversationQueryVariables>(AiConversationDocument, options);
      }
export function useAiConversationLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<AiConversationQuery, AiConversationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<AiConversationQuery, AiConversationQueryVariables>(AiConversationDocument, options);
        }
// @ts-ignore
export function useAiConversationSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<AiConversationQuery, AiConversationQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<AiConversationQuery, AiConversationQueryVariables>;
// @ts-ignore
export function useAiConversationSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<AiConversationQuery, AiConversationQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<AiConversationQuery | undefined, AiConversationQueryVariables>;
export function useAiConversationSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<AiConversationQuery, AiConversationQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          // @ts-ignore
          return ApolloReactHooks.useSuspenseQuery<AiConversationQuery, AiConversationQueryVariables>(AiConversationDocument, options);
        }
export type AiConversationQueryHookResult = ReturnType<typeof useAiConversationQuery>;
export type AiConversationLazyQueryHookResult = ReturnType<typeof useAiConversationLazyQuery>;
export type AiConversationSuspenseQueryHookResult = ReturnType<typeof useAiConversationSuspenseQuery>;
export type AiConversationQueryResult = ApolloReactCommon.QueryResult<AiConversationQuery, AiConversationQueryVariables>;
export function refetchAiConversationQuery(variables: AiConversationQueryVariables) {
      return { query: AiConversationDocument, variables: variables }
    }
export const AiMessagesDocument = gql`
    query aiMessages($conversationId: ID!, $page: Int, $limit: Int, $sorts: AiMessageSortInputObject) {
  data: aiMessages(
    conversationId: $conversationId
    page: $page
    limit: $limit
    sorts: $sorts
  ) {
    collection {
      ...aiMessageFragment
    }
    metadata {
      ...metadataFragment
    }
  }
}
    ${AiMessageFragmentFragmentDoc}
${MetadataFragmentFragmentDoc}`;

/**
 * __useAiMessagesQuery__
 *
 * To run a query within a React component, call `useAiMessagesQuery` and pass it any options that fit your needs.
 * When your component renders, `useAiMessagesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAiMessagesQuery({
 *   variables: {
 *      conversationId: // value for 'conversationId'
 *      page: // value for 'page'
 *      limit: // value for 'limit'
 *      sorts: // value for 'sorts'
 *   },
 * });
 */
export function useAiMessagesQuery(baseOptions: ApolloReactHooks.QueryHookOptions<AiMessagesQuery, AiMessagesQueryVariables> & ({ variables: AiMessagesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<AiMessagesQuery, AiMessagesQueryVariables>(AiMessagesDocument, options);
      }
export function useAiMessagesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<AiMessagesQuery, AiMessagesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<AiMessagesQuery, AiMessagesQueryVariables>(AiMessagesDocument, options);
        }
// @ts-ignore
export function useAiMessagesSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<AiMessagesQuery, AiMessagesQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<AiMessagesQuery, AiMessagesQueryVariables>;
// @ts-ignore
export function useAiMessagesSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<AiMessagesQuery, AiMessagesQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<AiMessagesQuery | undefined, AiMessagesQueryVariables>;
export function useAiMessagesSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<AiMessagesQuery, AiMessagesQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          // @ts-ignore
          return ApolloReactHooks.useSuspenseQuery<AiMessagesQuery, AiMessagesQueryVariables>(AiMessagesDocument, options);
        }
export type AiMessagesQueryHookResult = ReturnType<typeof useAiMessagesQuery>;
export type AiMessagesLazyQueryHookResult = ReturnType<typeof useAiMessagesLazyQuery>;
export type AiMessagesSuspenseQueryHookResult = ReturnType<typeof useAiMessagesSuspenseQuery>;
export type AiMessagesQueryResult = ApolloReactCommon.QueryResult<AiMessagesQuery, AiMessagesQueryVariables>;
export function refetchAiMessagesQuery(variables: AiMessagesQueryVariables) {
      return { query: AiMessagesDocument, variables: variables }
    }
export const AiSourceDocumentationsDocument = gql`
    query aiSourceDocumentations($filters: [DocumentationFilterInputObject!]) {
  data: documentations(filters: $filters) {
    collection {
      id
      name
      favorited
      currentVersion {
        id
        versionNumber
        notes
        attachmentAttached {
          ...attachmentFragment
        }
      }
    }
  }
}
    ${AttachmentFragmentFragmentDoc}`;

/**
 * __useAiSourceDocumentationsQuery__
 *
 * To run a query within a React component, call `useAiSourceDocumentationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAiSourceDocumentationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAiSourceDocumentationsQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useAiSourceDocumentationsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<AiSourceDocumentationsQuery, AiSourceDocumentationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<AiSourceDocumentationsQuery, AiSourceDocumentationsQueryVariables>(AiSourceDocumentationsDocument, options);
      }
export function useAiSourceDocumentationsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<AiSourceDocumentationsQuery, AiSourceDocumentationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<AiSourceDocumentationsQuery, AiSourceDocumentationsQueryVariables>(AiSourceDocumentationsDocument, options);
        }
// @ts-ignore
export function useAiSourceDocumentationsSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<AiSourceDocumentationsQuery, AiSourceDocumentationsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<AiSourceDocumentationsQuery, AiSourceDocumentationsQueryVariables>;
// @ts-ignore
export function useAiSourceDocumentationsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<AiSourceDocumentationsQuery, AiSourceDocumentationsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<AiSourceDocumentationsQuery | undefined, AiSourceDocumentationsQueryVariables>;
export function useAiSourceDocumentationsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<AiSourceDocumentationsQuery, AiSourceDocumentationsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          // @ts-ignore
          return ApolloReactHooks.useSuspenseQuery<AiSourceDocumentationsQuery, AiSourceDocumentationsQueryVariables>(AiSourceDocumentationsDocument, options);
        }
export type AiSourceDocumentationsQueryHookResult = ReturnType<typeof useAiSourceDocumentationsQuery>;
export type AiSourceDocumentationsLazyQueryHookResult = ReturnType<typeof useAiSourceDocumentationsLazyQuery>;
export type AiSourceDocumentationsSuspenseQueryHookResult = ReturnType<typeof useAiSourceDocumentationsSuspenseQuery>;
export type AiSourceDocumentationsQueryResult = ApolloReactCommon.QueryResult<AiSourceDocumentationsQuery, AiSourceDocumentationsQueryVariables>;
export function refetchAiSourceDocumentationsQuery(variables?: AiSourceDocumentationsQueryVariables) {
      return { query: AiSourceDocumentationsDocument, variables: variables }
    }
export const AiBudgetStatusDocument = gql`
    query aiBudgetStatus {
  data: aiBudgetStatus {
    ...aiBudgetStatusFragment
  }
}
    ${AiBudgetStatusFragmentFragmentDoc}`;

/**
 * __useAiBudgetStatusQuery__
 *
 * To run a query within a React component, call `useAiBudgetStatusQuery` and pass it any options that fit your needs.
 * When your component renders, `useAiBudgetStatusQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAiBudgetStatusQuery({
 *   variables: {
 *   },
 * });
 */
export function useAiBudgetStatusQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<AiBudgetStatusQuery, AiBudgetStatusQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<AiBudgetStatusQuery, AiBudgetStatusQueryVariables>(AiBudgetStatusDocument, options);
      }
export function useAiBudgetStatusLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<AiBudgetStatusQuery, AiBudgetStatusQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<AiBudgetStatusQuery, AiBudgetStatusQueryVariables>(AiBudgetStatusDocument, options);
        }
// @ts-ignore
export function useAiBudgetStatusSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<AiBudgetStatusQuery, AiBudgetStatusQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<AiBudgetStatusQuery, AiBudgetStatusQueryVariables>;
// @ts-ignore
export function useAiBudgetStatusSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<AiBudgetStatusQuery, AiBudgetStatusQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<AiBudgetStatusQuery | undefined, AiBudgetStatusQueryVariables>;
export function useAiBudgetStatusSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<AiBudgetStatusQuery, AiBudgetStatusQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          // @ts-ignore
          return ApolloReactHooks.useSuspenseQuery<AiBudgetStatusQuery, AiBudgetStatusQueryVariables>(AiBudgetStatusDocument, options);
        }
export type AiBudgetStatusQueryHookResult = ReturnType<typeof useAiBudgetStatusQuery>;
export type AiBudgetStatusLazyQueryHookResult = ReturnType<typeof useAiBudgetStatusLazyQuery>;
export type AiBudgetStatusSuspenseQueryHookResult = ReturnType<typeof useAiBudgetStatusSuspenseQuery>;
export type AiBudgetStatusQueryResult = ApolloReactCommon.QueryResult<AiBudgetStatusQuery, AiBudgetStatusQueryVariables>;
export function refetchAiBudgetStatusQuery(variables?: AiBudgetStatusQueryVariables) {
      return { query: AiBudgetStatusDocument, variables: variables }
    }
export const AiBudgetStatusLiveDocument = gql`
    subscription aiBudgetStatusLive {
  aiBudgetStatus {
    ...aiBudgetStatusFragment
  }
}
    ${AiBudgetStatusFragmentFragmentDoc}`;

/**
 * __useAiBudgetStatusLiveSubscription__
 *
 * To run a query within a React component, call `useAiBudgetStatusLiveSubscription` and pass it any options that fit your needs.
 * When your component renders, `useAiBudgetStatusLiveSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAiBudgetStatusLiveSubscription({
 *   variables: {
 *   },
 * });
 */
export function useAiBudgetStatusLiveSubscription(baseOptions?: ApolloReactHooks.SubscriptionHookOptions<AiBudgetStatusLiveSubscription, AiBudgetStatusLiveSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useSubscription<AiBudgetStatusLiveSubscription, AiBudgetStatusLiveSubscriptionVariables>(AiBudgetStatusLiveDocument, options);
      }
export type AiBudgetStatusLiveSubscriptionHookResult = ReturnType<typeof useAiBudgetStatusLiveSubscription>;
export type AiBudgetStatusLiveSubscriptionResult = ApolloReactCommon.SubscriptionResult<AiBudgetStatusLiveSubscription>;
export const AiThinkingCapabilityDocument = gql`
    query aiThinkingCapability {
  data: aiThinkingCapability {
    mode
    levels
    selectable
  }
}
    `;

/**
 * __useAiThinkingCapabilityQuery__
 *
 * To run a query within a React component, call `useAiThinkingCapabilityQuery` and pass it any options that fit your needs.
 * When your component renders, `useAiThinkingCapabilityQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAiThinkingCapabilityQuery({
 *   variables: {
 *   },
 * });
 */
export function useAiThinkingCapabilityQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<AiThinkingCapabilityQuery, AiThinkingCapabilityQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<AiThinkingCapabilityQuery, AiThinkingCapabilityQueryVariables>(AiThinkingCapabilityDocument, options);
      }
export function useAiThinkingCapabilityLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<AiThinkingCapabilityQuery, AiThinkingCapabilityQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<AiThinkingCapabilityQuery, AiThinkingCapabilityQueryVariables>(AiThinkingCapabilityDocument, options);
        }
// @ts-ignore
export function useAiThinkingCapabilitySuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<AiThinkingCapabilityQuery, AiThinkingCapabilityQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<AiThinkingCapabilityQuery, AiThinkingCapabilityQueryVariables>;
// @ts-ignore
export function useAiThinkingCapabilitySuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<AiThinkingCapabilityQuery, AiThinkingCapabilityQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<AiThinkingCapabilityQuery | undefined, AiThinkingCapabilityQueryVariables>;
export function useAiThinkingCapabilitySuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<AiThinkingCapabilityQuery, AiThinkingCapabilityQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          // @ts-ignore
          return ApolloReactHooks.useSuspenseQuery<AiThinkingCapabilityQuery, AiThinkingCapabilityQueryVariables>(AiThinkingCapabilityDocument, options);
        }
export type AiThinkingCapabilityQueryHookResult = ReturnType<typeof useAiThinkingCapabilityQuery>;
export type AiThinkingCapabilityLazyQueryHookResult = ReturnType<typeof useAiThinkingCapabilityLazyQuery>;
export type AiThinkingCapabilitySuspenseQueryHookResult = ReturnType<typeof useAiThinkingCapabilitySuspenseQuery>;
export type AiThinkingCapabilityQueryResult = ApolloReactCommon.QueryResult<AiThinkingCapabilityQuery, AiThinkingCapabilityQueryVariables>;
export function refetchAiThinkingCapabilityQuery(variables?: AiThinkingCapabilityQueryVariables) {
      return { query: AiThinkingCapabilityDocument, variables: variables }
    }
export const AiIndexableMediaKindsDocument = gql`
    query aiIndexableMediaKinds {
  whoami {
    resource {
      __typename
      ... on User {
        company {
          plan {
            aiIndexableMediaKinds
          }
        }
      }
    }
  }
}
    `;

/**
 * __useAiIndexableMediaKindsQuery__
 *
 * To run a query within a React component, call `useAiIndexableMediaKindsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAiIndexableMediaKindsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAiIndexableMediaKindsQuery({
 *   variables: {
 *   },
 * });
 */
export function useAiIndexableMediaKindsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<AiIndexableMediaKindsQuery, AiIndexableMediaKindsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<AiIndexableMediaKindsQuery, AiIndexableMediaKindsQueryVariables>(AiIndexableMediaKindsDocument, options);
      }
export function useAiIndexableMediaKindsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<AiIndexableMediaKindsQuery, AiIndexableMediaKindsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<AiIndexableMediaKindsQuery, AiIndexableMediaKindsQueryVariables>(AiIndexableMediaKindsDocument, options);
        }
// @ts-ignore
export function useAiIndexableMediaKindsSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<AiIndexableMediaKindsQuery, AiIndexableMediaKindsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<AiIndexableMediaKindsQuery, AiIndexableMediaKindsQueryVariables>;
// @ts-ignore
export function useAiIndexableMediaKindsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<AiIndexableMediaKindsQuery, AiIndexableMediaKindsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<AiIndexableMediaKindsQuery | undefined, AiIndexableMediaKindsQueryVariables>;
export function useAiIndexableMediaKindsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<AiIndexableMediaKindsQuery, AiIndexableMediaKindsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          // @ts-ignore
          return ApolloReactHooks.useSuspenseQuery<AiIndexableMediaKindsQuery, AiIndexableMediaKindsQueryVariables>(AiIndexableMediaKindsDocument, options);
        }
export type AiIndexableMediaKindsQueryHookResult = ReturnType<typeof useAiIndexableMediaKindsQuery>;
export type AiIndexableMediaKindsLazyQueryHookResult = ReturnType<typeof useAiIndexableMediaKindsLazyQuery>;
export type AiIndexableMediaKindsSuspenseQueryHookResult = ReturnType<typeof useAiIndexableMediaKindsSuspenseQuery>;
export type AiIndexableMediaKindsQueryResult = ApolloReactCommon.QueryResult<AiIndexableMediaKindsQuery, AiIndexableMediaKindsQueryVariables>;
export function refetchAiIndexableMediaKindsQuery(variables?: AiIndexableMediaKindsQueryVariables) {
      return { query: AiIndexableMediaKindsDocument, variables: variables }
    }
export const AiUsageByUserDocument = gql`
    query aiUsageByUser($filters: [AiUsageByUserFilterInputObject!], $sorts: AiUsageByUserSortInputObject, $page: Int, $limit: Int) {
  data: aiUsageByUser(
    filters: $filters
    sorts: $sorts
    page: $page
    limit: $limit
  ) {
    collection {
      creditsUsed
      sharePercentage
      user {
        id
        firstName
        lastName
        avatarAttached {
          id
          urls {
            small
            original
          }
        }
      }
    }
    metadata {
      ...metadataFragment
    }
  }
}
    ${MetadataFragmentFragmentDoc}`;

/**
 * __useAiUsageByUserQuery__
 *
 * To run a query within a React component, call `useAiUsageByUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useAiUsageByUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAiUsageByUserQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      sorts: // value for 'sorts'
 *      page: // value for 'page'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useAiUsageByUserQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<AiUsageByUserQuery, AiUsageByUserQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<AiUsageByUserQuery, AiUsageByUserQueryVariables>(AiUsageByUserDocument, options);
      }
export function useAiUsageByUserLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<AiUsageByUserQuery, AiUsageByUserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<AiUsageByUserQuery, AiUsageByUserQueryVariables>(AiUsageByUserDocument, options);
        }
// @ts-ignore
export function useAiUsageByUserSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<AiUsageByUserQuery, AiUsageByUserQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<AiUsageByUserQuery, AiUsageByUserQueryVariables>;
// @ts-ignore
export function useAiUsageByUserSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<AiUsageByUserQuery, AiUsageByUserQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<AiUsageByUserQuery | undefined, AiUsageByUserQueryVariables>;
export function useAiUsageByUserSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<AiUsageByUserQuery, AiUsageByUserQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          // @ts-ignore
          return ApolloReactHooks.useSuspenseQuery<AiUsageByUserQuery, AiUsageByUserQueryVariables>(AiUsageByUserDocument, options);
        }
export type AiUsageByUserQueryHookResult = ReturnType<typeof useAiUsageByUserQuery>;
export type AiUsageByUserLazyQueryHookResult = ReturnType<typeof useAiUsageByUserLazyQuery>;
export type AiUsageByUserSuspenseQueryHookResult = ReturnType<typeof useAiUsageByUserSuspenseQuery>;
export type AiUsageByUserQueryResult = ApolloReactCommon.QueryResult<AiUsageByUserQuery, AiUsageByUserQueryVariables>;
export function refetchAiUsageByUserQuery(variables?: AiUsageByUserQueryVariables) {
      return { query: AiUsageByUserDocument, variables: variables }
    }
export const AiCompanyIndexingCoverageDocument = gql`
    query aiCompanyIndexingCoverage {
  data: aiCompanyIndexingCoverage {
    ...aiIndexingCoverageFragment
  }
}
    ${AiIndexingCoverageFragmentFragmentDoc}`;

/**
 * __useAiCompanyIndexingCoverageQuery__
 *
 * To run a query within a React component, call `useAiCompanyIndexingCoverageQuery` and pass it any options that fit your needs.
 * When your component renders, `useAiCompanyIndexingCoverageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAiCompanyIndexingCoverageQuery({
 *   variables: {
 *   },
 * });
 */
export function useAiCompanyIndexingCoverageQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<AiCompanyIndexingCoverageQuery, AiCompanyIndexingCoverageQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<AiCompanyIndexingCoverageQuery, AiCompanyIndexingCoverageQueryVariables>(AiCompanyIndexingCoverageDocument, options);
      }
export function useAiCompanyIndexingCoverageLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<AiCompanyIndexingCoverageQuery, AiCompanyIndexingCoverageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<AiCompanyIndexingCoverageQuery, AiCompanyIndexingCoverageQueryVariables>(AiCompanyIndexingCoverageDocument, options);
        }
// @ts-ignore
export function useAiCompanyIndexingCoverageSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<AiCompanyIndexingCoverageQuery, AiCompanyIndexingCoverageQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<AiCompanyIndexingCoverageQuery, AiCompanyIndexingCoverageQueryVariables>;
// @ts-ignore
export function useAiCompanyIndexingCoverageSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<AiCompanyIndexingCoverageQuery, AiCompanyIndexingCoverageQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<AiCompanyIndexingCoverageQuery | undefined, AiCompanyIndexingCoverageQueryVariables>;
export function useAiCompanyIndexingCoverageSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<AiCompanyIndexingCoverageQuery, AiCompanyIndexingCoverageQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          // @ts-ignore
          return ApolloReactHooks.useSuspenseQuery<AiCompanyIndexingCoverageQuery, AiCompanyIndexingCoverageQueryVariables>(AiCompanyIndexingCoverageDocument, options);
        }
export type AiCompanyIndexingCoverageQueryHookResult = ReturnType<typeof useAiCompanyIndexingCoverageQuery>;
export type AiCompanyIndexingCoverageLazyQueryHookResult = ReturnType<typeof useAiCompanyIndexingCoverageLazyQuery>;
export type AiCompanyIndexingCoverageSuspenseQueryHookResult = ReturnType<typeof useAiCompanyIndexingCoverageSuspenseQuery>;
export type AiCompanyIndexingCoverageQueryResult = ApolloReactCommon.QueryResult<AiCompanyIndexingCoverageQuery, AiCompanyIndexingCoverageQueryVariables>;
export function refetchAiCompanyIndexingCoverageQuery(variables?: AiCompanyIndexingCoverageQueryVariables) {
      return { query: AiCompanyIndexingCoverageDocument, variables: variables }
    }
export const AiIndexingRetryParkedDocument = gql`
    mutation aiIndexingRetryParked {
  data: aiIndexingRetryParked(input: {}) {
    ...aiIndexingCoverageFragment
  }
}
    ${AiIndexingCoverageFragmentFragmentDoc}`;

/**
 * __useAiIndexingRetryParkedMutation__
 *
 * To run a mutation, you first call `useAiIndexingRetryParkedMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAiIndexingRetryParkedMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [aiIndexingRetryParkedMutation, { data, loading, error }] = useAiIndexingRetryParkedMutation({
 *   variables: {
 *   },
 * });
 */
export function useAiIndexingRetryParkedMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<AiIndexingRetryParkedMutation, AiIndexingRetryParkedMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<AiIndexingRetryParkedMutation, AiIndexingRetryParkedMutationVariables>(AiIndexingRetryParkedDocument, options);
      }
export type AiIndexingRetryParkedMutationHookResult = ReturnType<typeof useAiIndexingRetryParkedMutation>;
export type AiIndexingRetryParkedMutationResult = ApolloReactCommon.MutationResult<AiIndexingRetryParkedMutation>;
export const AiIndexingDocumentationsDocument = gql`
    query aiIndexingDocumentations($page: Int, $limit: Int, $sorts: DocumentationSortInputObject, $filters: [DocumentationFilterInputObject!]) {
  data: documentations(
    page: $page
    limit: $limit
    sorts: $sorts
    filters: $filters
  ) {
    collection {
      id
      name
      code
      category {
        ...edmDocumentationCategoryFragment
      }
      currentVersion {
        id
        attachmentAttached {
          ...attachmentFragment
        }
      }
      aiIndexingError
    }
    metadata {
      ...metadataFragment
    }
  }
}
    ${EdmDocumentationCategoryFragmentFragmentDoc}
${AttachmentFragmentFragmentDoc}
${MetadataFragmentFragmentDoc}`;

/**
 * __useAiIndexingDocumentationsQuery__
 *
 * To run a query within a React component, call `useAiIndexingDocumentationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAiIndexingDocumentationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAiIndexingDocumentationsQuery({
 *   variables: {
 *      page: // value for 'page'
 *      limit: // value for 'limit'
 *      sorts: // value for 'sorts'
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useAiIndexingDocumentationsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<AiIndexingDocumentationsQuery, AiIndexingDocumentationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<AiIndexingDocumentationsQuery, AiIndexingDocumentationsQueryVariables>(AiIndexingDocumentationsDocument, options);
      }
export function useAiIndexingDocumentationsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<AiIndexingDocumentationsQuery, AiIndexingDocumentationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<AiIndexingDocumentationsQuery, AiIndexingDocumentationsQueryVariables>(AiIndexingDocumentationsDocument, options);
        }
// @ts-ignore
export function useAiIndexingDocumentationsSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<AiIndexingDocumentationsQuery, AiIndexingDocumentationsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<AiIndexingDocumentationsQuery, AiIndexingDocumentationsQueryVariables>;
// @ts-ignore
export function useAiIndexingDocumentationsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<AiIndexingDocumentationsQuery, AiIndexingDocumentationsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<AiIndexingDocumentationsQuery | undefined, AiIndexingDocumentationsQueryVariables>;
export function useAiIndexingDocumentationsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<AiIndexingDocumentationsQuery, AiIndexingDocumentationsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          // @ts-ignore
          return ApolloReactHooks.useSuspenseQuery<AiIndexingDocumentationsQuery, AiIndexingDocumentationsQueryVariables>(AiIndexingDocumentationsDocument, options);
        }
export type AiIndexingDocumentationsQueryHookResult = ReturnType<typeof useAiIndexingDocumentationsQuery>;
export type AiIndexingDocumentationsLazyQueryHookResult = ReturnType<typeof useAiIndexingDocumentationsLazyQuery>;
export type AiIndexingDocumentationsSuspenseQueryHookResult = ReturnType<typeof useAiIndexingDocumentationsSuspenseQuery>;
export type AiIndexingDocumentationsQueryResult = ApolloReactCommon.QueryResult<AiIndexingDocumentationsQuery, AiIndexingDocumentationsQueryVariables>;
export function refetchAiIndexingDocumentationsQuery(variables?: AiIndexingDocumentationsQueryVariables) {
      return { query: AiIndexingDocumentationsDocument, variables: variables }
    }
export const AiSendMessageDocument = gql`
    mutation aiSendMessage($attributes: AiSendMessageInputObject!) {
  data: aiSendMessage(input: {attributes: $attributes}) {
    ...aiConversationFragment
  }
}
    ${AiConversationFragmentFragmentDoc}`;

/**
 * __useAiSendMessageMutation__
 *
 * To run a mutation, you first call `useAiSendMessageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAiSendMessageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [aiSendMessageMutation, { data, loading, error }] = useAiSendMessageMutation({
 *   variables: {
 *      attributes: // value for 'attributes'
 *   },
 * });
 */
export function useAiSendMessageMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<AiSendMessageMutation, AiSendMessageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<AiSendMessageMutation, AiSendMessageMutationVariables>(AiSendMessageDocument, options);
      }
export type AiSendMessageMutationHookResult = ReturnType<typeof useAiSendMessageMutation>;
export type AiSendMessageMutationResult = ApolloReactCommon.MutationResult<AiSendMessageMutation>;
export const AiConversationUpdateDocument = gql`
    mutation aiConversationUpdate($id: ID!, $attributes: AiConversationUpdateInputObject!) {
  data: aiConversationUpdate(input: {id: $id, attributes: $attributes}) {
    ...aiConversationFragment
  }
}
    ${AiConversationFragmentFragmentDoc}`;

/**
 * __useAiConversationUpdateMutation__
 *
 * To run a mutation, you first call `useAiConversationUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAiConversationUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [aiConversationUpdateMutation, { data, loading, error }] = useAiConversationUpdateMutation({
 *   variables: {
 *      id: // value for 'id'
 *      attributes: // value for 'attributes'
 *   },
 * });
 */
export function useAiConversationUpdateMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<AiConversationUpdateMutation, AiConversationUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<AiConversationUpdateMutation, AiConversationUpdateMutationVariables>(AiConversationUpdateDocument, options);
      }
export type AiConversationUpdateMutationHookResult = ReturnType<typeof useAiConversationUpdateMutation>;
export type AiConversationUpdateMutationResult = ApolloReactCommon.MutationResult<AiConversationUpdateMutation>;
export const AiConversationDestroyDocument = gql`
    mutation aiConversationDestroy($id: ID!) {
  data: aiConversationDestroy(input: {id: $id}) {
    id
  }
}
    `;

/**
 * __useAiConversationDestroyMutation__
 *
 * To run a mutation, you first call `useAiConversationDestroyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAiConversationDestroyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [aiConversationDestroyMutation, { data, loading, error }] = useAiConversationDestroyMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useAiConversationDestroyMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<AiConversationDestroyMutation, AiConversationDestroyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<AiConversationDestroyMutation, AiConversationDestroyMutationVariables>(AiConversationDestroyDocument, options);
      }
export type AiConversationDestroyMutationHookResult = ReturnType<typeof useAiConversationDestroyMutation>;
export type AiConversationDestroyMutationResult = ApolloReactCommon.MutationResult<AiConversationDestroyMutation>;
export const AiSendMessageStopDocument = gql`
    mutation aiSendMessageStop($id: ID!) {
  data: aiSendMessageStop(input: {id: $id}) {
    ...aiConversationFragment
  }
}
    ${AiConversationFragmentFragmentDoc}`;

/**
 * __useAiSendMessageStopMutation__
 *
 * To run a mutation, you first call `useAiSendMessageStopMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAiSendMessageStopMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [aiSendMessageStopMutation, { data, loading, error }] = useAiSendMessageStopMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useAiSendMessageStopMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<AiSendMessageStopMutation, AiSendMessageStopMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<AiSendMessageStopMutation, AiSendMessageStopMutationVariables>(AiSendMessageStopDocument, options);
      }
export type AiSendMessageStopMutationHookResult = ReturnType<typeof useAiSendMessageStopMutation>;
export type AiSendMessageStopMutationResult = ApolloReactCommon.MutationResult<AiSendMessageStopMutation>;
export const AiMessageFeedbackCreateDocument = gql`
    mutation aiMessageFeedbackCreate($id: ID!, $attributes: AiMessageFeedbackInputObject!) {
  data: aiMessageFeedbackCreate(input: {id: $id, attributes: $attributes}) {
    ...aiMessageFragment
  }
}
    ${AiMessageFragmentFragmentDoc}`;

/**
 * __useAiMessageFeedbackCreateMutation__
 *
 * To run a mutation, you first call `useAiMessageFeedbackCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAiMessageFeedbackCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [aiMessageFeedbackCreateMutation, { data, loading, error }] = useAiMessageFeedbackCreateMutation({
 *   variables: {
 *      id: // value for 'id'
 *      attributes: // value for 'attributes'
 *   },
 * });
 */
export function useAiMessageFeedbackCreateMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<AiMessageFeedbackCreateMutation, AiMessageFeedbackCreateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<AiMessageFeedbackCreateMutation, AiMessageFeedbackCreateMutationVariables>(AiMessageFeedbackCreateDocument, options);
      }
export type AiMessageFeedbackCreateMutationHookResult = ReturnType<typeof useAiMessageFeedbackCreateMutation>;
export type AiMessageFeedbackCreateMutationResult = ApolloReactCommon.MutationResult<AiMessageFeedbackCreateMutation>;
export const AiMessageFeedbackDestroyDocument = gql`
    mutation aiMessageFeedbackDestroy($id: ID!) {
  data: aiMessageFeedbackDestroy(input: {id: $id}) {
    ...aiMessageFragment
  }
}
    ${AiMessageFragmentFragmentDoc}`;

/**
 * __useAiMessageFeedbackDestroyMutation__
 *
 * To run a mutation, you first call `useAiMessageFeedbackDestroyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAiMessageFeedbackDestroyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [aiMessageFeedbackDestroyMutation, { data, loading, error }] = useAiMessageFeedbackDestroyMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useAiMessageFeedbackDestroyMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<AiMessageFeedbackDestroyMutation, AiMessageFeedbackDestroyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<AiMessageFeedbackDestroyMutation, AiMessageFeedbackDestroyMutationVariables>(AiMessageFeedbackDestroyDocument, options);
      }
export type AiMessageFeedbackDestroyMutationHookResult = ReturnType<typeof useAiMessageFeedbackDestroyMutation>;
export type AiMessageFeedbackDestroyMutationResult = ApolloReactCommon.MutationResult<AiMessageFeedbackDestroyMutation>;
export const AiGenerateDocumentationFieldsDocument = gql`
    mutation aiGenerateDocumentationFields($attributes: AiGenerateDocumentationFieldsInputObject!) {
  data: aiGenerateDocumentationFields(input: {attributes: $attributes}) {
    generationId
  }
}
    `;

/**
 * __useAiGenerateDocumentationFieldsMutation__
 *
 * To run a mutation, you first call `useAiGenerateDocumentationFieldsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAiGenerateDocumentationFieldsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [aiGenerateDocumentationFieldsMutation, { data, loading, error }] = useAiGenerateDocumentationFieldsMutation({
 *   variables: {
 *      attributes: // value for 'attributes'
 *   },
 * });
 */
export function useAiGenerateDocumentationFieldsMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<AiGenerateDocumentationFieldsMutation, AiGenerateDocumentationFieldsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<AiGenerateDocumentationFieldsMutation, AiGenerateDocumentationFieldsMutationVariables>(AiGenerateDocumentationFieldsDocument, options);
      }
export type AiGenerateDocumentationFieldsMutationHookResult = ReturnType<typeof useAiGenerateDocumentationFieldsMutation>;
export type AiGenerateDocumentationFieldsMutationResult = ApolloReactCommon.MutationResult<AiGenerateDocumentationFieldsMutation>;
export const AiGenerateDocumentationVersionFieldsDocument = gql`
    mutation aiGenerateDocumentationVersionFields($attributes: AiGenerateDocumentationVersionFieldsInputObject!) {
  data: aiGenerateDocumentationVersionFields(input: {attributes: $attributes}) {
    generationId
  }
}
    `;

/**
 * __useAiGenerateDocumentationVersionFieldsMutation__
 *
 * To run a mutation, you first call `useAiGenerateDocumentationVersionFieldsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAiGenerateDocumentationVersionFieldsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [aiGenerateDocumentationVersionFieldsMutation, { data, loading, error }] = useAiGenerateDocumentationVersionFieldsMutation({
 *   variables: {
 *      attributes: // value for 'attributes'
 *   },
 * });
 */
export function useAiGenerateDocumentationVersionFieldsMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<AiGenerateDocumentationVersionFieldsMutation, AiGenerateDocumentationVersionFieldsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<AiGenerateDocumentationVersionFieldsMutation, AiGenerateDocumentationVersionFieldsMutationVariables>(AiGenerateDocumentationVersionFieldsDocument, options);
      }
export type AiGenerateDocumentationVersionFieldsMutationHookResult = ReturnType<typeof useAiGenerateDocumentationVersionFieldsMutation>;
export type AiGenerateDocumentationVersionFieldsMutationResult = ApolloReactCommon.MutationResult<AiGenerateDocumentationVersionFieldsMutation>;
export const AiDismissDocumentationDetectionDocument = gql`
    mutation aiDismissDocumentationDetection($id: ID!, $attributes: AiDismissDocumentationDetectionInputObject!) {
  data: aiDismissDocumentationDetection(input: {id: $id, attributes: $attributes}) {
    id
    code
    suggestedCodes
    aiDetectionStatus {
      field
      status
    }
  }
}
    `;

/**
 * __useAiDismissDocumentationDetectionMutation__
 *
 * To run a mutation, you first call `useAiDismissDocumentationDetectionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAiDismissDocumentationDetectionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [aiDismissDocumentationDetectionMutation, { data, loading, error }] = useAiDismissDocumentationDetectionMutation({
 *   variables: {
 *      id: // value for 'id'
 *      attributes: // value for 'attributes'
 *   },
 * });
 */
export function useAiDismissDocumentationDetectionMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<AiDismissDocumentationDetectionMutation, AiDismissDocumentationDetectionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<AiDismissDocumentationDetectionMutation, AiDismissDocumentationDetectionMutationVariables>(AiDismissDocumentationDetectionDocument, options);
      }
export type AiDismissDocumentationDetectionMutationHookResult = ReturnType<typeof useAiDismissDocumentationDetectionMutation>;
export type AiDismissDocumentationDetectionMutationResult = ApolloReactCommon.MutationResult<AiDismissDocumentationDetectionMutation>;
export const AiDocumentationPreviewDocument = gql`
    query aiDocumentationPreview($id: ID!, $versionId: ID! = "", $hasVersion: Boolean! = false, $isViewLocked: Boolean! = false) {
  data: documentation(id: $id) {
    id
    name
    read @skip(if: $isViewLocked)
    favorited @skip(if: $isViewLocked)
    currentVersion {
      id
      versionNumber
      notes
      attachmentAttached {
        ...attachmentFragment
      }
    }
  }
  pinnedVersion: documentationVersion(documentationId: $id, id: $versionId) @include(if: $hasVersion) {
    id
    versionNumber
    notes
    attachmentAttached {
      ...attachmentFragment
    }
  }
}
    ${AttachmentFragmentFragmentDoc}`;

/**
 * __useAiDocumentationPreviewQuery__
 *
 * To run a query within a React component, call `useAiDocumentationPreviewQuery` and pass it any options that fit your needs.
 * When your component renders, `useAiDocumentationPreviewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAiDocumentationPreviewQuery({
 *   variables: {
 *      id: // value for 'id'
 *      versionId: // value for 'versionId'
 *      hasVersion: // value for 'hasVersion'
 *      isViewLocked: // value for 'isViewLocked'
 *   },
 * });
 */
export function useAiDocumentationPreviewQuery(baseOptions: ApolloReactHooks.QueryHookOptions<AiDocumentationPreviewQuery, AiDocumentationPreviewQueryVariables> & ({ variables: AiDocumentationPreviewQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<AiDocumentationPreviewQuery, AiDocumentationPreviewQueryVariables>(AiDocumentationPreviewDocument, options);
      }
export function useAiDocumentationPreviewLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<AiDocumentationPreviewQuery, AiDocumentationPreviewQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<AiDocumentationPreviewQuery, AiDocumentationPreviewQueryVariables>(AiDocumentationPreviewDocument, options);
        }
// @ts-ignore
export function useAiDocumentationPreviewSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<AiDocumentationPreviewQuery, AiDocumentationPreviewQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<AiDocumentationPreviewQuery, AiDocumentationPreviewQueryVariables>;
// @ts-ignore
export function useAiDocumentationPreviewSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<AiDocumentationPreviewQuery, AiDocumentationPreviewQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<AiDocumentationPreviewQuery | undefined, AiDocumentationPreviewQueryVariables>;
export function useAiDocumentationPreviewSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<AiDocumentationPreviewQuery, AiDocumentationPreviewQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          // @ts-ignore
          return ApolloReactHooks.useSuspenseQuery<AiDocumentationPreviewQuery, AiDocumentationPreviewQueryVariables>(AiDocumentationPreviewDocument, options);
        }
export type AiDocumentationPreviewQueryHookResult = ReturnType<typeof useAiDocumentationPreviewQuery>;
export type AiDocumentationPreviewLazyQueryHookResult = ReturnType<typeof useAiDocumentationPreviewLazyQuery>;
export type AiDocumentationPreviewSuspenseQueryHookResult = ReturnType<typeof useAiDocumentationPreviewSuspenseQuery>;
export type AiDocumentationPreviewQueryResult = ApolloReactCommon.QueryResult<AiDocumentationPreviewQuery, AiDocumentationPreviewQueryVariables>;
export function refetchAiDocumentationPreviewQuery(variables: AiDocumentationPreviewQueryVariables) {
      return { query: AiDocumentationPreviewDocument, variables: variables }
    }
export const AiCompanyIndexingCoverageChangedDocument = gql`
    subscription aiCompanyIndexingCoverageChanged {
  data: aiCompanyIndexingCoverageChanged {
    ...aiIndexingCoverageFragment
  }
}
    ${AiIndexingCoverageFragmentFragmentDoc}`;

/**
 * __useAiCompanyIndexingCoverageChangedSubscription__
 *
 * To run a query within a React component, call `useAiCompanyIndexingCoverageChangedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useAiCompanyIndexingCoverageChangedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAiCompanyIndexingCoverageChangedSubscription({
 *   variables: {
 *   },
 * });
 */
export function useAiCompanyIndexingCoverageChangedSubscription(baseOptions?: ApolloReactHooks.SubscriptionHookOptions<AiCompanyIndexingCoverageChangedSubscription, AiCompanyIndexingCoverageChangedSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useSubscription<AiCompanyIndexingCoverageChangedSubscription, AiCompanyIndexingCoverageChangedSubscriptionVariables>(AiCompanyIndexingCoverageChangedDocument, options);
      }
export type AiCompanyIndexingCoverageChangedSubscriptionHookResult = ReturnType<typeof useAiCompanyIndexingCoverageChangedSubscription>;
export type AiCompanyIndexingCoverageChangedSubscriptionResult = ApolloReactCommon.SubscriptionResult<AiCompanyIndexingCoverageChangedSubscription>;
export const AiConversationStreamDocument = gql`
    subscription aiConversationStream($conversationId: ID!) {
  data: aiConversationStream(conversationId: $conversationId) {
    eventType
    messageId
    delta
    sequence
    status
    errorCode
    toolCallId
    toolName
    toolStatus
    suggestedFollowups
    conversationTitle
  }
}
    `;

/**
 * __useAiConversationStreamSubscription__
 *
 * To run a query within a React component, call `useAiConversationStreamSubscription` and pass it any options that fit your needs.
 * When your component renders, `useAiConversationStreamSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAiConversationStreamSubscription({
 *   variables: {
 *      conversationId: // value for 'conversationId'
 *   },
 * });
 */
export function useAiConversationStreamSubscription(baseOptions: ApolloReactHooks.SubscriptionHookOptions<AiConversationStreamSubscription, AiConversationStreamSubscriptionVariables> & ({ variables: AiConversationStreamSubscriptionVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useSubscription<AiConversationStreamSubscription, AiConversationStreamSubscriptionVariables>(AiConversationStreamDocument, options);
      }
export type AiConversationStreamSubscriptionHookResult = ReturnType<typeof useAiConversationStreamSubscription>;
export type AiConversationStreamSubscriptionResult = ApolloReactCommon.SubscriptionResult<AiConversationStreamSubscription>;
export const AiDocumentationFieldsGeneratedDocument = gql`
    subscription aiDocumentationFieldsGenerated($generationId: ID!) {
  data: aiDocumentationFieldsGenerated(generationId: $generationId) {
    generationId
    errorCode
    results {
      field
      text
      values
      categoryId
      notFound
      errorCode
    }
  }
}
    `;

/**
 * __useAiDocumentationFieldsGeneratedSubscription__
 *
 * To run a query within a React component, call `useAiDocumentationFieldsGeneratedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useAiDocumentationFieldsGeneratedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAiDocumentationFieldsGeneratedSubscription({
 *   variables: {
 *      generationId: // value for 'generationId'
 *   },
 * });
 */
export function useAiDocumentationFieldsGeneratedSubscription(baseOptions: ApolloReactHooks.SubscriptionHookOptions<AiDocumentationFieldsGeneratedSubscription, AiDocumentationFieldsGeneratedSubscriptionVariables> & ({ variables: AiDocumentationFieldsGeneratedSubscriptionVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useSubscription<AiDocumentationFieldsGeneratedSubscription, AiDocumentationFieldsGeneratedSubscriptionVariables>(AiDocumentationFieldsGeneratedDocument, options);
      }
export type AiDocumentationFieldsGeneratedSubscriptionHookResult = ReturnType<typeof useAiDocumentationFieldsGeneratedSubscription>;
export type AiDocumentationFieldsGeneratedSubscriptionResult = ApolloReactCommon.SubscriptionResult<AiDocumentationFieldsGeneratedSubscription>;
export const AiDocumentationVersionFieldsGeneratedDocument = gql`
    subscription aiDocumentationVersionFieldsGenerated($generationId: ID!) {
  data: aiDocumentationVersionFieldsGenerated(generationId: $generationId) {
    generationId
    errorCode
    results {
      field
      text
      values
      categoryId
      notFound
      errorCode
    }
  }
}
    `;

/**
 * __useAiDocumentationVersionFieldsGeneratedSubscription__
 *
 * To run a query within a React component, call `useAiDocumentationVersionFieldsGeneratedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useAiDocumentationVersionFieldsGeneratedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAiDocumentationVersionFieldsGeneratedSubscription({
 *   variables: {
 *      generationId: // value for 'generationId'
 *   },
 * });
 */
export function useAiDocumentationVersionFieldsGeneratedSubscription(baseOptions: ApolloReactHooks.SubscriptionHookOptions<AiDocumentationVersionFieldsGeneratedSubscription, AiDocumentationVersionFieldsGeneratedSubscriptionVariables> & ({ variables: AiDocumentationVersionFieldsGeneratedSubscriptionVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useSubscription<AiDocumentationVersionFieldsGeneratedSubscription, AiDocumentationVersionFieldsGeneratedSubscriptionVariables>(AiDocumentationVersionFieldsGeneratedDocument, options);
      }
export type AiDocumentationVersionFieldsGeneratedSubscriptionHookResult = ReturnType<typeof useAiDocumentationVersionFieldsGeneratedSubscription>;
export type AiDocumentationVersionFieldsGeneratedSubscriptionResult = ApolloReactCommon.SubscriptionResult<AiDocumentationVersionFieldsGeneratedSubscription>;
export const ApiTokenDocument = gql`
    query apiToken($id: ID!) {
  data: apiToken(id: $id) {
    id
    createdAt
    updatedAt
    label
    status
  }
}
    `;

/**
 * __useApiTokenQuery__
 *
 * To run a query within a React component, call `useApiTokenQuery` and pass it any options that fit your needs.
 * When your component renders, `useApiTokenQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useApiTokenQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useApiTokenQuery(baseOptions: ApolloReactHooks.QueryHookOptions<ApiTokenQuery, ApiTokenQueryVariables> & ({ variables: ApiTokenQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ApiTokenQuery, ApiTokenQueryVariables>(ApiTokenDocument, options);
      }
export function useApiTokenLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ApiTokenQuery, ApiTokenQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ApiTokenQuery, ApiTokenQueryVariables>(ApiTokenDocument, options);
        }
// @ts-ignore
export function useApiTokenSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<ApiTokenQuery, ApiTokenQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ApiTokenQuery, ApiTokenQueryVariables>;
// @ts-ignore
export function useApiTokenSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ApiTokenQuery, ApiTokenQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ApiTokenQuery | undefined, ApiTokenQueryVariables>;
export function useApiTokenSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ApiTokenQuery, ApiTokenQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          // @ts-ignore
          return ApolloReactHooks.useSuspenseQuery<ApiTokenQuery, ApiTokenQueryVariables>(ApiTokenDocument, options);
        }
export type ApiTokenQueryHookResult = ReturnType<typeof useApiTokenQuery>;
export type ApiTokenLazyQueryHookResult = ReturnType<typeof useApiTokenLazyQuery>;
export type ApiTokenSuspenseQueryHookResult = ReturnType<typeof useApiTokenSuspenseQuery>;
export type ApiTokenQueryResult = ApolloReactCommon.QueryResult<ApiTokenQuery, ApiTokenQueryVariables>;
export function refetchApiTokenQuery(variables: ApiTokenQueryVariables) {
      return { query: ApiTokenDocument, variables: variables }
    }
export const ApiTokensDocument = gql`
    query apiTokens($page: Int, $limit: Int) {
  data: apiTokens(page: $page, limit: $limit) {
    collection {
      id
      createdAt
      label
      status
    }
    metadata {
      ...metadataFragment
    }
  }
}
    ${MetadataFragmentFragmentDoc}`;

/**
 * __useApiTokensQuery__
 *
 * To run a query within a React component, call `useApiTokensQuery` and pass it any options that fit your needs.
 * When your component renders, `useApiTokensQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useApiTokensQuery({
 *   variables: {
 *      page: // value for 'page'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useApiTokensQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<ApiTokensQuery, ApiTokensQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ApiTokensQuery, ApiTokensQueryVariables>(ApiTokensDocument, options);
      }
export function useApiTokensLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ApiTokensQuery, ApiTokensQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ApiTokensQuery, ApiTokensQueryVariables>(ApiTokensDocument, options);
        }
// @ts-ignore
export function useApiTokensSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<ApiTokensQuery, ApiTokensQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ApiTokensQuery, ApiTokensQueryVariables>;
// @ts-ignore
export function useApiTokensSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ApiTokensQuery, ApiTokensQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ApiTokensQuery | undefined, ApiTokensQueryVariables>;
export function useApiTokensSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ApiTokensQuery, ApiTokensQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          // @ts-ignore
          return ApolloReactHooks.useSuspenseQuery<ApiTokensQuery, ApiTokensQueryVariables>(ApiTokensDocument, options);
        }
export type ApiTokensQueryHookResult = ReturnType<typeof useApiTokensQuery>;
export type ApiTokensLazyQueryHookResult = ReturnType<typeof useApiTokensLazyQuery>;
export type ApiTokensSuspenseQueryHookResult = ReturnType<typeof useApiTokensSuspenseQuery>;
export type ApiTokensQueryResult = ApolloReactCommon.QueryResult<ApiTokensQuery, ApiTokensQueryVariables>;
export function refetchApiTokensQuery(variables?: ApiTokensQueryVariables) {
      return { query: ApiTokensDocument, variables: variables }
    }
export const ApiTokenCreateDocument = gql`
    mutation apiTokenCreate($attributes: ApiTokenCreateInputObject!) {
  data: apiTokenCreate(input: {attributes: $attributes}) {
    id
    label
    token
  }
}
    `;

/**
 * __useApiTokenCreateMutation__
 *
 * To run a mutation, you first call `useApiTokenCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useApiTokenCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [apiTokenCreateMutation, { data, loading, error }] = useApiTokenCreateMutation({
 *   variables: {
 *      attributes: // value for 'attributes'
 *   },
 * });
 */
export function useApiTokenCreateMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<ApiTokenCreateMutation, ApiTokenCreateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<ApiTokenCreateMutation, ApiTokenCreateMutationVariables>(ApiTokenCreateDocument, options);
      }
export type ApiTokenCreateMutationHookResult = ReturnType<typeof useApiTokenCreateMutation>;
export type ApiTokenCreateMutationResult = ApolloReactCommon.MutationResult<ApiTokenCreateMutation>;
export const ApiTokenUpdateDocument = gql`
    mutation apiTokenUpdate($attributes: ApiTokenUpdateInputObject!, $id: ID!) {
  data: apiTokenUpdate(input: {id: $id, attributes: $attributes}) {
    label
  }
}
    `;

/**
 * __useApiTokenUpdateMutation__
 *
 * To run a mutation, you first call `useApiTokenUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useApiTokenUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [apiTokenUpdateMutation, { data, loading, error }] = useApiTokenUpdateMutation({
 *   variables: {
 *      attributes: // value for 'attributes'
 *      id: // value for 'id'
 *   },
 * });
 */
export function useApiTokenUpdateMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<ApiTokenUpdateMutation, ApiTokenUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<ApiTokenUpdateMutation, ApiTokenUpdateMutationVariables>(ApiTokenUpdateDocument, options);
      }
export type ApiTokenUpdateMutationHookResult = ReturnType<typeof useApiTokenUpdateMutation>;
export type ApiTokenUpdateMutationResult = ApolloReactCommon.MutationResult<ApiTokenUpdateMutation>;
export const ApiTokenDestroyDocument = gql`
    mutation apiTokenDestroy($id: ID!) {
  apiTokenDestroy(input: {id: $id})
}
    `;

/**
 * __useApiTokenDestroyMutation__
 *
 * To run a mutation, you first call `useApiTokenDestroyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useApiTokenDestroyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [apiTokenDestroyMutation, { data, loading, error }] = useApiTokenDestroyMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useApiTokenDestroyMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<ApiTokenDestroyMutation, ApiTokenDestroyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<ApiTokenDestroyMutation, ApiTokenDestroyMutationVariables>(ApiTokenDestroyDocument, options);
      }
export type ApiTokenDestroyMutationHookResult = ReturnType<typeof useApiTokenDestroyMutation>;
export type ApiTokenDestroyMutationResult = ApolloReactCommon.MutationResult<ApiTokenDestroyMutation>;
export const AssetsDocument = gql`
    query assets($page: Int, $limit: Int, $sorts: AssetSortInputObject, $filters: [AssetFilterInputObject!], $includeFullData: Boolean = false, $includeCategoryData: Boolean = false) {
  data: assets(page: $page, limit: $limit, sorts: $sorts, filters: $filters) {
    collection {
      category @include(if: $includeCategoryData) {
        color
        name
        id
      }
      id
      code
      fullCode
      manufacturer @include(if: $includeFullData)
      model @include(if: $includeFullData)
      name
      serialNumber @include(if: $includeFullData)
      site {
        id
        name
        code
      }
      siteArea {
        id
        name
        code
      }
      iconAttached {
        ...attachmentFragment
      }
      canDestroy {
        ...authorizationResultFragment
      }
    }
    metadata {
      ...metadataFragment
    }
  }
}
    ${AttachmentFragmentFragmentDoc}
${AuthorizationResultFragmentFragmentDoc}
${MetadataFragmentFragmentDoc}`;

/**
 * __useAssetsQuery__
 *
 * To run a query within a React component, call `useAssetsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAssetsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAssetsQuery({
 *   variables: {
 *      page: // value for 'page'
 *      limit: // value for 'limit'
 *      sorts: // value for 'sorts'
 *      filters: // value for 'filters'
 *      includeFullData: // value for 'includeFullData'
 *      includeCategoryData: // value for 'includeCategoryData'
 *   },
 * });
 */
export function useAssetsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<AssetsQuery, AssetsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<AssetsQuery, AssetsQueryVariables>(AssetsDocument, options);
      }
export function useAssetsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<AssetsQuery, AssetsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<AssetsQuery, AssetsQueryVariables>(AssetsDocument, options);
        }
// @ts-ignore
export function useAssetsSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<AssetsQuery, AssetsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<AssetsQuery, AssetsQueryVariables>;
// @ts-ignore
export function useAssetsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<AssetsQuery, AssetsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<AssetsQuery | undefined, AssetsQueryVariables>;
export function useAssetsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<AssetsQuery, AssetsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          // @ts-ignore
          return ApolloReactHooks.useSuspenseQuery<AssetsQuery, AssetsQueryVariables>(AssetsDocument, options);
        }
export type AssetsQueryHookResult = ReturnType<typeof useAssetsQuery>;
export type AssetsLazyQueryHookResult = ReturnType<typeof useAssetsLazyQuery>;
export type AssetsSuspenseQueryHookResult = ReturnType<typeof useAssetsSuspenseQuery>;
export type AssetsQueryResult = ApolloReactCommon.QueryResult<AssetsQuery, AssetsQueryVariables>;
export function refetchAssetsQuery(variables?: AssetsQueryVariables) {
      return { query: AssetsDocument, variables: variables }
    }
export const AssetIdsDocument = gql`
    query assetIds($sorts: AssetSortInputObject, $filters: [AssetFilterInputObject!], $onlyIds: Boolean, $includeSiteId: Boolean = false) {
  data: assets(sorts: $sorts, filters: $filters, onlyIds: $onlyIds) {
    collection {
      id
      siteId @include(if: $includeSiteId)
    }
  }
}
    `;

/**
 * __useAssetIdsQuery__
 *
 * To run a query within a React component, call `useAssetIdsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAssetIdsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAssetIdsQuery({
 *   variables: {
 *      sorts: // value for 'sorts'
 *      filters: // value for 'filters'
 *      onlyIds: // value for 'onlyIds'
 *      includeSiteId: // value for 'includeSiteId'
 *   },
 * });
 */
export function useAssetIdsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<AssetIdsQuery, AssetIdsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<AssetIdsQuery, AssetIdsQueryVariables>(AssetIdsDocument, options);
      }
export function useAssetIdsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<AssetIdsQuery, AssetIdsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<AssetIdsQuery, AssetIdsQueryVariables>(AssetIdsDocument, options);
        }
// @ts-ignore
export function useAssetIdsSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<AssetIdsQuery, AssetIdsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<AssetIdsQuery, AssetIdsQueryVariables>;
// @ts-ignore
export function useAssetIdsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<AssetIdsQuery, AssetIdsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<AssetIdsQuery | undefined, AssetIdsQueryVariables>;
export function useAssetIdsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<AssetIdsQuery, AssetIdsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          // @ts-ignore
          return ApolloReactHooks.useSuspenseQuery<AssetIdsQuery, AssetIdsQueryVariables>(AssetIdsDocument, options);
        }
export type AssetIdsQueryHookResult = ReturnType<typeof useAssetIdsQuery>;
export type AssetIdsLazyQueryHookResult = ReturnType<typeof useAssetIdsLazyQuery>;
export type AssetIdsSuspenseQueryHookResult = ReturnType<typeof useAssetIdsSuspenseQuery>;
export type AssetIdsQueryResult = ApolloReactCommon.QueryResult<AssetIdsQuery, AssetIdsQueryVariables>;
export function refetchAssetIdsQuery(variables?: AssetIdsQueryVariables) {
      return { query: AssetIdsDocument, variables: variables }
    }
export const AssetsSearchListDocument = gql`
    query assetsSearchList($page: Int, $limit: Int, $sorts: AssetSortInputObject, $filters: [AssetFilterInputObject!]) {
  data: assets(page: $page, limit: $limit, sorts: $sorts, filters: $filters) {
    collection {
      id
      fullCode
      name
      iconAttached {
        ...attachmentFragment
      }
      poorWifi
      usesAsNomenclatureCount
    }
    metadata {
      ...metadataFragment
    }
  }
}
    ${AttachmentFragmentFragmentDoc}
${MetadataFragmentFragmentDoc}`;

/**
 * __useAssetsSearchListQuery__
 *
 * To run a query within a React component, call `useAssetsSearchListQuery` and pass it any options that fit your needs.
 * When your component renders, `useAssetsSearchListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAssetsSearchListQuery({
 *   variables: {
 *      page: // value for 'page'
 *      limit: // value for 'limit'
 *      sorts: // value for 'sorts'
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useAssetsSearchListQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<AssetsSearchListQuery, AssetsSearchListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<AssetsSearchListQuery, AssetsSearchListQueryVariables>(AssetsSearchListDocument, options);
      }
export function useAssetsSearchListLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<AssetsSearchListQuery, AssetsSearchListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<AssetsSearchListQuery, AssetsSearchListQueryVariables>(AssetsSearchListDocument, options);
        }
// @ts-ignore
export function useAssetsSearchListSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<AssetsSearchListQuery, AssetsSearchListQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<AssetsSearchListQuery, AssetsSearchListQueryVariables>;
// @ts-ignore
export function useAssetsSearchListSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<AssetsSearchListQuery, AssetsSearchListQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<AssetsSearchListQuery | undefined, AssetsSearchListQueryVariables>;
export function useAssetsSearchListSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<AssetsSearchListQuery, AssetsSearchListQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          // @ts-ignore
          return ApolloReactHooks.useSuspenseQuery<AssetsSearchListQuery, AssetsSearchListQueryVariables>(AssetsSearchListDocument, options);
        }
export type AssetsSearchListQueryHookResult = ReturnType<typeof useAssetsSearchListQuery>;
export type AssetsSearchListLazyQueryHookResult = ReturnType<typeof useAssetsSearchListLazyQuery>;
export type AssetsSearchListSuspenseQueryHookResult = ReturnType<typeof useAssetsSearchListSuspenseQuery>;
export type AssetsSearchListQueryResult = ApolloReactCommon.QueryResult<AssetsSearchListQuery, AssetsSearchListQueryVariables>;
export function refetchAssetsSearchListQuery(variables?: AssetsSearchListQueryVariables) {
      return { query: AssetsSearchListDocument, variables: variables }
    }
export const AssetDocument = gql`
    query asset($findBy: AssetFindByInputObject!, $includeFullData: Boolean = false) {
  data: asset(findBy: $findBy) {
    ...assetFragment @include(if: $includeFullData)
    id
    name
    fullCode
    siteId
    canDestroy {
      ...authorizationResultFragment
    }
  }
}
    ${AssetFragmentFragmentDoc}
${AssetCategoryFragmentFragmentDoc}
${AttachmentFragmentFragmentDoc}
${AuthorizationResultFragmentFragmentDoc}`;

/**
 * __useAssetQuery__
 *
 * To run a query within a React component, call `useAssetQuery` and pass it any options that fit your needs.
 * When your component renders, `useAssetQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAssetQuery({
 *   variables: {
 *      findBy: // value for 'findBy'
 *      includeFullData: // value for 'includeFullData'
 *   },
 * });
 */
export function useAssetQuery(baseOptions: ApolloReactHooks.QueryHookOptions<AssetQuery, AssetQueryVariables> & ({ variables: AssetQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<AssetQuery, AssetQueryVariables>(AssetDocument, options);
      }
export function useAssetLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<AssetQuery, AssetQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<AssetQuery, AssetQueryVariables>(AssetDocument, options);
        }
// @ts-ignore
export function useAssetSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<AssetQuery, AssetQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<AssetQuery, AssetQueryVariables>;
// @ts-ignore
export function useAssetSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<AssetQuery, AssetQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<AssetQuery | undefined, AssetQueryVariables>;
export function useAssetSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<AssetQuery, AssetQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          // @ts-ignore
          return ApolloReactHooks.useSuspenseQuery<AssetQuery, AssetQueryVariables>(AssetDocument, options);
        }
export type AssetQueryHookResult = ReturnType<typeof useAssetQuery>;
export type AssetLazyQueryHookResult = ReturnType<typeof useAssetLazyQuery>;
export type AssetSuspenseQueryHookResult = ReturnType<typeof useAssetSuspenseQuery>;
export type AssetQueryResult = ApolloReactCommon.QueryResult<AssetQuery, AssetQueryVariables>;
export function refetchAssetQuery(variables: AssetQueryVariables) {
      return { query: AssetDocument, variables: variables }
    }
export const AssetWithCountersDocument = gql`
    query assetWithCounters($findBy: AssetFindByInputObject!, $includeFullData: Boolean = false, $mainAssetId: ID!, $nomenclaturesFilters: [NomenclatureFilterInputObject!], $countersFilters: [CounterFilterInputObject!], $documentationsFilters: [DocumentationFilterInputObject!], $interventionsFilters: [InterventionFilterInputObject!], $interventionsScopeName: InterventionScopeNameEnum!, $isDocumentationLocked: Boolean! = false, $isInterventionsLocked: Boolean! = false) {
  data: asset(findBy: $findBy) {
    ...assetFragment @include(if: $includeFullData)
    id
    name
    fullCode
    site @skip(if: $includeFullData) {
      id
      name
    }
    siteArea @skip(if: $includeFullData) {
      id
      name
    }
    canDestroy {
      ...authorizationResultFragment
    }
  }
  nomenclatures(filters: $nomenclaturesFilters, mainAssetId: $mainAssetId) {
    metadata {
      totalCount
    }
  }
  counters(filters: $countersFilters, assetId: $mainAssetId) {
    metadata {
      totalCount
    }
  }
  documentations(filters: $documentationsFilters) @skip(if: $isDocumentationLocked) {
    metadata {
      totalCount
    }
  }
  interventions(
    filters: $interventionsFilters
    scopeName: $interventionsScopeName
  ) @skip(if: $isInterventionsLocked) {
    metadata {
      totalCount
    }
  }
}
    ${AssetFragmentFragmentDoc}
${AssetCategoryFragmentFragmentDoc}
${AttachmentFragmentFragmentDoc}
${AuthorizationResultFragmentFragmentDoc}`;

/**
 * __useAssetWithCountersQuery__
 *
 * To run a query within a React component, call `useAssetWithCountersQuery` and pass it any options that fit your needs.
 * When your component renders, `useAssetWithCountersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAssetWithCountersQuery({
 *   variables: {
 *      findBy: // value for 'findBy'
 *      includeFullData: // value for 'includeFullData'
 *      mainAssetId: // value for 'mainAssetId'
 *      nomenclaturesFilters: // value for 'nomenclaturesFilters'
 *      countersFilters: // value for 'countersFilters'
 *      documentationsFilters: // value for 'documentationsFilters'
 *      interventionsFilters: // value for 'interventionsFilters'
 *      interventionsScopeName: // value for 'interventionsScopeName'
 *      isDocumentationLocked: // value for 'isDocumentationLocked'
 *      isInterventionsLocked: // value for 'isInterventionsLocked'
 *   },
 * });
 */
export function useAssetWithCountersQuery(baseOptions: ApolloReactHooks.QueryHookOptions<AssetWithCountersQuery, AssetWithCountersQueryVariables> & ({ variables: AssetWithCountersQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<AssetWithCountersQuery, AssetWithCountersQueryVariables>(AssetWithCountersDocument, options);
      }
export function useAssetWithCountersLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<AssetWithCountersQuery, AssetWithCountersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<AssetWithCountersQuery, AssetWithCountersQueryVariables>(AssetWithCountersDocument, options);
        }
// @ts-ignore
export function useAssetWithCountersSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<AssetWithCountersQuery, AssetWithCountersQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<AssetWithCountersQuery, AssetWithCountersQueryVariables>;
// @ts-ignore
export function useAssetWithCountersSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<AssetWithCountersQuery, AssetWithCountersQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<AssetWithCountersQuery | undefined, AssetWithCountersQueryVariables>;
export function useAssetWithCountersSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<AssetWithCountersQuery, AssetWithCountersQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          // @ts-ignore
          return ApolloReactHooks.useSuspenseQuery<AssetWithCountersQuery, AssetWithCountersQueryVariables>(AssetWithCountersDocument, options);
        }
export type AssetWithCountersQueryHookResult = ReturnType<typeof useAssetWithCountersQuery>;
export type AssetWithCountersLazyQueryHookResult = ReturnType<typeof useAssetWithCountersLazyQuery>;
export type AssetWithCountersSuspenseQueryHookResult = ReturnType<typeof useAssetWithCountersSuspenseQuery>;
export type AssetWithCountersQueryResult = ApolloReactCommon.QueryResult<AssetWithCountersQuery, AssetWithCountersQueryVariables>;
export function refetchAssetWithCountersQuery(variables: AssetWithCountersQueryVariables) {
      return { query: AssetWithCountersDocument, variables: variables }
    }
export const AssetCategoryDocument = gql`
    query assetCategory($id: ID!) {
  data: assetCategory(id: $id) {
    ...assetCategoryFragment
  }
}
    ${AssetCategoryFragmentFragmentDoc}`;

/**
 * __useAssetCategoryQuery__
 *
 * To run a query within a React component, call `useAssetCategoryQuery` and pass it any options that fit your needs.
 * When your component renders, `useAssetCategoryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAssetCategoryQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useAssetCategoryQuery(baseOptions: ApolloReactHooks.QueryHookOptions<AssetCategoryQuery, AssetCategoryQueryVariables> & ({ variables: AssetCategoryQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<AssetCategoryQuery, AssetCategoryQueryVariables>(AssetCategoryDocument, options);
      }
export function useAssetCategoryLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<AssetCategoryQuery, AssetCategoryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<AssetCategoryQuery, AssetCategoryQueryVariables>(AssetCategoryDocument, options);
        }
// @ts-ignore
export function useAssetCategorySuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<AssetCategoryQuery, AssetCategoryQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<AssetCategoryQuery, AssetCategoryQueryVariables>;
// @ts-ignore
export function useAssetCategorySuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<AssetCategoryQuery, AssetCategoryQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<AssetCategoryQuery | undefined, AssetCategoryQueryVariables>;
export function useAssetCategorySuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<AssetCategoryQuery, AssetCategoryQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          // @ts-ignore
          return ApolloReactHooks.useSuspenseQuery<AssetCategoryQuery, AssetCategoryQueryVariables>(AssetCategoryDocument, options);
        }
export type AssetCategoryQueryHookResult = ReturnType<typeof useAssetCategoryQuery>;
export type AssetCategoryLazyQueryHookResult = ReturnType<typeof useAssetCategoryLazyQuery>;
export type AssetCategorySuspenseQueryHookResult = ReturnType<typeof useAssetCategorySuspenseQuery>;
export type AssetCategoryQueryResult = ApolloReactCommon.QueryResult<AssetCategoryQuery, AssetCategoryQueryVariables>;
export function refetchAssetCategoryQuery(variables: AssetCategoryQueryVariables) {
      return { query: AssetCategoryDocument, variables: variables }
    }
export const AssetCategoriesDocument = gql`
    query assetCategories($page: Int, $limit: Int, $filters: [AssetCategoryFilterInputObject!], $sorts: AssetCategorySortInputObject) {
  data: assetCategories(
    page: $page
    limit: $limit
    sorts: $sorts
    filters: $filters
  ) {
    collection {
      ...assetCategoryFragment
      assets {
        collection {
          id
          name
        }
      }
      visibleAssetsCount
      canDestroy {
        value
      }
    }
    metadata {
      ...metadataFragment
    }
  }
}
    ${AssetCategoryFragmentFragmentDoc}
${MetadataFragmentFragmentDoc}`;

/**
 * __useAssetCategoriesQuery__
 *
 * To run a query within a React component, call `useAssetCategoriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useAssetCategoriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAssetCategoriesQuery({
 *   variables: {
 *      page: // value for 'page'
 *      limit: // value for 'limit'
 *      filters: // value for 'filters'
 *      sorts: // value for 'sorts'
 *   },
 * });
 */
export function useAssetCategoriesQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<AssetCategoriesQuery, AssetCategoriesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<AssetCategoriesQuery, AssetCategoriesQueryVariables>(AssetCategoriesDocument, options);
      }
export function useAssetCategoriesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<AssetCategoriesQuery, AssetCategoriesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<AssetCategoriesQuery, AssetCategoriesQueryVariables>(AssetCategoriesDocument, options);
        }
// @ts-ignore
export function useAssetCategoriesSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<AssetCategoriesQuery, AssetCategoriesQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<AssetCategoriesQuery, AssetCategoriesQueryVariables>;
// @ts-ignore
export function useAssetCategoriesSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<AssetCategoriesQuery, AssetCategoriesQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<AssetCategoriesQuery | undefined, AssetCategoriesQueryVariables>;
export function useAssetCategoriesSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<AssetCategoriesQuery, AssetCategoriesQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          // @ts-ignore
          return ApolloReactHooks.useSuspenseQuery<AssetCategoriesQuery, AssetCategoriesQueryVariables>(AssetCategoriesDocument, options);
        }
export type AssetCategoriesQueryHookResult = ReturnType<typeof useAssetCategoriesQuery>;
export type AssetCategoriesLazyQueryHookResult = ReturnType<typeof useAssetCategoriesLazyQuery>;
export type AssetCategoriesSuspenseQueryHookResult = ReturnType<typeof useAssetCategoriesSuspenseQuery>;
export type AssetCategoriesQueryResult = ApolloReactCommon.QueryResult<AssetCategoriesQuery, AssetCategoriesQueryVariables>;
export function refetchAssetCategoriesQuery(variables?: AssetCategoriesQueryVariables) {
      return { query: AssetCategoriesDocument, variables: variables }
    }
export const AssetCategoriesSearchListDocument = gql`
    query assetCategoriesSearchList($page: Int, $limit: Int, $filters: [AssetCategoryFilterInputObject!], $sorts: AssetCategorySortInputObject) {
  data: assetCategories(
    page: $page
    limit: $limit
    sorts: $sorts
    filters: $filters
  ) {
    collection {
      ...assetCategoryFragment
    }
    metadata {
      ...metadataFragment
    }
  }
}
    ${AssetCategoryFragmentFragmentDoc}
${MetadataFragmentFragmentDoc}`;

/**
 * __useAssetCategoriesSearchListQuery__
 *
 * To run a query within a React component, call `useAssetCategoriesSearchListQuery` and pass it any options that fit your needs.
 * When your component renders, `useAssetCategoriesSearchListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAssetCategoriesSearchListQuery({
 *   variables: {
 *      page: // value for 'page'
 *      limit: // value for 'limit'
 *      filters: // value for 'filters'
 *      sorts: // value for 'sorts'
 *   },
 * });
 */
export function useAssetCategoriesSearchListQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<AssetCategoriesSearchListQuery, AssetCategoriesSearchListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<AssetCategoriesSearchListQuery, AssetCategoriesSearchListQueryVariables>(AssetCategoriesSearchListDocument, options);
      }
export function useAssetCategoriesSearchListLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<AssetCategoriesSearchListQuery, AssetCategoriesSearchListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<AssetCategoriesSearchListQuery, AssetCategoriesSearchListQueryVariables>(AssetCategoriesSearchListDocument, options);
        }
// @ts-ignore
export function useAssetCategoriesSearchListSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<AssetCategoriesSearchListQuery, AssetCategoriesSearchListQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<AssetCategoriesSearchListQuery, AssetCategoriesSearchListQueryVariables>;
// @ts-ignore
export function useAssetCategoriesSearchListSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<AssetCategoriesSearchListQuery, AssetCategoriesSearchListQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<AssetCategoriesSearchListQuery | undefined, AssetCategoriesSearchListQueryVariables>;
export function useAssetCategoriesSearchListSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<AssetCategoriesSearchListQuery, AssetCategoriesSearchListQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          // @ts-ignore
          return ApolloReactHooks.useSuspenseQuery<AssetCategoriesSearchListQuery, AssetCategoriesSearchListQueryVariables>(AssetCategoriesSearchListDocument, options);
        }
export type AssetCategoriesSearchListQueryHookResult = ReturnType<typeof useAssetCategoriesSearchListQuery>;
export type AssetCategoriesSearchListLazyQueryHookResult = ReturnType<typeof useAssetCategoriesSearchListLazyQuery>;
export type AssetCategoriesSearchListSuspenseQueryHookResult = ReturnType<typeof useAssetCategoriesSearchListSuspenseQuery>;
export type AssetCategoriesSearchListQueryResult = ApolloReactCommon.QueryResult<AssetCategoriesSearchListQuery, AssetCategoriesSearchListQueryVariables>;
export function refetchAssetCategoriesSearchListQuery(variables?: AssetCategoriesSearchListQueryVariables) {
      return { query: AssetCategoriesSearchListDocument, variables: variables }
    }
export const AssetBulkDestroyDocument = gql`
    mutation assetBulkDestroy($input: AssetBulkDestroyInput!) {
  data: assetBulkDestroy(input: $input)
}
    `;

/**
 * __useAssetBulkDestroyMutation__
 *
 * To run a mutation, you first call `useAssetBulkDestroyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAssetBulkDestroyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [assetBulkDestroyMutation, { data, loading, error }] = useAssetBulkDestroyMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAssetBulkDestroyMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<AssetBulkDestroyMutation, AssetBulkDestroyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<AssetBulkDestroyMutation, AssetBulkDestroyMutationVariables>(AssetBulkDestroyDocument, options);
      }
export type AssetBulkDestroyMutationHookResult = ReturnType<typeof useAssetBulkDestroyMutation>;
export type AssetBulkDestroyMutationResult = ApolloReactCommon.MutationResult<AssetBulkDestroyMutation>;
export const AssetCategoryCreateDocument = gql`
    mutation assetCategoryCreate($attributes: AssetCategoryCreateInputObject!) {
  data: assetCategoryCreate(input: {attributes: $attributes}) {
    ...assetCategoryFragment
  }
}
    ${AssetCategoryFragmentFragmentDoc}`;

/**
 * __useAssetCategoryCreateMutation__
 *
 * To run a mutation, you first call `useAssetCategoryCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAssetCategoryCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [assetCategoryCreateMutation, { data, loading, error }] = useAssetCategoryCreateMutation({
 *   variables: {
 *      attributes: // value for 'attributes'
 *   },
 * });
 */
export function useAssetCategoryCreateMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<AssetCategoryCreateMutation, AssetCategoryCreateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<AssetCategoryCreateMutation, AssetCategoryCreateMutationVariables>(AssetCategoryCreateDocument, options);
      }
export type AssetCategoryCreateMutationHookResult = ReturnType<typeof useAssetCategoryCreateMutation>;
export type AssetCategoryCreateMutationResult = ApolloReactCommon.MutationResult<AssetCategoryCreateMutation>;
export const AssetCategoryUpdateDocument = gql`
    mutation assetCategoryUpdate($attributes: AssetCategoryUpdateInputObject!, $id: ID!, $refreshQrPrefixForAssets: Boolean) {
  data: assetCategoryUpdate(
    input: {id: $id, attributes: $attributes, refreshQrPrefixForAssets: $refreshQrPrefixForAssets}
  ) {
    ...assetCategoryFragment
  }
}
    ${AssetCategoryFragmentFragmentDoc}`;

/**
 * __useAssetCategoryUpdateMutation__
 *
 * To run a mutation, you first call `useAssetCategoryUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAssetCategoryUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [assetCategoryUpdateMutation, { data, loading, error }] = useAssetCategoryUpdateMutation({
 *   variables: {
 *      attributes: // value for 'attributes'
 *      id: // value for 'id'
 *      refreshQrPrefixForAssets: // value for 'refreshQrPrefixForAssets'
 *   },
 * });
 */
export function useAssetCategoryUpdateMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<AssetCategoryUpdateMutation, AssetCategoryUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<AssetCategoryUpdateMutation, AssetCategoryUpdateMutationVariables>(AssetCategoryUpdateDocument, options);
      }
export type AssetCategoryUpdateMutationHookResult = ReturnType<typeof useAssetCategoryUpdateMutation>;
export type AssetCategoryUpdateMutationResult = ApolloReactCommon.MutationResult<AssetCategoryUpdateMutation>;
export const AssetCategoryDestroyDocument = gql`
    mutation assetCategoryDestroy($id: ID!) {
  assetCategoryDestroy(input: {id: $id})
}
    `;

/**
 * __useAssetCategoryDestroyMutation__
 *
 * To run a mutation, you first call `useAssetCategoryDestroyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAssetCategoryDestroyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [assetCategoryDestroyMutation, { data, loading, error }] = useAssetCategoryDestroyMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useAssetCategoryDestroyMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<AssetCategoryDestroyMutation, AssetCategoryDestroyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<AssetCategoryDestroyMutation, AssetCategoryDestroyMutationVariables>(AssetCategoryDestroyDocument, options);
      }
export type AssetCategoryDestroyMutationHookResult = ReturnType<typeof useAssetCategoryDestroyMutation>;
export type AssetCategoryDestroyMutationResult = ApolloReactCommon.MutationResult<AssetCategoryDestroyMutation>;
export const AssetCreateDocument = gql`
    mutation assetCreate($attributes: AssetCreateInputObject!) {
  data: assetCreate(input: {attributes: $attributes}) {
    ...assetFragment
  }
}
    ${AssetFragmentFragmentDoc}
${AssetCategoryFragmentFragmentDoc}
${AttachmentFragmentFragmentDoc}`;

/**
 * __useAssetCreateMutation__
 *
 * To run a mutation, you first call `useAssetCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAssetCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [assetCreateMutation, { data, loading, error }] = useAssetCreateMutation({
 *   variables: {
 *      attributes: // value for 'attributes'
 *   },
 * });
 */
export function useAssetCreateMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<AssetCreateMutation, AssetCreateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<AssetCreateMutation, AssetCreateMutationVariables>(AssetCreateDocument, options);
      }
export type AssetCreateMutationHookResult = ReturnType<typeof useAssetCreateMutation>;
export type AssetCreateMutationResult = ApolloReactCommon.MutationResult<AssetCreateMutation>;
export const AssetUpdateDocument = gql`
    mutation assetUpdate($attributes: AssetUpdateInputObject!, $id: ID!) {
  data: assetUpdate(input: {attributes: $attributes, id: $id}) {
    ...assetFragment
  }
}
    ${AssetFragmentFragmentDoc}
${AssetCategoryFragmentFragmentDoc}
${AttachmentFragmentFragmentDoc}`;

/**
 * __useAssetUpdateMutation__
 *
 * To run a mutation, you first call `useAssetUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAssetUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [assetUpdateMutation, { data, loading, error }] = useAssetUpdateMutation({
 *   variables: {
 *      attributes: // value for 'attributes'
 *      id: // value for 'id'
 *   },
 * });
 */
export function useAssetUpdateMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<AssetUpdateMutation, AssetUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<AssetUpdateMutation, AssetUpdateMutationVariables>(AssetUpdateDocument, options);
      }
export type AssetUpdateMutationHookResult = ReturnType<typeof useAssetUpdateMutation>;
export type AssetUpdateMutationResult = ApolloReactCommon.MutationResult<AssetUpdateMutation>;
export const AssetBulkQrCodeCreateDocument = gql`
    mutation assetBulkQrCodeCreate($params: QrCodesCreateInputObject!) {
  data: assetBulkQrCodeCreate(input: {params: $params}) {
    ...backgroundJobTreeFragment
  }
}
    ${BackgroundJobTreeFragmentFragmentDoc}
${BackgroundJobFragmentFragmentDoc}
${AuthorizationResultFragmentFragmentDoc}`;

/**
 * __useAssetBulkQrCodeCreateMutation__
 *
 * To run a mutation, you first call `useAssetBulkQrCodeCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAssetBulkQrCodeCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [assetBulkQrCodeCreateMutation, { data, loading, error }] = useAssetBulkQrCodeCreateMutation({
 *   variables: {
 *      params: // value for 'params'
 *   },
 * });
 */
export function useAssetBulkQrCodeCreateMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<AssetBulkQrCodeCreateMutation, AssetBulkQrCodeCreateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<AssetBulkQrCodeCreateMutation, AssetBulkQrCodeCreateMutationVariables>(AssetBulkQrCodeCreateDocument, options);
      }
export type AssetBulkQrCodeCreateMutationHookResult = ReturnType<typeof useAssetBulkQrCodeCreateMutation>;
export type AssetBulkQrCodeCreateMutationResult = ApolloReactCommon.MutationResult<AssetBulkQrCodeCreateMutation>;
export const AssetNomenclatureBulkQrCodeCreateDocument = gql`
    mutation assetNomenclatureBulkQrCodeCreate($params: QrCodesCreateInputObject!) {
  data: nomenclatureBulkQrCodeCreate(input: {params: $params}) {
    ...backgroundJobTreeFragment
  }
}
    ${BackgroundJobTreeFragmentFragmentDoc}
${BackgroundJobFragmentFragmentDoc}
${AuthorizationResultFragmentFragmentDoc}`;

/**
 * __useAssetNomenclatureBulkQrCodeCreateMutation__
 *
 * To run a mutation, you first call `useAssetNomenclatureBulkQrCodeCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAssetNomenclatureBulkQrCodeCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [assetNomenclatureBulkQrCodeCreateMutation, { data, loading, error }] = useAssetNomenclatureBulkQrCodeCreateMutation({
 *   variables: {
 *      params: // value for 'params'
 *   },
 * });
 */
export function useAssetNomenclatureBulkQrCodeCreateMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<AssetNomenclatureBulkQrCodeCreateMutation, AssetNomenclatureBulkQrCodeCreateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<AssetNomenclatureBulkQrCodeCreateMutation, AssetNomenclatureBulkQrCodeCreateMutationVariables>(AssetNomenclatureBulkQrCodeCreateDocument, options);
      }
export type AssetNomenclatureBulkQrCodeCreateMutationHookResult = ReturnType<typeof useAssetNomenclatureBulkQrCodeCreateMutation>;
export type AssetNomenclatureBulkQrCodeCreateMutationResult = ApolloReactCommon.MutationResult<AssetNomenclatureBulkQrCodeCreateMutation>;
export const AssetCountersDocument = gql`
    query assetCounters($page: Int, $limit: Int, $sorts: CounterSortInputObject, $filters: [CounterFilterInputObject!], $assetId: ID!) {
  data: counters(
    page: $page
    limit: $limit
    sorts: $sorts
    filters: $filters
    assetId: $assetId
  ) {
    collection {
      code
      fullCode
      id
      lastCheckAt
      latestIndex
      measureType
      measureUnit
      name
    }
    metadata {
      ...metadataFragment
    }
  }
}
    ${MetadataFragmentFragmentDoc}`;

/**
 * __useAssetCountersQuery__
 *
 * To run a query within a React component, call `useAssetCountersQuery` and pass it any options that fit your needs.
 * When your component renders, `useAssetCountersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAssetCountersQuery({
 *   variables: {
 *      page: // value for 'page'
 *      limit: // value for 'limit'
 *      sorts: // value for 'sorts'
 *      filters: // value for 'filters'
 *      assetId: // value for 'assetId'
 *   },
 * });
 */
export function useAssetCountersQuery(baseOptions: ApolloReactHooks.QueryHookOptions<AssetCountersQuery, AssetCountersQueryVariables> & ({ variables: AssetCountersQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<AssetCountersQuery, AssetCountersQueryVariables>(AssetCountersDocument, options);
      }
export function useAssetCountersLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<AssetCountersQuery, AssetCountersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<AssetCountersQuery, AssetCountersQueryVariables>(AssetCountersDocument, options);
        }
// @ts-ignore
export function useAssetCountersSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<AssetCountersQuery, AssetCountersQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<AssetCountersQuery, AssetCountersQueryVariables>;
// @ts-ignore
export function useAssetCountersSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<AssetCountersQuery, AssetCountersQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<AssetCountersQuery | undefined, AssetCountersQueryVariables>;
export function useAssetCountersSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<AssetCountersQuery, AssetCountersQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          // @ts-ignore
          return ApolloReactHooks.useSuspenseQuery<AssetCountersQuery, AssetCountersQueryVariables>(AssetCountersDocument, options);
        }
export type AssetCountersQueryHookResult = ReturnType<typeof useAssetCountersQuery>;
export type AssetCountersLazyQueryHookResult = ReturnType<typeof useAssetCountersLazyQuery>;
export type AssetCountersSuspenseQueryHookResult = ReturnType<typeof useAssetCountersSuspenseQuery>;
export type AssetCountersQueryResult = ApolloReactCommon.QueryResult<AssetCountersQuery, AssetCountersQueryVariables>;
export function refetchAssetCountersQuery(variables: AssetCountersQueryVariables) {
      return { query: AssetCountersDocument, variables: variables }
    }
export const AssetCountersIdsDocument = gql`
    query assetCountersIds($sorts: CounterSortInputObject, $filters: [CounterFilterInputObject!], $onlyIds: Boolean, $assetId: ID!) {
  data: counters(
    sorts: $sorts
    filters: $filters
    onlyIds: $onlyIds
    assetId: $assetId
  ) {
    collection {
      id
    }
  }
}
    `;

/**
 * __useAssetCountersIdsQuery__
 *
 * To run a query within a React component, call `useAssetCountersIdsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAssetCountersIdsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAssetCountersIdsQuery({
 *   variables: {
 *      sorts: // value for 'sorts'
 *      filters: // value for 'filters'
 *      onlyIds: // value for 'onlyIds'
 *      assetId: // value for 'assetId'
 *   },
 * });
 */
export function useAssetCountersIdsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<AssetCountersIdsQuery, AssetCountersIdsQueryVariables> & ({ variables: AssetCountersIdsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<AssetCountersIdsQuery, AssetCountersIdsQueryVariables>(AssetCountersIdsDocument, options);
      }
export function useAssetCountersIdsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<AssetCountersIdsQuery, AssetCountersIdsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<AssetCountersIdsQuery, AssetCountersIdsQueryVariables>(AssetCountersIdsDocument, options);
        }
// @ts-ignore
export function useAssetCountersIdsSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<AssetCountersIdsQuery, AssetCountersIdsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<AssetCountersIdsQuery, AssetCountersIdsQueryVariables>;
// @ts-ignore
export function useAssetCountersIdsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<AssetCountersIdsQuery, AssetCountersIdsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<AssetCountersIdsQuery | undefined, AssetCountersIdsQueryVariables>;
export function useAssetCountersIdsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<AssetCountersIdsQuery, AssetCountersIdsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          // @ts-ignore
          return ApolloReactHooks.useSuspenseQuery<AssetCountersIdsQuery, AssetCountersIdsQueryVariables>(AssetCountersIdsDocument, options);
        }
export type AssetCountersIdsQueryHookResult = ReturnType<typeof useAssetCountersIdsQuery>;
export type AssetCountersIdsLazyQueryHookResult = ReturnType<typeof useAssetCountersIdsLazyQuery>;
export type AssetCountersIdsSuspenseQueryHookResult = ReturnType<typeof useAssetCountersIdsSuspenseQuery>;
export type AssetCountersIdsQueryResult = ApolloReactCommon.QueryResult<AssetCountersIdsQuery, AssetCountersIdsQueryVariables>;
export function refetchAssetCountersIdsQuery(variables: AssetCountersIdsQueryVariables) {
      return { query: AssetCountersIdsDocument, variables: variables }
    }
export const AssetCounterDocument = gql`
    query assetCounter($findBy: CounterFindByInputObject!, $assetFindBy: AssetFindByInputObject!) {
  data: counter(findBy: $findBy, assetFindBy: $assetFindBy) {
    id
    name
    code
    fullCode
    measureType
    measureUnit
    prohibitLowerIndexThanPrevious
    latestIndex
    lastCheckAt
  }
}
    `;

/**
 * __useAssetCounterQuery__
 *
 * To run a query within a React component, call `useAssetCounterQuery` and pass it any options that fit your needs.
 * When your component renders, `useAssetCounterQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAssetCounterQuery({
 *   variables: {
 *      findBy: // value for 'findBy'
 *      assetFindBy: // value for 'assetFindBy'
 *   },
 * });
 */
export function useAssetCounterQuery(baseOptions: ApolloReactHooks.QueryHookOptions<AssetCounterQuery, AssetCounterQueryVariables> & ({ variables: AssetCounterQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<AssetCounterQuery, AssetCounterQueryVariables>(AssetCounterDocument, options);
      }
export function useAssetCounterLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<AssetCounterQuery, AssetCounterQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<AssetCounterQuery, AssetCounterQueryVariables>(AssetCounterDocument, options);
        }
// @ts-ignore
export function useAssetCounterSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<AssetCounterQuery, AssetCounterQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<AssetCounterQuery, AssetCounterQueryVariables>;
// @ts-ignore
export function useAssetCounterSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<AssetCounterQuery, AssetCounterQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<AssetCounterQuery | undefined, AssetCounterQueryVariables>;
export function useAssetCounterSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<AssetCounterQuery, AssetCounterQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          // @ts-ignore
          return ApolloReactHooks.useSuspenseQuery<AssetCounterQuery, AssetCounterQueryVariables>(AssetCounterDocument, options);
        }
export type AssetCounterQueryHookResult = ReturnType<typeof useAssetCounterQuery>;
export type AssetCounterLazyQueryHookResult = ReturnType<typeof useAssetCounterLazyQuery>;
export type AssetCounterSuspenseQueryHookResult = ReturnType<typeof useAssetCounterSuspenseQuery>;
export type AssetCounterQueryResult = ApolloReactCommon.QueryResult<AssetCounterQuery, AssetCounterQueryVariables>;
export function refetchAssetCounterQuery(variables: AssetCounterQueryVariables) {
      return { query: AssetCounterDocument, variables: variables }
    }
export const AssetCounterMeasureDocument = gql`
    query assetCounterMeasure($id: ID!, $assetId: ID!, $counterId: ID!) {
  data: counterMeasure(id: $id, assetId: $assetId, counterId: $counterId) {
    id
    index
  }
}
    `;

/**
 * __useAssetCounterMeasureQuery__
 *
 * To run a query within a React component, call `useAssetCounterMeasureQuery` and pass it any options that fit your needs.
 * When your component renders, `useAssetCounterMeasureQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAssetCounterMeasureQuery({
 *   variables: {
 *      id: // value for 'id'
 *      assetId: // value for 'assetId'
 *      counterId: // value for 'counterId'
 *   },
 * });
 */
export function useAssetCounterMeasureQuery(baseOptions: ApolloReactHooks.QueryHookOptions<AssetCounterMeasureQuery, AssetCounterMeasureQueryVariables> & ({ variables: AssetCounterMeasureQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<AssetCounterMeasureQuery, AssetCounterMeasureQueryVariables>(AssetCounterMeasureDocument, options);
      }
export function useAssetCounterMeasureLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<AssetCounterMeasureQuery, AssetCounterMeasureQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<AssetCounterMeasureQuery, AssetCounterMeasureQueryVariables>(AssetCounterMeasureDocument, options);
        }
// @ts-ignore
export function useAssetCounterMeasureSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<AssetCounterMeasureQuery, AssetCounterMeasureQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<AssetCounterMeasureQuery, AssetCounterMeasureQueryVariables>;
// @ts-ignore
export function useAssetCounterMeasureSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<AssetCounterMeasureQuery, AssetCounterMeasureQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<AssetCounterMeasureQuery | undefined, AssetCounterMeasureQueryVariables>;
export function useAssetCounterMeasureSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<AssetCounterMeasureQuery, AssetCounterMeasureQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          // @ts-ignore
          return ApolloReactHooks.useSuspenseQuery<AssetCounterMeasureQuery, AssetCounterMeasureQueryVariables>(AssetCounterMeasureDocument, options);
        }
export type AssetCounterMeasureQueryHookResult = ReturnType<typeof useAssetCounterMeasureQuery>;
export type AssetCounterMeasureLazyQueryHookResult = ReturnType<typeof useAssetCounterMeasureLazyQuery>;
export type AssetCounterMeasureSuspenseQueryHookResult = ReturnType<typeof useAssetCounterMeasureSuspenseQuery>;
export type AssetCounterMeasureQueryResult = ApolloReactCommon.QueryResult<AssetCounterMeasureQuery, AssetCounterMeasureQueryVariables>;
export function refetchAssetCounterMeasureQuery(variables: AssetCounterMeasureQueryVariables) {
      return { query: AssetCounterMeasureDocument, variables: variables }
    }
export const AssetCounterMeasuresDocument = gql`
    query assetCounterMeasures($page: Int, $limit: Int, $sorts: CounterMeasureSortInputObject, $filters: [CounterMeasureFilterInputObject!], $assetId: ID!, $counterId: ID!) {
  data: counterMeasures(
    page: $page
    limit: $limit
    sorts: $sorts
    filters: $filters
    assetId: $assetId
    counterId: $counterId
  ) {
    collection {
      id
      createdAt
      cumulativeUsage
      index
      gap
      resetToZero
    }
    metadata {
      ...metadataFragment
    }
  }
}
    ${MetadataFragmentFragmentDoc}`;

/**
 * __useAssetCounterMeasuresQuery__
 *
 * To run a query within a React component, call `useAssetCounterMeasuresQuery` and pass it any options that fit your needs.
 * When your component renders, `useAssetCounterMeasuresQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAssetCounterMeasuresQuery({
 *   variables: {
 *      page: // value for 'page'
 *      limit: // value for 'limit'
 *      sorts: // value for 'sorts'
 *      filters: // value for 'filters'
 *      assetId: // value for 'assetId'
 *      counterId: // value for 'counterId'
 *   },
 * });
 */
export function useAssetCounterMeasuresQuery(baseOptions: ApolloReactHooks.QueryHookOptions<AssetCounterMeasuresQuery, AssetCounterMeasuresQueryVariables> & ({ variables: AssetCounterMeasuresQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<AssetCounterMeasuresQuery, AssetCounterMeasuresQueryVariables>(AssetCounterMeasuresDocument, options);
      }
export function useAssetCounterMeasuresLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<AssetCounterMeasuresQuery, AssetCounterMeasuresQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<AssetCounterMeasuresQuery, AssetCounterMeasuresQueryVariables>(AssetCounterMeasuresDocument, options);
        }
// @ts-ignore
export function useAssetCounterMeasuresSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<AssetCounterMeasuresQuery, AssetCounterMeasuresQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<AssetCounterMeasuresQuery, AssetCounterMeasuresQueryVariables>;
// @ts-ignore
export function useAssetCounterMeasuresSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<AssetCounterMeasuresQuery, AssetCounterMeasuresQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<AssetCounterMeasuresQuery | undefined, AssetCounterMeasuresQueryVariables>;
export function useAssetCounterMeasuresSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<AssetCounterMeasuresQuery, AssetCounterMeasuresQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          // @ts-ignore
          return ApolloReactHooks.useSuspenseQuery<AssetCounterMeasuresQuery, AssetCounterMeasuresQueryVariables>(AssetCounterMeasuresDocument, options);
        }
export type AssetCounterMeasuresQueryHookResult = ReturnType<typeof useAssetCounterMeasuresQuery>;
export type AssetCounterMeasuresLazyQueryHookResult = ReturnType<typeof useAssetCounterMeasuresLazyQuery>;
export type AssetCounterMeasuresSuspenseQueryHookResult = ReturnType<typeof useAssetCounterMeasuresSuspenseQuery>;
export type AssetCounterMeasuresQueryResult = ApolloReactCommon.QueryResult<AssetCounterMeasuresQuery, AssetCounterMeasuresQueryVariables>;
export function refetchAssetCounterMeasuresQuery(variables: AssetCounterMeasuresQueryVariables) {
      return { query: AssetCounterMeasuresDocument, variables: variables }
    }
export const AssetCounterMeasuresGraphDataDocument = gql`
    query assetCounterMeasuresGraphData($assetId: ID!, $counterId: ID!, $dateRange: DateRangeInputObject!) {
  data: counterMeasuresGraphData(
    assetId: $assetId
    counterId: $counterId
    dateRange: $dateRange
  ) {
    createdAt
    cumulativeUsage
    gap
  }
}
    `;

/**
 * __useAssetCounterMeasuresGraphDataQuery__
 *
 * To run a query within a React component, call `useAssetCounterMeasuresGraphDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useAssetCounterMeasuresGraphDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAssetCounterMeasuresGraphDataQuery({
 *   variables: {
 *      assetId: // value for 'assetId'
 *      counterId: // value for 'counterId'
 *      dateRange: // value for 'dateRange'
 *   },
 * });
 */
export function useAssetCounterMeasuresGraphDataQuery(baseOptions: ApolloReactHooks.QueryHookOptions<AssetCounterMeasuresGraphDataQuery, AssetCounterMeasuresGraphDataQueryVariables> & ({ variables: AssetCounterMeasuresGraphDataQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<AssetCounterMeasuresGraphDataQuery, AssetCounterMeasuresGraphDataQueryVariables>(AssetCounterMeasuresGraphDataDocument, options);
      }
export function useAssetCounterMeasuresGraphDataLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<AssetCounterMeasuresGraphDataQuery, AssetCounterMeasuresGraphDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<AssetCounterMeasuresGraphDataQuery, AssetCounterMeasuresGraphDataQueryVariables>(AssetCounterMeasuresGraphDataDocument, options);
        }
// @ts-ignore
export function useAssetCounterMeasuresGraphDataSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<AssetCounterMeasuresGraphDataQuery, AssetCounterMeasuresGraphDataQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<AssetCounterMeasuresGraphDataQuery, AssetCounterMeasuresGraphDataQueryVariables>;
// @ts-ignore
export function useAssetCounterMeasuresGraphDataSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<AssetCounterMeasuresGraphDataQuery, AssetCounterMeasuresGraphDataQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<AssetCounterMeasuresGraphDataQuery | undefined, AssetCounterMeasuresGraphDataQueryVariables>;
export function useAssetCounterMeasuresGraphDataSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<AssetCounterMeasuresGraphDataQuery, AssetCounterMeasuresGraphDataQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          // @ts-ignore
          return ApolloReactHooks.useSuspenseQuery<AssetCounterMeasuresGraphDataQuery, AssetCounterMeasuresGraphDataQueryVariables>(AssetCounterMeasuresGraphDataDocument, options);
        }
export type AssetCounterMeasuresGraphDataQueryHookResult = ReturnType<typeof useAssetCounterMeasuresGraphDataQuery>;
export type AssetCounterMeasuresGraphDataLazyQueryHookResult = ReturnType<typeof useAssetCounterMeasuresGraphDataLazyQuery>;
export type AssetCounterMeasuresGraphDataSuspenseQueryHookResult = ReturnType<typeof useAssetCounterMeasuresGraphDataSuspenseQuery>;
export type AssetCounterMeasuresGraphDataQueryResult = ApolloReactCommon.QueryResult<AssetCounterMeasuresGraphDataQuery, AssetCounterMeasuresGraphDataQueryVariables>;
export function refetchAssetCounterMeasuresGraphDataQuery(variables: AssetCounterMeasuresGraphDataQueryVariables) {
      return { query: AssetCounterMeasuresGraphDataDocument, variables: variables }
    }
export const AssetCounterCreateDocument = gql`
    mutation assetCounterCreate($attributes: CounterCreateInputObject!) {
  data: counterCreate(input: {attributes: $attributes}) {
    id
  }
}
    `;

/**
 * __useAssetCounterCreateMutation__
 *
 * To run a mutation, you first call `useAssetCounterCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAssetCounterCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [assetCounterCreateMutation, { data, loading, error }] = useAssetCounterCreateMutation({
 *   variables: {
 *      attributes: // value for 'attributes'
 *   },
 * });
 */
export function useAssetCounterCreateMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<AssetCounterCreateMutation, AssetCounterCreateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<AssetCounterCreateMutation, AssetCounterCreateMutationVariables>(AssetCounterCreateDocument, options);
      }
export type AssetCounterCreateMutationHookResult = ReturnType<typeof useAssetCounterCreateMutation>;
export type AssetCounterCreateMutationResult = ApolloReactCommon.MutationResult<AssetCounterCreateMutation>;
export const AssetCounterUpdateDocument = gql`
    mutation assetCounterUpdate($attributes: CounterUpdateInputObject!, $id: ID!, $assetId: ID!) {
  data: counterUpdate(
    input: {id: $id, assetId: $assetId, attributes: $attributes}
  ) {
    id
    name
    code
    fullCode
    measureType
    measureUnit
    prohibitLowerIndexThanPrevious
  }
}
    `;

/**
 * __useAssetCounterUpdateMutation__
 *
 * To run a mutation, you first call `useAssetCounterUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAssetCounterUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [assetCounterUpdateMutation, { data, loading, error }] = useAssetCounterUpdateMutation({
 *   variables: {
 *      attributes: // value for 'attributes'
 *      id: // value for 'id'
 *      assetId: // value for 'assetId'
 *   },
 * });
 */
export function useAssetCounterUpdateMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<AssetCounterUpdateMutation, AssetCounterUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<AssetCounterUpdateMutation, AssetCounterUpdateMutationVariables>(AssetCounterUpdateDocument, options);
      }
export type AssetCounterUpdateMutationHookResult = ReturnType<typeof useAssetCounterUpdateMutation>;
export type AssetCounterUpdateMutationResult = ApolloReactCommon.MutationResult<AssetCounterUpdateMutation>;
export const AssetCounterDestroyDocument = gql`
    mutation assetCounterDestroy($ids: [ID!]!, $assetId: ID!) {
  counterBulkDestroy(input: {ids: $ids, assetId: $assetId})
}
    `;

/**
 * __useAssetCounterDestroyMutation__
 *
 * To run a mutation, you first call `useAssetCounterDestroyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAssetCounterDestroyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [assetCounterDestroyMutation, { data, loading, error }] = useAssetCounterDestroyMutation({
 *   variables: {
 *      ids: // value for 'ids'
 *      assetId: // value for 'assetId'
 *   },
 * });
 */
export function useAssetCounterDestroyMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<AssetCounterDestroyMutation, AssetCounterDestroyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<AssetCounterDestroyMutation, AssetCounterDestroyMutationVariables>(AssetCounterDestroyDocument, options);
      }
export type AssetCounterDestroyMutationHookResult = ReturnType<typeof useAssetCounterDestroyMutation>;
export type AssetCounterDestroyMutationResult = ApolloReactCommon.MutationResult<AssetCounterDestroyMutation>;
export const AssetCounterMeasureCreateDocument = gql`
    mutation assetCounterMeasureCreate($attributes: CounterMeasureCreateInputObject!, $assetId: ID!) {
  data: counterMeasureCreate(input: {assetId: $assetId, attributes: $attributes}) {
    id
  }
}
    `;

/**
 * __useAssetCounterMeasureCreateMutation__
 *
 * To run a mutation, you first call `useAssetCounterMeasureCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAssetCounterMeasureCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [assetCounterMeasureCreateMutation, { data, loading, error }] = useAssetCounterMeasureCreateMutation({
 *   variables: {
 *      attributes: // value for 'attributes'
 *      assetId: // value for 'assetId'
 *   },
 * });
 */
export function useAssetCounterMeasureCreateMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<AssetCounterMeasureCreateMutation, AssetCounterMeasureCreateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<AssetCounterMeasureCreateMutation, AssetCounterMeasureCreateMutationVariables>(AssetCounterMeasureCreateDocument, options);
      }
export type AssetCounterMeasureCreateMutationHookResult = ReturnType<typeof useAssetCounterMeasureCreateMutation>;
export type AssetCounterMeasureCreateMutationResult = ApolloReactCommon.MutationResult<AssetCounterMeasureCreateMutation>;
export const AssetCounterResetToZeroDocument = gql`
    mutation assetCounterResetToZero($id: ID!, $assetId: ID!) {
  data: counterResetToZero(input: {id: $id, assetId: $assetId}) {
    id
  }
}
    `;

/**
 * __useAssetCounterResetToZeroMutation__
 *
 * To run a mutation, you first call `useAssetCounterResetToZeroMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAssetCounterResetToZeroMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [assetCounterResetToZeroMutation, { data, loading, error }] = useAssetCounterResetToZeroMutation({
 *   variables: {
 *      id: // value for 'id'
 *      assetId: // value for 'assetId'
 *   },
 * });
 */
export function useAssetCounterResetToZeroMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<AssetCounterResetToZeroMutation, AssetCounterResetToZeroMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<AssetCounterResetToZeroMutation, AssetCounterResetToZeroMutationVariables>(AssetCounterResetToZeroDocument, options);
      }
export type AssetCounterResetToZeroMutationHookResult = ReturnType<typeof useAssetCounterResetToZeroMutation>;
export type AssetCounterResetToZeroMutationResult = ApolloReactCommon.MutationResult<AssetCounterResetToZeroMutation>;
export const AssetCounterBulkQrCodeCreateDocument = gql`
    mutation assetCounterBulkQrCodeCreate($params: QrCodesCreateInputObject!, $assetId: ID!) {
  data: counterBulkQrCodeCreate(input: {assetId: $assetId, params: $params}) {
    ...backgroundJobTreeFragment
  }
}
    ${BackgroundJobTreeFragmentFragmentDoc}
${BackgroundJobFragmentFragmentDoc}
${AuthorizationResultFragmentFragmentDoc}`;

/**
 * __useAssetCounterBulkQrCodeCreateMutation__
 *
 * To run a mutation, you first call `useAssetCounterBulkQrCodeCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAssetCounterBulkQrCodeCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [assetCounterBulkQrCodeCreateMutation, { data, loading, error }] = useAssetCounterBulkQrCodeCreateMutation({
 *   variables: {
 *      params: // value for 'params'
 *      assetId: // value for 'assetId'
 *   },
 * });
 */
export function useAssetCounterBulkQrCodeCreateMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<AssetCounterBulkQrCodeCreateMutation, AssetCounterBulkQrCodeCreateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<AssetCounterBulkQrCodeCreateMutation, AssetCounterBulkQrCodeCreateMutationVariables>(AssetCounterBulkQrCodeCreateDocument, options);
      }
export type AssetCounterBulkQrCodeCreateMutationHookResult = ReturnType<typeof useAssetCounterBulkQrCodeCreateMutation>;
export type AssetCounterBulkQrCodeCreateMutationResult = ApolloReactCommon.MutationResult<AssetCounterBulkQrCodeCreateMutation>;
export const AssetNomenclaturesDocument = gql`
    query assetNomenclatures($page: Int, $limit: Int, $sorts: NomenclatureSortInputObject, $filters: [NomenclatureFilterInputObject!], $mainAssetId: ID!) {
  data: nomenclatures(
    page: $page
    limit: $limit
    sorts: $sorts
    filters: $filters
    mainAssetId: $mainAssetId
  ) {
    collection {
      id
      quantity
      componentAsset {
        id
        name
        code
        fullCode
        usesAsNomenclatureCount
        iconAttached {
          ...attachmentFragment
        }
      }
    }
    metadata {
      ...metadataFragment
    }
  }
}
    ${AttachmentFragmentFragmentDoc}
${MetadataFragmentFragmentDoc}`;

/**
 * __useAssetNomenclaturesQuery__
 *
 * To run a query within a React component, call `useAssetNomenclaturesQuery` and pass it any options that fit your needs.
 * When your component renders, `useAssetNomenclaturesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAssetNomenclaturesQuery({
 *   variables: {
 *      page: // value for 'page'
 *      limit: // value for 'limit'
 *      sorts: // value for 'sorts'
 *      filters: // value for 'filters'
 *      mainAssetId: // value for 'mainAssetId'
 *   },
 * });
 */
export function useAssetNomenclaturesQuery(baseOptions: ApolloReactHooks.QueryHookOptions<AssetNomenclaturesQuery, AssetNomenclaturesQueryVariables> & ({ variables: AssetNomenclaturesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<AssetNomenclaturesQuery, AssetNomenclaturesQueryVariables>(AssetNomenclaturesDocument, options);
      }
export function useAssetNomenclaturesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<AssetNomenclaturesQuery, AssetNomenclaturesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<AssetNomenclaturesQuery, AssetNomenclaturesQueryVariables>(AssetNomenclaturesDocument, options);
        }
// @ts-ignore
export function useAssetNomenclaturesSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<AssetNomenclaturesQuery, AssetNomenclaturesQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<AssetNomenclaturesQuery, AssetNomenclaturesQueryVariables>;
// @ts-ignore
export function useAssetNomenclaturesSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<AssetNomenclaturesQuery, AssetNomenclaturesQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<AssetNomenclaturesQuery | undefined, AssetNomenclaturesQueryVariables>;
export function useAssetNomenclaturesSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<AssetNomenclaturesQuery, AssetNomenclaturesQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          // @ts-ignore
          return ApolloReactHooks.useSuspenseQuery<AssetNomenclaturesQuery, AssetNomenclaturesQueryVariables>(AssetNomenclaturesDocument, options);
        }
export type AssetNomenclaturesQueryHookResult = ReturnType<typeof useAssetNomenclaturesQuery>;
export type AssetNomenclaturesLazyQueryHookResult = ReturnType<typeof useAssetNomenclaturesLazyQuery>;
export type AssetNomenclaturesSuspenseQueryHookResult = ReturnType<typeof useAssetNomenclaturesSuspenseQuery>;
export type AssetNomenclaturesQueryResult = ApolloReactCommon.QueryResult<AssetNomenclaturesQuery, AssetNomenclaturesQueryVariables>;
export function refetchAssetNomenclaturesQuery(variables: AssetNomenclaturesQueryVariables) {
      return { query: AssetNomenclaturesDocument, variables: variables }
    }
export const AssetNomenclaturesIdsDocument = gql`
    query assetNomenclaturesIds($sorts: NomenclatureSortInputObject, $filters: [NomenclatureFilterInputObject!], $onlyIds: Boolean, $mainAssetId: ID!) {
  data: nomenclatures(
    sorts: $sorts
    filters: $filters
    onlyIds: $onlyIds
    mainAssetId: $mainAssetId
  ) {
    collection {
      id
    }
  }
}
    `;

/**
 * __useAssetNomenclaturesIdsQuery__
 *
 * To run a query within a React component, call `useAssetNomenclaturesIdsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAssetNomenclaturesIdsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAssetNomenclaturesIdsQuery({
 *   variables: {
 *      sorts: // value for 'sorts'
 *      filters: // value for 'filters'
 *      onlyIds: // value for 'onlyIds'
 *      mainAssetId: // value for 'mainAssetId'
 *   },
 * });
 */
export function useAssetNomenclaturesIdsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<AssetNomenclaturesIdsQuery, AssetNomenclaturesIdsQueryVariables> & ({ variables: AssetNomenclaturesIdsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<AssetNomenclaturesIdsQuery, AssetNomenclaturesIdsQueryVariables>(AssetNomenclaturesIdsDocument, options);
      }
export function useAssetNomenclaturesIdsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<AssetNomenclaturesIdsQuery, AssetNomenclaturesIdsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<AssetNomenclaturesIdsQuery, AssetNomenclaturesIdsQueryVariables>(AssetNomenclaturesIdsDocument, options);
        }
// @ts-ignore
export function useAssetNomenclaturesIdsSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<AssetNomenclaturesIdsQuery, AssetNomenclaturesIdsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<AssetNomenclaturesIdsQuery, AssetNomenclaturesIdsQueryVariables>;
// @ts-ignore
export function useAssetNomenclaturesIdsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<AssetNomenclaturesIdsQuery, AssetNomenclaturesIdsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<AssetNomenclaturesIdsQuery | undefined, AssetNomenclaturesIdsQueryVariables>;
export function useAssetNomenclaturesIdsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<AssetNomenclaturesIdsQuery, AssetNomenclaturesIdsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          // @ts-ignore
          return ApolloReactHooks.useSuspenseQuery<AssetNomenclaturesIdsQuery, AssetNomenclaturesIdsQueryVariables>(AssetNomenclaturesIdsDocument, options);
        }
export type AssetNomenclaturesIdsQueryHookResult = ReturnType<typeof useAssetNomenclaturesIdsQuery>;
export type AssetNomenclaturesIdsLazyQueryHookResult = ReturnType<typeof useAssetNomenclaturesIdsLazyQuery>;
export type AssetNomenclaturesIdsSuspenseQueryHookResult = ReturnType<typeof useAssetNomenclaturesIdsSuspenseQuery>;
export type AssetNomenclaturesIdsQueryResult = ApolloReactCommon.QueryResult<AssetNomenclaturesIdsQuery, AssetNomenclaturesIdsQueryVariables>;
export function refetchAssetNomenclaturesIdsQuery(variables: AssetNomenclaturesIdsQueryVariables) {
      return { query: AssetNomenclaturesIdsDocument, variables: variables }
    }
export const AssetNomenclatureDocument = gql`
    query assetNomenclature($id: ID!, $mainAssetId: ID!) {
  data: nomenclature(id: $id, mainAssetId: $mainAssetId) {
    id
    quantity
    componentAsset {
      id
      name
      fullCode
      iconAttached {
        ...attachmentFragment
      }
    }
  }
}
    ${AttachmentFragmentFragmentDoc}`;

/**
 * __useAssetNomenclatureQuery__
 *
 * To run a query within a React component, call `useAssetNomenclatureQuery` and pass it any options that fit your needs.
 * When your component renders, `useAssetNomenclatureQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAssetNomenclatureQuery({
 *   variables: {
 *      id: // value for 'id'
 *      mainAssetId: // value for 'mainAssetId'
 *   },
 * });
 */
export function useAssetNomenclatureQuery(baseOptions: ApolloReactHooks.QueryHookOptions<AssetNomenclatureQuery, AssetNomenclatureQueryVariables> & ({ variables: AssetNomenclatureQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<AssetNomenclatureQuery, AssetNomenclatureQueryVariables>(AssetNomenclatureDocument, options);
      }
export function useAssetNomenclatureLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<AssetNomenclatureQuery, AssetNomenclatureQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<AssetNomenclatureQuery, AssetNomenclatureQueryVariables>(AssetNomenclatureDocument, options);
        }
// @ts-ignore
export function useAssetNomenclatureSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<AssetNomenclatureQuery, AssetNomenclatureQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<AssetNomenclatureQuery, AssetNomenclatureQueryVariables>;
// @ts-ignore
export function useAssetNomenclatureSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<AssetNomenclatureQuery, AssetNomenclatureQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<AssetNomenclatureQuery | undefined, AssetNomenclatureQueryVariables>;
export function useAssetNomenclatureSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<AssetNomenclatureQuery, AssetNomenclatureQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          // @ts-ignore
          return ApolloReactHooks.useSuspenseQuery<AssetNomenclatureQuery, AssetNomenclatureQueryVariables>(AssetNomenclatureDocument, options);
        }
export type AssetNomenclatureQueryHookResult = ReturnType<typeof useAssetNomenclatureQuery>;
export type AssetNomenclatureLazyQueryHookResult = ReturnType<typeof useAssetNomenclatureLazyQuery>;
export type AssetNomenclatureSuspenseQueryHookResult = ReturnType<typeof useAssetNomenclatureSuspenseQuery>;
export type AssetNomenclatureQueryResult = ApolloReactCommon.QueryResult<AssetNomenclatureQuery, AssetNomenclatureQueryVariables>;
export function refetchAssetNomenclatureQuery(variables: AssetNomenclatureQueryVariables) {
      return { query: AssetNomenclatureDocument, variables: variables }
    }
export const AssetNomenclatureCreateDocument = gql`
    mutation assetNomenclatureCreate($attributes: NomenclatureCreateInputObject!) {
  data: nomenclatureCreate(input: {attributes: $attributes}) {
    componentAsset {
      id
      name
    }
    quantity
  }
}
    `;

/**
 * __useAssetNomenclatureCreateMutation__
 *
 * To run a mutation, you first call `useAssetNomenclatureCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAssetNomenclatureCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [assetNomenclatureCreateMutation, { data, loading, error }] = useAssetNomenclatureCreateMutation({
 *   variables: {
 *      attributes: // value for 'attributes'
 *   },
 * });
 */
export function useAssetNomenclatureCreateMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<AssetNomenclatureCreateMutation, AssetNomenclatureCreateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<AssetNomenclatureCreateMutation, AssetNomenclatureCreateMutationVariables>(AssetNomenclatureCreateDocument, options);
      }
export type AssetNomenclatureCreateMutationHookResult = ReturnType<typeof useAssetNomenclatureCreateMutation>;
export type AssetNomenclatureCreateMutationResult = ApolloReactCommon.MutationResult<AssetNomenclatureCreateMutation>;
export const AssetNomenclatureUpdateDocument = gql`
    mutation assetNomenclatureUpdate($attributes: NomenclatureUpdateInputObject!, $id: ID!, $mainAssetId: ID!) {
  data: nomenclatureUpdate(
    input: {id: $id, mainAssetId: $mainAssetId, attributes: $attributes}
  ) {
    componentAsset {
      id
      name
    }
    quantity
  }
}
    `;

/**
 * __useAssetNomenclatureUpdateMutation__
 *
 * To run a mutation, you first call `useAssetNomenclatureUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAssetNomenclatureUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [assetNomenclatureUpdateMutation, { data, loading, error }] = useAssetNomenclatureUpdateMutation({
 *   variables: {
 *      attributes: // value for 'attributes'
 *      id: // value for 'id'
 *      mainAssetId: // value for 'mainAssetId'
 *   },
 * });
 */
export function useAssetNomenclatureUpdateMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<AssetNomenclatureUpdateMutation, AssetNomenclatureUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<AssetNomenclatureUpdateMutation, AssetNomenclatureUpdateMutationVariables>(AssetNomenclatureUpdateDocument, options);
      }
export type AssetNomenclatureUpdateMutationHookResult = ReturnType<typeof useAssetNomenclatureUpdateMutation>;
export type AssetNomenclatureUpdateMutationResult = ApolloReactCommon.MutationResult<AssetNomenclatureUpdateMutation>;
export const AssetNomenclatureDestroyDocument = gql`
    mutation assetNomenclatureDestroy($ids: [ID!]!, $mainAssetId: ID!) {
  nomenclatureBulkDestroy(input: {ids: $ids, mainAssetId: $mainAssetId})
}
    `;

/**
 * __useAssetNomenclatureDestroyMutation__
 *
 * To run a mutation, you first call `useAssetNomenclatureDestroyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAssetNomenclatureDestroyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [assetNomenclatureDestroyMutation, { data, loading, error }] = useAssetNomenclatureDestroyMutation({
 *   variables: {
 *      ids: // value for 'ids'
 *      mainAssetId: // value for 'mainAssetId'
 *   },
 * });
 */
export function useAssetNomenclatureDestroyMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<AssetNomenclatureDestroyMutation, AssetNomenclatureDestroyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<AssetNomenclatureDestroyMutation, AssetNomenclatureDestroyMutationVariables>(AssetNomenclatureDestroyDocument, options);
      }
export type AssetNomenclatureDestroyMutationHookResult = ReturnType<typeof useAssetNomenclatureDestroyMutation>;
export type AssetNomenclatureDestroyMutationResult = ApolloReactCommon.MutationResult<AssetNomenclatureDestroyMutation>;
export const AuthenticationConfirmationsEmailConfirmationDocument = gql`
    mutation authenticationConfirmationsEmailConfirmation($input: AuthenticationConfirmationsEmailConfirmationInput!) {
  data: authenticationConfirmationsEmailConfirmation(input: $input) {
    resource {
      ... on SystemAdmin {
        id
      }
    }
  }
}
    `;

/**
 * __useAuthenticationConfirmationsEmailConfirmationMutation__
 *
 * To run a mutation, you first call `useAuthenticationConfirmationsEmailConfirmationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAuthenticationConfirmationsEmailConfirmationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [authenticationConfirmationsEmailConfirmationMutation, { data, loading, error }] = useAuthenticationConfirmationsEmailConfirmationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAuthenticationConfirmationsEmailConfirmationMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<AuthenticationConfirmationsEmailConfirmationMutation, AuthenticationConfirmationsEmailConfirmationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<AuthenticationConfirmationsEmailConfirmationMutation, AuthenticationConfirmationsEmailConfirmationMutationVariables>(AuthenticationConfirmationsEmailConfirmationDocument, options);
      }
export type AuthenticationConfirmationsEmailConfirmationMutationHookResult = ReturnType<typeof useAuthenticationConfirmationsEmailConfirmationMutation>;
export type AuthenticationConfirmationsEmailConfirmationMutationResult = ApolloReactCommon.MutationResult<AuthenticationConfirmationsEmailConfirmationMutation>;
export const AuthenticationConfirmationsRegistrationConfirmationDocument = gql`
    mutation authenticationConfirmationsRegistrationConfirmation($input: AuthenticationConfirmationsRegistrationConfirmationInput!) {
  data: authenticationConfirmationsRegistrationConfirmation(input: $input) {
    resource {
      ... on SystemAdmin {
        id
      }
    }
  }
}
    `;

/**
 * __useAuthenticationConfirmationsRegistrationConfirmationMutation__
 *
 * To run a mutation, you first call `useAuthenticationConfirmationsRegistrationConfirmationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAuthenticationConfirmationsRegistrationConfirmationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [authenticationConfirmationsRegistrationConfirmationMutation, { data, loading, error }] = useAuthenticationConfirmationsRegistrationConfirmationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAuthenticationConfirmationsRegistrationConfirmationMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<AuthenticationConfirmationsRegistrationConfirmationMutation, AuthenticationConfirmationsRegistrationConfirmationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<AuthenticationConfirmationsRegistrationConfirmationMutation, AuthenticationConfirmationsRegistrationConfirmationMutationVariables>(AuthenticationConfirmationsRegistrationConfirmationDocument, options);
      }
export type AuthenticationConfirmationsRegistrationConfirmationMutationHookResult = ReturnType<typeof useAuthenticationConfirmationsRegistrationConfirmationMutation>;
export type AuthenticationConfirmationsRegistrationConfirmationMutationResult = ApolloReactCommon.MutationResult<AuthenticationConfirmationsRegistrationConfirmationMutation>;
export const AuthenticationConfirmationsResendEmailConfirmationDocument = gql`
    mutation authenticationConfirmationsResendEmailConfirmation($input: AuthenticationConfirmationsResendEmailConfirmationInput!) {
  data: authenticationConfirmationsResendEmailConfirmation(input: $input) {
    message
  }
}
    `;

/**
 * __useAuthenticationConfirmationsResendEmailConfirmationMutation__
 *
 * To run a mutation, you first call `useAuthenticationConfirmationsResendEmailConfirmationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAuthenticationConfirmationsResendEmailConfirmationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [authenticationConfirmationsResendEmailConfirmationMutation, { data, loading, error }] = useAuthenticationConfirmationsResendEmailConfirmationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAuthenticationConfirmationsResendEmailConfirmationMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<AuthenticationConfirmationsResendEmailConfirmationMutation, AuthenticationConfirmationsResendEmailConfirmationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<AuthenticationConfirmationsResendEmailConfirmationMutation, AuthenticationConfirmationsResendEmailConfirmationMutationVariables>(AuthenticationConfirmationsResendEmailConfirmationDocument, options);
      }
export type AuthenticationConfirmationsResendEmailConfirmationMutationHookResult = ReturnType<typeof useAuthenticationConfirmationsResendEmailConfirmationMutation>;
export type AuthenticationConfirmationsResendEmailConfirmationMutationResult = ApolloReactCommon.MutationResult<AuthenticationConfirmationsResendEmailConfirmationMutation>;
export const AuthenticationConfirmationsResendRegistrationConfirmationDocument = gql`
    mutation authenticationConfirmationsResendRegistrationConfirmation($input: AuthenticationConfirmationsResendRegistrationConfirmationInput!) {
  data: authenticationConfirmationsResendRegistrationConfirmation(input: $input) {
    message
  }
}
    `;

/**
 * __useAuthenticationConfirmationsResendRegistrationConfirmationMutation__
 *
 * To run a mutation, you first call `useAuthenticationConfirmationsResendRegistrationConfirmationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAuthenticationConfirmationsResendRegistrationConfirmationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [authenticationConfirmationsResendRegistrationConfirmationMutation, { data, loading, error }] = useAuthenticationConfirmationsResendRegistrationConfirmationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAuthenticationConfirmationsResendRegistrationConfirmationMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<AuthenticationConfirmationsResendRegistrationConfirmationMutation, AuthenticationConfirmationsResendRegistrationConfirmationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<AuthenticationConfirmationsResendRegistrationConfirmationMutation, AuthenticationConfirmationsResendRegistrationConfirmationMutationVariables>(AuthenticationConfirmationsResendRegistrationConfirmationDocument, options);
      }
export type AuthenticationConfirmationsResendRegistrationConfirmationMutationHookResult = ReturnType<typeof useAuthenticationConfirmationsResendRegistrationConfirmationMutation>;
export type AuthenticationConfirmationsResendRegistrationConfirmationMutationResult = ApolloReactCommon.MutationResult<AuthenticationConfirmationsResendRegistrationConfirmationMutation>;
export const AuthenticationPasswordsForgotDocument = gql`
    mutation authenticationPasswordsForgot($input: AuthenticationPasswordsForgotInput!) {
  data: authenticationPasswordsForgot(input: $input) {
    message
  }
}
    `;

/**
 * __useAuthenticationPasswordsForgotMutation__
 *
 * To run a mutation, you first call `useAuthenticationPasswordsForgotMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAuthenticationPasswordsForgotMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [authenticationPasswordsForgotMutation, { data, loading, error }] = useAuthenticationPasswordsForgotMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAuthenticationPasswordsForgotMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<AuthenticationPasswordsForgotMutation, AuthenticationPasswordsForgotMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<AuthenticationPasswordsForgotMutation, AuthenticationPasswordsForgotMutationVariables>(AuthenticationPasswordsForgotDocument, options);
      }
export type AuthenticationPasswordsForgotMutationHookResult = ReturnType<typeof useAuthenticationPasswordsForgotMutation>;
export type AuthenticationPasswordsForgotMutationResult = ApolloReactCommon.MutationResult<AuthenticationPasswordsForgotMutation>;
export const AuthenticationPasswordsUpdateDocument = gql`
    mutation authenticationPasswordsUpdate($input: AuthenticationPasswordsUpdateInput!) {
  data: authenticationPasswordsUpdate(input: $input) {
    resource {
      ... on SystemAdmin {
        id
      }
    }
  }
}
    `;

/**
 * __useAuthenticationPasswordsUpdateMutation__
 *
 * To run a mutation, you first call `useAuthenticationPasswordsUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAuthenticationPasswordsUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [authenticationPasswordsUpdateMutation, { data, loading, error }] = useAuthenticationPasswordsUpdateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAuthenticationPasswordsUpdateMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<AuthenticationPasswordsUpdateMutation, AuthenticationPasswordsUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<AuthenticationPasswordsUpdateMutation, AuthenticationPasswordsUpdateMutationVariables>(AuthenticationPasswordsUpdateDocument, options);
      }
export type AuthenticationPasswordsUpdateMutationHookResult = ReturnType<typeof useAuthenticationPasswordsUpdateMutation>;
export type AuthenticationPasswordsUpdateMutationResult = ApolloReactCommon.MutationResult<AuthenticationPasswordsUpdateMutation>;
export const AuthenticationSessionEndDocument = gql`
    mutation authenticationSessionEnd($input: AuthenticationSessionEndInput!) {
  data: authenticationSessionEnd(input: $input)
}
    `;

/**
 * __useAuthenticationSessionEndMutation__
 *
 * To run a mutation, you first call `useAuthenticationSessionEndMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAuthenticationSessionEndMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [authenticationSessionEndMutation, { data, loading, error }] = useAuthenticationSessionEndMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAuthenticationSessionEndMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<AuthenticationSessionEndMutation, AuthenticationSessionEndMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<AuthenticationSessionEndMutation, AuthenticationSessionEndMutationVariables>(AuthenticationSessionEndDocument, options);
      }
export type AuthenticationSessionEndMutationHookResult = ReturnType<typeof useAuthenticationSessionEndMutation>;
export type AuthenticationSessionEndMutationResult = ApolloReactCommon.MutationResult<AuthenticationSessionEndMutation>;
export const BackgroundJobsDocument = gql`
    query backgroundJobs($page: Int, $limit: Int, $scope: BackgroundJobScopeEnum, $filters: [BackgroundJobFilterInputObject!], $sorts: BackgroundJobSortInputObject) {
  data: backgroundJobs(
    page: $page
    limit: $limit
    scope: $scope
    filters: $filters
    sorts: $sorts
  ) {
    collection {
      ...backgroundJobTreeFragment
    }
    metadata {
      ...metadataFragment
    }
  }
}
    ${BackgroundJobTreeFragmentFragmentDoc}
${BackgroundJobFragmentFragmentDoc}
${AuthorizationResultFragmentFragmentDoc}
${MetadataFragmentFragmentDoc}`;

/**
 * __useBackgroundJobsQuery__
 *
 * To run a query within a React component, call `useBackgroundJobsQuery` and pass it any options that fit your needs.
 * When your component renders, `useBackgroundJobsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBackgroundJobsQuery({
 *   variables: {
 *      page: // value for 'page'
 *      limit: // value for 'limit'
 *      scope: // value for 'scope'
 *      filters: // value for 'filters'
 *      sorts: // value for 'sorts'
 *   },
 * });
 */
export function useBackgroundJobsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<BackgroundJobsQuery, BackgroundJobsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<BackgroundJobsQuery, BackgroundJobsQueryVariables>(BackgroundJobsDocument, options);
      }
export function useBackgroundJobsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<BackgroundJobsQuery, BackgroundJobsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<BackgroundJobsQuery, BackgroundJobsQueryVariables>(BackgroundJobsDocument, options);
        }
// @ts-ignore
export function useBackgroundJobsSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<BackgroundJobsQuery, BackgroundJobsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<BackgroundJobsQuery, BackgroundJobsQueryVariables>;
// @ts-ignore
export function useBackgroundJobsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<BackgroundJobsQuery, BackgroundJobsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<BackgroundJobsQuery | undefined, BackgroundJobsQueryVariables>;
export function useBackgroundJobsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<BackgroundJobsQuery, BackgroundJobsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          // @ts-ignore
          return ApolloReactHooks.useSuspenseQuery<BackgroundJobsQuery, BackgroundJobsQueryVariables>(BackgroundJobsDocument, options);
        }
export type BackgroundJobsQueryHookResult = ReturnType<typeof useBackgroundJobsQuery>;
export type BackgroundJobsLazyQueryHookResult = ReturnType<typeof useBackgroundJobsLazyQuery>;
export type BackgroundJobsSuspenseQueryHookResult = ReturnType<typeof useBackgroundJobsSuspenseQuery>;
export type BackgroundJobsQueryResult = ApolloReactCommon.QueryResult<BackgroundJobsQuery, BackgroundJobsQueryVariables>;
export function refetchBackgroundJobsQuery(variables?: BackgroundJobsQueryVariables) {
      return { query: BackgroundJobsDocument, variables: variables }
    }
export const BackgroundJobDocument = gql`
    query backgroundJob($id: ID!) {
  data: backgroundJob(id: $id) {
    ...backgroundJobTreeFragment
  }
}
    ${BackgroundJobTreeFragmentFragmentDoc}
${BackgroundJobFragmentFragmentDoc}
${AuthorizationResultFragmentFragmentDoc}`;

/**
 * __useBackgroundJobQuery__
 *
 * To run a query within a React component, call `useBackgroundJobQuery` and pass it any options that fit your needs.
 * When your component renders, `useBackgroundJobQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBackgroundJobQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useBackgroundJobQuery(baseOptions: ApolloReactHooks.QueryHookOptions<BackgroundJobQuery, BackgroundJobQueryVariables> & ({ variables: BackgroundJobQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<BackgroundJobQuery, BackgroundJobQueryVariables>(BackgroundJobDocument, options);
      }
export function useBackgroundJobLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<BackgroundJobQuery, BackgroundJobQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<BackgroundJobQuery, BackgroundJobQueryVariables>(BackgroundJobDocument, options);
        }
// @ts-ignore
export function useBackgroundJobSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<BackgroundJobQuery, BackgroundJobQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<BackgroundJobQuery, BackgroundJobQueryVariables>;
// @ts-ignore
export function useBackgroundJobSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<BackgroundJobQuery, BackgroundJobQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<BackgroundJobQuery | undefined, BackgroundJobQueryVariables>;
export function useBackgroundJobSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<BackgroundJobQuery, BackgroundJobQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          // @ts-ignore
          return ApolloReactHooks.useSuspenseQuery<BackgroundJobQuery, BackgroundJobQueryVariables>(BackgroundJobDocument, options);
        }
export type BackgroundJobQueryHookResult = ReturnType<typeof useBackgroundJobQuery>;
export type BackgroundJobLazyQueryHookResult = ReturnType<typeof useBackgroundJobLazyQuery>;
export type BackgroundJobSuspenseQueryHookResult = ReturnType<typeof useBackgroundJobSuspenseQuery>;
export type BackgroundJobQueryResult = ApolloReactCommon.QueryResult<BackgroundJobQuery, BackgroundJobQueryVariables>;
export function refetchBackgroundJobQuery(variables: BackgroundJobQueryVariables) {
      return { query: BackgroundJobDocument, variables: variables }
    }
export const BackgroundJobProgressDocument = gql`
    subscription backgroundJobProgress {
  backgroundJobProgress {
    rootId
    node {
      ...backgroundJobTreeFragment
    }
  }
}
    ${BackgroundJobTreeFragmentFragmentDoc}
${BackgroundJobFragmentFragmentDoc}
${AuthorizationResultFragmentFragmentDoc}`;

/**
 * __useBackgroundJobProgressSubscription__
 *
 * To run a query within a React component, call `useBackgroundJobProgressSubscription` and pass it any options that fit your needs.
 * When your component renders, `useBackgroundJobProgressSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBackgroundJobProgressSubscription({
 *   variables: {
 *   },
 * });
 */
export function useBackgroundJobProgressSubscription(baseOptions?: ApolloReactHooks.SubscriptionHookOptions<BackgroundJobProgressSubscription, BackgroundJobProgressSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useSubscription<BackgroundJobProgressSubscription, BackgroundJobProgressSubscriptionVariables>(BackgroundJobProgressDocument, options);
      }
export type BackgroundJobProgressSubscriptionHookResult = ReturnType<typeof useBackgroundJobProgressSubscription>;
export type BackgroundJobProgressSubscriptionResult = ApolloReactCommon.SubscriptionResult<BackgroundJobProgressSubscription>;
export const BackgroundJobCancelDocument = gql`
    mutation backgroundJobCancel($input: BackgroundJobCancelInput!) {
  data: backgroundJobCancel(input: $input) {
    ...backgroundJobFragment
  }
}
    ${BackgroundJobFragmentFragmentDoc}
${AuthorizationResultFragmentFragmentDoc}`;

/**
 * __useBackgroundJobCancelMutation__
 *
 * To run a mutation, you first call `useBackgroundJobCancelMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBackgroundJobCancelMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [backgroundJobCancelMutation, { data, loading, error }] = useBackgroundJobCancelMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useBackgroundJobCancelMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<BackgroundJobCancelMutation, BackgroundJobCancelMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<BackgroundJobCancelMutation, BackgroundJobCancelMutationVariables>(BackgroundJobCancelDocument, options);
      }
export type BackgroundJobCancelMutationHookResult = ReturnType<typeof useBackgroundJobCancelMutation>;
export type BackgroundJobCancelMutationResult = ApolloReactCommon.MutationResult<BackgroundJobCancelMutation>;
export const BackgroundJobDismissDocument = gql`
    mutation backgroundJobDismiss($input: BackgroundJobDismissInput!) {
  data: backgroundJobDismiss(input: $input) {
    ...backgroundJobFragment
  }
}
    ${BackgroundJobFragmentFragmentDoc}
${AuthorizationResultFragmentFragmentDoc}`;

/**
 * __useBackgroundJobDismissMutation__
 *
 * To run a mutation, you first call `useBackgroundJobDismissMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBackgroundJobDismissMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [backgroundJobDismissMutation, { data, loading, error }] = useBackgroundJobDismissMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useBackgroundJobDismissMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<BackgroundJobDismissMutation, BackgroundJobDismissMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<BackgroundJobDismissMutation, BackgroundJobDismissMutationVariables>(BackgroundJobDismissDocument, options);
      }
export type BackgroundJobDismissMutationHookResult = ReturnType<typeof useBackgroundJobDismissMutation>;
export type BackgroundJobDismissMutationResult = ApolloReactCommon.MutationResult<BackgroundJobDismissMutation>;
export const BackgroundJobRequestDeliveryDocument = gql`
    mutation backgroundJobRequestDelivery($input: BackgroundJobRequestDeliveryInput!) {
  data: backgroundJobRequestDelivery(input: $input) {
    ...backgroundJobFragment
  }
}
    ${BackgroundJobFragmentFragmentDoc}
${AuthorizationResultFragmentFragmentDoc}`;

/**
 * __useBackgroundJobRequestDeliveryMutation__
 *
 * To run a mutation, you first call `useBackgroundJobRequestDeliveryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBackgroundJobRequestDeliveryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [backgroundJobRequestDeliveryMutation, { data, loading, error }] = useBackgroundJobRequestDeliveryMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useBackgroundJobRequestDeliveryMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<BackgroundJobRequestDeliveryMutation, BackgroundJobRequestDeliveryMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<BackgroundJobRequestDeliveryMutation, BackgroundJobRequestDeliveryMutationVariables>(BackgroundJobRequestDeliveryDocument, options);
      }
export type BackgroundJobRequestDeliveryMutationHookResult = ReturnType<typeof useBackgroundJobRequestDeliveryMutation>;
export type BackgroundJobRequestDeliveryMutationResult = ApolloReactCommon.MutationResult<BackgroundJobRequestDeliveryMutation>;
export const BackgroundJobRequeueDocument = gql`
    mutation backgroundJobRequeue($input: BackgroundJobRequeueInput!) {
  data: backgroundJobRequeue(input: $input) {
    ...backgroundJobFragment
  }
}
    ${BackgroundJobFragmentFragmentDoc}
${AuthorizationResultFragmentFragmentDoc}`;

/**
 * __useBackgroundJobRequeueMutation__
 *
 * To run a mutation, you first call `useBackgroundJobRequeueMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBackgroundJobRequeueMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [backgroundJobRequeueMutation, { data, loading, error }] = useBackgroundJobRequeueMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useBackgroundJobRequeueMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<BackgroundJobRequeueMutation, BackgroundJobRequeueMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<BackgroundJobRequeueMutation, BackgroundJobRequeueMutationVariables>(BackgroundJobRequeueDocument, options);
      }
export type BackgroundJobRequeueMutationHookResult = ReturnType<typeof useBackgroundJobRequeueMutation>;
export type BackgroundJobRequeueMutationResult = ApolloReactCommon.MutationResult<BackgroundJobRequeueMutation>;
export const WhoamiDocument = gql`
    query Whoami($includeFullData: Boolean = true) {
  whoami {
    resource {
      __typename
      ... on User {
        avatarAttached @include(if: $includeFullData) {
          ...attachmentFragment
        }
        deactivatedAt @include(if: $includeFullData)
        debugModeUntil
        createdAt @include(if: $includeFullData)
        email @include(if: $includeFullData)
        firstName @include(if: $includeFullData)
        id
        lang @include(if: $includeFullData)
        lastName @include(if: $includeFullData)
        personalId @include(if: $includeFullData)
        passwordSetupRequired @include(if: $includeFullData)
        passwordUpdatedAt @include(if: $includeFullData)
        unconfirmedEmail @include(if: $includeFullData)
        updatedAt @include(if: $includeFullData)
        username @include(if: $includeFullData)
        verified @include(if: $includeFullData)
        phoneNumber @include(if: $includeFullData)
        role
        sites @include(if: $includeFullData) {
          collection {
            id
            name
          }
        }
        codeOfConductAccepted @include(if: $includeFullData)
        finalAccesses {
          component
          itemIds
          level
          scopeLevel
          policy
        }
        company {
          id
          activeUsersCount
          plan {
            usersLimit
            accesses {
              component
              level
            }
            upgradeFeatures
          }
          createdAt
        }
      }
    }
  }
}
    ${AttachmentFragmentFragmentDoc}`;

/**
 * __useWhoamiQuery__
 *
 * To run a query within a React component, call `useWhoamiQuery` and pass it any options that fit your needs.
 * When your component renders, `useWhoamiQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWhoamiQuery({
 *   variables: {
 *      includeFullData: // value for 'includeFullData'
 *   },
 * });
 */
export function useWhoamiQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<WhoamiQuery, WhoamiQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<WhoamiQuery, WhoamiQueryVariables>(WhoamiDocument, options);
      }
export function useWhoamiLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<WhoamiQuery, WhoamiQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<WhoamiQuery, WhoamiQueryVariables>(WhoamiDocument, options);
        }
// @ts-ignore
export function useWhoamiSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<WhoamiQuery, WhoamiQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<WhoamiQuery, WhoamiQueryVariables>;
// @ts-ignore
export function useWhoamiSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<WhoamiQuery, WhoamiQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<WhoamiQuery | undefined, WhoamiQueryVariables>;
export function useWhoamiSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<WhoamiQuery, WhoamiQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          // @ts-ignore
          return ApolloReactHooks.useSuspenseQuery<WhoamiQuery, WhoamiQueryVariables>(WhoamiDocument, options);
        }
export type WhoamiQueryHookResult = ReturnType<typeof useWhoamiQuery>;
export type WhoamiLazyQueryHookResult = ReturnType<typeof useWhoamiLazyQuery>;
export type WhoamiSuspenseQueryHookResult = ReturnType<typeof useWhoamiSuspenseQuery>;
export type WhoamiQueryResult = ApolloReactCommon.QueryResult<WhoamiQuery, WhoamiQueryVariables>;
export function refetchWhoamiQuery(variables?: WhoamiQueryVariables) {
      return { query: WhoamiDocument, variables: variables }
    }
export const CountriesDocument = gql`
    query countries {
  data: countries {
    code
    name
  }
}
    `;

/**
 * __useCountriesQuery__
 *
 * To run a query within a React component, call `useCountriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useCountriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCountriesQuery({
 *   variables: {
 *   },
 * });
 */
export function useCountriesQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<CountriesQuery, CountriesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<CountriesQuery, CountriesQueryVariables>(CountriesDocument, options);
      }
export function useCountriesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<CountriesQuery, CountriesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<CountriesQuery, CountriesQueryVariables>(CountriesDocument, options);
        }
// @ts-ignore
export function useCountriesSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<CountriesQuery, CountriesQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<CountriesQuery, CountriesQueryVariables>;
// @ts-ignore
export function useCountriesSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<CountriesQuery, CountriesQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<CountriesQuery | undefined, CountriesQueryVariables>;
export function useCountriesSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<CountriesQuery, CountriesQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          // @ts-ignore
          return ApolloReactHooks.useSuspenseQuery<CountriesQuery, CountriesQueryVariables>(CountriesDocument, options);
        }
export type CountriesQueryHookResult = ReturnType<typeof useCountriesQuery>;
export type CountriesLazyQueryHookResult = ReturnType<typeof useCountriesLazyQuery>;
export type CountriesSuspenseQueryHookResult = ReturnType<typeof useCountriesSuspenseQuery>;
export type CountriesQueryResult = ApolloReactCommon.QueryResult<CountriesQuery, CountriesQueryVariables>;
export function refetchCountriesQuery(variables?: CountriesQueryVariables) {
      return { query: CountriesDocument, variables: variables }
    }
export const DataImportDocument = gql`
    query dataImport($id: ID!) {
  data: dataImport(id: $id) {
    ...dataImportFragment
  }
}
    ${DataImportFragmentFragmentDoc}
${AttachmentFragmentFragmentDoc}
${BackgroundJobTreeFragmentFragmentDoc}
${BackgroundJobFragmentFragmentDoc}
${AuthorizationResultFragmentFragmentDoc}`;

/**
 * __useDataImportQuery__
 *
 * To run a query within a React component, call `useDataImportQuery` and pass it any options that fit your needs.
 * When your component renders, `useDataImportQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDataImportQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDataImportQuery(baseOptions: ApolloReactHooks.QueryHookOptions<DataImportQuery, DataImportQueryVariables> & ({ variables: DataImportQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<DataImportQuery, DataImportQueryVariables>(DataImportDocument, options);
      }
export function useDataImportLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<DataImportQuery, DataImportQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<DataImportQuery, DataImportQueryVariables>(DataImportDocument, options);
        }
// @ts-ignore
export function useDataImportSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<DataImportQuery, DataImportQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<DataImportQuery, DataImportQueryVariables>;
// @ts-ignore
export function useDataImportSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<DataImportQuery, DataImportQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<DataImportQuery | undefined, DataImportQueryVariables>;
export function useDataImportSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<DataImportQuery, DataImportQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          // @ts-ignore
          return ApolloReactHooks.useSuspenseQuery<DataImportQuery, DataImportQueryVariables>(DataImportDocument, options);
        }
export type DataImportQueryHookResult = ReturnType<typeof useDataImportQuery>;
export type DataImportLazyQueryHookResult = ReturnType<typeof useDataImportLazyQuery>;
export type DataImportSuspenseQueryHookResult = ReturnType<typeof useDataImportSuspenseQuery>;
export type DataImportQueryResult = ApolloReactCommon.QueryResult<DataImportQuery, DataImportQueryVariables>;
export function refetchDataImportQuery(variables: DataImportQueryVariables) {
      return { query: DataImportDocument, variables: variables }
    }
export const DataImportsDocument = gql`
    query dataImports($page: Int, $limit: Int, $filters: [DataImportFilterInputObject!], $sorts: DataImportSortInputObject, $onlyIds: Boolean) {
  data: dataImports(
    page: $page
    limit: $limit
    filters: $filters
    sorts: $sorts
    onlyIds: $onlyIds
  ) {
    collection {
      ...dataImportFragment
    }
    metadata {
      ...metadataFragment
    }
  }
}
    ${DataImportFragmentFragmentDoc}
${AttachmentFragmentFragmentDoc}
${BackgroundJobTreeFragmentFragmentDoc}
${BackgroundJobFragmentFragmentDoc}
${AuthorizationResultFragmentFragmentDoc}
${MetadataFragmentFragmentDoc}`;

/**
 * __useDataImportsQuery__
 *
 * To run a query within a React component, call `useDataImportsQuery` and pass it any options that fit your needs.
 * When your component renders, `useDataImportsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDataImportsQuery({
 *   variables: {
 *      page: // value for 'page'
 *      limit: // value for 'limit'
 *      filters: // value for 'filters'
 *      sorts: // value for 'sorts'
 *      onlyIds: // value for 'onlyIds'
 *   },
 * });
 */
export function useDataImportsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<DataImportsQuery, DataImportsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<DataImportsQuery, DataImportsQueryVariables>(DataImportsDocument, options);
      }
export function useDataImportsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<DataImportsQuery, DataImportsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<DataImportsQuery, DataImportsQueryVariables>(DataImportsDocument, options);
        }
// @ts-ignore
export function useDataImportsSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<DataImportsQuery, DataImportsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<DataImportsQuery, DataImportsQueryVariables>;
// @ts-ignore
export function useDataImportsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<DataImportsQuery, DataImportsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<DataImportsQuery | undefined, DataImportsQueryVariables>;
export function useDataImportsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<DataImportsQuery, DataImportsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          // @ts-ignore
          return ApolloReactHooks.useSuspenseQuery<DataImportsQuery, DataImportsQueryVariables>(DataImportsDocument, options);
        }
export type DataImportsQueryHookResult = ReturnType<typeof useDataImportsQuery>;
export type DataImportsLazyQueryHookResult = ReturnType<typeof useDataImportsLazyQuery>;
export type DataImportsSuspenseQueryHookResult = ReturnType<typeof useDataImportsSuspenseQuery>;
export type DataImportsQueryResult = ApolloReactCommon.QueryResult<DataImportsQuery, DataImportsQueryVariables>;
export function refetchDataImportsQuery(variables?: DataImportsQueryVariables) {
      return { query: DataImportsDocument, variables: variables }
    }
export const DataImportIdsDocument = gql`
    query dataImportIds($page: Int, $limit: Int, $filters: [DataImportFilterInputObject!], $sorts: DataImportSortInputObject, $onlyIds: Boolean) {
  data: dataImports(
    page: $page
    limit: $limit
    filters: $filters
    sorts: $sorts
    onlyIds: $onlyIds
  ) {
    collection {
      id
    }
  }
}
    `;

/**
 * __useDataImportIdsQuery__
 *
 * To run a query within a React component, call `useDataImportIdsQuery` and pass it any options that fit your needs.
 * When your component renders, `useDataImportIdsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDataImportIdsQuery({
 *   variables: {
 *      page: // value for 'page'
 *      limit: // value for 'limit'
 *      filters: // value for 'filters'
 *      sorts: // value for 'sorts'
 *      onlyIds: // value for 'onlyIds'
 *   },
 * });
 */
export function useDataImportIdsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<DataImportIdsQuery, DataImportIdsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<DataImportIdsQuery, DataImportIdsQueryVariables>(DataImportIdsDocument, options);
      }
export function useDataImportIdsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<DataImportIdsQuery, DataImportIdsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<DataImportIdsQuery, DataImportIdsQueryVariables>(DataImportIdsDocument, options);
        }
// @ts-ignore
export function useDataImportIdsSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<DataImportIdsQuery, DataImportIdsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<DataImportIdsQuery, DataImportIdsQueryVariables>;
// @ts-ignore
export function useDataImportIdsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<DataImportIdsQuery, DataImportIdsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<DataImportIdsQuery | undefined, DataImportIdsQueryVariables>;
export function useDataImportIdsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<DataImportIdsQuery, DataImportIdsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          // @ts-ignore
          return ApolloReactHooks.useSuspenseQuery<DataImportIdsQuery, DataImportIdsQueryVariables>(DataImportIdsDocument, options);
        }
export type DataImportIdsQueryHookResult = ReturnType<typeof useDataImportIdsQuery>;
export type DataImportIdsLazyQueryHookResult = ReturnType<typeof useDataImportIdsLazyQuery>;
export type DataImportIdsSuspenseQueryHookResult = ReturnType<typeof useDataImportIdsSuspenseQuery>;
export type DataImportIdsQueryResult = ApolloReactCommon.QueryResult<DataImportIdsQuery, DataImportIdsQueryVariables>;
export function refetchDataImportIdsQuery(variables?: DataImportIdsQueryVariables) {
      return { query: DataImportIdsDocument, variables: variables }
    }
export const DataImportConfigDocument = gql`
    query dataImportConfig {
  data: dataImportConfig
}
    `;

/**
 * __useDataImportConfigQuery__
 *
 * To run a query within a React component, call `useDataImportConfigQuery` and pass it any options that fit your needs.
 * When your component renders, `useDataImportConfigQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDataImportConfigQuery({
 *   variables: {
 *   },
 * });
 */
export function useDataImportConfigQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<DataImportConfigQuery, DataImportConfigQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<DataImportConfigQuery, DataImportConfigQueryVariables>(DataImportConfigDocument, options);
      }
export function useDataImportConfigLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<DataImportConfigQuery, DataImportConfigQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<DataImportConfigQuery, DataImportConfigQueryVariables>(DataImportConfigDocument, options);
        }
// @ts-ignore
export function useDataImportConfigSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<DataImportConfigQuery, DataImportConfigQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<DataImportConfigQuery, DataImportConfigQueryVariables>;
// @ts-ignore
export function useDataImportConfigSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<DataImportConfigQuery, DataImportConfigQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<DataImportConfigQuery | undefined, DataImportConfigQueryVariables>;
export function useDataImportConfigSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<DataImportConfigQuery, DataImportConfigQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          // @ts-ignore
          return ApolloReactHooks.useSuspenseQuery<DataImportConfigQuery, DataImportConfigQueryVariables>(DataImportConfigDocument, options);
        }
export type DataImportConfigQueryHookResult = ReturnType<typeof useDataImportConfigQuery>;
export type DataImportConfigLazyQueryHookResult = ReturnType<typeof useDataImportConfigLazyQuery>;
export type DataImportConfigSuspenseQueryHookResult = ReturnType<typeof useDataImportConfigSuspenseQuery>;
export type DataImportConfigQueryResult = ApolloReactCommon.QueryResult<DataImportConfigQuery, DataImportConfigQueryVariables>;
export function refetchDataImportConfigQuery(variables?: DataImportConfigQueryVariables) {
      return { query: DataImportConfigDocument, variables: variables }
    }
export const DataImportCreateDocument = gql`
    mutation dataImportCreate($attributes: DataImportCreateInputObject!) {
  data: dataImportCreate(input: {attributes: $attributes}) {
    ...dataImportFragment
  }
}
    ${DataImportFragmentFragmentDoc}
${AttachmentFragmentFragmentDoc}
${BackgroundJobTreeFragmentFragmentDoc}
${BackgroundJobFragmentFragmentDoc}
${AuthorizationResultFragmentFragmentDoc}`;

/**
 * __useDataImportCreateMutation__
 *
 * To run a mutation, you first call `useDataImportCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDataImportCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [dataImportCreateMutation, { data, loading, error }] = useDataImportCreateMutation({
 *   variables: {
 *      attributes: // value for 'attributes'
 *   },
 * });
 */
export function useDataImportCreateMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<DataImportCreateMutation, DataImportCreateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<DataImportCreateMutation, DataImportCreateMutationVariables>(DataImportCreateDocument, options);
      }
export type DataImportCreateMutationHookResult = ReturnType<typeof useDataImportCreateMutation>;
export type DataImportCreateMutationResult = ApolloReactCommon.MutationResult<DataImportCreateMutation>;
export const DataImportUpdateDocument = gql`
    mutation dataImportUpdate($attributes: DataImportUpdateInputObject!, $id: ID!) {
  data: dataImportUpdate(input: {id: $id, attributes: $attributes}) {
    ...dataImportFragment
  }
}
    ${DataImportFragmentFragmentDoc}
${AttachmentFragmentFragmentDoc}
${BackgroundJobTreeFragmentFragmentDoc}
${BackgroundJobFragmentFragmentDoc}
${AuthorizationResultFragmentFragmentDoc}`;

/**
 * __useDataImportUpdateMutation__
 *
 * To run a mutation, you first call `useDataImportUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDataImportUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [dataImportUpdateMutation, { data, loading, error }] = useDataImportUpdateMutation({
 *   variables: {
 *      attributes: // value for 'attributes'
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDataImportUpdateMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<DataImportUpdateMutation, DataImportUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<DataImportUpdateMutation, DataImportUpdateMutationVariables>(DataImportUpdateDocument, options);
      }
export type DataImportUpdateMutationHookResult = ReturnType<typeof useDataImportUpdateMutation>;
export type DataImportUpdateMutationResult = ApolloReactCommon.MutationResult<DataImportUpdateMutation>;
export const DataImportDestroyDocument = gql`
    mutation dataImportDestroy($id: ID!) {
  dataImportDestroy(input: {id: $id})
}
    `;

/**
 * __useDataImportDestroyMutation__
 *
 * To run a mutation, you first call `useDataImportDestroyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDataImportDestroyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [dataImportDestroyMutation, { data, loading, error }] = useDataImportDestroyMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDataImportDestroyMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<DataImportDestroyMutation, DataImportDestroyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<DataImportDestroyMutation, DataImportDestroyMutationVariables>(DataImportDestroyDocument, options);
      }
export type DataImportDestroyMutationHookResult = ReturnType<typeof useDataImportDestroyMutation>;
export type DataImportDestroyMutationResult = ApolloReactCommon.MutationResult<DataImportDestroyMutation>;
export const DepartmentsDocument = gql`
    query departments($page: Int, $limit: Int, $sorts: DepartmentSortInputObject, $filters: [DepartmentFilterInputObject!]) {
  data: departments(page: $page, limit: $limit, sorts: $sorts, filters: $filters) {
    collection {
      ...departmentListItemFragment
    }
    metadata {
      ...metadataFragment
    }
  }
}
    ${DepartmentListItemFragmentFragmentDoc}
${AttachmentFragmentFragmentDoc}
${AuthorizationResultFragmentFragmentDoc}
${MetadataFragmentFragmentDoc}`;

/**
 * __useDepartmentsQuery__
 *
 * To run a query within a React component, call `useDepartmentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useDepartmentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDepartmentsQuery({
 *   variables: {
 *      page: // value for 'page'
 *      limit: // value for 'limit'
 *      sorts: // value for 'sorts'
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useDepartmentsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<DepartmentsQuery, DepartmentsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<DepartmentsQuery, DepartmentsQueryVariables>(DepartmentsDocument, options);
      }
export function useDepartmentsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<DepartmentsQuery, DepartmentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<DepartmentsQuery, DepartmentsQueryVariables>(DepartmentsDocument, options);
        }
// @ts-ignore
export function useDepartmentsSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<DepartmentsQuery, DepartmentsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<DepartmentsQuery, DepartmentsQueryVariables>;
// @ts-ignore
export function useDepartmentsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<DepartmentsQuery, DepartmentsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<DepartmentsQuery | undefined, DepartmentsQueryVariables>;
export function useDepartmentsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<DepartmentsQuery, DepartmentsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          // @ts-ignore
          return ApolloReactHooks.useSuspenseQuery<DepartmentsQuery, DepartmentsQueryVariables>(DepartmentsDocument, options);
        }
export type DepartmentsQueryHookResult = ReturnType<typeof useDepartmentsQuery>;
export type DepartmentsLazyQueryHookResult = ReturnType<typeof useDepartmentsLazyQuery>;
export type DepartmentsSuspenseQueryHookResult = ReturnType<typeof useDepartmentsSuspenseQuery>;
export type DepartmentsQueryResult = ApolloReactCommon.QueryResult<DepartmentsQuery, DepartmentsQueryVariables>;
export function refetchDepartmentsQuery(variables?: DepartmentsQueryVariables) {
      return { query: DepartmentsDocument, variables: variables }
    }
export const DepartmentDocument = gql`
    query department($id: ID!) {
  data: department(id: $id) {
    ...departmentFragment
  }
}
    ${DepartmentFragmentFragmentDoc}
${AttachmentFragmentFragmentDoc}
${AuthorizationResultFragmentFragmentDoc}`;

/**
 * __useDepartmentQuery__
 *
 * To run a query within a React component, call `useDepartmentQuery` and pass it any options that fit your needs.
 * When your component renders, `useDepartmentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDepartmentQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDepartmentQuery(baseOptions: ApolloReactHooks.QueryHookOptions<DepartmentQuery, DepartmentQueryVariables> & ({ variables: DepartmentQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<DepartmentQuery, DepartmentQueryVariables>(DepartmentDocument, options);
      }
export function useDepartmentLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<DepartmentQuery, DepartmentQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<DepartmentQuery, DepartmentQueryVariables>(DepartmentDocument, options);
        }
// @ts-ignore
export function useDepartmentSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<DepartmentQuery, DepartmentQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<DepartmentQuery, DepartmentQueryVariables>;
// @ts-ignore
export function useDepartmentSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<DepartmentQuery, DepartmentQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<DepartmentQuery | undefined, DepartmentQueryVariables>;
export function useDepartmentSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<DepartmentQuery, DepartmentQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          // @ts-ignore
          return ApolloReactHooks.useSuspenseQuery<DepartmentQuery, DepartmentQueryVariables>(DepartmentDocument, options);
        }
export type DepartmentQueryHookResult = ReturnType<typeof useDepartmentQuery>;
export type DepartmentLazyQueryHookResult = ReturnType<typeof useDepartmentLazyQuery>;
export type DepartmentSuspenseQueryHookResult = ReturnType<typeof useDepartmentSuspenseQuery>;
export type DepartmentQueryResult = ApolloReactCommon.QueryResult<DepartmentQuery, DepartmentQueryVariables>;
export function refetchDepartmentQuery(variables: DepartmentQueryVariables) {
      return { query: DepartmentDocument, variables: variables }
    }
export const DepartmentIdsDocument = gql`
    query departmentIds($sorts: DepartmentSortInputObject, $filters: [DepartmentFilterInputObject!], $onlyIds: Boolean) {
  data: departments(sorts: $sorts, filters: $filters, onlyIds: $onlyIds) {
    collection {
      id
    }
  }
}
    `;

/**
 * __useDepartmentIdsQuery__
 *
 * To run a query within a React component, call `useDepartmentIdsQuery` and pass it any options that fit your needs.
 * When your component renders, `useDepartmentIdsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDepartmentIdsQuery({
 *   variables: {
 *      sorts: // value for 'sorts'
 *      filters: // value for 'filters'
 *      onlyIds: // value for 'onlyIds'
 *   },
 * });
 */
export function useDepartmentIdsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<DepartmentIdsQuery, DepartmentIdsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<DepartmentIdsQuery, DepartmentIdsQueryVariables>(DepartmentIdsDocument, options);
      }
export function useDepartmentIdsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<DepartmentIdsQuery, DepartmentIdsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<DepartmentIdsQuery, DepartmentIdsQueryVariables>(DepartmentIdsDocument, options);
        }
// @ts-ignore
export function useDepartmentIdsSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<DepartmentIdsQuery, DepartmentIdsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<DepartmentIdsQuery, DepartmentIdsQueryVariables>;
// @ts-ignore
export function useDepartmentIdsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<DepartmentIdsQuery, DepartmentIdsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<DepartmentIdsQuery | undefined, DepartmentIdsQueryVariables>;
export function useDepartmentIdsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<DepartmentIdsQuery, DepartmentIdsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          // @ts-ignore
          return ApolloReactHooks.useSuspenseQuery<DepartmentIdsQuery, DepartmentIdsQueryVariables>(DepartmentIdsDocument, options);
        }
export type DepartmentIdsQueryHookResult = ReturnType<typeof useDepartmentIdsQuery>;
export type DepartmentIdsLazyQueryHookResult = ReturnType<typeof useDepartmentIdsLazyQuery>;
export type DepartmentIdsSuspenseQueryHookResult = ReturnType<typeof useDepartmentIdsSuspenseQuery>;
export type DepartmentIdsQueryResult = ApolloReactCommon.QueryResult<DepartmentIdsQuery, DepartmentIdsQueryVariables>;
export function refetchDepartmentIdsQuery(variables?: DepartmentIdsQueryVariables) {
      return { query: DepartmentIdsDocument, variables: variables }
    }
export const DepartmentsSearchListDocument = gql`
    query departmentsSearchList($page: Int, $limit: Int, $sorts: DepartmentSortInputObject, $filters: [DepartmentFilterInputObject!]) {
  data: departments(page: $page, limit: $limit, sorts: $sorts, filters: $filters) {
    collection {
      id
      name
      path
      color
    }
    metadata {
      ...metadataFragment
    }
  }
}
    ${MetadataFragmentFragmentDoc}`;

/**
 * __useDepartmentsSearchListQuery__
 *
 * To run a query within a React component, call `useDepartmentsSearchListQuery` and pass it any options that fit your needs.
 * When your component renders, `useDepartmentsSearchListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDepartmentsSearchListQuery({
 *   variables: {
 *      page: // value for 'page'
 *      limit: // value for 'limit'
 *      sorts: // value for 'sorts'
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useDepartmentsSearchListQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<DepartmentsSearchListQuery, DepartmentsSearchListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<DepartmentsSearchListQuery, DepartmentsSearchListQueryVariables>(DepartmentsSearchListDocument, options);
      }
export function useDepartmentsSearchListLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<DepartmentsSearchListQuery, DepartmentsSearchListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<DepartmentsSearchListQuery, DepartmentsSearchListQueryVariables>(DepartmentsSearchListDocument, options);
        }
// @ts-ignore
export function useDepartmentsSearchListSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<DepartmentsSearchListQuery, DepartmentsSearchListQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<DepartmentsSearchListQuery, DepartmentsSearchListQueryVariables>;
// @ts-ignore
export function useDepartmentsSearchListSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<DepartmentsSearchListQuery, DepartmentsSearchListQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<DepartmentsSearchListQuery | undefined, DepartmentsSearchListQueryVariables>;
export function useDepartmentsSearchListSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<DepartmentsSearchListQuery, DepartmentsSearchListQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          // @ts-ignore
          return ApolloReactHooks.useSuspenseQuery<DepartmentsSearchListQuery, DepartmentsSearchListQueryVariables>(DepartmentsSearchListDocument, options);
        }
export type DepartmentsSearchListQueryHookResult = ReturnType<typeof useDepartmentsSearchListQuery>;
export type DepartmentsSearchListLazyQueryHookResult = ReturnType<typeof useDepartmentsSearchListLazyQuery>;
export type DepartmentsSearchListSuspenseQueryHookResult = ReturnType<typeof useDepartmentsSearchListSuspenseQuery>;
export type DepartmentsSearchListQueryResult = ApolloReactCommon.QueryResult<DepartmentsSearchListQuery, DepartmentsSearchListQueryVariables>;
export function refetchDepartmentsSearchListQuery(variables?: DepartmentsSearchListQueryVariables) {
      return { query: DepartmentsSearchListDocument, variables: variables }
    }
export const DepartmentCreateDocument = gql`
    mutation departmentCreate($attributes: DepartmentCreateInputObject!) {
  data: departmentCreate(input: {attributes: $attributes}) {
    ...departmentFragment
  }
}
    ${DepartmentFragmentFragmentDoc}
${AttachmentFragmentFragmentDoc}
${AuthorizationResultFragmentFragmentDoc}`;

/**
 * __useDepartmentCreateMutation__
 *
 * To run a mutation, you first call `useDepartmentCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDepartmentCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [departmentCreateMutation, { data, loading, error }] = useDepartmentCreateMutation({
 *   variables: {
 *      attributes: // value for 'attributes'
 *   },
 * });
 */
export function useDepartmentCreateMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<DepartmentCreateMutation, DepartmentCreateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<DepartmentCreateMutation, DepartmentCreateMutationVariables>(DepartmentCreateDocument, options);
      }
export type DepartmentCreateMutationHookResult = ReturnType<typeof useDepartmentCreateMutation>;
export type DepartmentCreateMutationResult = ApolloReactCommon.MutationResult<DepartmentCreateMutation>;
export const DepartmentUpdateDocument = gql`
    mutation departmentUpdate($id: ID!, $attributes: DepartmentUpdateInputObject!) {
  data: departmentUpdate(input: {id: $id, attributes: $attributes}) {
    ...departmentFragment
  }
}
    ${DepartmentFragmentFragmentDoc}
${AttachmentFragmentFragmentDoc}
${AuthorizationResultFragmentFragmentDoc}`;

/**
 * __useDepartmentUpdateMutation__
 *
 * To run a mutation, you first call `useDepartmentUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDepartmentUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [departmentUpdateMutation, { data, loading, error }] = useDepartmentUpdateMutation({
 *   variables: {
 *      id: // value for 'id'
 *      attributes: // value for 'attributes'
 *   },
 * });
 */
export function useDepartmentUpdateMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<DepartmentUpdateMutation, DepartmentUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<DepartmentUpdateMutation, DepartmentUpdateMutationVariables>(DepartmentUpdateDocument, options);
      }
export type DepartmentUpdateMutationHookResult = ReturnType<typeof useDepartmentUpdateMutation>;
export type DepartmentUpdateMutationResult = ApolloReactCommon.MutationResult<DepartmentUpdateMutation>;
export const DepartmentDestroyDocument = gql`
    mutation departmentDestroy($id: ID!) {
  data: departmentDestroy(input: {id: $id})
}
    `;

/**
 * __useDepartmentDestroyMutation__
 *
 * To run a mutation, you first call `useDepartmentDestroyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDepartmentDestroyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [departmentDestroyMutation, { data, loading, error }] = useDepartmentDestroyMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDepartmentDestroyMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<DepartmentDestroyMutation, DepartmentDestroyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<DepartmentDestroyMutation, DepartmentDestroyMutationVariables>(DepartmentDestroyDocument, options);
      }
export type DepartmentDestroyMutationHookResult = ReturnType<typeof useDepartmentDestroyMutation>;
export type DepartmentDestroyMutationResult = ApolloReactCommon.MutationResult<DepartmentDestroyMutation>;
export const DepartmentHierarchyDocument = gql`
    query departmentHierarchy($id: ID!) {
  data: department(id: $id) {
    ...departmentHierarchyNodeFragment
    parent {
      ...departmentHierarchyNodeFragment
      parent {
        ...departmentHierarchyNodeFragment
        parent {
          ...departmentHierarchyNodeFragment
          parent {
            ...departmentHierarchyNodeFragment
          }
        }
      }
    }
  }
}
    ${DepartmentHierarchyNodeFragmentFragmentDoc}`;

/**
 * __useDepartmentHierarchyQuery__
 *
 * To run a query within a React component, call `useDepartmentHierarchyQuery` and pass it any options that fit your needs.
 * When your component renders, `useDepartmentHierarchyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDepartmentHierarchyQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDepartmentHierarchyQuery(baseOptions: ApolloReactHooks.QueryHookOptions<DepartmentHierarchyQuery, DepartmentHierarchyQueryVariables> & ({ variables: DepartmentHierarchyQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<DepartmentHierarchyQuery, DepartmentHierarchyQueryVariables>(DepartmentHierarchyDocument, options);
      }
export function useDepartmentHierarchyLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<DepartmentHierarchyQuery, DepartmentHierarchyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<DepartmentHierarchyQuery, DepartmentHierarchyQueryVariables>(DepartmentHierarchyDocument, options);
        }
// @ts-ignore
export function useDepartmentHierarchySuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<DepartmentHierarchyQuery, DepartmentHierarchyQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<DepartmentHierarchyQuery, DepartmentHierarchyQueryVariables>;
// @ts-ignore
export function useDepartmentHierarchySuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<DepartmentHierarchyQuery, DepartmentHierarchyQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<DepartmentHierarchyQuery | undefined, DepartmentHierarchyQueryVariables>;
export function useDepartmentHierarchySuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<DepartmentHierarchyQuery, DepartmentHierarchyQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          // @ts-ignore
          return ApolloReactHooks.useSuspenseQuery<DepartmentHierarchyQuery, DepartmentHierarchyQueryVariables>(DepartmentHierarchyDocument, options);
        }
export type DepartmentHierarchyQueryHookResult = ReturnType<typeof useDepartmentHierarchyQuery>;
export type DepartmentHierarchyLazyQueryHookResult = ReturnType<typeof useDepartmentHierarchyLazyQuery>;
export type DepartmentHierarchySuspenseQueryHookResult = ReturnType<typeof useDepartmentHierarchySuspenseQuery>;
export type DepartmentHierarchyQueryResult = ApolloReactCommon.QueryResult<DepartmentHierarchyQuery, DepartmentHierarchyQueryVariables>;
export function refetchDepartmentHierarchyQuery(variables: DepartmentHierarchyQueryVariables) {
      return { query: DepartmentHierarchyDocument, variables: variables }
    }
export const DepartmentHierarchyChildrenDocument = gql`
    query departmentHierarchyChildren($id: ID!) {
  data: department(id: $id) {
    children {
      ...departmentHierarchyNodeFragment
    }
  }
}
    ${DepartmentHierarchyNodeFragmentFragmentDoc}`;

/**
 * __useDepartmentHierarchyChildrenQuery__
 *
 * To run a query within a React component, call `useDepartmentHierarchyChildrenQuery` and pass it any options that fit your needs.
 * When your component renders, `useDepartmentHierarchyChildrenQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDepartmentHierarchyChildrenQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDepartmentHierarchyChildrenQuery(baseOptions: ApolloReactHooks.QueryHookOptions<DepartmentHierarchyChildrenQuery, DepartmentHierarchyChildrenQueryVariables> & ({ variables: DepartmentHierarchyChildrenQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<DepartmentHierarchyChildrenQuery, DepartmentHierarchyChildrenQueryVariables>(DepartmentHierarchyChildrenDocument, options);
      }
export function useDepartmentHierarchyChildrenLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<DepartmentHierarchyChildrenQuery, DepartmentHierarchyChildrenQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<DepartmentHierarchyChildrenQuery, DepartmentHierarchyChildrenQueryVariables>(DepartmentHierarchyChildrenDocument, options);
        }
// @ts-ignore
export function useDepartmentHierarchyChildrenSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<DepartmentHierarchyChildrenQuery, DepartmentHierarchyChildrenQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<DepartmentHierarchyChildrenQuery, DepartmentHierarchyChildrenQueryVariables>;
// @ts-ignore
export function useDepartmentHierarchyChildrenSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<DepartmentHierarchyChildrenQuery, DepartmentHierarchyChildrenQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<DepartmentHierarchyChildrenQuery | undefined, DepartmentHierarchyChildrenQueryVariables>;
export function useDepartmentHierarchyChildrenSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<DepartmentHierarchyChildrenQuery, DepartmentHierarchyChildrenQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          // @ts-ignore
          return ApolloReactHooks.useSuspenseQuery<DepartmentHierarchyChildrenQuery, DepartmentHierarchyChildrenQueryVariables>(DepartmentHierarchyChildrenDocument, options);
        }
export type DepartmentHierarchyChildrenQueryHookResult = ReturnType<typeof useDepartmentHierarchyChildrenQuery>;
export type DepartmentHierarchyChildrenLazyQueryHookResult = ReturnType<typeof useDepartmentHierarchyChildrenLazyQuery>;
export type DepartmentHierarchyChildrenSuspenseQueryHookResult = ReturnType<typeof useDepartmentHierarchyChildrenSuspenseQuery>;
export type DepartmentHierarchyChildrenQueryResult = ApolloReactCommon.QueryResult<DepartmentHierarchyChildrenQuery, DepartmentHierarchyChildrenQueryVariables>;
export function refetchDepartmentHierarchyChildrenQuery(variables: DepartmentHierarchyChildrenQueryVariables) {
      return { query: DepartmentHierarchyChildrenDocument, variables: variables }
    }
export const DepartmentChildrenDocument = gql`
    query departmentChildren($id: ID!) {
  data: department(id: $id) {
    children {
      ...departmentListItemFragment
    }
  }
}
    ${DepartmentListItemFragmentFragmentDoc}
${AttachmentFragmentFragmentDoc}
${AuthorizationResultFragmentFragmentDoc}`;

/**
 * __useDepartmentChildrenQuery__
 *
 * To run a query within a React component, call `useDepartmentChildrenQuery` and pass it any options that fit your needs.
 * When your component renders, `useDepartmentChildrenQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDepartmentChildrenQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDepartmentChildrenQuery(baseOptions: ApolloReactHooks.QueryHookOptions<DepartmentChildrenQuery, DepartmentChildrenQueryVariables> & ({ variables: DepartmentChildrenQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<DepartmentChildrenQuery, DepartmentChildrenQueryVariables>(DepartmentChildrenDocument, options);
      }
export function useDepartmentChildrenLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<DepartmentChildrenQuery, DepartmentChildrenQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<DepartmentChildrenQuery, DepartmentChildrenQueryVariables>(DepartmentChildrenDocument, options);
        }
// @ts-ignore
export function useDepartmentChildrenSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<DepartmentChildrenQuery, DepartmentChildrenQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<DepartmentChildrenQuery, DepartmentChildrenQueryVariables>;
// @ts-ignore
export function useDepartmentChildrenSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<DepartmentChildrenQuery, DepartmentChildrenQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<DepartmentChildrenQuery | undefined, DepartmentChildrenQueryVariables>;
export function useDepartmentChildrenSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<DepartmentChildrenQuery, DepartmentChildrenQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          // @ts-ignore
          return ApolloReactHooks.useSuspenseQuery<DepartmentChildrenQuery, DepartmentChildrenQueryVariables>(DepartmentChildrenDocument, options);
        }
export type DepartmentChildrenQueryHookResult = ReturnType<typeof useDepartmentChildrenQuery>;
export type DepartmentChildrenLazyQueryHookResult = ReturnType<typeof useDepartmentChildrenLazyQuery>;
export type DepartmentChildrenSuspenseQueryHookResult = ReturnType<typeof useDepartmentChildrenSuspenseQuery>;
export type DepartmentChildrenQueryResult = ApolloReactCommon.QueryResult<DepartmentChildrenQuery, DepartmentChildrenQueryVariables>;
export function refetchDepartmentChildrenQuery(variables: DepartmentChildrenQueryVariables) {
      return { query: DepartmentChildrenDocument, variables: variables }
    }
export const DocumentationDocument = gql`
    query documentation($id: ID!) {
  data: documentation(id: $id) {
    id
    name
    tags {
      id
      name
    }
  }
}
    `;

/**
 * __useDocumentationQuery__
 *
 * To run a query within a React component, call `useDocumentationQuery` and pass it any options that fit your needs.
 * When your component renders, `useDocumentationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDocumentationQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDocumentationQuery(baseOptions: ApolloReactHooks.QueryHookOptions<DocumentationQuery, DocumentationQueryVariables> & ({ variables: DocumentationQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<DocumentationQuery, DocumentationQueryVariables>(DocumentationDocument, options);
      }
export function useDocumentationLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<DocumentationQuery, DocumentationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<DocumentationQuery, DocumentationQueryVariables>(DocumentationDocument, options);
        }
// @ts-ignore
export function useDocumentationSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<DocumentationQuery, DocumentationQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<DocumentationQuery, DocumentationQueryVariables>;
// @ts-ignore
export function useDocumentationSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<DocumentationQuery, DocumentationQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<DocumentationQuery | undefined, DocumentationQueryVariables>;
export function useDocumentationSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<DocumentationQuery, DocumentationQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          // @ts-ignore
          return ApolloReactHooks.useSuspenseQuery<DocumentationQuery, DocumentationQueryVariables>(DocumentationDocument, options);
        }
export type DocumentationQueryHookResult = ReturnType<typeof useDocumentationQuery>;
export type DocumentationLazyQueryHookResult = ReturnType<typeof useDocumentationLazyQuery>;
export type DocumentationSuspenseQueryHookResult = ReturnType<typeof useDocumentationSuspenseQuery>;
export type DocumentationQueryResult = ApolloReactCommon.QueryResult<DocumentationQuery, DocumentationQueryVariables>;
export function refetchDocumentationQuery(variables: DocumentationQueryVariables) {
      return { query: DocumentationDocument, variables: variables }
    }
export const DocumentationCreateDocument = gql`
    mutation documentationCreate($attributes: DocumentationCreateInputObject!) {
  data: documentationCreate(input: {attributes: $attributes}) {
    id
    name
    tags {
      id
      name
    }
  }
}
    `;

/**
 * __useDocumentationCreateMutation__
 *
 * To run a mutation, you first call `useDocumentationCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDocumentationCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [documentationCreateMutation, { data, loading, error }] = useDocumentationCreateMutation({
 *   variables: {
 *      attributes: // value for 'attributes'
 *   },
 * });
 */
export function useDocumentationCreateMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<DocumentationCreateMutation, DocumentationCreateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<DocumentationCreateMutation, DocumentationCreateMutationVariables>(DocumentationCreateDocument, options);
      }
export type DocumentationCreateMutationHookResult = ReturnType<typeof useDocumentationCreateMutation>;
export type DocumentationCreateMutationResult = ApolloReactCommon.MutationResult<DocumentationCreateMutation>;
export const DocumentationUpdateDocument = gql`
    mutation documentationUpdate($attributes: DocumentationUpdateInputObject!, $id: ID!) {
  data: documentationUpdate(input: {id: $id, attributes: $attributes}) {
    id
    name
    tags {
      id
      name
    }
  }
}
    `;

/**
 * __useDocumentationUpdateMutation__
 *
 * To run a mutation, you first call `useDocumentationUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDocumentationUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [documentationUpdateMutation, { data, loading, error }] = useDocumentationUpdateMutation({
 *   variables: {
 *      attributes: // value for 'attributes'
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDocumentationUpdateMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<DocumentationUpdateMutation, DocumentationUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<DocumentationUpdateMutation, DocumentationUpdateMutationVariables>(DocumentationUpdateDocument, options);
      }
export type DocumentationUpdateMutationHookResult = ReturnType<typeof useDocumentationUpdateMutation>;
export type DocumentationUpdateMutationResult = ApolloReactCommon.MutationResult<DocumentationUpdateMutation>;
export const DocumentationBulkDestroyDocument = gql`
    mutation documentationBulkDestroy($ids: [ID!]!) {
  documentationBulkDestroy(input: {ids: $ids})
}
    `;

/**
 * __useDocumentationBulkDestroyMutation__
 *
 * To run a mutation, you first call `useDocumentationBulkDestroyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDocumentationBulkDestroyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [documentationBulkDestroyMutation, { data, loading, error }] = useDocumentationBulkDestroyMutation({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useDocumentationBulkDestroyMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<DocumentationBulkDestroyMutation, DocumentationBulkDestroyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<DocumentationBulkDestroyMutation, DocumentationBulkDestroyMutationVariables>(DocumentationBulkDestroyDocument, options);
      }
export type DocumentationBulkDestroyMutationHookResult = ReturnType<typeof useDocumentationBulkDestroyMutation>;
export type DocumentationBulkDestroyMutationResult = ApolloReactCommon.MutationResult<DocumentationBulkDestroyMutation>;
export const EdmDocumentationsIdsDocument = gql`
    query edmDocumentationsIds($page: Int, $limit: Int, $sorts: DocumentationSortInputObject, $filters: [DocumentationFilterInputObject!], $onlyIds: Boolean, $scope: DocumentationScopeInputObject) {
  data: documentations(
    page: $page
    limit: $limit
    sorts: $sorts
    filters: $filters
    onlyIds: $onlyIds
    scope: $scope
  ) {
    collection {
      id
    }
  }
}
    `;

/**
 * __useEdmDocumentationsIdsQuery__
 *
 * To run a query within a React component, call `useEdmDocumentationsIdsQuery` and pass it any options that fit your needs.
 * When your component renders, `useEdmDocumentationsIdsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEdmDocumentationsIdsQuery({
 *   variables: {
 *      page: // value for 'page'
 *      limit: // value for 'limit'
 *      sorts: // value for 'sorts'
 *      filters: // value for 'filters'
 *      onlyIds: // value for 'onlyIds'
 *      scope: // value for 'scope'
 *   },
 * });
 */
export function useEdmDocumentationsIdsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<EdmDocumentationsIdsQuery, EdmDocumentationsIdsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<EdmDocumentationsIdsQuery, EdmDocumentationsIdsQueryVariables>(EdmDocumentationsIdsDocument, options);
      }
export function useEdmDocumentationsIdsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<EdmDocumentationsIdsQuery, EdmDocumentationsIdsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<EdmDocumentationsIdsQuery, EdmDocumentationsIdsQueryVariables>(EdmDocumentationsIdsDocument, options);
        }
// @ts-ignore
export function useEdmDocumentationsIdsSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<EdmDocumentationsIdsQuery, EdmDocumentationsIdsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<EdmDocumentationsIdsQuery, EdmDocumentationsIdsQueryVariables>;
// @ts-ignore
export function useEdmDocumentationsIdsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<EdmDocumentationsIdsQuery, EdmDocumentationsIdsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<EdmDocumentationsIdsQuery | undefined, EdmDocumentationsIdsQueryVariables>;
export function useEdmDocumentationsIdsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<EdmDocumentationsIdsQuery, EdmDocumentationsIdsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          // @ts-ignore
          return ApolloReactHooks.useSuspenseQuery<EdmDocumentationsIdsQuery, EdmDocumentationsIdsQueryVariables>(EdmDocumentationsIdsDocument, options);
        }
export type EdmDocumentationsIdsQueryHookResult = ReturnType<typeof useEdmDocumentationsIdsQuery>;
export type EdmDocumentationsIdsLazyQueryHookResult = ReturnType<typeof useEdmDocumentationsIdsLazyQuery>;
export type EdmDocumentationsIdsSuspenseQueryHookResult = ReturnType<typeof useEdmDocumentationsIdsSuspenseQuery>;
export type EdmDocumentationsIdsQueryResult = ApolloReactCommon.QueryResult<EdmDocumentationsIdsQuery, EdmDocumentationsIdsQueryVariables>;
export function refetchEdmDocumentationsIdsQuery(variables?: EdmDocumentationsIdsQueryVariables) {
      return { query: EdmDocumentationsIdsDocument, variables: variables }
    }
export const EdmDocumentationsCounterDocument = gql`
    query edmDocumentationsCounter($filters: [DocumentationFilterInputObject!]) {
  myApprovals: documentations(filters: $filters) {
    metadata {
      totalCount
    }
  }
}
    `;

/**
 * __useEdmDocumentationsCounterQuery__
 *
 * To run a query within a React component, call `useEdmDocumentationsCounterQuery` and pass it any options that fit your needs.
 * When your component renders, `useEdmDocumentationsCounterQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEdmDocumentationsCounterQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useEdmDocumentationsCounterQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<EdmDocumentationsCounterQuery, EdmDocumentationsCounterQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<EdmDocumentationsCounterQuery, EdmDocumentationsCounterQueryVariables>(EdmDocumentationsCounterDocument, options);
      }
export function useEdmDocumentationsCounterLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<EdmDocumentationsCounterQuery, EdmDocumentationsCounterQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<EdmDocumentationsCounterQuery, EdmDocumentationsCounterQueryVariables>(EdmDocumentationsCounterDocument, options);
        }
// @ts-ignore
export function useEdmDocumentationsCounterSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<EdmDocumentationsCounterQuery, EdmDocumentationsCounterQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<EdmDocumentationsCounterQuery, EdmDocumentationsCounterQueryVariables>;
// @ts-ignore
export function useEdmDocumentationsCounterSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<EdmDocumentationsCounterQuery, EdmDocumentationsCounterQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<EdmDocumentationsCounterQuery | undefined, EdmDocumentationsCounterQueryVariables>;
export function useEdmDocumentationsCounterSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<EdmDocumentationsCounterQuery, EdmDocumentationsCounterQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          // @ts-ignore
          return ApolloReactHooks.useSuspenseQuery<EdmDocumentationsCounterQuery, EdmDocumentationsCounterQueryVariables>(EdmDocumentationsCounterDocument, options);
        }
export type EdmDocumentationsCounterQueryHookResult = ReturnType<typeof useEdmDocumentationsCounterQuery>;
export type EdmDocumentationsCounterLazyQueryHookResult = ReturnType<typeof useEdmDocumentationsCounterLazyQuery>;
export type EdmDocumentationsCounterSuspenseQueryHookResult = ReturnType<typeof useEdmDocumentationsCounterSuspenseQuery>;
export type EdmDocumentationsCounterQueryResult = ApolloReactCommon.QueryResult<EdmDocumentationsCounterQuery, EdmDocumentationsCounterQueryVariables>;
export function refetchEdmDocumentationsCounterQuery(variables?: EdmDocumentationsCounterQueryVariables) {
      return { query: EdmDocumentationsCounterDocument, variables: variables }
    }
export const EdmDocumentationDocument = gql`
    query edmDocumentation($id: ID!, $isViewLocked: Boolean! = false, $isAiDetectionEnabled: Boolean! = false) {
  data: documentation(id: $id) {
    ...edmDocumentationBaseFragment
    ...edmDocumentationPremiumFragment @skip(if: $isViewLocked)
    ...edmDocumentationAiDetectionFragment @include(if: $isAiDetectionEnabled)
    favorited @skip(if: $isViewLocked)
    description
    totalEngagementSeconds @skip(if: $isViewLocked)
    currentVersion {
      id
      notes
      attachmentAttached {
        ...attachmentFragment
      }
    }
  }
}
    ${EdmDocumentationBaseFragmentFragmentDoc}
${AttachmentFragmentFragmentDoc}
${AuthorizationResultFragmentFragmentDoc}
${EdmDocumentationPremiumFragmentFragmentDoc}
${EdmDocumentationCategoryFragmentFragmentDoc}
${EdmDocumentationAiDetectionFragmentFragmentDoc}`;

/**
 * __useEdmDocumentationQuery__
 *
 * To run a query within a React component, call `useEdmDocumentationQuery` and pass it any options that fit your needs.
 * When your component renders, `useEdmDocumentationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEdmDocumentationQuery({
 *   variables: {
 *      id: // value for 'id'
 *      isViewLocked: // value for 'isViewLocked'
 *      isAiDetectionEnabled: // value for 'isAiDetectionEnabled'
 *   },
 * });
 */
export function useEdmDocumentationQuery(baseOptions: ApolloReactHooks.QueryHookOptions<EdmDocumentationQuery, EdmDocumentationQueryVariables> & ({ variables: EdmDocumentationQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<EdmDocumentationQuery, EdmDocumentationQueryVariables>(EdmDocumentationDocument, options);
      }
export function useEdmDocumentationLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<EdmDocumentationQuery, EdmDocumentationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<EdmDocumentationQuery, EdmDocumentationQueryVariables>(EdmDocumentationDocument, options);
        }
// @ts-ignore
export function useEdmDocumentationSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<EdmDocumentationQuery, EdmDocumentationQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<EdmDocumentationQuery, EdmDocumentationQueryVariables>;
// @ts-ignore
export function useEdmDocumentationSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<EdmDocumentationQuery, EdmDocumentationQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<EdmDocumentationQuery | undefined, EdmDocumentationQueryVariables>;
export function useEdmDocumentationSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<EdmDocumentationQuery, EdmDocumentationQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          // @ts-ignore
          return ApolloReactHooks.useSuspenseQuery<EdmDocumentationQuery, EdmDocumentationQueryVariables>(EdmDocumentationDocument, options);
        }
export type EdmDocumentationQueryHookResult = ReturnType<typeof useEdmDocumentationQuery>;
export type EdmDocumentationLazyQueryHookResult = ReturnType<typeof useEdmDocumentationLazyQuery>;
export type EdmDocumentationSuspenseQueryHookResult = ReturnType<typeof useEdmDocumentationSuspenseQuery>;
export type EdmDocumentationQueryResult = ApolloReactCommon.QueryResult<EdmDocumentationQuery, EdmDocumentationQueryVariables>;
export function refetchEdmDocumentationQuery(variables: EdmDocumentationQueryVariables) {
      return { query: EdmDocumentationDocument, variables: variables }
    }
export const EdmDocumentationNameDocument = gql`
    query edmDocumentationName($id: ID!) {
  data: documentation(id: $id) {
    id
    name
  }
}
    `;

/**
 * __useEdmDocumentationNameQuery__
 *
 * To run a query within a React component, call `useEdmDocumentationNameQuery` and pass it any options that fit your needs.
 * When your component renders, `useEdmDocumentationNameQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEdmDocumentationNameQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useEdmDocumentationNameQuery(baseOptions: ApolloReactHooks.QueryHookOptions<EdmDocumentationNameQuery, EdmDocumentationNameQueryVariables> & ({ variables: EdmDocumentationNameQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<EdmDocumentationNameQuery, EdmDocumentationNameQueryVariables>(EdmDocumentationNameDocument, options);
      }
export function useEdmDocumentationNameLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<EdmDocumentationNameQuery, EdmDocumentationNameQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<EdmDocumentationNameQuery, EdmDocumentationNameQueryVariables>(EdmDocumentationNameDocument, options);
        }
// @ts-ignore
export function useEdmDocumentationNameSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<EdmDocumentationNameQuery, EdmDocumentationNameQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<EdmDocumentationNameQuery, EdmDocumentationNameQueryVariables>;
// @ts-ignore
export function useEdmDocumentationNameSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<EdmDocumentationNameQuery, EdmDocumentationNameQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<EdmDocumentationNameQuery | undefined, EdmDocumentationNameQueryVariables>;
export function useEdmDocumentationNameSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<EdmDocumentationNameQuery, EdmDocumentationNameQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          // @ts-ignore
          return ApolloReactHooks.useSuspenseQuery<EdmDocumentationNameQuery, EdmDocumentationNameQueryVariables>(EdmDocumentationNameDocument, options);
        }
export type EdmDocumentationNameQueryHookResult = ReturnType<typeof useEdmDocumentationNameQuery>;
export type EdmDocumentationNameLazyQueryHookResult = ReturnType<typeof useEdmDocumentationNameLazyQuery>;
export type EdmDocumentationNameSuspenseQueryHookResult = ReturnType<typeof useEdmDocumentationNameSuspenseQuery>;
export type EdmDocumentationNameQueryResult = ApolloReactCommon.QueryResult<EdmDocumentationNameQuery, EdmDocumentationNameQueryVariables>;
export function refetchEdmDocumentationNameQuery(variables: EdmDocumentationNameQueryVariables) {
      return { query: EdmDocumentationNameDocument, variables: variables }
    }
export const EdmDocumentationAccessesCountsDocument = gql`
    query edmDocumentationAccessesCounts($documentationId: String!) {
  sectors: sectors(
    filters: [{documentationsId: {predicate: {eq: $documentationId}}}]
    page: 1
    limit: 1
  ) {
    metadata {
      totalCount
    }
  }
  sites: sites(
    filters: [{documentationsId: {predicate: {eq: $documentationId}}}]
    page: 1
    limit: 1
  ) {
    metadata {
      totalCount
    }
  }
}
    `;

/**
 * __useEdmDocumentationAccessesCountsQuery__
 *
 * To run a query within a React component, call `useEdmDocumentationAccessesCountsQuery` and pass it any options that fit your needs.
 * When your component renders, `useEdmDocumentationAccessesCountsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEdmDocumentationAccessesCountsQuery({
 *   variables: {
 *      documentationId: // value for 'documentationId'
 *   },
 * });
 */
export function useEdmDocumentationAccessesCountsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<EdmDocumentationAccessesCountsQuery, EdmDocumentationAccessesCountsQueryVariables> & ({ variables: EdmDocumentationAccessesCountsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<EdmDocumentationAccessesCountsQuery, EdmDocumentationAccessesCountsQueryVariables>(EdmDocumentationAccessesCountsDocument, options);
      }
export function useEdmDocumentationAccessesCountsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<EdmDocumentationAccessesCountsQuery, EdmDocumentationAccessesCountsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<EdmDocumentationAccessesCountsQuery, EdmDocumentationAccessesCountsQueryVariables>(EdmDocumentationAccessesCountsDocument, options);
        }
// @ts-ignore
export function useEdmDocumentationAccessesCountsSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<EdmDocumentationAccessesCountsQuery, EdmDocumentationAccessesCountsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<EdmDocumentationAccessesCountsQuery, EdmDocumentationAccessesCountsQueryVariables>;
// @ts-ignore
export function useEdmDocumentationAccessesCountsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<EdmDocumentationAccessesCountsQuery, EdmDocumentationAccessesCountsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<EdmDocumentationAccessesCountsQuery | undefined, EdmDocumentationAccessesCountsQueryVariables>;
export function useEdmDocumentationAccessesCountsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<EdmDocumentationAccessesCountsQuery, EdmDocumentationAccessesCountsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          // @ts-ignore
          return ApolloReactHooks.useSuspenseQuery<EdmDocumentationAccessesCountsQuery, EdmDocumentationAccessesCountsQueryVariables>(EdmDocumentationAccessesCountsDocument, options);
        }
export type EdmDocumentationAccessesCountsQueryHookResult = ReturnType<typeof useEdmDocumentationAccessesCountsQuery>;
export type EdmDocumentationAccessesCountsLazyQueryHookResult = ReturnType<typeof useEdmDocumentationAccessesCountsLazyQuery>;
export type EdmDocumentationAccessesCountsSuspenseQueryHookResult = ReturnType<typeof useEdmDocumentationAccessesCountsSuspenseQuery>;
export type EdmDocumentationAccessesCountsQueryResult = ApolloReactCommon.QueryResult<EdmDocumentationAccessesCountsQuery, EdmDocumentationAccessesCountsQueryVariables>;
export function refetchEdmDocumentationAccessesCountsQuery(variables: EdmDocumentationAccessesCountsQueryVariables) {
      return { query: EdmDocumentationAccessesCountsDocument, variables: variables }
    }
export const EdmDocumentationOperationalScopeCountsDocument = gql`
    query edmDocumentationOperationalScopeCounts($documentationId: String!, $includeAssets: Boolean!, $includeAreas: Boolean!, $includeTasks: Boolean!, $isViewLocked: Boolean! = false) {
  assets: assets(
    filters: [{documentationsId: {predicate: {eq: $documentationId}}}]
    page: 1
    limit: 1
  ) @include(if: $includeAssets) {
    metadata {
      totalCount
    }
  }
  siteAreas: siteAreas(
    filters: [{documentationsId: {predicate: {eq: $documentationId}}}]
    page: 1
    limit: 1
  ) @include(if: $includeAreas) @skip(if: $isViewLocked) {
    metadata {
      totalCount
    }
  }
  formTemplates: formTemplates(
    filters: [{documentationsId: {predicate: {eq: $documentationId}}}]
    scopeName: ACTIVE
    page: 1
    limit: 1
  ) @include(if: $includeTasks) @skip(if: $isViewLocked) {
    metadata {
      totalCount
    }
  }
  tasks: tasks(
    filters: [{documentationsId: {predicate: {eq: $documentationId}}}]
    scope: {name: CURRENT}
    page: 1
    limit: 1
  ) @include(if: $includeTasks) @skip(if: $isViewLocked) {
    metadata {
      totalCount
    }
  }
}
    `;

/**
 * __useEdmDocumentationOperationalScopeCountsQuery__
 *
 * To run a query within a React component, call `useEdmDocumentationOperationalScopeCountsQuery` and pass it any options that fit your needs.
 * When your component renders, `useEdmDocumentationOperationalScopeCountsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEdmDocumentationOperationalScopeCountsQuery({
 *   variables: {
 *      documentationId: // value for 'documentationId'
 *      includeAssets: // value for 'includeAssets'
 *      includeAreas: // value for 'includeAreas'
 *      includeTasks: // value for 'includeTasks'
 *      isViewLocked: // value for 'isViewLocked'
 *   },
 * });
 */
export function useEdmDocumentationOperationalScopeCountsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<EdmDocumentationOperationalScopeCountsQuery, EdmDocumentationOperationalScopeCountsQueryVariables> & ({ variables: EdmDocumentationOperationalScopeCountsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<EdmDocumentationOperationalScopeCountsQuery, EdmDocumentationOperationalScopeCountsQueryVariables>(EdmDocumentationOperationalScopeCountsDocument, options);
      }
export function useEdmDocumentationOperationalScopeCountsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<EdmDocumentationOperationalScopeCountsQuery, EdmDocumentationOperationalScopeCountsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<EdmDocumentationOperationalScopeCountsQuery, EdmDocumentationOperationalScopeCountsQueryVariables>(EdmDocumentationOperationalScopeCountsDocument, options);
        }
// @ts-ignore
export function useEdmDocumentationOperationalScopeCountsSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<EdmDocumentationOperationalScopeCountsQuery, EdmDocumentationOperationalScopeCountsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<EdmDocumentationOperationalScopeCountsQuery, EdmDocumentationOperationalScopeCountsQueryVariables>;
// @ts-ignore
export function useEdmDocumentationOperationalScopeCountsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<EdmDocumentationOperationalScopeCountsQuery, EdmDocumentationOperationalScopeCountsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<EdmDocumentationOperationalScopeCountsQuery | undefined, EdmDocumentationOperationalScopeCountsQueryVariables>;
export function useEdmDocumentationOperationalScopeCountsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<EdmDocumentationOperationalScopeCountsQuery, EdmDocumentationOperationalScopeCountsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          // @ts-ignore
          return ApolloReactHooks.useSuspenseQuery<EdmDocumentationOperationalScopeCountsQuery, EdmDocumentationOperationalScopeCountsQueryVariables>(EdmDocumentationOperationalScopeCountsDocument, options);
        }
export type EdmDocumentationOperationalScopeCountsQueryHookResult = ReturnType<typeof useEdmDocumentationOperationalScopeCountsQuery>;
export type EdmDocumentationOperationalScopeCountsLazyQueryHookResult = ReturnType<typeof useEdmDocumentationOperationalScopeCountsLazyQuery>;
export type EdmDocumentationOperationalScopeCountsSuspenseQueryHookResult = ReturnType<typeof useEdmDocumentationOperationalScopeCountsSuspenseQuery>;
export type EdmDocumentationOperationalScopeCountsQueryResult = ApolloReactCommon.QueryResult<EdmDocumentationOperationalScopeCountsQuery, EdmDocumentationOperationalScopeCountsQueryVariables>;
export function refetchEdmDocumentationOperationalScopeCountsQuery(variables: EdmDocumentationOperationalScopeCountsQueryVariables) {
      return { query: EdmDocumentationOperationalScopeCountsDocument, variables: variables }
    }
export const EdmDocumentationHistoryCountersDocument = gql`
    query edmDocumentationHistoryCounters($documentationId: ID!, $documentationIdFilter: String!, $isViewLocked: Boolean! = false) {
  versions: documentationVersions(
    documentationId: $documentationId
    page: 1
    limit: 1
  ) {
    metadata {
      totalCount
    }
  }
  views: documentationVersionViews(
    filters: [{documentationId: {predicate: {eq: $documentationIdFilter}}}]
    page: 1
    limit: 1
  ) @skip(if: $isViewLocked) {
    metadata {
      totalCount
    }
  }
}
    `;

/**
 * __useEdmDocumentationHistoryCountersQuery__
 *
 * To run a query within a React component, call `useEdmDocumentationHistoryCountersQuery` and pass it any options that fit your needs.
 * When your component renders, `useEdmDocumentationHistoryCountersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEdmDocumentationHistoryCountersQuery({
 *   variables: {
 *      documentationId: // value for 'documentationId'
 *      documentationIdFilter: // value for 'documentationIdFilter'
 *      isViewLocked: // value for 'isViewLocked'
 *   },
 * });
 */
export function useEdmDocumentationHistoryCountersQuery(baseOptions: ApolloReactHooks.QueryHookOptions<EdmDocumentationHistoryCountersQuery, EdmDocumentationHistoryCountersQueryVariables> & ({ variables: EdmDocumentationHistoryCountersQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<EdmDocumentationHistoryCountersQuery, EdmDocumentationHistoryCountersQueryVariables>(EdmDocumentationHistoryCountersDocument, options);
      }
export function useEdmDocumentationHistoryCountersLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<EdmDocumentationHistoryCountersQuery, EdmDocumentationHistoryCountersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<EdmDocumentationHistoryCountersQuery, EdmDocumentationHistoryCountersQueryVariables>(EdmDocumentationHistoryCountersDocument, options);
        }
// @ts-ignore
export function useEdmDocumentationHistoryCountersSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<EdmDocumentationHistoryCountersQuery, EdmDocumentationHistoryCountersQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<EdmDocumentationHistoryCountersQuery, EdmDocumentationHistoryCountersQueryVariables>;
// @ts-ignore
export function useEdmDocumentationHistoryCountersSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<EdmDocumentationHistoryCountersQuery, EdmDocumentationHistoryCountersQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<EdmDocumentationHistoryCountersQuery | undefined, EdmDocumentationHistoryCountersQueryVariables>;
export function useEdmDocumentationHistoryCountersSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<EdmDocumentationHistoryCountersQuery, EdmDocumentationHistoryCountersQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          // @ts-ignore
          return ApolloReactHooks.useSuspenseQuery<EdmDocumentationHistoryCountersQuery, EdmDocumentationHistoryCountersQueryVariables>(EdmDocumentationHistoryCountersDocument, options);
        }
export type EdmDocumentationHistoryCountersQueryHookResult = ReturnType<typeof useEdmDocumentationHistoryCountersQuery>;
export type EdmDocumentationHistoryCountersLazyQueryHookResult = ReturnType<typeof useEdmDocumentationHistoryCountersLazyQuery>;
export type EdmDocumentationHistoryCountersSuspenseQueryHookResult = ReturnType<typeof useEdmDocumentationHistoryCountersSuspenseQuery>;
export type EdmDocumentationHistoryCountersQueryResult = ApolloReactCommon.QueryResult<EdmDocumentationHistoryCountersQuery, EdmDocumentationHistoryCountersQueryVariables>;
export function refetchEdmDocumentationHistoryCountersQuery(variables: EdmDocumentationHistoryCountersQueryVariables) {
      return { query: EdmDocumentationHistoryCountersDocument, variables: variables }
    }
export const EdmDocumentationVersionsDocument = gql`
    query edmDocumentationVersions($documentationId: ID!, $page: Int, $limit: Int, $sorts: DocumentationVersionSortInputObject) {
  data: documentationVersions(
    documentationId: $documentationId
    page: $page
    limit: $limit
    sorts: $sorts
  ) {
    collection {
      id
      versionNumber
      notes
      createdAt
      createdBy {
        id
        firstName
        lastName
        avatarAttached {
          ...attachmentFragment
        }
      }
      attachmentAttached {
        ...attachmentFragment
      }
    }
    metadata {
      ...metadataFragment
    }
  }
}
    ${AttachmentFragmentFragmentDoc}
${MetadataFragmentFragmentDoc}`;

/**
 * __useEdmDocumentationVersionsQuery__
 *
 * To run a query within a React component, call `useEdmDocumentationVersionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useEdmDocumentationVersionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEdmDocumentationVersionsQuery({
 *   variables: {
 *      documentationId: // value for 'documentationId'
 *      page: // value for 'page'
 *      limit: // value for 'limit'
 *      sorts: // value for 'sorts'
 *   },
 * });
 */
export function useEdmDocumentationVersionsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<EdmDocumentationVersionsQuery, EdmDocumentationVersionsQueryVariables> & ({ variables: EdmDocumentationVersionsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<EdmDocumentationVersionsQuery, EdmDocumentationVersionsQueryVariables>(EdmDocumentationVersionsDocument, options);
      }
export function useEdmDocumentationVersionsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<EdmDocumentationVersionsQuery, EdmDocumentationVersionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<EdmDocumentationVersionsQuery, EdmDocumentationVersionsQueryVariables>(EdmDocumentationVersionsDocument, options);
        }
// @ts-ignore
export function useEdmDocumentationVersionsSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<EdmDocumentationVersionsQuery, EdmDocumentationVersionsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<EdmDocumentationVersionsQuery, EdmDocumentationVersionsQueryVariables>;
// @ts-ignore
export function useEdmDocumentationVersionsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<EdmDocumentationVersionsQuery, EdmDocumentationVersionsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<EdmDocumentationVersionsQuery | undefined, EdmDocumentationVersionsQueryVariables>;
export function useEdmDocumentationVersionsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<EdmDocumentationVersionsQuery, EdmDocumentationVersionsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          // @ts-ignore
          return ApolloReactHooks.useSuspenseQuery<EdmDocumentationVersionsQuery, EdmDocumentationVersionsQueryVariables>(EdmDocumentationVersionsDocument, options);
        }
export type EdmDocumentationVersionsQueryHookResult = ReturnType<typeof useEdmDocumentationVersionsQuery>;
export type EdmDocumentationVersionsLazyQueryHookResult = ReturnType<typeof useEdmDocumentationVersionsLazyQuery>;
export type EdmDocumentationVersionsSuspenseQueryHookResult = ReturnType<typeof useEdmDocumentationVersionsSuspenseQuery>;
export type EdmDocumentationVersionsQueryResult = ApolloReactCommon.QueryResult<EdmDocumentationVersionsQuery, EdmDocumentationVersionsQueryVariables>;
export function refetchEdmDocumentationVersionsQuery(variables: EdmDocumentationVersionsQueryVariables) {
      return { query: EdmDocumentationVersionsDocument, variables: variables }
    }
export const EdmDocumentationCategoriesDocument = gql`
    query edmDocumentationCategories($page: Int, $limit: Int, $sorts: DocumentationCategorySortInputObject, $filters: [DocumentationCategoryFilterInputObject!]) {
  data: documentationCategories(
    page: $page
    limit: $limit
    sorts: $sorts
    filters: $filters
  ) {
    collection {
      ...edmDocumentationCategoryFragment
      description
      documentationsCount
      canDestroy {
        ...authorizationResultFragment
      }
    }
    metadata {
      ...metadataFragment
    }
  }
}
    ${EdmDocumentationCategoryFragmentFragmentDoc}
${AuthorizationResultFragmentFragmentDoc}
${MetadataFragmentFragmentDoc}`;

/**
 * __useEdmDocumentationCategoriesQuery__
 *
 * To run a query within a React component, call `useEdmDocumentationCategoriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useEdmDocumentationCategoriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEdmDocumentationCategoriesQuery({
 *   variables: {
 *      page: // value for 'page'
 *      limit: // value for 'limit'
 *      sorts: // value for 'sorts'
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useEdmDocumentationCategoriesQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<EdmDocumentationCategoriesQuery, EdmDocumentationCategoriesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<EdmDocumentationCategoriesQuery, EdmDocumentationCategoriesQueryVariables>(EdmDocumentationCategoriesDocument, options);
      }
export function useEdmDocumentationCategoriesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<EdmDocumentationCategoriesQuery, EdmDocumentationCategoriesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<EdmDocumentationCategoriesQuery, EdmDocumentationCategoriesQueryVariables>(EdmDocumentationCategoriesDocument, options);
        }
// @ts-ignore
export function useEdmDocumentationCategoriesSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<EdmDocumentationCategoriesQuery, EdmDocumentationCategoriesQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<EdmDocumentationCategoriesQuery, EdmDocumentationCategoriesQueryVariables>;
// @ts-ignore
export function useEdmDocumentationCategoriesSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<EdmDocumentationCategoriesQuery, EdmDocumentationCategoriesQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<EdmDocumentationCategoriesQuery | undefined, EdmDocumentationCategoriesQueryVariables>;
export function useEdmDocumentationCategoriesSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<EdmDocumentationCategoriesQuery, EdmDocumentationCategoriesQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          // @ts-ignore
          return ApolloReactHooks.useSuspenseQuery<EdmDocumentationCategoriesQuery, EdmDocumentationCategoriesQueryVariables>(EdmDocumentationCategoriesDocument, options);
        }
export type EdmDocumentationCategoriesQueryHookResult = ReturnType<typeof useEdmDocumentationCategoriesQuery>;
export type EdmDocumentationCategoriesLazyQueryHookResult = ReturnType<typeof useEdmDocumentationCategoriesLazyQuery>;
export type EdmDocumentationCategoriesSuspenseQueryHookResult = ReturnType<typeof useEdmDocumentationCategoriesSuspenseQuery>;
export type EdmDocumentationCategoriesQueryResult = ApolloReactCommon.QueryResult<EdmDocumentationCategoriesQuery, EdmDocumentationCategoriesQueryVariables>;
export function refetchEdmDocumentationCategoriesQuery(variables?: EdmDocumentationCategoriesQueryVariables) {
      return { query: EdmDocumentationCategoriesDocument, variables: variables }
    }
export const EdmDocumentationCategoriesSearchListDocument = gql`
    query edmDocumentationCategoriesSearchList($page: Int, $limit: Int, $sorts: DocumentationCategorySortInputObject, $filters: [DocumentationCategoryFilterInputObject!]) {
  data: documentationCategories(
    page: $page
    limit: $limit
    sorts: $sorts
    filters: $filters
  ) {
    collection {
      ...edmDocumentationCategoryFragment
    }
    metadata {
      ...metadataFragment
    }
  }
}
    ${EdmDocumentationCategoryFragmentFragmentDoc}
${MetadataFragmentFragmentDoc}`;

/**
 * __useEdmDocumentationCategoriesSearchListQuery__
 *
 * To run a query within a React component, call `useEdmDocumentationCategoriesSearchListQuery` and pass it any options that fit your needs.
 * When your component renders, `useEdmDocumentationCategoriesSearchListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEdmDocumentationCategoriesSearchListQuery({
 *   variables: {
 *      page: // value for 'page'
 *      limit: // value for 'limit'
 *      sorts: // value for 'sorts'
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useEdmDocumentationCategoriesSearchListQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<EdmDocumentationCategoriesSearchListQuery, EdmDocumentationCategoriesSearchListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<EdmDocumentationCategoriesSearchListQuery, EdmDocumentationCategoriesSearchListQueryVariables>(EdmDocumentationCategoriesSearchListDocument, options);
      }
export function useEdmDocumentationCategoriesSearchListLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<EdmDocumentationCategoriesSearchListQuery, EdmDocumentationCategoriesSearchListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<EdmDocumentationCategoriesSearchListQuery, EdmDocumentationCategoriesSearchListQueryVariables>(EdmDocumentationCategoriesSearchListDocument, options);
        }
// @ts-ignore
export function useEdmDocumentationCategoriesSearchListSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<EdmDocumentationCategoriesSearchListQuery, EdmDocumentationCategoriesSearchListQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<EdmDocumentationCategoriesSearchListQuery, EdmDocumentationCategoriesSearchListQueryVariables>;
// @ts-ignore
export function useEdmDocumentationCategoriesSearchListSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<EdmDocumentationCategoriesSearchListQuery, EdmDocumentationCategoriesSearchListQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<EdmDocumentationCategoriesSearchListQuery | undefined, EdmDocumentationCategoriesSearchListQueryVariables>;
export function useEdmDocumentationCategoriesSearchListSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<EdmDocumentationCategoriesSearchListQuery, EdmDocumentationCategoriesSearchListQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          // @ts-ignore
          return ApolloReactHooks.useSuspenseQuery<EdmDocumentationCategoriesSearchListQuery, EdmDocumentationCategoriesSearchListQueryVariables>(EdmDocumentationCategoriesSearchListDocument, options);
        }
export type EdmDocumentationCategoriesSearchListQueryHookResult = ReturnType<typeof useEdmDocumentationCategoriesSearchListQuery>;
export type EdmDocumentationCategoriesSearchListLazyQueryHookResult = ReturnType<typeof useEdmDocumentationCategoriesSearchListLazyQuery>;
export type EdmDocumentationCategoriesSearchListSuspenseQueryHookResult = ReturnType<typeof useEdmDocumentationCategoriesSearchListSuspenseQuery>;
export type EdmDocumentationCategoriesSearchListQueryResult = ApolloReactCommon.QueryResult<EdmDocumentationCategoriesSearchListQuery, EdmDocumentationCategoriesSearchListQueryVariables>;
export function refetchEdmDocumentationCategoriesSearchListQuery(variables?: EdmDocumentationCategoriesSearchListQueryVariables) {
      return { query: EdmDocumentationCategoriesSearchListDocument, variables: variables }
    }
export const EdmDocumentationCategoryDocument = gql`
    query edmDocumentationCategory($id: ID!) {
  data: documentationCategory(id: $id) {
    ...edmDocumentationCategoryFragment
    description
  }
}
    ${EdmDocumentationCategoryFragmentFragmentDoc}`;

/**
 * __useEdmDocumentationCategoryQuery__
 *
 * To run a query within a React component, call `useEdmDocumentationCategoryQuery` and pass it any options that fit your needs.
 * When your component renders, `useEdmDocumentationCategoryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEdmDocumentationCategoryQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useEdmDocumentationCategoryQuery(baseOptions: ApolloReactHooks.QueryHookOptions<EdmDocumentationCategoryQuery, EdmDocumentationCategoryQueryVariables> & ({ variables: EdmDocumentationCategoryQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<EdmDocumentationCategoryQuery, EdmDocumentationCategoryQueryVariables>(EdmDocumentationCategoryDocument, options);
      }
export function useEdmDocumentationCategoryLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<EdmDocumentationCategoryQuery, EdmDocumentationCategoryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<EdmDocumentationCategoryQuery, EdmDocumentationCategoryQueryVariables>(EdmDocumentationCategoryDocument, options);
        }
// @ts-ignore
export function useEdmDocumentationCategorySuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<EdmDocumentationCategoryQuery, EdmDocumentationCategoryQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<EdmDocumentationCategoryQuery, EdmDocumentationCategoryQueryVariables>;
// @ts-ignore
export function useEdmDocumentationCategorySuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<EdmDocumentationCategoryQuery, EdmDocumentationCategoryQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<EdmDocumentationCategoryQuery | undefined, EdmDocumentationCategoryQueryVariables>;
export function useEdmDocumentationCategorySuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<EdmDocumentationCategoryQuery, EdmDocumentationCategoryQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          // @ts-ignore
          return ApolloReactHooks.useSuspenseQuery<EdmDocumentationCategoryQuery, EdmDocumentationCategoryQueryVariables>(EdmDocumentationCategoryDocument, options);
        }
export type EdmDocumentationCategoryQueryHookResult = ReturnType<typeof useEdmDocumentationCategoryQuery>;
export type EdmDocumentationCategoryLazyQueryHookResult = ReturnType<typeof useEdmDocumentationCategoryLazyQuery>;
export type EdmDocumentationCategorySuspenseQueryHookResult = ReturnType<typeof useEdmDocumentationCategorySuspenseQuery>;
export type EdmDocumentationCategoryQueryResult = ApolloReactCommon.QueryResult<EdmDocumentationCategoryQuery, EdmDocumentationCategoryQueryVariables>;
export function refetchEdmDocumentationCategoryQuery(variables: EdmDocumentationCategoryQueryVariables) {
      return { query: EdmDocumentationCategoryDocument, variables: variables }
    }
export const EdmDocumentationCreateDocument = gql`
    mutation edmDocumentationCreate($attributes: DocumentationCreateInputObject!, $isViewLocked: Boolean! = false) {
  data: documentationCreate(input: {attributes: $attributes}) {
    ...edmDocumentationBaseFragment
    ...edmDocumentationPremiumFragment @skip(if: $isViewLocked)
  }
}
    ${EdmDocumentationBaseFragmentFragmentDoc}
${AttachmentFragmentFragmentDoc}
${AuthorizationResultFragmentFragmentDoc}
${EdmDocumentationPremiumFragmentFragmentDoc}
${EdmDocumentationCategoryFragmentFragmentDoc}`;

/**
 * __useEdmDocumentationCreateMutation__
 *
 * To run a mutation, you first call `useEdmDocumentationCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEdmDocumentationCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [edmDocumentationCreateMutation, { data, loading, error }] = useEdmDocumentationCreateMutation({
 *   variables: {
 *      attributes: // value for 'attributes'
 *      isViewLocked: // value for 'isViewLocked'
 *   },
 * });
 */
export function useEdmDocumentationCreateMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<EdmDocumentationCreateMutation, EdmDocumentationCreateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<EdmDocumentationCreateMutation, EdmDocumentationCreateMutationVariables>(EdmDocumentationCreateDocument, options);
      }
export type EdmDocumentationCreateMutationHookResult = ReturnType<typeof useEdmDocumentationCreateMutation>;
export type EdmDocumentationCreateMutationResult = ApolloReactCommon.MutationResult<EdmDocumentationCreateMutation>;
export const EdmDocumentationUpdateDocument = gql`
    mutation edmDocumentationUpdate($id: ID!, $attributes: DocumentationUpdateInputObject!, $isViewLocked: Boolean! = false, $isAiDetectionEnabled: Boolean! = false) {
  data: documentationUpdate(input: {id: $id, attributes: $attributes}) {
    ...edmDocumentationBaseFragment
    ...edmDocumentationPremiumFragment @skip(if: $isViewLocked)
    ...edmDocumentationAiDetectionFragment @include(if: $isAiDetectionEnabled)
    description
  }
}
    ${EdmDocumentationBaseFragmentFragmentDoc}
${AttachmentFragmentFragmentDoc}
${AuthorizationResultFragmentFragmentDoc}
${EdmDocumentationPremiumFragmentFragmentDoc}
${EdmDocumentationCategoryFragmentFragmentDoc}
${EdmDocumentationAiDetectionFragmentFragmentDoc}`;

/**
 * __useEdmDocumentationUpdateMutation__
 *
 * To run a mutation, you first call `useEdmDocumentationUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEdmDocumentationUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [edmDocumentationUpdateMutation, { data, loading, error }] = useEdmDocumentationUpdateMutation({
 *   variables: {
 *      id: // value for 'id'
 *      attributes: // value for 'attributes'
 *      isViewLocked: // value for 'isViewLocked'
 *      isAiDetectionEnabled: // value for 'isAiDetectionEnabled'
 *   },
 * });
 */
export function useEdmDocumentationUpdateMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<EdmDocumentationUpdateMutation, EdmDocumentationUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<EdmDocumentationUpdateMutation, EdmDocumentationUpdateMutationVariables>(EdmDocumentationUpdateDocument, options);
      }
export type EdmDocumentationUpdateMutationHookResult = ReturnType<typeof useEdmDocumentationUpdateMutation>;
export type EdmDocumentationUpdateMutationResult = ApolloReactCommon.MutationResult<EdmDocumentationUpdateMutation>;
export const EdmDocumentationBulkDestroyDocument = gql`
    mutation edmDocumentationBulkDestroy($ids: [ID!]!) {
  edmDocumentationBulkDestroy: documentationBulkDestroy(input: {ids: $ids})
}
    `;

/**
 * __useEdmDocumentationBulkDestroyMutation__
 *
 * To run a mutation, you first call `useEdmDocumentationBulkDestroyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEdmDocumentationBulkDestroyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [edmDocumentationBulkDestroyMutation, { data, loading, error }] = useEdmDocumentationBulkDestroyMutation({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useEdmDocumentationBulkDestroyMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<EdmDocumentationBulkDestroyMutation, EdmDocumentationBulkDestroyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<EdmDocumentationBulkDestroyMutation, EdmDocumentationBulkDestroyMutationVariables>(EdmDocumentationBulkDestroyDocument, options);
      }
export type EdmDocumentationBulkDestroyMutationHookResult = ReturnType<typeof useEdmDocumentationBulkDestroyMutation>;
export type EdmDocumentationBulkDestroyMutationResult = ApolloReactCommon.MutationResult<EdmDocumentationBulkDestroyMutation>;
export const EdmDocumentationVersionCreateDocument = gql`
    mutation edmDocumentationVersionCreate($documentationId: ID!, $attributes: DocumentationVersionCreateInputObject!) {
  data: documentationVersionCreate(
    input: {documentationId: $documentationId, attributes: $attributes}
  ) {
    id
    versionNumber
    notes
    createdAt
    attachmentAttached {
      ...attachmentFragment
    }
  }
}
    ${AttachmentFragmentFragmentDoc}`;

/**
 * __useEdmDocumentationVersionCreateMutation__
 *
 * To run a mutation, you first call `useEdmDocumentationVersionCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEdmDocumentationVersionCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [edmDocumentationVersionCreateMutation, { data, loading, error }] = useEdmDocumentationVersionCreateMutation({
 *   variables: {
 *      documentationId: // value for 'documentationId'
 *      attributes: // value for 'attributes'
 *   },
 * });
 */
export function useEdmDocumentationVersionCreateMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<EdmDocumentationVersionCreateMutation, EdmDocumentationVersionCreateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<EdmDocumentationVersionCreateMutation, EdmDocumentationVersionCreateMutationVariables>(EdmDocumentationVersionCreateDocument, options);
      }
export type EdmDocumentationVersionCreateMutationHookResult = ReturnType<typeof useEdmDocumentationVersionCreateMutation>;
export type EdmDocumentationVersionCreateMutationResult = ApolloReactCommon.MutationResult<EdmDocumentationVersionCreateMutation>;
export const EdmDocumentationCategoryCreateDocument = gql`
    mutation edmDocumentationCategoryCreate($attributes: DocumentationCategoryCreateInputObject!) {
  data: documentationCategoryCreate(input: {attributes: $attributes}) {
    ...edmDocumentationCategoryFragment
  }
}
    ${EdmDocumentationCategoryFragmentFragmentDoc}`;

/**
 * __useEdmDocumentationCategoryCreateMutation__
 *
 * To run a mutation, you first call `useEdmDocumentationCategoryCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEdmDocumentationCategoryCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [edmDocumentationCategoryCreateMutation, { data, loading, error }] = useEdmDocumentationCategoryCreateMutation({
 *   variables: {
 *      attributes: // value for 'attributes'
 *   },
 * });
 */
export function useEdmDocumentationCategoryCreateMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<EdmDocumentationCategoryCreateMutation, EdmDocumentationCategoryCreateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<EdmDocumentationCategoryCreateMutation, EdmDocumentationCategoryCreateMutationVariables>(EdmDocumentationCategoryCreateDocument, options);
      }
export type EdmDocumentationCategoryCreateMutationHookResult = ReturnType<typeof useEdmDocumentationCategoryCreateMutation>;
export type EdmDocumentationCategoryCreateMutationResult = ApolloReactCommon.MutationResult<EdmDocumentationCategoryCreateMutation>;
export const EdmDocumentationCategoryUpdateDocument = gql`
    mutation edmDocumentationCategoryUpdate($id: ID!, $attributes: DocumentationCategoryUpdateInputObject!) {
  data: documentationCategoryUpdate(input: {id: $id, attributes: $attributes}) {
    ...edmDocumentationCategoryFragment
    description
  }
}
    ${EdmDocumentationCategoryFragmentFragmentDoc}`;

/**
 * __useEdmDocumentationCategoryUpdateMutation__
 *
 * To run a mutation, you first call `useEdmDocumentationCategoryUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEdmDocumentationCategoryUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [edmDocumentationCategoryUpdateMutation, { data, loading, error }] = useEdmDocumentationCategoryUpdateMutation({
 *   variables: {
 *      id: // value for 'id'
 *      attributes: // value for 'attributes'
 *   },
 * });
 */
export function useEdmDocumentationCategoryUpdateMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<EdmDocumentationCategoryUpdateMutation, EdmDocumentationCategoryUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<EdmDocumentationCategoryUpdateMutation, EdmDocumentationCategoryUpdateMutationVariables>(EdmDocumentationCategoryUpdateDocument, options);
      }
export type EdmDocumentationCategoryUpdateMutationHookResult = ReturnType<typeof useEdmDocumentationCategoryUpdateMutation>;
export type EdmDocumentationCategoryUpdateMutationResult = ApolloReactCommon.MutationResult<EdmDocumentationCategoryUpdateMutation>;
export const EdmDocumentationCategoryDestroyDocument = gql`
    mutation edmDocumentationCategoryDestroy($id: ID!) {
  documentationCategoryDestroy(input: {id: $id})
}
    `;

/**
 * __useEdmDocumentationCategoryDestroyMutation__
 *
 * To run a mutation, you first call `useEdmDocumentationCategoryDestroyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEdmDocumentationCategoryDestroyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [edmDocumentationCategoryDestroyMutation, { data, loading, error }] = useEdmDocumentationCategoryDestroyMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useEdmDocumentationCategoryDestroyMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<EdmDocumentationCategoryDestroyMutation, EdmDocumentationCategoryDestroyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<EdmDocumentationCategoryDestroyMutation, EdmDocumentationCategoryDestroyMutationVariables>(EdmDocumentationCategoryDestroyDocument, options);
      }
export type EdmDocumentationCategoryDestroyMutationHookResult = ReturnType<typeof useEdmDocumentationCategoryDestroyMutation>;
export type EdmDocumentationCategoryDestroyMutationResult = ApolloReactCommon.MutationResult<EdmDocumentationCategoryDestroyMutation>;
export const EdmDocumentationBulkUpdateValidationStatusDocument = gql`
    mutation edmDocumentationBulkUpdateValidationStatus($ids: [ID!]!, $attributes: DocumentationUpdateValidationStatusInputObject!) {
  documentationBulkUpdateValidationStatus(
    input: {ids: $ids, attributes: $attributes}
  )
}
    `;

/**
 * __useEdmDocumentationBulkUpdateValidationStatusMutation__
 *
 * To run a mutation, you first call `useEdmDocumentationBulkUpdateValidationStatusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEdmDocumentationBulkUpdateValidationStatusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [edmDocumentationBulkUpdateValidationStatusMutation, { data, loading, error }] = useEdmDocumentationBulkUpdateValidationStatusMutation({
 *   variables: {
 *      ids: // value for 'ids'
 *      attributes: // value for 'attributes'
 *   },
 * });
 */
export function useEdmDocumentationBulkUpdateValidationStatusMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<EdmDocumentationBulkUpdateValidationStatusMutation, EdmDocumentationBulkUpdateValidationStatusMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<EdmDocumentationBulkUpdateValidationStatusMutation, EdmDocumentationBulkUpdateValidationStatusMutationVariables>(EdmDocumentationBulkUpdateValidationStatusDocument, options);
      }
export type EdmDocumentationBulkUpdateValidationStatusMutationHookResult = ReturnType<typeof useEdmDocumentationBulkUpdateValidationStatusMutation>;
export type EdmDocumentationBulkUpdateValidationStatusMutationResult = ApolloReactCommon.MutationResult<EdmDocumentationBulkUpdateValidationStatusMutation>;
export const EdmDocumentationBulkEditDocument = gql`
    mutation edmDocumentationBulkEdit($ids: [ID!]!, $attributes: DocumentationBulkEditInputObject!) {
  documentationBulkEdit(input: {ids: $ids, attributes: $attributes})
}
    `;

/**
 * __useEdmDocumentationBulkEditMutation__
 *
 * To run a mutation, you first call `useEdmDocumentationBulkEditMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEdmDocumentationBulkEditMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [edmDocumentationBulkEditMutation, { data, loading, error }] = useEdmDocumentationBulkEditMutation({
 *   variables: {
 *      ids: // value for 'ids'
 *      attributes: // value for 'attributes'
 *   },
 * });
 */
export function useEdmDocumentationBulkEditMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<EdmDocumentationBulkEditMutation, EdmDocumentationBulkEditMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<EdmDocumentationBulkEditMutation, EdmDocumentationBulkEditMutationVariables>(EdmDocumentationBulkEditDocument, options);
      }
export type EdmDocumentationBulkEditMutationHookResult = ReturnType<typeof useEdmDocumentationBulkEditMutation>;
export type EdmDocumentationBulkEditMutationResult = ApolloReactCommon.MutationResult<EdmDocumentationBulkEditMutation>;
export const EdmDocumentationSkipRenewalDocument = gql`
    mutation edmDocumentationSkipRenewal($id: ID!) {
  data: documentationSkipRenewal(input: {id: $id}) {
    ...edmDocumentationFragment
  }
}
    ${EdmDocumentationFragmentFragmentDoc}
${EdmDocumentationBaseFragmentFragmentDoc}
${AttachmentFragmentFragmentDoc}
${AuthorizationResultFragmentFragmentDoc}
${EdmDocumentationPremiumFragmentFragmentDoc}
${EdmDocumentationCategoryFragmentFragmentDoc}`;

/**
 * __useEdmDocumentationSkipRenewalMutation__
 *
 * To run a mutation, you first call `useEdmDocumentationSkipRenewalMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEdmDocumentationSkipRenewalMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [edmDocumentationSkipRenewalMutation, { data, loading, error }] = useEdmDocumentationSkipRenewalMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useEdmDocumentationSkipRenewalMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<EdmDocumentationSkipRenewalMutation, EdmDocumentationSkipRenewalMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<EdmDocumentationSkipRenewalMutation, EdmDocumentationSkipRenewalMutationVariables>(EdmDocumentationSkipRenewalDocument, options);
      }
export type EdmDocumentationSkipRenewalMutationHookResult = ReturnType<typeof useEdmDocumentationSkipRenewalMutation>;
export type EdmDocumentationSkipRenewalMutationResult = ApolloReactCommon.MutationResult<EdmDocumentationSkipRenewalMutation>;
export const EdmDocumentationImportCreateDocument = gql`
    mutation edmDocumentationImportCreate($attributes: DocumentationImportCreateInputObject!) {
  data: documentationImportCreate(input: {attributes: $attributes}) {
    id
    backgroundJob {
      ...backgroundJobTreeFragment
    }
  }
}
    ${BackgroundJobTreeFragmentFragmentDoc}
${BackgroundJobFragmentFragmentDoc}
${AuthorizationResultFragmentFragmentDoc}`;

/**
 * __useEdmDocumentationImportCreateMutation__
 *
 * To run a mutation, you first call `useEdmDocumentationImportCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEdmDocumentationImportCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [edmDocumentationImportCreateMutation, { data, loading, error }] = useEdmDocumentationImportCreateMutation({
 *   variables: {
 *      attributes: // value for 'attributes'
 *   },
 * });
 */
export function useEdmDocumentationImportCreateMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<EdmDocumentationImportCreateMutation, EdmDocumentationImportCreateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<EdmDocumentationImportCreateMutation, EdmDocumentationImportCreateMutationVariables>(EdmDocumentationImportCreateDocument, options);
      }
export type EdmDocumentationImportCreateMutationHookResult = ReturnType<typeof useEdmDocumentationImportCreateMutation>;
export type EdmDocumentationImportCreateMutationResult = ApolloReactCommon.MutationResult<EdmDocumentationImportCreateMutation>;
export const EdmDocumentationImportFtpPreviewDocument = gql`
    mutation edmDocumentationImportFtpPreview($attributes: DocumentationImportFtpConfigInputObject!) {
  data: documentationImportFtpPreview(input: {attributes: $attributes}) {
    totalFilesCount
    supportedFilesCount
    unsupportedFilesCount
    sampleFilenames
  }
}
    `;

/**
 * __useEdmDocumentationImportFtpPreviewMutation__
 *
 * To run a mutation, you first call `useEdmDocumentationImportFtpPreviewMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEdmDocumentationImportFtpPreviewMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [edmDocumentationImportFtpPreviewMutation, { data, loading, error }] = useEdmDocumentationImportFtpPreviewMutation({
 *   variables: {
 *      attributes: // value for 'attributes'
 *   },
 * });
 */
export function useEdmDocumentationImportFtpPreviewMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<EdmDocumentationImportFtpPreviewMutation, EdmDocumentationImportFtpPreviewMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<EdmDocumentationImportFtpPreviewMutation, EdmDocumentationImportFtpPreviewMutationVariables>(EdmDocumentationImportFtpPreviewDocument, options);
      }
export type EdmDocumentationImportFtpPreviewMutationHookResult = ReturnType<typeof useEdmDocumentationImportFtpPreviewMutation>;
export type EdmDocumentationImportFtpPreviewMutationResult = ApolloReactCommon.MutationResult<EdmDocumentationImportFtpPreviewMutation>;
export const EdmDocumentRenewalReminderTemplateDocument = gql`
    query edmDocumentRenewalReminderTemplate {
  data: documentRenewalReminderTemplate {
    ...edmDocumentRenewalReminderTemplateFragment
  }
}
    ${EdmDocumentRenewalReminderTemplateFragmentFragmentDoc}`;

/**
 * __useEdmDocumentRenewalReminderTemplateQuery__
 *
 * To run a query within a React component, call `useEdmDocumentRenewalReminderTemplateQuery` and pass it any options that fit your needs.
 * When your component renders, `useEdmDocumentRenewalReminderTemplateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEdmDocumentRenewalReminderTemplateQuery({
 *   variables: {
 *   },
 * });
 */
export function useEdmDocumentRenewalReminderTemplateQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<EdmDocumentRenewalReminderTemplateQuery, EdmDocumentRenewalReminderTemplateQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<EdmDocumentRenewalReminderTemplateQuery, EdmDocumentRenewalReminderTemplateQueryVariables>(EdmDocumentRenewalReminderTemplateDocument, options);
      }
export function useEdmDocumentRenewalReminderTemplateLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<EdmDocumentRenewalReminderTemplateQuery, EdmDocumentRenewalReminderTemplateQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<EdmDocumentRenewalReminderTemplateQuery, EdmDocumentRenewalReminderTemplateQueryVariables>(EdmDocumentRenewalReminderTemplateDocument, options);
        }
// @ts-ignore
export function useEdmDocumentRenewalReminderTemplateSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<EdmDocumentRenewalReminderTemplateQuery, EdmDocumentRenewalReminderTemplateQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<EdmDocumentRenewalReminderTemplateQuery, EdmDocumentRenewalReminderTemplateQueryVariables>;
// @ts-ignore
export function useEdmDocumentRenewalReminderTemplateSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<EdmDocumentRenewalReminderTemplateQuery, EdmDocumentRenewalReminderTemplateQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<EdmDocumentRenewalReminderTemplateQuery | undefined, EdmDocumentRenewalReminderTemplateQueryVariables>;
export function useEdmDocumentRenewalReminderTemplateSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<EdmDocumentRenewalReminderTemplateQuery, EdmDocumentRenewalReminderTemplateQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          // @ts-ignore
          return ApolloReactHooks.useSuspenseQuery<EdmDocumentRenewalReminderTemplateQuery, EdmDocumentRenewalReminderTemplateQueryVariables>(EdmDocumentRenewalReminderTemplateDocument, options);
        }
export type EdmDocumentRenewalReminderTemplateQueryHookResult = ReturnType<typeof useEdmDocumentRenewalReminderTemplateQuery>;
export type EdmDocumentRenewalReminderTemplateLazyQueryHookResult = ReturnType<typeof useEdmDocumentRenewalReminderTemplateLazyQuery>;
export type EdmDocumentRenewalReminderTemplateSuspenseQueryHookResult = ReturnType<typeof useEdmDocumentRenewalReminderTemplateSuspenseQuery>;
export type EdmDocumentRenewalReminderTemplateQueryResult = ApolloReactCommon.QueryResult<EdmDocumentRenewalReminderTemplateQuery, EdmDocumentRenewalReminderTemplateQueryVariables>;
export function refetchEdmDocumentRenewalReminderTemplateQuery(variables?: EdmDocumentRenewalReminderTemplateQueryVariables) {
      return { query: EdmDocumentRenewalReminderTemplateDocument, variables: variables }
    }
export const EdmDocumentRenewalReminderTemplateUpdateDocument = gql`
    mutation edmDocumentRenewalReminderTemplateUpdate($attributes: DocumentRenewalReminderTemplateUpdateInputObject!) {
  data: documentRenewalReminderTemplateUpdate(input: {attributes: $attributes}) {
    ...edmDocumentRenewalReminderTemplateFragment
  }
}
    ${EdmDocumentRenewalReminderTemplateFragmentFragmentDoc}`;

/**
 * __useEdmDocumentRenewalReminderTemplateUpdateMutation__
 *
 * To run a mutation, you first call `useEdmDocumentRenewalReminderTemplateUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEdmDocumentRenewalReminderTemplateUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [edmDocumentRenewalReminderTemplateUpdateMutation, { data, loading, error }] = useEdmDocumentRenewalReminderTemplateUpdateMutation({
 *   variables: {
 *      attributes: // value for 'attributes'
 *   },
 * });
 */
export function useEdmDocumentRenewalReminderTemplateUpdateMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<EdmDocumentRenewalReminderTemplateUpdateMutation, EdmDocumentRenewalReminderTemplateUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<EdmDocumentRenewalReminderTemplateUpdateMutation, EdmDocumentRenewalReminderTemplateUpdateMutationVariables>(EdmDocumentRenewalReminderTemplateUpdateDocument, options);
      }
export type EdmDocumentRenewalReminderTemplateUpdateMutationHookResult = ReturnType<typeof useEdmDocumentRenewalReminderTemplateUpdateMutation>;
export type EdmDocumentRenewalReminderTemplateUpdateMutationResult = ApolloReactCommon.MutationResult<EdmDocumentRenewalReminderTemplateUpdateMutation>;
export const EdmDocumentationActivityHistoriesDocument = gql`
    query edmDocumentationActivityHistories($sourceableId: ID!, $sourceableType: HistorySourceableTypeEnum!, $scope: String, $page: Int, $limit: Int, $sorts: HistorySortInputObject) {
  data: histories(
    sourceableId: $sourceableId
    sourceableType: $sourceableType
    scope: $scope
    page: $page
    limit: $limit
    sorts: $sorts
  ) {
    collection {
      id
      kind
      system
      occurredAt
      user {
        id
        firstName
        lastName
        avatarAttached {
          ...attachmentFragment
        }
      }
      data {
        __typename
        ... on DocumentationHistoryData {
          versionNumber
          renewalDeadlineDate
          renewalOverdue
          renewalSkipped
          validationStatus
          approverId
        }
      }
    }
    metadata {
      ...metadataFragment
    }
  }
}
    ${AttachmentFragmentFragmentDoc}
${MetadataFragmentFragmentDoc}`;

/**
 * __useEdmDocumentationActivityHistoriesQuery__
 *
 * To run a query within a React component, call `useEdmDocumentationActivityHistoriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useEdmDocumentationActivityHistoriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEdmDocumentationActivityHistoriesQuery({
 *   variables: {
 *      sourceableId: // value for 'sourceableId'
 *      sourceableType: // value for 'sourceableType'
 *      scope: // value for 'scope'
 *      page: // value for 'page'
 *      limit: // value for 'limit'
 *      sorts: // value for 'sorts'
 *   },
 * });
 */
export function useEdmDocumentationActivityHistoriesQuery(baseOptions: ApolloReactHooks.QueryHookOptions<EdmDocumentationActivityHistoriesQuery, EdmDocumentationActivityHistoriesQueryVariables> & ({ variables: EdmDocumentationActivityHistoriesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<EdmDocumentationActivityHistoriesQuery, EdmDocumentationActivityHistoriesQueryVariables>(EdmDocumentationActivityHistoriesDocument, options);
      }
export function useEdmDocumentationActivityHistoriesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<EdmDocumentationActivityHistoriesQuery, EdmDocumentationActivityHistoriesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<EdmDocumentationActivityHistoriesQuery, EdmDocumentationActivityHistoriesQueryVariables>(EdmDocumentationActivityHistoriesDocument, options);
        }
// @ts-ignore
export function useEdmDocumentationActivityHistoriesSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<EdmDocumentationActivityHistoriesQuery, EdmDocumentationActivityHistoriesQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<EdmDocumentationActivityHistoriesQuery, EdmDocumentationActivityHistoriesQueryVariables>;
// @ts-ignore
export function useEdmDocumentationActivityHistoriesSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<EdmDocumentationActivityHistoriesQuery, EdmDocumentationActivityHistoriesQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<EdmDocumentationActivityHistoriesQuery | undefined, EdmDocumentationActivityHistoriesQueryVariables>;
export function useEdmDocumentationActivityHistoriesSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<EdmDocumentationActivityHistoriesQuery, EdmDocumentationActivityHistoriesQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          // @ts-ignore
          return ApolloReactHooks.useSuspenseQuery<EdmDocumentationActivityHistoriesQuery, EdmDocumentationActivityHistoriesQueryVariables>(EdmDocumentationActivityHistoriesDocument, options);
        }
export type EdmDocumentationActivityHistoriesQueryHookResult = ReturnType<typeof useEdmDocumentationActivityHistoriesQuery>;
export type EdmDocumentationActivityHistoriesLazyQueryHookResult = ReturnType<typeof useEdmDocumentationActivityHistoriesLazyQuery>;
export type EdmDocumentationActivityHistoriesSuspenseQueryHookResult = ReturnType<typeof useEdmDocumentationActivityHistoriesSuspenseQuery>;
export type EdmDocumentationActivityHistoriesQueryResult = ApolloReactCommon.QueryResult<EdmDocumentationActivityHistoriesQuery, EdmDocumentationActivityHistoriesQueryVariables>;
export function refetchEdmDocumentationActivityHistoriesQuery(variables: EdmDocumentationActivityHistoriesQueryVariables) {
      return { query: EdmDocumentationActivityHistoriesDocument, variables: variables }
    }
export const EdmDocumentationVersionViewsDocument = gql`
    query edmDocumentationVersionViews($filters: [DocumentationVersionViewFilterInputObject!], $sorts: DocumentationVersionViewSortInputObject, $page: Int, $limit: Int) {
  data: documentationVersionViews(
    filters: $filters
    sorts: $sorts
    page: $page
    limit: $limit
  ) {
    collection {
      id
      viewedAt
      readingDurationSeconds
      createdAt
      user {
        id
        firstName
        lastName
        avatarAttached {
          ...attachmentFragment
        }
      }
    }
    metadata {
      ...metadataFragment
    }
  }
}
    ${AttachmentFragmentFragmentDoc}
${MetadataFragmentFragmentDoc}`;

/**
 * __useEdmDocumentationVersionViewsQuery__
 *
 * To run a query within a React component, call `useEdmDocumentationVersionViewsQuery` and pass it any options that fit your needs.
 * When your component renders, `useEdmDocumentationVersionViewsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEdmDocumentationVersionViewsQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      sorts: // value for 'sorts'
 *      page: // value for 'page'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useEdmDocumentationVersionViewsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<EdmDocumentationVersionViewsQuery, EdmDocumentationVersionViewsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<EdmDocumentationVersionViewsQuery, EdmDocumentationVersionViewsQueryVariables>(EdmDocumentationVersionViewsDocument, options);
      }
export function useEdmDocumentationVersionViewsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<EdmDocumentationVersionViewsQuery, EdmDocumentationVersionViewsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<EdmDocumentationVersionViewsQuery, EdmDocumentationVersionViewsQueryVariables>(EdmDocumentationVersionViewsDocument, options);
        }
// @ts-ignore
export function useEdmDocumentationVersionViewsSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<EdmDocumentationVersionViewsQuery, EdmDocumentationVersionViewsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<EdmDocumentationVersionViewsQuery, EdmDocumentationVersionViewsQueryVariables>;
// @ts-ignore
export function useEdmDocumentationVersionViewsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<EdmDocumentationVersionViewsQuery, EdmDocumentationVersionViewsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<EdmDocumentationVersionViewsQuery | undefined, EdmDocumentationVersionViewsQueryVariables>;
export function useEdmDocumentationVersionViewsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<EdmDocumentationVersionViewsQuery, EdmDocumentationVersionViewsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          // @ts-ignore
          return ApolloReactHooks.useSuspenseQuery<EdmDocumentationVersionViewsQuery, EdmDocumentationVersionViewsQueryVariables>(EdmDocumentationVersionViewsDocument, options);
        }
export type EdmDocumentationVersionViewsQueryHookResult = ReturnType<typeof useEdmDocumentationVersionViewsQuery>;
export type EdmDocumentationVersionViewsLazyQueryHookResult = ReturnType<typeof useEdmDocumentationVersionViewsLazyQuery>;
export type EdmDocumentationVersionViewsSuspenseQueryHookResult = ReturnType<typeof useEdmDocumentationVersionViewsSuspenseQuery>;
export type EdmDocumentationVersionViewsQueryResult = ApolloReactCommon.QueryResult<EdmDocumentationVersionViewsQuery, EdmDocumentationVersionViewsQueryVariables>;
export function refetchEdmDocumentationVersionViewsQuery(variables?: EdmDocumentationVersionViewsQueryVariables) {
      return { query: EdmDocumentationVersionViewsDocument, variables: variables }
    }
export const EdmDocumentationsAnalyticsByDocumentDocument = gql`
    query edmDocumentationsAnalyticsByDocument($period: DateRangeInputObject!, $sorts: DocumentationAnalyticsSortInputObject, $filters: [DocumentationFilterInputObject!], $page: Int, $limit: Int) {
  data: documentationsAnalyticsByDocument(
    period: $period
    sorts: $sorts
    filters: $filters
    page: $page
    limit: $limit
  ) {
    collection {
      documentationId
      viewCount
      uniqueViews
      avgTime
      minTime
      maxTime
    }
    metadata {
      ...metadataFragment
    }
  }
}
    ${MetadataFragmentFragmentDoc}`;

/**
 * __useEdmDocumentationsAnalyticsByDocumentQuery__
 *
 * To run a query within a React component, call `useEdmDocumentationsAnalyticsByDocumentQuery` and pass it any options that fit your needs.
 * When your component renders, `useEdmDocumentationsAnalyticsByDocumentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEdmDocumentationsAnalyticsByDocumentQuery({
 *   variables: {
 *      period: // value for 'period'
 *      sorts: // value for 'sorts'
 *      filters: // value for 'filters'
 *      page: // value for 'page'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useEdmDocumentationsAnalyticsByDocumentQuery(baseOptions: ApolloReactHooks.QueryHookOptions<EdmDocumentationsAnalyticsByDocumentQuery, EdmDocumentationsAnalyticsByDocumentQueryVariables> & ({ variables: EdmDocumentationsAnalyticsByDocumentQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<EdmDocumentationsAnalyticsByDocumentQuery, EdmDocumentationsAnalyticsByDocumentQueryVariables>(EdmDocumentationsAnalyticsByDocumentDocument, options);
      }
export function useEdmDocumentationsAnalyticsByDocumentLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<EdmDocumentationsAnalyticsByDocumentQuery, EdmDocumentationsAnalyticsByDocumentQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<EdmDocumentationsAnalyticsByDocumentQuery, EdmDocumentationsAnalyticsByDocumentQueryVariables>(EdmDocumentationsAnalyticsByDocumentDocument, options);
        }
// @ts-ignore
export function useEdmDocumentationsAnalyticsByDocumentSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<EdmDocumentationsAnalyticsByDocumentQuery, EdmDocumentationsAnalyticsByDocumentQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<EdmDocumentationsAnalyticsByDocumentQuery, EdmDocumentationsAnalyticsByDocumentQueryVariables>;
// @ts-ignore
export function useEdmDocumentationsAnalyticsByDocumentSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<EdmDocumentationsAnalyticsByDocumentQuery, EdmDocumentationsAnalyticsByDocumentQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<EdmDocumentationsAnalyticsByDocumentQuery | undefined, EdmDocumentationsAnalyticsByDocumentQueryVariables>;
export function useEdmDocumentationsAnalyticsByDocumentSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<EdmDocumentationsAnalyticsByDocumentQuery, EdmDocumentationsAnalyticsByDocumentQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          // @ts-ignore
          return ApolloReactHooks.useSuspenseQuery<EdmDocumentationsAnalyticsByDocumentQuery, EdmDocumentationsAnalyticsByDocumentQueryVariables>(EdmDocumentationsAnalyticsByDocumentDocument, options);
        }
export type EdmDocumentationsAnalyticsByDocumentQueryHookResult = ReturnType<typeof useEdmDocumentationsAnalyticsByDocumentQuery>;
export type EdmDocumentationsAnalyticsByDocumentLazyQueryHookResult = ReturnType<typeof useEdmDocumentationsAnalyticsByDocumentLazyQuery>;
export type EdmDocumentationsAnalyticsByDocumentSuspenseQueryHookResult = ReturnType<typeof useEdmDocumentationsAnalyticsByDocumentSuspenseQuery>;
export type EdmDocumentationsAnalyticsByDocumentQueryResult = ApolloReactCommon.QueryResult<EdmDocumentationsAnalyticsByDocumentQuery, EdmDocumentationsAnalyticsByDocumentQueryVariables>;
export function refetchEdmDocumentationsAnalyticsByDocumentQuery(variables: EdmDocumentationsAnalyticsByDocumentQueryVariables) {
      return { query: EdmDocumentationsAnalyticsByDocumentDocument, variables: variables }
    }
export const EdmDocumentationsAnalyticsTrendDocument = gql`
    query edmDocumentationsAnalyticsTrend($period: DateRangeInputObject!, $periodGroupBy: PeriodGroupByEnum!, $filters: [DocumentationFilterInputObject!], $limit: Int) {
  data: documentationsAnalyticsTrend(
    period: $period
    periodGroupBy: $periodGroupBy
    filters: $filters
    limit: $limit
  ) {
    period
    allViews
    uniqueViews
  }
}
    `;

/**
 * __useEdmDocumentationsAnalyticsTrendQuery__
 *
 * To run a query within a React component, call `useEdmDocumentationsAnalyticsTrendQuery` and pass it any options that fit your needs.
 * When your component renders, `useEdmDocumentationsAnalyticsTrendQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEdmDocumentationsAnalyticsTrendQuery({
 *   variables: {
 *      period: // value for 'period'
 *      periodGroupBy: // value for 'periodGroupBy'
 *      filters: // value for 'filters'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useEdmDocumentationsAnalyticsTrendQuery(baseOptions: ApolloReactHooks.QueryHookOptions<EdmDocumentationsAnalyticsTrendQuery, EdmDocumentationsAnalyticsTrendQueryVariables> & ({ variables: EdmDocumentationsAnalyticsTrendQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<EdmDocumentationsAnalyticsTrendQuery, EdmDocumentationsAnalyticsTrendQueryVariables>(EdmDocumentationsAnalyticsTrendDocument, options);
      }
export function useEdmDocumentationsAnalyticsTrendLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<EdmDocumentationsAnalyticsTrendQuery, EdmDocumentationsAnalyticsTrendQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<EdmDocumentationsAnalyticsTrendQuery, EdmDocumentationsAnalyticsTrendQueryVariables>(EdmDocumentationsAnalyticsTrendDocument, options);
        }
// @ts-ignore
export function useEdmDocumentationsAnalyticsTrendSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<EdmDocumentationsAnalyticsTrendQuery, EdmDocumentationsAnalyticsTrendQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<EdmDocumentationsAnalyticsTrendQuery, EdmDocumentationsAnalyticsTrendQueryVariables>;
// @ts-ignore
export function useEdmDocumentationsAnalyticsTrendSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<EdmDocumentationsAnalyticsTrendQuery, EdmDocumentationsAnalyticsTrendQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<EdmDocumentationsAnalyticsTrendQuery | undefined, EdmDocumentationsAnalyticsTrendQueryVariables>;
export function useEdmDocumentationsAnalyticsTrendSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<EdmDocumentationsAnalyticsTrendQuery, EdmDocumentationsAnalyticsTrendQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          // @ts-ignore
          return ApolloReactHooks.useSuspenseQuery<EdmDocumentationsAnalyticsTrendQuery, EdmDocumentationsAnalyticsTrendQueryVariables>(EdmDocumentationsAnalyticsTrendDocument, options);
        }
export type EdmDocumentationsAnalyticsTrendQueryHookResult = ReturnType<typeof useEdmDocumentationsAnalyticsTrendQuery>;
export type EdmDocumentationsAnalyticsTrendLazyQueryHookResult = ReturnType<typeof useEdmDocumentationsAnalyticsTrendLazyQuery>;
export type EdmDocumentationsAnalyticsTrendSuspenseQueryHookResult = ReturnType<typeof useEdmDocumentationsAnalyticsTrendSuspenseQuery>;
export type EdmDocumentationsAnalyticsTrendQueryResult = ApolloReactCommon.QueryResult<EdmDocumentationsAnalyticsTrendQuery, EdmDocumentationsAnalyticsTrendQueryVariables>;
export function refetchEdmDocumentationsAnalyticsTrendQuery(variables: EdmDocumentationsAnalyticsTrendQueryVariables) {
      return { query: EdmDocumentationsAnalyticsTrendDocument, variables: variables }
    }
export const EdmDocumentationsAnalyticsByCategoryDocument = gql`
    query edmDocumentationsAnalyticsByCategory($period: DateRangeInputObject!, $sorts: DocumentationAnalyticsByCategorySortInputObject, $filters: [DocumentationFilterInputObject!], $limit: Int) {
  data: documentationsAnalyticsByCategory(
    period: $period
    sorts: $sorts
    filters: $filters
    limit: $limit
  ) {
    categoryId
    viewCount
    percentage
  }
}
    `;

/**
 * __useEdmDocumentationsAnalyticsByCategoryQuery__
 *
 * To run a query within a React component, call `useEdmDocumentationsAnalyticsByCategoryQuery` and pass it any options that fit your needs.
 * When your component renders, `useEdmDocumentationsAnalyticsByCategoryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEdmDocumentationsAnalyticsByCategoryQuery({
 *   variables: {
 *      period: // value for 'period'
 *      sorts: // value for 'sorts'
 *      filters: // value for 'filters'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useEdmDocumentationsAnalyticsByCategoryQuery(baseOptions: ApolloReactHooks.QueryHookOptions<EdmDocumentationsAnalyticsByCategoryQuery, EdmDocumentationsAnalyticsByCategoryQueryVariables> & ({ variables: EdmDocumentationsAnalyticsByCategoryQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<EdmDocumentationsAnalyticsByCategoryQuery, EdmDocumentationsAnalyticsByCategoryQueryVariables>(EdmDocumentationsAnalyticsByCategoryDocument, options);
      }
export function useEdmDocumentationsAnalyticsByCategoryLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<EdmDocumentationsAnalyticsByCategoryQuery, EdmDocumentationsAnalyticsByCategoryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<EdmDocumentationsAnalyticsByCategoryQuery, EdmDocumentationsAnalyticsByCategoryQueryVariables>(EdmDocumentationsAnalyticsByCategoryDocument, options);
        }
// @ts-ignore
export function useEdmDocumentationsAnalyticsByCategorySuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<EdmDocumentationsAnalyticsByCategoryQuery, EdmDocumentationsAnalyticsByCategoryQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<EdmDocumentationsAnalyticsByCategoryQuery, EdmDocumentationsAnalyticsByCategoryQueryVariables>;
// @ts-ignore
export function useEdmDocumentationsAnalyticsByCategorySuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<EdmDocumentationsAnalyticsByCategoryQuery, EdmDocumentationsAnalyticsByCategoryQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<EdmDocumentationsAnalyticsByCategoryQuery | undefined, EdmDocumentationsAnalyticsByCategoryQueryVariables>;
export function useEdmDocumentationsAnalyticsByCategorySuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<EdmDocumentationsAnalyticsByCategoryQuery, EdmDocumentationsAnalyticsByCategoryQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          // @ts-ignore
          return ApolloReactHooks.useSuspenseQuery<EdmDocumentationsAnalyticsByCategoryQuery, EdmDocumentationsAnalyticsByCategoryQueryVariables>(EdmDocumentationsAnalyticsByCategoryDocument, options);
        }
export type EdmDocumentationsAnalyticsByCategoryQueryHookResult = ReturnType<typeof useEdmDocumentationsAnalyticsByCategoryQuery>;
export type EdmDocumentationsAnalyticsByCategoryLazyQueryHookResult = ReturnType<typeof useEdmDocumentationsAnalyticsByCategoryLazyQuery>;
export type EdmDocumentationsAnalyticsByCategorySuspenseQueryHookResult = ReturnType<typeof useEdmDocumentationsAnalyticsByCategorySuspenseQuery>;
export type EdmDocumentationsAnalyticsByCategoryQueryResult = ApolloReactCommon.QueryResult<EdmDocumentationsAnalyticsByCategoryQuery, EdmDocumentationsAnalyticsByCategoryQueryVariables>;
export function refetchEdmDocumentationsAnalyticsByCategoryQuery(variables: EdmDocumentationsAnalyticsByCategoryQueryVariables) {
      return { query: EdmDocumentationsAnalyticsByCategoryDocument, variables: variables }
    }
export const EdmDocumentationLinksDocument = gql`
    query edmDocumentationLinks($findBy: DocumentationLinkFindByInputObject!, $filters: [DocumentationLinkFilterInputObject!], $page: Int, $limit: Int) {
  data: documentationLinks(
    findBy: $findBy
    filters: $filters
    page: $page
    limit: $limit
  ) {
    collection {
      id
      documentationId
      linkableId
      linkableType
      visibleViaQr
    }
  }
}
    `;

/**
 * __useEdmDocumentationLinksQuery__
 *
 * To run a query within a React component, call `useEdmDocumentationLinksQuery` and pass it any options that fit your needs.
 * When your component renders, `useEdmDocumentationLinksQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEdmDocumentationLinksQuery({
 *   variables: {
 *      findBy: // value for 'findBy'
 *      filters: // value for 'filters'
 *      page: // value for 'page'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useEdmDocumentationLinksQuery(baseOptions: ApolloReactHooks.QueryHookOptions<EdmDocumentationLinksQuery, EdmDocumentationLinksQueryVariables> & ({ variables: EdmDocumentationLinksQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<EdmDocumentationLinksQuery, EdmDocumentationLinksQueryVariables>(EdmDocumentationLinksDocument, options);
      }
export function useEdmDocumentationLinksLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<EdmDocumentationLinksQuery, EdmDocumentationLinksQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<EdmDocumentationLinksQuery, EdmDocumentationLinksQueryVariables>(EdmDocumentationLinksDocument, options);
        }
// @ts-ignore
export function useEdmDocumentationLinksSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<EdmDocumentationLinksQuery, EdmDocumentationLinksQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<EdmDocumentationLinksQuery, EdmDocumentationLinksQueryVariables>;
// @ts-ignore
export function useEdmDocumentationLinksSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<EdmDocumentationLinksQuery, EdmDocumentationLinksQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<EdmDocumentationLinksQuery | undefined, EdmDocumentationLinksQueryVariables>;
export function useEdmDocumentationLinksSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<EdmDocumentationLinksQuery, EdmDocumentationLinksQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          // @ts-ignore
          return ApolloReactHooks.useSuspenseQuery<EdmDocumentationLinksQuery, EdmDocumentationLinksQueryVariables>(EdmDocumentationLinksDocument, options);
        }
export type EdmDocumentationLinksQueryHookResult = ReturnType<typeof useEdmDocumentationLinksQuery>;
export type EdmDocumentationLinksLazyQueryHookResult = ReturnType<typeof useEdmDocumentationLinksLazyQuery>;
export type EdmDocumentationLinksSuspenseQueryHookResult = ReturnType<typeof useEdmDocumentationLinksSuspenseQuery>;
export type EdmDocumentationLinksQueryResult = ApolloReactCommon.QueryResult<EdmDocumentationLinksQuery, EdmDocumentationLinksQueryVariables>;
export function refetchEdmDocumentationLinksQuery(variables: EdmDocumentationLinksQueryVariables) {
      return { query: EdmDocumentationLinksDocument, variables: variables }
    }
export const EdmDocumentationLinkedTasksDocument = gql`
    query edmDocumentationLinkedTasks($scope: TaskScopeInputObject!, $filters: [TaskFilterInputObject!]) {
  data: tasks(scope: $scope, filters: $filters, onlyIds: true) {
    collection {
      id
      groupKey
    }
  }
}
    `;

/**
 * __useEdmDocumentationLinkedTasksQuery__
 *
 * To run a query within a React component, call `useEdmDocumentationLinkedTasksQuery` and pass it any options that fit your needs.
 * When your component renders, `useEdmDocumentationLinkedTasksQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEdmDocumentationLinkedTasksQuery({
 *   variables: {
 *      scope: // value for 'scope'
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useEdmDocumentationLinkedTasksQuery(baseOptions: ApolloReactHooks.QueryHookOptions<EdmDocumentationLinkedTasksQuery, EdmDocumentationLinkedTasksQueryVariables> & ({ variables: EdmDocumentationLinkedTasksQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<EdmDocumentationLinkedTasksQuery, EdmDocumentationLinkedTasksQueryVariables>(EdmDocumentationLinkedTasksDocument, options);
      }
export function useEdmDocumentationLinkedTasksLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<EdmDocumentationLinkedTasksQuery, EdmDocumentationLinkedTasksQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<EdmDocumentationLinkedTasksQuery, EdmDocumentationLinkedTasksQueryVariables>(EdmDocumentationLinkedTasksDocument, options);
        }
// @ts-ignore
export function useEdmDocumentationLinkedTasksSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<EdmDocumentationLinkedTasksQuery, EdmDocumentationLinkedTasksQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<EdmDocumentationLinkedTasksQuery, EdmDocumentationLinkedTasksQueryVariables>;
// @ts-ignore
export function useEdmDocumentationLinkedTasksSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<EdmDocumentationLinkedTasksQuery, EdmDocumentationLinkedTasksQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<EdmDocumentationLinkedTasksQuery | undefined, EdmDocumentationLinkedTasksQueryVariables>;
export function useEdmDocumentationLinkedTasksSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<EdmDocumentationLinkedTasksQuery, EdmDocumentationLinkedTasksQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          // @ts-ignore
          return ApolloReactHooks.useSuspenseQuery<EdmDocumentationLinkedTasksQuery, EdmDocumentationLinkedTasksQueryVariables>(EdmDocumentationLinkedTasksDocument, options);
        }
export type EdmDocumentationLinkedTasksQueryHookResult = ReturnType<typeof useEdmDocumentationLinkedTasksQuery>;
export type EdmDocumentationLinkedTasksLazyQueryHookResult = ReturnType<typeof useEdmDocumentationLinkedTasksLazyQuery>;
export type EdmDocumentationLinkedTasksSuspenseQueryHookResult = ReturnType<typeof useEdmDocumentationLinkedTasksSuspenseQuery>;
export type EdmDocumentationLinkedTasksQueryResult = ApolloReactCommon.QueryResult<EdmDocumentationLinkedTasksQuery, EdmDocumentationLinkedTasksQueryVariables>;
export function refetchEdmDocumentationLinkedTasksQuery(variables: EdmDocumentationLinkedTasksQueryVariables) {
      return { query: EdmDocumentationLinkedTasksDocument, variables: variables }
    }
export const EdmDocumentationLinkedTasksListDocument = gql`
    query edmDocumentationLinkedTasksList($page: Int, $limit: Int, $scope: TaskScopeInputObject!, $filters: [TaskFilterInputObject!], $sorts: TaskSortInputObject) {
  tasks(
    page: $page
    limit: $limit
    scope: $scope
    filters: $filters
    sorts: $sorts
  ) {
    collection {
      id
      name
      status
      kind
      priority
      recurringRuleId
      site {
        id
        name
      }
      siteArea {
        id
        name
      }
      formTemplate {
        category {
          ...formCategoryFragment
        }
        id
      }
    }
    metadata {
      ...metadataFragment
    }
  }
}
    ${FormCategoryFragmentFragmentDoc}
${MetadataFragmentFragmentDoc}`;

/**
 * __useEdmDocumentationLinkedTasksListQuery__
 *
 * To run a query within a React component, call `useEdmDocumentationLinkedTasksListQuery` and pass it any options that fit your needs.
 * When your component renders, `useEdmDocumentationLinkedTasksListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEdmDocumentationLinkedTasksListQuery({
 *   variables: {
 *      page: // value for 'page'
 *      limit: // value for 'limit'
 *      scope: // value for 'scope'
 *      filters: // value for 'filters'
 *      sorts: // value for 'sorts'
 *   },
 * });
 */
export function useEdmDocumentationLinkedTasksListQuery(baseOptions: ApolloReactHooks.QueryHookOptions<EdmDocumentationLinkedTasksListQuery, EdmDocumentationLinkedTasksListQueryVariables> & ({ variables: EdmDocumentationLinkedTasksListQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<EdmDocumentationLinkedTasksListQuery, EdmDocumentationLinkedTasksListQueryVariables>(EdmDocumentationLinkedTasksListDocument, options);
      }
export function useEdmDocumentationLinkedTasksListLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<EdmDocumentationLinkedTasksListQuery, EdmDocumentationLinkedTasksListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<EdmDocumentationLinkedTasksListQuery, EdmDocumentationLinkedTasksListQueryVariables>(EdmDocumentationLinkedTasksListDocument, options);
        }
// @ts-ignore
export function useEdmDocumentationLinkedTasksListSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<EdmDocumentationLinkedTasksListQuery, EdmDocumentationLinkedTasksListQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<EdmDocumentationLinkedTasksListQuery, EdmDocumentationLinkedTasksListQueryVariables>;
// @ts-ignore
export function useEdmDocumentationLinkedTasksListSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<EdmDocumentationLinkedTasksListQuery, EdmDocumentationLinkedTasksListQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<EdmDocumentationLinkedTasksListQuery | undefined, EdmDocumentationLinkedTasksListQueryVariables>;
export function useEdmDocumentationLinkedTasksListSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<EdmDocumentationLinkedTasksListQuery, EdmDocumentationLinkedTasksListQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          // @ts-ignore
          return ApolloReactHooks.useSuspenseQuery<EdmDocumentationLinkedTasksListQuery, EdmDocumentationLinkedTasksListQueryVariables>(EdmDocumentationLinkedTasksListDocument, options);
        }
export type EdmDocumentationLinkedTasksListQueryHookResult = ReturnType<typeof useEdmDocumentationLinkedTasksListQuery>;
export type EdmDocumentationLinkedTasksListLazyQueryHookResult = ReturnType<typeof useEdmDocumentationLinkedTasksListLazyQuery>;
export type EdmDocumentationLinkedTasksListSuspenseQueryHookResult = ReturnType<typeof useEdmDocumentationLinkedTasksListSuspenseQuery>;
export type EdmDocumentationLinkedTasksListQueryResult = ApolloReactCommon.QueryResult<EdmDocumentationLinkedTasksListQuery, EdmDocumentationLinkedTasksListQueryVariables>;
export function refetchEdmDocumentationLinkedTasksListQuery(variables: EdmDocumentationLinkedTasksListQueryVariables) {
      return { query: EdmDocumentationLinkedTasksListDocument, variables: variables }
    }
export const FeFilterPresetsDocument = gql`
    query feFilterPresets($filters: [FeFilterPresetFilterInputObject!], $limit: Int, $page: Int, $sorts: FeFilterPresetSortInputObject) {
  data: feFilterPresets(
    filters: $filters
    limit: $limit
    page: $page
    sorts: $sorts
  ) {
    collection {
      ...feFilterPreset
    }
    metadata {
      ...metadataFragment
    }
  }
}
    ${FeFilterPresetFragmentDoc}
${MetadataFragmentFragmentDoc}`;

/**
 * __useFeFilterPresetsQuery__
 *
 * To run a query within a React component, call `useFeFilterPresetsQuery` and pass it any options that fit your needs.
 * When your component renders, `useFeFilterPresetsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFeFilterPresetsQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      limit: // value for 'limit'
 *      page: // value for 'page'
 *      sorts: // value for 'sorts'
 *   },
 * });
 */
export function useFeFilterPresetsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<FeFilterPresetsQuery, FeFilterPresetsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<FeFilterPresetsQuery, FeFilterPresetsQueryVariables>(FeFilterPresetsDocument, options);
      }
export function useFeFilterPresetsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<FeFilterPresetsQuery, FeFilterPresetsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<FeFilterPresetsQuery, FeFilterPresetsQueryVariables>(FeFilterPresetsDocument, options);
        }
// @ts-ignore
export function useFeFilterPresetsSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<FeFilterPresetsQuery, FeFilterPresetsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<FeFilterPresetsQuery, FeFilterPresetsQueryVariables>;
// @ts-ignore
export function useFeFilterPresetsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<FeFilterPresetsQuery, FeFilterPresetsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<FeFilterPresetsQuery | undefined, FeFilterPresetsQueryVariables>;
export function useFeFilterPresetsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<FeFilterPresetsQuery, FeFilterPresetsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          // @ts-ignore
          return ApolloReactHooks.useSuspenseQuery<FeFilterPresetsQuery, FeFilterPresetsQueryVariables>(FeFilterPresetsDocument, options);
        }
export type FeFilterPresetsQueryHookResult = ReturnType<typeof useFeFilterPresetsQuery>;
export type FeFilterPresetsLazyQueryHookResult = ReturnType<typeof useFeFilterPresetsLazyQuery>;
export type FeFilterPresetsSuspenseQueryHookResult = ReturnType<typeof useFeFilterPresetsSuspenseQuery>;
export type FeFilterPresetsQueryResult = ApolloReactCommon.QueryResult<FeFilterPresetsQuery, FeFilterPresetsQueryVariables>;
export function refetchFeFilterPresetsQuery(variables?: FeFilterPresetsQueryVariables) {
      return { query: FeFilterPresetsDocument, variables: variables }
    }
export const FeFilterPresetDocument = gql`
    query feFilterPreset($id: ID!) {
  data: feFilterPreset(id: $id) {
    ...feFilterPreset
  }
}
    ${FeFilterPresetFragmentDoc}`;

/**
 * __useFeFilterPresetQuery__
 *
 * To run a query within a React component, call `useFeFilterPresetQuery` and pass it any options that fit your needs.
 * When your component renders, `useFeFilterPresetQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFeFilterPresetQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useFeFilterPresetQuery(baseOptions: ApolloReactHooks.QueryHookOptions<FeFilterPresetQuery, FeFilterPresetQueryVariables> & ({ variables: FeFilterPresetQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<FeFilterPresetQuery, FeFilterPresetQueryVariables>(FeFilterPresetDocument, options);
      }
export function useFeFilterPresetLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<FeFilterPresetQuery, FeFilterPresetQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<FeFilterPresetQuery, FeFilterPresetQueryVariables>(FeFilterPresetDocument, options);
        }
// @ts-ignore
export function useFeFilterPresetSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<FeFilterPresetQuery, FeFilterPresetQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<FeFilterPresetQuery, FeFilterPresetQueryVariables>;
// @ts-ignore
export function useFeFilterPresetSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<FeFilterPresetQuery, FeFilterPresetQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<FeFilterPresetQuery | undefined, FeFilterPresetQueryVariables>;
export function useFeFilterPresetSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<FeFilterPresetQuery, FeFilterPresetQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          // @ts-ignore
          return ApolloReactHooks.useSuspenseQuery<FeFilterPresetQuery, FeFilterPresetQueryVariables>(FeFilterPresetDocument, options);
        }
export type FeFilterPresetQueryHookResult = ReturnType<typeof useFeFilterPresetQuery>;
export type FeFilterPresetLazyQueryHookResult = ReturnType<typeof useFeFilterPresetLazyQuery>;
export type FeFilterPresetSuspenseQueryHookResult = ReturnType<typeof useFeFilterPresetSuspenseQuery>;
export type FeFilterPresetQueryResult = ApolloReactCommon.QueryResult<FeFilterPresetQuery, FeFilterPresetQueryVariables>;
export function refetchFeFilterPresetQuery(variables: FeFilterPresetQueryVariables) {
      return { query: FeFilterPresetDocument, variables: variables }
    }
export const FeFilterPresetCreateDocument = gql`
    mutation feFilterPresetCreate($attributes: FeFilterPresetCreateInputObject!) {
  data: feFilterPresetCreate(input: {attributes: $attributes}) {
    ...feFilterPreset
  }
}
    ${FeFilterPresetFragmentDoc}`;

/**
 * __useFeFilterPresetCreateMutation__
 *
 * To run a mutation, you first call `useFeFilterPresetCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useFeFilterPresetCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [feFilterPresetCreateMutation, { data, loading, error }] = useFeFilterPresetCreateMutation({
 *   variables: {
 *      attributes: // value for 'attributes'
 *   },
 * });
 */
export function useFeFilterPresetCreateMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<FeFilterPresetCreateMutation, FeFilterPresetCreateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<FeFilterPresetCreateMutation, FeFilterPresetCreateMutationVariables>(FeFilterPresetCreateDocument, options);
      }
export type FeFilterPresetCreateMutationHookResult = ReturnType<typeof useFeFilterPresetCreateMutation>;
export type FeFilterPresetCreateMutationResult = ApolloReactCommon.MutationResult<FeFilterPresetCreateMutation>;
export const FeFilterPresetUpdateDocument = gql`
    mutation feFilterPresetUpdate($attributes: FeFilterPresetUpdateInputObject!, $id: ID!) {
  data: feFilterPresetUpdate(input: {attributes: $attributes, id: $id}) {
    ...feFilterPreset
  }
}
    ${FeFilterPresetFragmentDoc}`;

/**
 * __useFeFilterPresetUpdateMutation__
 *
 * To run a mutation, you first call `useFeFilterPresetUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useFeFilterPresetUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [feFilterPresetUpdateMutation, { data, loading, error }] = useFeFilterPresetUpdateMutation({
 *   variables: {
 *      attributes: // value for 'attributes'
 *      id: // value for 'id'
 *   },
 * });
 */
export function useFeFilterPresetUpdateMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<FeFilterPresetUpdateMutation, FeFilterPresetUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<FeFilterPresetUpdateMutation, FeFilterPresetUpdateMutationVariables>(FeFilterPresetUpdateDocument, options);
      }
export type FeFilterPresetUpdateMutationHookResult = ReturnType<typeof useFeFilterPresetUpdateMutation>;
export type FeFilterPresetUpdateMutationResult = ApolloReactCommon.MutationResult<FeFilterPresetUpdateMutation>;
export const FeFilterPresetDestroyDocument = gql`
    mutation feFilterPresetDestroy($id: ID!) {
  feFilterPresetDestroy(input: {id: $id})
}
    `;

/**
 * __useFeFilterPresetDestroyMutation__
 *
 * To run a mutation, you first call `useFeFilterPresetDestroyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useFeFilterPresetDestroyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [feFilterPresetDestroyMutation, { data, loading, error }] = useFeFilterPresetDestroyMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useFeFilterPresetDestroyMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<FeFilterPresetDestroyMutation, FeFilterPresetDestroyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<FeFilterPresetDestroyMutation, FeFilterPresetDestroyMutationVariables>(FeFilterPresetDestroyDocument, options);
      }
export type FeFilterPresetDestroyMutationHookResult = ReturnType<typeof useFeFilterPresetDestroyMutation>;
export type FeFilterPresetDestroyMutationResult = ApolloReactCommon.MutationResult<FeFilterPresetDestroyMutation>;
export const FormTemplateDocument = gql`
    query formTemplate($id: ID!) {
  data: formTemplate(id: $id) {
    ...formTemplateFullFragment
    archivedAt
    hasLinkedDocumentations
    canArchive {
      value
    }
    canDestroy {
      value
    }
    canUpdate {
      value
    }
  }
}
    ${FormTemplateFullFragmentFragmentDoc}
${FormTemplateFragmentFragmentDoc}
${FormCategoryFragmentFragmentDoc}`;

/**
 * __useFormTemplateQuery__
 *
 * To run a query within a React component, call `useFormTemplateQuery` and pass it any options that fit your needs.
 * When your component renders, `useFormTemplateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFormTemplateQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useFormTemplateQuery(baseOptions: ApolloReactHooks.QueryHookOptions<FormTemplateQuery, FormTemplateQueryVariables> & ({ variables: FormTemplateQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<FormTemplateQuery, FormTemplateQueryVariables>(FormTemplateDocument, options);
      }
export function useFormTemplateLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<FormTemplateQuery, FormTemplateQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<FormTemplateQuery, FormTemplateQueryVariables>(FormTemplateDocument, options);
        }
// @ts-ignore
export function useFormTemplateSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<FormTemplateQuery, FormTemplateQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<FormTemplateQuery, FormTemplateQueryVariables>;
// @ts-ignore
export function useFormTemplateSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<FormTemplateQuery, FormTemplateQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<FormTemplateQuery | undefined, FormTemplateQueryVariables>;
export function useFormTemplateSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<FormTemplateQuery, FormTemplateQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          // @ts-ignore
          return ApolloReactHooks.useSuspenseQuery<FormTemplateQuery, FormTemplateQueryVariables>(FormTemplateDocument, options);
        }
export type FormTemplateQueryHookResult = ReturnType<typeof useFormTemplateQuery>;
export type FormTemplateLazyQueryHookResult = ReturnType<typeof useFormTemplateLazyQuery>;
export type FormTemplateSuspenseQueryHookResult = ReturnType<typeof useFormTemplateSuspenseQuery>;
export type FormTemplateQueryResult = ApolloReactCommon.QueryResult<FormTemplateQuery, FormTemplateQueryVariables>;
export function refetchFormTemplateQuery(variables: FormTemplateQueryVariables) {
      return { query: FormTemplateDocument, variables: variables }
    }
export const FormTemplateVersionsSearchListDocument = gql`
    query formTemplateVersionsSearchList($filters: [FormTemplateVersionFilterInputObject!], $formTemplateId: ID!, $limit: Int, $page: Int, $sorts: FormTemplateVersionSortInputObject) {
  data: formTemplateVersions(
    filters: $filters
    formTemplateId: $formTemplateId
    limit: $limit
    page: $page
    sorts: $sorts
  ) {
    collection {
      id
      version
      createdAt
      status
    }
    metadata {
      ...metadataFragment
    }
  }
}
    ${MetadataFragmentFragmentDoc}`;

/**
 * __useFormTemplateVersionsSearchListQuery__
 *
 * To run a query within a React component, call `useFormTemplateVersionsSearchListQuery` and pass it any options that fit your needs.
 * When your component renders, `useFormTemplateVersionsSearchListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFormTemplateVersionsSearchListQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      formTemplateId: // value for 'formTemplateId'
 *      limit: // value for 'limit'
 *      page: // value for 'page'
 *      sorts: // value for 'sorts'
 *   },
 * });
 */
export function useFormTemplateVersionsSearchListQuery(baseOptions: ApolloReactHooks.QueryHookOptions<FormTemplateVersionsSearchListQuery, FormTemplateVersionsSearchListQueryVariables> & ({ variables: FormTemplateVersionsSearchListQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<FormTemplateVersionsSearchListQuery, FormTemplateVersionsSearchListQueryVariables>(FormTemplateVersionsSearchListDocument, options);
      }
export function useFormTemplateVersionsSearchListLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<FormTemplateVersionsSearchListQuery, FormTemplateVersionsSearchListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<FormTemplateVersionsSearchListQuery, FormTemplateVersionsSearchListQueryVariables>(FormTemplateVersionsSearchListDocument, options);
        }
// @ts-ignore
export function useFormTemplateVersionsSearchListSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<FormTemplateVersionsSearchListQuery, FormTemplateVersionsSearchListQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<FormTemplateVersionsSearchListQuery, FormTemplateVersionsSearchListQueryVariables>;
// @ts-ignore
export function useFormTemplateVersionsSearchListSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<FormTemplateVersionsSearchListQuery, FormTemplateVersionsSearchListQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<FormTemplateVersionsSearchListQuery | undefined, FormTemplateVersionsSearchListQueryVariables>;
export function useFormTemplateVersionsSearchListSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<FormTemplateVersionsSearchListQuery, FormTemplateVersionsSearchListQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          // @ts-ignore
          return ApolloReactHooks.useSuspenseQuery<FormTemplateVersionsSearchListQuery, FormTemplateVersionsSearchListQueryVariables>(FormTemplateVersionsSearchListDocument, options);
        }
export type FormTemplateVersionsSearchListQueryHookResult = ReturnType<typeof useFormTemplateVersionsSearchListQuery>;
export type FormTemplateVersionsSearchListLazyQueryHookResult = ReturnType<typeof useFormTemplateVersionsSearchListLazyQuery>;
export type FormTemplateVersionsSearchListSuspenseQueryHookResult = ReturnType<typeof useFormTemplateVersionsSearchListSuspenseQuery>;
export type FormTemplateVersionsSearchListQueryResult = ApolloReactCommon.QueryResult<FormTemplateVersionsSearchListQuery, FormTemplateVersionsSearchListQueryVariables>;
export function refetchFormTemplateVersionsSearchListQuery(variables: FormTemplateVersionsSearchListQueryVariables) {
      return { query: FormTemplateVersionsSearchListDocument, variables: variables }
    }
export const FormTemplateVersionDocument = gql`
    query formTemplateVersion($formTemplateId: ID!, $id: ID!, $isViewLocked: Boolean! = false) {
  data: formTemplateVersion(formTemplateId: $formTemplateId, id: $id) {
    ...fullFormTemplateVersionFragment
    visibleLinkedTasksCount
  }
}
    ${FullFormTemplateVersionFragmentFragmentDoc}
${FormTemplateVersionFragmentFragmentDoc}
${QuestionsFragmentFragmentDoc}
${AttachmentFragmentFragmentDoc}`;

/**
 * __useFormTemplateVersionQuery__
 *
 * To run a query within a React component, call `useFormTemplateVersionQuery` and pass it any options that fit your needs.
 * When your component renders, `useFormTemplateVersionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFormTemplateVersionQuery({
 *   variables: {
 *      formTemplateId: // value for 'formTemplateId'
 *      id: // value for 'id'
 *      isViewLocked: // value for 'isViewLocked'
 *   },
 * });
 */
export function useFormTemplateVersionQuery(baseOptions: ApolloReactHooks.QueryHookOptions<FormTemplateVersionQuery, FormTemplateVersionQueryVariables> & ({ variables: FormTemplateVersionQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<FormTemplateVersionQuery, FormTemplateVersionQueryVariables>(FormTemplateVersionDocument, options);
      }
export function useFormTemplateVersionLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<FormTemplateVersionQuery, FormTemplateVersionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<FormTemplateVersionQuery, FormTemplateVersionQueryVariables>(FormTemplateVersionDocument, options);
        }
// @ts-ignore
export function useFormTemplateVersionSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<FormTemplateVersionQuery, FormTemplateVersionQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<FormTemplateVersionQuery, FormTemplateVersionQueryVariables>;
// @ts-ignore
export function useFormTemplateVersionSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<FormTemplateVersionQuery, FormTemplateVersionQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<FormTemplateVersionQuery | undefined, FormTemplateVersionQueryVariables>;
export function useFormTemplateVersionSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<FormTemplateVersionQuery, FormTemplateVersionQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          // @ts-ignore
          return ApolloReactHooks.useSuspenseQuery<FormTemplateVersionQuery, FormTemplateVersionQueryVariables>(FormTemplateVersionDocument, options);
        }
export type FormTemplateVersionQueryHookResult = ReturnType<typeof useFormTemplateVersionQuery>;
export type FormTemplateVersionLazyQueryHookResult = ReturnType<typeof useFormTemplateVersionLazyQuery>;
export type FormTemplateVersionSuspenseQueryHookResult = ReturnType<typeof useFormTemplateVersionSuspenseQuery>;
export type FormTemplateVersionQueryResult = ApolloReactCommon.QueryResult<FormTemplateVersionQuery, FormTemplateVersionQueryVariables>;
export function refetchFormTemplateVersionQuery(variables: FormTemplateVersionQueryVariables) {
      return { query: FormTemplateVersionDocument, variables: variables }
    }
export const FormCategoryDocument = gql`
    query formCategory($id: ID!) {
  data: formCategory(id: $id) {
    id
    name
    color
  }
}
    `;

/**
 * __useFormCategoryQuery__
 *
 * To run a query within a React component, call `useFormCategoryQuery` and pass it any options that fit your needs.
 * When your component renders, `useFormCategoryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFormCategoryQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useFormCategoryQuery(baseOptions: ApolloReactHooks.QueryHookOptions<FormCategoryQuery, FormCategoryQueryVariables> & ({ variables: FormCategoryQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<FormCategoryQuery, FormCategoryQueryVariables>(FormCategoryDocument, options);
      }
export function useFormCategoryLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<FormCategoryQuery, FormCategoryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<FormCategoryQuery, FormCategoryQueryVariables>(FormCategoryDocument, options);
        }
// @ts-ignore
export function useFormCategorySuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<FormCategoryQuery, FormCategoryQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<FormCategoryQuery, FormCategoryQueryVariables>;
// @ts-ignore
export function useFormCategorySuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<FormCategoryQuery, FormCategoryQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<FormCategoryQuery | undefined, FormCategoryQueryVariables>;
export function useFormCategorySuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<FormCategoryQuery, FormCategoryQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          // @ts-ignore
          return ApolloReactHooks.useSuspenseQuery<FormCategoryQuery, FormCategoryQueryVariables>(FormCategoryDocument, options);
        }
export type FormCategoryQueryHookResult = ReturnType<typeof useFormCategoryQuery>;
export type FormCategoryLazyQueryHookResult = ReturnType<typeof useFormCategoryLazyQuery>;
export type FormCategorySuspenseQueryHookResult = ReturnType<typeof useFormCategorySuspenseQuery>;
export type FormCategoryQueryResult = ApolloReactCommon.QueryResult<FormCategoryQuery, FormCategoryQueryVariables>;
export function refetchFormCategoryQuery(variables: FormCategoryQueryVariables) {
      return { query: FormCategoryDocument, variables: variables }
    }
export const FormCategoriesDocument = gql`
    query formCategories($filters: [FormCategoryFilterInputObject!], $limit: Int, $page: Int, $sorts: FormCategorySortInputObject) {
  data: formCategories(
    filters: $filters
    limit: $limit
    page: $page
    sorts: $sorts
  ) {
    collection {
      ...formCategoryFragment
      formTemplatesCount
      formTemplates {
        collection {
          id
          name
          currentVersion {
            id
          }
        }
      }
      canDestroy {
        value
      }
    }
    metadata {
      ...metadataFragment
    }
  }
}
    ${FormCategoryFragmentFragmentDoc}
${MetadataFragmentFragmentDoc}`;

/**
 * __useFormCategoriesQuery__
 *
 * To run a query within a React component, call `useFormCategoriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useFormCategoriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFormCategoriesQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      limit: // value for 'limit'
 *      page: // value for 'page'
 *      sorts: // value for 'sorts'
 *   },
 * });
 */
export function useFormCategoriesQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<FormCategoriesQuery, FormCategoriesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<FormCategoriesQuery, FormCategoriesQueryVariables>(FormCategoriesDocument, options);
      }
export function useFormCategoriesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<FormCategoriesQuery, FormCategoriesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<FormCategoriesQuery, FormCategoriesQueryVariables>(FormCategoriesDocument, options);
        }
// @ts-ignore
export function useFormCategoriesSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<FormCategoriesQuery, FormCategoriesQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<FormCategoriesQuery, FormCategoriesQueryVariables>;
// @ts-ignore
export function useFormCategoriesSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<FormCategoriesQuery, FormCategoriesQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<FormCategoriesQuery | undefined, FormCategoriesQueryVariables>;
export function useFormCategoriesSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<FormCategoriesQuery, FormCategoriesQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          // @ts-ignore
          return ApolloReactHooks.useSuspenseQuery<FormCategoriesQuery, FormCategoriesQueryVariables>(FormCategoriesDocument, options);
        }
export type FormCategoriesQueryHookResult = ReturnType<typeof useFormCategoriesQuery>;
export type FormCategoriesLazyQueryHookResult = ReturnType<typeof useFormCategoriesLazyQuery>;
export type FormCategoriesSuspenseQueryHookResult = ReturnType<typeof useFormCategoriesSuspenseQuery>;
export type FormCategoriesQueryResult = ApolloReactCommon.QueryResult<FormCategoriesQuery, FormCategoriesQueryVariables>;
export function refetchFormCategoriesQuery(variables?: FormCategoriesQueryVariables) {
      return { query: FormCategoriesDocument, variables: variables }
    }
export const FormCategoriesSearchListDocument = gql`
    query formCategoriesSearchList($filters: [FormCategoryFilterInputObject!], $limit: Int, $page: Int, $sorts: FormCategorySortInputObject) {
  data: formCategories(
    filters: $filters
    limit: $limit
    page: $page
    sorts: $sorts
  ) {
    collection {
      ...formCategoryFragment
    }
    metadata {
      ...metadataFragment
    }
  }
}
    ${FormCategoryFragmentFragmentDoc}
${MetadataFragmentFragmentDoc}`;

/**
 * __useFormCategoriesSearchListQuery__
 *
 * To run a query within a React component, call `useFormCategoriesSearchListQuery` and pass it any options that fit your needs.
 * When your component renders, `useFormCategoriesSearchListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFormCategoriesSearchListQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      limit: // value for 'limit'
 *      page: // value for 'page'
 *      sorts: // value for 'sorts'
 *   },
 * });
 */
export function useFormCategoriesSearchListQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<FormCategoriesSearchListQuery, FormCategoriesSearchListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<FormCategoriesSearchListQuery, FormCategoriesSearchListQueryVariables>(FormCategoriesSearchListDocument, options);
      }
export function useFormCategoriesSearchListLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<FormCategoriesSearchListQuery, FormCategoriesSearchListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<FormCategoriesSearchListQuery, FormCategoriesSearchListQueryVariables>(FormCategoriesSearchListDocument, options);
        }
// @ts-ignore
export function useFormCategoriesSearchListSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<FormCategoriesSearchListQuery, FormCategoriesSearchListQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<FormCategoriesSearchListQuery, FormCategoriesSearchListQueryVariables>;
// @ts-ignore
export function useFormCategoriesSearchListSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<FormCategoriesSearchListQuery, FormCategoriesSearchListQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<FormCategoriesSearchListQuery | undefined, FormCategoriesSearchListQueryVariables>;
export function useFormCategoriesSearchListSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<FormCategoriesSearchListQuery, FormCategoriesSearchListQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          // @ts-ignore
          return ApolloReactHooks.useSuspenseQuery<FormCategoriesSearchListQuery, FormCategoriesSearchListQueryVariables>(FormCategoriesSearchListDocument, options);
        }
export type FormCategoriesSearchListQueryHookResult = ReturnType<typeof useFormCategoriesSearchListQuery>;
export type FormCategoriesSearchListLazyQueryHookResult = ReturnType<typeof useFormCategoriesSearchListLazyQuery>;
export type FormCategoriesSearchListSuspenseQueryHookResult = ReturnType<typeof useFormCategoriesSearchListSuspenseQuery>;
export type FormCategoriesSearchListQueryResult = ApolloReactCommon.QueryResult<FormCategoriesSearchListQuery, FormCategoriesSearchListQueryVariables>;
export function refetchFormCategoriesSearchListQuery(variables?: FormCategoriesSearchListQueryVariables) {
      return { query: FormCategoriesSearchListDocument, variables: variables }
    }
export const FormTemplatesDocument = gql`
    query formTemplates($filters: [FormTemplateFilterInputObject!], $limit: Int, $page: Int, $scopeName: FormTemplateScopeNameEnum!, $sorts: FormTemplateSortInputObject) {
  data: formTemplates(
    filters: $filters
    limit: $limit
    page: $page
    scopeName: $scopeName
    sorts: $sorts
  ) {
    collection {
      id
      name
      category {
        ...formCategoryFragment
      }
      createdAt
      archivedAt
      currentVersion {
        id
        version
      }
      versionsCount
      visibleLinkedTasksCount
      canDestroy {
        value
      }
      canArchive {
        value
      }
      canUpdate {
        value
      }
    }
    metadata {
      ...metadataFragment
    }
  }
  activeCounter: formTemplates(scopeName: ACTIVE, filters: $filters) {
    metadata {
      totalCount
    }
  }
  archivedCounter: formTemplates(scopeName: ARCHIVED, filters: $filters) {
    metadata {
      totalCount
    }
  }
}
    ${FormCategoryFragmentFragmentDoc}
${MetadataFragmentFragmentDoc}`;

/**
 * __useFormTemplatesQuery__
 *
 * To run a query within a React component, call `useFormTemplatesQuery` and pass it any options that fit your needs.
 * When your component renders, `useFormTemplatesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFormTemplatesQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      limit: // value for 'limit'
 *      page: // value for 'page'
 *      scopeName: // value for 'scopeName'
 *      sorts: // value for 'sorts'
 *   },
 * });
 */
export function useFormTemplatesQuery(baseOptions: ApolloReactHooks.QueryHookOptions<FormTemplatesQuery, FormTemplatesQueryVariables> & ({ variables: FormTemplatesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<FormTemplatesQuery, FormTemplatesQueryVariables>(FormTemplatesDocument, options);
      }
export function useFormTemplatesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<FormTemplatesQuery, FormTemplatesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<FormTemplatesQuery, FormTemplatesQueryVariables>(FormTemplatesDocument, options);
        }
// @ts-ignore
export function useFormTemplatesSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<FormTemplatesQuery, FormTemplatesQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<FormTemplatesQuery, FormTemplatesQueryVariables>;
// @ts-ignore
export function useFormTemplatesSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<FormTemplatesQuery, FormTemplatesQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<FormTemplatesQuery | undefined, FormTemplatesQueryVariables>;
export function useFormTemplatesSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<FormTemplatesQuery, FormTemplatesQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          // @ts-ignore
          return ApolloReactHooks.useSuspenseQuery<FormTemplatesQuery, FormTemplatesQueryVariables>(FormTemplatesDocument, options);
        }
export type FormTemplatesQueryHookResult = ReturnType<typeof useFormTemplatesQuery>;
export type FormTemplatesLazyQueryHookResult = ReturnType<typeof useFormTemplatesLazyQuery>;
export type FormTemplatesSuspenseQueryHookResult = ReturnType<typeof useFormTemplatesSuspenseQuery>;
export type FormTemplatesQueryResult = ApolloReactCommon.QueryResult<FormTemplatesQuery, FormTemplatesQueryVariables>;
export function refetchFormTemplatesQuery(variables: FormTemplatesQueryVariables) {
      return { query: FormTemplatesDocument, variables: variables }
    }
export const FormTemplateIdsDocument = gql`
    query formTemplateIds($filters: [FormTemplateFilterInputObject!], $onlyIds: Boolean, $scopeName: FormTemplateScopeNameEnum!, $sorts: FormTemplateSortInputObject) {
  data: formTemplates(
    filters: $filters
    sorts: $sorts
    onlyIds: $onlyIds
    scopeName: $scopeName
  ) {
    collection {
      id
    }
  }
}
    `;

/**
 * __useFormTemplateIdsQuery__
 *
 * To run a query within a React component, call `useFormTemplateIdsQuery` and pass it any options that fit your needs.
 * When your component renders, `useFormTemplateIdsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFormTemplateIdsQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      onlyIds: // value for 'onlyIds'
 *      scopeName: // value for 'scopeName'
 *      sorts: // value for 'sorts'
 *   },
 * });
 */
export function useFormTemplateIdsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<FormTemplateIdsQuery, FormTemplateIdsQueryVariables> & ({ variables: FormTemplateIdsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<FormTemplateIdsQuery, FormTemplateIdsQueryVariables>(FormTemplateIdsDocument, options);
      }
export function useFormTemplateIdsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<FormTemplateIdsQuery, FormTemplateIdsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<FormTemplateIdsQuery, FormTemplateIdsQueryVariables>(FormTemplateIdsDocument, options);
        }
// @ts-ignore
export function useFormTemplateIdsSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<FormTemplateIdsQuery, FormTemplateIdsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<FormTemplateIdsQuery, FormTemplateIdsQueryVariables>;
// @ts-ignore
export function useFormTemplateIdsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<FormTemplateIdsQuery, FormTemplateIdsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<FormTemplateIdsQuery | undefined, FormTemplateIdsQueryVariables>;
export function useFormTemplateIdsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<FormTemplateIdsQuery, FormTemplateIdsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          // @ts-ignore
          return ApolloReactHooks.useSuspenseQuery<FormTemplateIdsQuery, FormTemplateIdsQueryVariables>(FormTemplateIdsDocument, options);
        }
export type FormTemplateIdsQueryHookResult = ReturnType<typeof useFormTemplateIdsQuery>;
export type FormTemplateIdsLazyQueryHookResult = ReturnType<typeof useFormTemplateIdsLazyQuery>;
export type FormTemplateIdsSuspenseQueryHookResult = ReturnType<typeof useFormTemplateIdsSuspenseQuery>;
export type FormTemplateIdsQueryResult = ApolloReactCommon.QueryResult<FormTemplateIdsQuery, FormTemplateIdsQueryVariables>;
export function refetchFormTemplateIdsQuery(variables: FormTemplateIdsQueryVariables) {
      return { query: FormTemplateIdsDocument, variables: variables }
    }
export const FormTemplatesSearchListDocument = gql`
    query formTemplatesSearchList($filters: [FormTemplateFilterInputObject!], $limit: Int, $page: Int, $scopeName: FormTemplateScopeNameEnum!, $sorts: FormTemplateSortInputObject) {
  data: formTemplates(
    filters: $filters
    limit: $limit
    page: $page
    scopeName: $scopeName
    sorts: $sorts
  ) {
    collection {
      id
      name
    }
    metadata {
      ...metadataFragment
    }
  }
}
    ${MetadataFragmentFragmentDoc}`;

/**
 * __useFormTemplatesSearchListQuery__
 *
 * To run a query within a React component, call `useFormTemplatesSearchListQuery` and pass it any options that fit your needs.
 * When your component renders, `useFormTemplatesSearchListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFormTemplatesSearchListQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      limit: // value for 'limit'
 *      page: // value for 'page'
 *      scopeName: // value for 'scopeName'
 *      sorts: // value for 'sorts'
 *   },
 * });
 */
export function useFormTemplatesSearchListQuery(baseOptions: ApolloReactHooks.QueryHookOptions<FormTemplatesSearchListQuery, FormTemplatesSearchListQueryVariables> & ({ variables: FormTemplatesSearchListQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<FormTemplatesSearchListQuery, FormTemplatesSearchListQueryVariables>(FormTemplatesSearchListDocument, options);
      }
export function useFormTemplatesSearchListLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<FormTemplatesSearchListQuery, FormTemplatesSearchListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<FormTemplatesSearchListQuery, FormTemplatesSearchListQueryVariables>(FormTemplatesSearchListDocument, options);
        }
// @ts-ignore
export function useFormTemplatesSearchListSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<FormTemplatesSearchListQuery, FormTemplatesSearchListQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<FormTemplatesSearchListQuery, FormTemplatesSearchListQueryVariables>;
// @ts-ignore
export function useFormTemplatesSearchListSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<FormTemplatesSearchListQuery, FormTemplatesSearchListQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<FormTemplatesSearchListQuery | undefined, FormTemplatesSearchListQueryVariables>;
export function useFormTemplatesSearchListSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<FormTemplatesSearchListQuery, FormTemplatesSearchListQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          // @ts-ignore
          return ApolloReactHooks.useSuspenseQuery<FormTemplatesSearchListQuery, FormTemplatesSearchListQueryVariables>(FormTemplatesSearchListDocument, options);
        }
export type FormTemplatesSearchListQueryHookResult = ReturnType<typeof useFormTemplatesSearchListQuery>;
export type FormTemplatesSearchListLazyQueryHookResult = ReturnType<typeof useFormTemplatesSearchListLazyQuery>;
export type FormTemplatesSearchListSuspenseQueryHookResult = ReturnType<typeof useFormTemplatesSearchListSuspenseQuery>;
export type FormTemplatesSearchListQueryResult = ApolloReactCommon.QueryResult<FormTemplatesSearchListQuery, FormTemplatesSearchListQueryVariables>;
export function refetchFormTemplatesSearchListQuery(variables: FormTemplatesSearchListQueryVariables) {
      return { query: FormTemplatesSearchListDocument, variables: variables }
    }
export const FormCategoryCreateDocument = gql`
    mutation formCategoryCreate($attributes: FormCategoryCreateInputObject!) {
  data: formCategoryCreate(input: {attributes: $attributes}) {
    ...formCategoryFragment
  }
}
    ${FormCategoryFragmentFragmentDoc}`;

/**
 * __useFormCategoryCreateMutation__
 *
 * To run a mutation, you first call `useFormCategoryCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useFormCategoryCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [formCategoryCreateMutation, { data, loading, error }] = useFormCategoryCreateMutation({
 *   variables: {
 *      attributes: // value for 'attributes'
 *   },
 * });
 */
export function useFormCategoryCreateMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<FormCategoryCreateMutation, FormCategoryCreateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<FormCategoryCreateMutation, FormCategoryCreateMutationVariables>(FormCategoryCreateDocument, options);
      }
export type FormCategoryCreateMutationHookResult = ReturnType<typeof useFormCategoryCreateMutation>;
export type FormCategoryCreateMutationResult = ApolloReactCommon.MutationResult<FormCategoryCreateMutation>;
export const FormCategoryUpdateDocument = gql`
    mutation formCategoryUpdate($attributes: FormCategoryUpdateInputObject!, $id: ID!) {
  data: formCategoryUpdate(input: {id: $id, attributes: $attributes}) {
    ...formCategoryFragment
  }
}
    ${FormCategoryFragmentFragmentDoc}`;

/**
 * __useFormCategoryUpdateMutation__
 *
 * To run a mutation, you first call `useFormCategoryUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useFormCategoryUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [formCategoryUpdateMutation, { data, loading, error }] = useFormCategoryUpdateMutation({
 *   variables: {
 *      attributes: // value for 'attributes'
 *      id: // value for 'id'
 *   },
 * });
 */
export function useFormCategoryUpdateMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<FormCategoryUpdateMutation, FormCategoryUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<FormCategoryUpdateMutation, FormCategoryUpdateMutationVariables>(FormCategoryUpdateDocument, options);
      }
export type FormCategoryUpdateMutationHookResult = ReturnType<typeof useFormCategoryUpdateMutation>;
export type FormCategoryUpdateMutationResult = ApolloReactCommon.MutationResult<FormCategoryUpdateMutation>;
export const FormCategoryDestroyDocument = gql`
    mutation formCategoryDestroy($id: ID!) {
  formCategoryDestroy(input: {id: $id})
}
    `;

/**
 * __useFormCategoryDestroyMutation__
 *
 * To run a mutation, you first call `useFormCategoryDestroyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useFormCategoryDestroyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [formCategoryDestroyMutation, { data, loading, error }] = useFormCategoryDestroyMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useFormCategoryDestroyMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<FormCategoryDestroyMutation, FormCategoryDestroyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<FormCategoryDestroyMutation, FormCategoryDestroyMutationVariables>(FormCategoryDestroyDocument, options);
      }
export type FormCategoryDestroyMutationHookResult = ReturnType<typeof useFormCategoryDestroyMutation>;
export type FormCategoryDestroyMutationResult = ApolloReactCommon.MutationResult<FormCategoryDestroyMutation>;
export const FormTemplateCreateDocument = gql`
    mutation formTemplateCreate($attributes: FormTemplateCreateInputObject!) {
  data: formTemplateCreate(input: {attributes: $attributes}) {
    ...formTemplateFullFragment
  }
}
    ${FormTemplateFullFragmentFragmentDoc}
${FormTemplateFragmentFragmentDoc}
${FormCategoryFragmentFragmentDoc}`;

/**
 * __useFormTemplateCreateMutation__
 *
 * To run a mutation, you first call `useFormTemplateCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useFormTemplateCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [formTemplateCreateMutation, { data, loading, error }] = useFormTemplateCreateMutation({
 *   variables: {
 *      attributes: // value for 'attributes'
 *   },
 * });
 */
export function useFormTemplateCreateMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<FormTemplateCreateMutation, FormTemplateCreateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<FormTemplateCreateMutation, FormTemplateCreateMutationVariables>(FormTemplateCreateDocument, options);
      }
export type FormTemplateCreateMutationHookResult = ReturnType<typeof useFormTemplateCreateMutation>;
export type FormTemplateCreateMutationResult = ApolloReactCommon.MutationResult<FormTemplateCreateMutation>;
export const FormTemplateUpdateDocument = gql`
    mutation formTemplateUpdate($attributes: FormTemplateUpdateInputObject!, $id: ID!) {
  data: formTemplateUpdate(input: {attributes: $attributes, id: $id}) {
    ...formTemplateFullFragment
  }
}
    ${FormTemplateFullFragmentFragmentDoc}
${FormTemplateFragmentFragmentDoc}
${FormCategoryFragmentFragmentDoc}`;

/**
 * __useFormTemplateUpdateMutation__
 *
 * To run a mutation, you first call `useFormTemplateUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useFormTemplateUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [formTemplateUpdateMutation, { data, loading, error }] = useFormTemplateUpdateMutation({
 *   variables: {
 *      attributes: // value for 'attributes'
 *      id: // value for 'id'
 *   },
 * });
 */
export function useFormTemplateUpdateMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<FormTemplateUpdateMutation, FormTemplateUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<FormTemplateUpdateMutation, FormTemplateUpdateMutationVariables>(FormTemplateUpdateDocument, options);
      }
export type FormTemplateUpdateMutationHookResult = ReturnType<typeof useFormTemplateUpdateMutation>;
export type FormTemplateUpdateMutationResult = ApolloReactCommon.MutationResult<FormTemplateUpdateMutation>;
export const FormTemplateBulkDestroyDocument = gql`
    mutation formTemplateBulkDestroy($ids: [ID!]!) {
  data: formTemplateBulkDestroy(input: {ids: $ids})
}
    `;

/**
 * __useFormTemplateBulkDestroyMutation__
 *
 * To run a mutation, you first call `useFormTemplateBulkDestroyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useFormTemplateBulkDestroyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [formTemplateBulkDestroyMutation, { data, loading, error }] = useFormTemplateBulkDestroyMutation({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useFormTemplateBulkDestroyMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<FormTemplateBulkDestroyMutation, FormTemplateBulkDestroyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<FormTemplateBulkDestroyMutation, FormTemplateBulkDestroyMutationVariables>(FormTemplateBulkDestroyDocument, options);
      }
export type FormTemplateBulkDestroyMutationHookResult = ReturnType<typeof useFormTemplateBulkDestroyMutation>;
export type FormTemplateBulkDestroyMutationResult = ApolloReactCommon.MutationResult<FormTemplateBulkDestroyMutation>;
export const FormTemplateBulkArchiveDocument = gql`
    mutation formTemplateBulkArchive($ids: [ID!]!) {
  data: formTemplateBulkArchive(input: {ids: $ids})
}
    `;

/**
 * __useFormTemplateBulkArchiveMutation__
 *
 * To run a mutation, you first call `useFormTemplateBulkArchiveMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useFormTemplateBulkArchiveMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [formTemplateBulkArchiveMutation, { data, loading, error }] = useFormTemplateBulkArchiveMutation({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useFormTemplateBulkArchiveMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<FormTemplateBulkArchiveMutation, FormTemplateBulkArchiveMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<FormTemplateBulkArchiveMutation, FormTemplateBulkArchiveMutationVariables>(FormTemplateBulkArchiveDocument, options);
      }
export type FormTemplateBulkArchiveMutationHookResult = ReturnType<typeof useFormTemplateBulkArchiveMutation>;
export type FormTemplateBulkArchiveMutationResult = ApolloReactCommon.MutationResult<FormTemplateBulkArchiveMutation>;
export const FormTemplateBulkRestoreDocument = gql`
    mutation formTemplateBulkRestore($ids: [ID!]!) {
  data: formTemplateBulkRestore(input: {ids: $ids})
}
    `;

/**
 * __useFormTemplateBulkRestoreMutation__
 *
 * To run a mutation, you first call `useFormTemplateBulkRestoreMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useFormTemplateBulkRestoreMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [formTemplateBulkRestoreMutation, { data, loading, error }] = useFormTemplateBulkRestoreMutation({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useFormTemplateBulkRestoreMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<FormTemplateBulkRestoreMutation, FormTemplateBulkRestoreMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<FormTemplateBulkRestoreMutation, FormTemplateBulkRestoreMutationVariables>(FormTemplateBulkRestoreDocument, options);
      }
export type FormTemplateBulkRestoreMutationHookResult = ReturnType<typeof useFormTemplateBulkRestoreMutation>;
export type FormTemplateBulkRestoreMutationResult = ApolloReactCommon.MutationResult<FormTemplateBulkRestoreMutation>;
export const FormTemplateUnlinkAllDocumentationsDocument = gql`
    mutation formTemplateUnlinkAllDocumentations($input: FormTemplateUnlinkAllDocumentationsInput!) {
  data: formTemplateUnlinkAllDocumentations(input: $input)
}
    `;

/**
 * __useFormTemplateUnlinkAllDocumentationsMutation__
 *
 * To run a mutation, you first call `useFormTemplateUnlinkAllDocumentationsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useFormTemplateUnlinkAllDocumentationsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [formTemplateUnlinkAllDocumentationsMutation, { data, loading, error }] = useFormTemplateUnlinkAllDocumentationsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useFormTemplateUnlinkAllDocumentationsMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<FormTemplateUnlinkAllDocumentationsMutation, FormTemplateUnlinkAllDocumentationsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<FormTemplateUnlinkAllDocumentationsMutation, FormTemplateUnlinkAllDocumentationsMutationVariables>(FormTemplateUnlinkAllDocumentationsDocument, options);
      }
export type FormTemplateUnlinkAllDocumentationsMutationHookResult = ReturnType<typeof useFormTemplateUnlinkAllDocumentationsMutation>;
export type FormTemplateUnlinkAllDocumentationsMutationResult = ApolloReactCommon.MutationResult<FormTemplateUnlinkAllDocumentationsMutation>;
export const FormTemplateVersionCreateDocument = gql`
    mutation formTemplateVersionCreate($attributes: FormTemplateVersionCuInputObject!, $formTemplateId: ID!, $isViewLocked: Boolean! = false) {
  data: formTemplateVersionCreate(
    input: {attributes: $attributes, formTemplateId: $formTemplateId}
  ) {
    ...fullFormTemplateVersionFragment
  }
}
    ${FullFormTemplateVersionFragmentFragmentDoc}
${FormTemplateVersionFragmentFragmentDoc}
${QuestionsFragmentFragmentDoc}
${AttachmentFragmentFragmentDoc}`;

/**
 * __useFormTemplateVersionCreateMutation__
 *
 * To run a mutation, you first call `useFormTemplateVersionCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useFormTemplateVersionCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [formTemplateVersionCreateMutation, { data, loading, error }] = useFormTemplateVersionCreateMutation({
 *   variables: {
 *      attributes: // value for 'attributes'
 *      formTemplateId: // value for 'formTemplateId'
 *      isViewLocked: // value for 'isViewLocked'
 *   },
 * });
 */
export function useFormTemplateVersionCreateMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<FormTemplateVersionCreateMutation, FormTemplateVersionCreateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<FormTemplateVersionCreateMutation, FormTemplateVersionCreateMutationVariables>(FormTemplateVersionCreateDocument, options);
      }
export type FormTemplateVersionCreateMutationHookResult = ReturnType<typeof useFormTemplateVersionCreateMutation>;
export type FormTemplateVersionCreateMutationResult = ApolloReactCommon.MutationResult<FormTemplateVersionCreateMutation>;
export const FormTemplateVersionUpdateDocument = gql`
    mutation formTemplateVersionUpdate($attributes: FormTemplateVersionCuInputObject!, $id: ID!, $formTemplateId: ID!) {
  data: formTemplateVersionUpdate(
    input: {attributes: $attributes, id: $id, formTemplateId: $formTemplateId}
  ) {
    id
  }
}
    `;

/**
 * __useFormTemplateVersionUpdateMutation__
 *
 * To run a mutation, you first call `useFormTemplateVersionUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useFormTemplateVersionUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [formTemplateVersionUpdateMutation, { data, loading, error }] = useFormTemplateVersionUpdateMutation({
 *   variables: {
 *      attributes: // value for 'attributes'
 *      id: // value for 'id'
 *      formTemplateId: // value for 'formTemplateId'
 *   },
 * });
 */
export function useFormTemplateVersionUpdateMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<FormTemplateVersionUpdateMutation, FormTemplateVersionUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<FormTemplateVersionUpdateMutation, FormTemplateVersionUpdateMutationVariables>(FormTemplateVersionUpdateDocument, options);
      }
export type FormTemplateVersionUpdateMutationHookResult = ReturnType<typeof useFormTemplateVersionUpdateMutation>;
export type FormTemplateVersionUpdateMutationResult = ApolloReactCommon.MutationResult<FormTemplateVersionUpdateMutation>;
export const FormTemplateVersionArchiveDocument = gql`
    mutation formTemplateVersionArchive($id: ID!, $formTemplateId: ID!, $isViewLocked: Boolean! = false) {
  data: formTemplateVersionArchive(
    input: {id: $id, formTemplateId: $formTemplateId}
  ) {
    ...fullFormTemplateVersionFragment
  }
}
    ${FullFormTemplateVersionFragmentFragmentDoc}
${FormTemplateVersionFragmentFragmentDoc}
${QuestionsFragmentFragmentDoc}
${AttachmentFragmentFragmentDoc}`;

/**
 * __useFormTemplateVersionArchiveMutation__
 *
 * To run a mutation, you first call `useFormTemplateVersionArchiveMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useFormTemplateVersionArchiveMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [formTemplateVersionArchiveMutation, { data, loading, error }] = useFormTemplateVersionArchiveMutation({
 *   variables: {
 *      id: // value for 'id'
 *      formTemplateId: // value for 'formTemplateId'
 *      isViewLocked: // value for 'isViewLocked'
 *   },
 * });
 */
export function useFormTemplateVersionArchiveMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<FormTemplateVersionArchiveMutation, FormTemplateVersionArchiveMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<FormTemplateVersionArchiveMutation, FormTemplateVersionArchiveMutationVariables>(FormTemplateVersionArchiveDocument, options);
      }
export type FormTemplateVersionArchiveMutationHookResult = ReturnType<typeof useFormTemplateVersionArchiveMutation>;
export type FormTemplateVersionArchiveMutationResult = ApolloReactCommon.MutationResult<FormTemplateVersionArchiveMutation>;
export const FormTemplateVersionRestoreDocument = gql`
    mutation formTemplateVersionRestore($id: ID!, $formTemplateId: ID!, $isViewLocked: Boolean! = false) {
  data: formTemplateVersionRestore(
    input: {id: $id, formTemplateId: $formTemplateId}
  ) {
    ...fullFormTemplateVersionFragment
    visibleLinkedTasksCount
  }
}
    ${FullFormTemplateVersionFragmentFragmentDoc}
${FormTemplateVersionFragmentFragmentDoc}
${QuestionsFragmentFragmentDoc}
${AttachmentFragmentFragmentDoc}`;

/**
 * __useFormTemplateVersionRestoreMutation__
 *
 * To run a mutation, you first call `useFormTemplateVersionRestoreMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useFormTemplateVersionRestoreMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [formTemplateVersionRestoreMutation, { data, loading, error }] = useFormTemplateVersionRestoreMutation({
 *   variables: {
 *      id: // value for 'id'
 *      formTemplateId: // value for 'formTemplateId'
 *      isViewLocked: // value for 'isViewLocked'
 *   },
 * });
 */
export function useFormTemplateVersionRestoreMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<FormTemplateVersionRestoreMutation, FormTemplateVersionRestoreMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<FormTemplateVersionRestoreMutation, FormTemplateVersionRestoreMutationVariables>(FormTemplateVersionRestoreDocument, options);
      }
export type FormTemplateVersionRestoreMutationHookResult = ReturnType<typeof useFormTemplateVersionRestoreMutation>;
export type FormTemplateVersionRestoreMutationResult = ApolloReactCommon.MutationResult<FormTemplateVersionRestoreMutation>;
export const FormTemplateVersionDestroyDocument = gql`
    mutation formTemplateVersionDestroy($id: ID!, $formTemplateId: ID!) {
  data: formTemplateVersionDestroy(
    input: {id: $id, formTemplateId: $formTemplateId}
  )
}
    `;

/**
 * __useFormTemplateVersionDestroyMutation__
 *
 * To run a mutation, you first call `useFormTemplateVersionDestroyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useFormTemplateVersionDestroyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [formTemplateVersionDestroyMutation, { data, loading, error }] = useFormTemplateVersionDestroyMutation({
 *   variables: {
 *      id: // value for 'id'
 *      formTemplateId: // value for 'formTemplateId'
 *   },
 * });
 */
export function useFormTemplateVersionDestroyMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<FormTemplateVersionDestroyMutation, FormTemplateVersionDestroyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<FormTemplateVersionDestroyMutation, FormTemplateVersionDestroyMutationVariables>(FormTemplateVersionDestroyDocument, options);
      }
export type FormTemplateVersionDestroyMutationHookResult = ReturnType<typeof useFormTemplateVersionDestroyMutation>;
export type FormTemplateVersionDestroyMutationResult = ApolloReactCommon.MutationResult<FormTemplateVersionDestroyMutation>;
export const FormChecklistTemplateDocument = gql`
    query formChecklistTemplate($id: ID!) {
  data: formChecklistTemplate(id: $id) {
    ...formChecklistTemplateWithOptionsFragment
  }
}
    ${FormChecklistTemplateWithOptionsFragmentFragmentDoc}
${FormChecklistTemplateFragmentFragmentDoc}
${AuthorizationResultFragmentFragmentDoc}`;

/**
 * __useFormChecklistTemplateQuery__
 *
 * To run a query within a React component, call `useFormChecklistTemplateQuery` and pass it any options that fit your needs.
 * When your component renders, `useFormChecklistTemplateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFormChecklistTemplateQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useFormChecklistTemplateQuery(baseOptions: ApolloReactHooks.QueryHookOptions<FormChecklistTemplateQuery, FormChecklistTemplateQueryVariables> & ({ variables: FormChecklistTemplateQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<FormChecklistTemplateQuery, FormChecklistTemplateQueryVariables>(FormChecklistTemplateDocument, options);
      }
export function useFormChecklistTemplateLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<FormChecklistTemplateQuery, FormChecklistTemplateQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<FormChecklistTemplateQuery, FormChecklistTemplateQueryVariables>(FormChecklistTemplateDocument, options);
        }
// @ts-ignore
export function useFormChecklistTemplateSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<FormChecklistTemplateQuery, FormChecklistTemplateQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<FormChecklistTemplateQuery, FormChecklistTemplateQueryVariables>;
// @ts-ignore
export function useFormChecklistTemplateSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<FormChecklistTemplateQuery, FormChecklistTemplateQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<FormChecklistTemplateQuery | undefined, FormChecklistTemplateQueryVariables>;
export function useFormChecklistTemplateSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<FormChecklistTemplateQuery, FormChecklistTemplateQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          // @ts-ignore
          return ApolloReactHooks.useSuspenseQuery<FormChecklistTemplateQuery, FormChecklistTemplateQueryVariables>(FormChecklistTemplateDocument, options);
        }
export type FormChecklistTemplateQueryHookResult = ReturnType<typeof useFormChecklistTemplateQuery>;
export type FormChecklistTemplateLazyQueryHookResult = ReturnType<typeof useFormChecklistTemplateLazyQuery>;
export type FormChecklistTemplateSuspenseQueryHookResult = ReturnType<typeof useFormChecklistTemplateSuspenseQuery>;
export type FormChecklistTemplateQueryResult = ApolloReactCommon.QueryResult<FormChecklistTemplateQuery, FormChecklistTemplateQueryVariables>;
export function refetchFormChecklistTemplateQuery(variables: FormChecklistTemplateQueryVariables) {
      return { query: FormChecklistTemplateDocument, variables: variables }
    }
export const FormChecklistTemplatesDocument = gql`
    query formChecklistTemplates($page: Int, $limit: Int, $filters: [FormChecklistTemplateFilterInputObject!], $sorts: FormChecklistTemplateSortInputObject) {
  data: formChecklistTemplates(
    page: $page
    limit: $limit
    filters: $filters
    sorts: $sorts
  ) {
    collection {
      ...formChecklistTemplateFragment
    }
    metadata {
      ...metadataFragment
    }
  }
}
    ${FormChecklistTemplateFragmentFragmentDoc}
${AuthorizationResultFragmentFragmentDoc}
${MetadataFragmentFragmentDoc}`;

/**
 * __useFormChecklistTemplatesQuery__
 *
 * To run a query within a React component, call `useFormChecklistTemplatesQuery` and pass it any options that fit your needs.
 * When your component renders, `useFormChecklistTemplatesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFormChecklistTemplatesQuery({
 *   variables: {
 *      page: // value for 'page'
 *      limit: // value for 'limit'
 *      filters: // value for 'filters'
 *      sorts: // value for 'sorts'
 *   },
 * });
 */
export function useFormChecklistTemplatesQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<FormChecklistTemplatesQuery, FormChecklistTemplatesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<FormChecklistTemplatesQuery, FormChecklistTemplatesQueryVariables>(FormChecklistTemplatesDocument, options);
      }
export function useFormChecklistTemplatesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<FormChecklistTemplatesQuery, FormChecklistTemplatesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<FormChecklistTemplatesQuery, FormChecklistTemplatesQueryVariables>(FormChecklistTemplatesDocument, options);
        }
// @ts-ignore
export function useFormChecklistTemplatesSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<FormChecklistTemplatesQuery, FormChecklistTemplatesQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<FormChecklistTemplatesQuery, FormChecklistTemplatesQueryVariables>;
// @ts-ignore
export function useFormChecklistTemplatesSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<FormChecklistTemplatesQuery, FormChecklistTemplatesQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<FormChecklistTemplatesQuery | undefined, FormChecklistTemplatesQueryVariables>;
export function useFormChecklistTemplatesSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<FormChecklistTemplatesQuery, FormChecklistTemplatesQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          // @ts-ignore
          return ApolloReactHooks.useSuspenseQuery<FormChecklistTemplatesQuery, FormChecklistTemplatesQueryVariables>(FormChecklistTemplatesDocument, options);
        }
export type FormChecklistTemplatesQueryHookResult = ReturnType<typeof useFormChecklistTemplatesQuery>;
export type FormChecklistTemplatesLazyQueryHookResult = ReturnType<typeof useFormChecklistTemplatesLazyQuery>;
export type FormChecklistTemplatesSuspenseQueryHookResult = ReturnType<typeof useFormChecklistTemplatesSuspenseQuery>;
export type FormChecklistTemplatesQueryResult = ApolloReactCommon.QueryResult<FormChecklistTemplatesQuery, FormChecklistTemplatesQueryVariables>;
export function refetchFormChecklistTemplatesQuery(variables?: FormChecklistTemplatesQueryVariables) {
      return { query: FormChecklistTemplatesDocument, variables: variables }
    }
export const FormChecklistTemplateIdsDocument = gql`
    query formChecklistTemplateIds($filters: [FormChecklistTemplateFilterInputObject!], $sorts: FormChecklistTemplateSortInputObject, $onlyIds: Boolean) {
  data: formChecklistTemplates(
    filters: $filters
    sorts: $sorts
    onlyIds: $onlyIds
  ) {
    collection {
      id
    }
  }
}
    `;

/**
 * __useFormChecklistTemplateIdsQuery__
 *
 * To run a query within a React component, call `useFormChecklistTemplateIdsQuery` and pass it any options that fit your needs.
 * When your component renders, `useFormChecklistTemplateIdsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFormChecklistTemplateIdsQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      sorts: // value for 'sorts'
 *      onlyIds: // value for 'onlyIds'
 *   },
 * });
 */
export function useFormChecklistTemplateIdsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<FormChecklistTemplateIdsQuery, FormChecklistTemplateIdsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<FormChecklistTemplateIdsQuery, FormChecklistTemplateIdsQueryVariables>(FormChecklistTemplateIdsDocument, options);
      }
export function useFormChecklistTemplateIdsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<FormChecklistTemplateIdsQuery, FormChecklistTemplateIdsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<FormChecklistTemplateIdsQuery, FormChecklistTemplateIdsQueryVariables>(FormChecklistTemplateIdsDocument, options);
        }
// @ts-ignore
export function useFormChecklistTemplateIdsSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<FormChecklistTemplateIdsQuery, FormChecklistTemplateIdsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<FormChecklistTemplateIdsQuery, FormChecklistTemplateIdsQueryVariables>;
// @ts-ignore
export function useFormChecklistTemplateIdsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<FormChecklistTemplateIdsQuery, FormChecklistTemplateIdsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<FormChecklistTemplateIdsQuery | undefined, FormChecklistTemplateIdsQueryVariables>;
export function useFormChecklistTemplateIdsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<FormChecklistTemplateIdsQuery, FormChecklistTemplateIdsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          // @ts-ignore
          return ApolloReactHooks.useSuspenseQuery<FormChecklistTemplateIdsQuery, FormChecklistTemplateIdsQueryVariables>(FormChecklistTemplateIdsDocument, options);
        }
export type FormChecklistTemplateIdsQueryHookResult = ReturnType<typeof useFormChecklistTemplateIdsQuery>;
export type FormChecklistTemplateIdsLazyQueryHookResult = ReturnType<typeof useFormChecklistTemplateIdsLazyQuery>;
export type FormChecklistTemplateIdsSuspenseQueryHookResult = ReturnType<typeof useFormChecklistTemplateIdsSuspenseQuery>;
export type FormChecklistTemplateIdsQueryResult = ApolloReactCommon.QueryResult<FormChecklistTemplateIdsQuery, FormChecklistTemplateIdsQueryVariables>;
export function refetchFormChecklistTemplateIdsQuery(variables?: FormChecklistTemplateIdsQueryVariables) {
      return { query: FormChecklistTemplateIdsDocument, variables: variables }
    }
export const FormChecklistTemplatesSearchListDocument = gql`
    query formChecklistTemplatesSearchList($page: Int, $limit: Int, $filters: [FormChecklistTemplateFilterInputObject!], $sorts: FormChecklistTemplateSortInputObject) {
  data: formChecklistTemplates(
    page: $page
    limit: $limit
    filters: $filters
    sorts: $sorts
  ) {
    collection {
      id
      name
    }
    metadata {
      ...metadataFragment
    }
  }
}
    ${MetadataFragmentFragmentDoc}`;

/**
 * __useFormChecklistTemplatesSearchListQuery__
 *
 * To run a query within a React component, call `useFormChecklistTemplatesSearchListQuery` and pass it any options that fit your needs.
 * When your component renders, `useFormChecklistTemplatesSearchListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFormChecklistTemplatesSearchListQuery({
 *   variables: {
 *      page: // value for 'page'
 *      limit: // value for 'limit'
 *      filters: // value for 'filters'
 *      sorts: // value for 'sorts'
 *   },
 * });
 */
export function useFormChecklistTemplatesSearchListQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<FormChecklistTemplatesSearchListQuery, FormChecklistTemplatesSearchListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<FormChecklistTemplatesSearchListQuery, FormChecklistTemplatesSearchListQueryVariables>(FormChecklistTemplatesSearchListDocument, options);
      }
export function useFormChecklistTemplatesSearchListLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<FormChecklistTemplatesSearchListQuery, FormChecklistTemplatesSearchListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<FormChecklistTemplatesSearchListQuery, FormChecklistTemplatesSearchListQueryVariables>(FormChecklistTemplatesSearchListDocument, options);
        }
// @ts-ignore
export function useFormChecklistTemplatesSearchListSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<FormChecklistTemplatesSearchListQuery, FormChecklistTemplatesSearchListQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<FormChecklistTemplatesSearchListQuery, FormChecklistTemplatesSearchListQueryVariables>;
// @ts-ignore
export function useFormChecklistTemplatesSearchListSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<FormChecklistTemplatesSearchListQuery, FormChecklistTemplatesSearchListQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<FormChecklistTemplatesSearchListQuery | undefined, FormChecklistTemplatesSearchListQueryVariables>;
export function useFormChecklistTemplatesSearchListSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<FormChecklistTemplatesSearchListQuery, FormChecklistTemplatesSearchListQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          // @ts-ignore
          return ApolloReactHooks.useSuspenseQuery<FormChecklistTemplatesSearchListQuery, FormChecklistTemplatesSearchListQueryVariables>(FormChecklistTemplatesSearchListDocument, options);
        }
export type FormChecklistTemplatesSearchListQueryHookResult = ReturnType<typeof useFormChecklistTemplatesSearchListQuery>;
export type FormChecklistTemplatesSearchListLazyQueryHookResult = ReturnType<typeof useFormChecklistTemplatesSearchListLazyQuery>;
export type FormChecklistTemplatesSearchListSuspenseQueryHookResult = ReturnType<typeof useFormChecklistTemplatesSearchListSuspenseQuery>;
export type FormChecklistTemplatesSearchListQueryResult = ApolloReactCommon.QueryResult<FormChecklistTemplatesSearchListQuery, FormChecklistTemplatesSearchListQueryVariables>;
export function refetchFormChecklistTemplatesSearchListQuery(variables?: FormChecklistTemplatesSearchListQueryVariables) {
      return { query: FormChecklistTemplatesSearchListDocument, variables: variables }
    }
export const FormChecklistTemplateCreateDocument = gql`
    mutation formChecklistTemplateCreate($attributes: FormChecklistTemplateCreateInputObject!) {
  data: formChecklistTemplateCreate(input: {attributes: $attributes}) {
    ...formChecklistTemplateWithOptionsFragment
    options {
      value
      position
      updatedAt
    }
  }
}
    ${FormChecklistTemplateWithOptionsFragmentFragmentDoc}
${FormChecklistTemplateFragmentFragmentDoc}
${AuthorizationResultFragmentFragmentDoc}`;

/**
 * __useFormChecklistTemplateCreateMutation__
 *
 * To run a mutation, you first call `useFormChecklistTemplateCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useFormChecklistTemplateCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [formChecklistTemplateCreateMutation, { data, loading, error }] = useFormChecklistTemplateCreateMutation({
 *   variables: {
 *      attributes: // value for 'attributes'
 *   },
 * });
 */
export function useFormChecklistTemplateCreateMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<FormChecklistTemplateCreateMutation, FormChecklistTemplateCreateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<FormChecklistTemplateCreateMutation, FormChecklistTemplateCreateMutationVariables>(FormChecklistTemplateCreateDocument, options);
      }
export type FormChecklistTemplateCreateMutationHookResult = ReturnType<typeof useFormChecklistTemplateCreateMutation>;
export type FormChecklistTemplateCreateMutationResult = ApolloReactCommon.MutationResult<FormChecklistTemplateCreateMutation>;
export const FormChecklistTemplateUpdateDocument = gql`
    mutation formChecklistTemplateUpdate($id: ID!, $attributes: FormChecklistTemplateUpdateInputObject!) {
  data: formChecklistTemplateUpdate(input: {id: $id, attributes: $attributes}) {
    ...formChecklistTemplateWithOptionsFragment
    options {
      value
      position
      updatedAt
    }
  }
}
    ${FormChecklistTemplateWithOptionsFragmentFragmentDoc}
${FormChecklistTemplateFragmentFragmentDoc}
${AuthorizationResultFragmentFragmentDoc}`;

/**
 * __useFormChecklistTemplateUpdateMutation__
 *
 * To run a mutation, you first call `useFormChecklistTemplateUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useFormChecklistTemplateUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [formChecklistTemplateUpdateMutation, { data, loading, error }] = useFormChecklistTemplateUpdateMutation({
 *   variables: {
 *      id: // value for 'id'
 *      attributes: // value for 'attributes'
 *   },
 * });
 */
export function useFormChecklistTemplateUpdateMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<FormChecklistTemplateUpdateMutation, FormChecklistTemplateUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<FormChecklistTemplateUpdateMutation, FormChecklistTemplateUpdateMutationVariables>(FormChecklistTemplateUpdateDocument, options);
      }
export type FormChecklistTemplateUpdateMutationHookResult = ReturnType<typeof useFormChecklistTemplateUpdateMutation>;
export type FormChecklistTemplateUpdateMutationResult = ApolloReactCommon.MutationResult<FormChecklistTemplateUpdateMutation>;
export const FormChecklistTemplateDestroyDocument = gql`
    mutation formChecklistTemplateDestroy($id: ID!) {
  data: formChecklistTemplateDestroy(input: {id: $id})
}
    `;

/**
 * __useFormChecklistTemplateDestroyMutation__
 *
 * To run a mutation, you first call `useFormChecklistTemplateDestroyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useFormChecklistTemplateDestroyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [formChecklistTemplateDestroyMutation, { data, loading, error }] = useFormChecklistTemplateDestroyMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useFormChecklistTemplateDestroyMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<FormChecklistTemplateDestroyMutation, FormChecklistTemplateDestroyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<FormChecklistTemplateDestroyMutation, FormChecklistTemplateDestroyMutationVariables>(FormChecklistTemplateDestroyDocument, options);
      }
export type FormChecklistTemplateDestroyMutationHookResult = ReturnType<typeof useFormChecklistTemplateDestroyMutation>;
export type FormChecklistTemplateDestroyMutationResult = ApolloReactCommon.MutationResult<FormChecklistTemplateDestroyMutation>;
export const HomePageDocument = gql`
    query homePage($id: ID!) {
  data: homePage(id: $id) {
    ...homePageFragment
  }
}
    ${HomePageFragmentFragmentDoc}
${AuthorizationResultFragmentFragmentDoc}`;

/**
 * __useHomePageQuery__
 *
 * To run a query within a React component, call `useHomePageQuery` and pass it any options that fit your needs.
 * When your component renders, `useHomePageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useHomePageQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useHomePageQuery(baseOptions: ApolloReactHooks.QueryHookOptions<HomePageQuery, HomePageQueryVariables> & ({ variables: HomePageQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<HomePageQuery, HomePageQueryVariables>(HomePageDocument, options);
      }
export function useHomePageLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<HomePageQuery, HomePageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<HomePageQuery, HomePageQueryVariables>(HomePageDocument, options);
        }
// @ts-ignore
export function useHomePageSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<HomePageQuery, HomePageQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<HomePageQuery, HomePageQueryVariables>;
// @ts-ignore
export function useHomePageSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<HomePageQuery, HomePageQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<HomePageQuery | undefined, HomePageQueryVariables>;
export function useHomePageSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<HomePageQuery, HomePageQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          // @ts-ignore
          return ApolloReactHooks.useSuspenseQuery<HomePageQuery, HomePageQueryVariables>(HomePageDocument, options);
        }
export type HomePageQueryHookResult = ReturnType<typeof useHomePageQuery>;
export type HomePageLazyQueryHookResult = ReturnType<typeof useHomePageLazyQuery>;
export type HomePageSuspenseQueryHookResult = ReturnType<typeof useHomePageSuspenseQuery>;
export type HomePageQueryResult = ApolloReactCommon.QueryResult<HomePageQuery, HomePageQueryVariables>;
export function refetchHomePageQuery(variables: HomePageQueryVariables) {
      return { query: HomePageDocument, variables: variables }
    }
export const HomePagesDocument = gql`
    query homePages($page: Int, $limit: Int) {
  data: homePages(page: $page, limit: $limit) {
    collection {
      ...homePageFragment
    }
    metadata {
      ...metadataFragment
    }
  }
}
    ${HomePageFragmentFragmentDoc}
${AuthorizationResultFragmentFragmentDoc}
${MetadataFragmentFragmentDoc}`;

/**
 * __useHomePagesQuery__
 *
 * To run a query within a React component, call `useHomePagesQuery` and pass it any options that fit your needs.
 * When your component renders, `useHomePagesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useHomePagesQuery({
 *   variables: {
 *      page: // value for 'page'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useHomePagesQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<HomePagesQuery, HomePagesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<HomePagesQuery, HomePagesQueryVariables>(HomePagesDocument, options);
      }
export function useHomePagesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<HomePagesQuery, HomePagesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<HomePagesQuery, HomePagesQueryVariables>(HomePagesDocument, options);
        }
// @ts-ignore
export function useHomePagesSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<HomePagesQuery, HomePagesQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<HomePagesQuery, HomePagesQueryVariables>;
// @ts-ignore
export function useHomePagesSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<HomePagesQuery, HomePagesQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<HomePagesQuery | undefined, HomePagesQueryVariables>;
export function useHomePagesSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<HomePagesQuery, HomePagesQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          // @ts-ignore
          return ApolloReactHooks.useSuspenseQuery<HomePagesQuery, HomePagesQueryVariables>(HomePagesDocument, options);
        }
export type HomePagesQueryHookResult = ReturnType<typeof useHomePagesQuery>;
export type HomePagesLazyQueryHookResult = ReturnType<typeof useHomePagesLazyQuery>;
export type HomePagesSuspenseQueryHookResult = ReturnType<typeof useHomePagesSuspenseQuery>;
export type HomePagesQueryResult = ApolloReactCommon.QueryResult<HomePagesQuery, HomePagesQueryVariables>;
export function refetchHomePagesQuery(variables?: HomePagesQueryVariables) {
      return { query: HomePagesDocument, variables: variables }
    }
export const WidgetDocument = gql`
    query widget($homePageId: ID!, $id: ID!) {
  data: widget(homePageId: $homePageId, id: $id) {
    ...widgetFragment
  }
}
    ${WidgetFragmentFragmentDoc}
${AttachmentFragmentFragmentDoc}`;

/**
 * __useWidgetQuery__
 *
 * To run a query within a React component, call `useWidgetQuery` and pass it any options that fit your needs.
 * When your component renders, `useWidgetQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWidgetQuery({
 *   variables: {
 *      homePageId: // value for 'homePageId'
 *      id: // value for 'id'
 *   },
 * });
 */
export function useWidgetQuery(baseOptions: ApolloReactHooks.QueryHookOptions<WidgetQuery, WidgetQueryVariables> & ({ variables: WidgetQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<WidgetQuery, WidgetQueryVariables>(WidgetDocument, options);
      }
export function useWidgetLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<WidgetQuery, WidgetQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<WidgetQuery, WidgetQueryVariables>(WidgetDocument, options);
        }
// @ts-ignore
export function useWidgetSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<WidgetQuery, WidgetQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<WidgetQuery, WidgetQueryVariables>;
// @ts-ignore
export function useWidgetSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<WidgetQuery, WidgetQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<WidgetQuery | undefined, WidgetQueryVariables>;
export function useWidgetSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<WidgetQuery, WidgetQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          // @ts-ignore
          return ApolloReactHooks.useSuspenseQuery<WidgetQuery, WidgetQueryVariables>(WidgetDocument, options);
        }
export type WidgetQueryHookResult = ReturnType<typeof useWidgetQuery>;
export type WidgetLazyQueryHookResult = ReturnType<typeof useWidgetLazyQuery>;
export type WidgetSuspenseQueryHookResult = ReturnType<typeof useWidgetSuspenseQuery>;
export type WidgetQueryResult = ApolloReactCommon.QueryResult<WidgetQuery, WidgetQueryVariables>;
export function refetchWidgetQuery(variables: WidgetQueryVariables) {
      return { query: WidgetDocument, variables: variables }
    }
export const WidgetsDocument = gql`
    query widgets($homePageId: ID!) {
  data: widgets(homePageId: $homePageId) {
    ...widgetFragment
  }
}
    ${WidgetFragmentFragmentDoc}
${AttachmentFragmentFragmentDoc}`;

/**
 * __useWidgetsQuery__
 *
 * To run a query within a React component, call `useWidgetsQuery` and pass it any options that fit your needs.
 * When your component renders, `useWidgetsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWidgetsQuery({
 *   variables: {
 *      homePageId: // value for 'homePageId'
 *   },
 * });
 */
export function useWidgetsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<WidgetsQuery, WidgetsQueryVariables> & ({ variables: WidgetsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<WidgetsQuery, WidgetsQueryVariables>(WidgetsDocument, options);
      }
export function useWidgetsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<WidgetsQuery, WidgetsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<WidgetsQuery, WidgetsQueryVariables>(WidgetsDocument, options);
        }
// @ts-ignore
export function useWidgetsSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<WidgetsQuery, WidgetsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<WidgetsQuery, WidgetsQueryVariables>;
// @ts-ignore
export function useWidgetsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<WidgetsQuery, WidgetsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<WidgetsQuery | undefined, WidgetsQueryVariables>;
export function useWidgetsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<WidgetsQuery, WidgetsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          // @ts-ignore
          return ApolloReactHooks.useSuspenseQuery<WidgetsQuery, WidgetsQueryVariables>(WidgetsDocument, options);
        }
export type WidgetsQueryHookResult = ReturnType<typeof useWidgetsQuery>;
export type WidgetsLazyQueryHookResult = ReturnType<typeof useWidgetsLazyQuery>;
export type WidgetsSuspenseQueryHookResult = ReturnType<typeof useWidgetsSuspenseQuery>;
export type WidgetsQueryResult = ApolloReactCommon.QueryResult<WidgetsQuery, WidgetsQueryVariables>;
export function refetchWidgetsQuery(variables: WidgetsQueryVariables) {
      return { query: WidgetsDocument, variables: variables }
    }
export const WidgetTemplateDocument = gql`
    query widgetTemplate($id: ID!) {
  data: widgetTemplate(id: $id) {
    ...widgetTemplateFragment
  }
}
    ${WidgetTemplateFragmentFragmentDoc}
${AttachmentFragmentFragmentDoc}`;

/**
 * __useWidgetTemplateQuery__
 *
 * To run a query within a React component, call `useWidgetTemplateQuery` and pass it any options that fit your needs.
 * When your component renders, `useWidgetTemplateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWidgetTemplateQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useWidgetTemplateQuery(baseOptions: ApolloReactHooks.QueryHookOptions<WidgetTemplateQuery, WidgetTemplateQueryVariables> & ({ variables: WidgetTemplateQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<WidgetTemplateQuery, WidgetTemplateQueryVariables>(WidgetTemplateDocument, options);
      }
export function useWidgetTemplateLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<WidgetTemplateQuery, WidgetTemplateQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<WidgetTemplateQuery, WidgetTemplateQueryVariables>(WidgetTemplateDocument, options);
        }
// @ts-ignore
export function useWidgetTemplateSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<WidgetTemplateQuery, WidgetTemplateQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<WidgetTemplateQuery, WidgetTemplateQueryVariables>;
// @ts-ignore
export function useWidgetTemplateSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<WidgetTemplateQuery, WidgetTemplateQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<WidgetTemplateQuery | undefined, WidgetTemplateQueryVariables>;
export function useWidgetTemplateSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<WidgetTemplateQuery, WidgetTemplateQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          // @ts-ignore
          return ApolloReactHooks.useSuspenseQuery<WidgetTemplateQuery, WidgetTemplateQueryVariables>(WidgetTemplateDocument, options);
        }
export type WidgetTemplateQueryHookResult = ReturnType<typeof useWidgetTemplateQuery>;
export type WidgetTemplateLazyQueryHookResult = ReturnType<typeof useWidgetTemplateLazyQuery>;
export type WidgetTemplateSuspenseQueryHookResult = ReturnType<typeof useWidgetTemplateSuspenseQuery>;
export type WidgetTemplateQueryResult = ApolloReactCommon.QueryResult<WidgetTemplateQuery, WidgetTemplateQueryVariables>;
export function refetchWidgetTemplateQuery(variables: WidgetTemplateQueryVariables) {
      return { query: WidgetTemplateDocument, variables: variables }
    }
export const WidgetTemplatesDocument = gql`
    query widgetTemplates($page: Int, $limit: Int, $sorts: WidgetTemplateSortInputObject, $filters: [WidgetTemplateFilterInputObject!], $onlyIds: Boolean) {
  data: widgetTemplates(
    page: $page
    limit: $limit
    sorts: $sorts
    filters: $filters
    onlyIds: $onlyIds
  ) {
    collection {
      ...widgetTemplateFragment
    }
    metadata {
      ...metadataFragment
    }
  }
}
    ${WidgetTemplateFragmentFragmentDoc}
${AttachmentFragmentFragmentDoc}
${MetadataFragmentFragmentDoc}`;

/**
 * __useWidgetTemplatesQuery__
 *
 * To run a query within a React component, call `useWidgetTemplatesQuery` and pass it any options that fit your needs.
 * When your component renders, `useWidgetTemplatesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWidgetTemplatesQuery({
 *   variables: {
 *      page: // value for 'page'
 *      limit: // value for 'limit'
 *      sorts: // value for 'sorts'
 *      filters: // value for 'filters'
 *      onlyIds: // value for 'onlyIds'
 *   },
 * });
 */
export function useWidgetTemplatesQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<WidgetTemplatesQuery, WidgetTemplatesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<WidgetTemplatesQuery, WidgetTemplatesQueryVariables>(WidgetTemplatesDocument, options);
      }
export function useWidgetTemplatesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<WidgetTemplatesQuery, WidgetTemplatesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<WidgetTemplatesQuery, WidgetTemplatesQueryVariables>(WidgetTemplatesDocument, options);
        }
// @ts-ignore
export function useWidgetTemplatesSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<WidgetTemplatesQuery, WidgetTemplatesQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<WidgetTemplatesQuery, WidgetTemplatesQueryVariables>;
// @ts-ignore
export function useWidgetTemplatesSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<WidgetTemplatesQuery, WidgetTemplatesQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<WidgetTemplatesQuery | undefined, WidgetTemplatesQueryVariables>;
export function useWidgetTemplatesSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<WidgetTemplatesQuery, WidgetTemplatesQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          // @ts-ignore
          return ApolloReactHooks.useSuspenseQuery<WidgetTemplatesQuery, WidgetTemplatesQueryVariables>(WidgetTemplatesDocument, options);
        }
export type WidgetTemplatesQueryHookResult = ReturnType<typeof useWidgetTemplatesQuery>;
export type WidgetTemplatesLazyQueryHookResult = ReturnType<typeof useWidgetTemplatesLazyQuery>;
export type WidgetTemplatesSuspenseQueryHookResult = ReturnType<typeof useWidgetTemplatesSuspenseQuery>;
export type WidgetTemplatesQueryResult = ApolloReactCommon.QueryResult<WidgetTemplatesQuery, WidgetTemplatesQueryVariables>;
export function refetchWidgetTemplatesQuery(variables?: WidgetTemplatesQueryVariables) {
      return { query: WidgetTemplatesDocument, variables: variables }
    }
export const WidgetTemplatesWithCountersDocument = gql`
    query widgetTemplatesWithCounters($page: Int, $limit: Int, $sorts: WidgetTemplateSortInputObject, $filters: [WidgetTemplateFilterInputObject!], $allTemplatesFilters: [WidgetTemplateFilterInputObject!], $publicTemplatesFilters: [WidgetTemplateFilterInputObject!], $privateTemplatesFilters: [WidgetTemplateFilterInputObject!]) {
  data: widgetTemplates(
    page: $page
    limit: $limit
    sorts: $sorts
    filters: $filters
  ) {
    collection {
      id
      title
      description
      kind
      fields {
        backgroundColor
        content
        link
      }
      attachmentsAttached {
        ...attachmentFragment
      }
    }
    metadata {
      ...metadataFragment
    }
  }
  allTemplates: widgetTemplates(filters: $allTemplatesFilters, onlyIds: true) {
    collection {
      id
    }
  }
  publicTemplates: widgetTemplates(
    filters: $publicTemplatesFilters
    onlyIds: true
  ) {
    collection {
      id
    }
  }
  privateTemplates: widgetTemplates(
    filters: $privateTemplatesFilters
    onlyIds: true
  ) {
    collection {
      id
    }
  }
}
    ${AttachmentFragmentFragmentDoc}
${MetadataFragmentFragmentDoc}`;

/**
 * __useWidgetTemplatesWithCountersQuery__
 *
 * To run a query within a React component, call `useWidgetTemplatesWithCountersQuery` and pass it any options that fit your needs.
 * When your component renders, `useWidgetTemplatesWithCountersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWidgetTemplatesWithCountersQuery({
 *   variables: {
 *      page: // value for 'page'
 *      limit: // value for 'limit'
 *      sorts: // value for 'sorts'
 *      filters: // value for 'filters'
 *      allTemplatesFilters: // value for 'allTemplatesFilters'
 *      publicTemplatesFilters: // value for 'publicTemplatesFilters'
 *      privateTemplatesFilters: // value for 'privateTemplatesFilters'
 *   },
 * });
 */
export function useWidgetTemplatesWithCountersQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<WidgetTemplatesWithCountersQuery, WidgetTemplatesWithCountersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<WidgetTemplatesWithCountersQuery, WidgetTemplatesWithCountersQueryVariables>(WidgetTemplatesWithCountersDocument, options);
      }
export function useWidgetTemplatesWithCountersLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<WidgetTemplatesWithCountersQuery, WidgetTemplatesWithCountersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<WidgetTemplatesWithCountersQuery, WidgetTemplatesWithCountersQueryVariables>(WidgetTemplatesWithCountersDocument, options);
        }
// @ts-ignore
export function useWidgetTemplatesWithCountersSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<WidgetTemplatesWithCountersQuery, WidgetTemplatesWithCountersQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<WidgetTemplatesWithCountersQuery, WidgetTemplatesWithCountersQueryVariables>;
// @ts-ignore
export function useWidgetTemplatesWithCountersSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<WidgetTemplatesWithCountersQuery, WidgetTemplatesWithCountersQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<WidgetTemplatesWithCountersQuery | undefined, WidgetTemplatesWithCountersQueryVariables>;
export function useWidgetTemplatesWithCountersSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<WidgetTemplatesWithCountersQuery, WidgetTemplatesWithCountersQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          // @ts-ignore
          return ApolloReactHooks.useSuspenseQuery<WidgetTemplatesWithCountersQuery, WidgetTemplatesWithCountersQueryVariables>(WidgetTemplatesWithCountersDocument, options);
        }
export type WidgetTemplatesWithCountersQueryHookResult = ReturnType<typeof useWidgetTemplatesWithCountersQuery>;
export type WidgetTemplatesWithCountersLazyQueryHookResult = ReturnType<typeof useWidgetTemplatesWithCountersLazyQuery>;
export type WidgetTemplatesWithCountersSuspenseQueryHookResult = ReturnType<typeof useWidgetTemplatesWithCountersSuspenseQuery>;
export type WidgetTemplatesWithCountersQueryResult = ApolloReactCommon.QueryResult<WidgetTemplatesWithCountersQuery, WidgetTemplatesWithCountersQueryVariables>;
export function refetchWidgetTemplatesWithCountersQuery(variables?: WidgetTemplatesWithCountersQueryVariables) {
      return { query: WidgetTemplatesWithCountersDocument, variables: variables }
    }
export const HomePageBulkUpdateDocument = gql`
    mutation homePageBulkUpdate($attributes: [HomePageUpdateInputObject!]!) {
  data: homePageBulkUpdate(input: {attributes: $attributes})
}
    `;

/**
 * __useHomePageBulkUpdateMutation__
 *
 * To run a mutation, you first call `useHomePageBulkUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useHomePageBulkUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [homePageBulkUpdateMutation, { data, loading, error }] = useHomePageBulkUpdateMutation({
 *   variables: {
 *      attributes: // value for 'attributes'
 *   },
 * });
 */
export function useHomePageBulkUpdateMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<HomePageBulkUpdateMutation, HomePageBulkUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<HomePageBulkUpdateMutation, HomePageBulkUpdateMutationVariables>(HomePageBulkUpdateDocument, options);
      }
export type HomePageBulkUpdateMutationHookResult = ReturnType<typeof useHomePageBulkUpdateMutation>;
export type HomePageBulkUpdateMutationResult = ApolloReactCommon.MutationResult<HomePageBulkUpdateMutation>;
export const WidgetBulkUpdateDocument = gql`
    mutation widgetBulkUpdate($homePageId: ID!, $attributes: [WidgetUpdateInputObject!]!) {
  data: widgetBulkUpdate(
    input: {homePageId: $homePageId, attributes: $attributes}
  )
}
    `;

/**
 * __useWidgetBulkUpdateMutation__
 *
 * To run a mutation, you first call `useWidgetBulkUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useWidgetBulkUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [widgetBulkUpdateMutation, { data, loading, error }] = useWidgetBulkUpdateMutation({
 *   variables: {
 *      homePageId: // value for 'homePageId'
 *      attributes: // value for 'attributes'
 *   },
 * });
 */
export function useWidgetBulkUpdateMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<WidgetBulkUpdateMutation, WidgetBulkUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<WidgetBulkUpdateMutation, WidgetBulkUpdateMutationVariables>(WidgetBulkUpdateDocument, options);
      }
export type WidgetBulkUpdateMutationHookResult = ReturnType<typeof useWidgetBulkUpdateMutation>;
export type WidgetBulkUpdateMutationResult = ApolloReactCommon.MutationResult<WidgetBulkUpdateMutation>;
export const WidgetTemplateCreateDocument = gql`
    mutation widgetTemplateCreate($attributes: WidgetTemplateCreateInputObject!) {
  data: widgetTemplateCreate(input: {attributes: $attributes}) {
    ...widgetTemplateFragment
  }
}
    ${WidgetTemplateFragmentFragmentDoc}
${AttachmentFragmentFragmentDoc}`;

/**
 * __useWidgetTemplateCreateMutation__
 *
 * To run a mutation, you first call `useWidgetTemplateCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useWidgetTemplateCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [widgetTemplateCreateMutation, { data, loading, error }] = useWidgetTemplateCreateMutation({
 *   variables: {
 *      attributes: // value for 'attributes'
 *   },
 * });
 */
export function useWidgetTemplateCreateMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<WidgetTemplateCreateMutation, WidgetTemplateCreateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<WidgetTemplateCreateMutation, WidgetTemplateCreateMutationVariables>(WidgetTemplateCreateDocument, options);
      }
export type WidgetTemplateCreateMutationHookResult = ReturnType<typeof useWidgetTemplateCreateMutation>;
export type WidgetTemplateCreateMutationResult = ApolloReactCommon.MutationResult<WidgetTemplateCreateMutation>;
export const WidgetTemplateDestroyDocument = gql`
    mutation widgetTemplateDestroy($id: ID!) {
  data: widgetTemplateDestroy(input: {id: $id})
}
    `;

/**
 * __useWidgetTemplateDestroyMutation__
 *
 * To run a mutation, you first call `useWidgetTemplateDestroyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useWidgetTemplateDestroyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [widgetTemplateDestroyMutation, { data, loading, error }] = useWidgetTemplateDestroyMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useWidgetTemplateDestroyMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<WidgetTemplateDestroyMutation, WidgetTemplateDestroyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<WidgetTemplateDestroyMutation, WidgetTemplateDestroyMutationVariables>(WidgetTemplateDestroyDocument, options);
      }
export type WidgetTemplateDestroyMutationHookResult = ReturnType<typeof useWidgetTemplateDestroyMutation>;
export type WidgetTemplateDestroyMutationResult = ApolloReactCommon.MutationResult<WidgetTemplateDestroyMutation>;
export const WidgetTemplateUpdateDocument = gql`
    mutation widgetTemplateUpdate($id: ID!, $attributes: WidgetTemplateUpdateInputObject!) {
  data: widgetTemplateUpdate(input: {id: $id, attributes: $attributes}) {
    ...widgetTemplateFragment
  }
}
    ${WidgetTemplateFragmentFragmentDoc}
${AttachmentFragmentFragmentDoc}`;

/**
 * __useWidgetTemplateUpdateMutation__
 *
 * To run a mutation, you first call `useWidgetTemplateUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useWidgetTemplateUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [widgetTemplateUpdateMutation, { data, loading, error }] = useWidgetTemplateUpdateMutation({
 *   variables: {
 *      id: // value for 'id'
 *      attributes: // value for 'attributes'
 *   },
 * });
 */
export function useWidgetTemplateUpdateMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<WidgetTemplateUpdateMutation, WidgetTemplateUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<WidgetTemplateUpdateMutation, WidgetTemplateUpdateMutationVariables>(WidgetTemplateUpdateDocument, options);
      }
export type WidgetTemplateUpdateMutationHookResult = ReturnType<typeof useWidgetTemplateUpdateMutation>;
export type WidgetTemplateUpdateMutationResult = ApolloReactCommon.MutationResult<WidgetTemplateUpdateMutation>;
export const InterventionsDocument = gql`
    query interventions($page: Int, $limit: Int, $sorts: InterventionSortInputObject, $filters: [InterventionFilterInputObject!], $scopeName: InterventionScopeNameEnum!) {
  data: interventions(
    page: $page
    limit: $limit
    sorts: $sorts
    filters: $filters
    scopeName: $scopeName
  ) {
    collection {
      id
      name
      createdAt
      closedAt
      code
      category {
        id
        name
        color
      }
      site {
        id
        name
      }
      siteArea {
        id
        name
      }
      asset {
        id
        name
        fullCode
        iconAttached {
          ...attachmentFragment
        }
      }
      priority
      status
      canUpdate {
        ...authorizationResultFragment
      }
      canDestroy {
        ...authorizationResultFragment
      }
      canClose {
        ...authorizationResultFragment
      }
    }
    metadata {
      ...metadataFragment
    }
  }
  openedCounter: interventions(scopeName: OPENED, filters: $filters) {
    metadata {
      totalCount
    }
  }
  closedCounter: interventions(scopeName: CLOSED, filters: $filters) {
    metadata {
      totalCount
    }
  }
}
    ${AttachmentFragmentFragmentDoc}
${AuthorizationResultFragmentFragmentDoc}
${MetadataFragmentFragmentDoc}`;

/**
 * __useInterventionsQuery__
 *
 * To run a query within a React component, call `useInterventionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useInterventionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInterventionsQuery({
 *   variables: {
 *      page: // value for 'page'
 *      limit: // value for 'limit'
 *      sorts: // value for 'sorts'
 *      filters: // value for 'filters'
 *      scopeName: // value for 'scopeName'
 *   },
 * });
 */
export function useInterventionsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<InterventionsQuery, InterventionsQueryVariables> & ({ variables: InterventionsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<InterventionsQuery, InterventionsQueryVariables>(InterventionsDocument, options);
      }
export function useInterventionsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<InterventionsQuery, InterventionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<InterventionsQuery, InterventionsQueryVariables>(InterventionsDocument, options);
        }
// @ts-ignore
export function useInterventionsSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<InterventionsQuery, InterventionsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<InterventionsQuery, InterventionsQueryVariables>;
// @ts-ignore
export function useInterventionsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<InterventionsQuery, InterventionsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<InterventionsQuery | undefined, InterventionsQueryVariables>;
export function useInterventionsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<InterventionsQuery, InterventionsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          // @ts-ignore
          return ApolloReactHooks.useSuspenseQuery<InterventionsQuery, InterventionsQueryVariables>(InterventionsDocument, options);
        }
export type InterventionsQueryHookResult = ReturnType<typeof useInterventionsQuery>;
export type InterventionsLazyQueryHookResult = ReturnType<typeof useInterventionsLazyQuery>;
export type InterventionsSuspenseQueryHookResult = ReturnType<typeof useInterventionsSuspenseQuery>;
export type InterventionsQueryResult = ApolloReactCommon.QueryResult<InterventionsQuery, InterventionsQueryVariables>;
export function refetchInterventionsQuery(variables: InterventionsQueryVariables) {
      return { query: InterventionsDocument, variables: variables }
    }
export const InterventionsIdsDocument = gql`
    query interventionsIds($page: Int, $limit: Int, $sorts: InterventionSortInputObject, $filters: [InterventionFilterInputObject!], $scopeName: InterventionScopeNameEnum!, $onlyIds: Boolean) {
  data: interventions(
    page: $page
    limit: $limit
    sorts: $sorts
    filters: $filters
    scopeName: $scopeName
    onlyIds: $onlyIds
  ) {
    collection {
      id
    }
  }
}
    `;

/**
 * __useInterventionsIdsQuery__
 *
 * To run a query within a React component, call `useInterventionsIdsQuery` and pass it any options that fit your needs.
 * When your component renders, `useInterventionsIdsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInterventionsIdsQuery({
 *   variables: {
 *      page: // value for 'page'
 *      limit: // value for 'limit'
 *      sorts: // value for 'sorts'
 *      filters: // value for 'filters'
 *      scopeName: // value for 'scopeName'
 *      onlyIds: // value for 'onlyIds'
 *   },
 * });
 */
export function useInterventionsIdsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<InterventionsIdsQuery, InterventionsIdsQueryVariables> & ({ variables: InterventionsIdsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<InterventionsIdsQuery, InterventionsIdsQueryVariables>(InterventionsIdsDocument, options);
      }
export function useInterventionsIdsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<InterventionsIdsQuery, InterventionsIdsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<InterventionsIdsQuery, InterventionsIdsQueryVariables>(InterventionsIdsDocument, options);
        }
// @ts-ignore
export function useInterventionsIdsSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<InterventionsIdsQuery, InterventionsIdsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<InterventionsIdsQuery, InterventionsIdsQueryVariables>;
// @ts-ignore
export function useInterventionsIdsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<InterventionsIdsQuery, InterventionsIdsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<InterventionsIdsQuery | undefined, InterventionsIdsQueryVariables>;
export function useInterventionsIdsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<InterventionsIdsQuery, InterventionsIdsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          // @ts-ignore
          return ApolloReactHooks.useSuspenseQuery<InterventionsIdsQuery, InterventionsIdsQueryVariables>(InterventionsIdsDocument, options);
        }
export type InterventionsIdsQueryHookResult = ReturnType<typeof useInterventionsIdsQuery>;
export type InterventionsIdsLazyQueryHookResult = ReturnType<typeof useInterventionsIdsLazyQuery>;
export type InterventionsIdsSuspenseQueryHookResult = ReturnType<typeof useInterventionsIdsSuspenseQuery>;
export type InterventionsIdsQueryResult = ApolloReactCommon.QueryResult<InterventionsIdsQuery, InterventionsIdsQueryVariables>;
export function refetchInterventionsIdsQuery(variables: InterventionsIdsQueryVariables) {
      return { query: InterventionsIdsDocument, variables: variables }
    }
export const InterventionsSearchListDocument = gql`
    query interventionsSearchList($page: Int, $limit: Int, $sorts: InterventionSortInputObject, $filters: [InterventionFilterInputObject!], $scopeName: InterventionScopeNameEnum!) {
  data: interventions(
    page: $page
    limit: $limit
    sorts: $sorts
    filters: $filters
    scopeName: $scopeName
  ) {
    collection {
      id
      name
      code
    }
    metadata {
      ...metadataFragment
    }
  }
}
    ${MetadataFragmentFragmentDoc}`;

/**
 * __useInterventionsSearchListQuery__
 *
 * To run a query within a React component, call `useInterventionsSearchListQuery` and pass it any options that fit your needs.
 * When your component renders, `useInterventionsSearchListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInterventionsSearchListQuery({
 *   variables: {
 *      page: // value for 'page'
 *      limit: // value for 'limit'
 *      sorts: // value for 'sorts'
 *      filters: // value for 'filters'
 *      scopeName: // value for 'scopeName'
 *   },
 * });
 */
export function useInterventionsSearchListQuery(baseOptions: ApolloReactHooks.QueryHookOptions<InterventionsSearchListQuery, InterventionsSearchListQueryVariables> & ({ variables: InterventionsSearchListQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<InterventionsSearchListQuery, InterventionsSearchListQueryVariables>(InterventionsSearchListDocument, options);
      }
export function useInterventionsSearchListLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<InterventionsSearchListQuery, InterventionsSearchListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<InterventionsSearchListQuery, InterventionsSearchListQueryVariables>(InterventionsSearchListDocument, options);
        }
// @ts-ignore
export function useInterventionsSearchListSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<InterventionsSearchListQuery, InterventionsSearchListQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<InterventionsSearchListQuery, InterventionsSearchListQueryVariables>;
// @ts-ignore
export function useInterventionsSearchListSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<InterventionsSearchListQuery, InterventionsSearchListQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<InterventionsSearchListQuery | undefined, InterventionsSearchListQueryVariables>;
export function useInterventionsSearchListSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<InterventionsSearchListQuery, InterventionsSearchListQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          // @ts-ignore
          return ApolloReactHooks.useSuspenseQuery<InterventionsSearchListQuery, InterventionsSearchListQueryVariables>(InterventionsSearchListDocument, options);
        }
export type InterventionsSearchListQueryHookResult = ReturnType<typeof useInterventionsSearchListQuery>;
export type InterventionsSearchListLazyQueryHookResult = ReturnType<typeof useInterventionsSearchListLazyQuery>;
export type InterventionsSearchListSuspenseQueryHookResult = ReturnType<typeof useInterventionsSearchListSuspenseQuery>;
export type InterventionsSearchListQueryResult = ApolloReactCommon.QueryResult<InterventionsSearchListQuery, InterventionsSearchListQueryVariables>;
export function refetchInterventionsSearchListQuery(variables: InterventionsSearchListQueryVariables) {
      return { query: InterventionsSearchListDocument, variables: variables }
    }
export const InterventionDocument = gql`
    query intervention($id: ID!) {
  data: intervention(id: $id) {
    ...interventionFragment
  }
  actionsCounter: interventionActions(interventionId: $id) {
    metadata {
      totalCount
    }
  }
}
    ${InterventionFragmentFragmentDoc}
${AttachmentFragmentFragmentDoc}
${AuthorizationResultFragmentFragmentDoc}`;

/**
 * __useInterventionQuery__
 *
 * To run a query within a React component, call `useInterventionQuery` and pass it any options that fit your needs.
 * When your component renders, `useInterventionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInterventionQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useInterventionQuery(baseOptions: ApolloReactHooks.QueryHookOptions<InterventionQuery, InterventionQueryVariables> & ({ variables: InterventionQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<InterventionQuery, InterventionQueryVariables>(InterventionDocument, options);
      }
export function useInterventionLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<InterventionQuery, InterventionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<InterventionQuery, InterventionQueryVariables>(InterventionDocument, options);
        }
// @ts-ignore
export function useInterventionSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<InterventionQuery, InterventionQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<InterventionQuery, InterventionQueryVariables>;
// @ts-ignore
export function useInterventionSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<InterventionQuery, InterventionQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<InterventionQuery | undefined, InterventionQueryVariables>;
export function useInterventionSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<InterventionQuery, InterventionQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          // @ts-ignore
          return ApolloReactHooks.useSuspenseQuery<InterventionQuery, InterventionQueryVariables>(InterventionDocument, options);
        }
export type InterventionQueryHookResult = ReturnType<typeof useInterventionQuery>;
export type InterventionLazyQueryHookResult = ReturnType<typeof useInterventionLazyQuery>;
export type InterventionSuspenseQueryHookResult = ReturnType<typeof useInterventionSuspenseQuery>;
export type InterventionQueryResult = ApolloReactCommon.QueryResult<InterventionQuery, InterventionQueryVariables>;
export function refetchInterventionQuery(variables: InterventionQueryVariables) {
      return { query: InterventionDocument, variables: variables }
    }
export const InterventionSiteIdDocument = gql`
    query interventionSiteId($id: ID!) {
  data: intervention(id: $id) {
    id
    siteId
    categoryId
  }
}
    `;

/**
 * __useInterventionSiteIdQuery__
 *
 * To run a query within a React component, call `useInterventionSiteIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useInterventionSiteIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInterventionSiteIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useInterventionSiteIdQuery(baseOptions: ApolloReactHooks.QueryHookOptions<InterventionSiteIdQuery, InterventionSiteIdQueryVariables> & ({ variables: InterventionSiteIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<InterventionSiteIdQuery, InterventionSiteIdQueryVariables>(InterventionSiteIdDocument, options);
      }
export function useInterventionSiteIdLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<InterventionSiteIdQuery, InterventionSiteIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<InterventionSiteIdQuery, InterventionSiteIdQueryVariables>(InterventionSiteIdDocument, options);
        }
// @ts-ignore
export function useInterventionSiteIdSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<InterventionSiteIdQuery, InterventionSiteIdQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<InterventionSiteIdQuery, InterventionSiteIdQueryVariables>;
// @ts-ignore
export function useInterventionSiteIdSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<InterventionSiteIdQuery, InterventionSiteIdQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<InterventionSiteIdQuery | undefined, InterventionSiteIdQueryVariables>;
export function useInterventionSiteIdSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<InterventionSiteIdQuery, InterventionSiteIdQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          // @ts-ignore
          return ApolloReactHooks.useSuspenseQuery<InterventionSiteIdQuery, InterventionSiteIdQueryVariables>(InterventionSiteIdDocument, options);
        }
export type InterventionSiteIdQueryHookResult = ReturnType<typeof useInterventionSiteIdQuery>;
export type InterventionSiteIdLazyQueryHookResult = ReturnType<typeof useInterventionSiteIdLazyQuery>;
export type InterventionSiteIdSuspenseQueryHookResult = ReturnType<typeof useInterventionSiteIdSuspenseQuery>;
export type InterventionSiteIdQueryResult = ApolloReactCommon.QueryResult<InterventionSiteIdQuery, InterventionSiteIdQueryVariables>;
export function refetchInterventionSiteIdQuery(variables: InterventionSiteIdQueryVariables) {
      return { query: InterventionSiteIdDocument, variables: variables }
    }
export const InterventionCategoryDocument = gql`
    query interventionCategory($id: ID!) {
  data: interventionCategory(id: $id) {
    ...interventionCategoryFragment
  }
}
    ${InterventionCategoryFragmentFragmentDoc}`;

/**
 * __useInterventionCategoryQuery__
 *
 * To run a query within a React component, call `useInterventionCategoryQuery` and pass it any options that fit your needs.
 * When your component renders, `useInterventionCategoryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInterventionCategoryQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useInterventionCategoryQuery(baseOptions: ApolloReactHooks.QueryHookOptions<InterventionCategoryQuery, InterventionCategoryQueryVariables> & ({ variables: InterventionCategoryQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<InterventionCategoryQuery, InterventionCategoryQueryVariables>(InterventionCategoryDocument, options);
      }
export function useInterventionCategoryLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<InterventionCategoryQuery, InterventionCategoryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<InterventionCategoryQuery, InterventionCategoryQueryVariables>(InterventionCategoryDocument, options);
        }
// @ts-ignore
export function useInterventionCategorySuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<InterventionCategoryQuery, InterventionCategoryQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<InterventionCategoryQuery, InterventionCategoryQueryVariables>;
// @ts-ignore
export function useInterventionCategorySuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<InterventionCategoryQuery, InterventionCategoryQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<InterventionCategoryQuery | undefined, InterventionCategoryQueryVariables>;
export function useInterventionCategorySuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<InterventionCategoryQuery, InterventionCategoryQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          // @ts-ignore
          return ApolloReactHooks.useSuspenseQuery<InterventionCategoryQuery, InterventionCategoryQueryVariables>(InterventionCategoryDocument, options);
        }
export type InterventionCategoryQueryHookResult = ReturnType<typeof useInterventionCategoryQuery>;
export type InterventionCategoryLazyQueryHookResult = ReturnType<typeof useInterventionCategoryLazyQuery>;
export type InterventionCategorySuspenseQueryHookResult = ReturnType<typeof useInterventionCategorySuspenseQuery>;
export type InterventionCategoryQueryResult = ApolloReactCommon.QueryResult<InterventionCategoryQuery, InterventionCategoryQueryVariables>;
export function refetchInterventionCategoryQuery(variables: InterventionCategoryQueryVariables) {
      return { query: InterventionCategoryDocument, variables: variables }
    }
export const InterventionCategoriesDocument = gql`
    query interventionCategories($page: Int, $limit: Int, $filters: [InterventionCategoryFilterInputObject!], $sorts: InterventionCategorySortInputObject) {
  data: interventionCategories(
    page: $page
    limit: $limit
    sorts: $sorts
    filters: $filters
  ) {
    collection {
      ...interventionCategoryFragment
      visibleInterventionsCount
      interventions {
        collection {
          id
          name
        }
      }
      canDestroy {
        ...authorizationResultFragment
      }
    }
    metadata {
      ...metadataFragment
    }
  }
}
    ${InterventionCategoryFragmentFragmentDoc}
${AuthorizationResultFragmentFragmentDoc}
${MetadataFragmentFragmentDoc}`;

/**
 * __useInterventionCategoriesQuery__
 *
 * To run a query within a React component, call `useInterventionCategoriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useInterventionCategoriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInterventionCategoriesQuery({
 *   variables: {
 *      page: // value for 'page'
 *      limit: // value for 'limit'
 *      filters: // value for 'filters'
 *      sorts: // value for 'sorts'
 *   },
 * });
 */
export function useInterventionCategoriesQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<InterventionCategoriesQuery, InterventionCategoriesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<InterventionCategoriesQuery, InterventionCategoriesQueryVariables>(InterventionCategoriesDocument, options);
      }
export function useInterventionCategoriesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<InterventionCategoriesQuery, InterventionCategoriesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<InterventionCategoriesQuery, InterventionCategoriesQueryVariables>(InterventionCategoriesDocument, options);
        }
// @ts-ignore
export function useInterventionCategoriesSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<InterventionCategoriesQuery, InterventionCategoriesQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<InterventionCategoriesQuery, InterventionCategoriesQueryVariables>;
// @ts-ignore
export function useInterventionCategoriesSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<InterventionCategoriesQuery, InterventionCategoriesQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<InterventionCategoriesQuery | undefined, InterventionCategoriesQueryVariables>;
export function useInterventionCategoriesSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<InterventionCategoriesQuery, InterventionCategoriesQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          // @ts-ignore
          return ApolloReactHooks.useSuspenseQuery<InterventionCategoriesQuery, InterventionCategoriesQueryVariables>(InterventionCategoriesDocument, options);
        }
export type InterventionCategoriesQueryHookResult = ReturnType<typeof useInterventionCategoriesQuery>;
export type InterventionCategoriesLazyQueryHookResult = ReturnType<typeof useInterventionCategoriesLazyQuery>;
export type InterventionCategoriesSuspenseQueryHookResult = ReturnType<typeof useInterventionCategoriesSuspenseQuery>;
export type InterventionCategoriesQueryResult = ApolloReactCommon.QueryResult<InterventionCategoriesQuery, InterventionCategoriesQueryVariables>;
export function refetchInterventionCategoriesQuery(variables?: InterventionCategoriesQueryVariables) {
      return { query: InterventionCategoriesDocument, variables: variables }
    }
export const InterventionCategoriesSearchListDocument = gql`
    query interventionCategoriesSearchList($page: Int, $limit: Int, $filters: [InterventionCategoryFilterInputObject!], $sorts: InterventionCategorySortInputObject) {
  data: interventionCategories(
    page: $page
    limit: $limit
    sorts: $sorts
    filters: $filters
  ) {
    collection {
      ...interventionCategoryFragment
    }
    metadata {
      ...metadataFragment
    }
  }
}
    ${InterventionCategoryFragmentFragmentDoc}
${MetadataFragmentFragmentDoc}`;

/**
 * __useInterventionCategoriesSearchListQuery__
 *
 * To run a query within a React component, call `useInterventionCategoriesSearchListQuery` and pass it any options that fit your needs.
 * When your component renders, `useInterventionCategoriesSearchListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInterventionCategoriesSearchListQuery({
 *   variables: {
 *      page: // value for 'page'
 *      limit: // value for 'limit'
 *      filters: // value for 'filters'
 *      sorts: // value for 'sorts'
 *   },
 * });
 */
export function useInterventionCategoriesSearchListQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<InterventionCategoriesSearchListQuery, InterventionCategoriesSearchListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<InterventionCategoriesSearchListQuery, InterventionCategoriesSearchListQueryVariables>(InterventionCategoriesSearchListDocument, options);
      }
export function useInterventionCategoriesSearchListLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<InterventionCategoriesSearchListQuery, InterventionCategoriesSearchListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<InterventionCategoriesSearchListQuery, InterventionCategoriesSearchListQueryVariables>(InterventionCategoriesSearchListDocument, options);
        }
// @ts-ignore
export function useInterventionCategoriesSearchListSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<InterventionCategoriesSearchListQuery, InterventionCategoriesSearchListQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<InterventionCategoriesSearchListQuery, InterventionCategoriesSearchListQueryVariables>;
// @ts-ignore
export function useInterventionCategoriesSearchListSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<InterventionCategoriesSearchListQuery, InterventionCategoriesSearchListQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<InterventionCategoriesSearchListQuery | undefined, InterventionCategoriesSearchListQueryVariables>;
export function useInterventionCategoriesSearchListSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<InterventionCategoriesSearchListQuery, InterventionCategoriesSearchListQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          // @ts-ignore
          return ApolloReactHooks.useSuspenseQuery<InterventionCategoriesSearchListQuery, InterventionCategoriesSearchListQueryVariables>(InterventionCategoriesSearchListDocument, options);
        }
export type InterventionCategoriesSearchListQueryHookResult = ReturnType<typeof useInterventionCategoriesSearchListQuery>;
export type InterventionCategoriesSearchListLazyQueryHookResult = ReturnType<typeof useInterventionCategoriesSearchListLazyQuery>;
export type InterventionCategoriesSearchListSuspenseQueryHookResult = ReturnType<typeof useInterventionCategoriesSearchListSuspenseQuery>;
export type InterventionCategoriesSearchListQueryResult = ApolloReactCommon.QueryResult<InterventionCategoriesSearchListQuery, InterventionCategoriesSearchListQueryVariables>;
export function refetchInterventionCategoriesSearchListQuery(variables?: InterventionCategoriesSearchListQueryVariables) {
      return { query: InterventionCategoriesSearchListDocument, variables: variables }
    }
export const InterventionActionDocument = gql`
    query interventionAction($interventionId: ID!, $id: ID!) {
  data: interventionAction(interventionId: $interventionId, id: $id) {
    ...interventionActionFragment
  }
}
    ${InterventionActionFragmentFragmentDoc}
${AttachmentFragmentFragmentDoc}
${AuthorizationResultFragmentFragmentDoc}`;

/**
 * __useInterventionActionQuery__
 *
 * To run a query within a React component, call `useInterventionActionQuery` and pass it any options that fit your needs.
 * When your component renders, `useInterventionActionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInterventionActionQuery({
 *   variables: {
 *      interventionId: // value for 'interventionId'
 *      id: // value for 'id'
 *   },
 * });
 */
export function useInterventionActionQuery(baseOptions: ApolloReactHooks.QueryHookOptions<InterventionActionQuery, InterventionActionQueryVariables> & ({ variables: InterventionActionQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<InterventionActionQuery, InterventionActionQueryVariables>(InterventionActionDocument, options);
      }
export function useInterventionActionLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<InterventionActionQuery, InterventionActionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<InterventionActionQuery, InterventionActionQueryVariables>(InterventionActionDocument, options);
        }
// @ts-ignore
export function useInterventionActionSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<InterventionActionQuery, InterventionActionQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<InterventionActionQuery, InterventionActionQueryVariables>;
// @ts-ignore
export function useInterventionActionSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<InterventionActionQuery, InterventionActionQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<InterventionActionQuery | undefined, InterventionActionQueryVariables>;
export function useInterventionActionSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<InterventionActionQuery, InterventionActionQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          // @ts-ignore
          return ApolloReactHooks.useSuspenseQuery<InterventionActionQuery, InterventionActionQueryVariables>(InterventionActionDocument, options);
        }
export type InterventionActionQueryHookResult = ReturnType<typeof useInterventionActionQuery>;
export type InterventionActionLazyQueryHookResult = ReturnType<typeof useInterventionActionLazyQuery>;
export type InterventionActionSuspenseQueryHookResult = ReturnType<typeof useInterventionActionSuspenseQuery>;
export type InterventionActionQueryResult = ApolloReactCommon.QueryResult<InterventionActionQuery, InterventionActionQueryVariables>;
export function refetchInterventionActionQuery(variables: InterventionActionQueryVariables) {
      return { query: InterventionActionDocument, variables: variables }
    }
export const InterventionActionHistoriesDocument = gql`
    query interventionActionHistories($page: Int, $limit: Int, $sourceableId: ID!, $sourceableType: HistorySourceableTypeEnum!, $sorts: HistorySortInputObject) {
  data: histories(
    page: $page
    limit: $limit
    sourceableId: $sourceableId
    sourceableType: $sourceableType
    sorts: $sorts
  ) {
    collection {
      id
      kind
      system
      occurredAt
      data {
        __typename
        ... on InterventionActionHistoryData {
          durationTime
          estimatedDate
          estimatedTime
          logisticTime
          status
        }
      }
      metadata {
        __typename
        ... on InterventionActionHistoryMetadata {
          reason
        }
      }
      user {
        id
        firstName
        lastName
        email
        avatarAttached {
          ...attachmentFragment
        }
      }
    }
    metadata {
      ...metadataFragment
    }
  }
}
    ${AttachmentFragmentFragmentDoc}
${MetadataFragmentFragmentDoc}`;

/**
 * __useInterventionActionHistoriesQuery__
 *
 * To run a query within a React component, call `useInterventionActionHistoriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useInterventionActionHistoriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInterventionActionHistoriesQuery({
 *   variables: {
 *      page: // value for 'page'
 *      limit: // value for 'limit'
 *      sourceableId: // value for 'sourceableId'
 *      sourceableType: // value for 'sourceableType'
 *      sorts: // value for 'sorts'
 *   },
 * });
 */
export function useInterventionActionHistoriesQuery(baseOptions: ApolloReactHooks.QueryHookOptions<InterventionActionHistoriesQuery, InterventionActionHistoriesQueryVariables> & ({ variables: InterventionActionHistoriesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<InterventionActionHistoriesQuery, InterventionActionHistoriesQueryVariables>(InterventionActionHistoriesDocument, options);
      }
export function useInterventionActionHistoriesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<InterventionActionHistoriesQuery, InterventionActionHistoriesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<InterventionActionHistoriesQuery, InterventionActionHistoriesQueryVariables>(InterventionActionHistoriesDocument, options);
        }
// @ts-ignore
export function useInterventionActionHistoriesSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<InterventionActionHistoriesQuery, InterventionActionHistoriesQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<InterventionActionHistoriesQuery, InterventionActionHistoriesQueryVariables>;
// @ts-ignore
export function useInterventionActionHistoriesSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<InterventionActionHistoriesQuery, InterventionActionHistoriesQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<InterventionActionHistoriesQuery | undefined, InterventionActionHistoriesQueryVariables>;
export function useInterventionActionHistoriesSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<InterventionActionHistoriesQuery, InterventionActionHistoriesQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          // @ts-ignore
          return ApolloReactHooks.useSuspenseQuery<InterventionActionHistoriesQuery, InterventionActionHistoriesQueryVariables>(InterventionActionHistoriesDocument, options);
        }
export type InterventionActionHistoriesQueryHookResult = ReturnType<typeof useInterventionActionHistoriesQuery>;
export type InterventionActionHistoriesLazyQueryHookResult = ReturnType<typeof useInterventionActionHistoriesLazyQuery>;
export type InterventionActionHistoriesSuspenseQueryHookResult = ReturnType<typeof useInterventionActionHistoriesSuspenseQuery>;
export type InterventionActionHistoriesQueryResult = ApolloReactCommon.QueryResult<InterventionActionHistoriesQuery, InterventionActionHistoriesQueryVariables>;
export function refetchInterventionActionHistoriesQuery(variables: InterventionActionHistoriesQueryVariables) {
      return { query: InterventionActionHistoriesDocument, variables: variables }
    }
export const InterventionActionsDocument = gql`
    query interventionActions($interventionId: ID!, $page: Int, $limit: Int, $sorts: InterventionActionSortInputObject, $filters: [InterventionActionFilterInputObject!]) {
  data: interventionActions(
    interventionId: $interventionId
    page: $page
    limit: $limit
    sorts: $sorts
    filters: $filters
  ) {
    collection {
      ...interventionActionFragment
    }
    metadata {
      ...metadataFragment
    }
  }
}
    ${InterventionActionFragmentFragmentDoc}
${AttachmentFragmentFragmentDoc}
${AuthorizationResultFragmentFragmentDoc}
${MetadataFragmentFragmentDoc}`;

/**
 * __useInterventionActionsQuery__
 *
 * To run a query within a React component, call `useInterventionActionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useInterventionActionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInterventionActionsQuery({
 *   variables: {
 *      interventionId: // value for 'interventionId'
 *      page: // value for 'page'
 *      limit: // value for 'limit'
 *      sorts: // value for 'sorts'
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useInterventionActionsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<InterventionActionsQuery, InterventionActionsQueryVariables> & ({ variables: InterventionActionsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<InterventionActionsQuery, InterventionActionsQueryVariables>(InterventionActionsDocument, options);
      }
export function useInterventionActionsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<InterventionActionsQuery, InterventionActionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<InterventionActionsQuery, InterventionActionsQueryVariables>(InterventionActionsDocument, options);
        }
// @ts-ignore
export function useInterventionActionsSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<InterventionActionsQuery, InterventionActionsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<InterventionActionsQuery, InterventionActionsQueryVariables>;
// @ts-ignore
export function useInterventionActionsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<InterventionActionsQuery, InterventionActionsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<InterventionActionsQuery | undefined, InterventionActionsQueryVariables>;
export function useInterventionActionsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<InterventionActionsQuery, InterventionActionsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          // @ts-ignore
          return ApolloReactHooks.useSuspenseQuery<InterventionActionsQuery, InterventionActionsQueryVariables>(InterventionActionsDocument, options);
        }
export type InterventionActionsQueryHookResult = ReturnType<typeof useInterventionActionsQuery>;
export type InterventionActionsLazyQueryHookResult = ReturnType<typeof useInterventionActionsLazyQuery>;
export type InterventionActionsSuspenseQueryHookResult = ReturnType<typeof useInterventionActionsSuspenseQuery>;
export type InterventionActionsQueryResult = ApolloReactCommon.QueryResult<InterventionActionsQuery, InterventionActionsQueryVariables>;
export function refetchInterventionActionsQuery(variables: InterventionActionsQueryVariables) {
      return { query: InterventionActionsDocument, variables: variables }
    }
export const InterventionActionIdsDocument = gql`
    query interventionActionIds($interventionId: ID!, $page: Int, $limit: Int, $sorts: InterventionActionSortInputObject, $filters: [InterventionActionFilterInputObject!], $onlyIds: Boolean) {
  data: interventionActions(
    interventionId: $interventionId
    page: $page
    limit: $limit
    sorts: $sorts
    filters: $filters
    onlyIds: $onlyIds
  ) {
    collection {
      id
    }
  }
}
    `;

/**
 * __useInterventionActionIdsQuery__
 *
 * To run a query within a React component, call `useInterventionActionIdsQuery` and pass it any options that fit your needs.
 * When your component renders, `useInterventionActionIdsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInterventionActionIdsQuery({
 *   variables: {
 *      interventionId: // value for 'interventionId'
 *      page: // value for 'page'
 *      limit: // value for 'limit'
 *      sorts: // value for 'sorts'
 *      filters: // value for 'filters'
 *      onlyIds: // value for 'onlyIds'
 *   },
 * });
 */
export function useInterventionActionIdsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<InterventionActionIdsQuery, InterventionActionIdsQueryVariables> & ({ variables: InterventionActionIdsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<InterventionActionIdsQuery, InterventionActionIdsQueryVariables>(InterventionActionIdsDocument, options);
      }
export function useInterventionActionIdsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<InterventionActionIdsQuery, InterventionActionIdsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<InterventionActionIdsQuery, InterventionActionIdsQueryVariables>(InterventionActionIdsDocument, options);
        }
// @ts-ignore
export function useInterventionActionIdsSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<InterventionActionIdsQuery, InterventionActionIdsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<InterventionActionIdsQuery, InterventionActionIdsQueryVariables>;
// @ts-ignore
export function useInterventionActionIdsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<InterventionActionIdsQuery, InterventionActionIdsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<InterventionActionIdsQuery | undefined, InterventionActionIdsQueryVariables>;
export function useInterventionActionIdsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<InterventionActionIdsQuery, InterventionActionIdsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          // @ts-ignore
          return ApolloReactHooks.useSuspenseQuery<InterventionActionIdsQuery, InterventionActionIdsQueryVariables>(InterventionActionIdsDocument, options);
        }
export type InterventionActionIdsQueryHookResult = ReturnType<typeof useInterventionActionIdsQuery>;
export type InterventionActionIdsLazyQueryHookResult = ReturnType<typeof useInterventionActionIdsLazyQuery>;
export type InterventionActionIdsSuspenseQueryHookResult = ReturnType<typeof useInterventionActionIdsSuspenseQuery>;
export type InterventionActionIdsQueryResult = ApolloReactCommon.QueryResult<InterventionActionIdsQuery, InterventionActionIdsQueryVariables>;
export function refetchInterventionActionIdsQuery(variables: InterventionActionIdsQueryVariables) {
      return { query: InterventionActionIdsDocument, variables: variables }
    }
export const InterventionSitePrefillDataDocument = gql`
    query interventionSitePrefillData($siteFindBy: SiteFindByInputObject!) {
  site(findBy: $siteFindBy) {
    id
    name
  }
}
    `;

/**
 * __useInterventionSitePrefillDataQuery__
 *
 * To run a query within a React component, call `useInterventionSitePrefillDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useInterventionSitePrefillDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInterventionSitePrefillDataQuery({
 *   variables: {
 *      siteFindBy: // value for 'siteFindBy'
 *   },
 * });
 */
export function useInterventionSitePrefillDataQuery(baseOptions: ApolloReactHooks.QueryHookOptions<InterventionSitePrefillDataQuery, InterventionSitePrefillDataQueryVariables> & ({ variables: InterventionSitePrefillDataQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<InterventionSitePrefillDataQuery, InterventionSitePrefillDataQueryVariables>(InterventionSitePrefillDataDocument, options);
      }
export function useInterventionSitePrefillDataLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<InterventionSitePrefillDataQuery, InterventionSitePrefillDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<InterventionSitePrefillDataQuery, InterventionSitePrefillDataQueryVariables>(InterventionSitePrefillDataDocument, options);
        }
// @ts-ignore
export function useInterventionSitePrefillDataSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<InterventionSitePrefillDataQuery, InterventionSitePrefillDataQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<InterventionSitePrefillDataQuery, InterventionSitePrefillDataQueryVariables>;
// @ts-ignore
export function useInterventionSitePrefillDataSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<InterventionSitePrefillDataQuery, InterventionSitePrefillDataQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<InterventionSitePrefillDataQuery | undefined, InterventionSitePrefillDataQueryVariables>;
export function useInterventionSitePrefillDataSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<InterventionSitePrefillDataQuery, InterventionSitePrefillDataQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          // @ts-ignore
          return ApolloReactHooks.useSuspenseQuery<InterventionSitePrefillDataQuery, InterventionSitePrefillDataQueryVariables>(InterventionSitePrefillDataDocument, options);
        }
export type InterventionSitePrefillDataQueryHookResult = ReturnType<typeof useInterventionSitePrefillDataQuery>;
export type InterventionSitePrefillDataLazyQueryHookResult = ReturnType<typeof useInterventionSitePrefillDataLazyQuery>;
export type InterventionSitePrefillDataSuspenseQueryHookResult = ReturnType<typeof useInterventionSitePrefillDataSuspenseQuery>;
export type InterventionSitePrefillDataQueryResult = ApolloReactCommon.QueryResult<InterventionSitePrefillDataQuery, InterventionSitePrefillDataQueryVariables>;
export function refetchInterventionSitePrefillDataQuery(variables: InterventionSitePrefillDataQueryVariables) {
      return { query: InterventionSitePrefillDataDocument, variables: variables }
    }
export const InterventionSiteAreaPrefillDataDocument = gql`
    query interventionSiteAreaPrefillData($siteFindBy: SiteFindByInputObject!, $siteAreaFindBy: SiteAreaFindByInputObject!) {
  siteArea(findBy: $siteAreaFindBy, siteFindBy: $siteFindBy) {
    ...siteAreaFragment
  }
}
    ${SiteAreaFragmentFragmentDoc}
${AuthorizationResultFragmentFragmentDoc}`;

/**
 * __useInterventionSiteAreaPrefillDataQuery__
 *
 * To run a query within a React component, call `useInterventionSiteAreaPrefillDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useInterventionSiteAreaPrefillDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInterventionSiteAreaPrefillDataQuery({
 *   variables: {
 *      siteFindBy: // value for 'siteFindBy'
 *      siteAreaFindBy: // value for 'siteAreaFindBy'
 *   },
 * });
 */
export function useInterventionSiteAreaPrefillDataQuery(baseOptions: ApolloReactHooks.QueryHookOptions<InterventionSiteAreaPrefillDataQuery, InterventionSiteAreaPrefillDataQueryVariables> & ({ variables: InterventionSiteAreaPrefillDataQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<InterventionSiteAreaPrefillDataQuery, InterventionSiteAreaPrefillDataQueryVariables>(InterventionSiteAreaPrefillDataDocument, options);
      }
export function useInterventionSiteAreaPrefillDataLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<InterventionSiteAreaPrefillDataQuery, InterventionSiteAreaPrefillDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<InterventionSiteAreaPrefillDataQuery, InterventionSiteAreaPrefillDataQueryVariables>(InterventionSiteAreaPrefillDataDocument, options);
        }
// @ts-ignore
export function useInterventionSiteAreaPrefillDataSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<InterventionSiteAreaPrefillDataQuery, InterventionSiteAreaPrefillDataQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<InterventionSiteAreaPrefillDataQuery, InterventionSiteAreaPrefillDataQueryVariables>;
// @ts-ignore
export function useInterventionSiteAreaPrefillDataSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<InterventionSiteAreaPrefillDataQuery, InterventionSiteAreaPrefillDataQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<InterventionSiteAreaPrefillDataQuery | undefined, InterventionSiteAreaPrefillDataQueryVariables>;
export function useInterventionSiteAreaPrefillDataSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<InterventionSiteAreaPrefillDataQuery, InterventionSiteAreaPrefillDataQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          // @ts-ignore
          return ApolloReactHooks.useSuspenseQuery<InterventionSiteAreaPrefillDataQuery, InterventionSiteAreaPrefillDataQueryVariables>(InterventionSiteAreaPrefillDataDocument, options);
        }
export type InterventionSiteAreaPrefillDataQueryHookResult = ReturnType<typeof useInterventionSiteAreaPrefillDataQuery>;
export type InterventionSiteAreaPrefillDataLazyQueryHookResult = ReturnType<typeof useInterventionSiteAreaPrefillDataLazyQuery>;
export type InterventionSiteAreaPrefillDataSuspenseQueryHookResult = ReturnType<typeof useInterventionSiteAreaPrefillDataSuspenseQuery>;
export type InterventionSiteAreaPrefillDataQueryResult = ApolloReactCommon.QueryResult<InterventionSiteAreaPrefillDataQuery, InterventionSiteAreaPrefillDataQueryVariables>;
export function refetchInterventionSiteAreaPrefillDataQuery(variables: InterventionSiteAreaPrefillDataQueryVariables) {
      return { query: InterventionSiteAreaPrefillDataDocument, variables: variables }
    }
export const InterventionAssetPrefillDataDocument = gql`
    query interventionAssetPrefillData($assetFindBy: AssetFindByInputObject!) {
  asset(findBy: $assetFindBy) {
    id
    name
    fullCode
    iconAttached {
      ...attachmentFragment
    }
    siteAreaId
  }
}
    ${AttachmentFragmentFragmentDoc}`;

/**
 * __useInterventionAssetPrefillDataQuery__
 *
 * To run a query within a React component, call `useInterventionAssetPrefillDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useInterventionAssetPrefillDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInterventionAssetPrefillDataQuery({
 *   variables: {
 *      assetFindBy: // value for 'assetFindBy'
 *   },
 * });
 */
export function useInterventionAssetPrefillDataQuery(baseOptions: ApolloReactHooks.QueryHookOptions<InterventionAssetPrefillDataQuery, InterventionAssetPrefillDataQueryVariables> & ({ variables: InterventionAssetPrefillDataQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<InterventionAssetPrefillDataQuery, InterventionAssetPrefillDataQueryVariables>(InterventionAssetPrefillDataDocument, options);
      }
export function useInterventionAssetPrefillDataLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<InterventionAssetPrefillDataQuery, InterventionAssetPrefillDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<InterventionAssetPrefillDataQuery, InterventionAssetPrefillDataQueryVariables>(InterventionAssetPrefillDataDocument, options);
        }
// @ts-ignore
export function useInterventionAssetPrefillDataSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<InterventionAssetPrefillDataQuery, InterventionAssetPrefillDataQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<InterventionAssetPrefillDataQuery, InterventionAssetPrefillDataQueryVariables>;
// @ts-ignore
export function useInterventionAssetPrefillDataSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<InterventionAssetPrefillDataQuery, InterventionAssetPrefillDataQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<InterventionAssetPrefillDataQuery | undefined, InterventionAssetPrefillDataQueryVariables>;
export function useInterventionAssetPrefillDataSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<InterventionAssetPrefillDataQuery, InterventionAssetPrefillDataQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          // @ts-ignore
          return ApolloReactHooks.useSuspenseQuery<InterventionAssetPrefillDataQuery, InterventionAssetPrefillDataQueryVariables>(InterventionAssetPrefillDataDocument, options);
        }
export type InterventionAssetPrefillDataQueryHookResult = ReturnType<typeof useInterventionAssetPrefillDataQuery>;
export type InterventionAssetPrefillDataLazyQueryHookResult = ReturnType<typeof useInterventionAssetPrefillDataLazyQuery>;
export type InterventionAssetPrefillDataSuspenseQueryHookResult = ReturnType<typeof useInterventionAssetPrefillDataSuspenseQuery>;
export type InterventionAssetPrefillDataQueryResult = ApolloReactCommon.QueryResult<InterventionAssetPrefillDataQuery, InterventionAssetPrefillDataQueryVariables>;
export function refetchInterventionAssetPrefillDataQuery(variables: InterventionAssetPrefillDataQueryVariables) {
      return { query: InterventionAssetPrefillDataDocument, variables: variables }
    }
export const InterventionTaskPrefillDataDocument = gql`
    query interventionTaskPrefillData($id: ID!) {
  task(id: $id) {
    id
    name
  }
}
    `;

/**
 * __useInterventionTaskPrefillDataQuery__
 *
 * To run a query within a React component, call `useInterventionTaskPrefillDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useInterventionTaskPrefillDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInterventionTaskPrefillDataQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useInterventionTaskPrefillDataQuery(baseOptions: ApolloReactHooks.QueryHookOptions<InterventionTaskPrefillDataQuery, InterventionTaskPrefillDataQueryVariables> & ({ variables: InterventionTaskPrefillDataQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<InterventionTaskPrefillDataQuery, InterventionTaskPrefillDataQueryVariables>(InterventionTaskPrefillDataDocument, options);
      }
export function useInterventionTaskPrefillDataLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<InterventionTaskPrefillDataQuery, InterventionTaskPrefillDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<InterventionTaskPrefillDataQuery, InterventionTaskPrefillDataQueryVariables>(InterventionTaskPrefillDataDocument, options);
        }
// @ts-ignore
export function useInterventionTaskPrefillDataSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<InterventionTaskPrefillDataQuery, InterventionTaskPrefillDataQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<InterventionTaskPrefillDataQuery, InterventionTaskPrefillDataQueryVariables>;
// @ts-ignore
export function useInterventionTaskPrefillDataSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<InterventionTaskPrefillDataQuery, InterventionTaskPrefillDataQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<InterventionTaskPrefillDataQuery | undefined, InterventionTaskPrefillDataQueryVariables>;
export function useInterventionTaskPrefillDataSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<InterventionTaskPrefillDataQuery, InterventionTaskPrefillDataQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          // @ts-ignore
          return ApolloReactHooks.useSuspenseQuery<InterventionTaskPrefillDataQuery, InterventionTaskPrefillDataQueryVariables>(InterventionTaskPrefillDataDocument, options);
        }
export type InterventionTaskPrefillDataQueryHookResult = ReturnType<typeof useInterventionTaskPrefillDataQuery>;
export type InterventionTaskPrefillDataLazyQueryHookResult = ReturnType<typeof useInterventionTaskPrefillDataLazyQuery>;
export type InterventionTaskPrefillDataSuspenseQueryHookResult = ReturnType<typeof useInterventionTaskPrefillDataSuspenseQuery>;
export type InterventionTaskPrefillDataQueryResult = ApolloReactCommon.QueryResult<InterventionTaskPrefillDataQuery, InterventionTaskPrefillDataQueryVariables>;
export function refetchInterventionTaskPrefillDataQuery(variables: InterventionTaskPrefillDataQueryVariables) {
      return { query: InterventionTaskPrefillDataDocument, variables: variables }
    }
export const InterventionCreateDocument = gql`
    mutation interventionCreate($attributes: InterventionCreateInputObject!, $assigneeRedirectUrl: String!) {
  data: interventionCreate(
    input: {attributes: $attributes, assigneeRedirectUrl: $assigneeRedirectUrl}
  ) {
    ...interventionFragment
  }
}
    ${InterventionFragmentFragmentDoc}
${AttachmentFragmentFragmentDoc}
${AuthorizationResultFragmentFragmentDoc}`;

/**
 * __useInterventionCreateMutation__
 *
 * To run a mutation, you first call `useInterventionCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInterventionCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [interventionCreateMutation, { data, loading, error }] = useInterventionCreateMutation({
 *   variables: {
 *      attributes: // value for 'attributes'
 *      assigneeRedirectUrl: // value for 'assigneeRedirectUrl'
 *   },
 * });
 */
export function useInterventionCreateMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<InterventionCreateMutation, InterventionCreateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<InterventionCreateMutation, InterventionCreateMutationVariables>(InterventionCreateDocument, options);
      }
export type InterventionCreateMutationHookResult = ReturnType<typeof useInterventionCreateMutation>;
export type InterventionCreateMutationResult = ApolloReactCommon.MutationResult<InterventionCreateMutation>;
export const InterventionUpdateDocument = gql`
    mutation interventionUpdate($attributes: InterventionUpdateInputObject!, $id: ID!, $assigneeRedirectUrl: String!) {
  data: interventionUpdate(
    input: {id: $id, attributes: $attributes, assigneeRedirectUrl: $assigneeRedirectUrl}
  ) {
    ...interventionFragment
  }
}
    ${InterventionFragmentFragmentDoc}
${AttachmentFragmentFragmentDoc}
${AuthorizationResultFragmentFragmentDoc}`;

/**
 * __useInterventionUpdateMutation__
 *
 * To run a mutation, you first call `useInterventionUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInterventionUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [interventionUpdateMutation, { data, loading, error }] = useInterventionUpdateMutation({
 *   variables: {
 *      attributes: // value for 'attributes'
 *      id: // value for 'id'
 *      assigneeRedirectUrl: // value for 'assigneeRedirectUrl'
 *   },
 * });
 */
export function useInterventionUpdateMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<InterventionUpdateMutation, InterventionUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<InterventionUpdateMutation, InterventionUpdateMutationVariables>(InterventionUpdateDocument, options);
      }
export type InterventionUpdateMutationHookResult = ReturnType<typeof useInterventionUpdateMutation>;
export type InterventionUpdateMutationResult = ApolloReactCommon.MutationResult<InterventionUpdateMutation>;
export const InterventionDestroyDocument = gql`
    mutation interventionDestroy($id: ID!) {
  interventionDestroy(input: {id: $id})
}
    `;

/**
 * __useInterventionDestroyMutation__
 *
 * To run a mutation, you first call `useInterventionDestroyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInterventionDestroyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [interventionDestroyMutation, { data, loading, error }] = useInterventionDestroyMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useInterventionDestroyMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<InterventionDestroyMutation, InterventionDestroyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<InterventionDestroyMutation, InterventionDestroyMutationVariables>(InterventionDestroyDocument, options);
      }
export type InterventionDestroyMutationHookResult = ReturnType<typeof useInterventionDestroyMutation>;
export type InterventionDestroyMutationResult = ApolloReactCommon.MutationResult<InterventionDestroyMutation>;
export const InterventionBulkCloseDocument = gql`
    mutation interventionBulkClose($ids: [ID!]!) {
  interventionBulkClose(input: {ids: $ids})
}
    `;

/**
 * __useInterventionBulkCloseMutation__
 *
 * To run a mutation, you first call `useInterventionBulkCloseMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInterventionBulkCloseMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [interventionBulkCloseMutation, { data, loading, error }] = useInterventionBulkCloseMutation({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useInterventionBulkCloseMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<InterventionBulkCloseMutation, InterventionBulkCloseMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<InterventionBulkCloseMutation, InterventionBulkCloseMutationVariables>(InterventionBulkCloseDocument, options);
      }
export type InterventionBulkCloseMutationHookResult = ReturnType<typeof useInterventionBulkCloseMutation>;
export type InterventionBulkCloseMutationResult = ApolloReactCommon.MutationResult<InterventionBulkCloseMutation>;
export const InterventionCategoryCreateDocument = gql`
    mutation interventionCategoryCreate($attributes: InterventionCategoryCreateInputObject!) {
  data: interventionCategoryCreate(input: {attributes: $attributes}) {
    ...interventionCategoryFragment
  }
}
    ${InterventionCategoryFragmentFragmentDoc}`;

/**
 * __useInterventionCategoryCreateMutation__
 *
 * To run a mutation, you first call `useInterventionCategoryCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInterventionCategoryCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [interventionCategoryCreateMutation, { data, loading, error }] = useInterventionCategoryCreateMutation({
 *   variables: {
 *      attributes: // value for 'attributes'
 *   },
 * });
 */
export function useInterventionCategoryCreateMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<InterventionCategoryCreateMutation, InterventionCategoryCreateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<InterventionCategoryCreateMutation, InterventionCategoryCreateMutationVariables>(InterventionCategoryCreateDocument, options);
      }
export type InterventionCategoryCreateMutationHookResult = ReturnType<typeof useInterventionCategoryCreateMutation>;
export type InterventionCategoryCreateMutationResult = ApolloReactCommon.MutationResult<InterventionCategoryCreateMutation>;
export const InterventionCategoryUpdateDocument = gql`
    mutation interventionCategoryUpdate($attributes: InterventionCategoryUpdateInputObject!, $id: ID!) {
  data: interventionCategoryUpdate(input: {id: $id, attributes: $attributes}) {
    ...interventionCategoryFragment
  }
}
    ${InterventionCategoryFragmentFragmentDoc}`;

/**
 * __useInterventionCategoryUpdateMutation__
 *
 * To run a mutation, you first call `useInterventionCategoryUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInterventionCategoryUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [interventionCategoryUpdateMutation, { data, loading, error }] = useInterventionCategoryUpdateMutation({
 *   variables: {
 *      attributes: // value for 'attributes'
 *      id: // value for 'id'
 *   },
 * });
 */
export function useInterventionCategoryUpdateMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<InterventionCategoryUpdateMutation, InterventionCategoryUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<InterventionCategoryUpdateMutation, InterventionCategoryUpdateMutationVariables>(InterventionCategoryUpdateDocument, options);
      }
export type InterventionCategoryUpdateMutationHookResult = ReturnType<typeof useInterventionCategoryUpdateMutation>;
export type InterventionCategoryUpdateMutationResult = ApolloReactCommon.MutationResult<InterventionCategoryUpdateMutation>;
export const InterventionCategoryDestroyDocument = gql`
    mutation interventionCategoryDestroy($id: ID!) {
  interventionCategoryDestroy(input: {id: $id})
}
    `;

/**
 * __useInterventionCategoryDestroyMutation__
 *
 * To run a mutation, you first call `useInterventionCategoryDestroyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInterventionCategoryDestroyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [interventionCategoryDestroyMutation, { data, loading, error }] = useInterventionCategoryDestroyMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useInterventionCategoryDestroyMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<InterventionCategoryDestroyMutation, InterventionCategoryDestroyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<InterventionCategoryDestroyMutation, InterventionCategoryDestroyMutationVariables>(InterventionCategoryDestroyDocument, options);
      }
export type InterventionCategoryDestroyMutationHookResult = ReturnType<typeof useInterventionCategoryDestroyMutation>;
export type InterventionCategoryDestroyMutationResult = ApolloReactCommon.MutationResult<InterventionCategoryDestroyMutation>;
export const InterventionActionCreateDocument = gql`
    mutation interventionActionCreate($attributes: InterventionActionCreateInputObject!, $assigneeRedirectUrl: String!, $mentionRedirectUrl: String!, $interventionId: ID!) {
  data: interventionActionCreate(
    input: {attributes: $attributes, assigneeRedirectUrl: $assigneeRedirectUrl, mentionRedirectUrl: $mentionRedirectUrl, interventionId: $interventionId}
  ) {
    ...interventionActionFragment
  }
}
    ${InterventionActionFragmentFragmentDoc}
${AttachmentFragmentFragmentDoc}
${AuthorizationResultFragmentFragmentDoc}`;

/**
 * __useInterventionActionCreateMutation__
 *
 * To run a mutation, you first call `useInterventionActionCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInterventionActionCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [interventionActionCreateMutation, { data, loading, error }] = useInterventionActionCreateMutation({
 *   variables: {
 *      attributes: // value for 'attributes'
 *      assigneeRedirectUrl: // value for 'assigneeRedirectUrl'
 *      mentionRedirectUrl: // value for 'mentionRedirectUrl'
 *      interventionId: // value for 'interventionId'
 *   },
 * });
 */
export function useInterventionActionCreateMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<InterventionActionCreateMutation, InterventionActionCreateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<InterventionActionCreateMutation, InterventionActionCreateMutationVariables>(InterventionActionCreateDocument, options);
      }
export type InterventionActionCreateMutationHookResult = ReturnType<typeof useInterventionActionCreateMutation>;
export type InterventionActionCreateMutationResult = ApolloReactCommon.MutationResult<InterventionActionCreateMutation>;
export const InterventionActionUpdateDocument = gql`
    mutation interventionActionUpdate($attributes: InterventionActionUpdateInputObject!, $id: ID!, $assigneeRedirectUrl: String!, $mentionRedirectUrl: String!, $interventionId: ID!) {
  data: interventionActionUpdate(
    input: {id: $id, attributes: $attributes, assigneeRedirectUrl: $assigneeRedirectUrl, mentionRedirectUrl: $mentionRedirectUrl, interventionId: $interventionId}
  ) {
    ...interventionActionFragment
  }
}
    ${InterventionActionFragmentFragmentDoc}
${AttachmentFragmentFragmentDoc}
${AuthorizationResultFragmentFragmentDoc}`;

/**
 * __useInterventionActionUpdateMutation__
 *
 * To run a mutation, you first call `useInterventionActionUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInterventionActionUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [interventionActionUpdateMutation, { data, loading, error }] = useInterventionActionUpdateMutation({
 *   variables: {
 *      attributes: // value for 'attributes'
 *      id: // value for 'id'
 *      assigneeRedirectUrl: // value for 'assigneeRedirectUrl'
 *      mentionRedirectUrl: // value for 'mentionRedirectUrl'
 *      interventionId: // value for 'interventionId'
 *   },
 * });
 */
export function useInterventionActionUpdateMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<InterventionActionUpdateMutation, InterventionActionUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<InterventionActionUpdateMutation, InterventionActionUpdateMutationVariables>(InterventionActionUpdateDocument, options);
      }
export type InterventionActionUpdateMutationHookResult = ReturnType<typeof useInterventionActionUpdateMutation>;
export type InterventionActionUpdateMutationResult = ApolloReactCommon.MutationResult<InterventionActionUpdateMutation>;
export const InterventionActionDestroyDocument = gql`
    mutation interventionActionDestroy($id: ID!, $interventionId: ID!) {
  interventionActionDestroy(input: {id: $id, interventionId: $interventionId})
}
    `;

/**
 * __useInterventionActionDestroyMutation__
 *
 * To run a mutation, you first call `useInterventionActionDestroyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInterventionActionDestroyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [interventionActionDestroyMutation, { data, loading, error }] = useInterventionActionDestroyMutation({
 *   variables: {
 *      id: // value for 'id'
 *      interventionId: // value for 'interventionId'
 *   },
 * });
 */
export function useInterventionActionDestroyMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<InterventionActionDestroyMutation, InterventionActionDestroyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<InterventionActionDestroyMutation, InterventionActionDestroyMutationVariables>(InterventionActionDestroyDocument, options);
      }
export type InterventionActionDestroyMutationHookResult = ReturnType<typeof useInterventionActionDestroyMutation>;
export type InterventionActionDestroyMutationResult = ApolloReactCommon.MutationResult<InterventionActionDestroyMutation>;
export const SectorsDocument = gql`
    query sectors($page: Int, $limit: Int, $sorts: SectorSortInputObject, $filters: [SectorFilterInputObject!], $taskFilters: [TaskFilterInputObject!], $includeFullData: Boolean = false, $includePerformanceDataByTaskDeadlinesMissed: Boolean = false, $includePerformanceDataByTaskResults: Boolean = false) {
  data: sectors(
    page: $page
    limit: $limit
    sorts: $sorts
    filters: $filters
    taskFilters: $taskFilters
  ) {
    collection {
      ...sectorFragment @include(if: $includeFullData)
      id
      name
      sitesCount @include(if: $includeFullData)
      sites @include(if: $includeFullData) {
        collection {
          id
          name
        }
      }
      totalAnomaliesByTaskDeadlinesMissed @include(if: $includePerformanceDataByTaskDeadlinesMissed)
      totalAnomaliesByTaskResults @include(if: $includePerformanceDataByTaskResults)
      successPercentageByTaskDeadlinesMissed @include(if: $includePerformanceDataByTaskDeadlinesMissed)
      successPercentageByTaskResults @include(if: $includePerformanceDataByTaskResults)
    }
    metadata {
      ...metadataFragment
    }
  }
}
    ${SectorFragmentFragmentDoc}
${AuthorizationResultFragmentFragmentDoc}
${MetadataFragmentFragmentDoc}`;

/**
 * __useSectorsQuery__
 *
 * To run a query within a React component, call `useSectorsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSectorsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSectorsQuery({
 *   variables: {
 *      page: // value for 'page'
 *      limit: // value for 'limit'
 *      sorts: // value for 'sorts'
 *      filters: // value for 'filters'
 *      taskFilters: // value for 'taskFilters'
 *      includeFullData: // value for 'includeFullData'
 *      includePerformanceDataByTaskDeadlinesMissed: // value for 'includePerformanceDataByTaskDeadlinesMissed'
 *      includePerformanceDataByTaskResults: // value for 'includePerformanceDataByTaskResults'
 *   },
 * });
 */
export function useSectorsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<SectorsQuery, SectorsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<SectorsQuery, SectorsQueryVariables>(SectorsDocument, options);
      }
export function useSectorsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<SectorsQuery, SectorsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<SectorsQuery, SectorsQueryVariables>(SectorsDocument, options);
        }
// @ts-ignore
export function useSectorsSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<SectorsQuery, SectorsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<SectorsQuery, SectorsQueryVariables>;
// @ts-ignore
export function useSectorsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<SectorsQuery, SectorsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<SectorsQuery | undefined, SectorsQueryVariables>;
export function useSectorsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<SectorsQuery, SectorsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          // @ts-ignore
          return ApolloReactHooks.useSuspenseQuery<SectorsQuery, SectorsQueryVariables>(SectorsDocument, options);
        }
export type SectorsQueryHookResult = ReturnType<typeof useSectorsQuery>;
export type SectorsLazyQueryHookResult = ReturnType<typeof useSectorsLazyQuery>;
export type SectorsSuspenseQueryHookResult = ReturnType<typeof useSectorsSuspenseQuery>;
export type SectorsQueryResult = ApolloReactCommon.QueryResult<SectorsQuery, SectorsQueryVariables>;
export function refetchSectorsQuery(variables?: SectorsQueryVariables) {
      return { query: SectorsDocument, variables: variables }
    }
export const SectorLocationsDocument = gql`
    query sectorLocations($filters: [LocationFilterInputObject!], $sectorFilters: [SectorFilterInputObject!], $mapParams: LocationMapParamsInputObject!) {
  data: sectorLocations(
    filters: $filters
    sectorFilters: $sectorFilters
    mapParams: $mapParams
  ) {
    ...geojsonFullFragment
  }
}
    ${GeojsonFullFragmentFragmentDoc}`;

/**
 * __useSectorLocationsQuery__
 *
 * To run a query within a React component, call `useSectorLocationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSectorLocationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSectorLocationsQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      sectorFilters: // value for 'sectorFilters'
 *      mapParams: // value for 'mapParams'
 *   },
 * });
 */
export function useSectorLocationsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<SectorLocationsQuery, SectorLocationsQueryVariables> & ({ variables: SectorLocationsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<SectorLocationsQuery, SectorLocationsQueryVariables>(SectorLocationsDocument, options);
      }
export function useSectorLocationsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<SectorLocationsQuery, SectorLocationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<SectorLocationsQuery, SectorLocationsQueryVariables>(SectorLocationsDocument, options);
        }
// @ts-ignore
export function useSectorLocationsSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<SectorLocationsQuery, SectorLocationsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<SectorLocationsQuery, SectorLocationsQueryVariables>;
// @ts-ignore
export function useSectorLocationsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<SectorLocationsQuery, SectorLocationsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<SectorLocationsQuery | undefined, SectorLocationsQueryVariables>;
export function useSectorLocationsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<SectorLocationsQuery, SectorLocationsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          // @ts-ignore
          return ApolloReactHooks.useSuspenseQuery<SectorLocationsQuery, SectorLocationsQueryVariables>(SectorLocationsDocument, options);
        }
export type SectorLocationsQueryHookResult = ReturnType<typeof useSectorLocationsQuery>;
export type SectorLocationsLazyQueryHookResult = ReturnType<typeof useSectorLocationsLazyQuery>;
export type SectorLocationsSuspenseQueryHookResult = ReturnType<typeof useSectorLocationsSuspenseQuery>;
export type SectorLocationsQueryResult = ApolloReactCommon.QueryResult<SectorLocationsQuery, SectorLocationsQueryVariables>;
export function refetchSectorLocationsQuery(variables: SectorLocationsQueryVariables) {
      return { query: SectorLocationsDocument, variables: variables }
    }
export const SectorLocationCenterDocument = gql`
    query sectorLocationCenter($filters: [LocationFilterInputObject!], $sectorFilters: [SectorFilterInputObject!]) {
  data: sectorLocationCenter(filters: $filters, sectorFilters: $sectorFilters) {
    lat
    lon
  }
}
    `;

/**
 * __useSectorLocationCenterQuery__
 *
 * To run a query within a React component, call `useSectorLocationCenterQuery` and pass it any options that fit your needs.
 * When your component renders, `useSectorLocationCenterQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSectorLocationCenterQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      sectorFilters: // value for 'sectorFilters'
 *   },
 * });
 */
export function useSectorLocationCenterQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<SectorLocationCenterQuery, SectorLocationCenterQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<SectorLocationCenterQuery, SectorLocationCenterQueryVariables>(SectorLocationCenterDocument, options);
      }
export function useSectorLocationCenterLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<SectorLocationCenterQuery, SectorLocationCenterQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<SectorLocationCenterQuery, SectorLocationCenterQueryVariables>(SectorLocationCenterDocument, options);
        }
// @ts-ignore
export function useSectorLocationCenterSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<SectorLocationCenterQuery, SectorLocationCenterQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<SectorLocationCenterQuery, SectorLocationCenterQueryVariables>;
// @ts-ignore
export function useSectorLocationCenterSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<SectorLocationCenterQuery, SectorLocationCenterQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<SectorLocationCenterQuery | undefined, SectorLocationCenterQueryVariables>;
export function useSectorLocationCenterSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<SectorLocationCenterQuery, SectorLocationCenterQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          // @ts-ignore
          return ApolloReactHooks.useSuspenseQuery<SectorLocationCenterQuery, SectorLocationCenterQueryVariables>(SectorLocationCenterDocument, options);
        }
export type SectorLocationCenterQueryHookResult = ReturnType<typeof useSectorLocationCenterQuery>;
export type SectorLocationCenterLazyQueryHookResult = ReturnType<typeof useSectorLocationCenterLazyQuery>;
export type SectorLocationCenterSuspenseQueryHookResult = ReturnType<typeof useSectorLocationCenterSuspenseQuery>;
export type SectorLocationCenterQueryResult = ApolloReactCommon.QueryResult<SectorLocationCenterQuery, SectorLocationCenterQueryVariables>;
export function refetchSectorLocationCenterQuery(variables?: SectorLocationCenterQueryVariables) {
      return { query: SectorLocationCenterDocument, variables: variables }
    }
export const SectorsSearchListDocument = gql`
    query sectorsSearchList($page: Int, $limit: Int, $sorts: SectorSortInputObject, $filters: [SectorFilterInputObject!]) {
  data: sectors(page: $page, limit: $limit, sorts: $sorts, filters: $filters) {
    collection {
      id
      name
      color
    }
    metadata {
      ...metadataFragment
    }
  }
}
    ${MetadataFragmentFragmentDoc}`;

/**
 * __useSectorsSearchListQuery__
 *
 * To run a query within a React component, call `useSectorsSearchListQuery` and pass it any options that fit your needs.
 * When your component renders, `useSectorsSearchListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSectorsSearchListQuery({
 *   variables: {
 *      page: // value for 'page'
 *      limit: // value for 'limit'
 *      sorts: // value for 'sorts'
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useSectorsSearchListQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<SectorsSearchListQuery, SectorsSearchListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<SectorsSearchListQuery, SectorsSearchListQueryVariables>(SectorsSearchListDocument, options);
      }
export function useSectorsSearchListLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<SectorsSearchListQuery, SectorsSearchListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<SectorsSearchListQuery, SectorsSearchListQueryVariables>(SectorsSearchListDocument, options);
        }
// @ts-ignore
export function useSectorsSearchListSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<SectorsSearchListQuery, SectorsSearchListQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<SectorsSearchListQuery, SectorsSearchListQueryVariables>;
// @ts-ignore
export function useSectorsSearchListSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<SectorsSearchListQuery, SectorsSearchListQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<SectorsSearchListQuery | undefined, SectorsSearchListQueryVariables>;
export function useSectorsSearchListSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<SectorsSearchListQuery, SectorsSearchListQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          // @ts-ignore
          return ApolloReactHooks.useSuspenseQuery<SectorsSearchListQuery, SectorsSearchListQueryVariables>(SectorsSearchListDocument, options);
        }
export type SectorsSearchListQueryHookResult = ReturnType<typeof useSectorsSearchListQuery>;
export type SectorsSearchListLazyQueryHookResult = ReturnType<typeof useSectorsSearchListLazyQuery>;
export type SectorsSearchListSuspenseQueryHookResult = ReturnType<typeof useSectorsSearchListSuspenseQuery>;
export type SectorsSearchListQueryResult = ApolloReactCommon.QueryResult<SectorsSearchListQuery, SectorsSearchListQueryVariables>;
export function refetchSectorsSearchListQuery(variables?: SectorsSearchListQueryVariables) {
      return { query: SectorsSearchListDocument, variables: variables }
    }
export const SectorIdsDocument = gql`
    query sectorIds($filters: [SectorFilterInputObject!], $sorts: SectorSortInputObject) {
  data: sectors(filters: $filters, sorts: $sorts) {
    collection {
      id
    }
  }
}
    `;

/**
 * __useSectorIdsQuery__
 *
 * To run a query within a React component, call `useSectorIdsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSectorIdsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSectorIdsQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      sorts: // value for 'sorts'
 *   },
 * });
 */
export function useSectorIdsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<SectorIdsQuery, SectorIdsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<SectorIdsQuery, SectorIdsQueryVariables>(SectorIdsDocument, options);
      }
export function useSectorIdsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<SectorIdsQuery, SectorIdsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<SectorIdsQuery, SectorIdsQueryVariables>(SectorIdsDocument, options);
        }
// @ts-ignore
export function useSectorIdsSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<SectorIdsQuery, SectorIdsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<SectorIdsQuery, SectorIdsQueryVariables>;
// @ts-ignore
export function useSectorIdsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<SectorIdsQuery, SectorIdsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<SectorIdsQuery | undefined, SectorIdsQueryVariables>;
export function useSectorIdsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<SectorIdsQuery, SectorIdsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          // @ts-ignore
          return ApolloReactHooks.useSuspenseQuery<SectorIdsQuery, SectorIdsQueryVariables>(SectorIdsDocument, options);
        }
export type SectorIdsQueryHookResult = ReturnType<typeof useSectorIdsQuery>;
export type SectorIdsLazyQueryHookResult = ReturnType<typeof useSectorIdsLazyQuery>;
export type SectorIdsSuspenseQueryHookResult = ReturnType<typeof useSectorIdsSuspenseQuery>;
export type SectorIdsQueryResult = ApolloReactCommon.QueryResult<SectorIdsQuery, SectorIdsQueryVariables>;
export function refetchSectorIdsQuery(variables?: SectorIdsQueryVariables) {
      return { query: SectorIdsDocument, variables: variables }
    }
export const SectorsPerformanceMetricsByTaskDeadlinesMissedDocument = gql`
    query sectorsPerformanceMetricsByTaskDeadlinesMissed($ids: [ID!]!, $taskFilters: [TaskFilterInputObject!]) {
  data: sectorsPerformanceMetricsByTaskDeadlinesMissed(
    ids: $ids
    taskFilters: $taskFilters
  ) {
    id
    successPercentageByTaskDeadlinesMissed
    totalAnomaliesByTaskDeadlinesMissed
  }
}
    `;

/**
 * __useSectorsPerformanceMetricsByTaskDeadlinesMissedQuery__
 *
 * To run a query within a React component, call `useSectorsPerformanceMetricsByTaskDeadlinesMissedQuery` and pass it any options that fit your needs.
 * When your component renders, `useSectorsPerformanceMetricsByTaskDeadlinesMissedQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSectorsPerformanceMetricsByTaskDeadlinesMissedQuery({
 *   variables: {
 *      ids: // value for 'ids'
 *      taskFilters: // value for 'taskFilters'
 *   },
 * });
 */
export function useSectorsPerformanceMetricsByTaskDeadlinesMissedQuery(baseOptions: ApolloReactHooks.QueryHookOptions<SectorsPerformanceMetricsByTaskDeadlinesMissedQuery, SectorsPerformanceMetricsByTaskDeadlinesMissedQueryVariables> & ({ variables: SectorsPerformanceMetricsByTaskDeadlinesMissedQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<SectorsPerformanceMetricsByTaskDeadlinesMissedQuery, SectorsPerformanceMetricsByTaskDeadlinesMissedQueryVariables>(SectorsPerformanceMetricsByTaskDeadlinesMissedDocument, options);
      }
export function useSectorsPerformanceMetricsByTaskDeadlinesMissedLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<SectorsPerformanceMetricsByTaskDeadlinesMissedQuery, SectorsPerformanceMetricsByTaskDeadlinesMissedQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<SectorsPerformanceMetricsByTaskDeadlinesMissedQuery, SectorsPerformanceMetricsByTaskDeadlinesMissedQueryVariables>(SectorsPerformanceMetricsByTaskDeadlinesMissedDocument, options);
        }
// @ts-ignore
export function useSectorsPerformanceMetricsByTaskDeadlinesMissedSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<SectorsPerformanceMetricsByTaskDeadlinesMissedQuery, SectorsPerformanceMetricsByTaskDeadlinesMissedQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<SectorsPerformanceMetricsByTaskDeadlinesMissedQuery, SectorsPerformanceMetricsByTaskDeadlinesMissedQueryVariables>;
// @ts-ignore
export function useSectorsPerformanceMetricsByTaskDeadlinesMissedSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<SectorsPerformanceMetricsByTaskDeadlinesMissedQuery, SectorsPerformanceMetricsByTaskDeadlinesMissedQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<SectorsPerformanceMetricsByTaskDeadlinesMissedQuery | undefined, SectorsPerformanceMetricsByTaskDeadlinesMissedQueryVariables>;
export function useSectorsPerformanceMetricsByTaskDeadlinesMissedSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<SectorsPerformanceMetricsByTaskDeadlinesMissedQuery, SectorsPerformanceMetricsByTaskDeadlinesMissedQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          // @ts-ignore
          return ApolloReactHooks.useSuspenseQuery<SectorsPerformanceMetricsByTaskDeadlinesMissedQuery, SectorsPerformanceMetricsByTaskDeadlinesMissedQueryVariables>(SectorsPerformanceMetricsByTaskDeadlinesMissedDocument, options);
        }
export type SectorsPerformanceMetricsByTaskDeadlinesMissedQueryHookResult = ReturnType<typeof useSectorsPerformanceMetricsByTaskDeadlinesMissedQuery>;
export type SectorsPerformanceMetricsByTaskDeadlinesMissedLazyQueryHookResult = ReturnType<typeof useSectorsPerformanceMetricsByTaskDeadlinesMissedLazyQuery>;
export type SectorsPerformanceMetricsByTaskDeadlinesMissedSuspenseQueryHookResult = ReturnType<typeof useSectorsPerformanceMetricsByTaskDeadlinesMissedSuspenseQuery>;
export type SectorsPerformanceMetricsByTaskDeadlinesMissedQueryResult = ApolloReactCommon.QueryResult<SectorsPerformanceMetricsByTaskDeadlinesMissedQuery, SectorsPerformanceMetricsByTaskDeadlinesMissedQueryVariables>;
export function refetchSectorsPerformanceMetricsByTaskDeadlinesMissedQuery(variables: SectorsPerformanceMetricsByTaskDeadlinesMissedQueryVariables) {
      return { query: SectorsPerformanceMetricsByTaskDeadlinesMissedDocument, variables: variables }
    }
export const SectorsPerformanceMetricsByTaskDeadlinesMissedByDateDocument = gql`
    query sectorsPerformanceMetricsByTaskDeadlinesMissedByDate($ids: [ID!]!, $taskFilters: [TaskFilterInputObject!], $periodGroupBy: PeriodGroupByEnum!) {
  data: sectorsPerformanceMetricsByTaskDeadlinesMissedByDate(
    ids: $ids
    taskFilters: $taskFilters
    periodGroupBy: $periodGroupBy
  ) {
    id
    period
    totalAnomaliesByTaskDeadlinesMissed
  }
}
    `;

/**
 * __useSectorsPerformanceMetricsByTaskDeadlinesMissedByDateQuery__
 *
 * To run a query within a React component, call `useSectorsPerformanceMetricsByTaskDeadlinesMissedByDateQuery` and pass it any options that fit your needs.
 * When your component renders, `useSectorsPerformanceMetricsByTaskDeadlinesMissedByDateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSectorsPerformanceMetricsByTaskDeadlinesMissedByDateQuery({
 *   variables: {
 *      ids: // value for 'ids'
 *      taskFilters: // value for 'taskFilters'
 *      periodGroupBy: // value for 'periodGroupBy'
 *   },
 * });
 */
export function useSectorsPerformanceMetricsByTaskDeadlinesMissedByDateQuery(baseOptions: ApolloReactHooks.QueryHookOptions<SectorsPerformanceMetricsByTaskDeadlinesMissedByDateQuery, SectorsPerformanceMetricsByTaskDeadlinesMissedByDateQueryVariables> & ({ variables: SectorsPerformanceMetricsByTaskDeadlinesMissedByDateQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<SectorsPerformanceMetricsByTaskDeadlinesMissedByDateQuery, SectorsPerformanceMetricsByTaskDeadlinesMissedByDateQueryVariables>(SectorsPerformanceMetricsByTaskDeadlinesMissedByDateDocument, options);
      }
export function useSectorsPerformanceMetricsByTaskDeadlinesMissedByDateLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<SectorsPerformanceMetricsByTaskDeadlinesMissedByDateQuery, SectorsPerformanceMetricsByTaskDeadlinesMissedByDateQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<SectorsPerformanceMetricsByTaskDeadlinesMissedByDateQuery, SectorsPerformanceMetricsByTaskDeadlinesMissedByDateQueryVariables>(SectorsPerformanceMetricsByTaskDeadlinesMissedByDateDocument, options);
        }
// @ts-ignore
export function useSectorsPerformanceMetricsByTaskDeadlinesMissedByDateSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<SectorsPerformanceMetricsByTaskDeadlinesMissedByDateQuery, SectorsPerformanceMetricsByTaskDeadlinesMissedByDateQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<SectorsPerformanceMetricsByTaskDeadlinesMissedByDateQuery, SectorsPerformanceMetricsByTaskDeadlinesMissedByDateQueryVariables>;
// @ts-ignore
export function useSectorsPerformanceMetricsByTaskDeadlinesMissedByDateSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<SectorsPerformanceMetricsByTaskDeadlinesMissedByDateQuery, SectorsPerformanceMetricsByTaskDeadlinesMissedByDateQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<SectorsPerformanceMetricsByTaskDeadlinesMissedByDateQuery | undefined, SectorsPerformanceMetricsByTaskDeadlinesMissedByDateQueryVariables>;
export function useSectorsPerformanceMetricsByTaskDeadlinesMissedByDateSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<SectorsPerformanceMetricsByTaskDeadlinesMissedByDateQuery, SectorsPerformanceMetricsByTaskDeadlinesMissedByDateQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          // @ts-ignore
          return ApolloReactHooks.useSuspenseQuery<SectorsPerformanceMetricsByTaskDeadlinesMissedByDateQuery, SectorsPerformanceMetricsByTaskDeadlinesMissedByDateQueryVariables>(SectorsPerformanceMetricsByTaskDeadlinesMissedByDateDocument, options);
        }
export type SectorsPerformanceMetricsByTaskDeadlinesMissedByDateQueryHookResult = ReturnType<typeof useSectorsPerformanceMetricsByTaskDeadlinesMissedByDateQuery>;
export type SectorsPerformanceMetricsByTaskDeadlinesMissedByDateLazyQueryHookResult = ReturnType<typeof useSectorsPerformanceMetricsByTaskDeadlinesMissedByDateLazyQuery>;
export type SectorsPerformanceMetricsByTaskDeadlinesMissedByDateSuspenseQueryHookResult = ReturnType<typeof useSectorsPerformanceMetricsByTaskDeadlinesMissedByDateSuspenseQuery>;
export type SectorsPerformanceMetricsByTaskDeadlinesMissedByDateQueryResult = ApolloReactCommon.QueryResult<SectorsPerformanceMetricsByTaskDeadlinesMissedByDateQuery, SectorsPerformanceMetricsByTaskDeadlinesMissedByDateQueryVariables>;
export function refetchSectorsPerformanceMetricsByTaskDeadlinesMissedByDateQuery(variables: SectorsPerformanceMetricsByTaskDeadlinesMissedByDateQueryVariables) {
      return { query: SectorsPerformanceMetricsByTaskDeadlinesMissedByDateDocument, variables: variables }
    }
export const SectorsPerformanceMetricsByTaskResultsDocument = gql`
    query sectorsPerformanceMetricsByTaskResults($ids: [ID!]!, $taskFilters: [TaskFilterInputObject!]) {
  data: sectorsPerformanceMetricsByTaskResults(
    ids: $ids
    taskFilters: $taskFilters
  ) {
    id
    successPercentageByTaskResults
    totalAnomaliesByTaskResults
  }
}
    `;

/**
 * __useSectorsPerformanceMetricsByTaskResultsQuery__
 *
 * To run a query within a React component, call `useSectorsPerformanceMetricsByTaskResultsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSectorsPerformanceMetricsByTaskResultsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSectorsPerformanceMetricsByTaskResultsQuery({
 *   variables: {
 *      ids: // value for 'ids'
 *      taskFilters: // value for 'taskFilters'
 *   },
 * });
 */
export function useSectorsPerformanceMetricsByTaskResultsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<SectorsPerformanceMetricsByTaskResultsQuery, SectorsPerformanceMetricsByTaskResultsQueryVariables> & ({ variables: SectorsPerformanceMetricsByTaskResultsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<SectorsPerformanceMetricsByTaskResultsQuery, SectorsPerformanceMetricsByTaskResultsQueryVariables>(SectorsPerformanceMetricsByTaskResultsDocument, options);
      }
export function useSectorsPerformanceMetricsByTaskResultsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<SectorsPerformanceMetricsByTaskResultsQuery, SectorsPerformanceMetricsByTaskResultsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<SectorsPerformanceMetricsByTaskResultsQuery, SectorsPerformanceMetricsByTaskResultsQueryVariables>(SectorsPerformanceMetricsByTaskResultsDocument, options);
        }
// @ts-ignore
export function useSectorsPerformanceMetricsByTaskResultsSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<SectorsPerformanceMetricsByTaskResultsQuery, SectorsPerformanceMetricsByTaskResultsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<SectorsPerformanceMetricsByTaskResultsQuery, SectorsPerformanceMetricsByTaskResultsQueryVariables>;
// @ts-ignore
export function useSectorsPerformanceMetricsByTaskResultsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<SectorsPerformanceMetricsByTaskResultsQuery, SectorsPerformanceMetricsByTaskResultsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<SectorsPerformanceMetricsByTaskResultsQuery | undefined, SectorsPerformanceMetricsByTaskResultsQueryVariables>;
export function useSectorsPerformanceMetricsByTaskResultsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<SectorsPerformanceMetricsByTaskResultsQuery, SectorsPerformanceMetricsByTaskResultsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          // @ts-ignore
          return ApolloReactHooks.useSuspenseQuery<SectorsPerformanceMetricsByTaskResultsQuery, SectorsPerformanceMetricsByTaskResultsQueryVariables>(SectorsPerformanceMetricsByTaskResultsDocument, options);
        }
export type SectorsPerformanceMetricsByTaskResultsQueryHookResult = ReturnType<typeof useSectorsPerformanceMetricsByTaskResultsQuery>;
export type SectorsPerformanceMetricsByTaskResultsLazyQueryHookResult = ReturnType<typeof useSectorsPerformanceMetricsByTaskResultsLazyQuery>;
export type SectorsPerformanceMetricsByTaskResultsSuspenseQueryHookResult = ReturnType<typeof useSectorsPerformanceMetricsByTaskResultsSuspenseQuery>;
export type SectorsPerformanceMetricsByTaskResultsQueryResult = ApolloReactCommon.QueryResult<SectorsPerformanceMetricsByTaskResultsQuery, SectorsPerformanceMetricsByTaskResultsQueryVariables>;
export function refetchSectorsPerformanceMetricsByTaskResultsQuery(variables: SectorsPerformanceMetricsByTaskResultsQueryVariables) {
      return { query: SectorsPerformanceMetricsByTaskResultsDocument, variables: variables }
    }
export const SectorsPerformanceMetricsByTaskResultsByDateDocument = gql`
    query sectorsPerformanceMetricsByTaskResultsByDate($ids: [ID!]!, $periodGroupBy: PeriodGroupByEnum!, $taskFilters: [TaskFilterInputObject!]) {
  data: sectorsPerformanceMetricsByTaskResultsByDate(
    ids: $ids
    periodGroupBy: $periodGroupBy
    taskFilters: $taskFilters
  ) {
    id
    period
    totalAnomaliesByTaskResults
  }
}
    `;

/**
 * __useSectorsPerformanceMetricsByTaskResultsByDateQuery__
 *
 * To run a query within a React component, call `useSectorsPerformanceMetricsByTaskResultsByDateQuery` and pass it any options that fit your needs.
 * When your component renders, `useSectorsPerformanceMetricsByTaskResultsByDateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSectorsPerformanceMetricsByTaskResultsByDateQuery({
 *   variables: {
 *      ids: // value for 'ids'
 *      periodGroupBy: // value for 'periodGroupBy'
 *      taskFilters: // value for 'taskFilters'
 *   },
 * });
 */
export function useSectorsPerformanceMetricsByTaskResultsByDateQuery(baseOptions: ApolloReactHooks.QueryHookOptions<SectorsPerformanceMetricsByTaskResultsByDateQuery, SectorsPerformanceMetricsByTaskResultsByDateQueryVariables> & ({ variables: SectorsPerformanceMetricsByTaskResultsByDateQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<SectorsPerformanceMetricsByTaskResultsByDateQuery, SectorsPerformanceMetricsByTaskResultsByDateQueryVariables>(SectorsPerformanceMetricsByTaskResultsByDateDocument, options);
      }
export function useSectorsPerformanceMetricsByTaskResultsByDateLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<SectorsPerformanceMetricsByTaskResultsByDateQuery, SectorsPerformanceMetricsByTaskResultsByDateQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<SectorsPerformanceMetricsByTaskResultsByDateQuery, SectorsPerformanceMetricsByTaskResultsByDateQueryVariables>(SectorsPerformanceMetricsByTaskResultsByDateDocument, options);
        }
// @ts-ignore
export function useSectorsPerformanceMetricsByTaskResultsByDateSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<SectorsPerformanceMetricsByTaskResultsByDateQuery, SectorsPerformanceMetricsByTaskResultsByDateQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<SectorsPerformanceMetricsByTaskResultsByDateQuery, SectorsPerformanceMetricsByTaskResultsByDateQueryVariables>;
// @ts-ignore
export function useSectorsPerformanceMetricsByTaskResultsByDateSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<SectorsPerformanceMetricsByTaskResultsByDateQuery, SectorsPerformanceMetricsByTaskResultsByDateQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<SectorsPerformanceMetricsByTaskResultsByDateQuery | undefined, SectorsPerformanceMetricsByTaskResultsByDateQueryVariables>;
export function useSectorsPerformanceMetricsByTaskResultsByDateSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<SectorsPerformanceMetricsByTaskResultsByDateQuery, SectorsPerformanceMetricsByTaskResultsByDateQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          // @ts-ignore
          return ApolloReactHooks.useSuspenseQuery<SectorsPerformanceMetricsByTaskResultsByDateQuery, SectorsPerformanceMetricsByTaskResultsByDateQueryVariables>(SectorsPerformanceMetricsByTaskResultsByDateDocument, options);
        }
export type SectorsPerformanceMetricsByTaskResultsByDateQueryHookResult = ReturnType<typeof useSectorsPerformanceMetricsByTaskResultsByDateQuery>;
export type SectorsPerformanceMetricsByTaskResultsByDateLazyQueryHookResult = ReturnType<typeof useSectorsPerformanceMetricsByTaskResultsByDateLazyQuery>;
export type SectorsPerformanceMetricsByTaskResultsByDateSuspenseQueryHookResult = ReturnType<typeof useSectorsPerformanceMetricsByTaskResultsByDateSuspenseQuery>;
export type SectorsPerformanceMetricsByTaskResultsByDateQueryResult = ApolloReactCommon.QueryResult<SectorsPerformanceMetricsByTaskResultsByDateQuery, SectorsPerformanceMetricsByTaskResultsByDateQueryVariables>;
export function refetchSectorsPerformanceMetricsByTaskResultsByDateQuery(variables: SectorsPerformanceMetricsByTaskResultsByDateQueryVariables) {
      return { query: SectorsPerformanceMetricsByTaskResultsByDateDocument, variables: variables }
    }
export const SectorDocument = gql`
    query sector($id: ID!) {
  data: sector(id: $id) {
    ...sectorFullFragment
    description
    sitesCount
    usersCount
    user {
      id
      lastName
      firstName
      avatarAttached {
        ...attachmentFragment
      }
      email
      phoneNumber
    }
  }
}
    ${SectorFullFragmentFragmentDoc}
${SectorFragmentFragmentDoc}
${AuthorizationResultFragmentFragmentDoc}
${LocationBoundaryFragmentFragmentDoc}
${GeojsonFragmentFragmentDoc}
${AttachmentFragmentFragmentDoc}`;

/**
 * __useSectorQuery__
 *
 * To run a query within a React component, call `useSectorQuery` and pass it any options that fit your needs.
 * When your component renders, `useSectorQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSectorQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useSectorQuery(baseOptions: ApolloReactHooks.QueryHookOptions<SectorQuery, SectorQueryVariables> & ({ variables: SectorQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<SectorQuery, SectorQueryVariables>(SectorDocument, options);
      }
export function useSectorLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<SectorQuery, SectorQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<SectorQuery, SectorQueryVariables>(SectorDocument, options);
        }
// @ts-ignore
export function useSectorSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<SectorQuery, SectorQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<SectorQuery, SectorQueryVariables>;
// @ts-ignore
export function useSectorSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<SectorQuery, SectorQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<SectorQuery | undefined, SectorQueryVariables>;
export function useSectorSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<SectorQuery, SectorQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          // @ts-ignore
          return ApolloReactHooks.useSuspenseQuery<SectorQuery, SectorQueryVariables>(SectorDocument, options);
        }
export type SectorQueryHookResult = ReturnType<typeof useSectorQuery>;
export type SectorLazyQueryHookResult = ReturnType<typeof useSectorLazyQuery>;
export type SectorSuspenseQueryHookResult = ReturnType<typeof useSectorSuspenseQuery>;
export type SectorQueryResult = ApolloReactCommon.QueryResult<SectorQuery, SectorQueryVariables>;
export function refetchSectorQuery(variables: SectorQueryVariables) {
      return { query: SectorDocument, variables: variables }
    }
export const SectorCreateDocument = gql`
    mutation sectorCreate($attributes: SectorCreateInputObject!) {
  data: sectorCreate(input: {attributes: $attributes}) {
    ...sectorFullFragment
    description
  }
}
    ${SectorFullFragmentFragmentDoc}
${SectorFragmentFragmentDoc}
${AuthorizationResultFragmentFragmentDoc}
${LocationBoundaryFragmentFragmentDoc}
${GeojsonFragmentFragmentDoc}`;

/**
 * __useSectorCreateMutation__
 *
 * To run a mutation, you first call `useSectorCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSectorCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sectorCreateMutation, { data, loading, error }] = useSectorCreateMutation({
 *   variables: {
 *      attributes: // value for 'attributes'
 *   },
 * });
 */
export function useSectorCreateMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<SectorCreateMutation, SectorCreateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<SectorCreateMutation, SectorCreateMutationVariables>(SectorCreateDocument, options);
      }
export type SectorCreateMutationHookResult = ReturnType<typeof useSectorCreateMutation>;
export type SectorCreateMutationResult = ApolloReactCommon.MutationResult<SectorCreateMutation>;
export const SectorUpdateDocument = gql`
    mutation sectorUpdate($attributes: SectorUpdateInputObject!, $id: ID!) {
  data: sectorUpdate(input: {attributes: $attributes, id: $id}) {
    ...sectorFullFragment
    description
  }
}
    ${SectorFullFragmentFragmentDoc}
${SectorFragmentFragmentDoc}
${AuthorizationResultFragmentFragmentDoc}
${LocationBoundaryFragmentFragmentDoc}
${GeojsonFragmentFragmentDoc}`;

/**
 * __useSectorUpdateMutation__
 *
 * To run a mutation, you first call `useSectorUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSectorUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sectorUpdateMutation, { data, loading, error }] = useSectorUpdateMutation({
 *   variables: {
 *      attributes: // value for 'attributes'
 *      id: // value for 'id'
 *   },
 * });
 */
export function useSectorUpdateMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<SectorUpdateMutation, SectorUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<SectorUpdateMutation, SectorUpdateMutationVariables>(SectorUpdateDocument, options);
      }
export type SectorUpdateMutationHookResult = ReturnType<typeof useSectorUpdateMutation>;
export type SectorUpdateMutationResult = ApolloReactCommon.MutationResult<SectorUpdateMutation>;
export const SectorDestroyDocument = gql`
    mutation sectorDestroy($id: ID!) {
  sectorDestroy(input: {id: $id})
}
    `;

/**
 * __useSectorDestroyMutation__
 *
 * To run a mutation, you first call `useSectorDestroyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSectorDestroyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sectorDestroyMutation, { data, loading, error }] = useSectorDestroyMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useSectorDestroyMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<SectorDestroyMutation, SectorDestroyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<SectorDestroyMutation, SectorDestroyMutationVariables>(SectorDestroyDocument, options);
      }
export type SectorDestroyMutationHookResult = ReturnType<typeof useSectorDestroyMutation>;
export type SectorDestroyMutationResult = ApolloReactCommon.MutationResult<SectorDestroyMutation>;
export const SiteDocument = gql`
    query site($findBy: SiteFindByInputObject!) {
  site(findBy: $findBy) {
    ...fullSiteFragment
  }
}
    ${FullSiteFragmentFragmentDoc}
${MainSiteFragmentFragmentDoc}
${AttachmentFragmentFragmentDoc}
${LocationBoundaryFragmentFragmentDoc}
${GeojsonFragmentFragmentDoc}`;

/**
 * __useSiteQuery__
 *
 * To run a query within a React component, call `useSiteQuery` and pass it any options that fit your needs.
 * When your component renders, `useSiteQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSiteQuery({
 *   variables: {
 *      findBy: // value for 'findBy'
 *   },
 * });
 */
export function useSiteQuery(baseOptions: ApolloReactHooks.QueryHookOptions<SiteQuery, SiteQueryVariables> & ({ variables: SiteQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<SiteQuery, SiteQueryVariables>(SiteDocument, options);
      }
export function useSiteLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<SiteQuery, SiteQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<SiteQuery, SiteQueryVariables>(SiteDocument, options);
        }
// @ts-ignore
export function useSiteSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<SiteQuery, SiteQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<SiteQuery, SiteQueryVariables>;
// @ts-ignore
export function useSiteSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<SiteQuery, SiteQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<SiteQuery | undefined, SiteQueryVariables>;
export function useSiteSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<SiteQuery, SiteQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          // @ts-ignore
          return ApolloReactHooks.useSuspenseQuery<SiteQuery, SiteQueryVariables>(SiteDocument, options);
        }
export type SiteQueryHookResult = ReturnType<typeof useSiteQuery>;
export type SiteLazyQueryHookResult = ReturnType<typeof useSiteLazyQuery>;
export type SiteSuspenseQueryHookResult = ReturnType<typeof useSiteSuspenseQuery>;
export type SiteQueryResult = ApolloReactCommon.QueryResult<SiteQuery, SiteQueryVariables>;
export function refetchSiteQuery(variables: SiteQueryVariables) {
      return { query: SiteDocument, variables: variables }
    }
export const SitesDocument = gql`
    query sites($page: Int, $limit: Int, $filters: [SiteFilterInputObject!], $taskFilters: [TaskFilterInputObject!], $sorts: SiteSortInputObject, $includeFullData: Boolean = false, $includePerformanceDataByTaskDeadlinesMissed: Boolean = false, $includePerformanceDataByTaskResults: Boolean = false) {
  data: sites(
    page: $page
    limit: $limit
    filters: $filters
    sorts: $sorts
    taskFilters: $taskFilters
  ) {
    collection {
      id
      name
      code @include(if: $includeFullData)
      locationPhotoAttached @include(if: $includeFullData) {
        ...attachmentFragment
      }
      siteAreasCount @include(if: $includeFullData)
      usersCount @include(if: $includeFullData)
      sector @include(if: $includeFullData) {
        id
        name
        color
      }
      totalAnomaliesByTaskDeadlinesMissed @include(if: $includePerformanceDataByTaskDeadlinesMissed)
      totalAnomaliesByTaskResults @include(if: $includePerformanceDataByTaskResults)
      successPercentageByTaskDeadlinesMissed @include(if: $includePerformanceDataByTaskDeadlinesMissed)
      successPercentageByTaskResults @include(if: $includePerformanceDataByTaskResults)
    }
    metadata {
      ...metadataFragment
    }
  }
}
    ${AttachmentFragmentFragmentDoc}
${MetadataFragmentFragmentDoc}`;

/**
 * __useSitesQuery__
 *
 * To run a query within a React component, call `useSitesQuery` and pass it any options that fit your needs.
 * When your component renders, `useSitesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSitesQuery({
 *   variables: {
 *      page: // value for 'page'
 *      limit: // value for 'limit'
 *      filters: // value for 'filters'
 *      taskFilters: // value for 'taskFilters'
 *      sorts: // value for 'sorts'
 *      includeFullData: // value for 'includeFullData'
 *      includePerformanceDataByTaskDeadlinesMissed: // value for 'includePerformanceDataByTaskDeadlinesMissed'
 *      includePerformanceDataByTaskResults: // value for 'includePerformanceDataByTaskResults'
 *   },
 * });
 */
export function useSitesQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<SitesQuery, SitesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<SitesQuery, SitesQueryVariables>(SitesDocument, options);
      }
export function useSitesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<SitesQuery, SitesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<SitesQuery, SitesQueryVariables>(SitesDocument, options);
        }
// @ts-ignore
export function useSitesSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<SitesQuery, SitesQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<SitesQuery, SitesQueryVariables>;
// @ts-ignore
export function useSitesSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<SitesQuery, SitesQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<SitesQuery | undefined, SitesQueryVariables>;
export function useSitesSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<SitesQuery, SitesQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          // @ts-ignore
          return ApolloReactHooks.useSuspenseQuery<SitesQuery, SitesQueryVariables>(SitesDocument, options);
        }
export type SitesQueryHookResult = ReturnType<typeof useSitesQuery>;
export type SitesLazyQueryHookResult = ReturnType<typeof useSitesLazyQuery>;
export type SitesSuspenseQueryHookResult = ReturnType<typeof useSitesSuspenseQuery>;
export type SitesQueryResult = ApolloReactCommon.QueryResult<SitesQuery, SitesQueryVariables>;
export function refetchSitesQuery(variables?: SitesQueryVariables) {
      return { query: SitesDocument, variables: variables }
    }
export const SiteLocationsDocument = gql`
    query siteLocations($filters: [LocationFilterInputObject!], $siteFilters: [SiteFilterInputObject!], $mapParams: LocationMapParamsInputObject!) {
  data: siteLocations(
    filters: $filters
    siteFilters: $siteFilters
    mapParams: $mapParams
  ) {
    ...geojsonFullFragment
  }
}
    ${GeojsonFullFragmentFragmentDoc}`;

/**
 * __useSiteLocationsQuery__
 *
 * To run a query within a React component, call `useSiteLocationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSiteLocationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSiteLocationsQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      siteFilters: // value for 'siteFilters'
 *      mapParams: // value for 'mapParams'
 *   },
 * });
 */
export function useSiteLocationsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<SiteLocationsQuery, SiteLocationsQueryVariables> & ({ variables: SiteLocationsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<SiteLocationsQuery, SiteLocationsQueryVariables>(SiteLocationsDocument, options);
      }
export function useSiteLocationsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<SiteLocationsQuery, SiteLocationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<SiteLocationsQuery, SiteLocationsQueryVariables>(SiteLocationsDocument, options);
        }
// @ts-ignore
export function useSiteLocationsSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<SiteLocationsQuery, SiteLocationsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<SiteLocationsQuery, SiteLocationsQueryVariables>;
// @ts-ignore
export function useSiteLocationsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<SiteLocationsQuery, SiteLocationsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<SiteLocationsQuery | undefined, SiteLocationsQueryVariables>;
export function useSiteLocationsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<SiteLocationsQuery, SiteLocationsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          // @ts-ignore
          return ApolloReactHooks.useSuspenseQuery<SiteLocationsQuery, SiteLocationsQueryVariables>(SiteLocationsDocument, options);
        }
export type SiteLocationsQueryHookResult = ReturnType<typeof useSiteLocationsQuery>;
export type SiteLocationsLazyQueryHookResult = ReturnType<typeof useSiteLocationsLazyQuery>;
export type SiteLocationsSuspenseQueryHookResult = ReturnType<typeof useSiteLocationsSuspenseQuery>;
export type SiteLocationsQueryResult = ApolloReactCommon.QueryResult<SiteLocationsQuery, SiteLocationsQueryVariables>;
export function refetchSiteLocationsQuery(variables: SiteLocationsQueryVariables) {
      return { query: SiteLocationsDocument, variables: variables }
    }
export const SiteLocationCenterDocument = gql`
    query siteLocationCenter($filters: [LocationFilterInputObject!], $siteFilters: [SiteFilterInputObject!]) {
  data: siteLocationCenter(filters: $filters, siteFilters: $siteFilters) {
    lat
    lon
  }
}
    `;

/**
 * __useSiteLocationCenterQuery__
 *
 * To run a query within a React component, call `useSiteLocationCenterQuery` and pass it any options that fit your needs.
 * When your component renders, `useSiteLocationCenterQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSiteLocationCenterQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      siteFilters: // value for 'siteFilters'
 *   },
 * });
 */
export function useSiteLocationCenterQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<SiteLocationCenterQuery, SiteLocationCenterQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<SiteLocationCenterQuery, SiteLocationCenterQueryVariables>(SiteLocationCenterDocument, options);
      }
export function useSiteLocationCenterLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<SiteLocationCenterQuery, SiteLocationCenterQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<SiteLocationCenterQuery, SiteLocationCenterQueryVariables>(SiteLocationCenterDocument, options);
        }
// @ts-ignore
export function useSiteLocationCenterSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<SiteLocationCenterQuery, SiteLocationCenterQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<SiteLocationCenterQuery, SiteLocationCenterQueryVariables>;
// @ts-ignore
export function useSiteLocationCenterSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<SiteLocationCenterQuery, SiteLocationCenterQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<SiteLocationCenterQuery | undefined, SiteLocationCenterQueryVariables>;
export function useSiteLocationCenterSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<SiteLocationCenterQuery, SiteLocationCenterQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          // @ts-ignore
          return ApolloReactHooks.useSuspenseQuery<SiteLocationCenterQuery, SiteLocationCenterQueryVariables>(SiteLocationCenterDocument, options);
        }
export type SiteLocationCenterQueryHookResult = ReturnType<typeof useSiteLocationCenterQuery>;
export type SiteLocationCenterLazyQueryHookResult = ReturnType<typeof useSiteLocationCenterLazyQuery>;
export type SiteLocationCenterSuspenseQueryHookResult = ReturnType<typeof useSiteLocationCenterSuspenseQuery>;
export type SiteLocationCenterQueryResult = ApolloReactCommon.QueryResult<SiteLocationCenterQuery, SiteLocationCenterQueryVariables>;
export function refetchSiteLocationCenterQuery(variables?: SiteLocationCenterQueryVariables) {
      return { query: SiteLocationCenterDocument, variables: variables }
    }
export const SitesIdsDocument = gql`
    query sitesIds($page: Int, $limit: Int, $filters: [SiteFilterInputObject!], $sorts: SiteSortInputObject, $onlyIds: Boolean) {
  data: sites(
    page: $page
    limit: $limit
    filters: $filters
    sorts: $sorts
    onlyIds: $onlyIds
  ) {
    collection {
      id
    }
  }
}
    `;

/**
 * __useSitesIdsQuery__
 *
 * To run a query within a React component, call `useSitesIdsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSitesIdsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSitesIdsQuery({
 *   variables: {
 *      page: // value for 'page'
 *      limit: // value for 'limit'
 *      filters: // value for 'filters'
 *      sorts: // value for 'sorts'
 *      onlyIds: // value for 'onlyIds'
 *   },
 * });
 */
export function useSitesIdsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<SitesIdsQuery, SitesIdsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<SitesIdsQuery, SitesIdsQueryVariables>(SitesIdsDocument, options);
      }
export function useSitesIdsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<SitesIdsQuery, SitesIdsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<SitesIdsQuery, SitesIdsQueryVariables>(SitesIdsDocument, options);
        }
// @ts-ignore
export function useSitesIdsSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<SitesIdsQuery, SitesIdsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<SitesIdsQuery, SitesIdsQueryVariables>;
// @ts-ignore
export function useSitesIdsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<SitesIdsQuery, SitesIdsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<SitesIdsQuery | undefined, SitesIdsQueryVariables>;
export function useSitesIdsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<SitesIdsQuery, SitesIdsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          // @ts-ignore
          return ApolloReactHooks.useSuspenseQuery<SitesIdsQuery, SitesIdsQueryVariables>(SitesIdsDocument, options);
        }
export type SitesIdsQueryHookResult = ReturnType<typeof useSitesIdsQuery>;
export type SitesIdsLazyQueryHookResult = ReturnType<typeof useSitesIdsLazyQuery>;
export type SitesIdsSuspenseQueryHookResult = ReturnType<typeof useSitesIdsSuspenseQuery>;
export type SitesIdsQueryResult = ApolloReactCommon.QueryResult<SitesIdsQuery, SitesIdsQueryVariables>;
export function refetchSitesIdsQuery(variables?: SitesIdsQueryVariables) {
      return { query: SitesIdsDocument, variables: variables }
    }
export const SitesSearchListDocument = gql`
    query sitesSearchList($page: Int, $limit: Int, $filters: [SiteFilterInputObject!], $sorts: SiteSortInputObject, $includeSector: Boolean = false) {
  data: sites(page: $page, limit: $limit, filters: $filters, sorts: $sorts) {
    collection {
      id
      name
      code
      sector @include(if: $includeSector) {
        id
        name
        color
      }
    }
    metadata {
      ...metadataFragment
    }
  }
}
    ${MetadataFragmentFragmentDoc}`;

/**
 * __useSitesSearchListQuery__
 *
 * To run a query within a React component, call `useSitesSearchListQuery` and pass it any options that fit your needs.
 * When your component renders, `useSitesSearchListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSitesSearchListQuery({
 *   variables: {
 *      page: // value for 'page'
 *      limit: // value for 'limit'
 *      filters: // value for 'filters'
 *      sorts: // value for 'sorts'
 *      includeSector: // value for 'includeSector'
 *   },
 * });
 */
export function useSitesSearchListQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<SitesSearchListQuery, SitesSearchListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<SitesSearchListQuery, SitesSearchListQueryVariables>(SitesSearchListDocument, options);
      }
export function useSitesSearchListLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<SitesSearchListQuery, SitesSearchListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<SitesSearchListQuery, SitesSearchListQueryVariables>(SitesSearchListDocument, options);
        }
// @ts-ignore
export function useSitesSearchListSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<SitesSearchListQuery, SitesSearchListQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<SitesSearchListQuery, SitesSearchListQueryVariables>;
// @ts-ignore
export function useSitesSearchListSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<SitesSearchListQuery, SitesSearchListQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<SitesSearchListQuery | undefined, SitesSearchListQueryVariables>;
export function useSitesSearchListSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<SitesSearchListQuery, SitesSearchListQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          // @ts-ignore
          return ApolloReactHooks.useSuspenseQuery<SitesSearchListQuery, SitesSearchListQueryVariables>(SitesSearchListDocument, options);
        }
export type SitesSearchListQueryHookResult = ReturnType<typeof useSitesSearchListQuery>;
export type SitesSearchListLazyQueryHookResult = ReturnType<typeof useSitesSearchListLazyQuery>;
export type SitesSearchListSuspenseQueryHookResult = ReturnType<typeof useSitesSearchListSuspenseQuery>;
export type SitesSearchListQueryResult = ApolloReactCommon.QueryResult<SitesSearchListQuery, SitesSearchListQueryVariables>;
export function refetchSitesSearchListQuery(variables?: SitesSearchListQueryVariables) {
      return { query: SitesSearchListDocument, variables: variables }
    }
export const SitesPerformanceMetricsByTaskDeadlinesMissedDocument = gql`
    query sitesPerformanceMetricsByTaskDeadlinesMissed($ids: [ID!]!, $taskFilters: [TaskFilterInputObject!]) {
  data: sitesPerformanceMetricsByTaskDeadlinesMissed(
    ids: $ids
    taskFilters: $taskFilters
  ) {
    id
    successPercentageByTaskDeadlinesMissed
    totalAnomaliesByTaskDeadlinesMissed
  }
}
    `;

/**
 * __useSitesPerformanceMetricsByTaskDeadlinesMissedQuery__
 *
 * To run a query within a React component, call `useSitesPerformanceMetricsByTaskDeadlinesMissedQuery` and pass it any options that fit your needs.
 * When your component renders, `useSitesPerformanceMetricsByTaskDeadlinesMissedQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSitesPerformanceMetricsByTaskDeadlinesMissedQuery({
 *   variables: {
 *      ids: // value for 'ids'
 *      taskFilters: // value for 'taskFilters'
 *   },
 * });
 */
export function useSitesPerformanceMetricsByTaskDeadlinesMissedQuery(baseOptions: ApolloReactHooks.QueryHookOptions<SitesPerformanceMetricsByTaskDeadlinesMissedQuery, SitesPerformanceMetricsByTaskDeadlinesMissedQueryVariables> & ({ variables: SitesPerformanceMetricsByTaskDeadlinesMissedQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<SitesPerformanceMetricsByTaskDeadlinesMissedQuery, SitesPerformanceMetricsByTaskDeadlinesMissedQueryVariables>(SitesPerformanceMetricsByTaskDeadlinesMissedDocument, options);
      }
export function useSitesPerformanceMetricsByTaskDeadlinesMissedLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<SitesPerformanceMetricsByTaskDeadlinesMissedQuery, SitesPerformanceMetricsByTaskDeadlinesMissedQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<SitesPerformanceMetricsByTaskDeadlinesMissedQuery, SitesPerformanceMetricsByTaskDeadlinesMissedQueryVariables>(SitesPerformanceMetricsByTaskDeadlinesMissedDocument, options);
        }
// @ts-ignore
export function useSitesPerformanceMetricsByTaskDeadlinesMissedSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<SitesPerformanceMetricsByTaskDeadlinesMissedQuery, SitesPerformanceMetricsByTaskDeadlinesMissedQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<SitesPerformanceMetricsByTaskDeadlinesMissedQuery, SitesPerformanceMetricsByTaskDeadlinesMissedQueryVariables>;
// @ts-ignore
export function useSitesPerformanceMetricsByTaskDeadlinesMissedSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<SitesPerformanceMetricsByTaskDeadlinesMissedQuery, SitesPerformanceMetricsByTaskDeadlinesMissedQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<SitesPerformanceMetricsByTaskDeadlinesMissedQuery | undefined, SitesPerformanceMetricsByTaskDeadlinesMissedQueryVariables>;
export function useSitesPerformanceMetricsByTaskDeadlinesMissedSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<SitesPerformanceMetricsByTaskDeadlinesMissedQuery, SitesPerformanceMetricsByTaskDeadlinesMissedQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          // @ts-ignore
          return ApolloReactHooks.useSuspenseQuery<SitesPerformanceMetricsByTaskDeadlinesMissedQuery, SitesPerformanceMetricsByTaskDeadlinesMissedQueryVariables>(SitesPerformanceMetricsByTaskDeadlinesMissedDocument, options);
        }
export type SitesPerformanceMetricsByTaskDeadlinesMissedQueryHookResult = ReturnType<typeof useSitesPerformanceMetricsByTaskDeadlinesMissedQuery>;
export type SitesPerformanceMetricsByTaskDeadlinesMissedLazyQueryHookResult = ReturnType<typeof useSitesPerformanceMetricsByTaskDeadlinesMissedLazyQuery>;
export type SitesPerformanceMetricsByTaskDeadlinesMissedSuspenseQueryHookResult = ReturnType<typeof useSitesPerformanceMetricsByTaskDeadlinesMissedSuspenseQuery>;
export type SitesPerformanceMetricsByTaskDeadlinesMissedQueryResult = ApolloReactCommon.QueryResult<SitesPerformanceMetricsByTaskDeadlinesMissedQuery, SitesPerformanceMetricsByTaskDeadlinesMissedQueryVariables>;
export function refetchSitesPerformanceMetricsByTaskDeadlinesMissedQuery(variables: SitesPerformanceMetricsByTaskDeadlinesMissedQueryVariables) {
      return { query: SitesPerformanceMetricsByTaskDeadlinesMissedDocument, variables: variables }
    }
export const SitesPerformanceMetricsByTaskDeadlinesMissedByDateDocument = gql`
    query sitesPerformanceMetricsByTaskDeadlinesMissedByDate($ids: [ID!]!, $taskFilters: [TaskFilterInputObject!], $periodGroupBy: PeriodGroupByEnum!) {
  data: sitesPerformanceMetricsByTaskDeadlinesMissedByDate(
    ids: $ids
    taskFilters: $taskFilters
    periodGroupBy: $periodGroupBy
  ) {
    id
    period
    totalAnomaliesByTaskDeadlinesMissed
  }
}
    `;

/**
 * __useSitesPerformanceMetricsByTaskDeadlinesMissedByDateQuery__
 *
 * To run a query within a React component, call `useSitesPerformanceMetricsByTaskDeadlinesMissedByDateQuery` and pass it any options that fit your needs.
 * When your component renders, `useSitesPerformanceMetricsByTaskDeadlinesMissedByDateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSitesPerformanceMetricsByTaskDeadlinesMissedByDateQuery({
 *   variables: {
 *      ids: // value for 'ids'
 *      taskFilters: // value for 'taskFilters'
 *      periodGroupBy: // value for 'periodGroupBy'
 *   },
 * });
 */
export function useSitesPerformanceMetricsByTaskDeadlinesMissedByDateQuery(baseOptions: ApolloReactHooks.QueryHookOptions<SitesPerformanceMetricsByTaskDeadlinesMissedByDateQuery, SitesPerformanceMetricsByTaskDeadlinesMissedByDateQueryVariables> & ({ variables: SitesPerformanceMetricsByTaskDeadlinesMissedByDateQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<SitesPerformanceMetricsByTaskDeadlinesMissedByDateQuery, SitesPerformanceMetricsByTaskDeadlinesMissedByDateQueryVariables>(SitesPerformanceMetricsByTaskDeadlinesMissedByDateDocument, options);
      }
export function useSitesPerformanceMetricsByTaskDeadlinesMissedByDateLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<SitesPerformanceMetricsByTaskDeadlinesMissedByDateQuery, SitesPerformanceMetricsByTaskDeadlinesMissedByDateQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<SitesPerformanceMetricsByTaskDeadlinesMissedByDateQuery, SitesPerformanceMetricsByTaskDeadlinesMissedByDateQueryVariables>(SitesPerformanceMetricsByTaskDeadlinesMissedByDateDocument, options);
        }
// @ts-ignore
export function useSitesPerformanceMetricsByTaskDeadlinesMissedByDateSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<SitesPerformanceMetricsByTaskDeadlinesMissedByDateQuery, SitesPerformanceMetricsByTaskDeadlinesMissedByDateQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<SitesPerformanceMetricsByTaskDeadlinesMissedByDateQuery, SitesPerformanceMetricsByTaskDeadlinesMissedByDateQueryVariables>;
// @ts-ignore
export function useSitesPerformanceMetricsByTaskDeadlinesMissedByDateSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<SitesPerformanceMetricsByTaskDeadlinesMissedByDateQuery, SitesPerformanceMetricsByTaskDeadlinesMissedByDateQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<SitesPerformanceMetricsByTaskDeadlinesMissedByDateQuery | undefined, SitesPerformanceMetricsByTaskDeadlinesMissedByDateQueryVariables>;
export function useSitesPerformanceMetricsByTaskDeadlinesMissedByDateSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<SitesPerformanceMetricsByTaskDeadlinesMissedByDateQuery, SitesPerformanceMetricsByTaskDeadlinesMissedByDateQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          // @ts-ignore
          return ApolloReactHooks.useSuspenseQuery<SitesPerformanceMetricsByTaskDeadlinesMissedByDateQuery, SitesPerformanceMetricsByTaskDeadlinesMissedByDateQueryVariables>(SitesPerformanceMetricsByTaskDeadlinesMissedByDateDocument, options);
        }
export type SitesPerformanceMetricsByTaskDeadlinesMissedByDateQueryHookResult = ReturnType<typeof useSitesPerformanceMetricsByTaskDeadlinesMissedByDateQuery>;
export type SitesPerformanceMetricsByTaskDeadlinesMissedByDateLazyQueryHookResult = ReturnType<typeof useSitesPerformanceMetricsByTaskDeadlinesMissedByDateLazyQuery>;
export type SitesPerformanceMetricsByTaskDeadlinesMissedByDateSuspenseQueryHookResult = ReturnType<typeof useSitesPerformanceMetricsByTaskDeadlinesMissedByDateSuspenseQuery>;
export type SitesPerformanceMetricsByTaskDeadlinesMissedByDateQueryResult = ApolloReactCommon.QueryResult<SitesPerformanceMetricsByTaskDeadlinesMissedByDateQuery, SitesPerformanceMetricsByTaskDeadlinesMissedByDateQueryVariables>;
export function refetchSitesPerformanceMetricsByTaskDeadlinesMissedByDateQuery(variables: SitesPerformanceMetricsByTaskDeadlinesMissedByDateQueryVariables) {
      return { query: SitesPerformanceMetricsByTaskDeadlinesMissedByDateDocument, variables: variables }
    }
export const SitesPerformanceMetricsByTaskResultsDocument = gql`
    query sitesPerformanceMetricsByTaskResults($ids: [ID!]!, $taskFilters: [TaskFilterInputObject!]) {
  data: sitesPerformanceMetricsByTaskResults(ids: $ids, taskFilters: $taskFilters) {
    id
    successPercentageByTaskResults
    totalAnomaliesByTaskResults
  }
}
    `;

/**
 * __useSitesPerformanceMetricsByTaskResultsQuery__
 *
 * To run a query within a React component, call `useSitesPerformanceMetricsByTaskResultsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSitesPerformanceMetricsByTaskResultsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSitesPerformanceMetricsByTaskResultsQuery({
 *   variables: {
 *      ids: // value for 'ids'
 *      taskFilters: // value for 'taskFilters'
 *   },
 * });
 */
export function useSitesPerformanceMetricsByTaskResultsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<SitesPerformanceMetricsByTaskResultsQuery, SitesPerformanceMetricsByTaskResultsQueryVariables> & ({ variables: SitesPerformanceMetricsByTaskResultsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<SitesPerformanceMetricsByTaskResultsQuery, SitesPerformanceMetricsByTaskResultsQueryVariables>(SitesPerformanceMetricsByTaskResultsDocument, options);
      }
export function useSitesPerformanceMetricsByTaskResultsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<SitesPerformanceMetricsByTaskResultsQuery, SitesPerformanceMetricsByTaskResultsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<SitesPerformanceMetricsByTaskResultsQuery, SitesPerformanceMetricsByTaskResultsQueryVariables>(SitesPerformanceMetricsByTaskResultsDocument, options);
        }
// @ts-ignore
export function useSitesPerformanceMetricsByTaskResultsSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<SitesPerformanceMetricsByTaskResultsQuery, SitesPerformanceMetricsByTaskResultsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<SitesPerformanceMetricsByTaskResultsQuery, SitesPerformanceMetricsByTaskResultsQueryVariables>;
// @ts-ignore
export function useSitesPerformanceMetricsByTaskResultsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<SitesPerformanceMetricsByTaskResultsQuery, SitesPerformanceMetricsByTaskResultsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<SitesPerformanceMetricsByTaskResultsQuery | undefined, SitesPerformanceMetricsByTaskResultsQueryVariables>;
export function useSitesPerformanceMetricsByTaskResultsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<SitesPerformanceMetricsByTaskResultsQuery, SitesPerformanceMetricsByTaskResultsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          // @ts-ignore
          return ApolloReactHooks.useSuspenseQuery<SitesPerformanceMetricsByTaskResultsQuery, SitesPerformanceMetricsByTaskResultsQueryVariables>(SitesPerformanceMetricsByTaskResultsDocument, options);
        }
export type SitesPerformanceMetricsByTaskResultsQueryHookResult = ReturnType<typeof useSitesPerformanceMetricsByTaskResultsQuery>;
export type SitesPerformanceMetricsByTaskResultsLazyQueryHookResult = ReturnType<typeof useSitesPerformanceMetricsByTaskResultsLazyQuery>;
export type SitesPerformanceMetricsByTaskResultsSuspenseQueryHookResult = ReturnType<typeof useSitesPerformanceMetricsByTaskResultsSuspenseQuery>;
export type SitesPerformanceMetricsByTaskResultsQueryResult = ApolloReactCommon.QueryResult<SitesPerformanceMetricsByTaskResultsQuery, SitesPerformanceMetricsByTaskResultsQueryVariables>;
export function refetchSitesPerformanceMetricsByTaskResultsQuery(variables: SitesPerformanceMetricsByTaskResultsQueryVariables) {
      return { query: SitesPerformanceMetricsByTaskResultsDocument, variables: variables }
    }
export const SitesPerformanceMetricsByTaskResultsByDateDocument = gql`
    query sitesPerformanceMetricsByTaskResultsByDate($ids: [ID!]!, $periodGroupBy: PeriodGroupByEnum!, $taskFilters: [TaskFilterInputObject!]) {
  data: sitesPerformanceMetricsByTaskResultsByDate(
    ids: $ids
    periodGroupBy: $periodGroupBy
    taskFilters: $taskFilters
  ) {
    id
    period
    totalAnomaliesByTaskResults
  }
}
    `;

/**
 * __useSitesPerformanceMetricsByTaskResultsByDateQuery__
 *
 * To run a query within a React component, call `useSitesPerformanceMetricsByTaskResultsByDateQuery` and pass it any options that fit your needs.
 * When your component renders, `useSitesPerformanceMetricsByTaskResultsByDateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSitesPerformanceMetricsByTaskResultsByDateQuery({
 *   variables: {
 *      ids: // value for 'ids'
 *      periodGroupBy: // value for 'periodGroupBy'
 *      taskFilters: // value for 'taskFilters'
 *   },
 * });
 */
export function useSitesPerformanceMetricsByTaskResultsByDateQuery(baseOptions: ApolloReactHooks.QueryHookOptions<SitesPerformanceMetricsByTaskResultsByDateQuery, SitesPerformanceMetricsByTaskResultsByDateQueryVariables> & ({ variables: SitesPerformanceMetricsByTaskResultsByDateQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<SitesPerformanceMetricsByTaskResultsByDateQuery, SitesPerformanceMetricsByTaskResultsByDateQueryVariables>(SitesPerformanceMetricsByTaskResultsByDateDocument, options);
      }
export function useSitesPerformanceMetricsByTaskResultsByDateLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<SitesPerformanceMetricsByTaskResultsByDateQuery, SitesPerformanceMetricsByTaskResultsByDateQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<SitesPerformanceMetricsByTaskResultsByDateQuery, SitesPerformanceMetricsByTaskResultsByDateQueryVariables>(SitesPerformanceMetricsByTaskResultsByDateDocument, options);
        }
// @ts-ignore
export function useSitesPerformanceMetricsByTaskResultsByDateSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<SitesPerformanceMetricsByTaskResultsByDateQuery, SitesPerformanceMetricsByTaskResultsByDateQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<SitesPerformanceMetricsByTaskResultsByDateQuery, SitesPerformanceMetricsByTaskResultsByDateQueryVariables>;
// @ts-ignore
export function useSitesPerformanceMetricsByTaskResultsByDateSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<SitesPerformanceMetricsByTaskResultsByDateQuery, SitesPerformanceMetricsByTaskResultsByDateQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<SitesPerformanceMetricsByTaskResultsByDateQuery | undefined, SitesPerformanceMetricsByTaskResultsByDateQueryVariables>;
export function useSitesPerformanceMetricsByTaskResultsByDateSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<SitesPerformanceMetricsByTaskResultsByDateQuery, SitesPerformanceMetricsByTaskResultsByDateQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          // @ts-ignore
          return ApolloReactHooks.useSuspenseQuery<SitesPerformanceMetricsByTaskResultsByDateQuery, SitesPerformanceMetricsByTaskResultsByDateQueryVariables>(SitesPerformanceMetricsByTaskResultsByDateDocument, options);
        }
export type SitesPerformanceMetricsByTaskResultsByDateQueryHookResult = ReturnType<typeof useSitesPerformanceMetricsByTaskResultsByDateQuery>;
export type SitesPerformanceMetricsByTaskResultsByDateLazyQueryHookResult = ReturnType<typeof useSitesPerformanceMetricsByTaskResultsByDateLazyQuery>;
export type SitesPerformanceMetricsByTaskResultsByDateSuspenseQueryHookResult = ReturnType<typeof useSitesPerformanceMetricsByTaskResultsByDateSuspenseQuery>;
export type SitesPerformanceMetricsByTaskResultsByDateQueryResult = ApolloReactCommon.QueryResult<SitesPerformanceMetricsByTaskResultsByDateQuery, SitesPerformanceMetricsByTaskResultsByDateQueryVariables>;
export function refetchSitesPerformanceMetricsByTaskResultsByDateQuery(variables: SitesPerformanceMetricsByTaskResultsByDateQueryVariables) {
      return { query: SitesPerformanceMetricsByTaskResultsByDateDocument, variables: variables }
    }
export const SiteCreateDocument = gql`
    mutation siteCreate($attributes: SiteCreateInputObject!) {
  data: siteCreate(input: {attributes: $attributes}) {
    ...fullSiteFragment
  }
}
    ${FullSiteFragmentFragmentDoc}
${MainSiteFragmentFragmentDoc}
${AttachmentFragmentFragmentDoc}
${LocationBoundaryFragmentFragmentDoc}
${GeojsonFragmentFragmentDoc}`;

/**
 * __useSiteCreateMutation__
 *
 * To run a mutation, you first call `useSiteCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSiteCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [siteCreateMutation, { data, loading, error }] = useSiteCreateMutation({
 *   variables: {
 *      attributes: // value for 'attributes'
 *   },
 * });
 */
export function useSiteCreateMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<SiteCreateMutation, SiteCreateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<SiteCreateMutation, SiteCreateMutationVariables>(SiteCreateDocument, options);
      }
export type SiteCreateMutationHookResult = ReturnType<typeof useSiteCreateMutation>;
export type SiteCreateMutationResult = ApolloReactCommon.MutationResult<SiteCreateMutation>;
export const SiteUpdateDocument = gql`
    mutation siteUpdate($id: ID!, $attributes: SiteUpdateInputObject!) {
  data: siteUpdate(input: {id: $id, attributes: $attributes}) {
    ...fullSiteFragment
  }
}
    ${FullSiteFragmentFragmentDoc}
${MainSiteFragmentFragmentDoc}
${AttachmentFragmentFragmentDoc}
${LocationBoundaryFragmentFragmentDoc}
${GeojsonFragmentFragmentDoc}`;

/**
 * __useSiteUpdateMutation__
 *
 * To run a mutation, you first call `useSiteUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSiteUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [siteUpdateMutation, { data, loading, error }] = useSiteUpdateMutation({
 *   variables: {
 *      id: // value for 'id'
 *      attributes: // value for 'attributes'
 *   },
 * });
 */
export function useSiteUpdateMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<SiteUpdateMutation, SiteUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<SiteUpdateMutation, SiteUpdateMutationVariables>(SiteUpdateDocument, options);
      }
export type SiteUpdateMutationHookResult = ReturnType<typeof useSiteUpdateMutation>;
export type SiteUpdateMutationResult = ApolloReactCommon.MutationResult<SiteUpdateMutation>;
export const SiteDestroyDocument = gql`
    mutation siteDestroy($id: ID!) {
  data: siteDestroy(input: {id: $id})
}
    `;

/**
 * __useSiteDestroyMutation__
 *
 * To run a mutation, you first call `useSiteDestroyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSiteDestroyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [siteDestroyMutation, { data, loading, error }] = useSiteDestroyMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useSiteDestroyMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<SiteDestroyMutation, SiteDestroyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<SiteDestroyMutation, SiteDestroyMutationVariables>(SiteDestroyDocument, options);
      }
export type SiteDestroyMutationHookResult = ReturnType<typeof useSiteDestroyMutation>;
export type SiteDestroyMutationResult = ApolloReactCommon.MutationResult<SiteDestroyMutation>;
export const SiteAreaDocument = gql`
    query siteArea($findBy: SiteAreaFindByInputObject!, $siteFindBy: SiteFindByInputObject!) {
  data: siteArea(findBy: $findBy, siteFindBy: $siteFindBy) {
    ...siteAreaFragment
  }
}
    ${SiteAreaFragmentFragmentDoc}
${AuthorizationResultFragmentFragmentDoc}`;

/**
 * __useSiteAreaQuery__
 *
 * To run a query within a React component, call `useSiteAreaQuery` and pass it any options that fit your needs.
 * When your component renders, `useSiteAreaQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSiteAreaQuery({
 *   variables: {
 *      findBy: // value for 'findBy'
 *      siteFindBy: // value for 'siteFindBy'
 *   },
 * });
 */
export function useSiteAreaQuery(baseOptions: ApolloReactHooks.QueryHookOptions<SiteAreaQuery, SiteAreaQueryVariables> & ({ variables: SiteAreaQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<SiteAreaQuery, SiteAreaQueryVariables>(SiteAreaDocument, options);
      }
export function useSiteAreaLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<SiteAreaQuery, SiteAreaQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<SiteAreaQuery, SiteAreaQueryVariables>(SiteAreaDocument, options);
        }
// @ts-ignore
export function useSiteAreaSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<SiteAreaQuery, SiteAreaQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<SiteAreaQuery, SiteAreaQueryVariables>;
// @ts-ignore
export function useSiteAreaSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<SiteAreaQuery, SiteAreaQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<SiteAreaQuery | undefined, SiteAreaQueryVariables>;
export function useSiteAreaSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<SiteAreaQuery, SiteAreaQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          // @ts-ignore
          return ApolloReactHooks.useSuspenseQuery<SiteAreaQuery, SiteAreaQueryVariables>(SiteAreaDocument, options);
        }
export type SiteAreaQueryHookResult = ReturnType<typeof useSiteAreaQuery>;
export type SiteAreaLazyQueryHookResult = ReturnType<typeof useSiteAreaLazyQuery>;
export type SiteAreaSuspenseQueryHookResult = ReturnType<typeof useSiteAreaSuspenseQuery>;
export type SiteAreaQueryResult = ApolloReactCommon.QueryResult<SiteAreaQuery, SiteAreaQueryVariables>;
export function refetchSiteAreaQuery(variables: SiteAreaQueryVariables) {
      return { query: SiteAreaDocument, variables: variables }
    }
export const SiteAreasDocument = gql`
    query siteAreas($page: Int, $limit: Int, $filters: [SiteAreaFilterInputObject!], $sorts: SiteAreaSortInputObject, $includeFullData: Boolean = false, $includeSiteData: Boolean = false, $includeCanDestroy: Boolean = false) {
  data: siteAreas(page: $page, limit: $limit, filters: $filters, sorts: $sorts) {
    collection {
      address @include(if: $includeFullData)
      canDestroy @include(if: $includeCanDestroy) {
        ...authorizationResultFragment
      }
      code
      description @include(if: $includeFullData)
      fullCode
      id
      name
      poorWifi @include(if: $includeFullData)
      site @include(if: $includeSiteData) {
        id
        name
        code
        sector {
          id
          name
          color
        }
      }
    }
    metadata {
      ...metadataFragment
    }
  }
}
    ${AuthorizationResultFragmentFragmentDoc}
${MetadataFragmentFragmentDoc}`;

/**
 * __useSiteAreasQuery__
 *
 * To run a query within a React component, call `useSiteAreasQuery` and pass it any options that fit your needs.
 * When your component renders, `useSiteAreasQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSiteAreasQuery({
 *   variables: {
 *      page: // value for 'page'
 *      limit: // value for 'limit'
 *      filters: // value for 'filters'
 *      sorts: // value for 'sorts'
 *      includeFullData: // value for 'includeFullData'
 *      includeSiteData: // value for 'includeSiteData'
 *      includeCanDestroy: // value for 'includeCanDestroy'
 *   },
 * });
 */
export function useSiteAreasQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<SiteAreasQuery, SiteAreasQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<SiteAreasQuery, SiteAreasQueryVariables>(SiteAreasDocument, options);
      }
export function useSiteAreasLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<SiteAreasQuery, SiteAreasQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<SiteAreasQuery, SiteAreasQueryVariables>(SiteAreasDocument, options);
        }
// @ts-ignore
export function useSiteAreasSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<SiteAreasQuery, SiteAreasQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<SiteAreasQuery, SiteAreasQueryVariables>;
// @ts-ignore
export function useSiteAreasSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<SiteAreasQuery, SiteAreasQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<SiteAreasQuery | undefined, SiteAreasQueryVariables>;
export function useSiteAreasSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<SiteAreasQuery, SiteAreasQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          // @ts-ignore
          return ApolloReactHooks.useSuspenseQuery<SiteAreasQuery, SiteAreasQueryVariables>(SiteAreasDocument, options);
        }
export type SiteAreasQueryHookResult = ReturnType<typeof useSiteAreasQuery>;
export type SiteAreasLazyQueryHookResult = ReturnType<typeof useSiteAreasLazyQuery>;
export type SiteAreasSuspenseQueryHookResult = ReturnType<typeof useSiteAreasSuspenseQuery>;
export type SiteAreasQueryResult = ApolloReactCommon.QueryResult<SiteAreasQuery, SiteAreasQueryVariables>;
export function refetchSiteAreasQuery(variables?: SiteAreasQueryVariables) {
      return { query: SiteAreasDocument, variables: variables }
    }
export const SiteAreaIdsDocument = gql`
    query siteAreaIds($filters: [SiteAreaFilterInputObject!], $sorts: SiteAreaSortInputObject, $onlyIds: Boolean, $includeSiteId: Boolean = false) {
  data: siteAreas(filters: $filters, sorts: $sorts, onlyIds: $onlyIds) {
    collection {
      id
      siteId @include(if: $includeSiteId)
    }
  }
}
    `;

/**
 * __useSiteAreaIdsQuery__
 *
 * To run a query within a React component, call `useSiteAreaIdsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSiteAreaIdsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSiteAreaIdsQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      sorts: // value for 'sorts'
 *      onlyIds: // value for 'onlyIds'
 *      includeSiteId: // value for 'includeSiteId'
 *   },
 * });
 */
export function useSiteAreaIdsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<SiteAreaIdsQuery, SiteAreaIdsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<SiteAreaIdsQuery, SiteAreaIdsQueryVariables>(SiteAreaIdsDocument, options);
      }
export function useSiteAreaIdsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<SiteAreaIdsQuery, SiteAreaIdsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<SiteAreaIdsQuery, SiteAreaIdsQueryVariables>(SiteAreaIdsDocument, options);
        }
// @ts-ignore
export function useSiteAreaIdsSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<SiteAreaIdsQuery, SiteAreaIdsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<SiteAreaIdsQuery, SiteAreaIdsQueryVariables>;
// @ts-ignore
export function useSiteAreaIdsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<SiteAreaIdsQuery, SiteAreaIdsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<SiteAreaIdsQuery | undefined, SiteAreaIdsQueryVariables>;
export function useSiteAreaIdsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<SiteAreaIdsQuery, SiteAreaIdsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          // @ts-ignore
          return ApolloReactHooks.useSuspenseQuery<SiteAreaIdsQuery, SiteAreaIdsQueryVariables>(SiteAreaIdsDocument, options);
        }
export type SiteAreaIdsQueryHookResult = ReturnType<typeof useSiteAreaIdsQuery>;
export type SiteAreaIdsLazyQueryHookResult = ReturnType<typeof useSiteAreaIdsLazyQuery>;
export type SiteAreaIdsSuspenseQueryHookResult = ReturnType<typeof useSiteAreaIdsSuspenseQuery>;
export type SiteAreaIdsQueryResult = ApolloReactCommon.QueryResult<SiteAreaIdsQuery, SiteAreaIdsQueryVariables>;
export function refetchSiteAreaIdsQuery(variables?: SiteAreaIdsQueryVariables) {
      return { query: SiteAreaIdsDocument, variables: variables }
    }
export const SiteAreasSearchListDocument = gql`
    query siteAreasSearchList($page: Int, $limit: Int, $filters: [SiteAreaFilterInputObject!], $sorts: SiteAreaSortInputObject) {
  data: siteAreas(page: $page, limit: $limit, filters: $filters, sorts: $sorts) {
    collection {
      id
      name
      poorWifi
    }
    metadata {
      ...metadataFragment
    }
  }
}
    ${MetadataFragmentFragmentDoc}`;

/**
 * __useSiteAreasSearchListQuery__
 *
 * To run a query within a React component, call `useSiteAreasSearchListQuery` and pass it any options that fit your needs.
 * When your component renders, `useSiteAreasSearchListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSiteAreasSearchListQuery({
 *   variables: {
 *      page: // value for 'page'
 *      limit: // value for 'limit'
 *      filters: // value for 'filters'
 *      sorts: // value for 'sorts'
 *   },
 * });
 */
export function useSiteAreasSearchListQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<SiteAreasSearchListQuery, SiteAreasSearchListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<SiteAreasSearchListQuery, SiteAreasSearchListQueryVariables>(SiteAreasSearchListDocument, options);
      }
export function useSiteAreasSearchListLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<SiteAreasSearchListQuery, SiteAreasSearchListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<SiteAreasSearchListQuery, SiteAreasSearchListQueryVariables>(SiteAreasSearchListDocument, options);
        }
// @ts-ignore
export function useSiteAreasSearchListSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<SiteAreasSearchListQuery, SiteAreasSearchListQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<SiteAreasSearchListQuery, SiteAreasSearchListQueryVariables>;
// @ts-ignore
export function useSiteAreasSearchListSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<SiteAreasSearchListQuery, SiteAreasSearchListQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<SiteAreasSearchListQuery | undefined, SiteAreasSearchListQueryVariables>;
export function useSiteAreasSearchListSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<SiteAreasSearchListQuery, SiteAreasSearchListQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          // @ts-ignore
          return ApolloReactHooks.useSuspenseQuery<SiteAreasSearchListQuery, SiteAreasSearchListQueryVariables>(SiteAreasSearchListDocument, options);
        }
export type SiteAreasSearchListQueryHookResult = ReturnType<typeof useSiteAreasSearchListQuery>;
export type SiteAreasSearchListLazyQueryHookResult = ReturnType<typeof useSiteAreasSearchListLazyQuery>;
export type SiteAreasSearchListSuspenseQueryHookResult = ReturnType<typeof useSiteAreasSearchListSuspenseQuery>;
export type SiteAreasSearchListQueryResult = ApolloReactCommon.QueryResult<SiteAreasSearchListQuery, SiteAreasSearchListQueryVariables>;
export function refetchSiteAreasSearchListQuery(variables?: SiteAreasSearchListQueryVariables) {
      return { query: SiteAreasSearchListDocument, variables: variables }
    }
export const SiteAreaUpdateDocument = gql`
    mutation siteAreaUpdate($id: ID!, $attributes: SiteAreaUpdateInputObject!) {
  data: siteAreaUpdate(input: {id: $id, attributes: $attributes}) {
    ...siteAreaFragment
  }
}
    ${SiteAreaFragmentFragmentDoc}
${AuthorizationResultFragmentFragmentDoc}`;

/**
 * __useSiteAreaUpdateMutation__
 *
 * To run a mutation, you first call `useSiteAreaUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSiteAreaUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [siteAreaUpdateMutation, { data, loading, error }] = useSiteAreaUpdateMutation({
 *   variables: {
 *      id: // value for 'id'
 *      attributes: // value for 'attributes'
 *   },
 * });
 */
export function useSiteAreaUpdateMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<SiteAreaUpdateMutation, SiteAreaUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<SiteAreaUpdateMutation, SiteAreaUpdateMutationVariables>(SiteAreaUpdateDocument, options);
      }
export type SiteAreaUpdateMutationHookResult = ReturnType<typeof useSiteAreaUpdateMutation>;
export type SiteAreaUpdateMutationResult = ApolloReactCommon.MutationResult<SiteAreaUpdateMutation>;
export const SiteAreaBulkDestroyDocument = gql`
    mutation siteAreaBulkDestroy($input: SiteAreaBulkDestroyInput!) {
  data: siteAreaBulkDestroy(input: $input) {
    destroyedCount
    blocked {
      id
      name
      canDestroy {
        ...authorizationResultFragment
      }
    }
  }
}
    ${AuthorizationResultFragmentFragmentDoc}`;

/**
 * __useSiteAreaBulkDestroyMutation__
 *
 * To run a mutation, you first call `useSiteAreaBulkDestroyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSiteAreaBulkDestroyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [siteAreaBulkDestroyMutation, { data, loading, error }] = useSiteAreaBulkDestroyMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSiteAreaBulkDestroyMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<SiteAreaBulkDestroyMutation, SiteAreaBulkDestroyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<SiteAreaBulkDestroyMutation, SiteAreaBulkDestroyMutationVariables>(SiteAreaBulkDestroyDocument, options);
      }
export type SiteAreaBulkDestroyMutationHookResult = ReturnType<typeof useSiteAreaBulkDestroyMutation>;
export type SiteAreaBulkDestroyMutationResult = ApolloReactCommon.MutationResult<SiteAreaBulkDestroyMutation>;
export const SiteAreaBulkQrCodeCreateDocument = gql`
    mutation siteAreaBulkQrCodeCreate($params: QrCodesCreateInputObject!) {
  data: siteAreaBulkQrCodeCreate(input: {params: $params}) {
    ...backgroundJobTreeFragment
  }
}
    ${BackgroundJobTreeFragmentFragmentDoc}
${BackgroundJobFragmentFragmentDoc}
${AuthorizationResultFragmentFragmentDoc}`;

/**
 * __useSiteAreaBulkQrCodeCreateMutation__
 *
 * To run a mutation, you first call `useSiteAreaBulkQrCodeCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSiteAreaBulkQrCodeCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [siteAreaBulkQrCodeCreateMutation, { data, loading, error }] = useSiteAreaBulkQrCodeCreateMutation({
 *   variables: {
 *      params: // value for 'params'
 *   },
 * });
 */
export function useSiteAreaBulkQrCodeCreateMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<SiteAreaBulkQrCodeCreateMutation, SiteAreaBulkQrCodeCreateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<SiteAreaBulkQrCodeCreateMutation, SiteAreaBulkQrCodeCreateMutationVariables>(SiteAreaBulkQrCodeCreateDocument, options);
      }
export type SiteAreaBulkQrCodeCreateMutationHookResult = ReturnType<typeof useSiteAreaBulkQrCodeCreateMutation>;
export type SiteAreaBulkQrCodeCreateMutationResult = ApolloReactCommon.MutationResult<SiteAreaBulkQrCodeCreateMutation>;
export const SsoIntegrationsDocument = gql`
    query ssoIntegrations($page: Int, $limit: Int, $sorts: SsoIntegrationSortInputObject, $filters: [SsoIntegrationFilterInputObject!]) {
  data: ssoIntegrations(
    page: $page
    limit: $limit
    sorts: $sorts
    filters: $filters
  ) {
    collection {
      id
      name
      status
      providerPreset
      providerType
      displayStatus
      updatedAt
      icon {
        ...attachmentFragment
      }
    }
    metadata {
      ...metadataFragment
    }
  }
}
    ${AttachmentFragmentFragmentDoc}
${MetadataFragmentFragmentDoc}`;

/**
 * __useSsoIntegrationsQuery__
 *
 * To run a query within a React component, call `useSsoIntegrationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSsoIntegrationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSsoIntegrationsQuery({
 *   variables: {
 *      page: // value for 'page'
 *      limit: // value for 'limit'
 *      sorts: // value for 'sorts'
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useSsoIntegrationsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<SsoIntegrationsQuery, SsoIntegrationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<SsoIntegrationsQuery, SsoIntegrationsQueryVariables>(SsoIntegrationsDocument, options);
      }
export function useSsoIntegrationsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<SsoIntegrationsQuery, SsoIntegrationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<SsoIntegrationsQuery, SsoIntegrationsQueryVariables>(SsoIntegrationsDocument, options);
        }
// @ts-ignore
export function useSsoIntegrationsSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<SsoIntegrationsQuery, SsoIntegrationsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<SsoIntegrationsQuery, SsoIntegrationsQueryVariables>;
// @ts-ignore
export function useSsoIntegrationsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<SsoIntegrationsQuery, SsoIntegrationsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<SsoIntegrationsQuery | undefined, SsoIntegrationsQueryVariables>;
export function useSsoIntegrationsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<SsoIntegrationsQuery, SsoIntegrationsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          // @ts-ignore
          return ApolloReactHooks.useSuspenseQuery<SsoIntegrationsQuery, SsoIntegrationsQueryVariables>(SsoIntegrationsDocument, options);
        }
export type SsoIntegrationsQueryHookResult = ReturnType<typeof useSsoIntegrationsQuery>;
export type SsoIntegrationsLazyQueryHookResult = ReturnType<typeof useSsoIntegrationsLazyQuery>;
export type SsoIntegrationsSuspenseQueryHookResult = ReturnType<typeof useSsoIntegrationsSuspenseQuery>;
export type SsoIntegrationsQueryResult = ApolloReactCommon.QueryResult<SsoIntegrationsQuery, SsoIntegrationsQueryVariables>;
export function refetchSsoIntegrationsQuery(variables?: SsoIntegrationsQueryVariables) {
      return { query: SsoIntegrationsDocument, variables: variables }
    }
export const SsoIntegrationDocument = gql`
    query ssoIntegration($id: ID!) {
  data: ssoIntegration(id: $id) {
    ...ssoIntegrationFragment
  }
}
    ${SsoIntegrationFragmentFragmentDoc}
${AttachmentFragmentFragmentDoc}`;

/**
 * __useSsoIntegrationQuery__
 *
 * To run a query within a React component, call `useSsoIntegrationQuery` and pass it any options that fit your needs.
 * When your component renders, `useSsoIntegrationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSsoIntegrationQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useSsoIntegrationQuery(baseOptions: ApolloReactHooks.QueryHookOptions<SsoIntegrationQuery, SsoIntegrationQueryVariables> & ({ variables: SsoIntegrationQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<SsoIntegrationQuery, SsoIntegrationQueryVariables>(SsoIntegrationDocument, options);
      }
export function useSsoIntegrationLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<SsoIntegrationQuery, SsoIntegrationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<SsoIntegrationQuery, SsoIntegrationQueryVariables>(SsoIntegrationDocument, options);
        }
// @ts-ignore
export function useSsoIntegrationSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<SsoIntegrationQuery, SsoIntegrationQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<SsoIntegrationQuery, SsoIntegrationQueryVariables>;
// @ts-ignore
export function useSsoIntegrationSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<SsoIntegrationQuery, SsoIntegrationQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<SsoIntegrationQuery | undefined, SsoIntegrationQueryVariables>;
export function useSsoIntegrationSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<SsoIntegrationQuery, SsoIntegrationQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          // @ts-ignore
          return ApolloReactHooks.useSuspenseQuery<SsoIntegrationQuery, SsoIntegrationQueryVariables>(SsoIntegrationDocument, options);
        }
export type SsoIntegrationQueryHookResult = ReturnType<typeof useSsoIntegrationQuery>;
export type SsoIntegrationLazyQueryHookResult = ReturnType<typeof useSsoIntegrationLazyQuery>;
export type SsoIntegrationSuspenseQueryHookResult = ReturnType<typeof useSsoIntegrationSuspenseQuery>;
export type SsoIntegrationQueryResult = ApolloReactCommon.QueryResult<SsoIntegrationQuery, SsoIntegrationQueryVariables>;
export function refetchSsoIntegrationQuery(variables: SsoIntegrationQueryVariables) {
      return { query: SsoIntegrationDocument, variables: variables }
    }
export const SsoIntegrationCreateDocument = gql`
    mutation ssoIntegrationCreate($attributes: SsoIntegrationCreateInputObject!) {
  data: ssoIntegrationCreate(input: {attributes: $attributes}) {
    ...ssoIntegrationFragment
  }
}
    ${SsoIntegrationFragmentFragmentDoc}
${AttachmentFragmentFragmentDoc}`;

/**
 * __useSsoIntegrationCreateMutation__
 *
 * To run a mutation, you first call `useSsoIntegrationCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSsoIntegrationCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [ssoIntegrationCreateMutation, { data, loading, error }] = useSsoIntegrationCreateMutation({
 *   variables: {
 *      attributes: // value for 'attributes'
 *   },
 * });
 */
export function useSsoIntegrationCreateMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<SsoIntegrationCreateMutation, SsoIntegrationCreateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<SsoIntegrationCreateMutation, SsoIntegrationCreateMutationVariables>(SsoIntegrationCreateDocument, options);
      }
export type SsoIntegrationCreateMutationHookResult = ReturnType<typeof useSsoIntegrationCreateMutation>;
export type SsoIntegrationCreateMutationResult = ApolloReactCommon.MutationResult<SsoIntegrationCreateMutation>;
export const SsoIntegrationUpdateDocument = gql`
    mutation ssoIntegrationUpdate($id: ID!, $attributes: SsoIntegrationUpdateInputObject!) {
  data: ssoIntegrationUpdate(input: {id: $id, attributes: $attributes}) {
    ...ssoIntegrationFragment
  }
}
    ${SsoIntegrationFragmentFragmentDoc}
${AttachmentFragmentFragmentDoc}`;

/**
 * __useSsoIntegrationUpdateMutation__
 *
 * To run a mutation, you first call `useSsoIntegrationUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSsoIntegrationUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [ssoIntegrationUpdateMutation, { data, loading, error }] = useSsoIntegrationUpdateMutation({
 *   variables: {
 *      id: // value for 'id'
 *      attributes: // value for 'attributes'
 *   },
 * });
 */
export function useSsoIntegrationUpdateMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<SsoIntegrationUpdateMutation, SsoIntegrationUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<SsoIntegrationUpdateMutation, SsoIntegrationUpdateMutationVariables>(SsoIntegrationUpdateDocument, options);
      }
export type SsoIntegrationUpdateMutationHookResult = ReturnType<typeof useSsoIntegrationUpdateMutation>;
export type SsoIntegrationUpdateMutationResult = ApolloReactCommon.MutationResult<SsoIntegrationUpdateMutation>;
export const SsoIntegrationPresetDefaultsDocument = gql`
    query ssoIntegrationPresetDefaults($preset: SsoIntegrationProviderPresetEnum!) {
  data: ssoIntegrationPresetDefaults(preset: $preset)
}
    `;

/**
 * __useSsoIntegrationPresetDefaultsQuery__
 *
 * To run a query within a React component, call `useSsoIntegrationPresetDefaultsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSsoIntegrationPresetDefaultsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSsoIntegrationPresetDefaultsQuery({
 *   variables: {
 *      preset: // value for 'preset'
 *   },
 * });
 */
export function useSsoIntegrationPresetDefaultsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<SsoIntegrationPresetDefaultsQuery, SsoIntegrationPresetDefaultsQueryVariables> & ({ variables: SsoIntegrationPresetDefaultsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<SsoIntegrationPresetDefaultsQuery, SsoIntegrationPresetDefaultsQueryVariables>(SsoIntegrationPresetDefaultsDocument, options);
      }
export function useSsoIntegrationPresetDefaultsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<SsoIntegrationPresetDefaultsQuery, SsoIntegrationPresetDefaultsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<SsoIntegrationPresetDefaultsQuery, SsoIntegrationPresetDefaultsQueryVariables>(SsoIntegrationPresetDefaultsDocument, options);
        }
// @ts-ignore
export function useSsoIntegrationPresetDefaultsSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<SsoIntegrationPresetDefaultsQuery, SsoIntegrationPresetDefaultsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<SsoIntegrationPresetDefaultsQuery, SsoIntegrationPresetDefaultsQueryVariables>;
// @ts-ignore
export function useSsoIntegrationPresetDefaultsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<SsoIntegrationPresetDefaultsQuery, SsoIntegrationPresetDefaultsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<SsoIntegrationPresetDefaultsQuery | undefined, SsoIntegrationPresetDefaultsQueryVariables>;
export function useSsoIntegrationPresetDefaultsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<SsoIntegrationPresetDefaultsQuery, SsoIntegrationPresetDefaultsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          // @ts-ignore
          return ApolloReactHooks.useSuspenseQuery<SsoIntegrationPresetDefaultsQuery, SsoIntegrationPresetDefaultsQueryVariables>(SsoIntegrationPresetDefaultsDocument, options);
        }
export type SsoIntegrationPresetDefaultsQueryHookResult = ReturnType<typeof useSsoIntegrationPresetDefaultsQuery>;
export type SsoIntegrationPresetDefaultsLazyQueryHookResult = ReturnType<typeof useSsoIntegrationPresetDefaultsLazyQuery>;
export type SsoIntegrationPresetDefaultsSuspenseQueryHookResult = ReturnType<typeof useSsoIntegrationPresetDefaultsSuspenseQuery>;
export type SsoIntegrationPresetDefaultsQueryResult = ApolloReactCommon.QueryResult<SsoIntegrationPresetDefaultsQuery, SsoIntegrationPresetDefaultsQueryVariables>;
export function refetchSsoIntegrationPresetDefaultsQuery(variables: SsoIntegrationPresetDefaultsQueryVariables) {
      return { query: SsoIntegrationPresetDefaultsDocument, variables: variables }
    }
export const SsoIntegrationGenerateCodeDocument = gql`
    query ssoIntegrationGenerateCode {
  data: ssoIntegrationGenerateCode {
    code
    acsUrl
    entityId
    metadataUrl
  }
}
    `;

/**
 * __useSsoIntegrationGenerateCodeQuery__
 *
 * To run a query within a React component, call `useSsoIntegrationGenerateCodeQuery` and pass it any options that fit your needs.
 * When your component renders, `useSsoIntegrationGenerateCodeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSsoIntegrationGenerateCodeQuery({
 *   variables: {
 *   },
 * });
 */
export function useSsoIntegrationGenerateCodeQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<SsoIntegrationGenerateCodeQuery, SsoIntegrationGenerateCodeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<SsoIntegrationGenerateCodeQuery, SsoIntegrationGenerateCodeQueryVariables>(SsoIntegrationGenerateCodeDocument, options);
      }
export function useSsoIntegrationGenerateCodeLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<SsoIntegrationGenerateCodeQuery, SsoIntegrationGenerateCodeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<SsoIntegrationGenerateCodeQuery, SsoIntegrationGenerateCodeQueryVariables>(SsoIntegrationGenerateCodeDocument, options);
        }
// @ts-ignore
export function useSsoIntegrationGenerateCodeSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<SsoIntegrationGenerateCodeQuery, SsoIntegrationGenerateCodeQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<SsoIntegrationGenerateCodeQuery, SsoIntegrationGenerateCodeQueryVariables>;
// @ts-ignore
export function useSsoIntegrationGenerateCodeSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<SsoIntegrationGenerateCodeQuery, SsoIntegrationGenerateCodeQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<SsoIntegrationGenerateCodeQuery | undefined, SsoIntegrationGenerateCodeQueryVariables>;
export function useSsoIntegrationGenerateCodeSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<SsoIntegrationGenerateCodeQuery, SsoIntegrationGenerateCodeQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          // @ts-ignore
          return ApolloReactHooks.useSuspenseQuery<SsoIntegrationGenerateCodeQuery, SsoIntegrationGenerateCodeQueryVariables>(SsoIntegrationGenerateCodeDocument, options);
        }
export type SsoIntegrationGenerateCodeQueryHookResult = ReturnType<typeof useSsoIntegrationGenerateCodeQuery>;
export type SsoIntegrationGenerateCodeLazyQueryHookResult = ReturnType<typeof useSsoIntegrationGenerateCodeLazyQuery>;
export type SsoIntegrationGenerateCodeSuspenseQueryHookResult = ReturnType<typeof useSsoIntegrationGenerateCodeSuspenseQuery>;
export type SsoIntegrationGenerateCodeQueryResult = ApolloReactCommon.QueryResult<SsoIntegrationGenerateCodeQuery, SsoIntegrationGenerateCodeQueryVariables>;
export function refetchSsoIntegrationGenerateCodeQuery(variables?: SsoIntegrationGenerateCodeQueryVariables) {
      return { query: SsoIntegrationGenerateCodeDocument, variables: variables }
    }
export const SsoIntegrationActivateDocument = gql`
    mutation ssoIntegrationActivate($id: ID!) {
  data: ssoIntegrationActivate(input: {id: $id}) {
    ...ssoIntegrationFragment
  }
}
    ${SsoIntegrationFragmentFragmentDoc}
${AttachmentFragmentFragmentDoc}`;

/**
 * __useSsoIntegrationActivateMutation__
 *
 * To run a mutation, you first call `useSsoIntegrationActivateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSsoIntegrationActivateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [ssoIntegrationActivateMutation, { data, loading, error }] = useSsoIntegrationActivateMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useSsoIntegrationActivateMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<SsoIntegrationActivateMutation, SsoIntegrationActivateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<SsoIntegrationActivateMutation, SsoIntegrationActivateMutationVariables>(SsoIntegrationActivateDocument, options);
      }
export type SsoIntegrationActivateMutationHookResult = ReturnType<typeof useSsoIntegrationActivateMutation>;
export type SsoIntegrationActivateMutationResult = ApolloReactCommon.MutationResult<SsoIntegrationActivateMutation>;
export const SsoIntegrationDeactivateDocument = gql`
    mutation ssoIntegrationDeactivate($id: ID!) {
  data: ssoIntegrationDeactivate(input: {id: $id}) {
    ...ssoIntegrationFragment
  }
}
    ${SsoIntegrationFragmentFragmentDoc}
${AttachmentFragmentFragmentDoc}`;

/**
 * __useSsoIntegrationDeactivateMutation__
 *
 * To run a mutation, you first call `useSsoIntegrationDeactivateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSsoIntegrationDeactivateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [ssoIntegrationDeactivateMutation, { data, loading, error }] = useSsoIntegrationDeactivateMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useSsoIntegrationDeactivateMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<SsoIntegrationDeactivateMutation, SsoIntegrationDeactivateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<SsoIntegrationDeactivateMutation, SsoIntegrationDeactivateMutationVariables>(SsoIntegrationDeactivateDocument, options);
      }
export type SsoIntegrationDeactivateMutationHookResult = ReturnType<typeof useSsoIntegrationDeactivateMutation>;
export type SsoIntegrationDeactivateMutationResult = ApolloReactCommon.MutationResult<SsoIntegrationDeactivateMutation>;
export const SsoIntegrationDestroyDocument = gql`
    mutation ssoIntegrationDestroy($id: ID!) {
  data: ssoIntegrationDestroy(input: {id: $id})
}
    `;

/**
 * __useSsoIntegrationDestroyMutation__
 *
 * To run a mutation, you first call `useSsoIntegrationDestroyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSsoIntegrationDestroyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [ssoIntegrationDestroyMutation, { data, loading, error }] = useSsoIntegrationDestroyMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useSsoIntegrationDestroyMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<SsoIntegrationDestroyMutation, SsoIntegrationDestroyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<SsoIntegrationDestroyMutation, SsoIntegrationDestroyMutationVariables>(SsoIntegrationDestroyDocument, options);
      }
export type SsoIntegrationDestroyMutationHookResult = ReturnType<typeof useSsoIntegrationDestroyMutation>;
export type SsoIntegrationDestroyMutationResult = ApolloReactCommon.MutationResult<SsoIntegrationDestroyMutation>;
export const CompanyDomainsDocument = gql`
    query companyDomains($page: Int, $limit: Int, $sorts: CompanyDomainSortInputObject, $filters: [CompanyDomainFilterInputObject!]) {
  data: companyDomains(
    page: $page
    limit: $limit
    sorts: $sorts
    filters: $filters
  ) {
    collection {
      ...companyDomainFragment
    }
    metadata {
      ...metadataFragment
    }
  }
}
    ${CompanyDomainFragmentFragmentDoc}
${MetadataFragmentFragmentDoc}`;

/**
 * __useCompanyDomainsQuery__
 *
 * To run a query within a React component, call `useCompanyDomainsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCompanyDomainsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCompanyDomainsQuery({
 *   variables: {
 *      page: // value for 'page'
 *      limit: // value for 'limit'
 *      sorts: // value for 'sorts'
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useCompanyDomainsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<CompanyDomainsQuery, CompanyDomainsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<CompanyDomainsQuery, CompanyDomainsQueryVariables>(CompanyDomainsDocument, options);
      }
export function useCompanyDomainsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<CompanyDomainsQuery, CompanyDomainsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<CompanyDomainsQuery, CompanyDomainsQueryVariables>(CompanyDomainsDocument, options);
        }
// @ts-ignore
export function useCompanyDomainsSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<CompanyDomainsQuery, CompanyDomainsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<CompanyDomainsQuery, CompanyDomainsQueryVariables>;
// @ts-ignore
export function useCompanyDomainsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<CompanyDomainsQuery, CompanyDomainsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<CompanyDomainsQuery | undefined, CompanyDomainsQueryVariables>;
export function useCompanyDomainsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<CompanyDomainsQuery, CompanyDomainsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          // @ts-ignore
          return ApolloReactHooks.useSuspenseQuery<CompanyDomainsQuery, CompanyDomainsQueryVariables>(CompanyDomainsDocument, options);
        }
export type CompanyDomainsQueryHookResult = ReturnType<typeof useCompanyDomainsQuery>;
export type CompanyDomainsLazyQueryHookResult = ReturnType<typeof useCompanyDomainsLazyQuery>;
export type CompanyDomainsSuspenseQueryHookResult = ReturnType<typeof useCompanyDomainsSuspenseQuery>;
export type CompanyDomainsQueryResult = ApolloReactCommon.QueryResult<CompanyDomainsQuery, CompanyDomainsQueryVariables>;
export function refetchCompanyDomainsQuery(variables?: CompanyDomainsQueryVariables) {
      return { query: CompanyDomainsDocument, variables: variables }
    }
export const CompanyDomainCreateDocument = gql`
    mutation companyDomainCreate($attributes: CompanyDomainCreateInputObject!) {
  data: companyDomainCreate(input: {attributes: $attributes}) {
    ...companyDomainFragment
  }
}
    ${CompanyDomainFragmentFragmentDoc}`;

/**
 * __useCompanyDomainCreateMutation__
 *
 * To run a mutation, you first call `useCompanyDomainCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCompanyDomainCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [companyDomainCreateMutation, { data, loading, error }] = useCompanyDomainCreateMutation({
 *   variables: {
 *      attributes: // value for 'attributes'
 *   },
 * });
 */
export function useCompanyDomainCreateMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CompanyDomainCreateMutation, CompanyDomainCreateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<CompanyDomainCreateMutation, CompanyDomainCreateMutationVariables>(CompanyDomainCreateDocument, options);
      }
export type CompanyDomainCreateMutationHookResult = ReturnType<typeof useCompanyDomainCreateMutation>;
export type CompanyDomainCreateMutationResult = ApolloReactCommon.MutationResult<CompanyDomainCreateMutation>;
export const CompanyDomainVerifyDocument = gql`
    mutation companyDomainVerify($id: ID!) {
  data: companyDomainVerify(input: {id: $id}) {
    ...companyDomainFragment
  }
}
    ${CompanyDomainFragmentFragmentDoc}`;

/**
 * __useCompanyDomainVerifyMutation__
 *
 * To run a mutation, you first call `useCompanyDomainVerifyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCompanyDomainVerifyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [companyDomainVerifyMutation, { data, loading, error }] = useCompanyDomainVerifyMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useCompanyDomainVerifyMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CompanyDomainVerifyMutation, CompanyDomainVerifyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<CompanyDomainVerifyMutation, CompanyDomainVerifyMutationVariables>(CompanyDomainVerifyDocument, options);
      }
export type CompanyDomainVerifyMutationHookResult = ReturnType<typeof useCompanyDomainVerifyMutation>;
export type CompanyDomainVerifyMutationResult = ApolloReactCommon.MutationResult<CompanyDomainVerifyMutation>;
export const CompanyDomainDestroyDocument = gql`
    mutation companyDomainDestroy($id: ID!) {
  data: companyDomainDestroy(input: {id: $id})
}
    `;

/**
 * __useCompanyDomainDestroyMutation__
 *
 * To run a mutation, you first call `useCompanyDomainDestroyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCompanyDomainDestroyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [companyDomainDestroyMutation, { data, loading, error }] = useCompanyDomainDestroyMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useCompanyDomainDestroyMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CompanyDomainDestroyMutation, CompanyDomainDestroyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<CompanyDomainDestroyMutation, CompanyDomainDestroyMutationVariables>(CompanyDomainDestroyDocument, options);
      }
export type CompanyDomainDestroyMutationHookResult = ReturnType<typeof useCompanyDomainDestroyMutation>;
export type CompanyDomainDestroyMutationResult = ApolloReactCommon.MutationResult<CompanyDomainDestroyMutation>;
export const SsoIntegrationsDomainCheckDocument = gql`
    query ssoIntegrationsDomainCheck($limit: Int, $filters: [SsoIntegrationFilterInputObject!]) {
  data: ssoIntegrations(limit: $limit, filters: $filters) {
    collection {
      id
    }
  }
}
    `;

/**
 * __useSsoIntegrationsDomainCheckQuery__
 *
 * To run a query within a React component, call `useSsoIntegrationsDomainCheckQuery` and pass it any options that fit your needs.
 * When your component renders, `useSsoIntegrationsDomainCheckQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSsoIntegrationsDomainCheckQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useSsoIntegrationsDomainCheckQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<SsoIntegrationsDomainCheckQuery, SsoIntegrationsDomainCheckQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<SsoIntegrationsDomainCheckQuery, SsoIntegrationsDomainCheckQueryVariables>(SsoIntegrationsDomainCheckDocument, options);
      }
export function useSsoIntegrationsDomainCheckLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<SsoIntegrationsDomainCheckQuery, SsoIntegrationsDomainCheckQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<SsoIntegrationsDomainCheckQuery, SsoIntegrationsDomainCheckQueryVariables>(SsoIntegrationsDomainCheckDocument, options);
        }
// @ts-ignore
export function useSsoIntegrationsDomainCheckSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<SsoIntegrationsDomainCheckQuery, SsoIntegrationsDomainCheckQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<SsoIntegrationsDomainCheckQuery, SsoIntegrationsDomainCheckQueryVariables>;
// @ts-ignore
export function useSsoIntegrationsDomainCheckSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<SsoIntegrationsDomainCheckQuery, SsoIntegrationsDomainCheckQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<SsoIntegrationsDomainCheckQuery | undefined, SsoIntegrationsDomainCheckQueryVariables>;
export function useSsoIntegrationsDomainCheckSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<SsoIntegrationsDomainCheckQuery, SsoIntegrationsDomainCheckQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          // @ts-ignore
          return ApolloReactHooks.useSuspenseQuery<SsoIntegrationsDomainCheckQuery, SsoIntegrationsDomainCheckQueryVariables>(SsoIntegrationsDomainCheckDocument, options);
        }
export type SsoIntegrationsDomainCheckQueryHookResult = ReturnType<typeof useSsoIntegrationsDomainCheckQuery>;
export type SsoIntegrationsDomainCheckLazyQueryHookResult = ReturnType<typeof useSsoIntegrationsDomainCheckLazyQuery>;
export type SsoIntegrationsDomainCheckSuspenseQueryHookResult = ReturnType<typeof useSsoIntegrationsDomainCheckSuspenseQuery>;
export type SsoIntegrationsDomainCheckQueryResult = ApolloReactCommon.QueryResult<SsoIntegrationsDomainCheckQuery, SsoIntegrationsDomainCheckQueryVariables>;
export function refetchSsoIntegrationsDomainCheckQuery(variables?: SsoIntegrationsDomainCheckQueryVariables) {
      return { query: SsoIntegrationsDomainCheckDocument, variables: variables }
    }
export const CompanyDomainsSearchListDocument = gql`
    query companyDomainsSearchList($page: Int, $limit: Int, $sorts: CompanyDomainSortInputObject, $filters: [CompanyDomainFilterInputObject!]) {
  data: companyDomains(
    page: $page
    limit: $limit
    sorts: $sorts
    filters: $filters
  ) {
    collection {
      id
      domain
      verified
    }
    metadata {
      ...metadataFragment
    }
  }
}
    ${MetadataFragmentFragmentDoc}`;

/**
 * __useCompanyDomainsSearchListQuery__
 *
 * To run a query within a React component, call `useCompanyDomainsSearchListQuery` and pass it any options that fit your needs.
 * When your component renders, `useCompanyDomainsSearchListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCompanyDomainsSearchListQuery({
 *   variables: {
 *      page: // value for 'page'
 *      limit: // value for 'limit'
 *      sorts: // value for 'sorts'
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useCompanyDomainsSearchListQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<CompanyDomainsSearchListQuery, CompanyDomainsSearchListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<CompanyDomainsSearchListQuery, CompanyDomainsSearchListQueryVariables>(CompanyDomainsSearchListDocument, options);
      }
export function useCompanyDomainsSearchListLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<CompanyDomainsSearchListQuery, CompanyDomainsSearchListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<CompanyDomainsSearchListQuery, CompanyDomainsSearchListQueryVariables>(CompanyDomainsSearchListDocument, options);
        }
// @ts-ignore
export function useCompanyDomainsSearchListSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<CompanyDomainsSearchListQuery, CompanyDomainsSearchListQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<CompanyDomainsSearchListQuery, CompanyDomainsSearchListQueryVariables>;
// @ts-ignore
export function useCompanyDomainsSearchListSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<CompanyDomainsSearchListQuery, CompanyDomainsSearchListQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<CompanyDomainsSearchListQuery | undefined, CompanyDomainsSearchListQueryVariables>;
export function useCompanyDomainsSearchListSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<CompanyDomainsSearchListQuery, CompanyDomainsSearchListQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          // @ts-ignore
          return ApolloReactHooks.useSuspenseQuery<CompanyDomainsSearchListQuery, CompanyDomainsSearchListQueryVariables>(CompanyDomainsSearchListDocument, options);
        }
export type CompanyDomainsSearchListQueryHookResult = ReturnType<typeof useCompanyDomainsSearchListQuery>;
export type CompanyDomainsSearchListLazyQueryHookResult = ReturnType<typeof useCompanyDomainsSearchListLazyQuery>;
export type CompanyDomainsSearchListSuspenseQueryHookResult = ReturnType<typeof useCompanyDomainsSearchListSuspenseQuery>;
export type CompanyDomainsSearchListQueryResult = ApolloReactCommon.QueryResult<CompanyDomainsSearchListQuery, CompanyDomainsSearchListQueryVariables>;
export function refetchCompanyDomainsSearchListQuery(variables?: CompanyDomainsSearchListQueryVariables) {
      return { query: CompanyDomainsSearchListDocument, variables: variables }
    }
export const SsoIntegrationSupportedMappingFieldsDocument = gql`
    query SsoIntegrationSupportedMappingFields {
  ssoIntegrationSupportedMappingFields {
    description
    key
    label
    required
    sortIndex
  }
}
    `;

/**
 * __useSsoIntegrationSupportedMappingFieldsQuery__
 *
 * To run a query within a React component, call `useSsoIntegrationSupportedMappingFieldsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSsoIntegrationSupportedMappingFieldsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSsoIntegrationSupportedMappingFieldsQuery({
 *   variables: {
 *   },
 * });
 */
export function useSsoIntegrationSupportedMappingFieldsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<SsoIntegrationSupportedMappingFieldsQuery, SsoIntegrationSupportedMappingFieldsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<SsoIntegrationSupportedMappingFieldsQuery, SsoIntegrationSupportedMappingFieldsQueryVariables>(SsoIntegrationSupportedMappingFieldsDocument, options);
      }
export function useSsoIntegrationSupportedMappingFieldsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<SsoIntegrationSupportedMappingFieldsQuery, SsoIntegrationSupportedMappingFieldsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<SsoIntegrationSupportedMappingFieldsQuery, SsoIntegrationSupportedMappingFieldsQueryVariables>(SsoIntegrationSupportedMappingFieldsDocument, options);
        }
// @ts-ignore
export function useSsoIntegrationSupportedMappingFieldsSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<SsoIntegrationSupportedMappingFieldsQuery, SsoIntegrationSupportedMappingFieldsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<SsoIntegrationSupportedMappingFieldsQuery, SsoIntegrationSupportedMappingFieldsQueryVariables>;
// @ts-ignore
export function useSsoIntegrationSupportedMappingFieldsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<SsoIntegrationSupportedMappingFieldsQuery, SsoIntegrationSupportedMappingFieldsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<SsoIntegrationSupportedMappingFieldsQuery | undefined, SsoIntegrationSupportedMappingFieldsQueryVariables>;
export function useSsoIntegrationSupportedMappingFieldsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<SsoIntegrationSupportedMappingFieldsQuery, SsoIntegrationSupportedMappingFieldsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          // @ts-ignore
          return ApolloReactHooks.useSuspenseQuery<SsoIntegrationSupportedMappingFieldsQuery, SsoIntegrationSupportedMappingFieldsQueryVariables>(SsoIntegrationSupportedMappingFieldsDocument, options);
        }
export type SsoIntegrationSupportedMappingFieldsQueryHookResult = ReturnType<typeof useSsoIntegrationSupportedMappingFieldsQuery>;
export type SsoIntegrationSupportedMappingFieldsLazyQueryHookResult = ReturnType<typeof useSsoIntegrationSupportedMappingFieldsLazyQuery>;
export type SsoIntegrationSupportedMappingFieldsSuspenseQueryHookResult = ReturnType<typeof useSsoIntegrationSupportedMappingFieldsSuspenseQuery>;
export type SsoIntegrationSupportedMappingFieldsQueryResult = ApolloReactCommon.QueryResult<SsoIntegrationSupportedMappingFieldsQuery, SsoIntegrationSupportedMappingFieldsQueryVariables>;
export function refetchSsoIntegrationSupportedMappingFieldsQuery(variables?: SsoIntegrationSupportedMappingFieldsQueryVariables) {
      return { query: SsoIntegrationSupportedMappingFieldsDocument, variables: variables }
    }
export const TagsDocument = gql`
    query tags($page: Int, $limit: Int, $sorts: TagSortInputObject, $filters: [TagFilterInputObject!]) {
  data: tags(page: $page, limit: $limit, sorts: $sorts, filters: $filters) {
    collection {
      id
      name
    }
    metadata {
      ...metadataFragment
    }
  }
}
    ${MetadataFragmentFragmentDoc}`;

/**
 * __useTagsQuery__
 *
 * To run a query within a React component, call `useTagsQuery` and pass it any options that fit your needs.
 * When your component renders, `useTagsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTagsQuery({
 *   variables: {
 *      page: // value for 'page'
 *      limit: // value for 'limit'
 *      sorts: // value for 'sorts'
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useTagsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<TagsQuery, TagsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<TagsQuery, TagsQueryVariables>(TagsDocument, options);
      }
export function useTagsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<TagsQuery, TagsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<TagsQuery, TagsQueryVariables>(TagsDocument, options);
        }
// @ts-ignore
export function useTagsSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<TagsQuery, TagsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<TagsQuery, TagsQueryVariables>;
// @ts-ignore
export function useTagsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<TagsQuery, TagsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<TagsQuery | undefined, TagsQueryVariables>;
export function useTagsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<TagsQuery, TagsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          // @ts-ignore
          return ApolloReactHooks.useSuspenseQuery<TagsQuery, TagsQueryVariables>(TagsDocument, options);
        }
export type TagsQueryHookResult = ReturnType<typeof useTagsQuery>;
export type TagsLazyQueryHookResult = ReturnType<typeof useTagsLazyQuery>;
export type TagsSuspenseQueryHookResult = ReturnType<typeof useTagsSuspenseQuery>;
export type TagsQueryResult = ApolloReactCommon.QueryResult<TagsQuery, TagsQueryVariables>;
export function refetchTagsQuery(variables?: TagsQueryVariables) {
      return { query: TagsDocument, variables: variables }
    }
export const TagDocument = gql`
    query tag($id: ID!) {
  data: tag(id: $id) {
    id
    name
  }
}
    `;

/**
 * __useTagQuery__
 *
 * To run a query within a React component, call `useTagQuery` and pass it any options that fit your needs.
 * When your component renders, `useTagQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTagQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useTagQuery(baseOptions: ApolloReactHooks.QueryHookOptions<TagQuery, TagQueryVariables> & ({ variables: TagQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<TagQuery, TagQueryVariables>(TagDocument, options);
      }
export function useTagLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<TagQuery, TagQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<TagQuery, TagQueryVariables>(TagDocument, options);
        }
// @ts-ignore
export function useTagSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<TagQuery, TagQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<TagQuery, TagQueryVariables>;
// @ts-ignore
export function useTagSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<TagQuery, TagQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<TagQuery | undefined, TagQueryVariables>;
export function useTagSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<TagQuery, TagQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          // @ts-ignore
          return ApolloReactHooks.useSuspenseQuery<TagQuery, TagQueryVariables>(TagDocument, options);
        }
export type TagQueryHookResult = ReturnType<typeof useTagQuery>;
export type TagLazyQueryHookResult = ReturnType<typeof useTagLazyQuery>;
export type TagSuspenseQueryHookResult = ReturnType<typeof useTagSuspenseQuery>;
export type TagQueryResult = ApolloReactCommon.QueryResult<TagQuery, TagQueryVariables>;
export function refetchTagQuery(variables: TagQueryVariables) {
      return { query: TagDocument, variables: variables }
    }
export const TagCreateDocument = gql`
    mutation tagCreate($attributes: TagCreateInputObject!) {
  data: tagCreate(input: {attributes: $attributes}) {
    id
    name
  }
}
    `;

/**
 * __useTagCreateMutation__
 *
 * To run a mutation, you first call `useTagCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTagCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [tagCreateMutation, { data, loading, error }] = useTagCreateMutation({
 *   variables: {
 *      attributes: // value for 'attributes'
 *   },
 * });
 */
export function useTagCreateMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<TagCreateMutation, TagCreateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<TagCreateMutation, TagCreateMutationVariables>(TagCreateDocument, options);
      }
export type TagCreateMutationHookResult = ReturnType<typeof useTagCreateMutation>;
export type TagCreateMutationResult = ApolloReactCommon.MutationResult<TagCreateMutation>;
export const TagDestroyDocument = gql`
    mutation tagDestroy($id: ID!) {
  tagDestroy(input: {id: $id})
}
    `;

/**
 * __useTagDestroyMutation__
 *
 * To run a mutation, you first call `useTagDestroyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTagDestroyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [tagDestroyMutation, { data, loading, error }] = useTagDestroyMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useTagDestroyMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<TagDestroyMutation, TagDestroyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<TagDestroyMutation, TagDestroyMutationVariables>(TagDestroyDocument, options);
      }
export type TagDestroyMutationHookResult = ReturnType<typeof useTagDestroyMutation>;
export type TagDestroyMutationResult = ApolloReactCommon.MutationResult<TagDestroyMutation>;
export const TaskFormCompletionDocument = gql`
    query taskFormCompletion($id: ID!) {
  data: task(id: $id) {
    id
    name
    status
    formTemplate {
      category {
        ...formCategoryFragment
      }
      description
      id
      name
      createdAt
      updatedAt
    }
    completion {
      id
      answers {
        id
        kind
        fieldId
        field {
          id
          options {
            id
            fieldId
            group
            position
            values
          }
        }
        questionId
        resp {
          group
          optionId
          position
          selected
          value
          valueId
        }
        attachmentsAttached {
          ...attachmentFragment
        }
      }
    }
  }
}
    ${FormCategoryFragmentFragmentDoc}
${AttachmentFragmentFragmentDoc}`;

/**
 * __useTaskFormCompletionQuery__
 *
 * To run a query within a React component, call `useTaskFormCompletionQuery` and pass it any options that fit your needs.
 * When your component renders, `useTaskFormCompletionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTaskFormCompletionQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useTaskFormCompletionQuery(baseOptions: ApolloReactHooks.QueryHookOptions<TaskFormCompletionQuery, TaskFormCompletionQueryVariables> & ({ variables: TaskFormCompletionQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<TaskFormCompletionQuery, TaskFormCompletionQueryVariables>(TaskFormCompletionDocument, options);
      }
export function useTaskFormCompletionLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<TaskFormCompletionQuery, TaskFormCompletionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<TaskFormCompletionQuery, TaskFormCompletionQueryVariables>(TaskFormCompletionDocument, options);
        }
// @ts-ignore
export function useTaskFormCompletionSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<TaskFormCompletionQuery, TaskFormCompletionQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<TaskFormCompletionQuery, TaskFormCompletionQueryVariables>;
// @ts-ignore
export function useTaskFormCompletionSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<TaskFormCompletionQuery, TaskFormCompletionQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<TaskFormCompletionQuery | undefined, TaskFormCompletionQueryVariables>;
export function useTaskFormCompletionSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<TaskFormCompletionQuery, TaskFormCompletionQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          // @ts-ignore
          return ApolloReactHooks.useSuspenseQuery<TaskFormCompletionQuery, TaskFormCompletionQueryVariables>(TaskFormCompletionDocument, options);
        }
export type TaskFormCompletionQueryHookResult = ReturnType<typeof useTaskFormCompletionQuery>;
export type TaskFormCompletionLazyQueryHookResult = ReturnType<typeof useTaskFormCompletionLazyQuery>;
export type TaskFormCompletionSuspenseQueryHookResult = ReturnType<typeof useTaskFormCompletionSuspenseQuery>;
export type TaskFormCompletionQueryResult = ApolloReactCommon.QueryResult<TaskFormCompletionQuery, TaskFormCompletionQueryVariables>;
export function refetchTaskFormCompletionQuery(variables: TaskFormCompletionQueryVariables) {
      return { query: TaskFormCompletionDocument, variables: variables }
    }
export const DashboardTaskCounterDocument = gql`
    query dashboardTaskCounter($filters: [TaskFilterInputObject!]) {
  myApprovals: tasks(scope: {name: MY_APPROVALS}, filters: $filters) {
    metadata {
      totalCount
    }
  }
}
    `;

/**
 * __useDashboardTaskCounterQuery__
 *
 * To run a query within a React component, call `useDashboardTaskCounterQuery` and pass it any options that fit your needs.
 * When your component renders, `useDashboardTaskCounterQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDashboardTaskCounterQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useDashboardTaskCounterQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<DashboardTaskCounterQuery, DashboardTaskCounterQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<DashboardTaskCounterQuery, DashboardTaskCounterQueryVariables>(DashboardTaskCounterDocument, options);
      }
export function useDashboardTaskCounterLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<DashboardTaskCounterQuery, DashboardTaskCounterQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<DashboardTaskCounterQuery, DashboardTaskCounterQueryVariables>(DashboardTaskCounterDocument, options);
        }
// @ts-ignore
export function useDashboardTaskCounterSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<DashboardTaskCounterQuery, DashboardTaskCounterQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<DashboardTaskCounterQuery, DashboardTaskCounterQueryVariables>;
// @ts-ignore
export function useDashboardTaskCounterSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<DashboardTaskCounterQuery, DashboardTaskCounterQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<DashboardTaskCounterQuery | undefined, DashboardTaskCounterQueryVariables>;
export function useDashboardTaskCounterSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<DashboardTaskCounterQuery, DashboardTaskCounterQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          // @ts-ignore
          return ApolloReactHooks.useSuspenseQuery<DashboardTaskCounterQuery, DashboardTaskCounterQueryVariables>(DashboardTaskCounterDocument, options);
        }
export type DashboardTaskCounterQueryHookResult = ReturnType<typeof useDashboardTaskCounterQuery>;
export type DashboardTaskCounterLazyQueryHookResult = ReturnType<typeof useDashboardTaskCounterLazyQuery>;
export type DashboardTaskCounterSuspenseQueryHookResult = ReturnType<typeof useDashboardTaskCounterSuspenseQuery>;
export type DashboardTaskCounterQueryResult = ApolloReactCommon.QueryResult<DashboardTaskCounterQuery, DashboardTaskCounterQueryVariables>;
export function refetchDashboardTaskCounterQuery(variables?: DashboardTaskCounterQueryVariables) {
      return { query: DashboardTaskCounterDocument, variables: variables }
    }
export const DashboardTaskDocument = gql`
    query dashboardTask($id: ID!) {
  data: task(id: $id) {
    ...taskFragment
    hasLinkedDocumentations
    formTemplate {
      id
      name
    }
    formTemplateVersion {
      id
      version
    }
  }
}
    ${TaskFragmentFragmentDoc}
${AttachmentFragmentFragmentDoc}
${CanActionsTaskFragmentFragmentDoc}
${AuthorizationResultFragmentFragmentDoc}`;

/**
 * __useDashboardTaskQuery__
 *
 * To run a query within a React component, call `useDashboardTaskQuery` and pass it any options that fit your needs.
 * When your component renders, `useDashboardTaskQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDashboardTaskQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDashboardTaskQuery(baseOptions: ApolloReactHooks.QueryHookOptions<DashboardTaskQuery, DashboardTaskQueryVariables> & ({ variables: DashboardTaskQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<DashboardTaskQuery, DashboardTaskQueryVariables>(DashboardTaskDocument, options);
      }
export function useDashboardTaskLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<DashboardTaskQuery, DashboardTaskQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<DashboardTaskQuery, DashboardTaskQueryVariables>(DashboardTaskDocument, options);
        }
// @ts-ignore
export function useDashboardTaskSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<DashboardTaskQuery, DashboardTaskQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<DashboardTaskQuery, DashboardTaskQueryVariables>;
// @ts-ignore
export function useDashboardTaskSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<DashboardTaskQuery, DashboardTaskQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<DashboardTaskQuery | undefined, DashboardTaskQueryVariables>;
export function useDashboardTaskSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<DashboardTaskQuery, DashboardTaskQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          // @ts-ignore
          return ApolloReactHooks.useSuspenseQuery<DashboardTaskQuery, DashboardTaskQueryVariables>(DashboardTaskDocument, options);
        }
export type DashboardTaskQueryHookResult = ReturnType<typeof useDashboardTaskQuery>;
export type DashboardTaskLazyQueryHookResult = ReturnType<typeof useDashboardTaskLazyQuery>;
export type DashboardTaskSuspenseQueryHookResult = ReturnType<typeof useDashboardTaskSuspenseQuery>;
export type DashboardTaskQueryResult = ApolloReactCommon.QueryResult<DashboardTaskQuery, DashboardTaskQueryVariables>;
export function refetchDashboardTaskQuery(variables: DashboardTaskQueryVariables) {
      return { query: DashboardTaskDocument, variables: variables }
    }
export const DashboardFullTaskDocument = gql`
    query dashboardFullTask($id: ID!) {
  data: task(id: $id) {
    ...taskFragment
    ...earlyCompletionFragment
    formTemplate {
      id
      name
      canUpdate {
        value
      }
    }
    formTemplateVersion {
      id
      version
    }
    recurringRule {
      ...recurringRuleFragment
    }
  }
}
    ${TaskFragmentFragmentDoc}
${AttachmentFragmentFragmentDoc}
${CanActionsTaskFragmentFragmentDoc}
${AuthorizationResultFragmentFragmentDoc}
${EarlyCompletionFragmentFragmentDoc}
${RecurringRuleFragmentFragmentDoc}`;

/**
 * __useDashboardFullTaskQuery__
 *
 * To run a query within a React component, call `useDashboardFullTaskQuery` and pass it any options that fit your needs.
 * When your component renders, `useDashboardFullTaskQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDashboardFullTaskQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDashboardFullTaskQuery(baseOptions: ApolloReactHooks.QueryHookOptions<DashboardFullTaskQuery, DashboardFullTaskQueryVariables> & ({ variables: DashboardFullTaskQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<DashboardFullTaskQuery, DashboardFullTaskQueryVariables>(DashboardFullTaskDocument, options);
      }
export function useDashboardFullTaskLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<DashboardFullTaskQuery, DashboardFullTaskQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<DashboardFullTaskQuery, DashboardFullTaskQueryVariables>(DashboardFullTaskDocument, options);
        }
// @ts-ignore
export function useDashboardFullTaskSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<DashboardFullTaskQuery, DashboardFullTaskQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<DashboardFullTaskQuery, DashboardFullTaskQueryVariables>;
// @ts-ignore
export function useDashboardFullTaskSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<DashboardFullTaskQuery, DashboardFullTaskQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<DashboardFullTaskQuery | undefined, DashboardFullTaskQueryVariables>;
export function useDashboardFullTaskSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<DashboardFullTaskQuery, DashboardFullTaskQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          // @ts-ignore
          return ApolloReactHooks.useSuspenseQuery<DashboardFullTaskQuery, DashboardFullTaskQueryVariables>(DashboardFullTaskDocument, options);
        }
export type DashboardFullTaskQueryHookResult = ReturnType<typeof useDashboardFullTaskQuery>;
export type DashboardFullTaskLazyQueryHookResult = ReturnType<typeof useDashboardFullTaskLazyQuery>;
export type DashboardFullTaskSuspenseQueryHookResult = ReturnType<typeof useDashboardFullTaskSuspenseQuery>;
export type DashboardFullTaskQueryResult = ApolloReactCommon.QueryResult<DashboardFullTaskQuery, DashboardFullTaskQueryVariables>;
export function refetchDashboardFullTaskQuery(variables: DashboardFullTaskQueryVariables) {
      return { query: DashboardFullTaskDocument, variables: variables }
    }
export const DashboardTaskFormTemplateDocument = gql`
    query dashboardTaskFormTemplate($id: ID!, $isViewLocked: Boolean! = false) {
  data: task(id: $id) {
    id
    name
    status
    formTemplate {
      ...formTemplateFragment
      hasLinkedDocumentations
      canUpdate {
        value
      }
    }
    formTemplateVersion {
      id
      version
      ...questionsFragment
      canUpdate {
        value
      }
    }
    ...canActionsTaskFragment
  }
}
    ${FormTemplateFragmentFragmentDoc}
${FormCategoryFragmentFragmentDoc}
${QuestionsFragmentFragmentDoc}
${AttachmentFragmentFragmentDoc}
${CanActionsTaskFragmentFragmentDoc}
${AuthorizationResultFragmentFragmentDoc}`;

/**
 * __useDashboardTaskFormTemplateQuery__
 *
 * To run a query within a React component, call `useDashboardTaskFormTemplateQuery` and pass it any options that fit your needs.
 * When your component renders, `useDashboardTaskFormTemplateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDashboardTaskFormTemplateQuery({
 *   variables: {
 *      id: // value for 'id'
 *      isViewLocked: // value for 'isViewLocked'
 *   },
 * });
 */
export function useDashboardTaskFormTemplateQuery(baseOptions: ApolloReactHooks.QueryHookOptions<DashboardTaskFormTemplateQuery, DashboardTaskFormTemplateQueryVariables> & ({ variables: DashboardTaskFormTemplateQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<DashboardTaskFormTemplateQuery, DashboardTaskFormTemplateQueryVariables>(DashboardTaskFormTemplateDocument, options);
      }
export function useDashboardTaskFormTemplateLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<DashboardTaskFormTemplateQuery, DashboardTaskFormTemplateQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<DashboardTaskFormTemplateQuery, DashboardTaskFormTemplateQueryVariables>(DashboardTaskFormTemplateDocument, options);
        }
// @ts-ignore
export function useDashboardTaskFormTemplateSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<DashboardTaskFormTemplateQuery, DashboardTaskFormTemplateQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<DashboardTaskFormTemplateQuery, DashboardTaskFormTemplateQueryVariables>;
// @ts-ignore
export function useDashboardTaskFormTemplateSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<DashboardTaskFormTemplateQuery, DashboardTaskFormTemplateQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<DashboardTaskFormTemplateQuery | undefined, DashboardTaskFormTemplateQueryVariables>;
export function useDashboardTaskFormTemplateSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<DashboardTaskFormTemplateQuery, DashboardTaskFormTemplateQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          // @ts-ignore
          return ApolloReactHooks.useSuspenseQuery<DashboardTaskFormTemplateQuery, DashboardTaskFormTemplateQueryVariables>(DashboardTaskFormTemplateDocument, options);
        }
export type DashboardTaskFormTemplateQueryHookResult = ReturnType<typeof useDashboardTaskFormTemplateQuery>;
export type DashboardTaskFormTemplateLazyQueryHookResult = ReturnType<typeof useDashboardTaskFormTemplateLazyQuery>;
export type DashboardTaskFormTemplateSuspenseQueryHookResult = ReturnType<typeof useDashboardTaskFormTemplateSuspenseQuery>;
export type DashboardTaskFormTemplateQueryResult = ApolloReactCommon.QueryResult<DashboardTaskFormTemplateQuery, DashboardTaskFormTemplateQueryVariables>;
export function refetchDashboardTaskFormTemplateQuery(variables: DashboardTaskFormTemplateQueryVariables) {
      return { query: DashboardTaskFormTemplateDocument, variables: variables }
    }
export const DashboardTaskScheduleDocument = gql`
    query dashboardTaskSchedule($id: ID!) {
  data: task(id: $id) {
    id
    kind
    deadlineAt
    ...earlyCompletionFragment
    recurringRule {
      ...recurringRuleFragment
    }
  }
}
    ${EarlyCompletionFragmentFragmentDoc}
${RecurringRuleFragmentFragmentDoc}`;

/**
 * __useDashboardTaskScheduleQuery__
 *
 * To run a query within a React component, call `useDashboardTaskScheduleQuery` and pass it any options that fit your needs.
 * When your component renders, `useDashboardTaskScheduleQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDashboardTaskScheduleQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDashboardTaskScheduleQuery(baseOptions: ApolloReactHooks.QueryHookOptions<DashboardTaskScheduleQuery, DashboardTaskScheduleQueryVariables> & ({ variables: DashboardTaskScheduleQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<DashboardTaskScheduleQuery, DashboardTaskScheduleQueryVariables>(DashboardTaskScheduleDocument, options);
      }
export function useDashboardTaskScheduleLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<DashboardTaskScheduleQuery, DashboardTaskScheduleQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<DashboardTaskScheduleQuery, DashboardTaskScheduleQueryVariables>(DashboardTaskScheduleDocument, options);
        }
// @ts-ignore
export function useDashboardTaskScheduleSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<DashboardTaskScheduleQuery, DashboardTaskScheduleQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<DashboardTaskScheduleQuery, DashboardTaskScheduleQueryVariables>;
// @ts-ignore
export function useDashboardTaskScheduleSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<DashboardTaskScheduleQuery, DashboardTaskScheduleQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<DashboardTaskScheduleQuery | undefined, DashboardTaskScheduleQueryVariables>;
export function useDashboardTaskScheduleSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<DashboardTaskScheduleQuery, DashboardTaskScheduleQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          // @ts-ignore
          return ApolloReactHooks.useSuspenseQuery<DashboardTaskScheduleQuery, DashboardTaskScheduleQueryVariables>(DashboardTaskScheduleDocument, options);
        }
export type DashboardTaskScheduleQueryHookResult = ReturnType<typeof useDashboardTaskScheduleQuery>;
export type DashboardTaskScheduleLazyQueryHookResult = ReturnType<typeof useDashboardTaskScheduleLazyQuery>;
export type DashboardTaskScheduleSuspenseQueryHookResult = ReturnType<typeof useDashboardTaskScheduleSuspenseQuery>;
export type DashboardTaskScheduleQueryResult = ApolloReactCommon.QueryResult<DashboardTaskScheduleQuery, DashboardTaskScheduleQueryVariables>;
export function refetchDashboardTaskScheduleQuery(variables: DashboardTaskScheduleQueryVariables) {
      return { query: DashboardTaskScheduleDocument, variables: variables }
    }
export const DashboardTaskShortDocument = gql`
    query dashboardTaskShort($id: ID!) {
  data: task(id: $id) {
    id
    name
    assetId
    siteId
    siteAreaId
    groupKey
    formTemplate {
      id
    }
    formTemplateVersion {
      id
      version
    }
    canInterventionCreate {
      ...authorizationResultFragment
    }
  }
}
    ${AuthorizationResultFragmentFragmentDoc}`;

/**
 * __useDashboardTaskShortQuery__
 *
 * To run a query within a React component, call `useDashboardTaskShortQuery` and pass it any options that fit your needs.
 * When your component renders, `useDashboardTaskShortQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDashboardTaskShortQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDashboardTaskShortQuery(baseOptions: ApolloReactHooks.QueryHookOptions<DashboardTaskShortQuery, DashboardTaskShortQueryVariables> & ({ variables: DashboardTaskShortQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<DashboardTaskShortQuery, DashboardTaskShortQueryVariables>(DashboardTaskShortDocument, options);
      }
export function useDashboardTaskShortLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<DashboardTaskShortQuery, DashboardTaskShortQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<DashboardTaskShortQuery, DashboardTaskShortQueryVariables>(DashboardTaskShortDocument, options);
        }
// @ts-ignore
export function useDashboardTaskShortSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<DashboardTaskShortQuery, DashboardTaskShortQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<DashboardTaskShortQuery, DashboardTaskShortQueryVariables>;
// @ts-ignore
export function useDashboardTaskShortSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<DashboardTaskShortQuery, DashboardTaskShortQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<DashboardTaskShortQuery | undefined, DashboardTaskShortQueryVariables>;
export function useDashboardTaskShortSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<DashboardTaskShortQuery, DashboardTaskShortQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          // @ts-ignore
          return ApolloReactHooks.useSuspenseQuery<DashboardTaskShortQuery, DashboardTaskShortQueryVariables>(DashboardTaskShortDocument, options);
        }
export type DashboardTaskShortQueryHookResult = ReturnType<typeof useDashboardTaskShortQuery>;
export type DashboardTaskShortLazyQueryHookResult = ReturnType<typeof useDashboardTaskShortLazyQuery>;
export type DashboardTaskShortSuspenseQueryHookResult = ReturnType<typeof useDashboardTaskShortSuspenseQuery>;
export type DashboardTaskShortQueryResult = ApolloReactCommon.QueryResult<DashboardTaskShortQuery, DashboardTaskShortQueryVariables>;
export function refetchDashboardTaskShortQuery(variables: DashboardTaskShortQueryVariables) {
      return { query: DashboardTaskShortDocument, variables: variables }
    }
export const DashboardTasksDocument = gql`
    query dashboardTasks($page: Int, $limit: Int, $scope: TaskScopeInputObject!, $filters: [TaskFilterInputObject!], $sorts: TaskSortInputObject, $includeArchivedAt: Boolean = false, $includeCompletedAt: Boolean = false, $includeCompletion: Boolean = false, $includeDeadlineAt: Boolean = false, $includeDeadlineMissedReason: Boolean = false, $includeFormTemplate: Boolean = false, $includeLastCheckAt: Boolean = false, $includeLateFor: Boolean = false, $includeAsset: Boolean = false) {
  tasks(
    page: $page
    limit: $limit
    scope: $scope
    filters: $filters
    sorts: $sorts
  ) {
    collection {
      id
      name
      site {
        id
        name
      }
      siteArea {
        id
        name
      }
      priority
      status
      kind
      recurringRuleId
      canArchive {
        ...authorizationResultFragment
      }
      canDestroy {
        ...authorizationResultFragment
      }
      canUpdate {
        ...authorizationResultFragment
      }
      canReschedule {
        ...authorizationResultFragment
      }
      asset @include(if: $includeAsset) {
        id
        name
        fullCode
        siteArea {
          code
        }
        iconAttached {
          ...attachmentFragment
        }
      }
      deadlineAt @include(if: $includeDeadlineAt)
      lastCheckAt @include(if: $includeLastCheckAt)
      archivedAt @include(if: $includeArchivedAt)
      completedAt @include(if: $includeCompletedAt)
      lateFor @include(if: $includeLateFor)
      deadlineMissedReason @include(if: $includeDeadlineMissedReason)
      formTemplate @include(if: $includeFormTemplate) {
        id
        category {
          id
          name
          color
        }
      }
      completion @include(if: $includeCompletion) {
        validityHint
      }
    }
    metadata {
      ...metadataFragment
    }
  }
  active: tasks(scope: {name: ACTIVE}, filters: $filters) {
    metadata {
      totalCount
    }
  }
  archived: tasks(scope: {name: ARCHIVED}, filters: $filters) {
    metadata {
      totalCount
    }
  }
  completed: tasks(scope: {name: COMPLETED}, filters: $filters) {
    metadata {
      totalCount
    }
  }
  myApprovals: tasks(scope: {name: MY_APPROVALS}, filters: $filters) {
    metadata {
      totalCount
    }
  }
  pending: tasks(scope: {name: PENDING}, filters: $filters) {
    metadata {
      totalCount
    }
  }
  deadlineMissed: tasks(scope: {name: DEADLINE_MISSED}, filters: $filters) {
    metadata {
      totalCount
    }
  }
}
    ${AuthorizationResultFragmentFragmentDoc}
${AttachmentFragmentFragmentDoc}
${MetadataFragmentFragmentDoc}`;

/**
 * __useDashboardTasksQuery__
 *
 * To run a query within a React component, call `useDashboardTasksQuery` and pass it any options that fit your needs.
 * When your component renders, `useDashboardTasksQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDashboardTasksQuery({
 *   variables: {
 *      page: // value for 'page'
 *      limit: // value for 'limit'
 *      scope: // value for 'scope'
 *      filters: // value for 'filters'
 *      sorts: // value for 'sorts'
 *      includeArchivedAt: // value for 'includeArchivedAt'
 *      includeCompletedAt: // value for 'includeCompletedAt'
 *      includeCompletion: // value for 'includeCompletion'
 *      includeDeadlineAt: // value for 'includeDeadlineAt'
 *      includeDeadlineMissedReason: // value for 'includeDeadlineMissedReason'
 *      includeFormTemplate: // value for 'includeFormTemplate'
 *      includeLastCheckAt: // value for 'includeLastCheckAt'
 *      includeLateFor: // value for 'includeLateFor'
 *      includeAsset: // value for 'includeAsset'
 *   },
 * });
 */
export function useDashboardTasksQuery(baseOptions: ApolloReactHooks.QueryHookOptions<DashboardTasksQuery, DashboardTasksQueryVariables> & ({ variables: DashboardTasksQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<DashboardTasksQuery, DashboardTasksQueryVariables>(DashboardTasksDocument, options);
      }
export function useDashboardTasksLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<DashboardTasksQuery, DashboardTasksQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<DashboardTasksQuery, DashboardTasksQueryVariables>(DashboardTasksDocument, options);
        }
// @ts-ignore
export function useDashboardTasksSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<DashboardTasksQuery, DashboardTasksQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<DashboardTasksQuery, DashboardTasksQueryVariables>;
// @ts-ignore
export function useDashboardTasksSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<DashboardTasksQuery, DashboardTasksQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<DashboardTasksQuery | undefined, DashboardTasksQueryVariables>;
export function useDashboardTasksSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<DashboardTasksQuery, DashboardTasksQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          // @ts-ignore
          return ApolloReactHooks.useSuspenseQuery<DashboardTasksQuery, DashboardTasksQueryVariables>(DashboardTasksDocument, options);
        }
export type DashboardTasksQueryHookResult = ReturnType<typeof useDashboardTasksQuery>;
export type DashboardTasksLazyQueryHookResult = ReturnType<typeof useDashboardTasksLazyQuery>;
export type DashboardTasksSuspenseQueryHookResult = ReturnType<typeof useDashboardTasksSuspenseQuery>;
export type DashboardTasksQueryResult = ApolloReactCommon.QueryResult<DashboardTasksQuery, DashboardTasksQueryVariables>;
export function refetchDashboardTasksQuery(variables: DashboardTasksQueryVariables) {
      return { query: DashboardTasksDocument, variables: variables }
    }
export const FormTemplateTasksDocument = gql`
    query formTemplateTasks($page: Int, $limit: Int, $scope: TaskScopeInputObject!, $filters: [TaskFilterInputObject!], $sorts: TaskSortInputObject) {
  tasks(
    page: $page
    limit: $limit
    scope: $scope
    filters: $filters
    sorts: $sorts
  ) {
    collection {
      id
      name
      status
      recurringRuleId
      site {
        id
        name
      }
      siteArea {
        id
        name
      }
      asset {
        id
        name
        fullCode
        siteArea {
          code
        }
        iconAttached {
          ...attachmentFragment
        }
      }
      formTemplateVersion {
        id
        version
      }
      formTemplate {
        id
      }
      canFormTemplateVersionUpdate {
        value
      }
    }
    metadata {
      ...metadataFragment
    }
  }
}
    ${AttachmentFragmentFragmentDoc}
${MetadataFragmentFragmentDoc}`;

/**
 * __useFormTemplateTasksQuery__
 *
 * To run a query within a React component, call `useFormTemplateTasksQuery` and pass it any options that fit your needs.
 * When your component renders, `useFormTemplateTasksQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFormTemplateTasksQuery({
 *   variables: {
 *      page: // value for 'page'
 *      limit: // value for 'limit'
 *      scope: // value for 'scope'
 *      filters: // value for 'filters'
 *      sorts: // value for 'sorts'
 *   },
 * });
 */
export function useFormTemplateTasksQuery(baseOptions: ApolloReactHooks.QueryHookOptions<FormTemplateTasksQuery, FormTemplateTasksQueryVariables> & ({ variables: FormTemplateTasksQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<FormTemplateTasksQuery, FormTemplateTasksQueryVariables>(FormTemplateTasksDocument, options);
      }
export function useFormTemplateTasksLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<FormTemplateTasksQuery, FormTemplateTasksQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<FormTemplateTasksQuery, FormTemplateTasksQueryVariables>(FormTemplateTasksDocument, options);
        }
// @ts-ignore
export function useFormTemplateTasksSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<FormTemplateTasksQuery, FormTemplateTasksQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<FormTemplateTasksQuery, FormTemplateTasksQueryVariables>;
// @ts-ignore
export function useFormTemplateTasksSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<FormTemplateTasksQuery, FormTemplateTasksQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<FormTemplateTasksQuery | undefined, FormTemplateTasksQueryVariables>;
export function useFormTemplateTasksSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<FormTemplateTasksQuery, FormTemplateTasksQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          // @ts-ignore
          return ApolloReactHooks.useSuspenseQuery<FormTemplateTasksQuery, FormTemplateTasksQueryVariables>(FormTemplateTasksDocument, options);
        }
export type FormTemplateTasksQueryHookResult = ReturnType<typeof useFormTemplateTasksQuery>;
export type FormTemplateTasksLazyQueryHookResult = ReturnType<typeof useFormTemplateTasksLazyQuery>;
export type FormTemplateTasksSuspenseQueryHookResult = ReturnType<typeof useFormTemplateTasksSuspenseQuery>;
export type FormTemplateTasksQueryResult = ApolloReactCommon.QueryResult<FormTemplateTasksQuery, FormTemplateTasksQueryVariables>;
export function refetchFormTemplateTasksQuery(variables: FormTemplateTasksQueryVariables) {
      return { query: FormTemplateTasksDocument, variables: variables }
    }
export const DashboardTaskIdsDocument = gql`
    query dashboardTaskIds($scope: TaskScopeInputObject!, $filters: [TaskFilterInputObject!], $sorts: TaskSortInputObject, $onlyIds: Boolean) {
  data: tasks(scope: $scope, filters: $filters, sorts: $sorts, onlyIds: $onlyIds) {
    collection {
      id
      groupKey
    }
  }
}
    `;

/**
 * __useDashboardTaskIdsQuery__
 *
 * To run a query within a React component, call `useDashboardTaskIdsQuery` and pass it any options that fit your needs.
 * When your component renders, `useDashboardTaskIdsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDashboardTaskIdsQuery({
 *   variables: {
 *      scope: // value for 'scope'
 *      filters: // value for 'filters'
 *      sorts: // value for 'sorts'
 *      onlyIds: // value for 'onlyIds'
 *   },
 * });
 */
export function useDashboardTaskIdsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<DashboardTaskIdsQuery, DashboardTaskIdsQueryVariables> & ({ variables: DashboardTaskIdsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<DashboardTaskIdsQuery, DashboardTaskIdsQueryVariables>(DashboardTaskIdsDocument, options);
      }
export function useDashboardTaskIdsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<DashboardTaskIdsQuery, DashboardTaskIdsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<DashboardTaskIdsQuery, DashboardTaskIdsQueryVariables>(DashboardTaskIdsDocument, options);
        }
// @ts-ignore
export function useDashboardTaskIdsSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<DashboardTaskIdsQuery, DashboardTaskIdsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<DashboardTaskIdsQuery, DashboardTaskIdsQueryVariables>;
// @ts-ignore
export function useDashboardTaskIdsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<DashboardTaskIdsQuery, DashboardTaskIdsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<DashboardTaskIdsQuery | undefined, DashboardTaskIdsQueryVariables>;
export function useDashboardTaskIdsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<DashboardTaskIdsQuery, DashboardTaskIdsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          // @ts-ignore
          return ApolloReactHooks.useSuspenseQuery<DashboardTaskIdsQuery, DashboardTaskIdsQueryVariables>(DashboardTaskIdsDocument, options);
        }
export type DashboardTaskIdsQueryHookResult = ReturnType<typeof useDashboardTaskIdsQuery>;
export type DashboardTaskIdsLazyQueryHookResult = ReturnType<typeof useDashboardTaskIdsLazyQuery>;
export type DashboardTaskIdsSuspenseQueryHookResult = ReturnType<typeof useDashboardTaskIdsSuspenseQuery>;
export type DashboardTaskIdsQueryResult = ApolloReactCommon.QueryResult<DashboardTaskIdsQuery, DashboardTaskIdsQueryVariables>;
export function refetchDashboardTaskIdsQuery(variables: DashboardTaskIdsQueryVariables) {
      return { query: DashboardTaskIdsDocument, variables: variables }
    }
export const DashboardOverviewTasksDocument = gql`
    query dashboardOverviewTasks($page: Int, $limit: Int, $scope: TaskScopeInputObject!, $filters: [TaskFilterInputObject!], $activeTasksFilters: [TaskFilterInputObject!], $sorts: TaskSortInputObject, $includeCompletion: Boolean = false, $includeStatus: Boolean = false) {
  tasks(
    page: $page
    limit: $limit
    scope: $scope
    filters: $filters
    sorts: $sorts
  ) {
    collection {
      id
      name
      deadlineAt
      nextDeadlineAt
      completedAt
      site {
        id
        name
      }
      siteArea {
        id
        name
      }
      assetId
      priority
      status @include(if: $includeStatus)
      recurringRuleId
      completion @include(if: $includeCompletion) {
        id
        validityHint
        status
        solvedAt
        canStatusUpdate {
          ...authorizationResultFragment
        }
      }
      intervention {
        id
        closedAt
      }
      canInterventionCreate {
        ...authorizationResultFragment
      }
      canCompletionCreate {
        ...authorizationResultFragment
      }
    }
    metadata {
      ...metadataFragment
    }
  }
  active: tasks(scope: {name: ACTIVE}, filters: $activeTasksFilters) {
    metadata {
      totalCount
    }
  }
  completed: tasks(scope: {name: COMPLETED}, filters: $filters) {
    metadata {
      totalCount
    }
  }
  failure: tasks(scope: {name: FAILURE}, filters: $filters) {
    metadata {
      totalCount
    }
  }
  solved: tasks(scope: {name: SOLVED}, filters: $filters) {
    metadata {
      totalCount
    }
  }
  success: tasks(scope: {name: SUCCESS}, filters: $filters) {
    metadata {
      totalCount
    }
  }
  warning: tasks(scope: {name: WARNING}, filters: $filters) {
    metadata {
      totalCount
    }
  }
  warningUnsolved: tasks(scope: {name: WARNING_UNSOLVED}, filters: $filters) {
    metadata {
      totalCount
    }
  }
  warningSolved: tasks(scope: {name: WARNING_SOLVED}, filters: $filters) {
    metadata {
      totalCount
    }
  }
  failureUnsolved: tasks(scope: {name: FAILURE_UNSOLVED}, filters: $filters) {
    metadata {
      totalCount
    }
  }
  failureSolved: tasks(scope: {name: FAILURE_SOLVED}, filters: $filters) {
    metadata {
      totalCount
    }
  }
  dashboardAll: tasks(scope: {name: DASHBOARD_ALL}, filters: $filters) {
    metadata {
      totalCount
    }
  }
  deadlineMissedWithoutReason: tasks(
    scope: {name: DEADLINE_MISSED_WITHOUT_REASON}
    filters: $activeTasksFilters
  ) {
    metadata {
      totalCount
    }
  }
}
    ${AuthorizationResultFragmentFragmentDoc}
${MetadataFragmentFragmentDoc}`;

/**
 * __useDashboardOverviewTasksQuery__
 *
 * To run a query within a React component, call `useDashboardOverviewTasksQuery` and pass it any options that fit your needs.
 * When your component renders, `useDashboardOverviewTasksQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDashboardOverviewTasksQuery({
 *   variables: {
 *      page: // value for 'page'
 *      limit: // value for 'limit'
 *      scope: // value for 'scope'
 *      filters: // value for 'filters'
 *      activeTasksFilters: // value for 'activeTasksFilters'
 *      sorts: // value for 'sorts'
 *      includeCompletion: // value for 'includeCompletion'
 *      includeStatus: // value for 'includeStatus'
 *   },
 * });
 */
export function useDashboardOverviewTasksQuery(baseOptions: ApolloReactHooks.QueryHookOptions<DashboardOverviewTasksQuery, DashboardOverviewTasksQueryVariables> & ({ variables: DashboardOverviewTasksQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<DashboardOverviewTasksQuery, DashboardOverviewTasksQueryVariables>(DashboardOverviewTasksDocument, options);
      }
export function useDashboardOverviewTasksLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<DashboardOverviewTasksQuery, DashboardOverviewTasksQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<DashboardOverviewTasksQuery, DashboardOverviewTasksQueryVariables>(DashboardOverviewTasksDocument, options);
        }
// @ts-ignore
export function useDashboardOverviewTasksSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<DashboardOverviewTasksQuery, DashboardOverviewTasksQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<DashboardOverviewTasksQuery, DashboardOverviewTasksQueryVariables>;
// @ts-ignore
export function useDashboardOverviewTasksSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<DashboardOverviewTasksQuery, DashboardOverviewTasksQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<DashboardOverviewTasksQuery | undefined, DashboardOverviewTasksQueryVariables>;
export function useDashboardOverviewTasksSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<DashboardOverviewTasksQuery, DashboardOverviewTasksQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          // @ts-ignore
          return ApolloReactHooks.useSuspenseQuery<DashboardOverviewTasksQuery, DashboardOverviewTasksQueryVariables>(DashboardOverviewTasksDocument, options);
        }
export type DashboardOverviewTasksQueryHookResult = ReturnType<typeof useDashboardOverviewTasksQuery>;
export type DashboardOverviewTasksLazyQueryHookResult = ReturnType<typeof useDashboardOverviewTasksLazyQuery>;
export type DashboardOverviewTasksSuspenseQueryHookResult = ReturnType<typeof useDashboardOverviewTasksSuspenseQuery>;
export type DashboardOverviewTasksQueryResult = ApolloReactCommon.QueryResult<DashboardOverviewTasksQuery, DashboardOverviewTasksQueryVariables>;
export function refetchDashboardOverviewTasksQuery(variables: DashboardOverviewTasksQueryVariables) {
      return { query: DashboardOverviewTasksDocument, variables: variables }
    }
export const DashboardTimelineTasksDocument = gql`
    query dashboardTimelineTasks($page: Int, $limit: Int, $scope: TaskScopeInputObject!, $filters: [TaskFilterInputObject!], $sorts: TaskSortInputObject) {
  tasks(
    page: $page
    limit: $limit
    scope: $scope
    filters: $filters
    sorts: $sorts
  ) {
    collection {
      id
      name
      deadlineAt
      completedAt
      archivedAt
      formTemplate {
        id
        category {
          id
          name
          color
        }
      }
      site {
        id
        name
      }
      siteArea {
        id
        name
      }
      priority
      status
      recurringRuleId
    }
    metadata {
      ...metadataFragment
    }
  }
  taskIds: tasks(scope: $scope, filters: $filters, sorts: $sorts, onlyIds: true) {
    collection {
      id
    }
  }
  timelineAll: tasks(scope: {name: DASHBOARD_ALL}, filters: $filters) {
    metadata {
      totalCount
    }
  }
  timelineFailure: tasks(scope: {name: FAILURE}, filters: $filters) {
    metadata {
      totalCount
    }
  }
  timelineWarning: tasks(scope: {name: WARNING}, filters: $filters) {
    metadata {
      totalCount
    }
  }
}
    ${MetadataFragmentFragmentDoc}`;

/**
 * __useDashboardTimelineTasksQuery__
 *
 * To run a query within a React component, call `useDashboardTimelineTasksQuery` and pass it any options that fit your needs.
 * When your component renders, `useDashboardTimelineTasksQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDashboardTimelineTasksQuery({
 *   variables: {
 *      page: // value for 'page'
 *      limit: // value for 'limit'
 *      scope: // value for 'scope'
 *      filters: // value for 'filters'
 *      sorts: // value for 'sorts'
 *   },
 * });
 */
export function useDashboardTimelineTasksQuery(baseOptions: ApolloReactHooks.QueryHookOptions<DashboardTimelineTasksQuery, DashboardTimelineTasksQueryVariables> & ({ variables: DashboardTimelineTasksQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<DashboardTimelineTasksQuery, DashboardTimelineTasksQueryVariables>(DashboardTimelineTasksDocument, options);
      }
export function useDashboardTimelineTasksLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<DashboardTimelineTasksQuery, DashboardTimelineTasksQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<DashboardTimelineTasksQuery, DashboardTimelineTasksQueryVariables>(DashboardTimelineTasksDocument, options);
        }
// @ts-ignore
export function useDashboardTimelineTasksSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<DashboardTimelineTasksQuery, DashboardTimelineTasksQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<DashboardTimelineTasksQuery, DashboardTimelineTasksQueryVariables>;
// @ts-ignore
export function useDashboardTimelineTasksSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<DashboardTimelineTasksQuery, DashboardTimelineTasksQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<DashboardTimelineTasksQuery | undefined, DashboardTimelineTasksQueryVariables>;
export function useDashboardTimelineTasksSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<DashboardTimelineTasksQuery, DashboardTimelineTasksQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          // @ts-ignore
          return ApolloReactHooks.useSuspenseQuery<DashboardTimelineTasksQuery, DashboardTimelineTasksQueryVariables>(DashboardTimelineTasksDocument, options);
        }
export type DashboardTimelineTasksQueryHookResult = ReturnType<typeof useDashboardTimelineTasksQuery>;
export type DashboardTimelineTasksLazyQueryHookResult = ReturnType<typeof useDashboardTimelineTasksLazyQuery>;
export type DashboardTimelineTasksSuspenseQueryHookResult = ReturnType<typeof useDashboardTimelineTasksSuspenseQuery>;
export type DashboardTimelineTasksQueryResult = ApolloReactCommon.QueryResult<DashboardTimelineTasksQuery, DashboardTimelineTasksQueryVariables>;
export function refetchDashboardTimelineTasksQuery(variables: DashboardTimelineTasksQueryVariables) {
      return { query: DashboardTimelineTasksDocument, variables: variables }
    }
export const TasksTimelineDocument = gql`
    query tasksTimeline($taskIds: [ID!]!, $queryData: TaskTimelineQueryDataInputObject!) {
  tasksTimeline(taskIds: $taskIds, queryData: $queryData) {
    id
    rows {
      date
      validityHintCounters {
        failure
        none
        success
        warning
      }
    }
  }
}
    `;

/**
 * __useTasksTimelineQuery__
 *
 * To run a query within a React component, call `useTasksTimelineQuery` and pass it any options that fit your needs.
 * When your component renders, `useTasksTimelineQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTasksTimelineQuery({
 *   variables: {
 *      taskIds: // value for 'taskIds'
 *      queryData: // value for 'queryData'
 *   },
 * });
 */
export function useTasksTimelineQuery(baseOptions: ApolloReactHooks.QueryHookOptions<TasksTimelineQuery, TasksTimelineQueryVariables> & ({ variables: TasksTimelineQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<TasksTimelineQuery, TasksTimelineQueryVariables>(TasksTimelineDocument, options);
      }
export function useTasksTimelineLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<TasksTimelineQuery, TasksTimelineQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<TasksTimelineQuery, TasksTimelineQueryVariables>(TasksTimelineDocument, options);
        }
// @ts-ignore
export function useTasksTimelineSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<TasksTimelineQuery, TasksTimelineQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<TasksTimelineQuery, TasksTimelineQueryVariables>;
// @ts-ignore
export function useTasksTimelineSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<TasksTimelineQuery, TasksTimelineQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<TasksTimelineQuery | undefined, TasksTimelineQueryVariables>;
export function useTasksTimelineSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<TasksTimelineQuery, TasksTimelineQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          // @ts-ignore
          return ApolloReactHooks.useSuspenseQuery<TasksTimelineQuery, TasksTimelineQueryVariables>(TasksTimelineDocument, options);
        }
export type TasksTimelineQueryHookResult = ReturnType<typeof useTasksTimelineQuery>;
export type TasksTimelineLazyQueryHookResult = ReturnType<typeof useTasksTimelineLazyQuery>;
export type TasksTimelineSuspenseQueryHookResult = ReturnType<typeof useTasksTimelineSuspenseQuery>;
export type TasksTimelineQueryResult = ApolloReactCommon.QueryResult<TasksTimelineQuery, TasksTimelineQueryVariables>;
export function refetchTasksTimelineQuery(variables: TasksTimelineQueryVariables) {
      return { query: TasksTimelineDocument, variables: variables }
    }
export const TasksSearchListDocument = gql`
    query tasksSearchList($page: Int, $limit: Int, $scope: TaskScopeInputObject!, $filters: [TaskFilterInputObject!], $sorts: TaskSortInputObject) {
  data: tasks(
    page: $page
    limit: $limit
    scope: $scope
    filters: $filters
    sorts: $sorts
  ) {
    collection {
      id
      name
      groupKey
    }
    metadata {
      ...metadataFragment
    }
  }
}
    ${MetadataFragmentFragmentDoc}`;

/**
 * __useTasksSearchListQuery__
 *
 * To run a query within a React component, call `useTasksSearchListQuery` and pass it any options that fit your needs.
 * When your component renders, `useTasksSearchListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTasksSearchListQuery({
 *   variables: {
 *      page: // value for 'page'
 *      limit: // value for 'limit'
 *      scope: // value for 'scope'
 *      filters: // value for 'filters'
 *      sorts: // value for 'sorts'
 *   },
 * });
 */
export function useTasksSearchListQuery(baseOptions: ApolloReactHooks.QueryHookOptions<TasksSearchListQuery, TasksSearchListQueryVariables> & ({ variables: TasksSearchListQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<TasksSearchListQuery, TasksSearchListQueryVariables>(TasksSearchListDocument, options);
      }
export function useTasksSearchListLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<TasksSearchListQuery, TasksSearchListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<TasksSearchListQuery, TasksSearchListQueryVariables>(TasksSearchListDocument, options);
        }
// @ts-ignore
export function useTasksSearchListSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<TasksSearchListQuery, TasksSearchListQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<TasksSearchListQuery, TasksSearchListQueryVariables>;
// @ts-ignore
export function useTasksSearchListSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<TasksSearchListQuery, TasksSearchListQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<TasksSearchListQuery | undefined, TasksSearchListQueryVariables>;
export function useTasksSearchListSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<TasksSearchListQuery, TasksSearchListQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          // @ts-ignore
          return ApolloReactHooks.useSuspenseQuery<TasksSearchListQuery, TasksSearchListQueryVariables>(TasksSearchListDocument, options);
        }
export type TasksSearchListQueryHookResult = ReturnType<typeof useTasksSearchListQuery>;
export type TasksSearchListLazyQueryHookResult = ReturnType<typeof useTasksSearchListLazyQuery>;
export type TasksSearchListSuspenseQueryHookResult = ReturnType<typeof useTasksSearchListSuspenseQuery>;
export type TasksSearchListQueryResult = ApolloReactCommon.QueryResult<TasksSearchListQuery, TasksSearchListQueryVariables>;
export function refetchTasksSearchListQuery(variables: TasksSearchListQueryVariables) {
      return { query: TasksSearchListDocument, variables: variables }
    }
export const TaskCompletionsDocument = gql`
    query taskCompletions($page: Int, $limit: Int, $groupKey: ID!, $filters: [TaskCompletionFilterInputObject!], $sorts: TaskCompletionSortInputObject) {
  data: taskCompletions(
    page: $page
    limit: $limit
    groupKey: $groupKey
    filters: $filters
    sorts: $sorts
  ) {
    collection {
      id
      taskId
      createdAt
      solvedAt
      status
      answers {
        id
        kind
        validityHint
        resp {
          optionId
          selected
          value
          valueId
          status
          statusReason
        }
      }
      task {
        assetId
        siteAreaId
        siteId
        formTemplateVersion {
          id
          version
        }
        canInterventionCreate {
          ...authorizationResultFragment
        }
        intervention {
          id
        }
      }
      performer {
        id
        firstName
        lastName
        avatarAttached {
          ...attachmentFragment
        }
      }
    }
    metadata {
      ...metadataFragment
    }
  }
}
    ${AuthorizationResultFragmentFragmentDoc}
${AttachmentFragmentFragmentDoc}
${MetadataFragmentFragmentDoc}`;

/**
 * __useTaskCompletionsQuery__
 *
 * To run a query within a React component, call `useTaskCompletionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useTaskCompletionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTaskCompletionsQuery({
 *   variables: {
 *      page: // value for 'page'
 *      limit: // value for 'limit'
 *      groupKey: // value for 'groupKey'
 *      filters: // value for 'filters'
 *      sorts: // value for 'sorts'
 *   },
 * });
 */
export function useTaskCompletionsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<TaskCompletionsQuery, TaskCompletionsQueryVariables> & ({ variables: TaskCompletionsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<TaskCompletionsQuery, TaskCompletionsQueryVariables>(TaskCompletionsDocument, options);
      }
export function useTaskCompletionsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<TaskCompletionsQuery, TaskCompletionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<TaskCompletionsQuery, TaskCompletionsQueryVariables>(TaskCompletionsDocument, options);
        }
// @ts-ignore
export function useTaskCompletionsSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<TaskCompletionsQuery, TaskCompletionsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<TaskCompletionsQuery, TaskCompletionsQueryVariables>;
// @ts-ignore
export function useTaskCompletionsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<TaskCompletionsQuery, TaskCompletionsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<TaskCompletionsQuery | undefined, TaskCompletionsQueryVariables>;
export function useTaskCompletionsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<TaskCompletionsQuery, TaskCompletionsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          // @ts-ignore
          return ApolloReactHooks.useSuspenseQuery<TaskCompletionsQuery, TaskCompletionsQueryVariables>(TaskCompletionsDocument, options);
        }
export type TaskCompletionsQueryHookResult = ReturnType<typeof useTaskCompletionsQuery>;
export type TaskCompletionsLazyQueryHookResult = ReturnType<typeof useTaskCompletionsLazyQuery>;
export type TaskCompletionsSuspenseQueryHookResult = ReturnType<typeof useTaskCompletionsSuspenseQuery>;
export type TaskCompletionsQueryResult = ApolloReactCommon.QueryResult<TaskCompletionsQuery, TaskCompletionsQueryVariables>;
export function refetchTaskCompletionsQuery(variables: TaskCompletionsQueryVariables) {
      return { query: TaskCompletionsDocument, variables: variables }
    }
export const TaskCompletionsIdsDocument = gql`
    query taskCompletionsIds($page: Int, $limit: Int, $groupKey: ID!, $filters: [TaskCompletionFilterInputObject!], $sorts: TaskCompletionSortInputObject) {
  data: taskCompletions(
    page: $page
    limit: $limit
    groupKey: $groupKey
    filters: $filters
    sorts: $sorts
    onlyIds: true
  ) {
    collection {
      id
    }
  }
}
    `;

/**
 * __useTaskCompletionsIdsQuery__
 *
 * To run a query within a React component, call `useTaskCompletionsIdsQuery` and pass it any options that fit your needs.
 * When your component renders, `useTaskCompletionsIdsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTaskCompletionsIdsQuery({
 *   variables: {
 *      page: // value for 'page'
 *      limit: // value for 'limit'
 *      groupKey: // value for 'groupKey'
 *      filters: // value for 'filters'
 *      sorts: // value for 'sorts'
 *   },
 * });
 */
export function useTaskCompletionsIdsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<TaskCompletionsIdsQuery, TaskCompletionsIdsQueryVariables> & ({ variables: TaskCompletionsIdsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<TaskCompletionsIdsQuery, TaskCompletionsIdsQueryVariables>(TaskCompletionsIdsDocument, options);
      }
export function useTaskCompletionsIdsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<TaskCompletionsIdsQuery, TaskCompletionsIdsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<TaskCompletionsIdsQuery, TaskCompletionsIdsQueryVariables>(TaskCompletionsIdsDocument, options);
        }
// @ts-ignore
export function useTaskCompletionsIdsSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<TaskCompletionsIdsQuery, TaskCompletionsIdsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<TaskCompletionsIdsQuery, TaskCompletionsIdsQueryVariables>;
// @ts-ignore
export function useTaskCompletionsIdsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<TaskCompletionsIdsQuery, TaskCompletionsIdsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<TaskCompletionsIdsQuery | undefined, TaskCompletionsIdsQueryVariables>;
export function useTaskCompletionsIdsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<TaskCompletionsIdsQuery, TaskCompletionsIdsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          // @ts-ignore
          return ApolloReactHooks.useSuspenseQuery<TaskCompletionsIdsQuery, TaskCompletionsIdsQueryVariables>(TaskCompletionsIdsDocument, options);
        }
export type TaskCompletionsIdsQueryHookResult = ReturnType<typeof useTaskCompletionsIdsQuery>;
export type TaskCompletionsIdsLazyQueryHookResult = ReturnType<typeof useTaskCompletionsIdsLazyQuery>;
export type TaskCompletionsIdsSuspenseQueryHookResult = ReturnType<typeof useTaskCompletionsIdsSuspenseQuery>;
export type TaskCompletionsIdsQueryResult = ApolloReactCommon.QueryResult<TaskCompletionsIdsQuery, TaskCompletionsIdsQueryVariables>;
export function refetchTaskCompletionsIdsQuery(variables: TaskCompletionsIdsQueryVariables) {
      return { query: TaskCompletionsIdsDocument, variables: variables }
    }
export const TaskCompletionDocument = gql`
    query taskCompletion($id: ID!, $isViewLocked: Boolean! = false) {
  data: taskCompletion(id: $id) {
    id
    createdAt
    validityHint
    answers {
      id
      kind
      fieldId
      validityHint
      field {
        id
        options {
          id
          fieldId
          group
          position
          values
          optionDocumentation @skip(if: $isViewLocked) {
            documentationId
          }
        }
      }
      questionId
      resp {
        validityHint
        group
        optionId
        position
        selected
        value
        valueId
        status
        statusReason
        documentationVersionViewId
      }
      documentationVersionViews {
        id
        documentationId
        readingDurationSeconds
      }
      attachmentsAttached {
        ...attachmentFragment
      }
    }
    task {
      assetId
      siteAreaId
      siteId
      formTemplateVersion {
        id
        version
        questions {
          id
          position
          attachmentsAttached {
            ...attachmentFragment
          }
          name
          fields {
            id
            kind
            required
            position
            options {
              id
              group
              position
              values
              validityHint
              optionDocumentation @skip(if: $isViewLocked) {
                documentationId
              }
            }
            settings {
              limitToOneRespPerColumn
              limitToOneRespPerRow
              limitToOneResp
            }
          }
        }
      }
      canInterventionCreate {
        ...authorizationResultFragment
      }
      intervention {
        id
      }
    }
    performer {
      id
      firstName
      lastName
      avatarAttached {
        ...attachmentFragment
      }
    }
  }
}
    ${AttachmentFragmentFragmentDoc}
${AuthorizationResultFragmentFragmentDoc}`;

/**
 * __useTaskCompletionQuery__
 *
 * To run a query within a React component, call `useTaskCompletionQuery` and pass it any options that fit your needs.
 * When your component renders, `useTaskCompletionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTaskCompletionQuery({
 *   variables: {
 *      id: // value for 'id'
 *      isViewLocked: // value for 'isViewLocked'
 *   },
 * });
 */
export function useTaskCompletionQuery(baseOptions: ApolloReactHooks.QueryHookOptions<TaskCompletionQuery, TaskCompletionQueryVariables> & ({ variables: TaskCompletionQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<TaskCompletionQuery, TaskCompletionQueryVariables>(TaskCompletionDocument, options);
      }
export function useTaskCompletionLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<TaskCompletionQuery, TaskCompletionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<TaskCompletionQuery, TaskCompletionQueryVariables>(TaskCompletionDocument, options);
        }
// @ts-ignore
export function useTaskCompletionSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<TaskCompletionQuery, TaskCompletionQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<TaskCompletionQuery, TaskCompletionQueryVariables>;
// @ts-ignore
export function useTaskCompletionSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<TaskCompletionQuery, TaskCompletionQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<TaskCompletionQuery | undefined, TaskCompletionQueryVariables>;
export function useTaskCompletionSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<TaskCompletionQuery, TaskCompletionQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          // @ts-ignore
          return ApolloReactHooks.useSuspenseQuery<TaskCompletionQuery, TaskCompletionQueryVariables>(TaskCompletionDocument, options);
        }
export type TaskCompletionQueryHookResult = ReturnType<typeof useTaskCompletionQuery>;
export type TaskCompletionLazyQueryHookResult = ReturnType<typeof useTaskCompletionLazyQuery>;
export type TaskCompletionSuspenseQueryHookResult = ReturnType<typeof useTaskCompletionSuspenseQuery>;
export type TaskCompletionQueryResult = ApolloReactCommon.QueryResult<TaskCompletionQuery, TaskCompletionQueryVariables>;
export function refetchTaskCompletionQuery(variables: TaskCompletionQueryVariables) {
      return { query: TaskCompletionDocument, variables: variables }
    }
export const TasksMyTodoCompletableByDateDataDocument = gql`
    query tasksMyTodoCompletableByDateData($date: ISO8601DateTime!) {
  data: tasksMyTodoCompletableByDateData(date: $date) {
    id
    offlineImportantDataDigest
  }
}
    `;

/**
 * __useTasksMyTodoCompletableByDateDataQuery__
 *
 * To run a query within a React component, call `useTasksMyTodoCompletableByDateDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useTasksMyTodoCompletableByDateDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTasksMyTodoCompletableByDateDataQuery({
 *   variables: {
 *      date: // value for 'date'
 *   },
 * });
 */
export function useTasksMyTodoCompletableByDateDataQuery(baseOptions: ApolloReactHooks.QueryHookOptions<TasksMyTodoCompletableByDateDataQuery, TasksMyTodoCompletableByDateDataQueryVariables> & ({ variables: TasksMyTodoCompletableByDateDataQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<TasksMyTodoCompletableByDateDataQuery, TasksMyTodoCompletableByDateDataQueryVariables>(TasksMyTodoCompletableByDateDataDocument, options);
      }
export function useTasksMyTodoCompletableByDateDataLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<TasksMyTodoCompletableByDateDataQuery, TasksMyTodoCompletableByDateDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<TasksMyTodoCompletableByDateDataQuery, TasksMyTodoCompletableByDateDataQueryVariables>(TasksMyTodoCompletableByDateDataDocument, options);
        }
// @ts-ignore
export function useTasksMyTodoCompletableByDateDataSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<TasksMyTodoCompletableByDateDataQuery, TasksMyTodoCompletableByDateDataQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<TasksMyTodoCompletableByDateDataQuery, TasksMyTodoCompletableByDateDataQueryVariables>;
// @ts-ignore
export function useTasksMyTodoCompletableByDateDataSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<TasksMyTodoCompletableByDateDataQuery, TasksMyTodoCompletableByDateDataQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<TasksMyTodoCompletableByDateDataQuery | undefined, TasksMyTodoCompletableByDateDataQueryVariables>;
export function useTasksMyTodoCompletableByDateDataSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<TasksMyTodoCompletableByDateDataQuery, TasksMyTodoCompletableByDateDataQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          // @ts-ignore
          return ApolloReactHooks.useSuspenseQuery<TasksMyTodoCompletableByDateDataQuery, TasksMyTodoCompletableByDateDataQueryVariables>(TasksMyTodoCompletableByDateDataDocument, options);
        }
export type TasksMyTodoCompletableByDateDataQueryHookResult = ReturnType<typeof useTasksMyTodoCompletableByDateDataQuery>;
export type TasksMyTodoCompletableByDateDataLazyQueryHookResult = ReturnType<typeof useTasksMyTodoCompletableByDateDataLazyQuery>;
export type TasksMyTodoCompletableByDateDataSuspenseQueryHookResult = ReturnType<typeof useTasksMyTodoCompletableByDateDataSuspenseQuery>;
export type TasksMyTodoCompletableByDateDataQueryResult = ApolloReactCommon.QueryResult<TasksMyTodoCompletableByDateDataQuery, TasksMyTodoCompletableByDateDataQueryVariables>;
export function refetchTasksMyTodoCompletableByDateDataQuery(variables: TasksMyTodoCompletableByDateDataQueryVariables) {
      return { query: TasksMyTodoCompletableByDateDataDocument, variables: variables }
    }
export const TasksDuplicatesListDocument = gql`
    query tasksDuplicatesList($page: Int, $limit: Int, $scope: TaskScopeInputObject!, $filters: [TaskFilterInputObject!], $sorts: TaskSortInputObject) {
  tasks(
    page: $page
    limit: $limit
    scope: $scope
    filters: $filters
    sorts: $sorts
  ) {
    collection {
      id
      name
      status
      kind
      priority
      recurringRuleId
      site {
        id
        name
      }
      siteArea {
        id
        name
      }
      formTemplate {
        category {
          ...formCategoryFragment
        }
        id
        name
      }
    }
    metadata {
      ...metadataFragment
    }
  }
}
    ${FormCategoryFragmentFragmentDoc}
${MetadataFragmentFragmentDoc}`;

/**
 * __useTasksDuplicatesListQuery__
 *
 * To run a query within a React component, call `useTasksDuplicatesListQuery` and pass it any options that fit your needs.
 * When your component renders, `useTasksDuplicatesListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTasksDuplicatesListQuery({
 *   variables: {
 *      page: // value for 'page'
 *      limit: // value for 'limit'
 *      scope: // value for 'scope'
 *      filters: // value for 'filters'
 *      sorts: // value for 'sorts'
 *   },
 * });
 */
export function useTasksDuplicatesListQuery(baseOptions: ApolloReactHooks.QueryHookOptions<TasksDuplicatesListQuery, TasksDuplicatesListQueryVariables> & ({ variables: TasksDuplicatesListQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<TasksDuplicatesListQuery, TasksDuplicatesListQueryVariables>(TasksDuplicatesListDocument, options);
      }
export function useTasksDuplicatesListLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<TasksDuplicatesListQuery, TasksDuplicatesListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<TasksDuplicatesListQuery, TasksDuplicatesListQueryVariables>(TasksDuplicatesListDocument, options);
        }
// @ts-ignore
export function useTasksDuplicatesListSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<TasksDuplicatesListQuery, TasksDuplicatesListQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<TasksDuplicatesListQuery, TasksDuplicatesListQueryVariables>;
// @ts-ignore
export function useTasksDuplicatesListSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<TasksDuplicatesListQuery, TasksDuplicatesListQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<TasksDuplicatesListQuery | undefined, TasksDuplicatesListQueryVariables>;
export function useTasksDuplicatesListSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<TasksDuplicatesListQuery, TasksDuplicatesListQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          // @ts-ignore
          return ApolloReactHooks.useSuspenseQuery<TasksDuplicatesListQuery, TasksDuplicatesListQueryVariables>(TasksDuplicatesListDocument, options);
        }
export type TasksDuplicatesListQueryHookResult = ReturnType<typeof useTasksDuplicatesListQuery>;
export type TasksDuplicatesListLazyQueryHookResult = ReturnType<typeof useTasksDuplicatesListLazyQuery>;
export type TasksDuplicatesListSuspenseQueryHookResult = ReturnType<typeof useTasksDuplicatesListSuspenseQuery>;
export type TasksDuplicatesListQueryResult = ApolloReactCommon.QueryResult<TasksDuplicatesListQuery, TasksDuplicatesListQueryVariables>;
export function refetchTasksDuplicatesListQuery(variables: TasksDuplicatesListQueryVariables) {
      return { query: TasksDuplicatesListDocument, variables: variables }
    }
export const TasksMultiselectListDocument = gql`
    query tasksMultiselectList($page: Int, $limit: Int, $scope: TaskScopeInputObject!, $filters: [TaskFilterInputObject!], $sorts: TaskSortInputObject) {
  tasks(
    page: $page
    limit: $limit
    scope: $scope
    filters: $filters
    sorts: $sorts
  ) {
    collection {
      id
      name
      groupKey
      kind
      recurringRuleId
      priority
      site {
        id
        name
      }
      siteArea {
        id
        name
      }
      asset {
        id
        name
        fullCode
        siteArea {
          code
        }
        iconAttached {
          ...attachmentFragment
        }
      }
      formTemplate {
        category {
          ...formCategoryFragment
        }
        id
        name
      }
    }
    metadata {
      ...metadataFragment
    }
  }
}
    ${AttachmentFragmentFragmentDoc}
${FormCategoryFragmentFragmentDoc}
${MetadataFragmentFragmentDoc}`;

/**
 * __useTasksMultiselectListQuery__
 *
 * To run a query within a React component, call `useTasksMultiselectListQuery` and pass it any options that fit your needs.
 * When your component renders, `useTasksMultiselectListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTasksMultiselectListQuery({
 *   variables: {
 *      page: // value for 'page'
 *      limit: // value for 'limit'
 *      scope: // value for 'scope'
 *      filters: // value for 'filters'
 *      sorts: // value for 'sorts'
 *   },
 * });
 */
export function useTasksMultiselectListQuery(baseOptions: ApolloReactHooks.QueryHookOptions<TasksMultiselectListQuery, TasksMultiselectListQueryVariables> & ({ variables: TasksMultiselectListQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<TasksMultiselectListQuery, TasksMultiselectListQueryVariables>(TasksMultiselectListDocument, options);
      }
export function useTasksMultiselectListLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<TasksMultiselectListQuery, TasksMultiselectListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<TasksMultiselectListQuery, TasksMultiselectListQueryVariables>(TasksMultiselectListDocument, options);
        }
// @ts-ignore
export function useTasksMultiselectListSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<TasksMultiselectListQuery, TasksMultiselectListQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<TasksMultiselectListQuery, TasksMultiselectListQueryVariables>;
// @ts-ignore
export function useTasksMultiselectListSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<TasksMultiselectListQuery, TasksMultiselectListQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<TasksMultiselectListQuery | undefined, TasksMultiselectListQueryVariables>;
export function useTasksMultiselectListSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<TasksMultiselectListQuery, TasksMultiselectListQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          // @ts-ignore
          return ApolloReactHooks.useSuspenseQuery<TasksMultiselectListQuery, TasksMultiselectListQueryVariables>(TasksMultiselectListDocument, options);
        }
export type TasksMultiselectListQueryHookResult = ReturnType<typeof useTasksMultiselectListQuery>;
export type TasksMultiselectListLazyQueryHookResult = ReturnType<typeof useTasksMultiselectListLazyQuery>;
export type TasksMultiselectListSuspenseQueryHookResult = ReturnType<typeof useTasksMultiselectListSuspenseQuery>;
export type TasksMultiselectListQueryResult = ApolloReactCommon.QueryResult<TasksMultiselectListQuery, TasksMultiselectListQueryVariables>;
export function refetchTasksMultiselectListQuery(variables: TasksMultiselectListQueryVariables) {
      return { query: TasksMultiselectListDocument, variables: variables }
    }
export const TaskCompletionCreateDocument = gql`
    mutation taskCompletionCreate($input: TaskCompletionCreateInputObject!) {
  taskCompletionCreate(input: {attributes: $input}) {
    id
  }
}
    `;

/**
 * __useTaskCompletionCreateMutation__
 *
 * To run a mutation, you first call `useTaskCompletionCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTaskCompletionCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [taskCompletionCreateMutation, { data, loading, error }] = useTaskCompletionCreateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useTaskCompletionCreateMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<TaskCompletionCreateMutation, TaskCompletionCreateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<TaskCompletionCreateMutation, TaskCompletionCreateMutationVariables>(TaskCompletionCreateDocument, options);
      }
export type TaskCompletionCreateMutationHookResult = ReturnType<typeof useTaskCompletionCreateMutation>;
export type TaskCompletionCreateMutationResult = ApolloReactCommon.MutationResult<TaskCompletionCreateMutation>;
export const TaskBulkCreateSameDocument = gql`
    mutation taskBulkCreateSame($attributes: TaskBulkCreateSameInputObject!) {
  data: taskBulkCreateSame(input: {attributes: $attributes})
}
    `;

/**
 * __useTaskBulkCreateSameMutation__
 *
 * To run a mutation, you first call `useTaskBulkCreateSameMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTaskBulkCreateSameMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [taskBulkCreateSameMutation, { data, loading, error }] = useTaskBulkCreateSameMutation({
 *   variables: {
 *      attributes: // value for 'attributes'
 *   },
 * });
 */
export function useTaskBulkCreateSameMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<TaskBulkCreateSameMutation, TaskBulkCreateSameMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<TaskBulkCreateSameMutation, TaskBulkCreateSameMutationVariables>(TaskBulkCreateSameDocument, options);
      }
export type TaskBulkCreateSameMutationHookResult = ReturnType<typeof useTaskBulkCreateSameMutation>;
export type TaskBulkCreateSameMutationResult = ApolloReactCommon.MutationResult<TaskBulkCreateSameMutation>;
export const TaskUpdateDocument = gql`
    mutation taskUpdate($attributes: TaskUpdateInputObject!, $id: ID!) {
  data: taskUpdate(input: {attributes: $attributes, id: $id}) {
    ...taskFragment
  }
}
    ${TaskFragmentFragmentDoc}
${AttachmentFragmentFragmentDoc}
${CanActionsTaskFragmentFragmentDoc}
${AuthorizationResultFragmentFragmentDoc}`;

/**
 * __useTaskUpdateMutation__
 *
 * To run a mutation, you first call `useTaskUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTaskUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [taskUpdateMutation, { data, loading, error }] = useTaskUpdateMutation({
 *   variables: {
 *      attributes: // value for 'attributes'
 *      id: // value for 'id'
 *   },
 * });
 */
export function useTaskUpdateMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<TaskUpdateMutation, TaskUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<TaskUpdateMutation, TaskUpdateMutationVariables>(TaskUpdateDocument, options);
      }
export type TaskUpdateMutationHookResult = ReturnType<typeof useTaskUpdateMutation>;
export type TaskUpdateMutationResult = ApolloReactCommon.MutationResult<TaskUpdateMutation>;
export const TaskBulkSchedulingDocument = gql`
    mutation taskBulkScheduling($ids: [ID!]!, $attributes: TaskBulkSchedulingInputObject!) {
  data: taskBulkScheduling(input: {ids: $ids, attributes: $attributes})
}
    `;

/**
 * __useTaskBulkSchedulingMutation__
 *
 * To run a mutation, you first call `useTaskBulkSchedulingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTaskBulkSchedulingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [taskBulkSchedulingMutation, { data, loading, error }] = useTaskBulkSchedulingMutation({
 *   variables: {
 *      ids: // value for 'ids'
 *      attributes: // value for 'attributes'
 *   },
 * });
 */
export function useTaskBulkSchedulingMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<TaskBulkSchedulingMutation, TaskBulkSchedulingMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<TaskBulkSchedulingMutation, TaskBulkSchedulingMutationVariables>(TaskBulkSchedulingDocument, options);
      }
export type TaskBulkSchedulingMutationHookResult = ReturnType<typeof useTaskBulkSchedulingMutation>;
export type TaskBulkSchedulingMutationResult = ApolloReactCommon.MutationResult<TaskBulkSchedulingMutation>;
export const TaskBulkUpdateStatusDocument = gql`
    mutation taskBulkUpdateStatus($ids: [ID!]!, $attributes: TaskUpdateStatusInputObject!) {
  data: taskBulkUpdateStatus(input: {ids: $ids, attributes: $attributes})
}
    `;

/**
 * __useTaskBulkUpdateStatusMutation__
 *
 * To run a mutation, you first call `useTaskBulkUpdateStatusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTaskBulkUpdateStatusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [taskBulkUpdateStatusMutation, { data, loading, error }] = useTaskBulkUpdateStatusMutation({
 *   variables: {
 *      ids: // value for 'ids'
 *      attributes: // value for 'attributes'
 *   },
 * });
 */
export function useTaskBulkUpdateStatusMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<TaskBulkUpdateStatusMutation, TaskBulkUpdateStatusMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<TaskBulkUpdateStatusMutation, TaskBulkUpdateStatusMutationVariables>(TaskBulkUpdateStatusDocument, options);
      }
export type TaskBulkUpdateStatusMutationHookResult = ReturnType<typeof useTaskBulkUpdateStatusMutation>;
export type TaskBulkUpdateStatusMutationResult = ApolloReactCommon.MutationResult<TaskBulkUpdateStatusMutation>;
export const TaskBulkDeadlineMissedReasonUpdateDocument = gql`
    mutation taskBulkDeadlineMissedReasonUpdate($ids: [ID!]!, $attributes: TaskUpdateDeadlineMissedReasonInputObject!) {
  data: taskBulkDeadlineMissedReasonUpdate(
    input: {ids: $ids, attributes: $attributes}
  )
}
    `;

/**
 * __useTaskBulkDeadlineMissedReasonUpdateMutation__
 *
 * To run a mutation, you first call `useTaskBulkDeadlineMissedReasonUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTaskBulkDeadlineMissedReasonUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [taskBulkDeadlineMissedReasonUpdateMutation, { data, loading, error }] = useTaskBulkDeadlineMissedReasonUpdateMutation({
 *   variables: {
 *      ids: // value for 'ids'
 *      attributes: // value for 'attributes'
 *   },
 * });
 */
export function useTaskBulkDeadlineMissedReasonUpdateMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<TaskBulkDeadlineMissedReasonUpdateMutation, TaskBulkDeadlineMissedReasonUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<TaskBulkDeadlineMissedReasonUpdateMutation, TaskBulkDeadlineMissedReasonUpdateMutationVariables>(TaskBulkDeadlineMissedReasonUpdateDocument, options);
      }
export type TaskBulkDeadlineMissedReasonUpdateMutationHookResult = ReturnType<typeof useTaskBulkDeadlineMissedReasonUpdateMutation>;
export type TaskBulkDeadlineMissedReasonUpdateMutationResult = ApolloReactCommon.MutationResult<TaskBulkDeadlineMissedReasonUpdateMutation>;
export const TaskDestroyDocument = gql`
    mutation taskDestroy($id: ID!) {
  data: taskDestroy(input: {id: $id})
}
    `;

/**
 * __useTaskDestroyMutation__
 *
 * To run a mutation, you first call `useTaskDestroyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTaskDestroyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [taskDestroyMutation, { data, loading, error }] = useTaskDestroyMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useTaskDestroyMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<TaskDestroyMutation, TaskDestroyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<TaskDestroyMutation, TaskDestroyMutationVariables>(TaskDestroyDocument, options);
      }
export type TaskDestroyMutationHookResult = ReturnType<typeof useTaskDestroyMutation>;
export type TaskDestroyMutationResult = ApolloReactCommon.MutationResult<TaskDestroyMutation>;
export const TaskUnlinkAllDocumentationsDocument = gql`
    mutation taskUnlinkAllDocumentations($input: TaskUnlinkAllDocumentationsInput!) {
  data: taskUnlinkAllDocumentations(input: $input)
}
    `;

/**
 * __useTaskUnlinkAllDocumentationsMutation__
 *
 * To run a mutation, you first call `useTaskUnlinkAllDocumentationsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTaskUnlinkAllDocumentationsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [taskUnlinkAllDocumentationsMutation, { data, loading, error }] = useTaskUnlinkAllDocumentationsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useTaskUnlinkAllDocumentationsMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<TaskUnlinkAllDocumentationsMutation, TaskUnlinkAllDocumentationsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<TaskUnlinkAllDocumentationsMutation, TaskUnlinkAllDocumentationsMutationVariables>(TaskUnlinkAllDocumentationsDocument, options);
      }
export type TaskUnlinkAllDocumentationsMutationHookResult = ReturnType<typeof useTaskUnlinkAllDocumentationsMutation>;
export type TaskUnlinkAllDocumentationsMutationResult = ApolloReactCommon.MutationResult<TaskUnlinkAllDocumentationsMutation>;
export const TaskCompletionStatusUpdateDocument = gql`
    mutation taskCompletionStatusUpdate($taskId: ID!, $attributes: TaskCompletionUpdateStatusInputObject!) {
  data: taskCompletionStatusUpdate(
    input: {taskId: $taskId, attributes: $attributes}
  ) {
    id
  }
}
    `;

/**
 * __useTaskCompletionStatusUpdateMutation__
 *
 * To run a mutation, you first call `useTaskCompletionStatusUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTaskCompletionStatusUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [taskCompletionStatusUpdateMutation, { data, loading, error }] = useTaskCompletionStatusUpdateMutation({
 *   variables: {
 *      taskId: // value for 'taskId'
 *      attributes: // value for 'attributes'
 *   },
 * });
 */
export function useTaskCompletionStatusUpdateMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<TaskCompletionStatusUpdateMutation, TaskCompletionStatusUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<TaskCompletionStatusUpdateMutation, TaskCompletionStatusUpdateMutationVariables>(TaskCompletionStatusUpdateDocument, options);
      }
export type TaskCompletionStatusUpdateMutationHookResult = ReturnType<typeof useTaskCompletionStatusUpdateMutation>;
export type TaskCompletionStatusUpdateMutationResult = ApolloReactCommon.MutationResult<TaskCompletionStatusUpdateMutation>;
export const TaskBulkTemplateVersionUpdateDocument = gql`
    mutation taskBulkTemplateVersionUpdate($input: TaskBulkTemplateVersionUpdateInput!) {
  data: taskBulkTemplateVersionUpdate(input: $input)
}
    `;

/**
 * __useTaskBulkTemplateVersionUpdateMutation__
 *
 * To run a mutation, you first call `useTaskBulkTemplateVersionUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTaskBulkTemplateVersionUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [taskBulkTemplateVersionUpdateMutation, { data, loading, error }] = useTaskBulkTemplateVersionUpdateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useTaskBulkTemplateVersionUpdateMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<TaskBulkTemplateVersionUpdateMutation, TaskBulkTemplateVersionUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<TaskBulkTemplateVersionUpdateMutation, TaskBulkTemplateVersionUpdateMutationVariables>(TaskBulkTemplateVersionUpdateDocument, options);
      }
export type TaskBulkTemplateVersionUpdateMutationHookResult = ReturnType<typeof useTaskBulkTemplateVersionUpdateMutation>;
export type TaskBulkTemplateVersionUpdateMutationResult = ApolloReactCommon.MutationResult<TaskBulkTemplateVersionUpdateMutation>;
export const TaskTimelineReportCreateDocument = gql`
    mutation taskTimelineReportCreate($input: TasksTimelineReportCreateInput!) {
  data: taskTimelineReportCreate(input: $input) {
    ...backgroundJobTreeFragment
  }
}
    ${BackgroundJobTreeFragmentFragmentDoc}
${BackgroundJobFragmentFragmentDoc}
${AuthorizationResultFragmentFragmentDoc}`;

/**
 * __useTaskTimelineReportCreateMutation__
 *
 * To run a mutation, you first call `useTaskTimelineReportCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTaskTimelineReportCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [taskTimelineReportCreateMutation, { data, loading, error }] = useTaskTimelineReportCreateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useTaskTimelineReportCreateMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<TaskTimelineReportCreateMutation, TaskTimelineReportCreateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<TaskTimelineReportCreateMutation, TaskTimelineReportCreateMutationVariables>(TaskTimelineReportCreateDocument, options);
      }
export type TaskTimelineReportCreateMutationHookResult = ReturnType<typeof useTaskTimelineReportCreateMutation>;
export type TaskTimelineReportCreateMutationResult = ApolloReactCommon.MutationResult<TaskTimelineReportCreateMutation>;
export const TeamsDocument = gql`
    query teams($page: Int, $limit: Int, $sorts: TeamSortInputObject, $filters: [TeamFilterInputObject!]) {
  data: teams(page: $page, limit: $limit, sorts: $sorts, filters: $filters) {
    collection {
      id
      name
      color
      visibleUsersCount
      readOnly
      canDestroy {
        ...authorizationResultFragment
      }
    }
    metadata {
      ...metadataFragment
    }
  }
}
    ${AuthorizationResultFragmentFragmentDoc}
${MetadataFragmentFragmentDoc}`;

/**
 * __useTeamsQuery__
 *
 * To run a query within a React component, call `useTeamsQuery` and pass it any options that fit your needs.
 * When your component renders, `useTeamsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTeamsQuery({
 *   variables: {
 *      page: // value for 'page'
 *      limit: // value for 'limit'
 *      sorts: // value for 'sorts'
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useTeamsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<TeamsQuery, TeamsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<TeamsQuery, TeamsQueryVariables>(TeamsDocument, options);
      }
export function useTeamsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<TeamsQuery, TeamsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<TeamsQuery, TeamsQueryVariables>(TeamsDocument, options);
        }
// @ts-ignore
export function useTeamsSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<TeamsQuery, TeamsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<TeamsQuery, TeamsQueryVariables>;
// @ts-ignore
export function useTeamsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<TeamsQuery, TeamsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<TeamsQuery | undefined, TeamsQueryVariables>;
export function useTeamsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<TeamsQuery, TeamsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          // @ts-ignore
          return ApolloReactHooks.useSuspenseQuery<TeamsQuery, TeamsQueryVariables>(TeamsDocument, options);
        }
export type TeamsQueryHookResult = ReturnType<typeof useTeamsQuery>;
export type TeamsLazyQueryHookResult = ReturnType<typeof useTeamsLazyQuery>;
export type TeamsSuspenseQueryHookResult = ReturnType<typeof useTeamsSuspenseQuery>;
export type TeamsQueryResult = ApolloReactCommon.QueryResult<TeamsQuery, TeamsQueryVariables>;
export function refetchTeamsQuery(variables?: TeamsQueryVariables) {
      return { query: TeamsDocument, variables: variables }
    }
export const TeamsIdsDocument = gql`
    query teamsIds($page: Int, $limit: Int, $sorts: TeamSortInputObject, $filters: [TeamFilterInputObject!], $onlyIds: Boolean) {
  data: teams(
    page: $page
    limit: $limit
    sorts: $sorts
    filters: $filters
    onlyIds: $onlyIds
  ) {
    collection {
      id
    }
  }
}
    `;

/**
 * __useTeamsIdsQuery__
 *
 * To run a query within a React component, call `useTeamsIdsQuery` and pass it any options that fit your needs.
 * When your component renders, `useTeamsIdsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTeamsIdsQuery({
 *   variables: {
 *      page: // value for 'page'
 *      limit: // value for 'limit'
 *      sorts: // value for 'sorts'
 *      filters: // value for 'filters'
 *      onlyIds: // value for 'onlyIds'
 *   },
 * });
 */
export function useTeamsIdsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<TeamsIdsQuery, TeamsIdsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<TeamsIdsQuery, TeamsIdsQueryVariables>(TeamsIdsDocument, options);
      }
export function useTeamsIdsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<TeamsIdsQuery, TeamsIdsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<TeamsIdsQuery, TeamsIdsQueryVariables>(TeamsIdsDocument, options);
        }
// @ts-ignore
export function useTeamsIdsSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<TeamsIdsQuery, TeamsIdsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<TeamsIdsQuery, TeamsIdsQueryVariables>;
// @ts-ignore
export function useTeamsIdsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<TeamsIdsQuery, TeamsIdsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<TeamsIdsQuery | undefined, TeamsIdsQueryVariables>;
export function useTeamsIdsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<TeamsIdsQuery, TeamsIdsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          // @ts-ignore
          return ApolloReactHooks.useSuspenseQuery<TeamsIdsQuery, TeamsIdsQueryVariables>(TeamsIdsDocument, options);
        }
export type TeamsIdsQueryHookResult = ReturnType<typeof useTeamsIdsQuery>;
export type TeamsIdsLazyQueryHookResult = ReturnType<typeof useTeamsIdsLazyQuery>;
export type TeamsIdsSuspenseQueryHookResult = ReturnType<typeof useTeamsIdsSuspenseQuery>;
export type TeamsIdsQueryResult = ApolloReactCommon.QueryResult<TeamsIdsQuery, TeamsIdsQueryVariables>;
export function refetchTeamsIdsQuery(variables?: TeamsIdsQueryVariables) {
      return { query: TeamsIdsDocument, variables: variables }
    }
export const TeamsSearchListDocument = gql`
    query teamsSearchList($page: Int, $limit: Int, $sorts: TeamSortInputObject, $filters: [TeamFilterInputObject!]) {
  data: teams(page: $page, limit: $limit, sorts: $sorts, filters: $filters) {
    collection {
      id
      name
      color
    }
    metadata {
      ...metadataFragment
    }
  }
}
    ${MetadataFragmentFragmentDoc}`;

/**
 * __useTeamsSearchListQuery__
 *
 * To run a query within a React component, call `useTeamsSearchListQuery` and pass it any options that fit your needs.
 * When your component renders, `useTeamsSearchListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTeamsSearchListQuery({
 *   variables: {
 *      page: // value for 'page'
 *      limit: // value for 'limit'
 *      sorts: // value for 'sorts'
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useTeamsSearchListQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<TeamsSearchListQuery, TeamsSearchListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<TeamsSearchListQuery, TeamsSearchListQueryVariables>(TeamsSearchListDocument, options);
      }
export function useTeamsSearchListLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<TeamsSearchListQuery, TeamsSearchListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<TeamsSearchListQuery, TeamsSearchListQueryVariables>(TeamsSearchListDocument, options);
        }
// @ts-ignore
export function useTeamsSearchListSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<TeamsSearchListQuery, TeamsSearchListQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<TeamsSearchListQuery, TeamsSearchListQueryVariables>;
// @ts-ignore
export function useTeamsSearchListSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<TeamsSearchListQuery, TeamsSearchListQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<TeamsSearchListQuery | undefined, TeamsSearchListQueryVariables>;
export function useTeamsSearchListSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<TeamsSearchListQuery, TeamsSearchListQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          // @ts-ignore
          return ApolloReactHooks.useSuspenseQuery<TeamsSearchListQuery, TeamsSearchListQueryVariables>(TeamsSearchListDocument, options);
        }
export type TeamsSearchListQueryHookResult = ReturnType<typeof useTeamsSearchListQuery>;
export type TeamsSearchListLazyQueryHookResult = ReturnType<typeof useTeamsSearchListLazyQuery>;
export type TeamsSearchListSuspenseQueryHookResult = ReturnType<typeof useTeamsSearchListSuspenseQuery>;
export type TeamsSearchListQueryResult = ApolloReactCommon.QueryResult<TeamsSearchListQuery, TeamsSearchListQueryVariables>;
export function refetchTeamsSearchListQuery(variables?: TeamsSearchListQueryVariables) {
      return { query: TeamsSearchListDocument, variables: variables }
    }
export const TeamDocument = gql`
    query team($id: ID!) {
  data: team(id: $id) {
    ...teamFragment
  }
}
    ${TeamFragmentFragmentDoc}
${AuthorizationResultFragmentFragmentDoc}`;

/**
 * __useTeamQuery__
 *
 * To run a query within a React component, call `useTeamQuery` and pass it any options that fit your needs.
 * When your component renders, `useTeamQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTeamQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useTeamQuery(baseOptions: ApolloReactHooks.QueryHookOptions<TeamQuery, TeamQueryVariables> & ({ variables: TeamQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<TeamQuery, TeamQueryVariables>(TeamDocument, options);
      }
export function useTeamLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<TeamQuery, TeamQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<TeamQuery, TeamQueryVariables>(TeamDocument, options);
        }
// @ts-ignore
export function useTeamSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<TeamQuery, TeamQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<TeamQuery, TeamQueryVariables>;
// @ts-ignore
export function useTeamSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<TeamQuery, TeamQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<TeamQuery | undefined, TeamQueryVariables>;
export function useTeamSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<TeamQuery, TeamQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          // @ts-ignore
          return ApolloReactHooks.useSuspenseQuery<TeamQuery, TeamQueryVariables>(TeamDocument, options);
        }
export type TeamQueryHookResult = ReturnType<typeof useTeamQuery>;
export type TeamLazyQueryHookResult = ReturnType<typeof useTeamLazyQuery>;
export type TeamSuspenseQueryHookResult = ReturnType<typeof useTeamSuspenseQuery>;
export type TeamQueryResult = ApolloReactCommon.QueryResult<TeamQuery, TeamQueryVariables>;
export function refetchTeamQuery(variables: TeamQueryVariables) {
      return { query: TeamDocument, variables: variables }
    }
export const TeamCreateDocument = gql`
    mutation teamCreate($attributes: TeamCreateInputObject!) {
  data: teamCreate(input: {attributes: $attributes}) {
    ...teamFragment
  }
}
    ${TeamFragmentFragmentDoc}
${AuthorizationResultFragmentFragmentDoc}`;

/**
 * __useTeamCreateMutation__
 *
 * To run a mutation, you first call `useTeamCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTeamCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [teamCreateMutation, { data, loading, error }] = useTeamCreateMutation({
 *   variables: {
 *      attributes: // value for 'attributes'
 *   },
 * });
 */
export function useTeamCreateMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<TeamCreateMutation, TeamCreateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<TeamCreateMutation, TeamCreateMutationVariables>(TeamCreateDocument, options);
      }
export type TeamCreateMutationHookResult = ReturnType<typeof useTeamCreateMutation>;
export type TeamCreateMutationResult = ApolloReactCommon.MutationResult<TeamCreateMutation>;
export const TeamUpdateDocument = gql`
    mutation teamUpdate($id: ID!, $attributes: TeamUpdateInputObject!) {
  data: teamUpdate(input: {id: $id, attributes: $attributes}) {
    ...teamFragment
  }
}
    ${TeamFragmentFragmentDoc}
${AuthorizationResultFragmentFragmentDoc}`;

/**
 * __useTeamUpdateMutation__
 *
 * To run a mutation, you first call `useTeamUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTeamUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [teamUpdateMutation, { data, loading, error }] = useTeamUpdateMutation({
 *   variables: {
 *      id: // value for 'id'
 *      attributes: // value for 'attributes'
 *   },
 * });
 */
export function useTeamUpdateMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<TeamUpdateMutation, TeamUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<TeamUpdateMutation, TeamUpdateMutationVariables>(TeamUpdateDocument, options);
      }
export type TeamUpdateMutationHookResult = ReturnType<typeof useTeamUpdateMutation>;
export type TeamUpdateMutationResult = ApolloReactCommon.MutationResult<TeamUpdateMutation>;
export const TeamDestroyDocument = gql`
    mutation teamDestroy($id: ID!) {
  data: teamDestroy(input: {id: $id})
}
    `;

/**
 * __useTeamDestroyMutation__
 *
 * To run a mutation, you first call `useTeamDestroyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTeamDestroyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [teamDestroyMutation, { data, loading, error }] = useTeamDestroyMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useTeamDestroyMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<TeamDestroyMutation, TeamDestroyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<TeamDestroyMutation, TeamDestroyMutationVariables>(TeamDestroyDocument, options);
      }
export type TeamDestroyMutationHookResult = ReturnType<typeof useTeamDestroyMutation>;
export type TeamDestroyMutationResult = ApolloReactCommon.MutationResult<TeamDestroyMutation>;
export const UsersDocument = gql`
    query users($page: Int, $limit: Int, $sorts: UserSortInputObject, $filters: [UserFilterInputObject!], $scope: UserScopeInputObject, $includeFullData: Boolean = false, $includeShortData: Boolean = false, $includeFinalAccesses: Boolean = false, $includePersonalAccesses: Boolean = false, $includeTeamAccesses: Boolean = false, $includeTeamData: Boolean = false) {
  data: users(
    page: $page
    limit: $limit
    sorts: $sorts
    filters: $filters
    scope: $scope
  ) {
    collection {
      avatarAttached {
        ...attachmentFragment
      }
      id
      firstName
      lastName
      email
      passwordSetupRequired @include(if: $includeFullData)
      passwordSetupRequired @include(if: $includeShortData)
      role
      personalId @include(if: $includeFullData)
      personalId @include(if: $includeShortData)
      sites @include(if: $includeFullData) {
        collection {
          id
          name
        }
      }
      sectors @include(if: $includeFullData) {
        collection {
          id
          name
          color
        }
      }
      unconfirmedEmail @include(if: $includeFullData)
      unconfirmedEmail @include(if: $includeShortData)
      verified @include(if: $includeFullData)
      verified @include(if: $includeShortData)
      deactivatedAt @include(if: $includeFullData)
      deactivatedAt @include(if: $includeShortData)
      team @include(if: $includeFullData) {
        id
        name
        color
      }
      team @include(if: $includeTeamData) {
        id
        name
        color
      }
      team @include(if: $includeTeamAccesses) {
        id
        name
        color
        accesses {
          component
          itemIds
          level
          scopeLevel
          policy
        }
      }
      finalAccesses @include(if: $includeFinalAccesses) {
        component
        itemIds
        level
        scopeLevel
        policy
      }
      personalAccesses @include(if: $includePersonalAccesses) {
        component
        itemIds
        level
        scopeLevel
        policy
      }
    }
    metadata {
      ...metadataFragment
    }
  }
}
    ${AttachmentFragmentFragmentDoc}
${MetadataFragmentFragmentDoc}`;

/**
 * __useUsersQuery__
 *
 * To run a query within a React component, call `useUsersQuery` and pass it any options that fit your needs.
 * When your component renders, `useUsersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUsersQuery({
 *   variables: {
 *      page: // value for 'page'
 *      limit: // value for 'limit'
 *      sorts: // value for 'sorts'
 *      filters: // value for 'filters'
 *      scope: // value for 'scope'
 *      includeFullData: // value for 'includeFullData'
 *      includeShortData: // value for 'includeShortData'
 *      includeFinalAccesses: // value for 'includeFinalAccesses'
 *      includePersonalAccesses: // value for 'includePersonalAccesses'
 *      includeTeamAccesses: // value for 'includeTeamAccesses'
 *      includeTeamData: // value for 'includeTeamData'
 *   },
 * });
 */
export function useUsersQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<UsersQuery, UsersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<UsersQuery, UsersQueryVariables>(UsersDocument, options);
      }
export function useUsersLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<UsersQuery, UsersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<UsersQuery, UsersQueryVariables>(UsersDocument, options);
        }
// @ts-ignore
export function useUsersSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<UsersQuery, UsersQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<UsersQuery, UsersQueryVariables>;
// @ts-ignore
export function useUsersSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<UsersQuery, UsersQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<UsersQuery | undefined, UsersQueryVariables>;
export function useUsersSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<UsersQuery, UsersQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          // @ts-ignore
          return ApolloReactHooks.useSuspenseQuery<UsersQuery, UsersQueryVariables>(UsersDocument, options);
        }
export type UsersQueryHookResult = ReturnType<typeof useUsersQuery>;
export type UsersLazyQueryHookResult = ReturnType<typeof useUsersLazyQuery>;
export type UsersSuspenseQueryHookResult = ReturnType<typeof useUsersSuspenseQuery>;
export type UsersQueryResult = ApolloReactCommon.QueryResult<UsersQuery, UsersQueryVariables>;
export function refetchUsersQuery(variables?: UsersQueryVariables) {
      return { query: UsersDocument, variables: variables }
    }
export const UsersIdsDocument = gql`
    query usersIds($page: Int, $limit: Int, $sorts: UserSortInputObject, $filters: [UserFilterInputObject!], $scope: UserScopeInputObject, $onlyIds: Boolean) {
  data: users(
    page: $page
    limit: $limit
    sorts: $sorts
    filters: $filters
    scope: $scope
    onlyIds: $onlyIds
  ) {
    collection {
      id
    }
  }
}
    `;

/**
 * __useUsersIdsQuery__
 *
 * To run a query within a React component, call `useUsersIdsQuery` and pass it any options that fit your needs.
 * When your component renders, `useUsersIdsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUsersIdsQuery({
 *   variables: {
 *      page: // value for 'page'
 *      limit: // value for 'limit'
 *      sorts: // value for 'sorts'
 *      filters: // value for 'filters'
 *      scope: // value for 'scope'
 *      onlyIds: // value for 'onlyIds'
 *   },
 * });
 */
export function useUsersIdsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<UsersIdsQuery, UsersIdsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<UsersIdsQuery, UsersIdsQueryVariables>(UsersIdsDocument, options);
      }
export function useUsersIdsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<UsersIdsQuery, UsersIdsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<UsersIdsQuery, UsersIdsQueryVariables>(UsersIdsDocument, options);
        }
// @ts-ignore
export function useUsersIdsSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<UsersIdsQuery, UsersIdsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<UsersIdsQuery, UsersIdsQueryVariables>;
// @ts-ignore
export function useUsersIdsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<UsersIdsQuery, UsersIdsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<UsersIdsQuery | undefined, UsersIdsQueryVariables>;
export function useUsersIdsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<UsersIdsQuery, UsersIdsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          // @ts-ignore
          return ApolloReactHooks.useSuspenseQuery<UsersIdsQuery, UsersIdsQueryVariables>(UsersIdsDocument, options);
        }
export type UsersIdsQueryHookResult = ReturnType<typeof useUsersIdsQuery>;
export type UsersIdsLazyQueryHookResult = ReturnType<typeof useUsersIdsLazyQuery>;
export type UsersIdsSuspenseQueryHookResult = ReturnType<typeof useUsersIdsSuspenseQuery>;
export type UsersIdsQueryResult = ApolloReactCommon.QueryResult<UsersIdsQuery, UsersIdsQueryVariables>;
export function refetchUsersIdsQuery(variables?: UsersIdsQueryVariables) {
      return { query: UsersIdsDocument, variables: variables }
    }
export const UsersCountersDocument = gql`
    query usersCounters($page: Int, $limit: Int, $sorts: UserSortInputObject, $filters: [UserFilterInputObject!], $fullAdminsFilters: [UserFilterInputObject!], $usersFilters: [UserFilterInputObject!], $unassignedFilters: [UserFilterInputObject!], $scope: UserScopeInputObject, $onlyIds: Boolean) {
  all: users(
    page: $page
    limit: $limit
    sorts: $sorts
    filters: $filters
    scope: $scope
    onlyIds: $onlyIds
  ) {
    metadata {
      totalCount
    }
  }
  fullAdmins: users(
    page: $page
    limit: $limit
    sorts: $sorts
    filters: $fullAdminsFilters
    scope: $scope
    onlyIds: $onlyIds
  ) {
    metadata {
      totalCount
    }
  }
  users: users(
    page: $page
    limit: $limit
    sorts: $sorts
    filters: $usersFilters
    scope: $scope
    onlyIds: $onlyIds
  ) {
    metadata {
      totalCount
    }
  }
  unassigned: users(
    page: $page
    limit: $limit
    sorts: $sorts
    filters: $unassignedFilters
    scope: $scope
    onlyIds: $onlyIds
  ) {
    metadata {
      totalCount
    }
  }
}
    `;

/**
 * __useUsersCountersQuery__
 *
 * To run a query within a React component, call `useUsersCountersQuery` and pass it any options that fit your needs.
 * When your component renders, `useUsersCountersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUsersCountersQuery({
 *   variables: {
 *      page: // value for 'page'
 *      limit: // value for 'limit'
 *      sorts: // value for 'sorts'
 *      filters: // value for 'filters'
 *      fullAdminsFilters: // value for 'fullAdminsFilters'
 *      usersFilters: // value for 'usersFilters'
 *      unassignedFilters: // value for 'unassignedFilters'
 *      scope: // value for 'scope'
 *      onlyIds: // value for 'onlyIds'
 *   },
 * });
 */
export function useUsersCountersQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<UsersCountersQuery, UsersCountersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<UsersCountersQuery, UsersCountersQueryVariables>(UsersCountersDocument, options);
      }
export function useUsersCountersLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<UsersCountersQuery, UsersCountersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<UsersCountersQuery, UsersCountersQueryVariables>(UsersCountersDocument, options);
        }
// @ts-ignore
export function useUsersCountersSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<UsersCountersQuery, UsersCountersQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<UsersCountersQuery, UsersCountersQueryVariables>;
// @ts-ignore
export function useUsersCountersSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<UsersCountersQuery, UsersCountersQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<UsersCountersQuery | undefined, UsersCountersQueryVariables>;
export function useUsersCountersSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<UsersCountersQuery, UsersCountersQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          // @ts-ignore
          return ApolloReactHooks.useSuspenseQuery<UsersCountersQuery, UsersCountersQueryVariables>(UsersCountersDocument, options);
        }
export type UsersCountersQueryHookResult = ReturnType<typeof useUsersCountersQuery>;
export type UsersCountersLazyQueryHookResult = ReturnType<typeof useUsersCountersLazyQuery>;
export type UsersCountersSuspenseQueryHookResult = ReturnType<typeof useUsersCountersSuspenseQuery>;
export type UsersCountersQueryResult = ApolloReactCommon.QueryResult<UsersCountersQuery, UsersCountersQueryVariables>;
export function refetchUsersCountersQuery(variables?: UsersCountersQueryVariables) {
      return { query: UsersCountersDocument, variables: variables }
    }
export const UsersSearchListDocument = gql`
    query usersSearchList($page: Int, $limit: Int, $sorts: UserSortInputObject, $filters: [UserFilterInputObject!], $scope: UserScopeInputObject) {
  data: users(
    page: $page
    limit: $limit
    sorts: $sorts
    filters: $filters
    scope: $scope
  ) {
    collection {
      id
      firstName
      lastName
      avatarAttached {
        ...attachmentFragment
      }
      email
    }
    metadata {
      ...metadataFragment
    }
  }
}
    ${AttachmentFragmentFragmentDoc}
${MetadataFragmentFragmentDoc}`;

/**
 * __useUsersSearchListQuery__
 *
 * To run a query within a React component, call `useUsersSearchListQuery` and pass it any options that fit your needs.
 * When your component renders, `useUsersSearchListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUsersSearchListQuery({
 *   variables: {
 *      page: // value for 'page'
 *      limit: // value for 'limit'
 *      sorts: // value for 'sorts'
 *      filters: // value for 'filters'
 *      scope: // value for 'scope'
 *   },
 * });
 */
export function useUsersSearchListQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<UsersSearchListQuery, UsersSearchListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<UsersSearchListQuery, UsersSearchListQueryVariables>(UsersSearchListDocument, options);
      }
export function useUsersSearchListLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<UsersSearchListQuery, UsersSearchListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<UsersSearchListQuery, UsersSearchListQueryVariables>(UsersSearchListDocument, options);
        }
// @ts-ignore
export function useUsersSearchListSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<UsersSearchListQuery, UsersSearchListQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<UsersSearchListQuery, UsersSearchListQueryVariables>;
// @ts-ignore
export function useUsersSearchListSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<UsersSearchListQuery, UsersSearchListQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<UsersSearchListQuery | undefined, UsersSearchListQueryVariables>;
export function useUsersSearchListSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<UsersSearchListQuery, UsersSearchListQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          // @ts-ignore
          return ApolloReactHooks.useSuspenseQuery<UsersSearchListQuery, UsersSearchListQueryVariables>(UsersSearchListDocument, options);
        }
export type UsersSearchListQueryHookResult = ReturnType<typeof useUsersSearchListQuery>;
export type UsersSearchListLazyQueryHookResult = ReturnType<typeof useUsersSearchListLazyQuery>;
export type UsersSearchListSuspenseQueryHookResult = ReturnType<typeof useUsersSearchListSuspenseQuery>;
export type UsersSearchListQueryResult = ApolloReactCommon.QueryResult<UsersSearchListQuery, UsersSearchListQueryVariables>;
export function refetchUsersSearchListQuery(variables?: UsersSearchListQueryVariables) {
      return { query: UsersSearchListDocument, variables: variables }
    }
export const UserDocument = gql`
    query user($id: ID!, $includeFullData: Boolean = false, $includeFinalAccesses: Boolean = false, $includePersonalAccesses: Boolean = false, $includeTeamAccesses: Boolean = false) {
  data: user(id: $id) {
    avatarAttached {
      ...attachmentFragment
    }
    id
    firstName
    lastName
    email @include(if: $includeFullData)
    passwordSetupRequired
    role
    personalId @include(if: $includeFullData)
    phoneNumber @include(if: $includeFullData)
    sites @include(if: $includeFullData) {
      collection {
        id
        name
      }
    }
    sectors @include(if: $includeFullData) {
      collection {
        id
        name
        color
      }
    }
    verified @include(if: $includeFullData)
    username @include(if: $includeFullData)
    deactivatedAt
    team @include(if: $includeFullData) {
      id
      name
      color
    }
    team @include(if: $includeTeamAccesses) {
      id
      name
      color
      accesses {
        component
        itemIds
        level
        scopeLevel
        policy
      }
    }
    finalAccesses @include(if: $includeFinalAccesses) {
      component
      itemIds
      level
      scopeLevel
      policy
    }
    personalAccesses @include(if: $includePersonalAccesses) {
      component
      itemIds
      level
      scopeLevel
      policy
    }
  }
}
    ${AttachmentFragmentFragmentDoc}`;

/**
 * __useUserQuery__
 *
 * To run a query within a React component, call `useUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserQuery({
 *   variables: {
 *      id: // value for 'id'
 *      includeFullData: // value for 'includeFullData'
 *      includeFinalAccesses: // value for 'includeFinalAccesses'
 *      includePersonalAccesses: // value for 'includePersonalAccesses'
 *      includeTeamAccesses: // value for 'includeTeamAccesses'
 *   },
 * });
 */
export function useUserQuery(baseOptions: ApolloReactHooks.QueryHookOptions<UserQuery, UserQueryVariables> & ({ variables: UserQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<UserQuery, UserQueryVariables>(UserDocument, options);
      }
export function useUserLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<UserQuery, UserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<UserQuery, UserQueryVariables>(UserDocument, options);
        }
// @ts-ignore
export function useUserSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<UserQuery, UserQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<UserQuery, UserQueryVariables>;
// @ts-ignore
export function useUserSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<UserQuery, UserQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<UserQuery | undefined, UserQueryVariables>;
export function useUserSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<UserQuery, UserQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          // @ts-ignore
          return ApolloReactHooks.useSuspenseQuery<UserQuery, UserQueryVariables>(UserDocument, options);
        }
export type UserQueryHookResult = ReturnType<typeof useUserQuery>;
export type UserLazyQueryHookResult = ReturnType<typeof useUserLazyQuery>;
export type UserSuspenseQueryHookResult = ReturnType<typeof useUserSuspenseQuery>;
export type UserQueryResult = ApolloReactCommon.QueryResult<UserQuery, UserQueryVariables>;
export function refetchUserQuery(variables: UserQueryVariables) {
      return { query: UserDocument, variables: variables }
    }
export const UserCreateDocument = gql`
    mutation userCreate($attributes: UserCreateInputObject!, $redirectUrl: String!) {
  data: userCreate(input: {attributes: $attributes, redirectUrl: $redirectUrl}) {
    ...fullUserFragment
  }
}
    ${FullUserFragmentFragmentDoc}
${AttachmentFragmentFragmentDoc}`;

/**
 * __useUserCreateMutation__
 *
 * To run a mutation, you first call `useUserCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUserCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [userCreateMutation, { data, loading, error }] = useUserCreateMutation({
 *   variables: {
 *      attributes: // value for 'attributes'
 *      redirectUrl: // value for 'redirectUrl'
 *   },
 * });
 */
export function useUserCreateMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UserCreateMutation, UserCreateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UserCreateMutation, UserCreateMutationVariables>(UserCreateDocument, options);
      }
export type UserCreateMutationHookResult = ReturnType<typeof useUserCreateMutation>;
export type UserCreateMutationResult = ApolloReactCommon.MutationResult<UserCreateMutation>;
export const UserUpdateDocument = gql`
    mutation userUpdate($id: ID!, $attributes: UserUpdateInputObject!, $finishRegistrationRedirectUrl: String!, $confirmEmailRedirectUrl: String!) {
  data: userUpdate(
    input: {id: $id, attributes: $attributes, finishRegistrationRedirectUrl: $finishRegistrationRedirectUrl, confirmEmailRedirectUrl: $confirmEmailRedirectUrl}
  ) {
    ...fullUserFragment
  }
}
    ${FullUserFragmentFragmentDoc}
${AttachmentFragmentFragmentDoc}`;

/**
 * __useUserUpdateMutation__
 *
 * To run a mutation, you first call `useUserUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUserUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [userUpdateMutation, { data, loading, error }] = useUserUpdateMutation({
 *   variables: {
 *      id: // value for 'id'
 *      attributes: // value for 'attributes'
 *      finishRegistrationRedirectUrl: // value for 'finishRegistrationRedirectUrl'
 *      confirmEmailRedirectUrl: // value for 'confirmEmailRedirectUrl'
 *   },
 * });
 */
export function useUserUpdateMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UserUpdateMutation, UserUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UserUpdateMutation, UserUpdateMutationVariables>(UserUpdateDocument, options);
      }
export type UserUpdateMutationHookResult = ReturnType<typeof useUserUpdateMutation>;
export type UserUpdateMutationResult = ApolloReactCommon.MutationResult<UserUpdateMutation>;
export const UserSelfUpdateDocument = gql`
    mutation userSelfUpdate($input: UserSelfUpdateInput!) {
  data: userSelfUpdate(input: $input) {
    ...fullUserFragment
    finalAccesses {
      component
      itemIds
      level
      scopeLevel
      policy
    }
  }
}
    ${FullUserFragmentFragmentDoc}
${AttachmentFragmentFragmentDoc}`;

/**
 * __useUserSelfUpdateMutation__
 *
 * To run a mutation, you first call `useUserSelfUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUserSelfUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [userSelfUpdateMutation, { data, loading, error }] = useUserSelfUpdateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUserSelfUpdateMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UserSelfUpdateMutation, UserSelfUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UserSelfUpdateMutation, UserSelfUpdateMutationVariables>(UserSelfUpdateDocument, options);
      }
export type UserSelfUpdateMutationHookResult = ReturnType<typeof useUserSelfUpdateMutation>;
export type UserSelfUpdateMutationResult = ApolloReactCommon.MutationResult<UserSelfUpdateMutation>;
export const UserDestroyDocument = gql`
    mutation userDestroy($id: ID!) {
  data: userDestroy(input: {id: $id})
}
    `;

/**
 * __useUserDestroyMutation__
 *
 * To run a mutation, you first call `useUserDestroyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUserDestroyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [userDestroyMutation, { data, loading, error }] = useUserDestroyMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useUserDestroyMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UserDestroyMutation, UserDestroyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UserDestroyMutation, UserDestroyMutationVariables>(UserDestroyDocument, options);
      }
export type UserDestroyMutationHookResult = ReturnType<typeof useUserDestroyMutation>;
export type UserDestroyMutationResult = ApolloReactCommon.MutationResult<UserDestroyMutation>;
export const AuthenticationPasswordSetupDocument = gql`
    mutation authenticationPasswordSetup($input: AuthenticationPasswordSetupInput!) {
  data: authenticationPasswordSetup(input: $input)
}
    `;

/**
 * __useAuthenticationPasswordSetupMutation__
 *
 * To run a mutation, you first call `useAuthenticationPasswordSetupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAuthenticationPasswordSetupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [authenticationPasswordSetupMutation, { data, loading, error }] = useAuthenticationPasswordSetupMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAuthenticationPasswordSetupMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<AuthenticationPasswordSetupMutation, AuthenticationPasswordSetupMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<AuthenticationPasswordSetupMutation, AuthenticationPasswordSetupMutationVariables>(AuthenticationPasswordSetupDocument, options);
      }
export type AuthenticationPasswordSetupMutationHookResult = ReturnType<typeof useAuthenticationPasswordSetupMutation>;
export type AuthenticationPasswordSetupMutationResult = ApolloReactCommon.MutationResult<AuthenticationPasswordSetupMutation>;
export const UserBulkActivateDocument = gql`
    mutation userBulkActivate($input: UserBulkActivateInput!) {
  data: userBulkActivate(input: $input)
}
    `;

/**
 * __useUserBulkActivateMutation__
 *
 * To run a mutation, you first call `useUserBulkActivateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUserBulkActivateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [userBulkActivateMutation, { data, loading, error }] = useUserBulkActivateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUserBulkActivateMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UserBulkActivateMutation, UserBulkActivateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UserBulkActivateMutation, UserBulkActivateMutationVariables>(UserBulkActivateDocument, options);
      }
export type UserBulkActivateMutationHookResult = ReturnType<typeof useUserBulkActivateMutation>;
export type UserBulkActivateMutationResult = ApolloReactCommon.MutationResult<UserBulkActivateMutation>;
export const UserBulkDeactivateDocument = gql`
    mutation userBulkDeactivate($input: UserBulkDeactivateInput!) {
  data: userBulkDeactivate(input: $input)
}
    `;

/**
 * __useUserBulkDeactivateMutation__
 *
 * To run a mutation, you first call `useUserBulkDeactivateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUserBulkDeactivateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [userBulkDeactivateMutation, { data, loading, error }] = useUserBulkDeactivateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUserBulkDeactivateMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UserBulkDeactivateMutation, UserBulkDeactivateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UserBulkDeactivateMutation, UserBulkDeactivateMutationVariables>(UserBulkDeactivateDocument, options);
      }
export type UserBulkDeactivateMutationHookResult = ReturnType<typeof useUserBulkDeactivateMutation>;
export type UserBulkDeactivateMutationResult = ApolloReactCommon.MutationResult<UserBulkDeactivateMutation>;